import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  LocalDateTime: any;
  UUID: any;
  JSONObject: any;
  JSON: any;
  DateTime: any;
  Date: any;
  LocalDate: any;
  LocalTime: any;
  BigInt: any;
  jsonb: any;
  smallint: any;
  timestamptz: any;
  uuid: any;
  bit: any;
  json: any;
  bigint: any;
  _int4: any;
  _text: any;
  name: any;
  numeric: any;
  date: any;
  bpchar: any;
  time: any;
  transitdoc_type: any;
  tenant_type: any;
  tsvector: any;
  bc_name: any;
  _declaration_tasks_data: any;
  timestamp: any;
  _varchar: any;
  _txtcode: any;
  _uuid: any;
  query_int: any;
  _int2: any;
  _int8: any;
  ltree: any;
  lquery: any;
  ltxtquery: any;
  PASSWORD_REGEX: any;
};

export type Query_Root = {
  acs_goods_items_for_drs: Maybe<Array<Maybe<DeclarationGoodsItems>>>;
  acs_goods_items_for_drs_count: Maybe<Count>;
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk: Maybe<Address>;
  /** fetch data from the table: "address_groups" */
  address_groups: Array<Address_Groups>;
  /** fetch data from the table: "address_mapping" */
  address_mapping: Array<Address_Mapping>;
  /** fetch data from the table: "address_mapping" using primary key columns */
  address_mapping_by_pk: Maybe<Address_Mapping>;
  /** fetch data from the table: "address_override" */
  address_override: Array<Address_Override>;
  /** fetch data from the table: "address_override" using primary key columns */
  address_override_by_pk: Maybe<Address_Override>;
  /** fetch data from the table: "address_type" */
  address_type: Array<Address_Type>;
  /** fetch data from the table: "address_type" using primary key columns */
  address_type_by_pk: Maybe<Address_Type>;
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch data from the table: "ai_stats_dt_type" */
  ai_stats_dt_type: Array<Ai_Stats_Dt_Type>;
  /** fetch data from the table: "ai_stats_type" */
  ai_stats_type: Array<Ai_Stats_Type>;
  /** fetch data from the table: "annotation_provider" */
  annotation_provider: Array<Annotation_Provider>;
  /** fetch data from the table: "annotation_provider" using primary key columns */
  annotation_provider_by_pk: Maybe<Annotation_Provider>;
  /** fetch data from the table: "annotation_type" */
  annotation_type: Array<Annotation_Type>;
  /** fetch data from the table: "annotation_type" using primary key columns */
  annotation_type_by_pk: Maybe<Annotation_Type>;
  /** fetch data from the table: "api_key" */
  api_key: Array<Api_Key>;
  /** fetch data from the table: "api_key" using primary key columns */
  api_key_by_pk: Maybe<Api_Key>;
  /** fetch data from the table: "arrival_type" */
  arrival_type: Array<Arrival_Type>;
  /** fetch data from the table: "arrival_type" using primary key columns */
  arrival_type_by_pk: Maybe<Arrival_Type>;
  /** fetch data from the table: "article" */
  article: Array<Article>;
  /** fetch data from the table: "article" using primary key columns */
  article_by_pk: Maybe<Article>;
  /** fetch data from the table: "bill" */
  bill: Array<Bill>;
  /** fetch aggregated fields from the table: "bill" */
  bill_aggregate: Bill_Aggregate;
  /** fetch data from the table: "bill" using primary key columns */
  bill_by_pk: Maybe<Bill>;
  /** fetch data from the table: "bill_detail" */
  bill_detail: Array<Bill_Detail>;
  /** fetch data from the table: "bill_detail" using primary key columns */
  bill_detail_by_pk: Maybe<Bill_Detail>;
  /** fetch data from the table: "clearance_type" */
  clearance_type: Array<Clearance_Type>;
  /** fetch data from the table: "clearance_type" using primary key columns */
  clearance_type_by_pk: Maybe<Clearance_Type>;
  /** An array relationship */
  containers: Array<Containers>;
  /** fetch data from the table: "containers" using primary key columns */
  containers_by_pk: Maybe<Containers>;
  /** fetch data from the table: "count_type" */
  count_type: Array<Count_Type>;
  /** fetch data from the table: "customs_office" */
  customs_office: Array<Customs_Office>;
  /** fetch data from the table: "customs_office" using primary key columns */
  customs_office_by_pk: Maybe<Customs_Office>;
  /** fetch data from the table: "customs_offices" */
  customs_offices: Array<Customs_Offices>;
  /** fetch data from the table: "customs_offices" using primary key columns */
  customs_offices_by_pk: Maybe<Customs_Offices>;
  /** fetch data from the table: "declaration" */
  declaration: Array<Declaration>;
  /** fetch data from the table: "declaration" using primary key columns */
  declaration_by_pk: Maybe<Declaration>;
  /** fetch data from the table: "declaration_discussion" */
  declaration_discussion: Array<Declaration_Discussion>;
  /** fetch aggregated fields from the table: "declaration_discussion" */
  declaration_discussion_aggregate: Declaration_Discussion_Aggregate;
  /** fetch data from the table: "declaration_discussion" using primary key columns */
  declaration_discussion_by_pk: Maybe<Declaration_Discussion>;
  /** fetch data from the table: "declaration_discussions" */
  declaration_discussions: Array<Declaration_Discussions>;
  /** fetch data from the table: "declaration_document" */
  declaration_document: Array<Declaration_Document>;
  /** fetch data from the table: "declaration_document" using primary key columns */
  declaration_document_by_pk: Maybe<Declaration_Document>;
  /** An array relationship */
  declaration_labels: Array<Declaration_Labels>;
  /** fetch data from the table: "declaration_labels" using primary key columns */
  declaration_labels_by_pk: Maybe<Declaration_Labels>;
  /** fetch data from the table: "declaration_message" */
  declaration_message: Array<Declaration_Message>;
  /** fetch aggregated fields from the table: "declaration_message" */
  declaration_message_aggregate: Declaration_Message_Aggregate;
  /** fetch data from the table: "declaration_message" using primary key columns */
  declaration_message_by_pk: Maybe<Declaration_Message>;
  /** fetch data from the table: "declaration_request" */
  declaration_request: Array<Declaration_Request>;
  /** fetch data from the table: "declaration_request_address" */
  declaration_request_address: Array<Declaration_Request_Address>;
  /** fetch data from the table: "declaration_request_address_ai" */
  declaration_request_address_ai: Array<Declaration_Request_Address_Ai>;
  /** fetch data from the table: "declaration_request_address_ai" using primary key columns */
  declaration_request_address_ai_by_pk: Maybe<Declaration_Request_Address_Ai>;
  /** fetch data from the table: "declaration_request_address" using primary key columns */
  declaration_request_address_by_pk: Maybe<Declaration_Request_Address>;
  /** fetch data from the table: "declaration_request" using primary key columns */
  declaration_request_by_pk: Maybe<Declaration_Request>;
  /** An array relationship */
  declaration_request_labels: Array<Declaration_Request_Labels>;
  /** fetch data from the table: "declaration_request_labels" using primary key columns */
  declaration_request_labels_by_pk: Maybe<Declaration_Request_Labels>;
  /** fetch data from the table: "declaration_requests" */
  declaration_requests: Array<Declaration_Requests>;
  /** fetch data from the table: "declaration_search" */
  declaration_search: Array<Declaration_Search>;
  /** An array relationship */
  declaration_special_mentions: Array<Declaration_Special_Mentions>;
  /** fetch data from the table: "declaration_special_mentions" using primary key columns */
  declaration_special_mentions_by_pk: Maybe<Declaration_Special_Mentions>;
  /** fetch data from the table: "declaration_status" */
  declaration_status: Array<Declaration_Status>;
  /** fetch data from the table: "declaration_status" using primary key columns */
  declaration_status_by_pk: Maybe<Declaration_Status>;
  /** fetch data from the table: "declaration_task" */
  declaration_task: Array<Declaration_Task>;
  /** fetch aggregated fields from the table: "declaration_task" */
  declaration_task_aggregate: Declaration_Task_Aggregate;
  /** fetch data from the table: "declaration_task" using primary key columns */
  declaration_task_by_pk: Maybe<Declaration_Task>;
  /** fetch data from the table: "declaration_tasks" */
  declaration_tasks: Array<Declaration_Tasks>;
  /** fetch data from the table: "declaration_tasks_obj" */
  declaration_tasks_obj: Array<Declaration_Tasks_Obj>;
  /** fetch data from the table: "declaration_type" */
  declaration_type: Array<Declaration_Type>;
  /** fetch data from the table: "declaration_type" using primary key columns */
  declaration_type_by_pk: Maybe<Declaration_Type>;
  /** fetch data from the table: "discussion_changes" */
  discussion_changes: Array<Discussion_Changes>;
  /** fetch data from the table: "doc_annotation" */
  doc_annotation: Array<Doc_Annotation>;
  /** fetch data from the table: "doc_annotation" using primary key columns */
  doc_annotation_by_pk: Maybe<Doc_Annotation>;
  /** fetch data from the table: "doc_search_type" */
  doc_search_type: Array<Doc_Search_Type>;
  /** fetch data from the table: "doc_stats_type" */
  doc_stats_type: Array<Doc_Stats_Type>;
  /** fetch data from the table: "docs_for_validation" */
  docs_for_validation: Array<Docs_For_Validation>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk: Maybe<Document>;
  /** fetch data from the table: "document_extension" */
  document_extension: Array<Document_Extension>;
  /** fetch data from the table: "document_extension" using primary key columns */
  document_extension_by_pk: Maybe<Document_Extension>;
  /** fetch data from the table: "document_flag" */
  document_flag: Array<Document_Flag>;
  /** fetch data from the table: "document_flag" using primary key columns */
  document_flag_by_pk: Maybe<Document_Flag>;
  /** fetch data from the table: "document_label_org_id" */
  document_label_org_id: Array<Document_Label_Org_Id>;
  /** fetch data from the table: "document_label_org_id" using primary key columns */
  document_label_org_id_by_pk: Maybe<Document_Label_Org_Id>;
  /** An array relationship */
  document_labels: Array<Document_Labels>;
  /** fetch data from the table: "document_labels" using primary key columns */
  document_labels_by_pk: Maybe<Document_Labels>;
  /** fetch data from the table: "document_page" */
  document_page: Array<Document_Page>;
  /** fetch aggregated fields from the table: "document_page" */
  document_page_aggregate: Document_Page_Aggregate;
  /** fetch data from the table: "document_page" using primary key columns */
  document_page_by_pk: Maybe<Document_Page>;
  /** fetch data from the table: "document_status" */
  document_status: Array<Document_Status>;
  /** fetch data from the table: "document_status" using primary key columns */
  document_status_by_pk: Maybe<Document_Status>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** An array relationship */
  document_type_all_tenant_settings: Array<Document_Type_All_Tenant_Settings>;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk: Maybe<Document_Type>;
  /** An array relationship */
  document_type_tenant_settings: Array<Document_Type_Tenant_Settings>;
  /** fetch data from the table: "document_type_tenant_settings" using primary key columns */
  document_type_tenant_settings_by_pk: Maybe<Document_Type_Tenant_Settings>;
  documents: Maybe<Array<Documents>>;
  /** fetch data from the table: "dr_stats" */
  dr_stats: Array<Dr_Stats>;
  /** fetch data from the table: "edec_countries" */
  edec_countries: Array<Edec_Countries>;
  /** fetch data from the table: "edec_countries" using primary key columns */
  edec_countries_by_pk: Maybe<Edec_Countries>;
  /** fetch data from the table: "edec_customs_offices" */
  edec_customs_offices: Array<Edec_Customs_Offices>;
  /** fetch data from the table: "edec_customs_offices" using primary key columns */
  edec_customs_offices_by_pk: Maybe<Edec_Customs_Offices>;
  /** fetch data from the table: "edec_domains" */
  edec_domains: Array<Edec_Domains>;
  /** fetch data from the table: "edec_domains" using primary key columns */
  edec_domains_by_pk: Maybe<Edec_Domains>;
  /** fetch data from the table: "edec_tariff_commodity_code" */
  edec_tariff_commodity_code: Array<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table: "edec_tariff_commodity_code" using primary key columns */
  edec_tariff_commodity_code_by_pk: Maybe<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table: "edec_tariff_statistical_code" */
  edec_tariff_statistical_code: Array<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table: "edec_tariff_statistical_code" using primary key columns */
  edec_tariff_statistical_code_by_pk: Maybe<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table: "email_search_type" */
  email_search_type: Array<Email_Search_Type>;
  /** fetch aggregated fields from the table: "email_search_type" */
  email_search_type_aggregate: Email_Search_Type_Aggregate;
  /** fetch data from the table: "extract_type" */
  extract_type: Array<Extract_Type>;
  /** fetch data from the table: "extract_type" using primary key columns */
  extract_type_by_pk: Maybe<Extract_Type>;
  /** fetch data from the table: "extraction_config" */
  extraction_config: Array<Extraction_Config>;
  /** fetch data from the table: "extraction_config" using primary key columns */
  extraction_config_by_pk: Maybe<Extraction_Config>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk: Maybe<File>;
  /** fetch data from the table: "file_stats_type" */
  file_stats_type: Array<File_Stats_Type>;
  /** fetch data from the table: "file_type" */
  file_type: Array<File_Type>;
  /** fetch data from the table: "file_type" using primary key columns */
  file_type_by_pk: Maybe<File_Type>;
  getAddressesByFrequency: Array<AddressAcs>;
  getAddressesOrOverrideACS: Array<AddressOrOverrideResult>;
  getAddressOverrides: Array<GetAddressOverridesResponse>;
  getAditRoles: Array<Role>;
  getAppModules: Array<ModuleEntity>;
  getBordereaus: Maybe<GetBordereaus>;
  getCommodityCodes: Array<CommodityCodeDescription>;
  getCurrentUser: UserPp;
  getDeclaraionLabels: Maybe<Array<DeclarationLabelQueryOutput>>;
  getDeclarationGoodItemsStatistics: Maybe<Scalars['JSON']>;
  getDeclarationRequestAddressEntity: Maybe<Array<DeclarationAddress>>;
  getDeclarationRequestsAdit: Array<DeclarationFlat>;
  getDeclarationRequestStatistics: Maybe<Scalars['JSON']>;
  getFileDocuments: Array<GetFileDocumentsQuery>;
  getFiles: Maybe<Array<Maybe<GetFiles>>>;
  getGoodItemsStatistics: Maybe<Scalars['JSON']>;
  getOrgIds: Array<OrgIdEntity>;
  getPageFragmentText: Maybe<Scalars['JSON']>;
  getSASToken: Maybe<SasTokenResponse>;
  getTenantAddresses: Array<AddressAcs>;
  getTenantConfig: Maybe<Scalars['JSON']>;
  getTenantReports: Maybe<Array<ReportEntity>>;
  getTenants: Array<TenantEntity>;
  getUserConfig: Maybe<Scalars['JSON']>;
  getUserOrgIds: Array<OrgIdEntity>;
  getUserPermissions: Array<CaslRule>;
  getUsers: Array<UserPp>;
  getWDCustomers: Array<TenantEntity>;
  getWDRoles: Array<Role>;
  getWDUsers: Array<UserPp>;
  /** fetch data from the table: "goods_item" */
  goods_item: Array<Goods_Item>;
  /** fetch aggregated fields from the table: "goods_item" */
  goods_item_aggregate: Goods_Item_Aggregate;
  /** fetch data from the table: "goods_item" using primary key columns */
  goods_item_by_pk: Maybe<Goods_Item>;
  /** An array relationship */
  goods_item_special_mentions: Array<Goods_Item_Special_Mentions>;
  /** An aggregate relationship */
  goods_item_special_mentions_aggregate: Goods_Item_Special_Mentions_Aggregate;
  /** fetch data from the table: "goods_item_special_mentions" using primary key columns */
  goods_item_special_mentions_by_pk: Maybe<Goods_Item_Special_Mentions>;
  /** fetch data from the table: "goods_items_for_drs" */
  goods_items_for_drs: Array<Goods_Items_For_Drs>;
  /** fetch data from the table: "import_list_trigger" */
  import_list_trigger: Array<Import_List_Trigger>;
  /** fetch aggregated fields from the table: "import_list_trigger" */
  import_list_trigger_aggregate: Import_List_Trigger_Aggregate;
  /** fetch data from the table: "import_list_trigger" using primary key columns */
  import_list_trigger_by_pk: Maybe<Import_List_Trigger>;
  /** fetch data from the table: "intf.dr_payment_info" */
  intf_dr_payment_info: Array<Intf_Dr_Payment_Info>;
  /** fetch data from the table: "json_type" */
  json_type: Array<Json_Type>;
  /** fetch data from the table: "kc_users" */
  kc_users: Array<Kc_Users>;
  /** fetch data from the table: "max_date_type" */
  max_date_type: Array<Max_Date_Type>;
  /** fetch data from the table: "model_retrain" */
  model_retrain: Array<Model_Retrain>;
  /** fetch data from the table: "model_retrain" using primary key columns */
  model_retrain_by_pk: Maybe<Model_Retrain>;
  notifications: Maybe<Scalars['JSON']>;
  /** fetch data from the table: "org_id" */
  org_id: Array<Org_Id>;
  /** fetch data from the table: "org_id" using primary key columns */
  org_id_by_pk: Maybe<Org_Id>;
  /** fetch data from the table: "org_ids" */
  org_ids: Array<Org_Ids>;
  /** fetch data from the table: "org_params" */
  org_params: Array<Org_Params>;
  /** fetch data from the table: "org_params" using primary key columns */
  org_params_by_pk: Maybe<Org_Params>;
  /** fetch data from the table: "org_params_org_id" */
  org_params_org_id: Array<Org_Params_Org_Id>;
  /** An array relationship */
  packagings: Array<Packagings>;
  /** An aggregate relationship */
  packagings_aggregate: Packagings_Aggregate;
  /** fetch data from the table: "packagings" using primary key columns */
  packagings_by_pk: Maybe<Packagings>;
  /** fetch data from the table: "page" */
  page: Array<Page>;
  /** fetch data from the table: "page" using primary key columns */
  page_by_pk: Maybe<Page>;
  /** fetch data from the table: "page_extract" */
  page_extract: Array<Page_Extract>;
  /** fetch data from the table: "page_extract" using primary key columns */
  page_extract_by_pk: Maybe<Page_Extract>;
  /** fetch data from the table: "page_status" */
  page_status: Array<Page_Status>;
  /** fetch data from the table: "page_status" using primary key columns */
  page_status_by_pk: Maybe<Page_Status>;
  /** fetch data from the table: "pages_m2m_cache" */
  pages_m2m_cache: Array<Pages_M2m_Cache>;
  /** fetch aggregated fields from the table: "pages_m2m_cache" */
  pages_m2m_cache_aggregate: Pages_M2m_Cache_Aggregate;
  /** An array relationship */
  permits: Array<Permits>;
  /** An aggregate relationship */
  permits_aggregate: Permits_Aggregate;
  /** fetch data from the table: "permits" using primary key columns */
  permits_by_pk: Maybe<Permits>;
  /** execute function "pp_address_groups" which returns "address_groups" */
  pp_address_groups: Array<Address_Groups>;
  /** execute function "pp_addresses" which returns "addresses" */
  pp_addresses: Array<Addresses>;
  /** execute function "pp_ai_stats" which returns "ai_stats_type" */
  pp_ai_stats: Array<Ai_Stats_Type>;
  /** execute function "pp_ai_stats_dt" which returns "ai_stats_dt_type" */
  pp_ai_stats_dt: Array<Ai_Stats_Dt_Type>;
  /** execute function "pp_check_json_param" which returns "json_type" */
  pp_check_json_param: Array<Json_Type>;
  /** execute function "pp_declaration_request" which returns "declaration_request" */
  pp_declaration_request: Array<Declaration_Request>;
  pp_declaration_requests: Maybe<Array<DeclarationAcs>>;
  pp_declaration_requests_count: Maybe<Count>;
  pp_declaration_requests_report: Maybe<Scalars['JSON']>;
  /** execute function "pp_declaration_tasks" which returns "declaration_tasks" */
  pp_declaration_tasks: Array<Declaration_Tasks>;
  /** execute function "pp_declaration_tasks_agg" which returns "json_type" */
  pp_declaration_tasks_agg: Maybe<Json_Type>;
  /** execute function "pp_declaration_tasks_obj" which returns "declaration_tasks_obj" */
  pp_declaration_tasks_obj: Maybe<Declaration_Tasks_Obj>;
  /** execute function "pp_declarations" which returns "declaration_search" */
  pp_declarations: Array<Declaration_Search>;
  /** execute function "pp_delete_declaration_requests" which returns "json_type" */
  pp_delete_declaration_requests: Array<Json_Type>;
  /** execute function "pp_doc_max_date_hs" which returns "max_date_type" */
  pp_doc_max_date_hs: Array<Max_Date_Type>;
  /** execute function "pp_doc_max_date_v2" which returns "max_date_type" */
  pp_doc_max_date_v2: Array<Max_Date_Type>;
  /** execute function "pp_doc_search" which returns "doc_search_type" */
  pp_doc_search: Array<Doc_Search_Type>;
  /** execute function "pp_doc_search_hs" which returns "doc_search_type" */
  pp_doc_search_hs: Array<Doc_Search_Type>;
  /** execute function "pp_doc_stats" which returns "doc_stats_type" */
  pp_doc_stats: Array<Doc_Stats_Type>;
  /** execute function "pp_docs_for_validation" which returns "docs_for_validation" */
  pp_docs_for_validation: Array<Docs_For_Validation>;
  /** execute function "pp_document" which returns "document" */
  pp_document: Array<Document>;
  /** execute function "pp_document" and query aggregates on result of table type "document" */
  pp_document_aggregate: Document_Aggregate;
  /** execute function "pp_document_flag" which returns "document_flag" */
  pp_document_flag: Array<Document_Flag>;
  /** execute function "pp_document_labels" which returns "document_labels" */
  pp_document_labels: Array<Document_Labels>;
  /** execute function "pp_dr_max_date" which returns "max_date_type" */
  pp_dr_max_date: Array<Max_Date_Type>;
  /** execute function "pp_dr_stats" which returns "dr_stats" */
  pp_dr_stats: Array<Dr_Stats>;
  /** execute function "pp_email_search" which returns "email_search_type" */
  pp_email_search: Array<Email_Search_Type>;
  /** execute function "pp_email_search" and query aggregates on result of table type "email_search_type" */
  pp_email_search_aggregate: Email_Search_Type_Aggregate;
  /** execute function "pp_email_search_hs" which returns "email_search_type" */
  pp_email_search_hs: Array<Email_Search_Type>;
  /** execute function "pp_email_search_hs" and query aggregates on result of table type "email_search_type" */
  pp_email_search_hs_aggregate: Email_Search_Type_Aggregate;
  /** execute function "pp_file_max_date_hs" which returns "max_date_type" */
  pp_file_max_date_hs: Array<Max_Date_Type>;
  /** execute function "pp_file_max_date_v2" which returns "max_date_type" */
  pp_file_max_date_v2: Array<Max_Date_Type>;
  /** execute function "pp_file_search" which returns "pp_types.file_search" */
  pp_file_search: Array<Pp_Types_File_Search>;
  /** execute function "pp_file_search_hs" which returns "pp_types.file_search" */
  pp_file_search_hs: Array<Pp_Types_File_Search>;
  /** execute function "pp_file_stats" which returns "file_stats_type" */
  pp_file_stats: Array<File_Stats_Type>;
  pp_get_kpi_commodity_code: Maybe<CommodityCodeStatistics>;
  pp_get_kpis: Maybe<StatisticsDto>;
  /** execute function "pp_hasura_session" which returns "json_type" */
  pp_hasura_session: Array<Json_Type>;
  /** execute function "pp_kc_users" which returns "kc_users" */
  pp_kc_users: Array<Kc_Users>;
  /** execute function "pp_last_doc_in_dr" which returns "document" */
  pp_last_doc_in_dr: Array<Document>;
  /** execute function "pp_last_doc_in_dr" and query aggregates on result of table type "document" */
  pp_last_doc_in_dr_aggregate: Document_Aggregate;
  /** execute function "pp_menu_indicators" which returns "json_type" */
  pp_menu_indicators: Array<Json_Type>;
  /** execute function "pp_org_id_delete" which returns "json_type" */
  pp_org_id_delete: Array<Json_Type>;
  /** execute function "pp_org_id_insert" which returns "json_type" */
  pp_org_id_insert: Array<Json_Type>;
  /** execute function "pp_org_id_update" which returns "json_type" */
  pp_org_id_update: Array<Json_Type>;
  /** execute function "pp_org_ids" which returns "org_ids" */
  pp_org_ids: Array<Org_Ids>;
  /** execute function "pp_page_extract_grids_text" which returns "json_type" */
  pp_page_extract_grids_text: Array<Json_Type>;
  /** execute function "pp_page_extract_text_fragment" which returns "json_type" */
  pp_page_extract_text_fragment: Array<Json_Type>;
  /** execute function "pp_page_extract_text_fragment_v2" which returns "json_type" */
  pp_page_extract_text_fragment_v2: Array<Json_Type>;
  /** execute function "pp_tenants" which returns "tenants" */
  pp_tenants: Array<Tenants>;
  /** fetch data from the table: "pp_types.file_search" */
  pp_types_file_search: Array<Pp_Types_File_Search>;
  /** execute function "pp_user_org_id" which returns "user_org_id" */
  pp_user_org_id: Array<User_Org_Id>;
  /** execute function "pp_user_search" which returns "user_search_type" */
  pp_user_search: Array<User_Search_Type>;
  /** execute function "pp_view_document_history" which returns "view_document_history" */
  pp_view_document_history: Array<View_Document_History>;
  /** execute function "pp_view_file_history" which returns "view_file_history" */
  pp_view_file_history: Array<View_File_History>;
  /** An array relationship */
  previous_documents: Array<Previous_Documents>;
  /** fetch data from the table: "previous_documents" using primary key columns */
  previous_documents_by_pk: Maybe<Previous_Documents>;
  /** An array relationship */
  produced_documents: Array<Produced_Documents>;
  /** An aggregate relationship */
  produced_documents_aggregate: Produced_Documents_Aggregate;
  /** fetch data from the table: "produced_documents" using primary key columns */
  produced_documents_by_pk: Maybe<Produced_Documents>;
  /** fetch data from the table: "report" */
  report: Array<Report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: Report_Aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk: Maybe<Report>;
  /** fetch data from the table: "service" */
  service: Array<Service>;
  /** fetch data from the table: "service" using primary key columns */
  service_by_pk: Maybe<Service>;
  /** fetch data from the table: "service_rate" */
  service_rate: Array<Service_Rate>;
  /** fetch data from the table: "service_tariff" */
  service_tariff: Array<Service_Tariff>;
  /** fetch aggregated fields from the table: "service_tariff" */
  service_tariff_aggregate: Service_Tariff_Aggregate;
  /** fetch data from the table: "setting" */
  setting: Array<Setting>;
  /** fetch data from the table: "setting" using primary key columns */
  setting_by_pk: Maybe<Setting>;
  /** fetch data from the table: "setting_group" */
  setting_group: Array<Setting_Group>;
  /** fetch data from the table: "setting_group" using primary key columns */
  setting_group_by_pk: Maybe<Setting_Group>;
  /** fetch data from the table: "setting_value" */
  setting_value: Array<Setting_Value>;
  /** fetch data from the table: "setting_value" using primary key columns */
  setting_value_by_pk: Maybe<Setting_Value>;
  /** fetch data from the table: "tariff_number_description" */
  tariff_number_description: Array<Tariff_Number_Description>;
  /** fetch data from the table: "tariff_number_description" using primary key columns */
  tariff_number_description_by_pk: Maybe<Tariff_Number_Description>;
  /** fetch data from the table: "task_type" */
  task_type: Array<Task_Type>;
  /** fetch data from the table: "task_type" using primary key columns */
  task_type_by_pk: Maybe<Task_Type>;
  /** fetch data from the table: "tenant" */
  tenant: Array<Tenant>;
  /** fetch data from the table: "tenant" using primary key columns */
  tenant_by_pk: Maybe<Tenant>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch data from the table: "transitdoc_type_descr" */
  transitdoc_type_descr: Array<Transitdoc_Type_Descr>;
  /** fetch data from the table: "user_org_id" */
  user_org_id: Array<User_Org_Id>;
  /** fetch data from the table: "user_org_id" using primary key columns */
  user_org_id_by_pk: Maybe<User_Org_Id>;
  /** fetch data from the table: "user_pp" */
  user_pp: Array<User_Pp>;
  /** fetch data from the table: "user_pp" using primary key columns */
  user_pp_by_pk: Maybe<User_Pp>;
  /** fetch data from the table: "user_search_type" */
  user_search_type: Array<User_Search_Type>;
  /** fetch data from the table: "view_document_history" */
  view_document_history: Array<View_Document_History>;
  /** fetch data from the table: "view_file_history" */
  view_file_history: Array<View_File_History>;
  /** fetch data from the table: "view_history" */
  view_history: Array<View_History>;
  /** fetch data from the table: "vw_documents" */
  vw_documents: Array<Vw_Documents>;
  /** fetch data from the table: "vw_finished_files" */
  vw_finished_files: Array<Vw_Finished_Files>;
};


export type Query_RootAcs_Goods_Items_For_DrsArgs = {
  _curr_userid?: InputMaybe<Scalars['String']>;
  args: AcsDeclarationGoodsItemsArgs;
};


export type Query_RootAcs_Goods_Items_For_Drs_CountArgs = {
  args: AcsDeclarationGoodsItemsArgs;
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAddress_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Address_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Groups_Order_By>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Query_RootAddress_MappingArgs = {
  distinct_on?: InputMaybe<Array<Address_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Mapping_Order_By>>;
  where?: InputMaybe<Address_Mapping_Bool_Exp>;
};


export type Query_RootAddress_Mapping_By_PkArgs = {
  address_id: Scalars['Int'];
  tenant_id: Scalars['uuid'];
};


export type Query_RootAddress_OverrideArgs = {
  distinct_on?: InputMaybe<Array<Address_Override_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Override_Order_By>>;
  where?: InputMaybe<Address_Override_Bool_Exp>;
};


export type Query_RootAddress_Override_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAddress_TypeArgs = {
  distinct_on?: InputMaybe<Array<Address_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Type_Order_By>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Query_RootAddress_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAi_Stats_Dt_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ai_Stats_Dt_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Dt_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Query_RootAi_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ai_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Query_RootAnnotation_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Provider_Order_By>>;
  where?: InputMaybe<Annotation_Provider_Bool_Exp>;
};


export type Query_RootAnnotation_Provider_By_PkArgs = {
  annotation_provider_id: Scalars['smallint'];
};


export type Query_RootAnnotation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Type_Order_By>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


export type Query_RootAnnotation_Type_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  annotation_provider_id: Scalars['smallint'];
  document_type: Scalars['String'];
};


export type Query_RootApi_KeyArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Key_Order_By>>;
  where?: InputMaybe<Api_Key_Bool_Exp>;
};


export type Query_RootApi_Key_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootArrival_TypeArgs = {
  distinct_on?: InputMaybe<Array<Arrival_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Arrival_Type_Order_By>>;
  where?: InputMaybe<Arrival_Type_Bool_Exp>;
};


export type Query_RootArrival_Type_By_PkArgs = {
  arrival_type: Scalars['String'];
};


export type Query_RootArticleArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Query_RootArticle_By_PkArgs = {
  article_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


export type Query_RootBillArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Order_By>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Query_RootBill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Order_By>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Query_RootBill_By_PkArgs = {
  bill_id: Scalars['bigint'];
};


export type Query_RootBill_DetailArgs = {
  distinct_on?: InputMaybe<Array<Bill_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Detail_Order_By>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


export type Query_RootBill_Detail_By_PkArgs = {
  detail_id: Scalars['bigint'];
};


export type Query_RootClearance_TypeArgs = {
  distinct_on?: InputMaybe<Array<Clearance_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clearance_Type_Order_By>>;
  where?: InputMaybe<Clearance_Type_Bool_Exp>;
};


export type Query_RootClearance_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootContainersArgs = {
  distinct_on?: InputMaybe<Array<Containers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Containers_Order_By>>;
  where?: InputMaybe<Containers_Bool_Exp>;
};


export type Query_RootContainers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Count_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Count_Type_Order_By>>;
  where?: InputMaybe<Count_Type_Bool_Exp>;
};


export type Query_RootCustoms_OfficeArgs = {
  distinct_on?: InputMaybe<Array<Customs_Office_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Office_Order_By>>;
  where?: InputMaybe<Customs_Office_Bool_Exp>;
};


export type Query_RootCustoms_Office_By_PkArgs = {
  office_number: Scalars['String'];
  valid_from: Scalars['timestamptz'];
};


export type Query_RootCustoms_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Customs_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Offices_Order_By>>;
  where?: InputMaybe<Customs_Offices_Bool_Exp>;
};


export type Query_RootCustoms_Offices_By_PkArgs = {
  office_number: Scalars['String'];
};


export type Query_RootDeclarationArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Order_By>>;
  where?: InputMaybe<Declaration_Bool_Exp>;
};


export type Query_RootDeclaration_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootDeclaration_DiscussionArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Query_RootDeclaration_Discussion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Query_RootDeclaration_Discussion_By_PkArgs = {
  discussion_id: Scalars['bigint'];
};


export type Query_RootDeclaration_DiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussions_Order_By>>;
  where?: InputMaybe<Declaration_Discussions_Bool_Exp>;
};


export type Query_RootDeclaration_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Document_Order_By>>;
  where?: InputMaybe<Declaration_Document_Bool_Exp>;
};


export type Query_RootDeclaration_Document_By_PkArgs = {
  doc_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootDeclaration_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Labels_Bool_Exp>;
};


export type Query_RootDeclaration_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeclaration_MessageArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Query_RootDeclaration_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Query_RootDeclaration_Message_By_PkArgs = {
  creation_user: Scalars['uuid'];
  discussion_id: Scalars['bigint'];
  msg_date: Scalars['timestamptz'];
  read_date?: InputMaybe<Scalars['timestamptz']>;
};


export type Query_RootDeclaration_RequestArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Query_RootDeclaration_Request_AddressArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


export type Query_RootDeclaration_Request_Address_AiArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Ai_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Ai_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Ai_Bool_Exp>;
};


export type Query_RootDeclaration_Request_Address_Ai_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeclaration_Request_Address_By_PkArgs = {
  address_type: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootDeclaration_Request_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootDeclaration_Request_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


export type Query_RootDeclaration_Request_Labels_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  label_id: Scalars['Int'];
};


export type Query_RootDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Requests_Order_By>>;
  where?: InputMaybe<Declaration_Requests_Bool_Exp>;
};


export type Query_RootDeclaration_SearchArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Search_Order_By>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Query_RootDeclaration_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Special_Mentions_Order_By>>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};


export type Query_RootDeclaration_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeclaration_StatusArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Status_Order_By>>;
  where?: InputMaybe<Declaration_Status_Bool_Exp>;
};


export type Query_RootDeclaration_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDeclaration_TaskArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Query_RootDeclaration_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Query_RootDeclaration_Task_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDeclaration_TasksArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Query_RootDeclaration_Tasks_ObjArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Obj_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Obj_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Query_RootDeclaration_TypeArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Type_Order_By>>;
  where?: InputMaybe<Declaration_Type_Bool_Exp>;
};


export type Query_RootDeclaration_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDiscussion_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Discussion_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discussion_Changes_Order_By>>;
  where?: InputMaybe<Discussion_Changes_Bool_Exp>;
};


export type Query_RootDoc_AnnotationArgs = {
  distinct_on?: InputMaybe<Array<Doc_Annotation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Annotation_Order_By>>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};


export type Query_RootDoc_Annotation_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


export type Query_RootDoc_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Query_RootDoc_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<Doc_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Stats_Type_Order_By>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Query_RootDocs_For_ValidationArgs = {
  distinct_on?: InputMaybe<Array<Docs_For_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Docs_For_Validation_Order_By>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Query_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootDocument_By_PkArgs = {
  document_type: Scalars['String'];
  id: Scalars['uuid'];
};


export type Query_RootDocument_ExtensionArgs = {
  distinct_on?: InputMaybe<Array<Document_Extension_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Extension_Order_By>>;
  where?: InputMaybe<Document_Extension_Bool_Exp>;
};


export type Query_RootDocument_Extension_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDocument_FlagArgs = {
  distinct_on?: InputMaybe<Array<Document_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Flag_Order_By>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Query_RootDocument_Flag_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Query_RootDocument_Label_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<Document_Label_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Label_Org_Id_Order_By>>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};


export type Query_RootDocument_Label_Org_Id_By_PkArgs = {
  label_id: Scalars['Int'];
  org_id: Scalars['smallint'];
};


export type Query_RootDocument_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Query_RootDocument_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootDocument_PageArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Query_RootDocument_Page_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Query_RootDocument_Page_By_PkArgs = {
  document_id: Scalars['uuid'];
  page_id: Scalars['uuid'];
  page_number: Scalars['smallint'];
};


export type Query_RootDocument_StatusArgs = {
  distinct_on?: InputMaybe<Array<Document_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Status_Order_By>>;
  where?: InputMaybe<Document_Status_Bool_Exp>;
};


export type Query_RootDocument_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDocument_TypeArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Query_RootDocument_Type_All_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


export type Query_RootDocument_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDocument_Type_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};


export type Query_RootDocument_Type_Tenant_Settings_By_PkArgs = {
  document_type: Scalars['String'];
  tenant: Scalars['uuid'];
};


export type Query_RootDocumentsArgs = {
  file: Scalars['UUID'];
  filters: FiltersExpressionAcsInput;
};


export type Query_RootDr_StatsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Stats_Order_By>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Query_RootEdec_CountriesArgs = {
  distinct_on?: InputMaybe<Array<Edec_Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Countries_Order_By>>;
  where?: InputMaybe<Edec_Countries_Bool_Exp>;
};


export type Query_RootEdec_Countries_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEdec_Customs_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Edec_Customs_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Customs_Offices_Order_By>>;
  where?: InputMaybe<Edec_Customs_Offices_Bool_Exp>;
};


export type Query_RootEdec_Customs_Offices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEdec_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Edec_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Domains_Order_By>>;
  where?: InputMaybe<Edec_Domains_Bool_Exp>;
};


export type Query_RootEdec_Domains_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEdec_Tariff_Commodity_CodeArgs = {
  distinct_on?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Order_By>>;
  where?: InputMaybe<Edec_Tariff_Commodity_Code_Bool_Exp>;
};


export type Query_RootEdec_Tariff_Commodity_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEdec_Tariff_Statistical_CodeArgs = {
  distinct_on?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Order_By>>;
  where?: InputMaybe<Edec_Tariff_Statistical_Code_Bool_Exp>;
};


export type Query_RootEdec_Tariff_Statistical_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootEmail_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootEmail_Search_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootExtract_TypeArgs = {
  distinct_on?: InputMaybe<Array<Extract_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Extract_Type_Order_By>>;
  where?: InputMaybe<Extract_Type_Bool_Exp>;
};


export type Query_RootExtract_Type_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
};


export type Query_RootExtraction_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Extraction_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Extraction_Config_Order_By>>;
  where?: InputMaybe<Extraction_Config_Bool_Exp>;
};


export type Query_RootExtraction_Config_By_PkArgs = {
  address_id: Scalars['Int'];
};


export type Query_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Query_RootFile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootFile_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Stats_Type_Order_By>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Query_RootFile_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Type_Order_By>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Query_RootFile_Type_By_PkArgs = {
  doc_types?: InputMaybe<Scalars['_varchar']>;
  file_type: Scalars['String'];
};


export type Query_RootGetAddressesByFrequencyArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetAddressesOrOverrideAcsArgs = {
  ids: Array<Scalars['Float']>;
};


export type Query_RootGetAddressOverridesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetBordereausArgs = {
  args?: InputMaybe<BordereauArgs>;
};


export type Query_RootGetCommodityCodesArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetDeclarationGoodItemsStatisticsArgs = {
  addresses?: InputMaybe<Scalars['String']>;
  addresses_qi?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  declaration_labels?: InputMaybe<Scalars['String']>;
  declaration_statuses?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  evv_status?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  max_date?: InputMaybe<Scalars['timestamptz']>;
  min_date?: InputMaybe<Scalars['timestamptz']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  search_field?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  total_items?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetDeclarationRequestsAditArgs = {
  addresses?: InputMaybe<Array<AddressFilter>>;
  dateMax?: InputMaybe<Scalars['LocalDateTime']>;
  dateMin?: InputMaybe<Scalars['LocalDateTime']>;
  declarationStatus?: InputMaybe<Array<DeclarationStatus>>;
  limit?: InputMaybe<Scalars['Int']>;
  maxTotalColis?: InputMaybe<Scalars['Int']>;
  maxTotalGrossWeight?: InputMaybe<Scalars['Float']>;
  minTotalColis?: InputMaybe<Scalars['Int']>;
  minTotalGrossWeight?: InputMaybe<Scalars['Float']>;
  nonclassifiedDocsExists?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['JSONObject']>>;
  orgIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetDeclarationRequestStatisticsArgs = {
  addresses?: InputMaybe<Scalars['String']>;
  addresses_qi?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  declaration_statuses?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  evv_status?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  max_date?: InputMaybe<Scalars['timestamptz']>;
  min_date?: InputMaybe<Scalars['timestamptz']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
  payer_id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  search_field?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};


export type Query_RootGetFileDocumentsArgs = {
  documentStatus?: InputMaybe<Array<DocumentStatus>>;
  fileId?: InputMaybe<Scalars['UUID']>;
};


export type Query_RootGetFilesArgs = {
  fileNumber: Scalars['String'];
};


export type Query_RootGetGoodItemsStatisticsArgs = {
  commodityCodes?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetOrgIdsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type Query_RootGetPageFragmentTextArgs = {
  height?: InputMaybe<Scalars['Int']>;
  pageUrl?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
  x?: InputMaybe<Scalars['Int']>;
  y?: InputMaybe<Scalars['Int']>;
};


export type Query_RootGetSasTokenArgs = {
  container: Scalars['String'];
  contentDisposition?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetTenantAddressesArgs = {
  addressType: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  selectedTenantId?: InputMaybe<Scalars['UUID']>;
};


export type Query_RootGetTenantConfigArgs = {
  tenantId?: InputMaybe<Scalars['ID']>;
};


export type Query_RootGetTenantsArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type Query_RootGetUsersArgs = {
  args?: InputMaybe<GetUsersArgs>;
};


export type Query_RootGetWdUsersArgs = {
  args?: InputMaybe<GetUsersArgs>;
};


export type Query_RootGoods_ItemArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Query_RootGoods_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Query_RootGoods_Item_By_PkArgs = {
  customs_item_number: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Query_RootGoods_Item_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Query_RootGoods_Item_Special_Mentions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Query_RootGoods_Item_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootGoods_Items_For_DrsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Items_For_Drs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Items_For_Drs_Order_By>>;
  where?: InputMaybe<Goods_Items_For_Drs_Bool_Exp>;
};


export type Query_RootImport_List_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Query_RootImport_List_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Query_RootImport_List_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootIntf_Dr_Payment_InfoArgs = {
  distinct_on?: InputMaybe<Array<Intf_Dr_Payment_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Intf_Dr_Payment_Info_Order_By>>;
  where?: InputMaybe<Intf_Dr_Payment_Info_Bool_Exp>;
};


export type Query_RootJson_TypeArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootKc_UsersArgs = {
  distinct_on?: InputMaybe<Array<Kc_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kc_Users_Order_By>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Query_RootMax_Date_TypeArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootModel_RetrainArgs = {
  distinct_on?: InputMaybe<Array<Model_Retrain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Retrain_Order_By>>;
  where?: InputMaybe<Model_Retrain_Bool_Exp>;
};


export type Query_RootModel_Retrain_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNotificationsArgs = {
  count: Scalars['Int'];
};


export type Query_RootOrg_IdArgs = {
  distinct_on?: InputMaybe<Array<Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Id_Order_By>>;
  where?: InputMaybe<Org_Id_Bool_Exp>;
};


export type Query_RootOrg_Id_By_PkArgs = {
  org_id: Scalars['smallint'];
};


export type Query_RootOrg_IdsArgs = {
  distinct_on?: InputMaybe<Array<Org_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Ids_Order_By>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Query_RootOrg_ParamsArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Order_By>>;
  where?: InputMaybe<Org_Params_Bool_Exp>;
};


export type Query_RootOrg_Params_By_PkArgs = {
  org_id: Scalars['Int'];
};


export type Query_RootOrg_Params_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Org_Id_Order_By>>;
  where?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
};


export type Query_RootPackagingsArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Query_RootPackagings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Query_RootPackagings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPageArgs = {
  distinct_on?: InputMaybe<Array<Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Order_By>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Query_RootPage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPage_ExtractArgs = {
  distinct_on?: InputMaybe<Array<Page_Extract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Extract_Order_By>>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};


export type Query_RootPage_Extract_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
  page_id: Scalars['uuid'];
};


export type Query_RootPage_StatusArgs = {
  distinct_on?: InputMaybe<Array<Page_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Status_Order_By>>;
  where?: InputMaybe<Page_Status_Bool_Exp>;
};


export type Query_RootPage_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootPages_M2m_CacheArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Query_RootPages_M2m_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Query_RootPermitsArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Query_RootPermits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Query_RootPermits_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootPp_Address_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Address_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Groups_Order_By>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Query_RootPp_AddressesArgs = {
  args: Pp_Addresses_Args;
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootPp_Ai_StatsArgs = {
  args: Pp_Ai_Stats_Args;
  distinct_on?: InputMaybe<Array<Ai_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Query_RootPp_Ai_Stats_DtArgs = {
  args: Pp_Ai_Stats_Dt_Args;
  distinct_on?: InputMaybe<Array<Ai_Stats_Dt_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Dt_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Query_RootPp_Check_Json_ParamArgs = {
  args: Pp_Check_Json_Param_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Declaration_RequestArgs = {
  args: Pp_Declaration_Request_Args;
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Query_RootPp_Declaration_RequestsArgs = {
  _curr_userid?: InputMaybe<Scalars['UUID']>;
  args: DeclarationRequestsArgs;
};


export type Query_RootPp_Declaration_Requests_CountArgs = {
  _curr_userid?: InputMaybe<Scalars['UUID']>;
  args: DeclarationRequestsArgs;
};


export type Query_RootPp_Declaration_Requests_ReportArgs = {
  args: DeclarationRequestsReportArgs;
};


export type Query_RootPp_Declaration_TasksArgs = {
  args: Pp_Declaration_Tasks_Args;
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Query_RootPp_Declaration_Tasks_AggArgs = {
  args: Pp_Declaration_Tasks_Agg_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Declaration_Tasks_ObjArgs = {
  args: Pp_Declaration_Tasks_Obj_Args;
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Obj_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Obj_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Query_RootPp_DeclarationsArgs = {
  args: Pp_Declarations_Args;
  distinct_on?: InputMaybe<Array<Declaration_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Search_Order_By>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Query_RootPp_Delete_Declaration_RequestsArgs = {
  args: Pp_Delete_Declaration_Requests_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_Max_Date_HsArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_Max_Date_V2Args = {
  args: Pp_Doc_Max_Date_V2_Args;
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_SearchArgs = {
  args: Pp_Doc_Search_Args;
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_Search_HsArgs = {
  args: Pp_Doc_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Doc_StatsArgs = {
  args: Pp_Doc_Stats_Args;
  distinct_on?: InputMaybe<Array<Doc_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Stats_Type_Order_By>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Query_RootPp_Docs_For_ValidationArgs = {
  args: Pp_Docs_For_Validation_Args;
  distinct_on?: InputMaybe<Array<Docs_For_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Docs_For_Validation_Order_By>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Query_RootPp_DocumentArgs = {
  args: Pp_Document_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootPp_Document_AggregateArgs = {
  args: Pp_Document_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootPp_Document_FlagArgs = {
  args: Pp_Document_Flag_Args;
  distinct_on?: InputMaybe<Array<Document_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Flag_Order_By>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Query_RootPp_Document_LabelsArgs = {
  args: Pp_Document_Labels_Args;
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Query_RootPp_Dr_Max_DateArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_Dr_StatsArgs = {
  args: Pp_Dr_Stats_Args;
  distinct_on?: InputMaybe<Array<Dr_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Stats_Order_By>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Query_RootPp_Email_SearchArgs = {
  args: Pp_Email_Search_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Email_Search_AggregateArgs = {
  args: Pp_Email_Search_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Email_Search_HsArgs = {
  args: Pp_Email_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootPp_Email_Search_Hs_AggregateArgs = {
  args: Pp_Email_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Query_RootPp_File_Max_Date_HsArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_File_Max_Date_V2Args = {
  args: Pp_File_Max_Date_V2_Args;
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Query_RootPp_File_SearchArgs = {
  args: Pp_File_Search_Args;
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Query_RootPp_File_Search_HsArgs = {
  args: Pp_File_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Query_RootPp_File_StatsArgs = {
  args: Pp_File_Stats_Args;
  distinct_on?: InputMaybe<Array<File_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Stats_Type_Order_By>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Query_RootPp_Get_Kpi_Commodity_CodeArgs = {
  commodity_code?: InputMaybe<Scalars['String']>;
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  tenant_id?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};


export type Query_RootPp_Get_KpisArgs = {
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  interval: Scalars['String'];
  lang?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};


export type Query_RootPp_Hasura_SessionArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Kc_UsersArgs = {
  args: Pp_Kc_Users_Args;
  distinct_on?: InputMaybe<Array<Kc_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kc_Users_Order_By>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Query_RootPp_Last_Doc_In_DrArgs = {
  args: Pp_Last_Doc_In_Dr_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootPp_Last_Doc_In_Dr_AggregateArgs = {
  args: Pp_Last_Doc_In_Dr_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Query_RootPp_Menu_IndicatorsArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Org_Id_DeleteArgs = {
  args: Pp_Org_Id_Delete_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Org_Id_InsertArgs = {
  args: Pp_Org_Id_Insert_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Org_Id_UpdateArgs = {
  args: Pp_Org_Id_Update_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Org_IdsArgs = {
  args: Pp_Org_Ids_Args;
  distinct_on?: InputMaybe<Array<Org_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Ids_Order_By>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Query_RootPp_Page_Extract_Grids_TextArgs = {
  args: Pp_Page_Extract_Grids_Text_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Page_Extract_Text_FragmentArgs = {
  args: Pp_Page_Extract_Text_Fragment_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_Page_Extract_Text_Fragment_V2Args = {
  args: Pp_Page_Extract_Text_Fragment_V2_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Query_RootPp_TenantsArgs = {
  args: Pp_Tenants_Args;
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootPp_Types_File_SearchArgs = {
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Query_RootPp_User_Org_IdArgs = {
  args: Pp_User_Org_Id_Args;
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Query_RootPp_User_SearchArgs = {
  args: Pp_User_Search_Args;
  distinct_on?: InputMaybe<Array<User_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Search_Type_Order_By>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Query_RootPp_View_Document_HistoryArgs = {
  args: Pp_View_Document_History_Args;
  distinct_on?: InputMaybe<Array<View_Document_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Document_History_Order_By>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Query_RootPp_View_File_HistoryArgs = {
  args: Pp_View_File_History_Args;
  distinct_on?: InputMaybe<Array<View_File_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_File_History_Order_By>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Query_RootPrevious_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Previous_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Previous_Documents_Order_By>>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};


export type Query_RootPrevious_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProduced_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Query_RootProduced_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Query_RootProduced_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootReportArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Query_RootReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Query_RootReport_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootServiceArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Query_RootService_By_PkArgs = {
  srv_id: Scalars['Int'];
};


export type Query_RootService_RateArgs = {
  distinct_on?: InputMaybe<Array<Service_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Rate_Order_By>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


export type Query_RootService_TariffArgs = {
  distinct_on?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Tariff_Order_By>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Query_RootService_Tariff_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Tariff_Order_By>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Query_RootSettingArgs = {
  distinct_on?: InputMaybe<Array<Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Order_By>>;
  where?: InputMaybe<Setting_Bool_Exp>;
};


export type Query_RootSetting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSetting_GroupArgs = {
  distinct_on?: InputMaybe<Array<Setting_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Group_Order_By>>;
  where?: InputMaybe<Setting_Group_Bool_Exp>;
};


export type Query_RootSetting_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSetting_ValueArgs = {
  distinct_on?: InputMaybe<Array<Setting_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Value_Order_By>>;
  where?: InputMaybe<Setting_Value_Bool_Exp>;
};


export type Query_RootSetting_Value_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTariff_Number_DescriptionArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Number_Description_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tariff_Number_Description_Order_By>>;
  where?: InputMaybe<Tariff_Number_Description_Bool_Exp>;
};


export type Query_RootTariff_Number_Description_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTask_TypeArgs = {
  distinct_on?: InputMaybe<Array<Task_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Type_Order_By>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Query_RootTask_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTenantArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenant_Order_By>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Query_RootTenant_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootTransitdoc_Type_DescrArgs = {
  distinct_on?: InputMaybe<Array<Transitdoc_Type_Descr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transitdoc_Type_Descr_Order_By>>;
  where?: InputMaybe<Transitdoc_Type_Descr_Bool_Exp>;
};


export type Query_RootUser_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Query_RootUser_Org_Id_By_PkArgs = {
  org_id: Scalars['smallint'];
  user_pp: Scalars['uuid'];
};


export type Query_RootUser_PpArgs = {
  distinct_on?: InputMaybe<Array<User_Pp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Pp_Order_By>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};


export type Query_RootUser_Pp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Search_Type_Order_By>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Query_RootView_Document_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_Document_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Document_History_Order_By>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Query_RootView_File_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_File_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_File_History_Order_By>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Query_RootView_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_History_Order_By>>;
  where?: InputMaybe<View_History_Bool_Exp>;
};


export type Query_RootVw_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Vw_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vw_Documents_Order_By>>;
  where?: InputMaybe<Vw_Documents_Bool_Exp>;
};


export type Query_RootVw_Finished_FilesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Finished_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vw_Finished_Files_Order_By>>;
  where?: InputMaybe<Vw_Finished_Files_Bool_Exp>;
};

export type AcsDeclarationGoodsItemsArgs = {
  _addresses?: InputMaybe<Array<AddressFilter>>;
  _addresses_qi?: InputMaybe<Scalars['String']>;
  _arrival_type?: InputMaybe<Scalars['String']>;
  _clr_type?: InputMaybe<Scalars['String']>;
  _date_max?: InputMaybe<Scalars['LocalDateTime']>;
  _date_min?: InputMaybe<Scalars['LocalDateTime']>;
  _decl_type?: InputMaybe<Scalars['String']>;
  _declaration_labels?: InputMaybe<Scalars['String']>;
  _declaration_statuses?: InputMaybe<Scalars['String']>;
  _evv_status?: InputMaybe<Scalars['String']>;
  _file_id?: InputMaybe<Scalars['UUID']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Array<Scalars['JSONObject']>>;
  _payer?: InputMaybe<Scalars['UUID']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_field?: InputMaybe<Scalars['String']>;
};

export type AddressFilter = {
  addressIds: Array<Scalars['Int']>;
  addressType: Scalars['String'];
};

export type DeclarationGoodsItems = {
  addresses: Maybe<Array<AddressAcs>>;
  customsItemNumber: Scalars['Int'];
  customsOffice: Maybe<EdecCustomsOffices>;
  declaration: Maybe<DeclarationEntity>;
  declarationLabels: Maybe<Array<Maybe<DeclarationLabel>>>;
  declarationRequest: DeclarationRequestAcs;
  declarationSpecialMentions: Maybe<Array<DeclarationSpecialMentionEntity>>;
  declarationStatus: DeclarationStatus;
  documents: Maybe<Array<Documents>>;
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  goodsItems: Maybe<GoodsItemAcs>;
  goodsItemSpecialMentions: Maybe<Array<GoodsItemSpecialMentionEntity>>;
  identification: Maybe<Scalars['String']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  myDuties: Maybe<Scalars['Float']>;
  packagings: Maybe<Array<PackagingEntity>>;
  permits: Maybe<Array<PermitEntity>>;
  previousDocuments: Maybe<Array<PreviousDocumentEntity>>;
  producedDocuments: Maybe<Array<ProducedDocumentEntity>>;
  refs: Maybe<Scalars['String']>;
  userPp: Maybe<UserPp>;
};

export type AddressAcs = {
  additionalValues: Maybe<Scalars['JSONObject']>;
  addressType: Maybe<AddressTypeAcs>;
  addressTypeId: Maybe<Scalars['Int']>;
  aoId: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyName2: Maybe<Scalars['String']>;
  contactEmail: Maybe<Scalars['String']>;
  contactPhone: Maybe<Scalars['String']>;
  contactWebsite: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creationDate: Scalars['DateTime'];
  creationUser: Scalars['UUID'];
  customsAccountNumber: Maybe<Scalars['String']>;
  drReference: Maybe<Scalars['String']>;
  errorEmailAddress: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Maybe<Scalars['Boolean']>;
  isLocked: Scalars['Boolean'];
  isPlatformUser: Scalars['Boolean'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  reference: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  streetNumber: Maybe<Scalars['String']>;
  traderIdentificationNumber: Maybe<Scalars['String']>;
  uidNumber: Maybe<Scalars['String']>;
  usageFrequency: Scalars['Int'];
  vatAccountNumber: Maybe<Scalars['String']>;
  vatNumber: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};

export type AddressTypeAcs = {
  id: Scalars['Int'];
  meta: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  translation: Maybe<Scalars['JSON']>;
};

export type EdecCustomsOffices = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  created: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  prefix: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
  validFrom: Maybe<Scalars['DateTime']>;
  validTo: Maybe<Scalars['DateTime']>;
  version: Maybe<Scalars['Int']>;
};

export type DeclarationEntity = {
  acceptanceDate: Maybe<Scalars['DateTime']>;
  accessCode: Maybe<Scalars['String']>;
  agreedLocationOfGoods: Maybe<Scalars['String']>;
  borderEauNumber: Maybe<Scalars['Int']>;
  bunchNumber: Maybe<Scalars['Int']>;
  changeInformation: Maybe<Scalars['String']>;
  clearanceLocation: Maybe<Scalars['Int']>;
  companyNumberTaxpayer: Maybe<Scalars['String']>;
  correctionCode: Maybe<Scalars['Int']>;
  correctionReason: Maybe<Scalars['String']>;
  customsAccountName: Maybe<Scalars['String']>;
  customsAccountNumber: Maybe<Scalars['Int']>;
  customsDeclarationNumber: Maybe<Scalars['String']>;
  customsDeclarationVersion: Maybe<Scalars['Int']>;
  customsOfficeNumber: Maybe<Scalars['String']>;
  declarantNumber: Maybe<Scalars['Int']>;
  declarationTime: Maybe<Scalars['Int']>;
  declarationType: Maybe<Scalars['String']>;
  deliveryDestination: Maybe<Scalars['String']>;
  dispatchCountry: Maybe<Scalars['String']>;
  dispatchCountryConfirmation: Maybe<Scalars['Boolean']>;
  drNo: Scalars['Int'];
  dutyAndOtherTaxesAmount: Maybe<Scalars['Float']>;
  dutyTotalAmount: Maybe<Scalars['Float']>;
  evvConfirmed: Scalars['Boolean'];
  evvReceived: Scalars['Boolean'];
  fileId: Scalars['String'];
  goodsItems: Maybe<Array<GoodsItemAcs>>;
  grossMass: Maybe<Scalars['Float']>;
  incoterms: Maybe<Scalars['String']>;
  initiator: Maybe<Scalars['Int']>;
  inspectionCode: Maybe<Scalars['Boolean']>;
  invoiceCurrencyType: Maybe<Scalars['String']>;
  lang: Maybe<Scalars['String']>;
  materialCheck: Maybe<Scalars['Boolean']>;
  packagingQuantity: Maybe<Scalars['Int']>;
  placeOfLoading: Maybe<Scalars['String']>;
  placeOfUnloading: Maybe<Scalars['String']>;
  postalShipmentType: Maybe<Scalars['String']>;
  previousDocument: Maybe<Array<PreviousDocumentEntity>>;
  procedureType: Maybe<Scalars['Int']>;
  provisionalDeclarationExpirationDate: Maybe<Scalars['String']>;
  reason: Maybe<Scalars['String']>;
  receiveStatus: Maybe<Scalars['Int']>;
  release: Maybe<Scalars['Boolean']>;
  requestorTraderIdentificationNumber: Maybe<Scalars['String']>;
  security: Maybe<Scalars['Boolean']>;
  selectionCorrelationId: Maybe<Scalars['String']>;
  sendStatus: Maybe<Scalars['Int']>;
  serviceType: Maybe<Scalars['String']>;
  showInWd: Maybe<Scalars['Boolean']>;
  specialMention: Maybe<Array<DeclarationSpecialMentionEntity>>;
  specificCircumstanceIndicator: Maybe<Scalars['String']>;
  status: Maybe<Scalars['Int']>;
  statusDate: Maybe<Scalars['Date']>;
  statusTime: Maybe<Scalars['String']>;
  totalColis: Maybe<Scalars['Int']>;
  totalGoodsItems: Maybe<Scalars['Int']>;
  totalGrossWeight: Maybe<Scalars['Float']>;
  totalVatValue: Maybe<Scalars['Float']>;
  traderDeclarationNumber: Maybe<Scalars['String']>;
  traderIdentificationNumber: Maybe<Scalars['String']>;
  traderReference: Maybe<Scalars['String']>;
  transferToTransitSystem: Maybe<Scalars['Boolean']>;
  transportCountry: Maybe<Scalars['String']>;
  transportInContainer: Maybe<Scalars['Boolean']>;
  transportMode: Maybe<Scalars['Int']>;
  transportNumber: Maybe<Scalars['String']>;
  transportType: Maybe<Scalars['String']>;
  uniqueConsignmentReferenceNumber: Maybe<Scalars['String']>;
  vatAccountName: Maybe<Scalars['String']>;
  vatAccountNumber: Maybe<Scalars['Int']>;
  vatNumber: Maybe<Scalars['String']>;
  vatSuffix: Maybe<Scalars['Boolean']>;
  vatTotalAmount: Maybe<Scalars['Float']>;
  warehouseCoded: Maybe<Scalars['Int']>;
};

export type GoodsItemAcs = {
  additionalUnit: Maybe<Scalars['String']>;
  additionalUnitConfirmation: Maybe<Scalars['Boolean']>;
  billingType: Maybe<Scalars['Int']>;
  clearanceType: Maybe<Scalars['Int']>;
  commercialGood: Maybe<Scalars['Boolean']>;
  commodityCode: Maybe<Scalars['String']>;
  commodityCodeConfirmation: Maybe<Scalars['Boolean']>;
  customsDeclarationVersion: Maybe<Scalars['Int']>;
  customsFavourCode: Maybe<Scalars['Int']>;
  customsItemNumber: Scalars['Int'];
  customsNetWeight: Maybe<Scalars['Float']>;
  description: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['Int']>;
  drNo: Scalars['Int'];
  dutyAndOtherTaxesTotal: Maybe<Scalars['Float']>;
  dutyRate: Maybe<Scalars['Float']>;
  dutyTotal: Maybe<Scalars['Float']>;
  fileId: Scalars['JSON'];
  grossMass: Maybe<Scalars['Float']>;
  grossMassConfirmation: Maybe<Scalars['Boolean']>;
  netDuty: Maybe<Scalars['Boolean']>;
  netMass: Maybe<Scalars['Float']>;
  netMassConfirmation: Maybe<Scalars['Boolean']>;
  nonCustomsLawObligation: Maybe<Scalars['Int']>;
  originCountry: Maybe<Scalars['String']>;
  originPreference: Maybe<Scalars['Boolean']>;
  packaging: Maybe<Array<PackagingEntity>>;
  permitObligationCode: Maybe<Scalars['Int']>;
  preferenceConfirmation: Maybe<Scalars['Boolean']>;
  processType: Maybe<Scalars['Int']>;
  rateConfirmation: Maybe<Scalars['Boolean']>;
  refinementType: Maybe<Scalars['Int']>;
  refundType: Maybe<Scalars['Int']>;
  repair: Maybe<Scalars['Boolean']>;
  repairReason: Maybe<Scalars['String']>;
  selectionResult: Maybe<Scalars['Int']>;
  statisticalCode: Maybe<Scalars['Int']>;
  statisticalValue: Maybe<Scalars['Int']>;
  storageType: Maybe<Scalars['Int']>;
  tareSupplement: Maybe<Scalars['Float']>;
  tareSupplementConfirmation: Maybe<Scalars['Boolean']>;
  unDangerousGoodsCode: Maybe<Scalars['String']>;
  vatCode: Maybe<Scalars['Int']>;
  vatCodeConfirmation: Maybe<Scalars['Boolean']>;
  vatRate: Maybe<Scalars['Float']>;
  vatTotal: Maybe<Scalars['Float']>;
  vatValue: Maybe<Scalars['Float']>;
  vatValueConfirmation: Maybe<Scalars['Boolean']>;
  vocQuantity: Maybe<Scalars['Float']>;
};

export type PackagingEntity = {
  customsItemNumber: Maybe<Scalars['Int']>;
  drNo: Maybe<Scalars['Int']>;
  fileId: Maybe<Scalars['ID']>;
  id: Scalars['Int'];
  packagingQuantity: Maybe<Scalars['Float']>;
  packagingReferenceNumber: Maybe<Scalars['String']>;
  packagingType: Maybe<Scalars['String']>;
};

export type PreviousDocumentEntity = {
  additionalInformation: Maybe<Scalars['String']>;
  drNo: Scalars['ID'];
  fileId: Scalars['ID'];
  id: Scalars['ID'];
  previousDocumentReference: Maybe<Scalars['String']>;
  previousDocumentType: Maybe<Scalars['String']>;
};

export type DeclarationSpecialMentionEntity = {
  drNo: Scalars['Float'];
  fileId: Scalars['String'];
  id: Scalars['ID'];
  sequenceNumber: Scalars['Float'];
  text: Scalars['String'];
};

export type DeclarationLabel = {
  color: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Maybe<Scalars['Boolean']>;
  title: Maybe<Scalars['JSON']>;
};

export type DeclarationRequestAcs = {
  acceptanceDate: Maybe<Scalars['DateTime']>;
  accountNumber: Maybe<Scalars['String']>;
  aiAutodec: Maybe<Scalars['Boolean']>;
  aiDate: Maybe<Scalars['DateTime']>;
  arrivalTime: Maybe<Scalars['DateTime']>;
  arrivalType: Maybe<ArrivalType>;
  cevStatus: Maybe<Scalars['String']>;
  chExpDecl: Maybe<Scalars['Boolean']>;
  clearanceType: Scalars['String'];
  creationDate: Scalars['DateTime'];
  creationUser: Scalars['String'];
  customsDeclarationNumber: Maybe<Scalars['String']>;
  customsDeclarationVersion: Maybe<Scalars['Int']>;
  declarationType: Scalars['String'];
  destTolldeptCode: Maybe<Scalars['String']>;
  destTolldeptName: Maybe<Scalars['String']>;
  drNo: Scalars['Int'];
  edec: Maybe<Scalars['JSON']>;
  eta: Maybe<Scalars['DateTime']>;
  fileId: Scalars['String'];
  impCustClr: Maybe<Scalars['Boolean']>;
  isExpress: Scalars['Boolean'];
  meta: Scalars['JSON'];
  serviceType: Maybe<Scalars['String']>;
  tollDep: Maybe<Scalars['String']>;
  traderReference: Maybe<Scalars['String']>;
  transitdocType: Maybe<Scalars['String']>;
  trNo: Maybe<Scalars['String']>;
  userPp: Maybe<UserPp>;
  waNumber: Maybe<Scalars['String']>;
};

export enum ArrivalType {
  AllowedConsignee = 'allowed_consignee',
  Border = 'border',
  Unknown = 'unknown'
}

export type UserPp = {
  code: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['String']>;
  defaultRoleId: Maybe<Scalars['Int']>;
  deleted: Maybe<Scalars['Boolean']>;
  deletedAt: Maybe<Scalars['DateTime']>;
  deletedByUser: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  email: Scalars['String'];
  externalAuthProvider: Scalars['Boolean'];
  firstName: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  ldapEntryDn: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  modules: Maybe<Array<ModuleEntity>>;
  oauthId: Maybe<Scalars['String']>;
  orgIdEntities: Array<OrgIdEntity>;
  permissions: Maybe<Scalars['String']>;
  permissionsDesk: Maybe<Array<Scalars['String']>>;
  phoneNumber: Maybe<Scalars['String']>;
  roles: Array<Role>;
  tenant: TenantEntity;
  tenantId: Scalars['UUID'];
  uiSettings: Scalars['JSON'];
  uiSettingsTemplates: Scalars['JSON'];
  userModules: Maybe<Array<UserModuleEntity>>;
  userType: Maybe<Scalars['String']>;
};

export type ModuleEntity = {
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type OrgIdEntity = {
  creationDate: Maybe<Scalars['DateTime']>;
  displayName: Scalars['String'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  orgId: Scalars['Float'];
  orgIdDescription: Scalars['String'];
};

export type Role = {
  description: Maybe<Scalars['String']>;
  grantedPermissions: Maybe<Array<GrantedPermission>>;
  id: Scalars['Int'];
  isWdRelevant: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  translations: Scalars['JSON'];
};

export type GrantedPermission = {
  permission: Maybe<PermissionEntity>;
  permissionId: Maybe<Scalars['Float']>;
  roleId: Maybe<Scalars['Float']>;
};

export type PermissionEntity = {
  action: Maybe<Scalars['String']>;
  conditions: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  permissionId: Scalars['ID'];
  subject: Maybe<Scalars['String']>;
};

export type TenantEntity = {
  accountNumber: Maybe<Scalars['String']>;
  address: AddressAcs;
  addressId: Scalars['Int'];
  creationDate: Maybe<Scalars['DateTime']>;
  declarationLabels: Array<DeclarationLabel>;
  documentTypeTenantSettings: Array<DocumentTypeTenantSettingsAcs>;
  externalTenantId: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isWdCustomer: Scalars['Boolean'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  permissions: Maybe<Scalars['String']>;
  permissionsJs: Maybe<Scalars['JSON']>;
  roles: Maybe<Array<Role>>;
  tenantName: Scalars['String'];
  tenantType: TenantType;
  traderIdentificationNumber: Maybe<Scalars['String']>;
};

export type DocumentTypeTenantSettingsAcs = {
  code: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  defaultFlags: Maybe<Scalars['Int']>;
  displayName: Maybe<Scalars['String']>;
  documentType: Scalars['String'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
};

export enum TenantType {
  Default = 'DEFAULT',
  Master = 'MASTER'
}

export type UserModuleEntity = {
  moduleId: Scalars['Int'];
  userId: Scalars['String'];
};

export enum DeclarationStatus {
  ArrivalConfirmed = 'arrival_confirmed',
  DeclarationCanceled = 'declaration_canceled',
  DeclarationExported = 'declaration_exported',
  DeclarationExportedReferenceMissing = 'declaration_exported_reference_missing',
  DeclarationPending = 'declaration_pending',
  DeclarationRevoked = 'declaration_revoked',
  DocumentsRecieved = 'documents_recieved',
  InProgress = 'in_progress',
  InformationMissing = 'information_missing'
}

export type Documents = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['DateTime']>;
  creation_user: Scalars['UUID'];
  customs_response_data: Maybe<CustomsResponseData>;
  document_blobs: Maybe<Scalars['JSON']>;
  document_extension: Scalars['String'];
  document_flags: Scalars['BigInt'];
  document_name: Maybe<Scalars['String']>;
  document_status: Scalars['String'];
  document_type: Scalars['String'];
  document_version: Scalars['Int'];
  documentType: Maybe<DocumentType>;
  file: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  is_deleted: Scalars['Boolean'];
  is_generated: Scalars['Boolean'];
  is_template: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['DateTime']>;
  last_modified_user: Maybe<Scalars['UUID']>;
  meta: Scalars['JSON'];
  number_of_pages: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['Int']>;
  pages_m2m: Maybe<Array<Maybe<DocumentPage>>>;
  sequence: Maybe<Scalars['Int']>;
};


export type DocumentsDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type CustomsResponseData = {
  acceptance_date: Maybe<Scalars['LocalDate']>;
  acceptance_time: Maybe<Scalars['LocalTime']>;
  access_code: Maybe<Scalars['String']>;
  consignee: Maybe<Scalars['JSON']>;
  consignor: Maybe<EvvAddress>;
  correction_code: Scalars['Int'];
  creation_date: Maybe<Scalars['DateTime']>;
  customs_account: Maybe<Scalars['JSON']>;
  customs_clearance_type: Maybe<Scalars['Int']>;
  customs_office: Maybe<Scalars['JSON']>;
  declarant: Maybe<Scalars['JSON']>;
  declaration_type: Maybe<Scalars['String']>;
  dispatch_country: Maybe<Scalars['String']>;
  doc_id: Scalars['String'];
  doctype_detected: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  document_version: Scalars['Int'];
  dr_no: Scalars['Int'];
  duty_and_additional_taxes: Maybe<Scalars['JSON']>;
  file_id: Scalars['UUID'];
  ft_search: Maybe<Scalars['String']>;
  goods_item: Maybe<Scalars['JSON']>;
  goods_items_tbl: Maybe<Scalars['JSON']>;
  gross_mass: Maybe<Scalars['Float']>;
  importer: Maybe<Scalars['JSON']>;
  incoterms: Maybe<Scalars['String']>;
  invoice_currency_type: Maybe<Scalars['String']>;
  message: Scalars['Int'];
  meta: Maybe<Scalars['JSON']>;
  number_of_goods_items: Maybe<Scalars['Int']>;
  packaging_quantity: Maybe<Scalars['Int']>;
  previous_document: Maybe<Scalars['JSON']>;
  special_mention: Maybe<Scalars['JSON']>;
  trader_declaration_number: Maybe<Scalars['String']>;
  trader_identification_number: Maybe<Scalars['String']>;
  traderreference: Maybe<Scalars['String']>;
  transport_in_container: Maybe<Scalars['String']>;
  transport_means: Maybe<Scalars['JSON']>;
  valuation_summary: Maybe<Scalars['JSON']>;
  value: Scalars['JSON'];
  vat: Maybe<Scalars['JSON']>;
  vat_account: Maybe<Scalars['JSON']>;
  vatnumber: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['Float']>;
};

export type EvvAddress = {
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
};

export type DocumentType = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Scalars['UUID'];
  displayName: Maybe<Scalars['String']>;
  document_type_all_tenant_settings: Maybe<Array<DocumentTypeTenantSettings>>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  translations: Maybe<Scalars['JSON']>;
};


export type DocumentTypeDocument_Type_All_Tenant_SettingsArgs = {
  filters?: InputMaybe<FiltersExpressionAcsInput>;
};


export type DocumentTypeTranslationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type FiltersExpressionAcsInput = {
  childExpressions?: InputMaybe<Array<FiltersExpressionAcsInput>>;
  filters?: InputMaybe<Array<FilterInput>>;
  operator: Scalars['String'];
};

export type FilterInput = {
  field: Scalars['String'];
  op: Scalars['String'];
  relationField?: InputMaybe<Scalars['String']>;
  values: Array<Scalars['String']>;
};

export type DocumentTypeTenantSettings = {
  code: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  defaultFlags: Maybe<Scalars['String']>;
  displayName: Maybe<Scalars['String']>;
  documentSchema: Maybe<Scalars['JSON']>;
  documentType: Maybe<Scalars['String']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  tenant: Maybe<Scalars['UUID']>;
};

export type DocumentPage = {
  documentId: Scalars['UUID'];
  page: PageAcs;
  pageId: Scalars['UUID'];
  pageNumber: Scalars['Int'];
};

export type PageAcs = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Scalars['UUID'];
  id: Scalars['UUID'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Scalars['JSON'];
  ocrText: Maybe<Scalars['String']>;
  pageNumber: Maybe<Scalars['Int']>;
  pageStatus: Scalars['String'];
  rotate: Scalars['Int'];
  thumbnailBigUrl: Maybe<Scalars['String']>;
  thumbnailSmallUrl: Maybe<Scalars['String']>;
};

export type GoodsItemSpecialMentionEntity = {
  customsItemNumber: Maybe<Scalars['Int']>;
  drNo: Maybe<Scalars['Int']>;
  fileId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  sequenceNumber: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

export type PermitEntity = {
  additionalInformation: Maybe<Scalars['String']>;
  customsItemNumber: Maybe<Scalars['Int']>;
  drNo: Maybe<Scalars['Int']>;
  fileId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  issueDate: Maybe<Scalars['DateTime']>;
  permitAuthority: Maybe<Scalars['Int']>;
  permitItemDetails: Maybe<Scalars['JSON']>;
  permitNumber: Maybe<Scalars['String']>;
  permitType: Maybe<Scalars['Int']>;
};

export type ProducedDocumentEntity = {
  additionalInformation: Maybe<Scalars['String']>;
  customsItemNumber: Maybe<Scalars['Int']>;
  drNo: Maybe<Scalars['Int']>;
  fileId: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  producedDocumentIssueDate: Maybe<Scalars['Date']>;
  producedDocumentReferenceNumber: Maybe<Scalars['String']>;
  producedDocumentType: Maybe<Scalars['String']>;
};

export type Count = {
  resultSetCount: Maybe<Scalars['Int']>;
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  AdditionalValues = 'additional_values',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  AoId = 'ao_id',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CompanyName_2 = 'company_name_2',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsAccountNumber = 'customs_account_number',
  /** column name */
  ErrorEmailAddress = 'error_email_address',
  /** column name */
  Id = 'id',
  /** column name */
  Imported = 'imported',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsLocked = 'is_locked',
  /** column name */
  IsPlatformUser = 'is_platform_user',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  SearchVector = 'search_vector',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number',
  /** column name */
  UidNumber = 'uid_number',
  /** column name */
  UsageFrequency = 'usage_frequency',
  /** column name */
  VatAccountNumber = 'vat_account_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  additional_values?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  addressType?: InputMaybe<Address_Type_Order_By>;
  ao_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  company_name_2?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  contact_website?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  creationUser?: InputMaybe<User_Pp_Order_By>;
  customs_account_number?: InputMaybe<Order_By>;
  error_email_address?: InputMaybe<Order_By>;
  extraction_config?: InputMaybe<Extraction_Config_Order_By>;
  id?: InputMaybe<Order_By>;
  imported?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_locked?: InputMaybe<Order_By>;
  is_platform_user?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  search_vector?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  uid_number?: InputMaybe<Order_By>;
  usage_frequency?: InputMaybe<Order_By>;
  vat_account_number?: InputMaybe<Order_By>;
  vat_number?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** Ordering options when selecting data from "address_type". */
export type Address_Type_Order_By = {
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_pp". */
export type User_Pp_Order_By = {
  code?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ldap_entry_dn?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  oauth_id?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  ui_settings?: InputMaybe<Order_By>;
  ui_settings_templates?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
  userOrgIds_aggregate?: InputMaybe<User_Org_Id_Aggregate_Order_By>;
};

/** Ordering options when selecting data from "tenant". */
export type Tenant_Order_By = {
  account_number?: InputMaybe<Order_By>;
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  api_keys_aggregate?: InputMaybe<Api_Key_Aggregate_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_labels_aggregate?: InputMaybe<Declaration_Labels_Aggregate_Order_By>;
  document_labels_aggregate?: InputMaybe<Document_Labels_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  import_list_triggers_aggregate?: InputMaybe<Import_List_Trigger_Aggregate_Order_By>;
  is_wd_customer?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  org_ids_aggregate?: InputMaybe<Org_Id_Aggregate_Order_By>;
  permissions?: InputMaybe<Order_By>;
  permissions_js?: InputMaybe<Order_By>;
  service_rates_aggregate?: InputMaybe<Service_Rate_Aggregate_Order_By>;
  tenant_name?: InputMaybe<Order_By>;
  tenant_type?: InputMaybe<Order_By>;
  tenantDocumentTypes_aggregate?: InputMaybe<Document_Type_All_Tenant_Settings_Aggregate_Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  user_pps_aggregate?: InputMaybe<User_Pp_Aggregate_Order_By>;
};

/** order by aggregate values of table "api_key" */
export type Api_Key_Aggregate_Order_By = {
  avg?: InputMaybe<Api_Key_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Api_Key_Max_Order_By>;
  min?: InputMaybe<Api_Key_Min_Order_By>;
  stddev?: InputMaybe<Api_Key_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Api_Key_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Api_Key_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Api_Key_Sum_Order_By>;
  var_pop?: InputMaybe<Api_Key_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Api_Key_Var_Samp_Order_By>;
  variance?: InputMaybe<Api_Key_Variance_Order_By>;
};

/** order by avg() on columns of table "api_key" */
export type Api_Key_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "api_key" */
export type Api_Key_Max_Order_By = {
  api_key?: InputMaybe<Order_By>;
  dsplay_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "api_key" */
export type Api_Key_Min_Order_By = {
  api_key?: InputMaybe<Order_By>;
  dsplay_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "api_key" */
export type Api_Key_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "api_key" */
export type Api_Key_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "api_key" */
export type Api_Key_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "api_key" */
export type Api_Key_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "api_key" */
export type Api_Key_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "api_key" */
export type Api_Key_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "api_key" */
export type Api_Key_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_labels" */
export type Declaration_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Labels_Max_Order_By>;
  min?: InputMaybe<Declaration_Labels_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_labels" */
export type Declaration_Labels_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_labels" */
export type Declaration_Labels_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_labels" */
export type Declaration_Labels_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_labels" */
export type Declaration_Labels_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_labels" */
export type Declaration_Labels_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_labels" */
export type Declaration_Labels_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_labels" */
export type Declaration_Labels_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_labels" */
export type Declaration_Labels_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_labels" */
export type Declaration_Labels_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_labels" */
export type Declaration_Labels_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "document_labels" */
export type Document_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Labels_Max_Order_By>;
  min?: InputMaybe<Document_Labels_Min_Order_By>;
  stddev?: InputMaybe<Document_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "document_labels" */
export type Document_Labels_Avg_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_labels" */
export type Document_Labels_Max_Order_By = {
  color?: InputMaybe<Order_By>;
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_labels" */
export type Document_Labels_Min_Order_By = {
  color?: InputMaybe<Order_By>;
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_labels" */
export type Document_Labels_Stddev_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_labels" */
export type Document_Labels_Stddev_Pop_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_labels" */
export type Document_Labels_Stddev_Samp_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_labels" */
export type Document_Labels_Sum_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_labels" */
export type Document_Labels_Var_Pop_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_labels" */
export type Document_Labels_Var_Samp_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_labels" */
export type Document_Labels_Variance_Order_By = {
  /** id of document_labels. */
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "import_list_trigger" */
export type Import_List_Trigger_Aggregate_Order_By = {
  avg?: InputMaybe<Import_List_Trigger_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Import_List_Trigger_Max_Order_By>;
  min?: InputMaybe<Import_List_Trigger_Min_Order_By>;
  stddev?: InputMaybe<Import_List_Trigger_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Import_List_Trigger_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Import_List_Trigger_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Import_List_Trigger_Sum_Order_By>;
  var_pop?: InputMaybe<Import_List_Trigger_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Import_List_Trigger_Var_Samp_Order_By>;
  variance?: InputMaybe<Import_List_Trigger_Variance_Order_By>;
};

/** order by avg() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Max_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Min_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "import_list_trigger" */
export type Import_List_Trigger_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "org_id" */
export type Org_Id_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Id_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Id_Max_Order_By>;
  min?: InputMaybe<Org_Id_Min_Order_By>;
  stddev?: InputMaybe<Org_Id_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Id_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Id_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Id_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Id_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Id_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Id_Variance_Order_By>;
};

/** order by avg() on columns of table "org_id" */
export type Org_Id_Avg_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "org_id" */
export type Org_Id_Max_Order_By = {
  /** org_id creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** org_id creation user. */
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  /** org_id last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified org_id. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  /** Tenant of org_id. */
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "org_id" */
export type Org_Id_Min_Order_By = {
  /** org_id creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** org_id creation user. */
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  /** org_id last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified org_id. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  /** Tenant of org_id. */
  tenant_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "org_id" */
export type Org_Id_Stddev_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "org_id" */
export type Org_Id_Stddev_Pop_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "org_id" */
export type Org_Id_Stddev_Samp_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "org_id" */
export type Org_Id_Sum_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "org_id" */
export type Org_Id_Var_Pop_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "org_id" */
export type Org_Id_Var_Samp_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "org_id" */
export type Org_Id_Variance_Order_By = {
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "service_rate" */
export type Service_Rate_Aggregate_Order_By = {
  avg?: InputMaybe<Service_Rate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Service_Rate_Max_Order_By>;
  min?: InputMaybe<Service_Rate_Min_Order_By>;
  stddev?: InputMaybe<Service_Rate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Service_Rate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Service_Rate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Service_Rate_Sum_Order_By>;
  var_pop?: InputMaybe<Service_Rate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Service_Rate_Var_Samp_Order_By>;
  variance?: InputMaybe<Service_Rate_Variance_Order_By>;
};

/** order by avg() on columns of table "service_rate" */
export type Service_Rate_Avg_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "service_rate" */
export type Service_Rate_Max_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "service_rate" */
export type Service_Rate_Min_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "service_rate" */
export type Service_Rate_Stddev_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "service_rate" */
export type Service_Rate_Stddev_Pop_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "service_rate" */
export type Service_Rate_Stddev_Samp_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "service_rate" */
export type Service_Rate_Sum_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "service_rate" */
export type Service_Rate_Var_Pop_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "service_rate" */
export type Service_Rate_Var_Samp_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "service_rate" */
export type Service_Rate_Variance_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Type_All_Tenant_Settings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Type_All_Tenant_Settings_Max_Order_By>;
  min?: InputMaybe<Document_Type_All_Tenant_Settings_Min_Order_By>;
  stddev?: InputMaybe<Document_Type_All_Tenant_Settings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Type_All_Tenant_Settings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Type_All_Tenant_Settings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Type_All_Tenant_Settings_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Type_All_Tenant_Settings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Type_All_Tenant_Settings_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Type_All_Tenant_Settings_Variance_Order_By>;
};

/** order by avg() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Avg_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Stddev_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Stddev_Pop_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Stddev_Samp_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Sum_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Var_Pop_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Var_Samp_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Variance_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "user_pp" */
export type User_Pp_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Pp_Max_Order_By>;
  min?: InputMaybe<User_Pp_Min_Order_By>;
};

/** order by max() on columns of table "user_pp" */
export type User_Pp_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  /** User creation date */
  creation_date?: InputMaybe<Order_By>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  /** id of user_pp. */
  id?: InputMaybe<Order_By>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ldap_entry_dn?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  oauth_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_pp" */
export type User_Pp_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  /** User creation date */
  creation_date?: InputMaybe<Order_By>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Order_By>;
  deleted_at?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  /** id of user_pp. */
  id?: InputMaybe<Order_By>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  ldap_entry_dn?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  oauth_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "user_org_id" */
export type User_Org_Id_Aggregate_Order_By = {
  avg?: InputMaybe<User_Org_Id_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Org_Id_Max_Order_By>;
  min?: InputMaybe<User_Org_Id_Min_Order_By>;
  stddev?: InputMaybe<User_Org_Id_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Org_Id_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Org_Id_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Org_Id_Sum_Order_By>;
  var_pop?: InputMaybe<User_Org_Id_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Org_Id_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Org_Id_Variance_Order_By>;
};

/** order by avg() on columns of table "user_org_id" */
export type User_Org_Id_Avg_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "user_org_id" */
export type User_Org_Id_Max_Order_By = {
  /** user_org_id creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** user_org_id creation user. */
  creation_user?: InputMaybe<Order_By>;
  /** user_org_id last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified user_org_id. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_org_id" */
export type User_Org_Id_Min_Order_By = {
  /** user_org_id creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** user_org_id creation user. */
  creation_user?: InputMaybe<Order_By>;
  /** user_org_id last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified user_org_id. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "user_org_id" */
export type User_Org_Id_Stddev_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_org_id" */
export type User_Org_Id_Stddev_Pop_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_org_id" */
export type User_Org_Id_Stddev_Samp_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "user_org_id" */
export type User_Org_Id_Sum_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "user_org_id" */
export type User_Org_Id_Var_Pop_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_org_id" */
export type User_Org_Id_Var_Samp_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_org_id" */
export type User_Org_Id_Variance_Order_By = {
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "extraction_config". */
export type Extraction_Config_Order_By = {
  address_id?: InputMaybe<Order_By>;
  aliases?: InputMaybe<Order_By>;
  document_templates?: InputMaybe<Order_By>;
  foun_config?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  additional_values?: InputMaybe<Jsonb_Comparison_Exp>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  addressType?: InputMaybe<Address_Type_Bool_Exp>;
  ao_id?: InputMaybe<Smallint_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  company_name_2?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  contact_website?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  creationUser?: InputMaybe<User_Pp_Bool_Exp>;
  customs_account_number?: InputMaybe<String_Comparison_Exp>;
  error_email_address?: InputMaybe<String_Comparison_Exp>;
  extraction_config?: InputMaybe<Extraction_Config_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  imported?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_locked?: InputMaybe<Boolean_Comparison_Exp>;
  is_platform_user?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  search_vector?: InputMaybe<Tsvector_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  uid_number?: InputMaybe<String_Comparison_Exp>;
  usage_frequency?: InputMaybe<Int_Comparison_Exp>;
  vat_account_number?: InputMaybe<String_Comparison_Exp>;
  vat_number?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to filter rows from the table "address_type". All fields are combined with a logical 'AND'. */
export type Address_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Type_Bool_Exp>>;
  _not?: InputMaybe<Address_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Type_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translation?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']>;
  _gt?: InputMaybe<Scalars['smallint']>;
  _gte?: InputMaybe<Scalars['smallint']>;
  _in?: InputMaybe<Array<Scalars['smallint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['smallint']>;
  _lte?: InputMaybe<Scalars['smallint']>;
  _neq?: InputMaybe<Scalars['smallint']>;
  _nin?: InputMaybe<Array<Scalars['smallint']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** Boolean expression to filter rows from the table "user_pp". All fields are combined with a logical 'AND'. */
export type User_Pp_Bool_Exp = {
  _and?: InputMaybe<Array<User_Pp_Bool_Exp>>;
  _not?: InputMaybe<User_Pp_Bool_Exp>;
  _or?: InputMaybe<Array<User_Pp_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  deleted?: InputMaybe<Boolean_Comparison_Exp>;
  deleted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted_by_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  ldap_entry_dn?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  oauth_id?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<Bit_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  ui_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  ui_settings_templates?: InputMaybe<Jsonb_Comparison_Exp>;
  user_type?: InputMaybe<String_Comparison_Exp>;
  userOrgIds?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "bit". All fields are combined with logical 'AND'. */
export type Bit_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bit']>;
  _gt?: InputMaybe<Scalars['bit']>;
  _gte?: InputMaybe<Scalars['bit']>;
  _in?: InputMaybe<Array<Scalars['bit']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bit']>;
  _lte?: InputMaybe<Scalars['bit']>;
  _neq?: InputMaybe<Scalars['bit']>;
  _nin?: InputMaybe<Array<Scalars['bit']>>;
};

/** Boolean expression to filter rows from the table "tenant". All fields are combined with a logical 'AND'. */
export type Tenant_Bool_Exp = {
  _and?: InputMaybe<Array<Tenant_Bool_Exp>>;
  _not?: InputMaybe<Tenant_Bool_Exp>;
  _or?: InputMaybe<Array<Tenant_Bool_Exp>>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  api_keys?: InputMaybe<Api_Key_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_labels?: InputMaybe<Declaration_Labels_Bool_Exp>;
  document_labels?: InputMaybe<Document_Labels_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  import_list_triggers?: InputMaybe<Import_List_Trigger_Bool_Exp>;
  import_list_triggers_aggregate?: InputMaybe<Import_List_Trigger_Aggregate_Bool_Exp>;
  is_wd_customer?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  org_ids?: InputMaybe<Org_Id_Bool_Exp>;
  permissions?: InputMaybe<Bit_Comparison_Exp>;
  permissions_js?: InputMaybe<Jsonb_Comparison_Exp>;
  service_rates?: InputMaybe<Service_Rate_Bool_Exp>;
  tenant_name?: InputMaybe<String_Comparison_Exp>;
  tenant_type?: InputMaybe<Tenant_Type_Comparison_Exp>;
  tenantDocumentTypes?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  user_pps?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "api_key". All fields are combined with a logical 'AND'. */
export type Api_Key_Bool_Exp = {
  _and?: InputMaybe<Array<Api_Key_Bool_Exp>>;
  _not?: InputMaybe<Api_Key_Bool_Exp>;
  _or?: InputMaybe<Array<Api_Key_Bool_Exp>>;
  api_key?: InputMaybe<String_Comparison_Exp>;
  dsplay_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_labels". All fields are combined with a logical 'AND'. */
export type Declaration_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Labels_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Labels_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_labels". All fields are combined with a logical 'AND'. */
export type Document_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Labels_Bool_Exp>>;
  _not?: InputMaybe<Document_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Labels_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<Jsonb_Comparison_Exp>;
  document_label_org_ids?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  tenantId?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_label_org_id". All fields are combined with a logical 'AND'. */
export type Document_Label_Org_Id_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Label_Org_Id_Bool_Exp>>;
  _not?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Label_Org_Id_Bool_Exp>>;
  label_id?: InputMaybe<Int_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "org_id". All fields are combined with a logical 'AND'. */
export type Org_Id_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Id_Bool_Exp>>;
  _not?: InputMaybe<Org_Id_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Id_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  org_id_description?: InputMaybe<String_Comparison_Exp>;
  orgIdUsers?: InputMaybe<User_Org_Id_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  userOrgId?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "document". All fields are combined with a logical 'AND'. */
export type Document_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Bool_Exp>>;
  _not?: InputMaybe<Document_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Bool_Exp>>;
  annotationType?: InputMaybe<Annotation_Type_Bool_Exp>;
  articles?: InputMaybe<Article_Bool_Exp>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  computedPagesM2M?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  doc_tasks?: InputMaybe<Declaration_Task_Bool_Exp>;
  doc_tasks_aggregate?: InputMaybe<Declaration_Task_Aggregate_Bool_Exp>;
  docAnnotations?: InputMaybe<Doc_Annotation_Bool_Exp>;
  document_blobs?: InputMaybe<Jsonb_Comparison_Exp>;
  document_extension?: InputMaybe<String_Comparison_Exp>;
  document_flags?: InputMaybe<Bigint_Comparison_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
  document_status?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  document_version?: InputMaybe<Int_Comparison_Exp>;
  documentExtensionByDocumentExtension?: InputMaybe<Document_Extension_Bool_Exp>;
  documentFile?: InputMaybe<File_Bool_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file?: InputMaybe<Uuid_Comparison_Exp>;
  file_object?: InputMaybe<File_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_customs_relevant?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_generated?: InputMaybe<Boolean_Comparison_Exp>;
  is_template?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_pages?: InputMaybe<Smallint_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  organization?: InputMaybe<Org_Id_Bool_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  pages_m2m?: InputMaybe<Document_Page_Bool_Exp>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Bool_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<Document_Status_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "annotation_type". All fields are combined with a logical 'AND'. */
export type Annotation_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Annotation_Type_Bool_Exp>>;
  _not?: InputMaybe<Annotation_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Annotation_Type_Bool_Exp>>;
  anno_schema?: InputMaybe<Json_Comparison_Exp>;
  anno_type_id?: InputMaybe<Smallint_Comparison_Exp>;
  annotation_provider?: InputMaybe<Annotation_Provider_Bool_Exp>;
  annotation_provider_id?: InputMaybe<Smallint_Comparison_Exp>;
  annotation_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  annotation_type?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  ui_schema?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

/** Boolean expression to filter rows from the table "annotation_provider". All fields are combined with a logical 'AND'. */
export type Annotation_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Annotation_Provider_Bool_Exp>>;
  _not?: InputMaybe<Annotation_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Annotation_Provider_Bool_Exp>>;
  annotation_provider?: InputMaybe<String_Comparison_Exp>;
  annotation_provider_id?: InputMaybe<Smallint_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_type". All fields are combined with a logical 'AND'. */
export type Document_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_Bool_Exp>>;
  annotation_types?: InputMaybe<Annotation_Type_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  document_type_all_tenant_settings?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
  document_type_tenant_settings?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  user_pp?: InputMaybe<User_Pp_Bool_Exp>;
  userPpByCreationUser?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "document_type_all_tenant_settings". All fields are combined with a logical 'AND'. */
export type Document_Type_All_Tenant_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  default_flags?: InputMaybe<Bigint_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  document_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tenant?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** Boolean expression to filter rows from the table "document_type_tenant_settings". All fields are combined with a logical 'AND'. */
export type Document_Type_Tenant_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Type_Tenant_Settings_Bool_Exp>>;
  _not?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Type_Tenant_Settings_Bool_Exp>>;
  code?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  default_flags?: InputMaybe<Bigint_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  document_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tenant?: InputMaybe<Uuid_Comparison_Exp>;
  Tenant?: InputMaybe<Tenant_Bool_Exp>;
};

export type Document_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Document_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Document_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Document_Aggregate_Bool_Exp_Count>;
};

export type Document_Aggregate_Bool_Exp_Bool_And = {
  arguments: Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "document_aggregate_bool_exp_bool_and_arguments_columns" columns of table "document" */
export enum Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  IsTemplate = 'is_template'
}

export type Document_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Document_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "document_aggregate_bool_exp_bool_or_arguments_columns" columns of table "document" */
export enum Document_Select_Column_Document_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  IsTemplate = 'is_template'
}

export type Document_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Document_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "document" */
export enum Document_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DocumentVersion = 'document_version',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Sequence = 'sequence'
}

/** Boolean expression to filter rows from the table "article". All fields are combined with a logical 'AND'. */
export type Article_Bool_Exp = {
  _and?: InputMaybe<Array<Article_Bool_Exp>>;
  _not?: InputMaybe<Article_Bool_Exp>;
  _or?: InputMaybe<Array<Article_Bool_Exp>>;
  article_id?: InputMaybe<Smallint_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  coords?: InputMaybe<_Int4_Comparison_Exp>;
  country_of_origin?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  gross_weight?: InputMaybe<String_Comparison_Exp>;
  height?: InputMaybe<String_Comparison_Exp>;
  hscode?: InputMaybe<String_Comparison_Exp>;
  length?: InputMaybe<String_Comparison_Exp>;
  marks?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  net_weight?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  price?: InputMaybe<String_Comparison_Exp>;
  purchase_order_number?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  total_price?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<String_Comparison_Exp>;
  width?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_int4". All fields are combined with logical 'AND'. */
export type _Int4_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_int4']>;
  _gt?: InputMaybe<Scalars['_int4']>;
  _gte?: InputMaybe<Scalars['_int4']>;
  _in?: InputMaybe<Array<Scalars['_int4']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_int4']>;
  _lte?: InputMaybe<Scalars['_int4']>;
  _neq?: InputMaybe<Scalars['_int4']>;
  _nin?: InputMaybe<Array<Scalars['_int4']>>;
};

/** Boolean expression to filter rows from the table "pages_m2m_cache". All fields are combined with a logical 'AND'. */
export type Pages_M2m_Cache_Bool_Exp = {
  _and?: InputMaybe<Array<Pages_M2m_Cache_Bool_Exp>>;
  _not?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
  _or?: InputMaybe<Array<Pages_M2m_Cache_Bool_Exp>>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  page?: InputMaybe<Uuid_Comparison_Exp>;
  page_number?: InputMaybe<Bigint_Comparison_Exp>;
  page_status?: InputMaybe<String_Comparison_Exp>;
  rotate?: InputMaybe<Int_Comparison_Exp>;
  thumbnail_big_url?: InputMaybe<String_Comparison_Exp>;
  thumbnail_small_url?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_task". All fields are combined with a logical 'AND'. */
export type Declaration_Task_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Task_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Task_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Task_Bool_Exp>>;
  assigned_to?: InputMaybe<Uuid_Comparison_Exp>;
  assigned_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  object_id?: InputMaybe<Uuid_Comparison_Exp>;
  task_status_id?: InputMaybe<Int_Comparison_Exp>;
  task_type?: InputMaybe<Task_Type_Bool_Exp>;
  task_type_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "file". All fields are combined with a logical 'AND'. */
export type File_Bool_Exp = {
  _and?: InputMaybe<Array<File_Bool_Exp>>;
  _not?: InputMaybe<File_Bool_Exp>;
  _or?: InputMaybe<Array<File_Bool_Exp>>;
  ai_doc_classification_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration?: InputMaybe<Declaration_Request_Bool_Exp>;
  declaration_requests?: InputMaybe<Declaration_Request_Bool_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  file_flags?: InputMaybe<Bigint_Comparison_Exp>;
  file_status?: InputMaybe<String_Comparison_Exp>;
  file_tasks?: InputMaybe<Declaration_Task_Bool_Exp>;
  file_tasks_aggregate?: InputMaybe<Declaration_Task_Aggregate_Bool_Exp>;
  file_type?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identification?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_request". All fields are combined with a logical 'AND'. */
export type Declaration_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Request_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Request_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  arrival_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  arrivalType?: InputMaybe<Arrival_Type_Bool_Exp>;
  bill_details?: InputMaybe<Bill_Detail_Bool_Exp>;
  cev_status?: InputMaybe<String_Comparison_Exp>;
  ch_exp_decl?: InputMaybe<Boolean_Comparison_Exp>;
  clearance_type?: InputMaybe<String_Comparison_Exp>;
  clearanceTypeByClearanceType?: InputMaybe<Clearance_Type_Bool_Exp>;
  clientCompany?: InputMaybe<Tenant_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_declaration_number?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Smallint_Comparison_Exp>;
  customsOffices?: InputMaybe<Customs_Offices_Bool_Exp>;
  declaration?: InputMaybe<Declaration_Bool_Exp>;
  declaration_discussions?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  declaration_discussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp>;
  declaration_documents?: InputMaybe<Declaration_Document_Bool_Exp>;
  declaration_request_addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  declaration_request_labels?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  declarationStatusByDeclarationStatus?: InputMaybe<Declaration_Status_Bool_Exp>;
  declarationTypeByDeclarationType?: InputMaybe<Declaration_Type_Bool_Exp>;
  dest_tolldept_code?: InputMaybe<String_Comparison_Exp>;
  dest_tolldept_name?: InputMaybe<String_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  edec?: InputMaybe<Jsonb_Comparison_Exp>;
  eta?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  imp_cust_clr?: InputMaybe<Boolean_Comparison_Exp>;
  is_express?: InputMaybe<Boolean_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  mrn_number?: InputMaybe<String_Comparison_Exp>;
  payer?: InputMaybe<Tenant_Bool_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  toll_dep?: InputMaybe<String_Comparison_Exp>;
  tr_no?: InputMaybe<String_Comparison_Exp>;
  trader_reference?: InputMaybe<String_Comparison_Exp>;
  transitdoc_type?: InputMaybe<Transitdoc_Type_Comparison_Exp>;
  user_pp?: InputMaybe<User_Pp_Bool_Exp>;
  wa_number?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_request_address". All fields are combined with a logical 'AND'. */
export type Declaration_Request_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Request_Address_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Request_Address_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Json_Comparison_Exp>;
  refs?: InputMaybe<_Text_Comparison_Exp>;
  search_refs?: InputMaybe<_Text_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']>;
  _gt?: InputMaybe<Scalars['_text']>;
  _gte?: InputMaybe<Scalars['_text']>;
  _in?: InputMaybe<Array<Scalars['_text']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_text']>;
  _lte?: InputMaybe<Scalars['_text']>;
  _neq?: InputMaybe<Scalars['_text']>;
  _nin?: InputMaybe<Array<Scalars['_text']>>;
};

/** Boolean expression to filter rows from the table "arrival_type". All fields are combined with a logical 'AND'. */
export type Arrival_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Arrival_Type_Bool_Exp>>;
  _not?: InputMaybe<Arrival_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Arrival_Type_Bool_Exp>>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "bill_detail". All fields are combined with a logical 'AND'. */
export type Bill_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Bill_Detail_Bool_Exp>>;
  _not?: InputMaybe<Bill_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Bill_Detail_Bool_Exp>>;
  bill?: InputMaybe<Bill_Bool_Exp>;
  bill_id?: InputMaybe<Bigint_Comparison_Exp>;
  charged_items?: InputMaybe<Bigint_Comparison_Exp>;
  const_charge?: InputMaybe<Numeric_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  detail_id?: InputMaybe<Bigint_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  remark?: InputMaybe<String_Comparison_Exp>;
  sequence?: InputMaybe<Smallint_Comparison_Exp>;
  service?: InputMaybe<Service_Bool_Exp>;
  srv_id?: InputMaybe<Int_Comparison_Exp>;
  var_charge?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "bill". All fields are combined with a logical 'AND'. */
export type Bill_Bool_Exp = {
  _and?: InputMaybe<Array<Bill_Bool_Exp>>;
  _not?: InputMaybe<Bill_Bool_Exp>;
  _or?: InputMaybe<Array<Bill_Bool_Exp>>;
  bill_details?: InputMaybe<Bill_Detail_Bool_Exp>;
  bill_id?: InputMaybe<Bigint_Comparison_Exp>;
  bill_type?: InputMaybe<Name_Comparison_Exp>;
  from_ts?: InputMaybe<Timestamptz_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  payment_terms?: InputMaybe<Smallint_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  to_ts?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "name". All fields are combined with logical 'AND'. */
export type Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['name']>;
  _gt?: InputMaybe<Scalars['name']>;
  _gte?: InputMaybe<Scalars['name']>;
  _in?: InputMaybe<Array<Scalars['name']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['name']>;
  _lte?: InputMaybe<Scalars['name']>;
  _neq?: InputMaybe<Scalars['name']>;
  _nin?: InputMaybe<Array<Scalars['name']>>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** Boolean expression to filter rows from the table "service". All fields are combined with a logical 'AND'. */
export type Service_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Bool_Exp>>;
  _not?: InputMaybe<Service_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Bool_Exp>>;
  service_rates?: InputMaybe<Service_Rate_Bool_Exp>;
  srv_desk?: InputMaybe<String_Comparison_Exp>;
  srv_id?: InputMaybe<Int_Comparison_Exp>;
  srv_type?: InputMaybe<String_Comparison_Exp>;
  translation?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "service_rate". All fields are combined with a logical 'AND'. */
export type Service_Rate_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Rate_Bool_Exp>>;
  _not?: InputMaybe<Service_Rate_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Rate_Bool_Exp>>;
  const_included?: InputMaybe<Int_Comparison_Exp>;
  const_rate?: InputMaybe<Numeric_Comparison_Exp>;
  service?: InputMaybe<Service_Bool_Exp>;
  srv_id?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  var_rate?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** Boolean expression to filter rows from the table "clearance_type". All fields are combined with a logical 'AND'. */
export type Clearance_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Clearance_Type_Bool_Exp>>;
  _not?: InputMaybe<Clearance_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Clearance_Type_Bool_Exp>>;
  declaration_requests?: InputMaybe<Declaration_Request_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "customs_offices". All fields are combined with a logical 'AND'. */
export type Customs_Offices_Bool_Exp = {
  _and?: InputMaybe<Array<Customs_Offices_Bool_Exp>>;
  _not?: InputMaybe<Customs_Offices_Bool_Exp>;
  _or?: InputMaybe<Array<Customs_Offices_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  office_number?: InputMaybe<String_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_to?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration". All fields are combined with a logical 'AND'. */
export type Declaration_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  access_code?: InputMaybe<String_Comparison_Exp>;
  addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  agreed_location_of_goods?: InputMaybe<String_Comparison_Exp>;
  ai_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  ai_results?: InputMaybe<Jsonb_Comparison_Exp>;
  border_eau_number?: InputMaybe<Numeric_Comparison_Exp>;
  bunch_number?: InputMaybe<Int_Comparison_Exp>;
  change_information?: InputMaybe<Date_Comparison_Exp>;
  clearance_location?: InputMaybe<Smallint_Comparison_Exp>;
  company_number_taxpayer?: InputMaybe<String_Comparison_Exp>;
  containers?: InputMaybe<Containers_Bool_Exp>;
  correction_code?: InputMaybe<Int_Comparison_Exp>;
  correction_reason?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_account_address_type?: InputMaybe<Int_Comparison_Exp>;
  customs_account_name?: InputMaybe<String_Comparison_Exp>;
  customs_account_number?: InputMaybe<Bigint_Comparison_Exp>;
  customs_declaration_number?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Int_Comparison_Exp>;
  customs_office_number?: InputMaybe<String_Comparison_Exp>;
  declarant_company_name?: InputMaybe<String_Comparison_Exp>;
  declarant_number?: InputMaybe<Int_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  declaration_special_mentions?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
  declaration_time?: InputMaybe<Smallint_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  delivery_destination?: InputMaybe<Bpchar_Comparison_Exp>;
  dispatch_country?: InputMaybe<String_Comparison_Exp>;
  dispatch_country_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_and_other_taxes_amount?: InputMaybe<Numeric_Comparison_Exp>;
  duty_total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  evv_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  evv_received?: InputMaybe<Boolean_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goods_items?: InputMaybe<Goods_Item_Bool_Exp>;
  goods_items_aggregate?: InputMaybe<Goods_Item_Aggregate_Bool_Exp>;
  gross_mass?: InputMaybe<Numeric_Comparison_Exp>;
  incoterms?: InputMaybe<String_Comparison_Exp>;
  initiator?: InputMaybe<Smallint_Comparison_Exp>;
  injunction_type?: InputMaybe<Smallint_Comparison_Exp>;
  inspection_code?: InputMaybe<Boolean_Comparison_Exp>;
  invoice_currency_type?: InputMaybe<String_Comparison_Exp>;
  lang?: InputMaybe<String_Comparison_Exp>;
  material_check?: InputMaybe<Boolean_Comparison_Exp>;
  net_mass?: InputMaybe<Numeric_Comparison_Exp>;
  packaging_quantity?: InputMaybe<Int_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_of_loading?: InputMaybe<String_Comparison_Exp>;
  place_of_unloading?: InputMaybe<String_Comparison_Exp>;
  postal_shipment_type?: InputMaybe<String_Comparison_Exp>;
  previous_documents?: InputMaybe<Previous_Documents_Bool_Exp>;
  procedure_type?: InputMaybe<Smallint_Comparison_Exp>;
  provisional_declaration_expiration_date?: InputMaybe<Date_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  receive_status?: InputMaybe<Int_Comparison_Exp>;
  release?: InputMaybe<Boolean_Comparison_Exp>;
  requestor_trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  security?: InputMaybe<Boolean_Comparison_Exp>;
  selection_correlation_id?: InputMaybe<String_Comparison_Exp>;
  send_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  send_status?: InputMaybe<Int_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  show_in_wd?: InputMaybe<Boolean_Comparison_Exp>;
  specific_circumstance_indicator?: InputMaybe<Bpchar_Comparison_Exp>;
  status?: InputMaybe<Int_Comparison_Exp>;
  status_date?: InputMaybe<Date_Comparison_Exp>;
  status_time?: InputMaybe<Time_Comparison_Exp>;
  tara_factor?: InputMaybe<Numeric_Comparison_Exp>;
  total_colis?: InputMaybe<Int_Comparison_Exp>;
  total_goods_items?: InputMaybe<Int_Comparison_Exp>;
  total_gross_weight?: InputMaybe<Numeric_Comparison_Exp>;
  total_vat_value?: InputMaybe<Numeric_Comparison_Exp>;
  trader_declaration_number?: InputMaybe<String_Comparison_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  trader_reference?: InputMaybe<String_Comparison_Exp>;
  transfer_to_transit_system?: InputMaybe<Boolean_Comparison_Exp>;
  transport_country?: InputMaybe<String_Comparison_Exp>;
  transport_in_container?: InputMaybe<Boolean_Comparison_Exp>;
  transport_mode?: InputMaybe<Int_Comparison_Exp>;
  transport_number?: InputMaybe<String_Comparison_Exp>;
  transport_type?: InputMaybe<String_Comparison_Exp>;
  unique_consignment_reference_number?: InputMaybe<String_Comparison_Exp>;
  vat_account_address_type?: InputMaybe<Int_Comparison_Exp>;
  vat_account_name?: InputMaybe<String_Comparison_Exp>;
  vat_account_number?: InputMaybe<Bigint_Comparison_Exp>;
  vat_number?: InputMaybe<String_Comparison_Exp>;
  vat_suffix?: InputMaybe<Boolean_Comparison_Exp>;
  vat_total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  warehouse_coded?: InputMaybe<Smallint_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "containers". All fields are combined with a logical 'AND'. */
export type Containers_Bool_Exp = {
  _and?: InputMaybe<Array<Containers_Bool_Exp>>;
  _not?: InputMaybe<Containers_Bool_Exp>;
  _or?: InputMaybe<Array<Containers_Bool_Exp>>;
  container_number?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_special_mentions". All fields are combined with a logical 'AND'. */
export type Declaration_Special_Mentions_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Special_Mentions_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Special_Mentions_Bool_Exp>>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  sequence_number?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']>;
  _gt?: InputMaybe<Scalars['bpchar']>;
  _gte?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']>;
  _in?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']>;
  _lt?: InputMaybe<Scalars['bpchar']>;
  _lte?: InputMaybe<Scalars['bpchar']>;
  _neq?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']>;
};

/** Boolean expression to filter rows from the table "goods_item". All fields are combined with a logical 'AND'. */
export type Goods_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Goods_Item_Bool_Exp>>;
  _not?: InputMaybe<Goods_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Goods_Item_Bool_Exp>>;
  additional_unit?: InputMaybe<String_Comparison_Exp>;
  additional_unit_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  billing_type?: InputMaybe<Smallint_Comparison_Exp>;
  clearance_type?: InputMaybe<Int_Comparison_Exp>;
  commercial_good?: InputMaybe<Boolean_Comparison_Exp>;
  commodity_code?: InputMaybe<String_Comparison_Exp>;
  commodity_code_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Int_Comparison_Exp>;
  customs_favour_code?: InputMaybe<Int_Comparison_Exp>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  customs_net_weight?: InputMaybe<Numeric_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  direction?: InputMaybe<Smallint_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_and_other_taxes_total?: InputMaybe<Numeric_Comparison_Exp>;
  duty_rate?: InputMaybe<Numeric_Comparison_Exp>;
  duty_total?: InputMaybe<Numeric_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goods_item_special_mentions?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
  goods_item_special_mentions_aggregate?: InputMaybe<Goods_Item_Special_Mentions_Aggregate_Bool_Exp>;
  gross_mass?: InputMaybe<Numeric_Comparison_Exp>;
  gross_mass_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  net_duty?: InputMaybe<Boolean_Comparison_Exp>;
  net_mass?: InputMaybe<Numeric_Comparison_Exp>;
  net_mass_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  non_customs_law_obligation?: InputMaybe<Smallint_Comparison_Exp>;
  origin_country?: InputMaybe<String_Comparison_Exp>;
  origin_preference?: InputMaybe<Boolean_Comparison_Exp>;
  packagings?: InputMaybe<Packagings_Bool_Exp>;
  packagings_aggregate?: InputMaybe<Packagings_Aggregate_Bool_Exp>;
  permit_obligation_code?: InputMaybe<Int_Comparison_Exp>;
  permits?: InputMaybe<Permits_Bool_Exp>;
  permits_aggregate?: InputMaybe<Permits_Aggregate_Bool_Exp>;
  preference_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  process_type?: InputMaybe<Smallint_Comparison_Exp>;
  produced_documents?: InputMaybe<Produced_Documents_Bool_Exp>;
  produced_documents_aggregate?: InputMaybe<Produced_Documents_Aggregate_Bool_Exp>;
  rate_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  refinement_type?: InputMaybe<Smallint_Comparison_Exp>;
  refund_type?: InputMaybe<Smallint_Comparison_Exp>;
  repair?: InputMaybe<Boolean_Comparison_Exp>;
  repair_reason?: InputMaybe<String_Comparison_Exp>;
  selection_result?: InputMaybe<Int_Comparison_Exp>;
  statistical_code?: InputMaybe<Int_Comparison_Exp>;
  statistical_value?: InputMaybe<Int_Comparison_Exp>;
  statistical_value_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  storage_type?: InputMaybe<Smallint_Comparison_Exp>;
  tare_supplement?: InputMaybe<Numeric_Comparison_Exp>;
  tare_supplement_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  un_dangerous_goods_code?: InputMaybe<String_Comparison_Exp>;
  vat_code?: InputMaybe<Smallint_Comparison_Exp>;
  vat_code_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  vat_rate?: InputMaybe<Numeric_Comparison_Exp>;
  vat_total?: InputMaybe<Numeric_Comparison_Exp>;
  vat_value?: InputMaybe<Numeric_Comparison_Exp>;
  vat_value_confirmation?: InputMaybe<Boolean_Comparison_Exp>;
  voc_quantity?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "goods_item_special_mentions". All fields are combined with a logical 'AND'. */
export type Goods_Item_Special_Mentions_Bool_Exp = {
  _and?: InputMaybe<Array<Goods_Item_Special_Mentions_Bool_Exp>>;
  _not?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
  _or?: InputMaybe<Array<Goods_Item_Special_Mentions_Bool_Exp>>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  sequence_number?: InputMaybe<Int_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
};

export type Goods_Item_Special_Mentions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Goods_Item_Special_Mentions_Aggregate_Bool_Exp_Count>;
};

export type Goods_Item_Special_Mentions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "goods_item_special_mentions" */
export enum Goods_Item_Special_Mentions_Select_Column {
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceNumber = 'sequence_number',
  /** column name */
  Text = 'text'
}

/** Boolean expression to filter rows from the table "packagings". All fields are combined with a logical 'AND'. */
export type Packagings_Bool_Exp = {
  _and?: InputMaybe<Array<Packagings_Bool_Exp>>;
  _not?: InputMaybe<Packagings_Bool_Exp>;
  _or?: InputMaybe<Array<Packagings_Bool_Exp>>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  packaging_quantity?: InputMaybe<Int_Comparison_Exp>;
  packaging_reference_number?: InputMaybe<String_Comparison_Exp>;
  packaging_type?: InputMaybe<String_Comparison_Exp>;
};

export type Packagings_Aggregate_Bool_Exp = {
  count?: InputMaybe<Packagings_Aggregate_Bool_Exp_Count>;
};

export type Packagings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Packagings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Packagings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "packagings" */
export enum Packagings_Select_Column {
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PackagingReferenceNumber = 'packaging_reference_number',
  /** column name */
  PackagingType = 'packaging_type'
}

/** Boolean expression to filter rows from the table "permits". All fields are combined with a logical 'AND'. */
export type Permits_Bool_Exp = {
  _and?: InputMaybe<Array<Permits_Bool_Exp>>;
  _not?: InputMaybe<Permits_Bool_Exp>;
  _or?: InputMaybe<Array<Permits_Bool_Exp>>;
  additional_information?: InputMaybe<String_Comparison_Exp>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  issue_date?: InputMaybe<Date_Comparison_Exp>;
  permit_authority?: InputMaybe<Int_Comparison_Exp>;
  permit_item_details?: InputMaybe<Jsonb_Comparison_Exp>;
  permit_number?: InputMaybe<String_Comparison_Exp>;
  permit_type?: InputMaybe<Int_Comparison_Exp>;
};

export type Permits_Aggregate_Bool_Exp = {
  count?: InputMaybe<Permits_Aggregate_Bool_Exp_Count>;
};

export type Permits_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Permits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Permits_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "permits" */
export enum Permits_Select_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  IssueDate = 'issue_date',
  /** column name */
  PermitAuthority = 'permit_authority',
  /** column name */
  PermitItemDetails = 'permit_item_details',
  /** column name */
  PermitNumber = 'permit_number',
  /** column name */
  PermitType = 'permit_type'
}

/** Boolean expression to filter rows from the table "produced_documents". All fields are combined with a logical 'AND'. */
export type Produced_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Produced_Documents_Bool_Exp>>;
  _not?: InputMaybe<Produced_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Produced_Documents_Bool_Exp>>;
  additional_information?: InputMaybe<String_Comparison_Exp>;
  customs_item_number?: InputMaybe<Int_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  produced_document_issue_date?: InputMaybe<Date_Comparison_Exp>;
  produced_document_reference_number?: InputMaybe<String_Comparison_Exp>;
  produced_document_type?: InputMaybe<String_Comparison_Exp>;
};

export type Produced_Documents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Produced_Documents_Aggregate_Bool_Exp_Count>;
};

export type Produced_Documents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Produced_Documents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "produced_documents" */
export enum Produced_Documents_Select_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProducedDocumentIssueDate = 'produced_document_issue_date',
  /** column name */
  ProducedDocumentReferenceNumber = 'produced_document_reference_number',
  /** column name */
  ProducedDocumentType = 'produced_document_type'
}

export type Goods_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Goods_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Goods_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Goods_Item_Aggregate_Bool_Exp_Count>;
};

export type Goods_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Goods_Item_Select_Column_Goods_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Goods_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "goods_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "goods_item" */
export enum Goods_Item_Select_Column_Goods_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AdditionalUnitConfirmation = 'additional_unit_confirmation',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCodeConfirmation = 'commodity_code_confirmation',
  /** column name */
  GrossMassConfirmation = 'gross_mass_confirmation',
  /** column name */
  NetDuty = 'net_duty',
  /** column name */
  NetMassConfirmation = 'net_mass_confirmation',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  PreferenceConfirmation = 'preference_confirmation',
  /** column name */
  RateConfirmation = 'rate_confirmation',
  /** column name */
  Repair = 'repair',
  /** column name */
  StatisticalValueConfirmation = 'statistical_value_confirmation',
  /** column name */
  TareSupplementConfirmation = 'tare_supplement_confirmation',
  /** column name */
  VatCodeConfirmation = 'vat_code_confirmation',
  /** column name */
  VatValueConfirmation = 'vat_value_confirmation'
}

export type Goods_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Goods_Item_Select_Column_Goods_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Goods_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "goods_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "goods_item" */
export enum Goods_Item_Select_Column_Goods_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AdditionalUnitConfirmation = 'additional_unit_confirmation',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCodeConfirmation = 'commodity_code_confirmation',
  /** column name */
  GrossMassConfirmation = 'gross_mass_confirmation',
  /** column name */
  NetDuty = 'net_duty',
  /** column name */
  NetMassConfirmation = 'net_mass_confirmation',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  PreferenceConfirmation = 'preference_confirmation',
  /** column name */
  RateConfirmation = 'rate_confirmation',
  /** column name */
  Repair = 'repair',
  /** column name */
  StatisticalValueConfirmation = 'statistical_value_confirmation',
  /** column name */
  TareSupplementConfirmation = 'tare_supplement_confirmation',
  /** column name */
  VatCodeConfirmation = 'vat_code_confirmation',
  /** column name */
  VatValueConfirmation = 'vat_value_confirmation'
}

export type Goods_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Goods_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Goods_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "goods_item" */
export enum Goods_Item_Select_Column {
  /** column name */
  AdditionalUnit = 'additional_unit',
  /** column name */
  AdditionalUnitConfirmation = 'additional_unit_confirmation',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CommodityCodeConfirmation = 'commodity_code_confirmation',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsFavourCode = 'customs_favour_code',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  CustomsNetWeight = 'customs_net_weight',
  /** column name */
  Description = 'description',
  /** column name */
  Direction = 'direction',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndOtherTaxesTotal = 'duty_and_other_taxes_total',
  /** column name */
  DutyRate = 'duty_rate',
  /** column name */
  DutyTotal = 'duty_total',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  GrossMassConfirmation = 'gross_mass_confirmation',
  /** column name */
  NetDuty = 'net_duty',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NetMassConfirmation = 'net_mass_confirmation',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  PermitObligationCode = 'permit_obligation_code',
  /** column name */
  PreferenceConfirmation = 'preference_confirmation',
  /** column name */
  ProcessType = 'process_type',
  /** column name */
  RateConfirmation = 'rate_confirmation',
  /** column name */
  RefinementType = 'refinement_type',
  /** column name */
  RefundType = 'refund_type',
  /** column name */
  Repair = 'repair',
  /** column name */
  RepairReason = 'repair_reason',
  /** column name */
  SelectionResult = 'selection_result',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  StatisticalValue = 'statistical_value',
  /** column name */
  StatisticalValueConfirmation = 'statistical_value_confirmation',
  /** column name */
  StorageType = 'storage_type',
  /** column name */
  TareSupplement = 'tare_supplement',
  /** column name */
  TareSupplementConfirmation = 'tare_supplement_confirmation',
  /** column name */
  UnDangerousGoodsCode = 'un_dangerous_goods_code',
  /** column name */
  VatCode = 'vat_code',
  /** column name */
  VatCodeConfirmation = 'vat_code_confirmation',
  /** column name */
  VatRate = 'vat_rate',
  /** column name */
  VatTotal = 'vat_total',
  /** column name */
  VatValue = 'vat_value',
  /** column name */
  VatValueConfirmation = 'vat_value_confirmation',
  /** column name */
  VocQuantity = 'voc_quantity'
}

/** Boolean expression to filter rows from the table "previous_documents". All fields are combined with a logical 'AND'. */
export type Previous_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Previous_Documents_Bool_Exp>>;
  _not?: InputMaybe<Previous_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Previous_Documents_Bool_Exp>>;
  additional_information?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  previous_document_reference?: InputMaybe<String_Comparison_Exp>;
  previous_document_type?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to filter rows from the table "declaration_discussion". All fields are combined with a logical 'AND'. */
export type Declaration_Discussion_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Discussion_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Discussion_Bool_Exp>>;
  closed?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_messages?: InputMaybe<Declaration_Message_Bool_Exp>;
  declaration_messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Bool_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  discussion_id?: InputMaybe<Bigint_Comparison_Exp>;
  discussion_theme?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  user_pp?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_message". All fields are combined with a logical 'AND'. */
export type Declaration_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Message_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Message_Bool_Exp>>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_discussion?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  discussion_id?: InputMaybe<Bigint_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  msg_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  read_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

export type Declaration_Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Declaration_Message_Aggregate_Bool_Exp_Count>;
};

export type Declaration_Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "declaration_message" */
export enum Declaration_Message_Select_Column {
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  MsgDate = 'msg_date',
  /** column name */
  ReadDate = 'read_date',
  /** column name */
  Type = 'type'
}

export type Declaration_Discussion_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp_Count>;
};

export type Declaration_Discussion_Aggregate_Bool_Exp_Bool_And = {
  arguments: Declaration_Discussion_Select_Column_Declaration_Discussion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "declaration_discussion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "declaration_discussion" */
export enum Declaration_Discussion_Select_Column_Declaration_Discussion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Closed = 'closed'
}

export type Declaration_Discussion_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Declaration_Discussion_Select_Column_Declaration_Discussion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

/** select "declaration_discussion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "declaration_discussion" */
export enum Declaration_Discussion_Select_Column_Declaration_Discussion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Closed = 'closed'
}

export type Declaration_Discussion_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "declaration_discussion" */
export enum Declaration_Discussion_Select_Column {
  /** column name */
  Closed = 'closed',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  DiscussionTheme = 'discussion_theme',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Meta = 'meta'
}

/** Boolean expression to filter rows from the table "declaration_document". All fields are combined with a logical 'AND'. */
export type Declaration_Document_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Document_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Document_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Document_Bool_Exp>>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_request_labels". All fields are combined with a logical 'AND'. */
export type Declaration_Request_Labels_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Request_Labels_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Request_Labels_Bool_Exp>>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  label_id?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_status". All fields are combined with a logical 'AND'. */
export type Declaration_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Status_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "declaration_type". All fields are combined with a logical 'AND'. */
export type Declaration_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Type_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Type_Bool_Exp>>;
  declaration_requests?: InputMaybe<Declaration_Request_Bool_Exp>;
  document_schema?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "transitdoc_type". All fields are combined with logical 'AND'. */
export type Transitdoc_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['transitdoc_type']>;
  _gt?: InputMaybe<Scalars['transitdoc_type']>;
  _gte?: InputMaybe<Scalars['transitdoc_type']>;
  _in?: InputMaybe<Array<Scalars['transitdoc_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['transitdoc_type']>;
  _lte?: InputMaybe<Scalars['transitdoc_type']>;
  _neq?: InputMaybe<Scalars['transitdoc_type']>;
  _nin?: InputMaybe<Array<Scalars['transitdoc_type']>>;
};

export type Declaration_Task_Aggregate_Bool_Exp = {
  count?: InputMaybe<Declaration_Task_Aggregate_Bool_Exp_Count>;
};

export type Declaration_Task_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Declaration_Task_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "declaration_task" */
export enum Declaration_Task_Select_Column {
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  TaskStatusId = 'task_status_id',
  /** column name */
  TaskTypeId = 'task_type_id',
  /** column name */
  Title = 'title'
}

/** Boolean expression to filter rows from the table "task_type". All fields are combined with a logical 'AND'. */
export type Task_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Task_Type_Bool_Exp>>;
  _not?: InputMaybe<Task_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Task_Type_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "doc_annotation". All fields are combined with a logical 'AND'. */
export type Doc_Annotation_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Annotation_Bool_Exp>>;
  _not?: InputMaybe<Doc_Annotation_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Annotation_Bool_Exp>>;
  anno_type_id?: InputMaybe<Smallint_Comparison_Exp>;
  annotation_type?: InputMaybe<Annotation_Type_Bool_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_extension". All fields are combined with a logical 'AND'. */
export type Document_Extension_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Extension_Bool_Exp>>;
  _not?: InputMaybe<Document_Extension_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Extension_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  thumbnails_supported?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "document_page". All fields are combined with a logical 'AND'. */
export type Document_Page_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Page_Bool_Exp>>;
  _not?: InputMaybe<Document_Page_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Page_Bool_Exp>>;
  document?: InputMaybe<Document_Bool_Exp>;
  document_id?: InputMaybe<Uuid_Comparison_Exp>;
  page?: InputMaybe<Page_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  page_number?: InputMaybe<Smallint_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "page". All fields are combined with a logical 'AND'. */
export type Page_Bool_Exp = {
  _and?: InputMaybe<Array<Page_Bool_Exp>>;
  _not?: InputMaybe<Page_Bool_Exp>;
  _or?: InputMaybe<Array<Page_Bool_Exp>>;
  ai_ignore_retraining?: InputMaybe<Boolean_Comparison_Exp>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Page_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Page_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  ocr_text?: InputMaybe<String_Comparison_Exp>;
  page_extracts?: InputMaybe<Page_Extract_Bool_Exp>;
  page_status?: InputMaybe<String_Comparison_Exp>;
  rotate?: InputMaybe<Smallint_Comparison_Exp>;
  thumbnail_big_url?: InputMaybe<String_Comparison_Exp>;
  thumbnail_small_url?: InputMaybe<String_Comparison_Exp>;
};

export type Document_Page_Aggregate_Bool_Exp = {
  count?: InputMaybe<Document_Page_Aggregate_Bool_Exp_Count>;
};

export type Document_Page_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Document_Page_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Document_Page_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "document_page" */
export enum Document_Page_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  PageNumber = 'page_number'
}

/** Boolean expression to filter rows from the table "page_extract". All fields are combined with a logical 'AND'. */
export type Page_Extract_Bool_Exp = {
  _and?: InputMaybe<Array<Page_Extract_Bool_Exp>>;
  _not?: InputMaybe<Page_Extract_Bool_Exp>;
  _or?: InputMaybe<Array<Page_Extract_Bool_Exp>>;
  extract_type?: InputMaybe<Extract_Type_Bool_Exp>;
  extract_type_id?: InputMaybe<Smallint_Comparison_Exp>;
  page?: InputMaybe<Page_Bool_Exp>;
  page_id?: InputMaybe<Uuid_Comparison_Exp>;
  tables?: InputMaybe<Jsonb_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "extract_type". All fields are combined with a logical 'AND'. */
export type Extract_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Extract_Type_Bool_Exp>>;
  _not?: InputMaybe<Extract_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Extract_Type_Bool_Exp>>;
  extract_type_id?: InputMaybe<Smallint_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translations?: InputMaybe<Json_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "document_status". All fields are combined with a logical 'AND'. */
export type Document_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Status_Bool_Exp>>;
  _not?: InputMaybe<Document_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Status_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "user_org_id". All fields are combined with a logical 'AND'. */
export type User_Org_Id_Bool_Exp = {
  _and?: InputMaybe<Array<User_Org_Id_Bool_Exp>>;
  _not?: InputMaybe<User_Org_Id_Bool_Exp>;
  _or?: InputMaybe<Array<User_Org_Id_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  user_pp?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Boolean expression to filter rows from the table "import_list_trigger". All fields are combined with a logical 'AND'. */
export type Import_List_Trigger_Bool_Exp = {
  _and?: InputMaybe<Array<Import_List_Trigger_Bool_Exp>>;
  _not?: InputMaybe<Import_List_Trigger_Bool_Exp>;
  _or?: InputMaybe<Array<Import_List_Trigger_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  creationUser?: InputMaybe<User_Pp_Bool_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  label?: InputMaybe<Declaration_Labels_Bool_Exp>;
  label_id?: InputMaybe<Int_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  lastModifiedUser?: InputMaybe<User_Pp_Bool_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

export type Import_List_Trigger_Aggregate_Bool_Exp = {
  count?: InputMaybe<Import_List_Trigger_Aggregate_Bool_Exp_Count>;
};

export type Import_List_Trigger_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Import_List_Trigger_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** select columns of table "import_list_trigger" */
export enum Import_List_Trigger_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  LabelId = 'label_id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type'
}

/** Boolean expression to compare columns of type "tenant_type". All fields are combined with logical 'AND'. */
export type Tenant_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tenant_type']>;
  _gt?: InputMaybe<Scalars['tenant_type']>;
  _gte?: InputMaybe<Scalars['tenant_type']>;
  _in?: InputMaybe<Array<Scalars['tenant_type']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tenant_type']>;
  _lte?: InputMaybe<Scalars['tenant_type']>;
  _neq?: InputMaybe<Scalars['tenant_type']>;
  _nin?: InputMaybe<Array<Scalars['tenant_type']>>;
};

/** Boolean expression to filter rows from the table "extraction_config". All fields are combined with a logical 'AND'. */
export type Extraction_Config_Bool_Exp = {
  _and?: InputMaybe<Array<Extraction_Config_Bool_Exp>>;
  _not?: InputMaybe<Extraction_Config_Bool_Exp>;
  _or?: InputMaybe<Array<Extraction_Config_Bool_Exp>>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  aliases?: InputMaybe<Jsonb_Comparison_Exp>;
  document_templates?: InputMaybe<Jsonb_Comparison_Exp>;
  foun_config?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']>;
  _gt?: InputMaybe<Scalars['tsvector']>;
  _gte?: InputMaybe<Scalars['tsvector']>;
  _in?: InputMaybe<Array<Scalars['tsvector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['tsvector']>;
  _lte?: InputMaybe<Scalars['tsvector']>;
  _neq?: InputMaybe<Scalars['tsvector']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']>>;
};

/** Table containing addresses of consgnor/consgnee */
export type Address = {
  additional_values: Maybe<Scalars['jsonb']>;
  address_type: Maybe<Scalars['Int']>;
  /** An object relationship */
  addressType: Maybe<Address_Type>;
  ao_id: Maybe<Scalars['smallint']>;
  city: Maybe<Scalars['String']>;
  company_name: Scalars['String'];
  company_name_2: Maybe<Scalars['String']>;
  contact_email: Maybe<Scalars['String']>;
  contact_phone: Maybe<Scalars['String']>;
  contact_website: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Scalars['uuid'];
  /** An object relationship */
  creationUser: Maybe<User_Pp>;
  customs_account_number: Maybe<Scalars['String']>;
  error_email_address: Maybe<Scalars['String']>;
  /** An object relationship */
  extraction_config: Maybe<Extraction_Config>;
  id: Scalars['Int'];
  imported: Maybe<Scalars['Boolean']>;
  is_active: Maybe<Scalars['Boolean']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_locked: Maybe<Scalars['Boolean']>;
  is_platform_user: Scalars['Boolean'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  payer_id: Maybe<Scalars['uuid']>;
  reference: Maybe<Scalars['String']>;
  search_vector: Maybe<Scalars['tsvector']>;
  street: Maybe<Scalars['String']>;
  street_number: Maybe<Scalars['String']>;
  /** An object relationship */
  tenant: Maybe<Tenant>;
  trader_identification_number: Maybe<Scalars['String']>;
  uid_number: Maybe<Scalars['String']>;
  usage_frequency: Maybe<Scalars['Int']>;
  vat_account_number: Maybe<Scalars['String']>;
  vat_number: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** Table containing addresses of consgnor/consgnee */
export type AddressAdditional_ValuesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Table containing addresses of consgnor/consgnee */
export type AddressMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "address_type" */
export type Address_Type = {
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
  name: Scalars['String'];
  translation: Scalars['jsonb'];
};


/** columns and relationships of "address_type" */
export type Address_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "address_type" */
export type Address_TypeTranslationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Users of system */
export type User_Pp = {
  code: Maybe<Scalars['String']>;
  /** An object relationship */
  created_by_user: Maybe<User_Pp>;
  /** User creation date */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** user_pp creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  deleted: Scalars['Boolean'];
  deleted_at: Maybe<Scalars['timestamptz']>;
  deleted_by_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  /** id of user_pp. */
  id: Scalars['uuid'];
  /** user_pp last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified user_pp. */
  last_modified_user: Maybe<Scalars['uuid']>;
  last_name: Maybe<Scalars['String']>;
  ldap_entry_dn: Maybe<Scalars['String']>;
  location: Maybe<Scalars['String']>;
  oauth_id: Maybe<Scalars['String']>;
  permissions: Maybe<Scalars['bit']>;
  phone_number: Maybe<Scalars['String']>;
  /** An object relationship */
  tenant: Tenant;
  /** Tenant of user_pp. */
  tenant_id: Scalars['uuid'];
  ui_settings: Maybe<Scalars['jsonb']>;
  ui_settings_templates: Maybe<Scalars['jsonb']>;
  user_type: Scalars['String'];
  /** An array relationship */
  userOrgIds: Array<User_Org_Id>;
};


/** Users of system */
export type User_PpUi_SettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Users of system */
export type User_PpUi_Settings_TemplatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Users of system */
export type User_PpUserOrgIdsArgs = {
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** Tenant groups users. */
export type Tenant = {
  /** Swiss Customs account number */
  account_number: Maybe<Scalars['String']>;
  /** An object relationship */
  address: Address;
  address_id: Scalars['Int'];
  /** An array relationship */
  api_keys: Array<Api_Key>;
  /** tenant creation date. */
  creation_date: Scalars['timestamptz'];
  /** tenant creation user. */
  creation_user: Scalars['uuid'];
  /** An array relationship */
  declaration_labels: Array<Declaration_Labels>;
  /** An array relationship */
  document_labels: Array<Document_Labels>;
  /** id of tenant. */
  id: Scalars['uuid'];
  /** An array relationship */
  import_list_triggers: Array<Import_List_Trigger>;
  /** An aggregate relationship */
  import_list_triggers_aggregate: Import_List_Trigger_Aggregate;
  is_wd_customer: Scalars['Boolean'];
  /** tenant last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified tenant. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** An array relationship */
  org_ids: Array<Org_Id>;
  permissions: Maybe<Scalars['bit']>;
  permissions_js: Scalars['jsonb'];
  /** An array relationship */
  service_rates: Array<Service_Rate>;
  tenant_name: Scalars['String'];
  tenant_type: Maybe<Scalars['tenant_type']>;
  /** An array relationship */
  tenantDocumentTypes: Array<Document_Type_All_Tenant_Settings>;
  trader_identification_number: Maybe<Scalars['String']>;
  /** An array relationship */
  user_pps: Array<User_Pp>;
};


/** Tenant groups users. */
export type TenantApi_KeysArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Key_Order_By>>;
  where?: InputMaybe<Api_Key_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantDeclaration_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Labels_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantDocument_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantImport_List_TriggersArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantImport_List_Triggers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantOrg_IdsArgs = {
  distinct_on?: InputMaybe<Array<Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Id_Order_By>>;
  where?: InputMaybe<Org_Id_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantPermissions_JsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Tenant groups users. */
export type TenantService_RatesArgs = {
  distinct_on?: InputMaybe<Array<Service_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Rate_Order_By>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantTenantDocumentTypesArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


/** Tenant groups users. */
export type TenantUser_PpsArgs = {
  distinct_on?: InputMaybe<Array<User_Pp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Pp_Order_By>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};

/** select columns of table "api_key" */
export enum Api_Key_Select_Column {
  /** column name */
  ApiKey = 'api_key',
  /** column name */
  DsplayName = 'dsplay_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta'
}

/** Ordering options when selecting data from "api_key". */
export type Api_Key_Order_By = {
  api_key?: InputMaybe<Order_By>;
  dsplay_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
};

/** Api_keys to call external methods of adit-api (now CreateDocument) */
export type Api_Key = {
  api_key: Scalars['String'];
  dsplay_name: Scalars['String'];
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
};


/** Api_keys to call external methods of adit-api (now CreateDocument) */
export type Api_KeyMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_labels" */
export enum Declaration_Labels_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title'
}

/** Ordering options when selecting data from "declaration_labels". */
export type Declaration_Labels_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_labels" */
export type Declaration_Labels = {
  color: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  /** An object relationship */
  tenant: Tenant;
  tenant_id: Scalars['uuid'];
  title: Scalars['jsonb'];
};


/** columns and relationships of "declaration_labels" */
export type Declaration_LabelsTitleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_labels" */
export enum Document_Labels_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  Title = 'title'
}

/** Ordering options when selecting data from "document_labels". */
export type Document_Labels_Order_By = {
  color?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  document_label_org_ids_aggregate?: InputMaybe<Document_Label_Org_Id_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "document_label_org_id" */
export type Document_Label_Org_Id_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Label_Org_Id_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Label_Org_Id_Max_Order_By>;
  min?: InputMaybe<Document_Label_Org_Id_Min_Order_By>;
  stddev?: InputMaybe<Document_Label_Org_Id_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Label_Org_Id_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Label_Org_Id_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Label_Org_Id_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Label_Org_Id_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Label_Org_Id_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Label_Org_Id_Variance_Order_By>;
};

/** order by avg() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Avg_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Max_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Min_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Stddev_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Stddev_Pop_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Stddev_Samp_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Sum_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Var_Pop_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Var_Samp_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_label_org_id" */
export type Document_Label_Org_Id_Variance_Order_By = {
  label_id?: InputMaybe<Order_By>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Order_By>;
};

/** Labels for document. Name for tables must be SIGNULAR. */
export type Document_Labels = {
  color: Scalars['String'];
  description: Scalars['jsonb'];
  /** An array relationship */
  document_label_org_ids: Array<Document_Label_Org_Id>;
  /** id of document_labels. */
  id: Scalars['Int'];
  /** Marks document_labels record as deleted. */
  is_deleted: Scalars['Boolean'];
  /** An object relationship */
  tenant: Maybe<Tenant>;
  tenantId: Maybe<Scalars['uuid']>;
  title: Scalars['jsonb'];
};


/** Labels for document. Name for tables must be SIGNULAR. */
export type Document_LabelsDescriptionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Labels for document. Name for tables must be SIGNULAR. */
export type Document_LabelsDocument_Label_Org_IdsArgs = {
  distinct_on?: InputMaybe<Array<Document_Label_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Label_Org_Id_Order_By>>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};


/** Labels for document. Name for tables must be SIGNULAR. */
export type Document_LabelsTitleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_label_org_id" */
export enum Document_Label_Org_Id_Select_Column {
  /** column name */
  LabelId = 'label_id',
  /** column name */
  OrgId = 'org_id'
}

/** Ordering options when selecting data from "document_label_org_id". */
export type Document_Label_Org_Id_Order_By = {
  label_id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
};

/** Ordering options when selecting data from "org_id". */
export type Org_Id_Order_By = {
  active?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  orgIdUsers_aggregate?: InputMaybe<User_Org_Id_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  userOrgId?: InputMaybe<User_Org_Id_Order_By>;
};

/** order by aggregate values of table "document" */
export type Document_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Max_Order_By>;
  min?: InputMaybe<Document_Min_Order_By>;
  stddev?: InputMaybe<Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Variance_Order_By>;
};

/** order by avg() on columns of table "document" */
export type Document_Avg_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document" */
export type Document_Max_Order_By = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Order_By>;
  /** document creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** document creation user. */
  creation_user?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Document Id related to document. */
  file?: InputMaybe<Order_By>;
  /** id of document. */
  id?: InputMaybe<Order_By>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document" */
export type Document_Min_Order_By = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Order_By>;
  /** document creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** document creation user. */
  creation_user?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Document Id related to document. */
  file?: InputMaybe<Order_By>;
  /** id of document. */
  id?: InputMaybe<Order_By>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document" */
export type Document_Stddev_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document" */
export type Document_Stddev_Pop_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document" */
export type Document_Stddev_Samp_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document" */
export type Document_Sum_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document" */
export type Document_Var_Pop_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document" */
export type Document_Var_Samp_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document" */
export type Document_Variance_Order_By = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Order_By>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Order_By>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_org_id". */
export type User_Org_Id_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  user_pp?: InputMaybe<Order_By>;
};

/** TABLE Of unknown puprose. Deprecate? */
export type Document_Label_Org_Id = {
  label_id: Scalars['Int'];
  /** Org_id related to document_label_org_id. */
  org_id: Scalars['smallint'];
  /** An object relationship */
  orgId: Org_Id;
};

/** List of orgranizations/departments/Abteilungs in system */
export type Org_Id = {
  /** can org_id be used to create new files in adit. */
  active: Maybe<Scalars['Boolean']>;
  /** org_id creation date. */
  creation_date: Scalars['timestamptz'];
  /** org_id creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** org_id last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified org_id. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** Org_id related to org_id. */
  org_id: Scalars['smallint'];
  org_id_description: Scalars['String'];
  /** An array relationship */
  orgIdUsers: Array<User_Org_Id>;
  /** Tenant of org_id. */
  tenant_id: Scalars['uuid'];
  /** An object relationship */
  userOrgId: Maybe<User_Org_Id>;
};


/** List of orgranizations/departments/Abteilungs in system */
export type Org_IdDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** List of orgranizations/departments/Abteilungs in system */
export type Org_IdDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** List of orgranizations/departments/Abteilungs in system */
export type Org_IdOrgIdUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** Ordering options when selecting data from "document". */
export type Document_Order_By = {
  annotationType_aggregate?: InputMaybe<Annotation_Type_Aggregate_Order_By>;
  articles_aggregate?: InputMaybe<Article_Aggregate_Order_By>;
  checksum?: InputMaybe<Order_By>;
  computedPagesM2M_aggregate?: InputMaybe<Pages_M2m_Cache_Aggregate_Order_By>;
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  doc_tasks_aggregate?: InputMaybe<Declaration_Task_Aggregate_Order_By>;
  docAnnotations_aggregate?: InputMaybe<Doc_Annotation_Aggregate_Order_By>;
  document_blobs?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  document_version?: InputMaybe<Order_By>;
  documentExtensionByDocumentExtension?: InputMaybe<Document_Extension_Order_By>;
  documentFile?: InputMaybe<File_Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  file_object?: InputMaybe<File_Order_By>;
  id?: InputMaybe<Order_By>;
  is_customs_relevant?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_generated?: InputMaybe<Order_By>;
  is_template?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  number_of_pages?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Org_Id_Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
  status?: InputMaybe<Document_Status_Order_By>;
};

/** order by aggregate values of table "annotation_type" */
export type Annotation_Type_Aggregate_Order_By = {
  avg?: InputMaybe<Annotation_Type_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Annotation_Type_Max_Order_By>;
  min?: InputMaybe<Annotation_Type_Min_Order_By>;
  stddev?: InputMaybe<Annotation_Type_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Annotation_Type_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Annotation_Type_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Annotation_Type_Sum_Order_By>;
  var_pop?: InputMaybe<Annotation_Type_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Annotation_Type_Var_Samp_Order_By>;
  variance?: InputMaybe<Annotation_Type_Variance_Order_By>;
};

/** order by avg() on columns of table "annotation_type" */
export type Annotation_Type_Avg_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "annotation_type" */
export type Annotation_Type_Max_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
  annotation_type?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "annotation_type" */
export type Annotation_Type_Min_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
  annotation_type?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "annotation_type" */
export type Annotation_Type_Stddev_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "annotation_type" */
export type Annotation_Type_Stddev_Pop_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "annotation_type" */
export type Annotation_Type_Stddev_Samp_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "annotation_type" */
export type Annotation_Type_Sum_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "annotation_type" */
export type Annotation_Type_Var_Pop_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "annotation_type" */
export type Annotation_Type_Var_Samp_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "annotation_type" */
export type Annotation_Type_Variance_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "article" */
export type Article_Aggregate_Order_By = {
  avg?: InputMaybe<Article_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Article_Max_Order_By>;
  min?: InputMaybe<Article_Min_Order_By>;
  stddev?: InputMaybe<Article_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Article_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Article_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Article_Sum_Order_By>;
  var_pop?: InputMaybe<Article_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Article_Var_Samp_Order_By>;
  variance?: InputMaybe<Article_Variance_Order_By>;
};

/** order by avg() on columns of table "article" */
export type Article_Avg_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "article" */
export type Article_Max_Order_By = {
  article_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  country_of_origin?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  gross_weight?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hscode?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  purchase_order_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "article" */
export type Article_Min_Order_By = {
  article_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  country_of_origin?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  gross_weight?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hscode?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  purchase_order_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "article" */
export type Article_Stddev_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "article" */
export type Article_Stddev_Pop_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "article" */
export type Article_Stddev_Samp_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "article" */
export type Article_Sum_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "article" */
export type Article_Var_Pop_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "article" */
export type Article_Var_Samp_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "article" */
export type Article_Variance_Order_By = {
  article_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Aggregate_Order_By = {
  avg?: InputMaybe<Pages_M2m_Cache_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pages_M2m_Cache_Max_Order_By>;
  min?: InputMaybe<Pages_M2m_Cache_Min_Order_By>;
  stddev?: InputMaybe<Pages_M2m_Cache_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pages_M2m_Cache_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pages_M2m_Cache_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pages_M2m_Cache_Sum_Order_By>;
  var_pop?: InputMaybe<Pages_M2m_Cache_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pages_M2m_Cache_Var_Samp_Order_By>;
  variance?: InputMaybe<Pages_M2m_Cache_Variance_Order_By>;
};

/** order by avg() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Avg_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Max_Order_By = {
  document_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
  page_status?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
  thumbnail_big_url?: InputMaybe<Order_By>;
  thumbnail_small_url?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Min_Order_By = {
  document_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
  page_status?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
  thumbnail_big_url?: InputMaybe<Order_By>;
  thumbnail_small_url?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Stddev_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Stddev_Pop_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Stddev_Samp_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Sum_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Var_Pop_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Var_Samp_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "pages_m2m_cache" */
export type Pages_M2m_Cache_Variance_Order_By = {
  page_number?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_task" */
export type Declaration_Task_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Task_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Task_Max_Order_By>;
  min?: InputMaybe<Declaration_Task_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Task_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Task_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Task_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Task_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Task_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Task_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Task_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_task" */
export type Declaration_Task_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_task" */
export type Declaration_Task_Max_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_task" */
export type Declaration_Task_Min_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_task" */
export type Declaration_Task_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_task" */
export type Declaration_Task_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_task" */
export type Declaration_Task_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_task" */
export type Declaration_Task_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_task" */
export type Declaration_Task_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_task" */
export type Declaration_Task_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_task" */
export type Declaration_Task_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Order_By>;
  task_type_id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "doc_annotation" */
export type Doc_Annotation_Aggregate_Order_By = {
  avg?: InputMaybe<Doc_Annotation_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Annotation_Max_Order_By>;
  min?: InputMaybe<Doc_Annotation_Min_Order_By>;
  stddev?: InputMaybe<Doc_Annotation_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Doc_Annotation_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Doc_Annotation_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Doc_Annotation_Sum_Order_By>;
  var_pop?: InputMaybe<Doc_Annotation_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Doc_Annotation_Var_Samp_Order_By>;
  variance?: InputMaybe<Doc_Annotation_Variance_Order_By>;
};

/** order by avg() on columns of table "doc_annotation" */
export type Doc_Annotation_Avg_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "doc_annotation" */
export type Doc_Annotation_Max_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  /** Document Id related to doc_annotation. */
  doc_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_annotation" */
export type Doc_Annotation_Min_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  /** Document Id related to doc_annotation. */
  doc_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "doc_annotation" */
export type Doc_Annotation_Stddev_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "doc_annotation" */
export type Doc_Annotation_Stddev_Pop_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "doc_annotation" */
export type Doc_Annotation_Stddev_Samp_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "doc_annotation" */
export type Doc_Annotation_Sum_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "doc_annotation" */
export type Doc_Annotation_Var_Pop_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "doc_annotation" */
export type Doc_Annotation_Var_Samp_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "doc_annotation" */
export type Doc_Annotation_Variance_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "document_extension". */
export type Document_Extension_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  thumbnails_supported?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Ordering options when selecting data from "file". */
export type File_Order_By = {
  ai_doc_classification_confirmed?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration?: InputMaybe<Declaration_Request_Order_By>;
  declaration_requests_aggregate?: InputMaybe<Declaration_Request_Aggregate_Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  file_flags?: InputMaybe<Order_By>;
  file_status?: InputMaybe<Order_By>;
  file_tasks_aggregate?: InputMaybe<Declaration_Task_Aggregate_Order_By>;
  file_type?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified_by_user?: InputMaybe<User_Pp_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  session_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "declaration_request". */
export type Declaration_Request_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  arrivalType?: InputMaybe<Arrival_Type_Order_By>;
  bill_details_aggregate?: InputMaybe<Bill_Detail_Aggregate_Order_By>;
  cev_status?: InputMaybe<Order_By>;
  ch_exp_decl?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  clearanceTypeByClearanceType?: InputMaybe<Clearance_Type_Order_By>;
  clientCompany?: InputMaybe<Tenant_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customsOffices?: InputMaybe<Customs_Offices_Order_By>;
  declaration?: InputMaybe<Declaration_Order_By>;
  declaration_discussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Order_By>;
  declaration_documents_aggregate?: InputMaybe<Declaration_Document_Aggregate_Order_By>;
  declaration_request_addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  declaration_request_labels_aggregate?: InputMaybe<Declaration_Request_Labels_Aggregate_Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  declarationStatusByDeclarationStatus?: InputMaybe<Declaration_Status_Order_By>;
  declarationTypeByDeclarationType?: InputMaybe<Declaration_Type_Order_By>;
  dest_tolldept_code?: InputMaybe<Order_By>;
  dest_tolldept_name?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  dr_no?: InputMaybe<Order_By>;
  edec?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  imp_cust_clr?: InputMaybe<Order_By>;
  is_express?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  mrn_number?: InputMaybe<Order_By>;
  payer?: InputMaybe<Tenant_Order_By>;
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  toll_dep?: InputMaybe<Order_By>;
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  transitdoc_type?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<User_Pp_Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_request_address" */
export type Declaration_Request_Address_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Request_Address_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Request_Address_Max_Order_By>;
  min?: InputMaybe<Declaration_Request_Address_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Request_Address_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Request_Address_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Request_Address_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Request_Address_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Request_Address_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Request_Address_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Request_Address_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Avg_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Max_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Min_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Stddev_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Stddev_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Stddev_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Sum_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Var_Pop_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Var_Samp_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_request_address" */
export type Declaration_Request_Address_Variance_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "arrival_type". */
export type Arrival_Type_Order_By = {
  arrival_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "bill_detail" */
export type Bill_Detail_Aggregate_Order_By = {
  avg?: InputMaybe<Bill_Detail_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Bill_Detail_Max_Order_By>;
  min?: InputMaybe<Bill_Detail_Min_Order_By>;
  stddev?: InputMaybe<Bill_Detail_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Bill_Detail_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Bill_Detail_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Bill_Detail_Sum_Order_By>;
  var_pop?: InputMaybe<Bill_Detail_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Bill_Detail_Var_Samp_Order_By>;
  variance?: InputMaybe<Bill_Detail_Variance_Order_By>;
};

/** order by avg() on columns of table "bill_detail" */
export type Bill_Detail_Avg_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "bill_detail" */
export type Bill_Detail_Max_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "bill_detail" */
export type Bill_Detail_Min_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "bill_detail" */
export type Bill_Detail_Stddev_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "bill_detail" */
export type Bill_Detail_Stddev_Pop_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "bill_detail" */
export type Bill_Detail_Stddev_Samp_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "bill_detail" */
export type Bill_Detail_Sum_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "bill_detail" */
export type Bill_Detail_Var_Pop_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "bill_detail" */
export type Bill_Detail_Var_Samp_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "bill_detail" */
export type Bill_Detail_Variance_Order_By = {
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "clearance_type". */
export type Clearance_Type_Order_By = {
  declaration_requests_aggregate?: InputMaybe<Declaration_Request_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_request" */
export type Declaration_Request_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Request_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Request_Max_Order_By>;
  min?: InputMaybe<Declaration_Request_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Request_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Request_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Request_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Request_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Request_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Request_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Request_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_request" */
export type Declaration_Request_Avg_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_request" */
export type Declaration_Request_Max_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  cev_status?: InputMaybe<Order_By>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Order_By>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Order_By>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Order_By>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Order_By>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Order_By>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Order_By>;
  mrn_number?: InputMaybe<Order_By>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Order_By>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_request" */
export type Declaration_Request_Min_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  cev_status?: InputMaybe<Order_By>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Order_By>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Order_By>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Order_By>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Order_By>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Order_By>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Order_By>;
  mrn_number?: InputMaybe<Order_By>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Order_By>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_request" */
export type Declaration_Request_Stddev_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_request" */
export type Declaration_Request_Stddev_Pop_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_request" */
export type Declaration_Request_Stddev_Samp_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_request" */
export type Declaration_Request_Sum_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_request" */
export type Declaration_Request_Var_Pop_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_request" */
export type Declaration_Request_Var_Samp_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_request" */
export type Declaration_Request_Variance_Order_By = {
  customs_declaration_version?: InputMaybe<Order_By>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "customs_offices". */
export type Customs_Offices_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_number?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "declaration". */
export type Declaration_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  access_code?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  agreed_location_of_goods?: InputMaybe<Order_By>;
  ai_confirmed?: InputMaybe<Order_By>;
  ai_results?: InputMaybe<Order_By>;
  border_eau_number?: InputMaybe<Order_By>;
  bunch_number?: InputMaybe<Order_By>;
  change_information?: InputMaybe<Order_By>;
  clearance_location?: InputMaybe<Order_By>;
  company_number_taxpayer?: InputMaybe<Order_By>;
  containers_aggregate?: InputMaybe<Containers_Aggregate_Order_By>;
  correction_code?: InputMaybe<Order_By>;
  correction_reason?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_account_address_type?: InputMaybe<Order_By>;
  customs_account_name?: InputMaybe<Order_By>;
  customs_account_number?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_office_number?: InputMaybe<Order_By>;
  declarant_company_name?: InputMaybe<Order_By>;
  declarant_number?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  declaration_special_mentions_aggregate?: InputMaybe<Declaration_Special_Mentions_Aggregate_Order_By>;
  declaration_time?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  delivery_destination?: InputMaybe<Order_By>;
  dispatch_country?: InputMaybe<Order_By>;
  dispatch_country_confirmation?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_amount?: InputMaybe<Order_By>;
  duty_total_amount?: InputMaybe<Order_By>;
  evv_confirmed?: InputMaybe<Order_By>;
  evv_received?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  goods_items_aggregate?: InputMaybe<Goods_Item_Aggregate_Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  incoterms?: InputMaybe<Order_By>;
  initiator?: InputMaybe<Order_By>;
  injunction_type?: InputMaybe<Order_By>;
  inspection_code?: InputMaybe<Order_By>;
  invoice_currency_type?: InputMaybe<Order_By>;
  lang?: InputMaybe<Order_By>;
  material_check?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  place_of_loading?: InputMaybe<Order_By>;
  place_of_unloading?: InputMaybe<Order_By>;
  postal_shipment_type?: InputMaybe<Order_By>;
  previous_documents_aggregate?: InputMaybe<Previous_Documents_Aggregate_Order_By>;
  procedure_type?: InputMaybe<Order_By>;
  provisional_declaration_expiration_date?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  receive_status?: InputMaybe<Order_By>;
  release?: InputMaybe<Order_By>;
  requestor_trader_identification_number?: InputMaybe<Order_By>;
  security?: InputMaybe<Order_By>;
  selection_correlation_id?: InputMaybe<Order_By>;
  send_date?: InputMaybe<Order_By>;
  send_status?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  show_in_wd?: InputMaybe<Order_By>;
  specific_circumstance_indicator?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_date?: InputMaybe<Order_By>;
  status_time?: InputMaybe<Order_By>;
  tara_factor?: InputMaybe<Order_By>;
  total_colis?: InputMaybe<Order_By>;
  total_goods_items?: InputMaybe<Order_By>;
  total_gross_weight?: InputMaybe<Order_By>;
  total_vat_value?: InputMaybe<Order_By>;
  trader_declaration_number?: InputMaybe<Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  transfer_to_transit_system?: InputMaybe<Order_By>;
  transport_country?: InputMaybe<Order_By>;
  transport_in_container?: InputMaybe<Order_By>;
  transport_mode?: InputMaybe<Order_By>;
  transport_number?: InputMaybe<Order_By>;
  transport_type?: InputMaybe<Order_By>;
  unique_consignment_reference_number?: InputMaybe<Order_By>;
  vat_account_address_type?: InputMaybe<Order_By>;
  vat_account_name?: InputMaybe<Order_By>;
  vat_account_number?: InputMaybe<Order_By>;
  vat_number?: InputMaybe<Order_By>;
  vat_suffix?: InputMaybe<Order_By>;
  vat_total_amount?: InputMaybe<Order_By>;
  warehouse_coded?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "containers" */
export type Containers_Aggregate_Order_By = {
  avg?: InputMaybe<Containers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Containers_Max_Order_By>;
  min?: InputMaybe<Containers_Min_Order_By>;
  stddev?: InputMaybe<Containers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Containers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Containers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Containers_Sum_Order_By>;
  var_pop?: InputMaybe<Containers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Containers_Var_Samp_Order_By>;
  variance?: InputMaybe<Containers_Variance_Order_By>;
};

/** order by avg() on columns of table "containers" */
export type Containers_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "containers" */
export type Containers_Max_Order_By = {
  container_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "containers" */
export type Containers_Min_Order_By = {
  container_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "containers" */
export type Containers_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "containers" */
export type Containers_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "containers" */
export type Containers_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "containers" */
export type Containers_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "containers" */
export type Containers_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "containers" */
export type Containers_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "containers" */
export type Containers_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Special_Mentions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Special_Mentions_Max_Order_By>;
  min?: InputMaybe<Declaration_Special_Mentions_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Special_Mentions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Special_Mentions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Special_Mentions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Special_Mentions_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Special_Mentions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Special_Mentions_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Special_Mentions_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Max_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Min_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "goods_item" */
export type Goods_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Goods_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Goods_Item_Max_Order_By>;
  min?: InputMaybe<Goods_Item_Min_Order_By>;
  stddev?: InputMaybe<Goods_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Goods_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Goods_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Goods_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Goods_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Goods_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Goods_Item_Variance_Order_By>;
};

/** order by avg() on columns of table "goods_item" */
export type Goods_Item_Avg_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "goods_item" */
export type Goods_Item_Max_Order_By = {
  additional_unit?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  repair_reason?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  un_dangerous_goods_code?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "goods_item" */
export type Goods_Item_Min_Order_By = {
  additional_unit?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  repair_reason?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  un_dangerous_goods_code?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "goods_item" */
export type Goods_Item_Stddev_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "goods_item" */
export type Goods_Item_Stddev_Pop_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "goods_item" */
export type Goods_Item_Stddev_Samp_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "goods_item" */
export type Goods_Item_Sum_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "goods_item" */
export type Goods_Item_Var_Pop_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "goods_item" */
export type Goods_Item_Var_Samp_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "goods_item" */
export type Goods_Item_Variance_Order_By = {
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "previous_documents" */
export type Previous_Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Previous_Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Previous_Documents_Max_Order_By>;
  min?: InputMaybe<Previous_Documents_Min_Order_By>;
  stddev?: InputMaybe<Previous_Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Previous_Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Previous_Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Previous_Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Previous_Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Previous_Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Previous_Documents_Variance_Order_By>;
};

/** order by avg() on columns of table "previous_documents" */
export type Previous_Documents_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "previous_documents" */
export type Previous_Documents_Max_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previous_document_reference?: InputMaybe<Order_By>;
  previous_document_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "previous_documents" */
export type Previous_Documents_Min_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previous_document_reference?: InputMaybe<Order_By>;
  previous_document_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "previous_documents" */
export type Previous_Documents_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "previous_documents" */
export type Previous_Documents_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "previous_documents" */
export type Previous_Documents_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "previous_documents" */
export type Previous_Documents_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "previous_documents" */
export type Previous_Documents_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "previous_documents" */
export type Previous_Documents_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "previous_documents" */
export type Previous_Documents_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_discussion" */
export type Declaration_Discussion_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Discussion_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Discussion_Max_Order_By>;
  min?: InputMaybe<Declaration_Discussion_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Discussion_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Discussion_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Discussion_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Discussion_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Discussion_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Discussion_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Discussion_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Avg_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Max_Order_By = {
  /** Creation date of discussion. */
  creation_date?: InputMaybe<Order_By>;
  /** User initiated discussion. */
  creation_user?: InputMaybe<Order_By>;
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  /** Theme of discussion. */
  discussion_theme?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** File/Declaration related to discussion. */
  file_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Min_Order_By = {
  /** Creation date of discussion. */
  creation_date?: InputMaybe<Order_By>;
  /** User initiated discussion. */
  creation_user?: InputMaybe<Order_By>;
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  /** Theme of discussion. */
  discussion_theme?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  /** File/Declaration related to discussion. */
  file_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Stddev_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Stddev_Pop_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Stddev_Samp_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Sum_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Var_Pop_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Var_Samp_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_discussion" */
export type Declaration_Discussion_Variance_Order_By = {
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_document" */
export type Declaration_Document_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Document_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Document_Max_Order_By>;
  min?: InputMaybe<Declaration_Document_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Document_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Document_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Document_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Document_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Document_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Document_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Document_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_document" */
export type Declaration_Document_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_document" */
export type Declaration_Document_Max_Order_By = {
  doc_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_document" */
export type Declaration_Document_Min_Order_By = {
  doc_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_document" */
export type Declaration_Document_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_document" */
export type Declaration_Document_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_document" */
export type Declaration_Document_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_document" */
export type Declaration_Document_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_document" */
export type Declaration_Document_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_document" */
export type Declaration_Document_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_document" */
export type Declaration_Document_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "declaration_request_labels" */
export type Declaration_Request_Labels_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Request_Labels_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Request_Labels_Max_Order_By>;
  min?: InputMaybe<Declaration_Request_Labels_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Request_Labels_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Request_Labels_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Request_Labels_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Request_Labels_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Request_Labels_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Request_Labels_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Request_Labels_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Avg_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Max_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Min_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Stddev_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Stddev_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Stddev_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Sum_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Var_Pop_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Var_Samp_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_request_labels" */
export type Declaration_Request_Labels_Variance_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "declaration_status". */
export type Declaration_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "declaration_type". */
export type Declaration_Type_Order_By = {
  declaration_requests_aggregate?: InputMaybe<Declaration_Request_Aggregate_Order_By>;
  document_schema?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "document_type". */
export type Document_Type_Order_By = {
  annotation_types_aggregate?: InputMaybe<Annotation_Type_Aggregate_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type_all_tenant_settings_aggregate?: InputMaybe<Document_Type_All_Tenant_Settings_Aggregate_Order_By>;
  document_type_tenant_settings_aggregate?: InputMaybe<Document_Type_Tenant_Settings_Aggregate_Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<User_Pp_Order_By>;
  userPpByCreationUser?: InputMaybe<User_Pp_Order_By>;
};

/** order by aggregate values of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Type_Tenant_Settings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Type_Tenant_Settings_Max_Order_By>;
  min?: InputMaybe<Document_Type_Tenant_Settings_Min_Order_By>;
  stddev?: InputMaybe<Document_Type_Tenant_Settings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Type_Tenant_Settings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Type_Tenant_Settings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Type_Tenant_Settings_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Type_Tenant_Settings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Type_Tenant_Settings_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Type_Tenant_Settings_Variance_Order_By>;
};

/** order by avg() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Avg_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Max_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Min_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Stddev_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Stddev_Pop_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Stddev_Samp_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Sum_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Var_Pop_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Var_Samp_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Variance_Order_By = {
  default_flags?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "document_page" */
export type Document_Page_Aggregate_Order_By = {
  avg?: InputMaybe<Document_Page_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Document_Page_Max_Order_By>;
  min?: InputMaybe<Document_Page_Min_Order_By>;
  stddev?: InputMaybe<Document_Page_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Document_Page_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Document_Page_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Document_Page_Sum_Order_By>;
  var_pop?: InputMaybe<Document_Page_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Document_Page_Var_Samp_Order_By>;
  variance?: InputMaybe<Document_Page_Variance_Order_By>;
};

/** order by avg() on columns of table "document_page" */
export type Document_Page_Avg_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "document_page" */
export type Document_Page_Max_Order_By = {
  /** Document Id related to document_page. */
  document_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "document_page" */
export type Document_Page_Min_Order_By = {
  /** Document Id related to document_page. */
  document_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "document_page" */
export type Document_Page_Stddev_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "document_page" */
export type Document_Page_Stddev_Pop_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "document_page" */
export type Document_Page_Stddev_Samp_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "document_page" */
export type Document_Page_Sum_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "document_page" */
export type Document_Page_Var_Pop_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "document_page" */
export type Document_Page_Var_Samp_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "document_page" */
export type Document_Page_Variance_Order_By = {
  page_number?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "document_status". */
export type Document_Status_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type Document = {
  /** An array relationship */
  annotationType: Array<Annotation_Type>;
  /** An array relationship */
  articles: Array<Article>;
  /** MD5-checksum of document. */
  checksum: Maybe<Scalars['String']>;
  /** Substitutes pages_m2m relationship */
  computedPagesM2M: Maybe<Array<Pages_M2m_Cache>>;
  /** An object relationship */
  created_by_user: User_Pp;
  /** document creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user: Scalars['uuid'];
  /** An array relationship */
  doc_tasks: Array<Declaration_Task>;
  /** An aggregate relationship */
  doc_tasks_aggregate: Declaration_Task_Aggregate;
  /** An array relationship */
  docAnnotations: Array<Doc_Annotation>;
  document_blobs: Scalars['jsonb'];
  document_extension: Scalars['String'];
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Scalars['bigint'];
  document_name: Maybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status: Scalars['String'];
  document_type: Scalars['String'];
  document_version: Scalars['Int'];
  /** An object relationship */
  documentExtensionByDocumentExtension: Document_Extension;
  /** An object relationship */
  documentFile: Maybe<File>;
  /** An object relationship */
  documentType: Document_Type;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file: Maybe<Scalars['uuid']>;
  /** An object relationship */
  file_object: Maybe<File>;
  /** id of document. */
  id: Scalars['uuid'];
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  /** Marks document record as deleted. */
  is_deleted: Scalars['Boolean'];
  is_generated: Scalars['Boolean'];
  is_template: Maybe<Scalars['Boolean']>;
  /** document last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** additional attributes */
  meta: Scalars['jsonb'];
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['smallint']>;
  /** An object relationship */
  organization: Maybe<Org_Id>;
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  /** An array relationship */
  pages_m2m: Array<Document_Page>;
  /** An aggregate relationship */
  pages_m2m_aggregate: Document_Page_Aggregate;
  sequence: Maybe<Scalars['Int']>;
  /** An object relationship */
  status: Document_Status;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentAnnotationTypeArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Type_Order_By>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentArticlesArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentComputedPagesM2MArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDoc_TasksArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDoc_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDocAnnotationsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Annotation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Annotation_Order_By>>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentPages_M2mArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/**
 * Documents in system. Partitioned by document types:
 * - doc_src:  {unknown}
 * - doc_customs: {customs_overview,customs_declaration}
 * - doc_dflt: all others
 *
 */
export type DocumentPages_M2m_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};

/** select columns of table "annotation_type" */
export enum Annotation_Type_Select_Column {
  /** column name */
  AnnoSchema = 'anno_schema',
  /** column name */
  AnnoTypeId = 'anno_type_id',
  /** column name */
  AnnotationProviderId = 'annotation_provider_id',
  /** column name */
  AnnotationSchema = 'annotation_schema',
  /** column name */
  AnnotationType = 'annotation_type',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  Meta = 'meta',
  /** column name */
  UiSchema = 'ui_schema'
}

/** Ordering options when selecting data from "annotation_type". */
export type Annotation_Type_Order_By = {
  anno_schema?: InputMaybe<Order_By>;
  anno_type_id?: InputMaybe<Order_By>;
  annotation_provider?: InputMaybe<Annotation_Provider_Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
  annotation_schema?: InputMaybe<Order_By>;
  annotation_type?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  meta?: InputMaybe<Order_By>;
  ui_schema?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "annotation_provider". */
export type Annotation_Provider_Order_By = {
  annotation_provider?: InputMaybe<Order_By>;
  annotation_provider_id?: InputMaybe<Order_By>;
};

/** Annotation types for doc_annotation. */
export type Annotation_Type = {
  anno_schema: Maybe<Scalars['json']>;
  anno_type_id: Scalars['smallint'];
  /** An object relationship */
  annotation_provider: Annotation_Provider;
  annotation_provider_id: Scalars['smallint'];
  annotation_schema: Maybe<Scalars['jsonb']>;
  annotation_type: Maybe<Scalars['String']>;
  document_type: Scalars['String'];
  /** An object relationship */
  documentType: Document_Type;
  /** additional attributes */
  meta: Scalars['jsonb'];
  ui_schema: Maybe<Scalars['jsonb']>;
};


/** Annotation types for doc_annotation. */
export type Annotation_TypeAnno_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Annotation types for doc_annotation. */
export type Annotation_TypeAnnotation_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Annotation types for doc_annotation. */
export type Annotation_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Annotation types for doc_annotation. */
export type Annotation_TypeUi_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "annotation_provider" */
export type Annotation_Provider = {
  annotation_provider: Scalars['String'];
  annotation_provider_id: Scalars['smallint'];
};

/** Document types in system */
export type Document_Type = {
  /** An array relationship */
  annotation_types: Array<Annotation_Type>;
  /** document_type creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_type creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** An array relationship */
  document_type_all_tenant_settings: Array<Document_Type_All_Tenant_Settings>;
  /** An array relationship */
  document_type_tenant_settings: Array<Document_Type_Tenant_Settings>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** document_type last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_type. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  translations: Scalars['jsonb'];
  /** An object relationship */
  user_pp: Maybe<User_Pp>;
  /** An object relationship */
  userPpByCreationUser: User_Pp;
};


/** Document types in system */
export type Document_TypeAnnotation_TypesArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Type_Order_By>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeDocument_Type_All_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeDocument_Type_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Document types in system */
export type Document_TypeTranslationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_type_all_tenant_settings" */
export enum Document_Type_All_Tenant_Settings_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DefaultFlags = 'default_flags',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DocumentSchema = 'document_schema',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Tenant = 'tenant'
}

/** Ordering options when selecting data from "document_type_all_tenant_settings". */
export type Document_Type_All_Tenant_Settings_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_schema?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
};

/** columns and relationships of "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings = {
  code: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  default_flags: Maybe<Scalars['bigint']>;
  display_name: Maybe<Scalars['String']>;
  document_schema: Maybe<Scalars['jsonb']>;
  document_type: Maybe<Scalars['String']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  tenant: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_SettingsDocument_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_SettingsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_type_tenant_settings" */
export enum Document_Type_Tenant_Settings_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DefaultFlags = 'default_flags',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DocumentSchema = 'document_schema',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Tenant = 'tenant'
}

/** Ordering options when selecting data from "document_type_tenant_settings". */
export type Document_Type_Tenant_Settings_Order_By = {
  code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  default_flags?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  document_schema?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
  Tenant?: InputMaybe<Tenant_Order_By>;
};

/** columns and relationships of "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings = {
  code: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  default_flags: Maybe<Scalars['bigint']>;
  display_name: Maybe<Scalars['String']>;
  document_schema: Maybe<Scalars['jsonb']>;
  document_type: Scalars['String'];
  /** An object relationship */
  documentType: Document_Type;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  tenant: Scalars['uuid'];
  /** An object relationship */
  Tenant: Maybe<Tenant>;
};


/** columns and relationships of "document_type_tenant_settings" */
export type Document_Type_Tenant_SettingsDocument_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "document_type_tenant_settings" */
export type Document_Type_Tenant_SettingsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "document" */
export type Document_Aggregate = {
  aggregate: Maybe<Document_Aggregate_Fields>;
  nodes: Array<Document>;
};

/** aggregate fields of "document" */
export type Document_Aggregate_Fields = {
  avg: Maybe<Document_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Document_Max_Fields>;
  min: Maybe<Document_Min_Fields>;
  stddev: Maybe<Document_Stddev_Fields>;
  stddev_pop: Maybe<Document_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Document_Stddev_Samp_Fields>;
  sum: Maybe<Document_Sum_Fields>;
  var_pop: Maybe<Document_Var_Pop_Fields>;
  var_samp: Maybe<Document_Var_Samp_Fields>;
  variance: Maybe<Document_Variance_Fields>;
};


/** aggregate fields of "document" */
export type Document_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Document_Avg_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Document_Max_Fields = {
  /** MD5-checksum of document. */
  checksum: Maybe<Scalars['String']>;
  /** document creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  document_extension: Maybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  document_version: Maybe<Scalars['Int']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file: Maybe<Scalars['uuid']>;
  /** id of document. */
  id: Maybe<Scalars['uuid']>;
  /** document last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['smallint']>;
  sequence: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Document_Min_Fields = {
  /** MD5-checksum of document. */
  checksum: Maybe<Scalars['String']>;
  /** document creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  document_extension: Maybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  document_version: Maybe<Scalars['Int']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file: Maybe<Scalars['uuid']>;
  /** id of document. */
  id: Maybe<Scalars['uuid']>;
  /** document last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['smallint']>;
  sequence: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Document_Stddev_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Stddev_Pop_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Stddev_Samp_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Document_Sum_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['bigint']>;
  document_version: Maybe<Scalars['Int']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['smallint']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['smallint']>;
  sequence: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Document_Var_Pop_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Var_Samp_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Variance_Fields = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags: Maybe<Scalars['Float']>;
  document_version: Maybe<Scalars['Float']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no: Maybe<Scalars['Float']>;
  /** Number of pages in documnent. */
  number_of_pages: Maybe<Scalars['Float']>;
  /** Org_id related to document. */
  org_id: Maybe<Scalars['Float']>;
  sequence: Maybe<Scalars['Float']>;
};

/** select columns of table "article" */
export enum Article_Select_Column {
  /** column name */
  ArticleId = 'article_id',
  /** column name */
  Code = 'code',
  /** column name */
  Coords = 'coords',
  /** column name */
  CountryOfOrigin = 'country_of_origin',
  /** column name */
  Description = 'description',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  GrossWeight = 'gross_weight',
  /** column name */
  Height = 'height',
  /** column name */
  Hscode = 'hscode',
  /** column name */
  Length = 'length',
  /** column name */
  Marks = 'marks',
  /** column name */
  Meta = 'meta',
  /** column name */
  NetWeight = 'net_weight',
  /** column name */
  Number = 'number',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Price = 'price',
  /** column name */
  PurchaseOrderNumber = 'purchase_order_number',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Size = 'size',
  /** column name */
  TotalPrice = 'total_price',
  /** column name */
  Unit = 'unit',
  /** column name */
  Volume = 'volume',
  /** column name */
  Width = 'width'
}

/** Ordering options when selecting data from "article". */
export type Article_Order_By = {
  article_id?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  coords?: InputMaybe<Order_By>;
  country_of_origin?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  gross_weight?: InputMaybe<Order_By>;
  height?: InputMaybe<Order_By>;
  hscode?: InputMaybe<Order_By>;
  length?: InputMaybe<Order_By>;
  marks?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  net_weight?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  purchase_order_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
  width?: InputMaybe<Order_By>;
};

/** columns and relationships of "article" */
export type Article = {
  article_id: Scalars['smallint'];
  code: Maybe<Scalars['String']>;
  coords: Maybe<Scalars['_int4']>;
  country_of_origin: Maybe<Scalars['String']>;
  description: Maybe<Scalars['String']>;
  doc_id: Scalars['uuid'];
  /** An object relationship */
  document: Maybe<Document>;
  gross_weight: Maybe<Scalars['String']>;
  height: Maybe<Scalars['String']>;
  hscode: Maybe<Scalars['String']>;
  length: Maybe<Scalars['String']>;
  marks: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['jsonb']>;
  net_weight: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  page_id: Maybe<Scalars['uuid']>;
  price: Maybe<Scalars['String']>;
  purchase_order_number: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['String']>;
  size: Maybe<Scalars['String']>;
  total_price: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
  volume: Maybe<Scalars['String']>;
  width: Maybe<Scalars['String']>;
};


/** columns and relationships of "article" */
export type ArticleMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "pages_m2m_cache" */
export enum Pages_M2m_Cache_Select_Column {
  /** column name */
  DocumentId = 'document_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Page = 'page',
  /** column name */
  PageNumber = 'page_number',
  /** column name */
  PageStatus = 'page_status',
  /** column name */
  Rotate = 'rotate',
  /** column name */
  ThumbnailBigUrl = 'thumbnail_big_url',
  /** column name */
  ThumbnailSmallUrl = 'thumbnail_small_url'
}

/** Ordering options when selecting data from "pages_m2m_cache". */
export type Pages_M2m_Cache_Order_By = {
  document_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  page?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
  page_status?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
  thumbnail_big_url?: InputMaybe<Order_By>;
  thumbnail_small_url?: InputMaybe<Order_By>;
};

/** columns and relationships of "pages_m2m_cache" */
export type Pages_M2m_Cache = {
  document_id: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  page: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['bigint']>;
  page_status: Maybe<Scalars['String']>;
  rotate: Maybe<Scalars['Int']>;
  thumbnail_big_url: Maybe<Scalars['String']>;
  thumbnail_small_url: Maybe<Scalars['String']>;
};


/** columns and relationships of "pages_m2m_cache" */
export type Pages_M2m_CacheMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Ordering options when selecting data from "declaration_task". */
export type Declaration_Task_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  assigned_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  due_date?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  task_status_id?: InputMaybe<Order_By>;
  task_type?: InputMaybe<Task_Type_Order_By>;
  task_type_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "task_type". */
export type Task_Type_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_task" */
export type Declaration_Task = {
  assigned_to: Maybe<Scalars['uuid']>;
  /** An object relationship */
  assigned_user: Maybe<User_Pp>;
  creation_date: Scalars['timestamptz'];
  /** An object relationship */
  document: Maybe<Document>;
  due_date: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: Maybe<File>;
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
  object_id: Scalars['uuid'];
  /** 1 = finished, 0 = open */
  task_status_id: Scalars['Int'];
  /** An object relationship */
  task_type: Task_Type;
  task_type_id: Scalars['Int'];
  title: Scalars['String'];
};


/** columns and relationships of "declaration_task" */
export type Declaration_TaskMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** File as collection of documents */
export type File = {
  ai_doc_classification_confirmed: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  created_by_user: User_Pp;
  /** file creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user: Scalars['uuid'];
  /** An object relationship */
  declaration: Maybe<Declaration_Request>;
  /** An array relationship */
  declaration_requests: Array<Declaration_Request>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  file_flags: Scalars['bigint'];
  file_status: Scalars['String'];
  /** An array relationship */
  file_tasks: Array<Declaration_Task>;
  /** An aggregate relationship */
  file_tasks_aggregate: Declaration_Task_Aggregate;
  file_type: Scalars['String'];
  file_url: Maybe<Scalars['String']>;
  /** id of file. */
  id: Scalars['uuid'];
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification: Maybe<Scalars['String']>;
  /** Marks file record as deleted. */
  is_deleted: Scalars['Boolean'];
  /** An object relationship */
  last_modified_by_user: Maybe<User_Pp>;
  /** file last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** additional attributes */
  meta: Scalars['jsonb'];
  name: Maybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['smallint']>;
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  session_id: Scalars['String'];
};


/** File as collection of documents */
export type FileDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


/** File as collection of documents */
export type FileDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** File as collection of documents */
export type FileDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** File as collection of documents */
export type FileFile_TasksArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


/** File as collection of documents */
export type FileFile_Tasks_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


/** File as collection of documents */
export type FileMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Declaration request from liber. */
export type Declaration_Request = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  /** Account number in CH customs */
  account_number: Maybe<Scalars['String']>;
  /** An array relationship */
  addresses: Array<Declaration_Request_Address>;
  arrival_time: Maybe<Scalars['timestamptz']>;
  arrival_type: Maybe<Scalars['String']>;
  /** An object relationship */
  arrivalType: Maybe<Arrival_Type>;
  /** An array relationship */
  bill_details: Array<Bill_Detail>;
  cev_status: Maybe<Scalars['String']>;
  /** WeDeclare must create CH-Exportdeclaration */
  ch_exp_decl: Maybe<Scalars['Boolean']>;
  /** Refer to values in table clearance_type. */
  clearance_type: Scalars['String'];
  /** An object relationship */
  clearanceTypeByClearanceType: Clearance_Type;
  /** An object relationship */
  clientCompany: Maybe<Tenant>;
  /** Date of creation of declaration request. */
  creation_date: Scalars['timestamptz'];
  /** User created declaration request. */
  creation_user: Scalars['uuid'];
  customs_declaration_number: Maybe<Scalars['String']>;
  customs_declaration_version: Maybe<Scalars['smallint']>;
  /** An object relationship */
  customsOffices: Maybe<Customs_Offices>;
  /** An object relationship */
  declaration: Maybe<Declaration>;
  /** An array relationship */
  declaration_discussions: Array<Declaration_Discussion>;
  /** An aggregate relationship */
  declaration_discussions_aggregate: Declaration_Discussion_Aggregate;
  /** An array relationship */
  declaration_documents: Array<Declaration_Document>;
  /** An array relationship */
  declaration_request_addresses: Array<Declaration_Request_Address>;
  /** An array relationship */
  declaration_request_labels: Array<Declaration_Request_Labels>;
  /** Refer to values in table declaration_status. */
  declaration_status: Scalars['String'];
  /** Refer to values in table declaration_type. */
  declaration_type: Scalars['String'];
  /** An object relationship */
  declarationStatusByDeclarationStatus: Declaration_Status;
  /** An object relationship */
  declarationTypeByDeclarationType: Declaration_Type;
  /** Destination Tolldept Code */
  dest_tolldept_code: Maybe<Scalars['String']>;
  /** Destination Tolldept Name */
  dest_tolldept_name: Maybe<Scalars['String']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no: Scalars['smallint'];
  edec: Maybe<Scalars['jsonb']>;
  eta: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: File;
  /** File related to declaration request. Part of primary key */
  file_id: Scalars['uuid'];
  /** WeDeclare must create the Import customs clearance in the destination Country */
  imp_cust_clr: Maybe<Scalars['Boolean']>;
  /** Service:  Standard  oder Express */
  is_express: Scalars['Boolean'];
  /** additional attributes */
  meta: Scalars['jsonb'];
  mrn_number: Maybe<Scalars['String']>;
  /** An object relationship */
  payer: Tenant;
  /** Who is paying for customs declaration (tenant) */
  payer_id: Scalars['uuid'];
  service_type: Maybe<Scalars['String']>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep: Maybe<Scalars['String']>;
  /** Truck and Trailer Plate No. */
  tr_no: Maybe<Scalars['String']>;
  trader_reference: Maybe<Scalars['String']>;
  /** Type Transitdocument */
  transitdoc_type: Maybe<Scalars['transitdoc_type']>;
  /** An object relationship */
  user_pp: User_Pp;
  wa_number: Maybe<Scalars['String']>;
};


/** Declaration request from liber. */
export type Declaration_RequestAddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestBill_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Bill_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Detail_Order_By>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_DiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_Discussions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Document_Order_By>>;
  where?: InputMaybe<Declaration_Document_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_Request_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDeclaration_Request_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** Declaration request from liber. */
export type Declaration_RequestEdecArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Declaration request from liber. */
export type Declaration_RequestMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_request_address" */
export enum Declaration_Request_Address_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Refs = 'refs',
  /** column name */
  SearchRefs = 'search_refs'
}

/** Ordering options when selecting data from "declaration_request_address". */
export type Declaration_Request_Address_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  refs?: InputMaybe<Order_By>;
  search_refs?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_request_address" */
export type Declaration_Request_Address = {
  /** An object relationship */
  address: Maybe<Address>;
  address_id: Maybe<Scalars['Int']>;
  address_type: Scalars['Int'];
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  meta: Scalars['json'];
  refs: Scalars['_text'];
  search_refs: Maybe<Scalars['_text']>;
};


/** columns and relationships of "declaration_request_address" */
export type Declaration_Request_AddressMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "arrival_type" */
export type Arrival_Type = {
  arrival_type: Scalars['String'];
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  description: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "arrival_type" */
export type Arrival_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "bill_detail" */
export enum Bill_Detail_Select_Column {
  /** column name */
  BillId = 'bill_id',
  /** column name */
  ChargedItems = 'charged_items',
  /** column name */
  ConstCharge = 'const_charge',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DetailId = 'detail_id',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  SrvId = 'srv_id',
  /** column name */
  VarCharge = 'var_charge'
}

/** Ordering options when selecting data from "bill_detail". */
export type Bill_Detail_Order_By = {
  bill?: InputMaybe<Bill_Order_By>;
  bill_id?: InputMaybe<Order_By>;
  charged_items?: InputMaybe<Order_By>;
  const_charge?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  detail_id?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  remark?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  service?: InputMaybe<Service_Order_By>;
  srv_id?: InputMaybe<Order_By>;
  var_charge?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "bill". */
export type Bill_Order_By = {
  bill_details_aggregate?: InputMaybe<Bill_Detail_Aggregate_Order_By>;
  bill_id?: InputMaybe<Order_By>;
  bill_type?: InputMaybe<Order_By>;
  from_ts?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  to_ts?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "service". */
export type Service_Order_By = {
  service_rates_aggregate?: InputMaybe<Service_Rate_Aggregate_Order_By>;
  srv_desk?: InputMaybe<Order_By>;
  srv_id?: InputMaybe<Order_By>;
  srv_type?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** columns and relationships of "bill_detail" */
export type Bill_Detail = {
  /** An object relationship */
  bill: Maybe<Bill>;
  bill_id: Maybe<Scalars['bigint']>;
  charged_items: Scalars['bigint'];
  const_charge: Scalars['numeric'];
  creation_date: Scalars['timestamptz'];
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id: Scalars['bigint'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  remark: Maybe<Scalars['String']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence: Scalars['smallint'];
  /** An object relationship */
  service: Service;
  srv_id: Scalars['Int'];
  var_charge: Scalars['numeric'];
};

/** columns and relationships of "bill" */
export type Bill = {
  /** An array relationship */
  bill_details: Array<Bill_Detail>;
  bill_id: Scalars['bigint'];
  /**
   * type of bill, e.g.
   *  - regular - ordianry bill.
   * also might be
   *  - correction
   *  - account_close
   *
   */
  bill_type: Maybe<Scalars['name']>;
  from_ts: Maybe<Scalars['timestamptz']>;
  meta: Scalars['jsonb'];
  payment_terms: Maybe<Scalars['smallint']>;
  /** An object relationship */
  tenant: Maybe<Tenant>;
  tenant_id: Maybe<Scalars['uuid']>;
  to_ts: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "bill" */
export type BillBill_DetailsArgs = {
  distinct_on?: InputMaybe<Array<Bill_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Detail_Order_By>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


/** columns and relationships of "bill" */
export type BillMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "service" */
export type Service = {
  /** An array relationship */
  service_rates: Array<Service_Rate>;
  srv_desk: Maybe<Scalars['String']>;
  srv_id: Scalars['Int'];
  srv_type: Maybe<Scalars['String']>;
  translation: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "service" */
export type ServiceService_RatesArgs = {
  distinct_on?: InputMaybe<Array<Service_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Rate_Order_By>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


/** columns and relationships of "service" */
export type ServiceTranslationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "service_rate" */
export enum Service_Rate_Select_Column {
  /** column name */
  ConstIncluded = 'const_included',
  /** column name */
  ConstRate = 'const_rate',
  /** column name */
  SrvId = 'srv_id',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  VarRate = 'var_rate'
}

/** Ordering options when selecting data from "service_rate". */
export type Service_Rate_Order_By = {
  const_included?: InputMaybe<Order_By>;
  const_rate?: InputMaybe<Order_By>;
  service?: InputMaybe<Service_Order_By>;
  srv_id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  var_rate?: InputMaybe<Order_By>;
};

/** columns and relationships of "service_rate" */
export type Service_Rate = {
  const_included: Maybe<Scalars['Int']>;
  const_rate: Maybe<Scalars['numeric']>;
  /** An object relationship */
  service: Service;
  srv_id: Scalars['Int'];
  start_date: Scalars['date'];
  tenant_id: Scalars['uuid'];
  var_rate: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "clearance_type" */
export type Clearance_Type = {
  /** An array relationship */
  declaration_requests: Array<Declaration_Request>;
  name: Scalars['String'];
};


/** columns and relationships of "clearance_type" */
export type Clearance_TypeDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};

/** select columns of table "declaration_request" */
export enum Declaration_Request_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  CevStatus = 'cev_status',
  /** column name */
  ChExpDecl = 'ch_exp_decl',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DestTolldeptCode = 'dest_tolldept_code',
  /** column name */
  DestTolldeptName = 'dest_tolldept_name',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  Edec = 'edec',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  ImpCustClr = 'imp_cust_clr',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  Meta = 'meta',
  /** column name */
  MrnNumber = 'mrn_number',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  TollDep = 'toll_dep',
  /** column name */
  TrNo = 'tr_no',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransitdocType = 'transitdoc_type',
  /** column name */
  WaNumber = 'wa_number'
}

/** Customs offices actual for today */
export type Customs_Offices = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  office_number: Scalars['String'];
  prefix: Maybe<Scalars['String']>;
  valid_from: Scalars['timestamptz'];
  valid_to: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "declaration" */
export type Declaration = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  access_code: Maybe<Scalars['String']>;
  /** An array relationship */
  addresses: Array<Declaration_Request_Address>;
  agreed_location_of_goods: Maybe<Scalars['String']>;
  ai_confirmed: Maybe<Scalars['Boolean']>;
  ai_results: Scalars['jsonb'];
  border_eau_number: Maybe<Scalars['numeric']>;
  bunch_number: Maybe<Scalars['Int']>;
  change_information: Maybe<Scalars['date']>;
  clearance_location: Maybe<Scalars['smallint']>;
  company_number_taxpayer: Maybe<Scalars['String']>;
  /** An array relationship */
  containers: Array<Containers>;
  correction_code: Maybe<Scalars['Int']>;
  correction_reason: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_account_address_type: Maybe<Scalars['Int']>;
  customs_account_name: Maybe<Scalars['String']>;
  customs_account_number: Maybe<Scalars['bigint']>;
  customs_declaration_number: Maybe<Scalars['String']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_office_number: Maybe<Scalars['String']>;
  declarant_company_name: Maybe<Scalars['String']>;
  declarant_number: Maybe<Scalars['Int']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  /** An array relationship */
  declaration_special_mentions: Array<Declaration_Special_Mentions>;
  declaration_time: Maybe<Scalars['smallint']>;
  declaration_type: Maybe<Scalars['String']>;
  delivery_destination: Maybe<Scalars['bpchar']>;
  dispatch_country: Maybe<Scalars['String']>;
  dispatch_country_confirmation: Maybe<Scalars['Boolean']>;
  dr_no: Scalars['smallint'];
  duty_and_other_taxes_amount: Maybe<Scalars['numeric']>;
  duty_total_amount: Maybe<Scalars['numeric']>;
  evv_confirmed: Scalars['Boolean'];
  evv_received: Scalars['Boolean'];
  /** An object relationship */
  file: File;
  file_id: Scalars['uuid'];
  /** An array relationship */
  goods_items: Array<Goods_Item>;
  /** An aggregate relationship */
  goods_items_aggregate: Goods_Item_Aggregate;
  gross_mass: Maybe<Scalars['numeric']>;
  incoterms: Maybe<Scalars['String']>;
  initiator: Maybe<Scalars['smallint']>;
  injunction_type: Maybe<Scalars['smallint']>;
  inspection_code: Maybe<Scalars['Boolean']>;
  invoice_currency_type: Maybe<Scalars['String']>;
  lang: Maybe<Scalars['String']>;
  material_check: Maybe<Scalars['Boolean']>;
  net_mass: Maybe<Scalars['numeric']>;
  packaging_quantity: Maybe<Scalars['Int']>;
  payer_id: Maybe<Scalars['uuid']>;
  place_of_loading: Maybe<Scalars['String']>;
  place_of_unloading: Maybe<Scalars['String']>;
  postal_shipment_type: Maybe<Scalars['String']>;
  /** An array relationship */
  previous_documents: Array<Previous_Documents>;
  procedure_type: Maybe<Scalars['smallint']>;
  provisional_declaration_expiration_date: Maybe<Scalars['date']>;
  reason: Maybe<Scalars['String']>;
  receive_status: Maybe<Scalars['Int']>;
  release: Maybe<Scalars['Boolean']>;
  requestor_trader_identification_number: Maybe<Scalars['String']>;
  security: Maybe<Scalars['Boolean']>;
  selection_correlation_id: Maybe<Scalars['String']>;
  send_date: Maybe<Scalars['timestamptz']>;
  send_status: Maybe<Scalars['Int']>;
  service_type: Maybe<Scalars['String']>;
  show_in_wd: Maybe<Scalars['Boolean']>;
  specific_circumstance_indicator: Maybe<Scalars['bpchar']>;
  status: Maybe<Scalars['Int']>;
  status_date: Maybe<Scalars['date']>;
  status_time: Maybe<Scalars['time']>;
  tara_factor: Maybe<Scalars['numeric']>;
  total_colis: Maybe<Scalars['Int']>;
  total_goods_items: Maybe<Scalars['Int']>;
  total_gross_weight: Maybe<Scalars['numeric']>;
  total_vat_value: Maybe<Scalars['numeric']>;
  trader_declaration_number: Maybe<Scalars['String']>;
  trader_identification_number: Maybe<Scalars['String']>;
  trader_reference: Maybe<Scalars['String']>;
  transfer_to_transit_system: Maybe<Scalars['Boolean']>;
  transport_country: Maybe<Scalars['String']>;
  transport_in_container: Maybe<Scalars['Boolean']>;
  transport_mode: Maybe<Scalars['Int']>;
  transport_number: Maybe<Scalars['String']>;
  transport_type: Maybe<Scalars['String']>;
  unique_consignment_reference_number: Maybe<Scalars['String']>;
  vat_account_address_type: Maybe<Scalars['Int']>;
  vat_account_name: Maybe<Scalars['String']>;
  vat_account_number: Maybe<Scalars['bigint']>;
  vat_number: Maybe<Scalars['String']>;
  vat_suffix: Maybe<Scalars['Boolean']>;
  vat_total_amount: Maybe<Scalars['numeric']>;
  warehouse_coded: Maybe<Scalars['smallint']>;
};


/** columns and relationships of "declaration" */
export type DeclarationAddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationAi_ResultsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "declaration" */
export type DeclarationContainersArgs = {
  distinct_on?: InputMaybe<Array<Containers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Containers_Order_By>>;
  where?: InputMaybe<Containers_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationDeclaration_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Special_Mentions_Order_By>>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationGoods_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationGoods_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


/** columns and relationships of "declaration" */
export type DeclarationPrevious_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Previous_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Previous_Documents_Order_By>>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};

/** select columns of table "containers" */
export enum Containers_Select_Column {
  /** column name */
  ContainerNumber = 'container_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id'
}

/** Ordering options when selecting data from "containers". */
export type Containers_Order_By = {
  container_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "containers" */
export type Containers = {
  container_number: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
};

/** select columns of table "declaration_special_mentions" */
export enum Declaration_Special_Mentions_Select_Column {
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceNumber = 'sequence_number',
  /** column name */
  Text = 'text'
}

/** Ordering options when selecting data from "declaration_special_mentions". */
export type Declaration_Special_Mentions_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_special_mentions" */
export type Declaration_Special_Mentions = {
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  sequence_number: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "goods_item". */
export type Goods_Item_Order_By = {
  additional_unit?: InputMaybe<Order_By>;
  additional_unit_confirmation?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  commercial_good?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  commodity_code_confirmation?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_favour_code?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  customs_net_weight?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  description?: InputMaybe<Order_By>;
  direction?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_and_other_taxes_total?: InputMaybe<Order_By>;
  duty_rate?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  goods_item_special_mentions_aggregate?: InputMaybe<Goods_Item_Special_Mentions_Aggregate_Order_By>;
  gross_mass?: InputMaybe<Order_By>;
  gross_mass_confirmation?: InputMaybe<Order_By>;
  net_duty?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  net_mass_confirmation?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  origin_preference?: InputMaybe<Order_By>;
  packagings_aggregate?: InputMaybe<Packagings_Aggregate_Order_By>;
  permit_obligation_code?: InputMaybe<Order_By>;
  permits_aggregate?: InputMaybe<Permits_Aggregate_Order_By>;
  preference_confirmation?: InputMaybe<Order_By>;
  process_type?: InputMaybe<Order_By>;
  produced_documents_aggregate?: InputMaybe<Produced_Documents_Aggregate_Order_By>;
  rate_confirmation?: InputMaybe<Order_By>;
  refinement_type?: InputMaybe<Order_By>;
  refund_type?: InputMaybe<Order_By>;
  repair?: InputMaybe<Order_By>;
  repair_reason?: InputMaybe<Order_By>;
  selection_result?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  statistical_value_confirmation?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  tare_supplement?: InputMaybe<Order_By>;
  tare_supplement_confirmation?: InputMaybe<Order_By>;
  un_dangerous_goods_code?: InputMaybe<Order_By>;
  vat_code?: InputMaybe<Order_By>;
  vat_code_confirmation?: InputMaybe<Order_By>;
  vat_rate?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vat_value?: InputMaybe<Order_By>;
  vat_value_confirmation?: InputMaybe<Order_By>;
  voc_quantity?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Aggregate_Order_By = {
  avg?: InputMaybe<Goods_Item_Special_Mentions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Goods_Item_Special_Mentions_Max_Order_By>;
  min?: InputMaybe<Goods_Item_Special_Mentions_Min_Order_By>;
  stddev?: InputMaybe<Goods_Item_Special_Mentions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Goods_Item_Special_Mentions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Goods_Item_Special_Mentions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Goods_Item_Special_Mentions_Sum_Order_By>;
  var_pop?: InputMaybe<Goods_Item_Special_Mentions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Goods_Item_Special_Mentions_Var_Samp_Order_By>;
  variance?: InputMaybe<Goods_Item_Special_Mentions_Variance_Order_By>;
};

/** order by avg() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Avg_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Max_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Min_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Stddev_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Stddev_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Stddev_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Sum_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Var_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Var_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Variance_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "packagings" */
export type Packagings_Aggregate_Order_By = {
  avg?: InputMaybe<Packagings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Packagings_Max_Order_By>;
  min?: InputMaybe<Packagings_Min_Order_By>;
  stddev?: InputMaybe<Packagings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Packagings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Packagings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Packagings_Sum_Order_By>;
  var_pop?: InputMaybe<Packagings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Packagings_Var_Samp_Order_By>;
  variance?: InputMaybe<Packagings_Variance_Order_By>;
};

/** order by avg() on columns of table "packagings" */
export type Packagings_Avg_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "packagings" */
export type Packagings_Max_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  packaging_reference_number?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "packagings" */
export type Packagings_Min_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  packaging_reference_number?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "packagings" */
export type Packagings_Stddev_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "packagings" */
export type Packagings_Stddev_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "packagings" */
export type Packagings_Stddev_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "packagings" */
export type Packagings_Sum_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "packagings" */
export type Packagings_Var_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "packagings" */
export type Packagings_Var_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "packagings" */
export type Packagings_Variance_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "permits" */
export type Permits_Aggregate_Order_By = {
  avg?: InputMaybe<Permits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Permits_Max_Order_By>;
  min?: InputMaybe<Permits_Min_Order_By>;
  stddev?: InputMaybe<Permits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Permits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Permits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Permits_Sum_Order_By>;
  var_pop?: InputMaybe<Permits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Permits_Var_Samp_Order_By>;
  variance?: InputMaybe<Permits_Variance_Order_By>;
};

/** order by avg() on columns of table "permits" */
export type Permits_Avg_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "permits" */
export type Permits_Max_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_number?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "permits" */
export type Permits_Min_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_number?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "permits" */
export type Permits_Stddev_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "permits" */
export type Permits_Stddev_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "permits" */
export type Permits_Stddev_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "permits" */
export type Permits_Sum_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "permits" */
export type Permits_Var_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "permits" */
export type Permits_Var_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "permits" */
export type Permits_Variance_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "produced_documents" */
export type Produced_Documents_Aggregate_Order_By = {
  avg?: InputMaybe<Produced_Documents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Produced_Documents_Max_Order_By>;
  min?: InputMaybe<Produced_Documents_Min_Order_By>;
  stddev?: InputMaybe<Produced_Documents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Produced_Documents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Produced_Documents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Produced_Documents_Sum_Order_By>;
  var_pop?: InputMaybe<Produced_Documents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Produced_Documents_Var_Samp_Order_By>;
  variance?: InputMaybe<Produced_Documents_Variance_Order_By>;
};

/** order by avg() on columns of table "produced_documents" */
export type Produced_Documents_Avg_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "produced_documents" */
export type Produced_Documents_Max_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  produced_document_issue_date?: InputMaybe<Order_By>;
  produced_document_reference_number?: InputMaybe<Order_By>;
  produced_document_type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "produced_documents" */
export type Produced_Documents_Min_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  produced_document_issue_date?: InputMaybe<Order_By>;
  produced_document_reference_number?: InputMaybe<Order_By>;
  produced_document_type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "produced_documents" */
export type Produced_Documents_Stddev_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "produced_documents" */
export type Produced_Documents_Stddev_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "produced_documents" */
export type Produced_Documents_Stddev_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "produced_documents" */
export type Produced_Documents_Sum_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "produced_documents" */
export type Produced_Documents_Var_Pop_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "produced_documents" */
export type Produced_Documents_Var_Samp_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "produced_documents" */
export type Produced_Documents_Variance_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "goods_item" */
export type Goods_Item = {
  additional_unit: Maybe<Scalars['String']>;
  additional_unit_confirmation: Maybe<Scalars['Boolean']>;
  billing_type: Maybe<Scalars['smallint']>;
  clearance_type: Maybe<Scalars['Int']>;
  commercial_good: Maybe<Scalars['Boolean']>;
  commodity_code: Maybe<Scalars['String']>;
  commodity_code_confirmation: Maybe<Scalars['Boolean']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_favour_code: Maybe<Scalars['Int']>;
  customs_item_number: Scalars['Int'];
  customs_net_weight: Maybe<Scalars['numeric']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  description: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['smallint']>;
  dr_no: Scalars['smallint'];
  duty_and_other_taxes_total: Maybe<Scalars['numeric']>;
  duty_rate: Maybe<Scalars['numeric']>;
  duty_total: Maybe<Scalars['numeric']>;
  file_id: Scalars['uuid'];
  /** An array relationship */
  goods_item_special_mentions: Array<Goods_Item_Special_Mentions>;
  /** An aggregate relationship */
  goods_item_special_mentions_aggregate: Goods_Item_Special_Mentions_Aggregate;
  gross_mass: Maybe<Scalars['numeric']>;
  gross_mass_confirmation: Maybe<Scalars['Boolean']>;
  net_duty: Maybe<Scalars['Boolean']>;
  net_mass: Maybe<Scalars['numeric']>;
  net_mass_confirmation: Maybe<Scalars['Boolean']>;
  non_customs_law_obligation: Maybe<Scalars['smallint']>;
  origin_country: Maybe<Scalars['String']>;
  origin_preference: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  packagings: Array<Packagings>;
  /** An aggregate relationship */
  packagings_aggregate: Packagings_Aggregate;
  permit_obligation_code: Maybe<Scalars['Int']>;
  /** An array relationship */
  permits: Array<Permits>;
  /** An aggregate relationship */
  permits_aggregate: Permits_Aggregate;
  preference_confirmation: Maybe<Scalars['Boolean']>;
  process_type: Maybe<Scalars['smallint']>;
  /** An array relationship */
  produced_documents: Array<Produced_Documents>;
  /** An aggregate relationship */
  produced_documents_aggregate: Produced_Documents_Aggregate;
  rate_confirmation: Maybe<Scalars['Boolean']>;
  refinement_type: Maybe<Scalars['smallint']>;
  refund_type: Maybe<Scalars['smallint']>;
  repair: Maybe<Scalars['Boolean']>;
  repair_reason: Maybe<Scalars['String']>;
  selection_result: Maybe<Scalars['Int']>;
  statistical_code: Maybe<Scalars['Int']>;
  statistical_value: Maybe<Scalars['Int']>;
  statistical_value_confirmation: Maybe<Scalars['Boolean']>;
  storage_type: Maybe<Scalars['smallint']>;
  tare_supplement: Maybe<Scalars['numeric']>;
  tare_supplement_confirmation: Maybe<Scalars['Boolean']>;
  un_dangerous_goods_code: Maybe<Scalars['String']>;
  vat_code: Maybe<Scalars['smallint']>;
  vat_code_confirmation: Maybe<Scalars['Boolean']>;
  vat_rate: Maybe<Scalars['numeric']>;
  vat_total: Maybe<Scalars['numeric']>;
  vat_value: Maybe<Scalars['numeric']>;
  vat_value_confirmation: Maybe<Scalars['Boolean']>;
  voc_quantity: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemGoods_Item_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemGoods_Item_Special_Mentions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemPackagingsArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemPackagings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemPermitsArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemPermits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemProduced_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


/** columns and relationships of "goods_item" */
export type Goods_ItemProduced_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};

/** Ordering options when selecting data from "goods_item_special_mentions". */
export type Goods_Item_Special_Mentions_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sequence_number?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
};

/** columns and relationships of "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  sequence_number: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** aggregated selection of "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Aggregate = {
  aggregate: Maybe<Goods_Item_Special_Mentions_Aggregate_Fields>;
  nodes: Array<Goods_Item_Special_Mentions>;
};

/** aggregate fields of "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Aggregate_Fields = {
  avg: Maybe<Goods_Item_Special_Mentions_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Goods_Item_Special_Mentions_Max_Fields>;
  min: Maybe<Goods_Item_Special_Mentions_Min_Fields>;
  stddev: Maybe<Goods_Item_Special_Mentions_Stddev_Fields>;
  stddev_pop: Maybe<Goods_Item_Special_Mentions_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Goods_Item_Special_Mentions_Stddev_Samp_Fields>;
  sum: Maybe<Goods_Item_Special_Mentions_Sum_Fields>;
  var_pop: Maybe<Goods_Item_Special_Mentions_Var_Pop_Fields>;
  var_samp: Maybe<Goods_Item_Special_Mentions_Var_Samp_Fields>;
  variance: Maybe<Goods_Item_Special_Mentions_Variance_Fields>;
};


/** aggregate fields of "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Goods_Item_Special_Mentions_Avg_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Goods_Item_Special_Mentions_Max_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  sequence_number: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Goods_Item_Special_Mentions_Min_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  sequence_number: Maybe<Scalars['Int']>;
  text: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Goods_Item_Special_Mentions_Stddev_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Goods_Item_Special_Mentions_Stddev_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Goods_Item_Special_Mentions_Stddev_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Goods_Item_Special_Mentions_Sum_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  id: Maybe<Scalars['Int']>;
  sequence_number: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Goods_Item_Special_Mentions_Var_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Goods_Item_Special_Mentions_Var_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Goods_Item_Special_Mentions_Variance_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  sequence_number: Maybe<Scalars['Float']>;
};

/** Ordering options when selecting data from "packagings". */
export type Packagings_Order_By = {
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  packaging_quantity?: InputMaybe<Order_By>;
  packaging_reference_number?: InputMaybe<Order_By>;
  packaging_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "packagings" */
export type Packagings = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  packaging_quantity: Maybe<Scalars['Int']>;
  packaging_reference_number: Maybe<Scalars['String']>;
  packaging_type: Maybe<Scalars['String']>;
};

/** aggregated selection of "packagings" */
export type Packagings_Aggregate = {
  aggregate: Maybe<Packagings_Aggregate_Fields>;
  nodes: Array<Packagings>;
};

/** aggregate fields of "packagings" */
export type Packagings_Aggregate_Fields = {
  avg: Maybe<Packagings_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Packagings_Max_Fields>;
  min: Maybe<Packagings_Min_Fields>;
  stddev: Maybe<Packagings_Stddev_Fields>;
  stddev_pop: Maybe<Packagings_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Packagings_Stddev_Samp_Fields>;
  sum: Maybe<Packagings_Sum_Fields>;
  var_pop: Maybe<Packagings_Var_Pop_Fields>;
  var_samp: Maybe<Packagings_Var_Samp_Fields>;
  variance: Maybe<Packagings_Variance_Fields>;
};


/** aggregate fields of "packagings" */
export type Packagings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Packagings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Packagings_Avg_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Packagings_Max_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  packaging_quantity: Maybe<Scalars['Int']>;
  packaging_reference_number: Maybe<Scalars['String']>;
  packaging_type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Packagings_Min_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  packaging_quantity: Maybe<Scalars['Int']>;
  packaging_reference_number: Maybe<Scalars['String']>;
  packaging_type: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Packagings_Stddev_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Packagings_Stddev_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Packagings_Stddev_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Packagings_Sum_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  id: Maybe<Scalars['Int']>;
  packaging_quantity: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Packagings_Var_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Packagings_Var_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Packagings_Variance_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  packaging_quantity: Maybe<Scalars['Float']>;
};

/** Ordering options when selecting data from "permits". */
export type Permits_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  issue_date?: InputMaybe<Order_By>;
  permit_authority?: InputMaybe<Order_By>;
  permit_item_details?: InputMaybe<Order_By>;
  permit_number?: InputMaybe<Order_By>;
  permit_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "permits" */
export type Permits = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  issue_date: Maybe<Scalars['date']>;
  permit_authority: Maybe<Scalars['Int']>;
  permit_item_details: Maybe<Scalars['jsonb']>;
  permit_number: Maybe<Scalars['String']>;
  permit_type: Maybe<Scalars['Int']>;
};


/** columns and relationships of "permits" */
export type PermitsPermit_Item_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "permits" */
export type Permits_Aggregate = {
  aggregate: Maybe<Permits_Aggregate_Fields>;
  nodes: Array<Permits>;
};

/** aggregate fields of "permits" */
export type Permits_Aggregate_Fields = {
  avg: Maybe<Permits_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Permits_Max_Fields>;
  min: Maybe<Permits_Min_Fields>;
  stddev: Maybe<Permits_Stddev_Fields>;
  stddev_pop: Maybe<Permits_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Permits_Stddev_Samp_Fields>;
  sum: Maybe<Permits_Sum_Fields>;
  var_pop: Maybe<Permits_Var_Pop_Fields>;
  var_samp: Maybe<Permits_Var_Samp_Fields>;
  variance: Maybe<Permits_Variance_Fields>;
};


/** aggregate fields of "permits" */
export type Permits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Permits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Permits_Avg_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Permits_Max_Fields = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  issue_date: Maybe<Scalars['date']>;
  permit_authority: Maybe<Scalars['Int']>;
  permit_number: Maybe<Scalars['String']>;
  permit_type: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Permits_Min_Fields = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  issue_date: Maybe<Scalars['date']>;
  permit_authority: Maybe<Scalars['Int']>;
  permit_number: Maybe<Scalars['String']>;
  permit_type: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Permits_Stddev_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Permits_Stddev_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Permits_Stddev_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Permits_Sum_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  id: Maybe<Scalars['Int']>;
  permit_authority: Maybe<Scalars['Int']>;
  permit_type: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Permits_Var_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Permits_Var_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Permits_Variance_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
  permit_authority: Maybe<Scalars['Float']>;
  permit_type: Maybe<Scalars['Float']>;
};

/** Ordering options when selecting data from "produced_documents". */
export type Produced_Documents_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  customs_item_number?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  produced_document_issue_date?: InputMaybe<Order_By>;
  produced_document_reference_number?: InputMaybe<Order_By>;
  produced_document_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "produced_documents" */
export type Produced_Documents = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Scalars['Int'];
  produced_document_issue_date: Maybe<Scalars['date']>;
  produced_document_reference_number: Maybe<Scalars['String']>;
  produced_document_type: Maybe<Scalars['String']>;
};

/** aggregated selection of "produced_documents" */
export type Produced_Documents_Aggregate = {
  aggregate: Maybe<Produced_Documents_Aggregate_Fields>;
  nodes: Array<Produced_Documents>;
};

/** aggregate fields of "produced_documents" */
export type Produced_Documents_Aggregate_Fields = {
  avg: Maybe<Produced_Documents_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Produced_Documents_Max_Fields>;
  min: Maybe<Produced_Documents_Min_Fields>;
  stddev: Maybe<Produced_Documents_Stddev_Fields>;
  stddev_pop: Maybe<Produced_Documents_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Produced_Documents_Stddev_Samp_Fields>;
  sum: Maybe<Produced_Documents_Sum_Fields>;
  var_pop: Maybe<Produced_Documents_Var_Pop_Fields>;
  var_samp: Maybe<Produced_Documents_Var_Samp_Fields>;
  variance: Maybe<Produced_Documents_Variance_Fields>;
};


/** aggregate fields of "produced_documents" */
export type Produced_Documents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Produced_Documents_Avg_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Produced_Documents_Max_Fields = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  produced_document_issue_date: Maybe<Scalars['date']>;
  produced_document_reference_number: Maybe<Scalars['String']>;
  produced_document_type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Produced_Documents_Min_Fields = {
  additional_information: Maybe<Scalars['String']>;
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  file_id: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['Int']>;
  produced_document_issue_date: Maybe<Scalars['date']>;
  produced_document_reference_number: Maybe<Scalars['String']>;
  produced_document_type: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Produced_Documents_Stddev_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Produced_Documents_Stddev_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Produced_Documents_Stddev_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Produced_Documents_Sum_Fields = {
  customs_item_number: Maybe<Scalars['Int']>;
  dr_no: Maybe<Scalars['smallint']>;
  id: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Produced_Documents_Var_Pop_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Produced_Documents_Var_Samp_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Produced_Documents_Variance_Fields = {
  customs_item_number: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  id: Maybe<Scalars['Float']>;
};

/** aggregated selection of "goods_item" */
export type Goods_Item_Aggregate = {
  aggregate: Maybe<Goods_Item_Aggregate_Fields>;
  nodes: Array<Goods_Item>;
};

/** aggregate fields of "goods_item" */
export type Goods_Item_Aggregate_Fields = {
  avg: Maybe<Goods_Item_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Goods_Item_Max_Fields>;
  min: Maybe<Goods_Item_Min_Fields>;
  stddev: Maybe<Goods_Item_Stddev_Fields>;
  stddev_pop: Maybe<Goods_Item_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Goods_Item_Stddev_Samp_Fields>;
  sum: Maybe<Goods_Item_Sum_Fields>;
  var_pop: Maybe<Goods_Item_Var_Pop_Fields>;
  var_samp: Maybe<Goods_Item_Var_Samp_Fields>;
  variance: Maybe<Goods_Item_Variance_Fields>;
};


/** aggregate fields of "goods_item" */
export type Goods_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Goods_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Goods_Item_Avg_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Goods_Item_Max_Fields = {
  additional_unit: Maybe<Scalars['String']>;
  billing_type: Maybe<Scalars['smallint']>;
  clearance_type: Maybe<Scalars['Int']>;
  commodity_code: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_favour_code: Maybe<Scalars['Int']>;
  customs_item_number: Maybe<Scalars['Int']>;
  customs_net_weight: Maybe<Scalars['numeric']>;
  description: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['smallint']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_and_other_taxes_total: Maybe<Scalars['numeric']>;
  duty_rate: Maybe<Scalars['numeric']>;
  duty_total: Maybe<Scalars['numeric']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['smallint']>;
  origin_country: Maybe<Scalars['String']>;
  permit_obligation_code: Maybe<Scalars['Int']>;
  process_type: Maybe<Scalars['smallint']>;
  refinement_type: Maybe<Scalars['smallint']>;
  refund_type: Maybe<Scalars['smallint']>;
  repair_reason: Maybe<Scalars['String']>;
  selection_result: Maybe<Scalars['Int']>;
  statistical_code: Maybe<Scalars['Int']>;
  statistical_value: Maybe<Scalars['Int']>;
  storage_type: Maybe<Scalars['smallint']>;
  tare_supplement: Maybe<Scalars['numeric']>;
  un_dangerous_goods_code: Maybe<Scalars['String']>;
  vat_code: Maybe<Scalars['smallint']>;
  vat_rate: Maybe<Scalars['numeric']>;
  vat_total: Maybe<Scalars['numeric']>;
  vat_value: Maybe<Scalars['numeric']>;
  voc_quantity: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Goods_Item_Min_Fields = {
  additional_unit: Maybe<Scalars['String']>;
  billing_type: Maybe<Scalars['smallint']>;
  clearance_type: Maybe<Scalars['Int']>;
  commodity_code: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_favour_code: Maybe<Scalars['Int']>;
  customs_item_number: Maybe<Scalars['Int']>;
  customs_net_weight: Maybe<Scalars['numeric']>;
  description: Maybe<Scalars['String']>;
  direction: Maybe<Scalars['smallint']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_and_other_taxes_total: Maybe<Scalars['numeric']>;
  duty_rate: Maybe<Scalars['numeric']>;
  duty_total: Maybe<Scalars['numeric']>;
  file_id: Maybe<Scalars['uuid']>;
  gross_mass: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['smallint']>;
  origin_country: Maybe<Scalars['String']>;
  permit_obligation_code: Maybe<Scalars['Int']>;
  process_type: Maybe<Scalars['smallint']>;
  refinement_type: Maybe<Scalars['smallint']>;
  refund_type: Maybe<Scalars['smallint']>;
  repair_reason: Maybe<Scalars['String']>;
  selection_result: Maybe<Scalars['Int']>;
  statistical_code: Maybe<Scalars['Int']>;
  statistical_value: Maybe<Scalars['Int']>;
  storage_type: Maybe<Scalars['smallint']>;
  tare_supplement: Maybe<Scalars['numeric']>;
  un_dangerous_goods_code: Maybe<Scalars['String']>;
  vat_code: Maybe<Scalars['smallint']>;
  vat_rate: Maybe<Scalars['numeric']>;
  vat_total: Maybe<Scalars['numeric']>;
  vat_value: Maybe<Scalars['numeric']>;
  voc_quantity: Maybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Goods_Item_Stddev_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Goods_Item_Stddev_Pop_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Goods_Item_Stddev_Samp_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Goods_Item_Sum_Fields = {
  billing_type: Maybe<Scalars['smallint']>;
  clearance_type: Maybe<Scalars['Int']>;
  customs_declaration_version: Maybe<Scalars['Int']>;
  customs_favour_code: Maybe<Scalars['Int']>;
  customs_item_number: Maybe<Scalars['Int']>;
  customs_net_weight: Maybe<Scalars['numeric']>;
  direction: Maybe<Scalars['smallint']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_and_other_taxes_total: Maybe<Scalars['numeric']>;
  duty_rate: Maybe<Scalars['numeric']>;
  duty_total: Maybe<Scalars['numeric']>;
  gross_mass: Maybe<Scalars['numeric']>;
  net_mass: Maybe<Scalars['numeric']>;
  non_customs_law_obligation: Maybe<Scalars['smallint']>;
  permit_obligation_code: Maybe<Scalars['Int']>;
  process_type: Maybe<Scalars['smallint']>;
  refinement_type: Maybe<Scalars['smallint']>;
  refund_type: Maybe<Scalars['smallint']>;
  selection_result: Maybe<Scalars['Int']>;
  statistical_code: Maybe<Scalars['Int']>;
  statistical_value: Maybe<Scalars['Int']>;
  storage_type: Maybe<Scalars['smallint']>;
  tare_supplement: Maybe<Scalars['numeric']>;
  vat_code: Maybe<Scalars['smallint']>;
  vat_rate: Maybe<Scalars['numeric']>;
  vat_total: Maybe<Scalars['numeric']>;
  vat_value: Maybe<Scalars['numeric']>;
  voc_quantity: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Goods_Item_Var_Pop_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Goods_Item_Var_Samp_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Goods_Item_Variance_Fields = {
  billing_type: Maybe<Scalars['Float']>;
  clearance_type: Maybe<Scalars['Float']>;
  customs_declaration_version: Maybe<Scalars['Float']>;
  customs_favour_code: Maybe<Scalars['Float']>;
  customs_item_number: Maybe<Scalars['Float']>;
  customs_net_weight: Maybe<Scalars['Float']>;
  direction: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
  duty_and_other_taxes_total: Maybe<Scalars['Float']>;
  duty_rate: Maybe<Scalars['Float']>;
  duty_total: Maybe<Scalars['Float']>;
  gross_mass: Maybe<Scalars['Float']>;
  net_mass: Maybe<Scalars['Float']>;
  non_customs_law_obligation: Maybe<Scalars['Float']>;
  permit_obligation_code: Maybe<Scalars['Float']>;
  process_type: Maybe<Scalars['Float']>;
  refinement_type: Maybe<Scalars['Float']>;
  refund_type: Maybe<Scalars['Float']>;
  selection_result: Maybe<Scalars['Float']>;
  statistical_code: Maybe<Scalars['Float']>;
  statistical_value: Maybe<Scalars['Float']>;
  storage_type: Maybe<Scalars['Float']>;
  tare_supplement: Maybe<Scalars['Float']>;
  vat_code: Maybe<Scalars['Float']>;
  vat_rate: Maybe<Scalars['Float']>;
  vat_total: Maybe<Scalars['Float']>;
  vat_value: Maybe<Scalars['Float']>;
  voc_quantity: Maybe<Scalars['Float']>;
};

/** select columns of table "previous_documents" */
export enum Previous_Documents_Select_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousDocumentReference = 'previous_document_reference',
  /** column name */
  PreviousDocumentType = 'previous_document_type'
}

/** Ordering options when selecting data from "previous_documents". */
export type Previous_Documents_Order_By = {
  additional_information?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  previous_document_reference?: InputMaybe<Order_By>;
  previous_document_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "previous_documents" */
export type Previous_Documents = {
  additional_information: Maybe<Scalars['String']>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  id: Scalars['Int'];
  previous_document_reference: Maybe<Scalars['String']>;
  previous_document_type: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "declaration_discussion". */
export type Declaration_Discussion_Order_By = {
  closed?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  discussion_theme?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<User_Pp_Order_By>;
};

/** order by aggregate values of table "declaration_message" */
export type Declaration_Message_Aggregate_Order_By = {
  avg?: InputMaybe<Declaration_Message_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Declaration_Message_Max_Order_By>;
  min?: InputMaybe<Declaration_Message_Min_Order_By>;
  stddev?: InputMaybe<Declaration_Message_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Declaration_Message_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Declaration_Message_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Declaration_Message_Sum_Order_By>;
  var_pop?: InputMaybe<Declaration_Message_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Declaration_Message_Var_Samp_Order_By>;
  variance?: InputMaybe<Declaration_Message_Variance_Order_By>;
};

/** order by avg() on columns of table "declaration_message" */
export type Declaration_Message_Avg_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "declaration_message" */
export type Declaration_Message_Max_Order_By = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  msg_date?: InputMaybe<Order_By>;
  read_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "declaration_message" */
export type Declaration_Message_Min_Order_By = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  msg_date?: InputMaybe<Order_By>;
  read_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "declaration_message" */
export type Declaration_Message_Stddev_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "declaration_message" */
export type Declaration_Message_Stddev_Pop_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "declaration_message" */
export type Declaration_Message_Stddev_Samp_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "declaration_message" */
export type Declaration_Message_Sum_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "declaration_message" */
export type Declaration_Message_Var_Pop_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "declaration_message" */
export type Declaration_Message_Var_Samp_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "declaration_message" */
export type Declaration_Message_Variance_Order_By = {
  discussion_id?: InputMaybe<Order_By>;
};

/** Discussions related to files/declarations. */
export type Declaration_Discussion = {
  /** Discussion is closed */
  closed: Scalars['Boolean'];
  /** Creation date of discussion. */
  creation_date: Scalars['timestamptz'];
  /** User initiated discussion. */
  creation_user: Scalars['uuid'];
  /** An array relationship */
  declaration_messages: Array<Declaration_Message>;
  /** An aggregate relationship */
  declaration_messages_aggregate: Declaration_Message_Aggregate;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  /** Unique identificator of discussion. */
  discussion_id: Scalars['bigint'];
  /** Theme of discussion. */
  discussion_theme: Maybe<Scalars['String']>;
  dr_no: Scalars['smallint'];
  /** File/Declaration related to discussion. */
  file_id: Scalars['uuid'];
  /** additional attributes */
  meta: Scalars['jsonb'];
  /** An object relationship */
  user_pp: User_Pp;
};


/** Discussions related to files/declarations. */
export type Declaration_DiscussionDeclaration_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** Discussions related to files/declarations. */
export type Declaration_DiscussionDeclaration_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** Discussions related to files/declarations. */
export type Declaration_DiscussionMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Ordering options when selecting data from "declaration_message". */
export type Declaration_Message_Order_By = {
  creation_user?: InputMaybe<Order_By>;
  declaration_discussion?: InputMaybe<Declaration_Discussion_Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  msg_date?: InputMaybe<Order_By>;
  read_date?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Message in declaration discussion. */
export type Declaration_Message = {
  /** declaration_message creation user. */
  creation_user: Scalars['uuid'];
  /** An object relationship */
  declaration_discussion: Declaration_Discussion;
  discussion_id: Scalars['bigint'];
  message: Scalars['String'];
  meta: Scalars['jsonb'];
  msg_date: Scalars['timestamptz'];
  read_date: Maybe<Scalars['timestamptz']>;
  type: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Maybe<User_Pp>;
};


/** Message in declaration discussion. */
export type Declaration_MessageMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "declaration_message" */
export type Declaration_Message_Aggregate = {
  aggregate: Maybe<Declaration_Message_Aggregate_Fields>;
  nodes: Array<Declaration_Message>;
};

/** aggregate fields of "declaration_message" */
export type Declaration_Message_Aggregate_Fields = {
  avg: Maybe<Declaration_Message_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Declaration_Message_Max_Fields>;
  min: Maybe<Declaration_Message_Min_Fields>;
  stddev: Maybe<Declaration_Message_Stddev_Fields>;
  stddev_pop: Maybe<Declaration_Message_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Declaration_Message_Stddev_Samp_Fields>;
  sum: Maybe<Declaration_Message_Sum_Fields>;
  var_pop: Maybe<Declaration_Message_Var_Pop_Fields>;
  var_samp: Maybe<Declaration_Message_Var_Samp_Fields>;
  variance: Maybe<Declaration_Message_Variance_Fields>;
};


/** aggregate fields of "declaration_message" */
export type Declaration_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Declaration_Message_Avg_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Declaration_Message_Max_Fields = {
  /** declaration_message creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  discussion_id: Maybe<Scalars['bigint']>;
  message: Maybe<Scalars['String']>;
  msg_date: Maybe<Scalars['timestamptz']>;
  read_date: Maybe<Scalars['timestamptz']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Declaration_Message_Min_Fields = {
  /** declaration_message creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  discussion_id: Maybe<Scalars['bigint']>;
  message: Maybe<Scalars['String']>;
  msg_date: Maybe<Scalars['timestamptz']>;
  read_date: Maybe<Scalars['timestamptz']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Declaration_Message_Stddev_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Declaration_Message_Stddev_Pop_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Declaration_Message_Stddev_Samp_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Declaration_Message_Sum_Fields = {
  discussion_id: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Declaration_Message_Var_Pop_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Declaration_Message_Var_Samp_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Declaration_Message_Variance_Fields = {
  discussion_id: Maybe<Scalars['Float']>;
};

/** aggregated selection of "declaration_discussion" */
export type Declaration_Discussion_Aggregate = {
  aggregate: Maybe<Declaration_Discussion_Aggregate_Fields>;
  nodes: Array<Declaration_Discussion>;
};

/** aggregate fields of "declaration_discussion" */
export type Declaration_Discussion_Aggregate_Fields = {
  avg: Maybe<Declaration_Discussion_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Declaration_Discussion_Max_Fields>;
  min: Maybe<Declaration_Discussion_Min_Fields>;
  stddev: Maybe<Declaration_Discussion_Stddev_Fields>;
  stddev_pop: Maybe<Declaration_Discussion_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Declaration_Discussion_Stddev_Samp_Fields>;
  sum: Maybe<Declaration_Discussion_Sum_Fields>;
  var_pop: Maybe<Declaration_Discussion_Var_Pop_Fields>;
  var_samp: Maybe<Declaration_Discussion_Var_Samp_Fields>;
  variance: Maybe<Declaration_Discussion_Variance_Fields>;
};


/** aggregate fields of "declaration_discussion" */
export type Declaration_Discussion_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Declaration_Discussion_Avg_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Declaration_Discussion_Max_Fields = {
  /** Creation date of discussion. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** User initiated discussion. */
  creation_user: Maybe<Scalars['uuid']>;
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['bigint']>;
  /** Theme of discussion. */
  discussion_theme: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  /** File/Declaration related to discussion. */
  file_id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Declaration_Discussion_Min_Fields = {
  /** Creation date of discussion. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** User initiated discussion. */
  creation_user: Maybe<Scalars['uuid']>;
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['bigint']>;
  /** Theme of discussion. */
  discussion_theme: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  /** File/Declaration related to discussion. */
  file_id: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Declaration_Discussion_Stddev_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Declaration_Discussion_Stddev_Pop_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Declaration_Discussion_Stddev_Samp_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Declaration_Discussion_Sum_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['bigint']>;
  dr_no: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type Declaration_Discussion_Var_Pop_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Declaration_Discussion_Var_Samp_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Declaration_Discussion_Variance_Fields = {
  /** Unique identificator of discussion. */
  discussion_id: Maybe<Scalars['Float']>;
  dr_no: Maybe<Scalars['Float']>;
};

/** select columns of table "declaration_document" */
export enum Declaration_Document_Select_Column {
  /** column name */
  DocId = 'doc_id',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id'
}

/** Ordering options when selecting data from "declaration_document". */
export type Declaration_Document_Order_By = {
  doc_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_document" */
export type Declaration_Document = {
  doc_id: Scalars['uuid'];
  /** An object relationship */
  document: Maybe<Document>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};

/** select columns of table "declaration_request_labels" */
export enum Declaration_Request_Labels_Select_Column {
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  LabelId = 'label_id'
}

/** Ordering options when selecting data from "declaration_request_labels". */
export type Declaration_Request_Labels_Order_By = {
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  label_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "declaration_request_labels" */
export type Declaration_Request_Labels = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  label_id: Scalars['Int'];
};

/** columns and relationships of "declaration_status" */
export type Declaration_Status = {
  name: Scalars['String'];
};

/** columns and relationships of "declaration_type" */
export type Declaration_Type = {
  /** An array relationship */
  declaration_requests: Array<Declaration_Request>;
  document_schema: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
};


/** columns and relationships of "declaration_type" */
export type Declaration_TypeDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


/** columns and relationships of "declaration_type" */
export type Declaration_TypeDocument_SchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "declaration_task" */
export type Declaration_Task_Aggregate = {
  aggregate: Maybe<Declaration_Task_Aggregate_Fields>;
  nodes: Array<Declaration_Task>;
};

/** aggregate fields of "declaration_task" */
export type Declaration_Task_Aggregate_Fields = {
  avg: Maybe<Declaration_Task_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Declaration_Task_Max_Fields>;
  min: Maybe<Declaration_Task_Min_Fields>;
  stddev: Maybe<Declaration_Task_Stddev_Fields>;
  stddev_pop: Maybe<Declaration_Task_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Declaration_Task_Stddev_Samp_Fields>;
  sum: Maybe<Declaration_Task_Sum_Fields>;
  var_pop: Maybe<Declaration_Task_Var_Pop_Fields>;
  var_samp: Maybe<Declaration_Task_Var_Samp_Fields>;
  variance: Maybe<Declaration_Task_Variance_Fields>;
};


/** aggregate fields of "declaration_task" */
export type Declaration_Task_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Declaration_Task_Avg_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Declaration_Task_Max_Fields = {
  assigned_to: Maybe<Scalars['uuid']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  due_date: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['Int']>;
  object_id: Maybe<Scalars['uuid']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Int']>;
  task_type_id: Maybe<Scalars['Int']>;
  title: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Declaration_Task_Min_Fields = {
  assigned_to: Maybe<Scalars['uuid']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  due_date: Maybe<Scalars['timestamptz']>;
  id: Maybe<Scalars['Int']>;
  object_id: Maybe<Scalars['uuid']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Int']>;
  task_type_id: Maybe<Scalars['Int']>;
  title: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Declaration_Task_Stddev_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Declaration_Task_Stddev_Pop_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Declaration_Task_Stddev_Samp_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Declaration_Task_Sum_Fields = {
  id: Maybe<Scalars['Int']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Int']>;
  task_type_id: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Declaration_Task_Var_Pop_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Declaration_Task_Var_Samp_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Declaration_Task_Variance_Fields = {
  id: Maybe<Scalars['Float']>;
  /** 1 = finished, 0 = open */
  task_status_id: Maybe<Scalars['Float']>;
  task_type_id: Maybe<Scalars['Float']>;
};

/** columns and relationships of "task_type" */
export type Task_Type = {
  display_name: Scalars['String'];
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
};


/** columns and relationships of "task_type" */
export type Task_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "doc_annotation" */
export enum Doc_Annotation_Select_Column {
  /** column name */
  AnnoTypeId = 'anno_type_id',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  Value = 'value'
}

/** Ordering options when selecting data from "doc_annotation". */
export type Doc_Annotation_Order_By = {
  anno_type_id?: InputMaybe<Order_By>;
  annotation_type?: InputMaybe<Annotation_Type_Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Contains annotations for document. */
export type Doc_Annotation = {
  anno_type_id: Scalars['smallint'];
  /** An object relationship */
  annotation_type: Annotation_Type;
  /** Document Id related to doc_annotation. */
  doc_id: Scalars['uuid'];
  /** An object relationship */
  document: Maybe<Document>;
  value: Maybe<Scalars['jsonb']>;
};


/** Contains annotations for document. */
export type Doc_AnnotationValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Enum-like table from document.extension. Questionable utitily. */
export type Document_Extension = {
  /** document_extension creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_extension creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** document_extension last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_extension. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  thumbnails_supported: Scalars['Boolean'];
  /** An object relationship */
  user: Maybe<User_Pp>;
};

/** Ordering options when selecting data from "document_page". */
export type Document_Page_Order_By = {
  document?: InputMaybe<Document_Order_By>;
  document_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Page_Order_By>;
  page_id?: InputMaybe<Order_By>;
  page_number?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "page". */
export type Page_Order_By = {
  ai_ignore_retraining?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Page_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  ocr_text?: InputMaybe<Order_By>;
  page_extracts_aggregate?: InputMaybe<Page_Extract_Aggregate_Order_By>;
  page_status?: InputMaybe<Order_By>;
  rotate?: InputMaybe<Order_By>;
  thumbnail_big_url?: InputMaybe<Order_By>;
  thumbnail_small_url?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "page_extract" */
export type Page_Extract_Aggregate_Order_By = {
  avg?: InputMaybe<Page_Extract_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Page_Extract_Max_Order_By>;
  min?: InputMaybe<Page_Extract_Min_Order_By>;
  stddev?: InputMaybe<Page_Extract_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Page_Extract_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Page_Extract_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Page_Extract_Sum_Order_By>;
  var_pop?: InputMaybe<Page_Extract_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Page_Extract_Var_Samp_Order_By>;
  variance?: InputMaybe<Page_Extract_Variance_Order_By>;
};

/** order by avg() on columns of table "page_extract" */
export type Page_Extract_Avg_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "page_extract" */
export type Page_Extract_Max_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "page_extract" */
export type Page_Extract_Min_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
  page_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "page_extract" */
export type Page_Extract_Stddev_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "page_extract" */
export type Page_Extract_Stddev_Pop_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "page_extract" */
export type Page_Extract_Stddev_Samp_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "page_extract" */
export type Page_Extract_Sum_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "page_extract" */
export type Page_Extract_Var_Pop_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "page_extract" */
export type Page_Extract_Var_Samp_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "page_extract" */
export type Page_Extract_Variance_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
};

/** Many-to-many relation between document and page */
export type Document_Page = {
  /** An object relationship */
  document: Maybe<Document>;
  /** Document Id related to document_page. */
  document_id: Scalars['uuid'];
  /** An object relationship */
  page: Maybe<Page>;
  page_id: Scalars['uuid'];
  page_number: Scalars['smallint'];
};

/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type Page = {
  ai_ignore_retraining: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  created_by_user: Maybe<User_Pp>;
  /** page creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** page creation user. */
  creation_user: Scalars['uuid'];
  /** An array relationship */
  documents: Array<Document_Page>;
  /** An aggregate relationship */
  documents_aggregate: Document_Page_Aggregate;
  /** id of page. */
  id: Scalars['uuid'];
  /** page last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified page. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** additional attributes */
  meta: Scalars['jsonb'];
  ocr_text: Maybe<Scalars['String']>;
  /** An array relationship */
  page_extracts: Array<Page_Extract>;
  page_status: Scalars['String'];
  rotate: Scalars['smallint'];
  thumbnail_big_url: Maybe<Scalars['String']>;
  thumbnail_small_url: Maybe<Scalars['String']>;
};


/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type PageDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type PageDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type PageMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** The biggest and possibly least useful table in DB. Beware relation pagesm2ms if graphq queries */
export type PagePage_ExtractsArgs = {
  distinct_on?: InputMaybe<Array<Page_Extract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Extract_Order_By>>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};

/** aggregated selection of "document_page" */
export type Document_Page_Aggregate = {
  aggregate: Maybe<Document_Page_Aggregate_Fields>;
  nodes: Array<Document_Page>;
};

/** aggregate fields of "document_page" */
export type Document_Page_Aggregate_Fields = {
  avg: Maybe<Document_Page_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Document_Page_Max_Fields>;
  min: Maybe<Document_Page_Min_Fields>;
  stddev: Maybe<Document_Page_Stddev_Fields>;
  stddev_pop: Maybe<Document_Page_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Document_Page_Stddev_Samp_Fields>;
  sum: Maybe<Document_Page_Sum_Fields>;
  var_pop: Maybe<Document_Page_Var_Pop_Fields>;
  var_samp: Maybe<Document_Page_Var_Samp_Fields>;
  variance: Maybe<Document_Page_Variance_Fields>;
};


/** aggregate fields of "document_page" */
export type Document_Page_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Page_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Document_Page_Avg_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Document_Page_Max_Fields = {
  /** Document Id related to document_page. */
  document_id: Maybe<Scalars['uuid']>;
  page_id: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['smallint']>;
};

/** aggregate min on columns */
export type Document_Page_Min_Fields = {
  /** Document Id related to document_page. */
  document_id: Maybe<Scalars['uuid']>;
  page_id: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['smallint']>;
};

/** aggregate stddev on columns */
export type Document_Page_Stddev_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Document_Page_Stddev_Pop_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Document_Page_Stddev_Samp_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Document_Page_Sum_Fields = {
  page_number: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type Document_Page_Var_Pop_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Document_Page_Var_Samp_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Document_Page_Variance_Fields = {
  page_number: Maybe<Scalars['Float']>;
};

/** select columns of table "page_extract" */
export enum Page_Extract_Select_Column {
  /** column name */
  ExtractTypeId = 'extract_type_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Tables = 'tables',
  /** column name */
  Value = 'value'
}

/** Ordering options when selecting data from "page_extract". */
export type Page_Extract_Order_By = {
  extract_type?: InputMaybe<Extract_Type_Order_By>;
  extract_type_id?: InputMaybe<Order_By>;
  page?: InputMaybe<Page_Order_By>;
  page_id?: InputMaybe<Order_By>;
  tables?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "extract_type". */
export type Extract_Type_Order_By = {
  extract_type_id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
};

/** columns and relationships of "page_extract" */
export type Page_Extract = {
  /** An object relationship */
  extract_type: Extract_Type;
  extract_type_id: Scalars['smallint'];
  /** An object relationship */
  page: Page;
  page_id: Scalars['uuid'];
  tables: Maybe<Scalars['jsonb']>;
  value: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "page_extract" */
export type Page_ExtractTablesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "page_extract" */
export type Page_ExtractValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Enum-like table. Used as value in page_extract. */
export type Extract_Type = {
  extract_type_id: Scalars['smallint'];
  /** additional attributes */
  meta: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  translations: Maybe<Scalars['json']>;
};


/** Enum-like table. Used as value in page_extract. */
export type Extract_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Enum-like table. Used as value in page_extract. */
export type Extract_TypeTranslationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Enum-like table that holds values for document.document_status */
export type Document_Status = {
  /** document_status creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_status creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** document_status last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_status. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  /** An object relationship */
  user: Maybe<User_Pp>;
};

/** select columns of table "user_org_id" */
export enum User_Org_Id_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  UserPp = 'user_pp'
}

/** Many-to-many relations beteewn users and organizations/Abtreilungs. */
export type User_Org_Id = {
  /** user_org_id creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** user_org_id creation user. */
  creation_user: Scalars['uuid'];
  /** user_org_id last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified user_org_id. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** Org_id related to user_org_id. */
  org_id: Scalars['smallint'];
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  user_pp: Scalars['uuid'];
};

/** Ordering options when selecting data from "import_list_trigger". */
export type Import_List_Trigger_Order_By = {
  config?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  creationUser?: InputMaybe<User_Pp_Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Declaration_Labels_Order_By>;
  label_id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  lastModifiedUser?: InputMaybe<User_Pp_Order_By>;
  meta?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Table for storing import-list-alert-trigger configurations */
export type Import_List_Trigger = {
  config: Scalars['jsonb'];
  creation_date: Scalars['timestamptz'];
  creation_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  creationUser: Maybe<User_Pp>;
  display_name: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  label: Maybe<Declaration_Labels>;
  label_id: Maybe<Scalars['Int']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  lastModifiedUser: Maybe<User_Pp>;
  meta: Scalars['jsonb'];
  tenant_id: Scalars['uuid'];
  type: Scalars['String'];
};


/** Table for storing import-list-alert-trigger configurations */
export type Import_List_TriggerConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Table for storing import-list-alert-trigger configurations */
export type Import_List_TriggerMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "import_list_trigger" */
export type Import_List_Trigger_Aggregate = {
  aggregate: Maybe<Import_List_Trigger_Aggregate_Fields>;
  nodes: Array<Import_List_Trigger>;
};

/** aggregate fields of "import_list_trigger" */
export type Import_List_Trigger_Aggregate_Fields = {
  avg: Maybe<Import_List_Trigger_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Import_List_Trigger_Max_Fields>;
  min: Maybe<Import_List_Trigger_Min_Fields>;
  stddev: Maybe<Import_List_Trigger_Stddev_Fields>;
  stddev_pop: Maybe<Import_List_Trigger_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Import_List_Trigger_Stddev_Samp_Fields>;
  sum: Maybe<Import_List_Trigger_Sum_Fields>;
  var_pop: Maybe<Import_List_Trigger_Var_Pop_Fields>;
  var_samp: Maybe<Import_List_Trigger_Var_Samp_Fields>;
  variance: Maybe<Import_List_Trigger_Variance_Fields>;
};


/** aggregate fields of "import_list_trigger" */
export type Import_List_Trigger_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Import_List_Trigger_Avg_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Import_List_Trigger_Max_Fields = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  label_id: Maybe<Scalars['Int']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  tenant_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Import_List_Trigger_Min_Fields = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['Int']>;
  label_id: Maybe<Scalars['Int']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  tenant_id: Maybe<Scalars['uuid']>;
  type: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Import_List_Trigger_Stddev_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Import_List_Trigger_Stddev_Pop_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Import_List_Trigger_Stddev_Samp_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Import_List_Trigger_Sum_Fields = {
  id: Maybe<Scalars['Int']>;
  label_id: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Import_List_Trigger_Var_Pop_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Import_List_Trigger_Var_Samp_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Import_List_Trigger_Variance_Fields = {
  id: Maybe<Scalars['Float']>;
  label_id: Maybe<Scalars['Float']>;
};

/** select columns of table "org_id" */
export enum Org_Id_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIdDescription = 'org_id_description',
  /** column name */
  TenantId = 'tenant_id'
}

/** select columns of table "user_pp" */
export enum User_Pp_Select_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LdapEntryDn = 'ldap_entry_dn',
  /** column name */
  Location = 'location',
  /** column name */
  OauthId = 'oauth_id',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UiSettings = 'ui_settings',
  /** column name */
  UiSettingsTemplates = 'ui_settings_templates',
  /** column name */
  UserType = 'user_type'
}

/** columns and relationships of "extraction_config" */
export type Extraction_Config = {
  address_id: Scalars['Int'];
  aliases: Maybe<Scalars['jsonb']>;
  document_templates: Maybe<Scalars['jsonb']>;
  foun_config: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "extraction_config" */
export type Extraction_ConfigAliasesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "extraction_config" */
export type Extraction_ConfigDocument_TemplatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "extraction_config" */
export type Extraction_ConfigFoun_ConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "address_groups" */
export enum Address_Groups_Select_Column {
  /** column name */
  BusinessCase = 'business_case',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  PayerAddress = 'payer_address',
  /** column name */
  PayerName = 'payer_name'
}

/** Ordering options when selecting data from "address_groups". */
export type Address_Groups_Order_By = {
  business_case?: InputMaybe<Order_By>;
  group_id?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  payer_address?: InputMaybe<Order_By>;
  payer_name?: InputMaybe<Order_By>;
  payerAddress?: InputMaybe<Address_Order_By>;
};

/** Boolean expression to filter rows from the table "address_groups". All fields are combined with a logical 'AND'. */
export type Address_Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Groups_Bool_Exp>>;
  _not?: InputMaybe<Address_Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Groups_Bool_Exp>>;
  business_case?: InputMaybe<Bc_Name_Comparison_Exp>;
  group_id?: InputMaybe<Smallint_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  payer_address?: InputMaybe<Int_Comparison_Exp>;
  payer_name?: InputMaybe<String_Comparison_Exp>;
  payerAddress?: InputMaybe<Address_Bool_Exp>;
};

/** Boolean expression to compare columns of type "bc_name". All fields are combined with logical 'AND'. */
export type Bc_Name_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bc_name']>;
  _gt?: InputMaybe<Scalars['bc_name']>;
  _gte?: InputMaybe<Scalars['bc_name']>;
  _in?: InputMaybe<Array<Scalars['bc_name']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bc_name']>;
  _lte?: InputMaybe<Scalars['bc_name']>;
  _neq?: InputMaybe<Scalars['bc_name']>;
  _nin?: InputMaybe<Array<Scalars['bc_name']>>;
};

/** columns and relationships of "address_groups" */
export type Address_Groups = {
  business_case: Maybe<Scalars['bc_name']>;
  group_id: Scalars['smallint'];
  group_name: Maybe<Scalars['String']>;
  payer_address: Maybe<Scalars['Int']>;
  payer_name: Maybe<Scalars['String']>;
  /** An object relationship */
  payerAddress: Maybe<Address>;
};

/** select columns of table "address_mapping" */
export enum Address_Mapping_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressOverrideId = 'address_override_id',
  /** column name */
  IsCrossAddress = 'is_cross_address',
  /** column name */
  TenantId = 'tenant_id'
}

/** Ordering options when selecting data from "address_mapping". */
export type Address_Mapping_Order_By = {
  address_id?: InputMaybe<Order_By>;
  address_override_id?: InputMaybe<Order_By>;
  is_cross_address?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address_mapping". All fields are combined with a logical 'AND'. */
export type Address_Mapping_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Mapping_Bool_Exp>>;
  _not?: InputMaybe<Address_Mapping_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Mapping_Bool_Exp>>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_override_id?: InputMaybe<Int_Comparison_Exp>;
  is_cross_address?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "address_mapping" */
export type Address_Mapping = {
  address_id: Scalars['Int'];
  address_override_id: Scalars['Int'];
  is_cross_address: Scalars['Boolean'];
  tenant_id: Scalars['uuid'];
};

/** select columns of table "address_override" */
export enum Address_Override_Select_Column {
  /** column name */
  AddressType = 'address_type',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** Ordering options when selecting data from "address_override". */
export type Address_Override_Order_By = {
  address_type?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  contact_website?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  vat_number?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "address_override". All fields are combined with a logical 'AND'. */
export type Address_Override_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Override_Bool_Exp>>;
  _not?: InputMaybe<Address_Override_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Override_Bool_Exp>>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  contact_website?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  vat_number?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "address_override" */
export type Address_Override = {
  address_type: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  company_name: Scalars['String'];
  contact_email: Maybe<Scalars['String']>;
  contact_phone: Maybe<Scalars['String']>;
  contact_website: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Scalars['uuid'];
  id: Scalars['Int'];
  is_deleted: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  payer_id: Maybe<Scalars['uuid']>;
  reference: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  street_number: Maybe<Scalars['String']>;
  vat_number: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** columns and relationships of "address_override" */
export type Address_OverrideMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "address_type" */
export enum Address_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Translation = 'translation'
}

/** select columns of table "addresses" */
export enum Addresses_Select_Column {
  /** column name */
  AddressType = 'address_type',
  /** column name */
  AddressTypes = 'address_types',
  /** column name */
  AoId = 'ao_id',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsAccountNumber = 'customs_account_number',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Qty = 'qty',
  /** column name */
  Reference = 'reference',
  /** column name */
  Source = 'source',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VatAccountNumber = 'vat_account_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** Ordering options when selecting data from "addresses". */
export type Addresses_Order_By = {
  address_type?: InputMaybe<Order_By>;
  address_types?: InputMaybe<Order_By>;
  addressType?: InputMaybe<Address_Type_Order_By>;
  ao_id?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  contact_website?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_account_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenant_Order_By>;
  vat_account_number?: InputMaybe<Order_By>;
  vat_number?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Addresses_Bool_Exp>>;
  _not?: InputMaybe<Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Addresses_Bool_Exp>>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  address_types?: InputMaybe<_Int4_Comparison_Exp>;
  addressType?: InputMaybe<Address_Type_Bool_Exp>;
  ao_id?: InputMaybe<Int_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  contact_website?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_account_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenant_Bool_Exp>;
  vat_account_number?: InputMaybe<String_Comparison_Exp>;
  vat_number?: InputMaybe<String_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** View that used as SETOF type for pp_addresses() */
export type Addresses = {
  address_type: Maybe<Scalars['Int']>;
  address_types: Maybe<Scalars['_int4']>;
  /** An object relationship */
  addressType: Maybe<Address_Type>;
  ao_id: Maybe<Scalars['Int']>;
  city: Maybe<Scalars['String']>;
  company_name: Scalars['String'];
  contact_email: Maybe<Scalars['String']>;
  contact_phone: Maybe<Scalars['String']>;
  contact_website: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Scalars['uuid'];
  customs_account_number: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  qty: Maybe<Scalars['bigint']>;
  reference: Maybe<Scalars['String']>;
  source: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  street_number: Maybe<Scalars['String']>;
  /** An object relationship */
  tenant: Maybe<Tenant>;
  vat_account_number: Maybe<Scalars['String']>;
  vat_number: Maybe<Scalars['String']>;
  zipcode: Maybe<Scalars['String']>;
};


/** View that used as SETOF type for pp_addresses() */
export type AddressesMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "ai_stats_dt_type" */
export enum Ai_Stats_Dt_Type_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DocsQty = 'docs_qty',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  PagesQty = 'pages_qty',
  /** column name */
  SuccessRatio = 'success_ratio',
  /** column name */
  TypesMatch = 'types_match',
  /** column name */
  Unknowns = 'unknowns',
  /** column name */
  UnknownsPct = 'unknowns_pct'
}

/** Ordering options when selecting data from "ai_stats_dt_type". */
export type Ai_Stats_Dt_Type_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  docs_qty?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  pages_qty?: InputMaybe<Order_By>;
  success_ratio?: InputMaybe<Order_By>;
  types_match?: InputMaybe<Order_By>;
  unknowns?: InputMaybe<Order_By>;
  unknowns_pct?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai_stats_dt_type". All fields are combined with a logical 'AND'. */
export type Ai_Stats_Dt_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Stats_Dt_Type_Bool_Exp>>;
  _not?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Stats_Dt_Type_Bool_Exp>>;
  creation_date?: InputMaybe<Date_Comparison_Exp>;
  docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  pages_qty?: InputMaybe<Bigint_Comparison_Exp>;
  success_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  types_match?: InputMaybe<Numeric_Comparison_Exp>;
  unknowns?: InputMaybe<Numeric_Comparison_Exp>;
  unknowns_pct?: InputMaybe<Numeric_Comparison_Exp>;
};

/** SETOF-type for pp_ai_stats_dt. */
export type Ai_Stats_Dt_Type = {
  creation_date: Maybe<Scalars['date']>;
  docs_qty: Maybe<Scalars['bigint']>;
  document_type: Maybe<Scalars['String']>;
  /** An object relationship */
  documentType: Maybe<Document_Type>;
  pages_qty: Maybe<Scalars['bigint']>;
  success_ratio: Maybe<Scalars['numeric']>;
  types_match: Maybe<Scalars['numeric']>;
  unknowns: Maybe<Scalars['numeric']>;
  unknowns_pct: Maybe<Scalars['numeric']>;
};

/** select columns of table "ai_stats_type" */
export enum Ai_Stats_Type_Select_Column {
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  SuccessRatio = 'success_ratio',
  /** column name */
  Total = 'total',
  /** column name */
  TypesMatch = 'types_match',
  /** column name */
  Unknowns = 'unknowns',
  /** column name */
  UnknownsPct = 'unknowns_pct'
}

/** Ordering options when selecting data from "ai_stats_type". */
export type Ai_Stats_Type_Order_By = {
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  success_ratio?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  types_match?: InputMaybe<Order_By>;
  unknowns?: InputMaybe<Order_By>;
  unknowns_pct?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ai_stats_type". All fields are combined with a logical 'AND'. */
export type Ai_Stats_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ai_Stats_Type_Bool_Exp>>;
  _not?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ai_Stats_Type_Bool_Exp>>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  success_ratio?: InputMaybe<Numeric_Comparison_Exp>;
  total?: InputMaybe<Bigint_Comparison_Exp>;
  types_match?: InputMaybe<Numeric_Comparison_Exp>;
  unknowns?: InputMaybe<Numeric_Comparison_Exp>;
  unknowns_pct?: InputMaybe<Numeric_Comparison_Exp>;
};

/** SETOF-type used in pp_ai_stats. */
export type Ai_Stats_Type = {
  document_type: Maybe<Scalars['String']>;
  /** An object relationship */
  documentType: Maybe<Document_Type>;
  success_ratio: Maybe<Scalars['numeric']>;
  total: Maybe<Scalars['bigint']>;
  types_match: Maybe<Scalars['numeric']>;
  unknowns: Maybe<Scalars['numeric']>;
  unknowns_pct: Maybe<Scalars['numeric']>;
};

/** select columns of table "annotation_provider" */
export enum Annotation_Provider_Select_Column {
  /** column name */
  AnnotationProvider = 'annotation_provider',
  /** column name */
  AnnotationProviderId = 'annotation_provider_id'
}

/** select columns of table "arrival_type" */
export enum Arrival_Type_Select_Column {
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Description = 'description',
  /** column name */
  Meta = 'meta'
}

/** select columns of table "bill" */
export enum Bill_Select_Column {
  /** column name */
  BillId = 'bill_id',
  /** column name */
  BillType = 'bill_type',
  /** column name */
  FromTs = 'from_ts',
  /** column name */
  Meta = 'meta',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ToTs = 'to_ts'
}

/** aggregated selection of "bill" */
export type Bill_Aggregate = {
  aggregate: Maybe<Bill_Aggregate_Fields>;
  nodes: Array<Bill>;
};

/** aggregate fields of "bill" */
export type Bill_Aggregate_Fields = {
  avg: Maybe<Bill_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Bill_Max_Fields>;
  min: Maybe<Bill_Min_Fields>;
  stddev: Maybe<Bill_Stddev_Fields>;
  stddev_pop: Maybe<Bill_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Bill_Stddev_Samp_Fields>;
  sum: Maybe<Bill_Sum_Fields>;
  var_pop: Maybe<Bill_Var_Pop_Fields>;
  var_samp: Maybe<Bill_Var_Samp_Fields>;
  variance: Maybe<Bill_Variance_Fields>;
};


/** aggregate fields of "bill" */
export type Bill_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bill_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Bill_Avg_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Bill_Max_Fields = {
  bill_id: Maybe<Scalars['bigint']>;
  from_ts: Maybe<Scalars['timestamptz']>;
  payment_terms: Maybe<Scalars['smallint']>;
  tenant_id: Maybe<Scalars['uuid']>;
  to_ts: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Bill_Min_Fields = {
  bill_id: Maybe<Scalars['bigint']>;
  from_ts: Maybe<Scalars['timestamptz']>;
  payment_terms: Maybe<Scalars['smallint']>;
  tenant_id: Maybe<Scalars['uuid']>;
  to_ts: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Bill_Stddev_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Bill_Stddev_Pop_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Bill_Stddev_Samp_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Bill_Sum_Fields = {
  bill_id: Maybe<Scalars['bigint']>;
  payment_terms: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type Bill_Var_Pop_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Bill_Var_Samp_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Bill_Variance_Fields = {
  bill_id: Maybe<Scalars['Float']>;
  payment_terms: Maybe<Scalars['Float']>;
};

/** select columns of table "clearance_type" */
export enum Clearance_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** select columns of table "count_type" */
export enum Count_Type_Select_Column {
  /** column name */
  Count = 'count'
}

/** Ordering options when selecting data from "count_type". */
export type Count_Type_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "count_type". All fields are combined with a logical 'AND'. */
export type Count_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Count_Type_Bool_Exp>>;
  _not?: InputMaybe<Count_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Count_Type_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** This view created for using functions as  'RETURNS  SETOF count_type'   */
export type Count_Type = {
  count: Maybe<Scalars['bigint']>;
};

/** select columns of table "customs_office" */
export enum Customs_Office_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeNumber = 'office_number',
  /** column name */
  Prefix = 'prefix',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** Ordering options when selecting data from "customs_office". */
export type Customs_Office_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  office_number?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customs_office". All fields are combined with a logical 'AND'. */
export type Customs_Office_Bool_Exp = {
  _and?: InputMaybe<Array<Customs_Office_Bool_Exp>>;
  _not?: InputMaybe<Customs_Office_Bool_Exp>;
  _or?: InputMaybe<Array<Customs_Office_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  office_number?: InputMaybe<String_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_to?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "customs_office" */
export type Customs_Office = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  office_number: Scalars['String'];
  prefix: Maybe<Scalars['String']>;
  valid_from: Scalars['timestamptz'];
  valid_to: Maybe<Scalars['timestamptz']>;
};

/** select columns of table "customs_offices" */
export enum Customs_Offices_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeNumber = 'office_number',
  /** column name */
  Prefix = 'prefix',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to'
}

/** select columns of table "declaration" */
export enum Declaration_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccessCode = 'access_code',
  /** column name */
  AgreedLocationOfGoods = 'agreed_location_of_goods',
  /** column name */
  AiConfirmed = 'ai_confirmed',
  /** column name */
  AiResults = 'ai_results',
  /** column name */
  BorderEauNumber = 'border_eau_number',
  /** column name */
  BunchNumber = 'bunch_number',
  /** column name */
  ChangeInformation = 'change_information',
  /** column name */
  ClearanceLocation = 'clearance_location',
  /** column name */
  CompanyNumberTaxpayer = 'company_number_taxpayer',
  /** column name */
  CorrectionCode = 'correction_code',
  /** column name */
  CorrectionReason = 'correction_reason',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsAccountAddressType = 'customs_account_address_type',
  /** column name */
  CustomsAccountName = 'customs_account_name',
  /** column name */
  CustomsAccountNumber = 'customs_account_number',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsOfficeNumber = 'customs_office_number',
  /** column name */
  DeclarantCompanyName = 'declarant_company_name',
  /** column name */
  DeclarantNumber = 'declarant_number',
  /** column name */
  DeclarationTime = 'declaration_time',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DeliveryDestination = 'delivery_destination',
  /** column name */
  DispatchCountry = 'dispatch_country',
  /** column name */
  DispatchCountryConfirmation = 'dispatch_country_confirmation',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndOtherTaxesAmount = 'duty_and_other_taxes_amount',
  /** column name */
  DutyTotalAmount = 'duty_total_amount',
  /** column name */
  EvvConfirmed = 'evv_confirmed',
  /** column name */
  EvvReceived = 'evv_received',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  Incoterms = 'incoterms',
  /** column name */
  Initiator = 'initiator',
  /** column name */
  InjunctionType = 'injunction_type',
  /** column name */
  InspectionCode = 'inspection_code',
  /** column name */
  InvoiceCurrencyType = 'invoice_currency_type',
  /** column name */
  Lang = 'lang',
  /** column name */
  MaterialCheck = 'material_check',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PlaceOfLoading = 'place_of_loading',
  /** column name */
  PlaceOfUnloading = 'place_of_unloading',
  /** column name */
  PostalShipmentType = 'postal_shipment_type',
  /** column name */
  ProcedureType = 'procedure_type',
  /** column name */
  ProvisionalDeclarationExpirationDate = 'provisional_declaration_expiration_date',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReceiveStatus = 'receive_status',
  /** column name */
  Release = 'release',
  /** column name */
  RequestorTraderIdentificationNumber = 'requestor_trader_identification_number',
  /** column name */
  Security = 'security',
  /** column name */
  SelectionCorrelationId = 'selection_correlation_id',
  /** column name */
  SendDate = 'send_date',
  /** column name */
  SendStatus = 'send_status',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  ShowInWd = 'show_in_wd',
  /** column name */
  SpecificCircumstanceIndicator = 'specific_circumstance_indicator',
  /** column name */
  Status = 'status',
  /** column name */
  StatusDate = 'status_date',
  /** column name */
  StatusTime = 'status_time',
  /** column name */
  TaraFactor = 'tara_factor',
  /** column name */
  TotalColis = 'total_colis',
  /** column name */
  TotalGoodsItems = 'total_goods_items',
  /** column name */
  TotalGrossWeight = 'total_gross_weight',
  /** column name */
  TotalVatValue = 'total_vat_value',
  /** column name */
  TraderDeclarationNumber = 'trader_declaration_number',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransferToTransitSystem = 'transfer_to_transit_system',
  /** column name */
  TransportCountry = 'transport_country',
  /** column name */
  TransportInContainer = 'transport_in_container',
  /** column name */
  TransportMode = 'transport_mode',
  /** column name */
  TransportNumber = 'transport_number',
  /** column name */
  TransportType = 'transport_type',
  /** column name */
  UniqueConsignmentReferenceNumber = 'unique_consignment_reference_number',
  /** column name */
  VatAccountAddressType = 'vat_account_address_type',
  /** column name */
  VatAccountName = 'vat_account_name',
  /** column name */
  VatAccountNumber = 'vat_account_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  VatSuffix = 'vat_suffix',
  /** column name */
  VatTotalAmount = 'vat_total_amount',
  /** column name */
  WarehouseCoded = 'warehouse_coded'
}

/** select columns of table "declaration_discussions" */
export enum Declaration_Discussions_Select_Column {
  /** column name */
  Closed = 'closed',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  DiscussionTheme = 'discussion_theme',
  /** column name */
  FileId = 'file_id',
  /** column name */
  LastReadDate = 'last_read_date',
  /** column name */
  LiberUser = 'liber_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Reference = 'reference'
}

/** Ordering options when selecting data from "declaration_discussions". */
export type Declaration_Discussions_Order_By = {
  closed?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  discussion_theme?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  last_read_date?: InputMaybe<Order_By>;
  liber_user?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Order_By>;
  meta?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_discussions". All fields are combined with a logical 'AND'. */
export type Declaration_Discussions_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Discussions_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Discussions_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Discussions_Bool_Exp>>;
  closed?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  discussion_id?: InputMaybe<Bigint_Comparison_Exp>;
  discussion_theme?: InputMaybe<String_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  last_read_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  liber_user?: InputMaybe<String_Comparison_Exp>;
  messages?: InputMaybe<Declaration_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Bool_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
};

/** Discussions related to files/declarations. Prefer use this view instead of this table. */
export type Declaration_Discussions = {
  closed: Maybe<Scalars['Boolean']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  discussion_id: Maybe<Scalars['bigint']>;
  discussion_theme: Maybe<Scalars['String']>;
  file_id: Maybe<Scalars['uuid']>;
  last_read_date: Maybe<Scalars['timestamptz']>;
  liber_user: Maybe<Scalars['String']>;
  /** An array relationship */
  messages: Array<Declaration_Message>;
  /** An aggregate relationship */
  messages_aggregate: Declaration_Message_Aggregate;
  meta: Maybe<Scalars['jsonb']>;
  reference: Maybe<Scalars['String']>;
};


/** Discussions related to files/declarations. Prefer use this view instead of this table. */
export type Declaration_DiscussionsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** Discussions related to files/declarations. Prefer use this view instead of this table. */
export type Declaration_DiscussionsMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** Discussions related to files/declarations. Prefer use this view instead of this table. */
export type Declaration_DiscussionsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_request_address_ai" */
export enum Declaration_Request_Address_Ai_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id'
}

/** Ordering options when selecting data from "declaration_request_address_ai". */
export type Declaration_Request_Address_Ai_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_request_address_ai". All fields are combined with a logical 'AND'. */
export type Declaration_Request_Address_Ai_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Request_Address_Ai_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Request_Address_Ai_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Request_Address_Ai_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_type?: InputMaybe<Int_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "declaration_request_address_ai" */
export type Declaration_Request_Address_Ai = {
  /** An object relationship */
  address: Maybe<Address>;
  address_id: Scalars['Int'];
  address_type: Scalars['Int'];
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  id: Scalars['Int'];
};

/** select columns of table "declaration_requests" */
export enum Declaration_Requests_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  AutoclassifiedDocsQty = 'autoclassified_docs_qty',
  /** column name */
  ChExpDecl = 'ch_exp_decl',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DestTolldeptCode = 'dest_tolldept_code',
  /** column name */
  DestTolldeptName = 'dest_tolldept_name',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  ImpCustClr = 'imp_cust_clr',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Meta = 'meta',
  /** column name */
  NonclassifiedDocsExists = 'nonclassified_docs_exists',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PermissionsJs = 'permissions_js',
  /** column name */
  Qty = 'qty',
  /** column name */
  Reference = 'reference',
  /** column name */
  RowNumber = 'row_number',
  /** column name */
  TollDep = 'toll_dep',
  /** column name */
  TrNo = 'tr_no',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransitdocType = 'transitdoc_type',
  /** column name */
  WaNumber = 'wa_number'
}

/** Ordering options when selecting data from "declaration_requests". */
export type Declaration_Requests_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  autoclassified_docs_qty?: InputMaybe<Order_By>;
  ch_exp_decl?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customsOffice?: InputMaybe<Customs_Offices_Order_By>;
  declaration_discussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Order_By>;
  declaration_labels_aggregate?: InputMaybe<Declaration_Request_Labels_Aggregate_Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  dest_tolldept_code?: InputMaybe<Order_By>;
  dest_tolldept_name?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  imp_cust_clr?: InputMaybe<Order_By>;
  is_express?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  nonclassified_docs_exists?: InputMaybe<Order_By>;
  payer?: InputMaybe<Tenant_Order_By>;
  payer_id?: InputMaybe<Order_By>;
  permissions_js?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  row_number?: InputMaybe<Order_By>;
  toll_dep?: InputMaybe<Order_By>;
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  transitdoc_type?: InputMaybe<Order_By>;
  user_pp?: InputMaybe<User_Pp_Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_requests". All fields are combined with a logical 'AND'. */
export type Declaration_Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Requests_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Requests_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  arrival_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  autoclassified_docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  ch_exp_decl?: InputMaybe<Boolean_Comparison_Exp>;
  clearance_type?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_declaration_number?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Smallint_Comparison_Exp>;
  customsOffice?: InputMaybe<Customs_Offices_Bool_Exp>;
  declaration_discussions?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  declaration_discussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp>;
  declaration_labels?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  dest_tolldept_code?: InputMaybe<String_Comparison_Exp>;
  dest_tolldept_name?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  eta?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  imp_cust_clr?: InputMaybe<Boolean_Comparison_Exp>;
  is_express?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  nonclassified_docs_exists?: InputMaybe<Boolean_Comparison_Exp>;
  payer?: InputMaybe<Tenant_Bool_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  permissions_js?: InputMaybe<Json_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  row_number?: InputMaybe<Bigint_Comparison_Exp>;
  toll_dep?: InputMaybe<String_Comparison_Exp>;
  tr_no?: InputMaybe<String_Comparison_Exp>;
  trader_reference?: InputMaybe<String_Comparison_Exp>;
  transitdoc_type?: InputMaybe<Transitdoc_Type_Comparison_Exp>;
  user_pp?: InputMaybe<User_Pp_Bool_Exp>;
  wa_number?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "declaration_requests" */
export type Declaration_Requests = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  account_number: Maybe<Scalars['String']>;
  /** An array relationship */
  addresses: Array<Declaration_Request_Address>;
  arrival_time: Maybe<Scalars['timestamptz']>;
  arrival_type: Maybe<Scalars['String']>;
  autoclassified_docs_qty: Maybe<Scalars['bigint']>;
  ch_exp_decl: Maybe<Scalars['Boolean']>;
  clearance_type: Scalars['String'];
  creation_date: Scalars['timestamptz'];
  creation_user: Scalars['uuid'];
  customs_declaration_number: Maybe<Scalars['String']>;
  customs_declaration_version: Maybe<Scalars['smallint']>;
  /** An object relationship */
  customsOffice: Maybe<Customs_Offices>;
  /** An array relationship */
  declaration_discussions: Array<Declaration_Discussion>;
  /** An aggregate relationship */
  declaration_discussions_aggregate: Declaration_Discussion_Aggregate;
  /** An array relationship */
  declaration_labels: Array<Declaration_Request_Labels>;
  declaration_status: Scalars['String'];
  declaration_type: Scalars['String'];
  dest_tolldept_code: Maybe<Scalars['String']>;
  dest_tolldept_name: Maybe<Scalars['String']>;
  dr_no: Scalars['smallint'];
  eta: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: Maybe<File>;
  file_id: Scalars['uuid'];
  imp_cust_clr: Maybe<Scalars['Boolean']>;
  is_express: Scalars['Boolean'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  meta: Scalars['jsonb'];
  nonclassified_docs_exists: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  payer: Maybe<Tenant>;
  payer_id: Scalars['uuid'];
  permissions_js: Maybe<Scalars['json']>;
  qty: Maybe<Scalars['bigint']>;
  reference: Maybe<Scalars['String']>;
  row_number: Maybe<Scalars['bigint']>;
  toll_dep: Maybe<Scalars['String']>;
  tr_no: Maybe<Scalars['String']>;
  trader_reference: Maybe<Scalars['String']>;
  transitdoc_type: Maybe<Scalars['transitdoc_type']>;
  /** An object relationship */
  user_pp: Maybe<User_Pp>;
  wa_number: Maybe<Scalars['String']>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsAddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsDeclaration_DiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsDeclaration_Discussions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsDeclaration_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "declaration_requests" */
export type Declaration_RequestsPermissions_JsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_search" */
export enum Declaration_Search_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  AutoclassifiedDocsQty = 'autoclassified_docs_qty',
  /** column name */
  ClassifiedDocsQty = 'classified_docs_qty',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DocsQty = 'docs_qty',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Identification = 'identification',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  NonclassifiedDocsExists = 'nonclassified_docs_exists',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  Reference = 'reference',
  /** column name */
  UserDisplayName = 'user_display_name',
  /** column name */
  WaNumber = 'wa_number'
}

/** Ordering options when selecting data from "declaration_search". */
export type Declaration_Search_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  addresses_aggregate?: InputMaybe<Declaration_Request_Address_Aggregate_Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  arrivalType?: InputMaybe<Arrival_Type_Order_By>;
  autoclassified_docs_qty?: InputMaybe<Order_By>;
  classified_docs_qty?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  declarationDiscussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Order_By>;
  docs_qty?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  file_id?: InputMaybe<Order_By>;
  identification?: InputMaybe<Order_By>;
  is_express?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  nonclassified_docs_exists?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
  user_display_name?: InputMaybe<Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_search". All fields are combined with a logical 'AND'. */
export type Declaration_Search_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Search_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Search_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Search_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  addresses?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
  arrival_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  arrivalType?: InputMaybe<Arrival_Type_Bool_Exp>;
  autoclassified_docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  classified_docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  clearance_type?: InputMaybe<String_Comparison_Exp>;
  company_id?: InputMaybe<Int_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  declarationDiscussions?: InputMaybe<Declaration_Discussion_Bool_Exp>;
  declarationDiscussions_aggregate?: InputMaybe<Declaration_Discussion_Aggregate_Bool_Exp>;
  docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  eta?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  identification?: InputMaybe<String_Comparison_Exp>;
  is_express?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  nonclassified_docs_exists?: InputMaybe<Boolean_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
  user_display_name?: InputMaybe<String_Comparison_Exp>;
  wa_number?: InputMaybe<String_Comparison_Exp>;
};

/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_Search = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  addresses: Array<Declaration_Request_Address>;
  arrival_time: Maybe<Scalars['timestamptz']>;
  arrival_type: Maybe<Scalars['String']>;
  /** An object relationship */
  arrivalType: Maybe<Arrival_Type>;
  autoclassified_docs_qty: Maybe<Scalars['bigint']>;
  classified_docs_qty: Maybe<Scalars['bigint']>;
  clearance_type: Scalars['String'];
  company_id: Maybe<Scalars['Int']>;
  company_name: Maybe<Scalars['String']>;
  creation_date: Scalars['timestamptz'];
  creation_user: Scalars['uuid'];
  declaration_status: Scalars['String'];
  declaration_type: Scalars['String'];
  /** An array relationship */
  declarationDiscussions: Array<Declaration_Discussion>;
  /** An aggregate relationship */
  declarationDiscussions_aggregate: Declaration_Discussion_Aggregate;
  docs_qty: Maybe<Scalars['bigint']>;
  dr_no: Scalars['smallint'];
  eta: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: Maybe<File>;
  file_id: Scalars['uuid'];
  identification: Maybe<Scalars['String']>;
  is_express: Scalars['Boolean'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  nonclassified_docs_exists: Maybe<Scalars['Boolean']>;
  org_id: Maybe<Scalars['smallint']>;
  qty: Maybe<Scalars['bigint']>;
  reference: Maybe<Scalars['String']>;
  /** An object relationship */
  user: Maybe<User_Pp>;
  user_display_name: Maybe<Scalars['String']>;
  wa_number: Maybe<Scalars['String']>;
};


/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_SearchAddressesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_SearchDeclarationDiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


/** View that used as return type `SETOF` for [pp_declarations](DB/functions/pp_declarations). By itself - not very useful */
export type Declaration_SearchDeclarationDiscussions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};

/** select columns of table "declaration_status" */
export enum Declaration_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** select columns of table "declaration_tasks" */
export enum Declaration_Tasks_Select_Column {
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ObjectId = 'object_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  Rn = 'rn',
  /** column name */
  TaskStatusId = 'task_status_id',
  /** column name */
  TaskTypeId = 'task_type_id',
  /** column name */
  Title = 'title'
}

/** Ordering options when selecting data from "declaration_tasks". */
export type Declaration_Tasks_Order_By = {
  assigned_to?: InputMaybe<Order_By>;
  assigned_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  due_date?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  object_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  rn?: InputMaybe<Order_By>;
  task_status_id?: InputMaybe<Order_By>;
  task_type?: InputMaybe<Task_Type_Order_By>;
  task_type_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_tasks". All fields are combined with a logical 'AND'. */
export type Declaration_Tasks_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Tasks_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Tasks_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Tasks_Bool_Exp>>;
  assigned_to?: InputMaybe<Uuid_Comparison_Exp>;
  assigned_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  object_id?: InputMaybe<Uuid_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  rn?: InputMaybe<Bigint_Comparison_Exp>;
  task_status_id?: InputMaybe<Int_Comparison_Exp>;
  task_type?: InputMaybe<Task_Type_Bool_Exp>;
  task_type_id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "declaration_tasks" */
export type Declaration_Tasks = {
  assigned_to: Maybe<Scalars['uuid']>;
  /** An object relationship */
  assigned_user: Maybe<User_Pp>;
  creation_date: Scalars['timestamptz'];
  /** An object relationship */
  document: Maybe<Document>;
  due_date: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  file: Maybe<File>;
  id: Scalars['Int'];
  meta: Scalars['jsonb'];
  object_id: Scalars['uuid'];
  qty: Maybe<Scalars['bigint']>;
  rn: Maybe<Scalars['bigint']>;
  task_status_id: Scalars['Int'];
  /** An object relationship */
  task_type: Maybe<Task_Type>;
  task_type_id: Scalars['Int'];
  title: Scalars['String'];
};


/** columns and relationships of "declaration_tasks" */
export type Declaration_TasksMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "declaration_tasks_obj" */
export enum Declaration_Tasks_Obj_Select_Column {
  /** column name */
  Tasks = 'tasks',
  /** column name */
  TotalFinished = 'total_finished',
  /** column name */
  TotalOpened = 'total_opened'
}

/** Ordering options when selecting data from "declaration_tasks_obj". */
export type Declaration_Tasks_Obj_Order_By = {
  tasks?: InputMaybe<Order_By>;
  total_finished?: InputMaybe<Order_By>;
  total_opened?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "declaration_tasks_obj". All fields are combined with a logical 'AND'. */
export type Declaration_Tasks_Obj_Bool_Exp = {
  _and?: InputMaybe<Array<Declaration_Tasks_Obj_Bool_Exp>>;
  _not?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
  _or?: InputMaybe<Array<Declaration_Tasks_Obj_Bool_Exp>>;
  tasks?: InputMaybe<_Declaration_Tasks_Data_Comparison_Exp>;
  total_finished?: InputMaybe<Bigint_Comparison_Exp>;
  total_opened?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_declaration_tasks_data". All fields are combined with logical 'AND'. */
export type _Declaration_Tasks_Data_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _gt?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _gte?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _in?: InputMaybe<Array<Scalars['_declaration_tasks_data']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _lte?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _neq?: InputMaybe<Scalars['_declaration_tasks_data']>;
  _nin?: InputMaybe<Array<Scalars['_declaration_tasks_data']>>;
};

/** columns and relationships of "declaration_tasks_obj" */
export type Declaration_Tasks_Obj = {
  tasks: Maybe<Scalars['_declaration_tasks_data']>;
  total_finished: Maybe<Scalars['bigint']>;
  total_opened: Maybe<Scalars['bigint']>;
};

/** select columns of table "declaration_type" */
export enum Declaration_Type_Select_Column {
  /** column name */
  DocumentSchema = 'document_schema',
  /** column name */
  Name = 'name'
}

/** select columns of table "discussion_changes" */
export enum Discussion_Changes_Select_Column {
  /** column name */
  AditUser = 'adit_user',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DiscussionClosed = 'discussion_closed',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  DiscussionTheme = 'discussion_theme',
  /** column name */
  FileId = 'file_id',
  /** column name */
  FileName = 'file_name',
  /** column name */
  LastMsgDate = 'last_msg_date',
  /** column name */
  LastUser = 'last_user',
  /** column name */
  LiberUser = 'liber_user',
  /** column name */
  Reference = 'reference'
}

/** Ordering options when selecting data from "discussion_changes". */
export type Discussion_Changes_Order_By = {
  adit_user?: InputMaybe<Order_By>;
  aditUser?: InputMaybe<User_Pp_Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  discussion_closed?: InputMaybe<Order_By>;
  discussion_id?: InputMaybe<Order_By>;
  discussion_theme?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  last_msg_date?: InputMaybe<Order_By>;
  last_user?: InputMaybe<Order_By>;
  liber_user?: InputMaybe<Order_By>;
  liberUser?: InputMaybe<User_Pp_Order_By>;
  messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Order_By>;
  reference?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "discussion_changes". All fields are combined with a logical 'AND'. */
export type Discussion_Changes_Bool_Exp = {
  _and?: InputMaybe<Array<Discussion_Changes_Bool_Exp>>;
  _not?: InputMaybe<Discussion_Changes_Bool_Exp>;
  _or?: InputMaybe<Array<Discussion_Changes_Bool_Exp>>;
  adit_user?: InputMaybe<Uuid_Comparison_Exp>;
  aditUser?: InputMaybe<User_Pp_Bool_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  discussion_closed?: InputMaybe<Boolean_Comparison_Exp>;
  discussion_id?: InputMaybe<Bigint_Comparison_Exp>;
  discussion_theme?: InputMaybe<String_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  last_msg_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_user?: InputMaybe<Uuid_Comparison_Exp>;
  liber_user?: InputMaybe<Uuid_Comparison_Exp>;
  liberUser?: InputMaybe<User_Pp_Bool_Exp>;
  messages?: InputMaybe<Declaration_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Declaration_Message_Aggregate_Bool_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
};

/** View that detects changes in declaration discussions. */
export type Discussion_Changes = {
  adit_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  aditUser: Maybe<User_Pp>;
  declaration_status: Maybe<Scalars['String']>;
  discussion_closed: Maybe<Scalars['Boolean']>;
  discussion_id: Maybe<Scalars['bigint']>;
  discussion_theme: Maybe<Scalars['String']>;
  file_id: Maybe<Scalars['uuid']>;
  file_name: Maybe<Scalars['String']>;
  last_msg_date: Maybe<Scalars['timestamptz']>;
  last_user: Maybe<Scalars['uuid']>;
  liber_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  liberUser: Maybe<User_Pp>;
  /** An array relationship */
  messages: Array<Declaration_Message>;
  /** An aggregate relationship */
  messages_aggregate: Declaration_Message_Aggregate;
  reference: Maybe<Scalars['String']>;
};


/** View that detects changes in declaration discussions. */
export type Discussion_ChangesMessagesArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


/** View that detects changes in declaration discussions. */
export type Discussion_ChangesMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};

/** select columns of table "doc_search_type" */
export enum Doc_Search_Type_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIdDescription = 'org_id_description',
  /** column name */
  Sequence = 'sequence',
  /** column name */
  TotalRows = 'total_rows',
  /** column name */
  UserCode = 'user_code',
  /** column name */
  UserDisplayName = 'user_display_name'
}

/** Ordering options when selecting data from "doc_search_type". */
export type Doc_Search_Type_Order_By = {
  checksum?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  document_blobs?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_generated?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  number_of_pages?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
  user_code?: InputMaybe<Order_By>;
  user_display_name?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doc_search_type". All fields are combined with a logical 'AND'. */
export type Doc_Search_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Search_Type_Bool_Exp>>;
  _not?: InputMaybe<Doc_Search_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Search_Type_Bool_Exp>>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  document_blobs?: InputMaybe<Jsonb_Comparison_Exp>;
  document_extension?: InputMaybe<String_Comparison_Exp>;
  document_flags?: InputMaybe<Bigint_Comparison_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
  document_status?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_generated?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_pages?: InputMaybe<Smallint_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  org_id_description?: InputMaybe<String_Comparison_Exp>;
  pages_m2m?: InputMaybe<Document_Page_Bool_Exp>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Bool_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
  user_code?: InputMaybe<String_Comparison_Exp>;
  user_display_name?: InputMaybe<String_Comparison_Exp>;
};

/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_Type = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  document_blobs: Maybe<Scalars['jsonb']>;
  document_extension: Maybe<Scalars['String']>;
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  file: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_generated: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  number_of_pages: Maybe<Scalars['smallint']>;
  org_id: Maybe<Scalars['smallint']>;
  org_id_description: Maybe<Scalars['String']>;
  /** An array relationship */
  pages_m2m: Array<Document_Page>;
  /** An aggregate relationship */
  pages_m2m_aggregate: Document_Page_Aggregate;
  sequence: Maybe<Scalars['Int']>;
  total_rows: Maybe<Scalars['bigint']>;
  user_code: Maybe<Scalars['String']>;
  user_display_name: Maybe<Scalars['String']>;
};


/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_TypeDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_TypePages_M2mArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/** SETOF-type from pp_doc_search% functions. */
export type Doc_Search_TypePages_M2m_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};

/** select columns of table "doc_stats_type" */
export enum Doc_Stats_Type_Select_Column {
  /** column name */
  DocsQty = 'docs_qty',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  TotalPages = 'total_pages',
  /** column name */
  UsersQty = 'users_qty'
}

/** Ordering options when selecting data from "doc_stats_type". */
export type Doc_Stats_Type_Order_By = {
  docs_qty?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  total_pages?: InputMaybe<Order_By>;
  users_qty?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "doc_stats_type". All fields are combined with a logical 'AND'. */
export type Doc_Stats_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Stats_Type_Bool_Exp>>;
  _not?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Stats_Type_Bool_Exp>>;
  docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  total_pages?: InputMaybe<Bigint_Comparison_Exp>;
  users_qty?: InputMaybe<Bigint_Comparison_Exp>;
};

/** SETOF-type used used in pp_doc_stats. */
export type Doc_Stats_Type = {
  docs_qty: Maybe<Scalars['bigint']>;
  document_type: Maybe<Scalars['String']>;
  total_pages: Maybe<Scalars['bigint']>;
  users_qty: Maybe<Scalars['bigint']>;
};

/** select columns of table "docs_for_validation" */
export enum Docs_For_Validation_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocOrder = 'doc_order',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Sequence = 'sequence'
}

/** Ordering options when selecting data from "docs_for_validation". */
export type Docs_For_Validation_Order_By = {
  checksum?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  doc_order?: InputMaybe<Order_By>;
  document_blobs?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  file?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_customs_relevant?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_generated?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  number_of_pages?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  sequence?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Boolean expression to filter rows from the table "docs_for_validation". All fields are combined with a logical 'AND'. */
export type Docs_For_Validation_Bool_Exp = {
  _and?: InputMaybe<Array<Docs_For_Validation_Bool_Exp>>;
  _not?: InputMaybe<Docs_For_Validation_Bool_Exp>;
  _or?: InputMaybe<Array<Docs_For_Validation_Bool_Exp>>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  doc_order?: InputMaybe<Bigint_Comparison_Exp>;
  document_blobs?: InputMaybe<Jsonb_Comparison_Exp>;
  document_extension?: InputMaybe<String_Comparison_Exp>;
  document_flags?: InputMaybe<Bigint_Comparison_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
  document_status?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_customs_relevant?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_generated?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_pages?: InputMaybe<Smallint_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/**
 * Documents for validation.
 *
 * Returned in order:
 * - `file`
 * - `document_type`
 * - `sequence`
 *
 *
 */
export type Docs_For_Validation = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  doc_order: Maybe<Scalars['bigint']>;
  document_blobs: Maybe<Scalars['jsonb']>;
  document_extension: Maybe<Scalars['String']>;
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  file: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_generated: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  number_of_pages: Maybe<Scalars['smallint']>;
  org_id: Maybe<Scalars['smallint']>;
  sequence: Maybe<Scalars['Int']>;
  /** An object relationship */
  user: Maybe<User_Pp>;
};


/**
 * Documents for validation.
 *
 * Returned in order:
 * - `file`
 * - `document_type`
 * - `sequence`
 *
 *
 */
export type Docs_For_ValidationDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/**
 * Documents for validation.
 *
 * Returned in order:
 * - `file`
 * - `document_type`
 * - `sequence`
 *
 *
 */
export type Docs_For_ValidationMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_extension" */
export enum Document_Extension_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Name = 'name',
  /** column name */
  ThumbnailsSupported = 'thumbnails_supported'
}

/** select columns of table "document_flag" */
export enum Document_Flag_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Display = 'display',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Translation = 'translation'
}

/** Ordering options when selecting data from "document_flag". */
export type Document_Flag_Order_By = {
  color?: InputMaybe<Order_By>;
  display?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  translation?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "document_flag". All fields are combined with a logical 'AND'. */
export type Document_Flag_Bool_Exp = {
  _and?: InputMaybe<Array<Document_Flag_Bool_Exp>>;
  _not?: InputMaybe<Document_Flag_Bool_Exp>;
  _or?: InputMaybe<Array<Document_Flag_Bool_Exp>>;
  color?: InputMaybe<String_Comparison_Exp>;
  display?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  translation?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Bitmask flag for documents. Use pp_enc_df/pp_dec_df to decode document.document_flags value. */
export type Document_Flag = {
  color: Maybe<Scalars['String']>;
  display: Scalars['Int'];
  /** id of document_flag. */
  id: Scalars['bigint'];
  name: Scalars['String'];
  translation: Scalars['jsonb'];
};


/** Bitmask flag for documents. Use pp_enc_df/pp_dec_df to decode document.document_flags value. */
export type Document_FlagTranslationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "document_status" */
export enum Document_Status_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Name = 'name'
}

/** select columns of table "document_type" */
export enum Document_Type_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Name = 'name',
  /** column name */
  Translations = 'translations'
}

/** aggregated selection of "document_type" */
export type Document_Type_Aggregate = {
  aggregate: Maybe<Document_Type_Aggregate_Fields>;
  nodes: Array<Document_Type>;
};

/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_Fields = {
  count: Scalars['Int'];
  max: Maybe<Document_Type_Max_Fields>;
  min: Maybe<Document_Type_Min_Fields>;
};


/** aggregate fields of "document_type" */
export type Document_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Document_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Document_Type_Max_Fields = {
  /** document_type creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_type creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  /** document_type last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_type. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Document_Type_Min_Fields = {
  /** document_type creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** document_type creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  display_name: Maybe<Scalars['String']>;
  /** document_type last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified document_type. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
};

/** select columns of table "dr_stats" */
export enum Dr_Stats_Select_Column {
  /** column name */
  MetricId = 'metric_id',
  /** column name */
  MetricLabel = 'metric_label',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TenantName = 'tenant_name',
  /** column name */
  Value = 'value'
}

/** Ordering options when selecting data from "dr_stats". */
export type Dr_Stats_Order_By = {
  metric_id?: InputMaybe<Order_By>;
  metric_label?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_name?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "dr_stats". All fields are combined with a logical 'AND'. */
export type Dr_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Dr_Stats_Bool_Exp>>;
  _not?: InputMaybe<Dr_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Dr_Stats_Bool_Exp>>;
  metric_id?: InputMaybe<String_Comparison_Exp>;
  metric_label?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_name?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Numeric_Comparison_Exp>;
};

/** columns and relationships of "dr_stats" */
export type Dr_Stats = {
  metric_id: Maybe<Scalars['String']>;
  metric_label: Maybe<Scalars['String']>;
  tenant_id: Maybe<Scalars['uuid']>;
  tenant_name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['numeric']>;
};

/** select columns of table "edec_countries" */
export enum Edec_Countries_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsoCode = 'iso_code',
  /** column name */
  NameDe = 'name_de',
  /** column name */
  NameEn = 'name_en',
  /** column name */
  NameFr = 'name_fr',
  /** column name */
  NameIt = 'name_it',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_countries". */
export type Edec_Countries_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  iso_code?: InputMaybe<Order_By>;
  name_de?: InputMaybe<Order_By>;
  name_en?: InputMaybe<Order_By>;
  name_fr?: InputMaybe<Order_By>;
  name_it?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_countries". All fields are combined with a logical 'AND'. */
export type Edec_Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Countries_Bool_Exp>>;
  _not?: InputMaybe<Edec_Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Countries_Bool_Exp>>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  iso_code?: InputMaybe<Bpchar_Comparison_Exp>;
  name_de?: InputMaybe<String_Comparison_Exp>;
  name_en?: InputMaybe<String_Comparison_Exp>;
  name_fr?: InputMaybe<String_Comparison_Exp>;
  name_it?: InputMaybe<String_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "edec_countries" */
export type Edec_Countries = {
  created: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  iso_code: Scalars['bpchar'];
  name_de: Maybe<Scalars['String']>;
  name_en: Maybe<Scalars['String']>;
  name_fr: Maybe<Scalars['String']>;
  name_it: Maybe<Scalars['String']>;
  valid_from: Maybe<Scalars['date']>;
  valid_to: Maybe<Scalars['date']>;
  version: Maybe<Scalars['Int']>;
};

/** select columns of table "edec_customs_offices" */
export enum Edec_Customs_Offices_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  City = 'city',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  Name = 'name',
  /** column name */
  Number = 'number',
  /** column name */
  Prefix = 'prefix',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_customs_offices". */
export type Edec_Customs_Offices_Order_By = {
  address?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_customs_offices". All fields are combined with a logical 'AND'. */
export type Edec_Customs_Offices_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Customs_Offices_Bool_Exp>>;
  _not?: InputMaybe<Edec_Customs_Offices_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Customs_Offices_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "edec_customs_offices" */
export type Edec_Customs_Offices = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  created: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  name: Maybe<Scalars['String']>;
  number: Maybe<Scalars['String']>;
  prefix: Maybe<Scalars['String']>;
  updated_at: Maybe<Scalars['timestamptz']>;
  valid_from: Maybe<Scalars['date']>;
  valid_to: Maybe<Scalars['date']>;
  version: Maybe<Scalars['Int']>;
};

/** select columns of table "edec_domains" */
export enum Edec_Domains_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DomainName = 'domain_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  MeaningDe = 'meaning_de',
  /** column name */
  MeaningEn = 'meaning_en',
  /** column name */
  MeaningFr = 'meaning_fr',
  /** column name */
  MeaningIt = 'meaning_it',
  /** column name */
  ValidForExport = 'valid_for_export',
  /** column name */
  ValidForImport = 'valid_for_import',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Value = 'value',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_domains". */
export type Edec_Domains_Order_By = {
  created_at?: InputMaybe<Order_By>;
  domain_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  meaning_de?: InputMaybe<Order_By>;
  meaning_en?: InputMaybe<Order_By>;
  meaning_fr?: InputMaybe<Order_By>;
  meaning_it?: InputMaybe<Order_By>;
  valid_for_export?: InputMaybe<Order_By>;
  valid_for_import?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_domains". All fields are combined with a logical 'AND'. */
export type Edec_Domains_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Domains_Bool_Exp>>;
  _not?: InputMaybe<Edec_Domains_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Domains_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  domain_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  meaning_de?: InputMaybe<String_Comparison_Exp>;
  meaning_en?: InputMaybe<String_Comparison_Exp>;
  meaning_fr?: InputMaybe<String_Comparison_Exp>;
  meaning_it?: InputMaybe<String_Comparison_Exp>;
  valid_for_export?: InputMaybe<Boolean_Comparison_Exp>;
  valid_for_import?: InputMaybe<Boolean_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "edec_domains" */
export type Edec_Domains = {
  created_at: Maybe<Scalars['timestamptz']>;
  domain_name: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  meaning_de: Maybe<Scalars['String']>;
  meaning_en: Maybe<Scalars['String']>;
  meaning_fr: Maybe<Scalars['String']>;
  meaning_it: Maybe<Scalars['String']>;
  valid_for_export: Maybe<Scalars['Boolean']>;
  valid_for_import: Maybe<Scalars['Boolean']>;
  valid_from: Maybe<Scalars['date']>;
  valid_to: Maybe<Scalars['date']>;
  value: Maybe<Scalars['String']>;
  version: Maybe<Scalars['Int']>;
};

/** select columns of table "edec_tariff_commodity_code" */
export enum Edec_Tariff_Commodity_Code_Select_Column {
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ValidForExport = 'valid_for_export',
  /** column name */
  ValidForImport = 'valid_for_import',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Value = 'value',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_tariff_commodity_code". */
export type Edec_Tariff_Commodity_Code_Order_By = {
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  valid_for_export?: InputMaybe<Order_By>;
  valid_for_import?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_tariff_commodity_code". All fields are combined with a logical 'AND'. */
export type Edec_Tariff_Commodity_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Bool_Exp>>;
  _not?: InputMaybe<Edec_Tariff_Commodity_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Bool_Exp>>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  valid_for_export?: InputMaybe<Boolean_Comparison_Exp>;
  valid_for_import?: InputMaybe<Boolean_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** columns and relationships of "edec_tariff_commodity_code" */
export type Edec_Tariff_Commodity_Code = {
  created: Scalars['timestamp'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  valid_for_export: Scalars['Boolean'];
  valid_for_import: Scalars['Boolean'];
  valid_from: Scalars['date'];
  valid_to: Scalars['date'];
  value: Scalars['String'];
  version: Scalars['Int'];
};

/** select columns of table "edec_tariff_statistical_code" */
export enum Edec_Tariff_Statistical_Code_Select_Column {
  /** column name */
  CommodityCodeId = 'commodity_code_id',
  /** column name */
  Created = 'created',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LowerScaleWeight = 'lower_scale_weight',
  /** column name */
  ScaleWeightCode = 'scale_weight_code',
  /** column name */
  StorageType = 'storage_type',
  /** column name */
  UpperScaleWeight = 'upper_scale_weight',
  /** column name */
  ValidForExport = 'valid_for_export',
  /** column name */
  ValidForImport = 'valid_for_import',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  ValidTo = 'valid_to',
  /** column name */
  Value = 'value',
  /** column name */
  Version = 'version'
}

/** Ordering options when selecting data from "edec_tariff_statistical_code". */
export type Edec_Tariff_Statistical_Code_Order_By = {
  commodity_code_id?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  lower_scale_weight?: InputMaybe<Order_By>;
  scale_weight_code?: InputMaybe<Order_By>;
  storage_type?: InputMaybe<Order_By>;
  upper_scale_weight?: InputMaybe<Order_By>;
  valid_for_export?: InputMaybe<Order_By>;
  valid_for_import?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  valid_to?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  version?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "edec_tariff_statistical_code". All fields are combined with a logical 'AND'. */
export type Edec_Tariff_Statistical_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Bool_Exp>>;
  _not?: InputMaybe<Edec_Tariff_Statistical_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Bool_Exp>>;
  commodity_code_id?: InputMaybe<Int_Comparison_Exp>;
  created?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  lower_scale_weight?: InputMaybe<Numeric_Comparison_Exp>;
  scale_weight_code?: InputMaybe<Int_Comparison_Exp>;
  storage_type?: InputMaybe<String_Comparison_Exp>;
  upper_scale_weight?: InputMaybe<Numeric_Comparison_Exp>;
  valid_for_export?: InputMaybe<Boolean_Comparison_Exp>;
  valid_for_import?: InputMaybe<Boolean_Comparison_Exp>;
  valid_from?: InputMaybe<Date_Comparison_Exp>;
  valid_to?: InputMaybe<Date_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
  version?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "edec_tariff_statistical_code" */
export type Edec_Tariff_Statistical_Code = {
  commodity_code_id: Scalars['Int'];
  created: Scalars['timestamp'];
  id: Scalars['Int'];
  is_active: Scalars['Boolean'];
  lower_scale_weight: Maybe<Scalars['numeric']>;
  scale_weight_code: Scalars['Int'];
  storage_type: Scalars['String'];
  upper_scale_weight: Maybe<Scalars['numeric']>;
  valid_for_export: Scalars['Boolean'];
  valid_for_import: Scalars['Boolean'];
  valid_from: Scalars['date'];
  valid_to: Scalars['date'];
  value: Scalars['Int'];
  version: Scalars['Int'];
};

/** select columns of table "email_search_type" */
export enum Email_Search_Type_Select_Column {
  /** column name */
  Attachments = 'attachments',
  /** column name */
  Company = 'company',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Sender = 'sender',
  /** column name */
  TotalRows = 'total_rows'
}

/** Ordering options when selecting data from "email_search_type". */
export type Email_Search_Type_Order_By = {
  attachments?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  file_status?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  sender?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_search_type". All fields are combined with a logical 'AND'. */
export type Email_Search_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Search_Type_Bool_Exp>>;
  _not?: InputMaybe<Email_Search_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Search_Type_Bool_Exp>>;
  attachments?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  file_status?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  sender?: InputMaybe<String_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
};

/** SETOF-type for pp_email_search% functions. */
export type Email_Search_Type = {
  attachments: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  file_status: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  name: Maybe<Scalars['String']>;
  sender: Maybe<Scalars['String']>;
  total_rows: Maybe<Scalars['bigint']>;
};


/** SETOF-type for pp_email_search% functions. */
export type Email_Search_TypeDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** SETOF-type for pp_email_search% functions. */
export type Email_Search_TypeDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** SETOF-type for pp_email_search% functions. */
export type Email_Search_TypeMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "email_search_type" */
export type Email_Search_Type_Aggregate = {
  aggregate: Maybe<Email_Search_Type_Aggregate_Fields>;
  nodes: Array<Email_Search_Type>;
};

/** aggregate fields of "email_search_type" */
export type Email_Search_Type_Aggregate_Fields = {
  avg: Maybe<Email_Search_Type_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Email_Search_Type_Max_Fields>;
  min: Maybe<Email_Search_Type_Min_Fields>;
  stddev: Maybe<Email_Search_Type_Stddev_Fields>;
  stddev_pop: Maybe<Email_Search_Type_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Email_Search_Type_Stddev_Samp_Fields>;
  sum: Maybe<Email_Search_Type_Sum_Fields>;
  var_pop: Maybe<Email_Search_Type_Var_Pop_Fields>;
  var_samp: Maybe<Email_Search_Type_Var_Samp_Fields>;
  variance: Maybe<Email_Search_Type_Variance_Fields>;
};


/** aggregate fields of "email_search_type" */
export type Email_Search_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Email_Search_Type_Avg_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Email_Search_Type_Max_Fields = {
  attachments: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  file_status: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  sender: Maybe<Scalars['String']>;
  total_rows: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Email_Search_Type_Min_Fields = {
  attachments: Maybe<Scalars['String']>;
  company: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  file_status: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  sender: Maybe<Scalars['String']>;
  total_rows: Maybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Email_Search_Type_Stddev_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Email_Search_Type_Stddev_Pop_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Email_Search_Type_Stddev_Samp_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Email_Search_Type_Sum_Fields = {
  total_rows: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Email_Search_Type_Var_Pop_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Email_Search_Type_Var_Samp_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Email_Search_Type_Variance_Fields = {
  total_rows: Maybe<Scalars['Float']>;
};

/** select columns of table "extract_type" */
export enum Extract_Type_Select_Column {
  /** column name */
  ExtractTypeId = 'extract_type_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  Translations = 'translations'
}

/** select columns of table "extraction_config" */
export enum Extraction_Config_Select_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  Aliases = 'aliases',
  /** column name */
  DocumentTemplates = 'document_templates',
  /** column name */
  FounConfig = 'foun_config'
}

/** select columns of table "file" */
export enum File_Select_Column {
  /** column name */
  AiDocClassificationConfirmed = 'ai_doc_classification_confirmed',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileType = 'file_type',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Identification = 'identification',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SessionId = 'session_id'
}

/** aggregated selection of "file" */
export type File_Aggregate = {
  aggregate: Maybe<File_Aggregate_Fields>;
  nodes: Array<File>;
};

/** aggregate fields of "file" */
export type File_Aggregate_Fields = {
  avg: Maybe<File_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<File_Max_Fields>;
  min: Maybe<File_Min_Fields>;
  stddev: Maybe<File_Stddev_Fields>;
  stddev_pop: Maybe<File_Stddev_Pop_Fields>;
  stddev_samp: Maybe<File_Stddev_Samp_Fields>;
  sum: Maybe<File_Sum_Fields>;
  var_pop: Maybe<File_Var_Pop_Fields>;
  var_samp: Maybe<File_Var_Samp_Fields>;
  variance: Maybe<File_Variance_Fields>;
};


/** aggregate fields of "file" */
export type File_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type File_Avg_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type File_Max_Fields = {
  /** file creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  file_flags: Maybe<Scalars['bigint']>;
  file_status: Maybe<Scalars['String']>;
  file_type: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  /** id of file. */
  id: Maybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification: Maybe<Scalars['String']>;
  /** file last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['smallint']>;
  session_id: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type File_Min_Fields = {
  /** file creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user: Maybe<Scalars['uuid']>;
  file_flags: Maybe<Scalars['bigint']>;
  file_status: Maybe<Scalars['String']>;
  file_type: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  /** id of file. */
  id: Maybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification: Maybe<Scalars['String']>;
  /** file last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Maybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['smallint']>;
  session_id: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type File_Stddev_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type File_Stddev_Pop_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type File_Stddev_Samp_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type File_Sum_Fields = {
  file_flags: Maybe<Scalars['bigint']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['smallint']>;
};

/** aggregate var_pop on columns */
export type File_Var_Pop_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type File_Var_Samp_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type File_Variance_Fields = {
  file_flags: Maybe<Scalars['Float']>;
  /** Org_id related to file. */
  org_id: Maybe<Scalars['Float']>;
};

/** select columns of table "file_stats_type" */
export enum File_Stats_Type_Select_Column {
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileFlagsId = 'file_flags_id',
  /** column name */
  Qty = 'qty',
  /** column name */
  UsersQty = 'users_qty'
}

/** Ordering options when selecting data from "file_stats_type". */
export type File_Stats_Type_Order_By = {
  file_flags?: InputMaybe<Order_By>;
  file_flags_id?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  users_qty?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_stats_type". All fields are combined with a logical 'AND'. */
export type File_Stats_Type_Bool_Exp = {
  _and?: InputMaybe<Array<File_Stats_Type_Bool_Exp>>;
  _not?: InputMaybe<File_Stats_Type_Bool_Exp>;
  _or?: InputMaybe<Array<File_Stats_Type_Bool_Exp>>;
  file_flags?: InputMaybe<String_Comparison_Exp>;
  file_flags_id?: InputMaybe<Bigint_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  users_qty?: InputMaybe<Bigint_Comparison_Exp>;
};

/** SETOF-type used in pp_file_stats. */
export type File_Stats_Type = {
  file_flags: Maybe<Scalars['String']>;
  file_flags_id: Maybe<Scalars['bigint']>;
  qty: Maybe<Scalars['bigint']>;
  users_qty: Maybe<Scalars['bigint']>;
};

/** select columns of table "file_type" */
export enum File_Type_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  DocTypes = 'doc_types',
  /** column name */
  FileType = 'file_type'
}

/** Ordering options when selecting data from "file_type". */
export type File_Type_Order_By = {
  description?: InputMaybe<Order_By>;
  doc_types?: InputMaybe<Order_By>;
  file_type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "file_type". All fields are combined with a logical 'AND'. */
export type File_Type_Bool_Exp = {
  _and?: InputMaybe<Array<File_Type_Bool_Exp>>;
  _not?: InputMaybe<File_Type_Bool_Exp>;
  _or?: InputMaybe<Array<File_Type_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  doc_types?: InputMaybe<_Varchar_Comparison_Exp>;
  file_type?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_varchar". All fields are combined with logical 'AND'. */
export type _Varchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_varchar']>;
  _gt?: InputMaybe<Scalars['_varchar']>;
  _gte?: InputMaybe<Scalars['_varchar']>;
  _in?: InputMaybe<Array<Scalars['_varchar']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_varchar']>;
  _lte?: InputMaybe<Scalars['_varchar']>;
  _neq?: InputMaybe<Scalars['_varchar']>;
  _nin?: InputMaybe<Array<Scalars['_varchar']>>;
};

/** File types in system. Restrict document types inside files of specific file_type. */
export type File_Type = {
  description: Scalars['String'];
  doc_types: Maybe<Scalars['_varchar']>;
  file_type: Scalars['String'];
};

export type AddressOrOverrideResult = {
  address: AddressAcs;
  original_id: Maybe<Scalars['Int']>;
};

export type GetAddressOverridesResponse = {
  qty: Scalars['Float'];
  sourceAddress: AddressAcs;
  targetAddress: AddressAcs;
};

export type BordereauArgs = {
  dutiesFrom?: InputMaybe<Scalars['Float']>;
  dutiesTo?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['LocalDateTime']>;
  minDate?: InputMaybe<Scalars['LocalDateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BordereauStatus>;
  vatFrom?: InputMaybe<Scalars['Float']>;
  vatTo?: InputMaybe<Scalars['Float']>;
};

export enum BordereauStatus {
  All = 'All',
  Completed = 'Completed',
  NotCompleted = 'NotCompleted'
}

export type GetBordereaus = {
  count: Maybe<Scalars['Int']>;
  data: Maybe<Array<Maybe<Bordereau>>>;
};

export type Bordereau = {
  accountNumber: Maybe<Scalars['String']>;
  amount: Maybe<Scalars['Float']>;
  bordereauItems: Maybe<Array<Maybe<BordereauItem>>>;
  bordereauPdfDoc: Maybe<Documents>;
  bordereauXmlDoc: Maybe<Documents>;
  consignee: Maybe<Scalars['String']>;
  documentDate: Maybe<Scalars['Date']>;
  documentNumber: Scalars['String'];
  documentTime: Maybe<Scalars['LocalTime']>;
  documentTitle: Maybe<Scalars['String']>;
  duties: Maybe<Scalars['Float']>;
  numberOfDocuments: Maybe<Scalars['Int']>;
  status: Maybe<Scalars['Boolean']>;
  vat: Maybe<Scalars['Float']>;
};

export type BordereauItem = {
  amount: Maybe<Scalars['Float']>;
  customOffice: Maybe<CustomsOfficeAcs>;
  customsDeclarationVersion: Maybe<Scalars['Int']>;
  customsReference: Scalars['String'];
  documentTypeAbbreviation: Maybe<Scalars['String']>;
  documentTypeName: Scalars['String'];
  documentTypeNameTranslations: Maybe<TranslationsAcs>;
  drNo: Maybe<Scalars['Int']>;
  file: Maybe<FileAcs>;
  id: Scalars['Int'];
  status: Maybe<Scalars['Boolean']>;
  traderReference: Maybe<Scalars['String']>;
};

export type CustomsOfficeAcs = {
  address: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  officeNumber: Scalars['String'];
  prefix: Maybe<Scalars['String']>;
  validFrom: Maybe<Scalars['DateTime']>;
  validTo: Maybe<Scalars['DateTime']>;
};

export type TranslationsAcs = {
  de: Maybe<Scalars['String']>;
  en: Maybe<Scalars['String']>;
};

export type FileAcs = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['String']>;
  declarations: Maybe<Array<Maybe<DeclarationAcs>>>;
  documents: Array<Documents>;
  fileFlags: Maybe<Scalars['String']>;
  fileStatus: Maybe<Scalars['String']>;
  fileType: Maybe<Scalars['String']>;
  fileUrl: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  identification: Maybe<Scalars['String']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['String']>;
  meta: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  orgId: Maybe<Scalars['Int']>;
  sessionId: Scalars['String'];
};


export type FileAcsDocumentsArgs = {
  filters?: InputMaybe<FiltersExpressionAcsInput>;
};

export type DeclarationAcs = {
  addresses: Maybe<Array<AddressAcs>>;
  addressReferences: Maybe<Scalars['String']>;
  autoclassifiedDocsQty: Maybe<Scalars['String']>;
  customsOffice: Maybe<EdecCustomsOffices>;
  declaration: DeclarationEntity;
  declarationDiscussion: Maybe<DeclarationDiscussionEntity>;
  declarationLabels: Array<DeclarationLabel>;
  declarationRequest: DeclarationRequestAcs;
  declarationStatus: DeclarationStatus;
  drNo: Scalars['Int'];
  file: FileAcs;
  fileId: Scalars['String'];
  myDuties: Maybe<Scalars['JSON']>;
  nonclassifiedDocsExists: Maybe<Scalars['Boolean']>;
  payer: TenantEntity;
  payerAddress: AddressAcs;
  searchReferences: Maybe<Scalars['String']>;
  userPp: Maybe<UserPp>;
};

export type DeclarationDiscussionEntity = {
  closed: Scalars['Boolean'];
  creationDate: Scalars['DateTime'];
  discussionId: Scalars['Int'];
  discussionTheme: Maybe<Scalars['String']>;
  drNo: Scalars['Int'];
  fileId: Scalars['String'];
  meta: Scalars['JSON'];
  unreadMessagesCount: Scalars['Int'];
};

export type CommodityCodeDescription = {
  commodityCode: Maybe<Scalars['String']>;
  descriptionDe: Scalars['String'];
  hierarchyVisual: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

export type DeclarationLabelQueryOutput = {
  color: Scalars['String'];
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  tenant_id: Scalars['UUID'];
  title: Scalars['JSON'];
};

export type DeclarationAddress = {
  address: Maybe<AddressAcs>;
  addressId: Maybe<Scalars['Int']>;
  addressType: Scalars['Int'];
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  meta: Maybe<Scalars['JSON']>;
  refs: Maybe<Array<Scalars['String']>>;
};

export type DeclarationFlat = {
  addressReferences: Maybe<Scalars['String']>;
  autoclassifiedDocsQty: Scalars['Int'];
  consigneeName: Maybe<Scalars['String']>;
  consigneeRef: Maybe<Scalars['String']>;
  consignorName: Maybe<Scalars['String']>;
  consignorRef: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['String']>;
  customsOfficeNumber: Maybe<Scalars['String']>;
  declarationStatus: DeclarationStatus;
  discussionId: Maybe<Scalars['Int']>;
  drNo: Scalars['Int'];
  evvReceived: Maybe<Scalars['Boolean']>;
  fileId: Scalars['String'];
  identification: Maybe<Scalars['String']>;
  importerRef: Maybe<Scalars['String']>;
  messageCount: Scalars['Int'];
  nonclassifiedDocsExists: Scalars['Int'];
  orgId: Maybe<Scalars['Int']>;
  payerName: Maybe<Scalars['String']>;
  payerRef: Maybe<Scalars['String']>;
  totalColis: Maybe<Scalars['Float']>;
  totalGrossWeight: Maybe<Scalars['Float']>;
};

export enum DocumentStatus {
  Archived = 'Archived',
  ArchivedFailed = 'ArchivedFailed',
  ArchivedPending = 'ArchivedPending',
  Classified = 'Classified',
  ClassifiedFailed = 'ClassifiedFailed',
  ClassifiedPending = 'ClassifiedPending',
  Finished = 'Finished',
  Initial = 'Initial',
  Pending = 'Pending',
  Proceeded = 'Proceeded',
  Raw = 'Raw',
  ThumbnailsFailed = 'ThumbnailsFailed',
  ThumbnailsGenerated = 'ThumbnailsGenerated',
  ThumbnailsPending = 'ThumbnailsPending',
  ThumbnailsProcessingFailed = 'ThumbnailsProcessingFailed',
  Uploaded = 'Uploaded'
}

export type GetFileDocumentsQuery = {
  blobs: Maybe<Array<DocumentBlob>>;
  creationUser: Maybe<Scalars['String']>;
  documentExtension: Scalars['String'];
  documentFlags: Scalars['Int'];
  documentName: Scalars['String'];
  documentStatus: Scalars['String'];
  documentType: Scalars['String'];
  documentTypeTranslations: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSON']>;
  pages: Array<PageAcs>;
  sequence: Maybe<Scalars['Int']>;
};

export type DocumentBlob = {
  extension: Scalars['String'];
  initial: Scalars['Boolean'];
  url: Scalars['String'];
};

export type GetFiles = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  declarations: Maybe<Array<Maybe<DeclarationAcs>>>;
  documents: Maybe<Array<Maybe<GetFilesDocumentAcs>>>;
  fileFlags: Maybe<Scalars['Int']>;
  fileUrl: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  identification: Maybe<Scalars['String']>;
  isDeleted: Maybe<Scalars['Boolean']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  meta: Maybe<Scalars['JSON']>;
  name: Maybe<Scalars['String']>;
  orgId: Maybe<Scalars['Int']>;
};

export type GetFilesDocumentAcs = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['DateTime']>;
  creation_user: Maybe<Scalars['UUID']>;
  document_blobs: Maybe<Scalars['JSON']>;
  document_extension: Maybe<Scalars['String']>;
  document_flags: Maybe<Scalars['Int']>;
  document_name: Maybe<Scalars['String']>;
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<GetFilesDocumentTypeAcs>;
  document_version: Maybe<Scalars['Int']>;
  documentPages: Maybe<Array<GetFilesDocumentPage>>;
  file: Scalars['UUID'];
  id: Scalars['UUID'];
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_generated: Maybe<Scalars['Boolean']>;
  is_template: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['DateTime']>;
  last_modified_user: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  number_of_pages: Maybe<Scalars['Int']>;
  org_id: Maybe<Scalars['Int']>;
  sequence: Maybe<Scalars['Int']>;
};

export type GetFilesDocumentTypeAcs = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  displayName: Maybe<Scalars['String']>;
  documentTypeTenantSettings: Maybe<Array<GetFilesDocumentTypeTenantSettings>>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  name: Maybe<Scalars['String']>;
  translations: Maybe<Scalars['JSON']>;
};

export type GetFilesDocumentTypeTenantSettings = {
  code: Maybe<Scalars['String']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  defaultFlags: Maybe<Scalars['Int']>;
  displayName: Maybe<Scalars['String']>;
  documentSchema: Maybe<Scalars['JSON']>;
  documentType: Maybe<Scalars['String']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  tenant: Scalars['UUID'];
};

export type GetFilesDocumentPage = {
  documentId: Scalars['UUID'];
  page: Maybe<GetFilesPageAcs>;
  pageId: Scalars['UUID'];
  pageNumber: Maybe<Scalars['Int']>;
};

export type GetFilesPageAcs = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<Scalars['UUID']>;
  meta: Maybe<Scalars['JSON']>;
  ocrText: Maybe<Scalars['String']>;
  pageStatus: Maybe<Scalars['String']>;
  rotate: Maybe<Scalars['Int']>;
  thumbnailBigUrl: Maybe<Scalars['String']>;
  thumbnailSmallUrl: Maybe<Scalars['String']>;
};

export type SasTokenResponse = {
  container: Maybe<Scalars['String']>;
  expiryDate: Maybe<Scalars['String']>;
  sasToken: Maybe<Scalars['String']>;
};

export type ReportEntity = {
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: Scalars['String'];
  id: Scalars['UUID'];
  isDeleted: Maybe<Scalars['Boolean']>;
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  md5: Maybe<Scalars['String']>;
  reportType: Scalars['String'];
  status: Maybe<Scalars['String']>;
  tenantId: Scalars['UUID'];
  url: Maybe<Scalars['String']>;
};

export type CaslRule = {
  action: Actions;
  subject: Subjects;
};

export enum Actions {
  Archive = 'Archive',
  Create = 'Create',
  Delete = 'Delete',
  Download = 'Download',
  HideColumns = 'HideColumns',
  Preview = 'Preview',
  Print = 'Print',
  Read = 'Read',
  Share = 'Share',
  Subscribe = 'Subscribe',
  Update = 'Update',
  Upload = 'Upload'
}

export enum Subjects {
  CustomerDocument = 'CustomerDocument',
  CustomsDocument = 'CustomsDocument',
  DashboardTable = 'DashboardTable',
  DashboardTile = 'DashboardTile',
  Declaration = 'Declaration',
  DeclarationGoodItemReport = 'DeclarationGoodItemReport',
  DeclarationReport = 'DeclarationReport',
  Document = 'Document',
  FreeTextFieldReference = 'FreeTextFieldReference',
  Kpi = 'KPI',
  NotificationsImport = 'NotificationsImport',
  NotificationsStatus = 'NotificationsStatus'
}

export type GetUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['UUID']>;
};

/** select columns of table "goods_items_for_drs" */
export enum Goods_Items_For_Drs_Select_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AdditionalUnit = 'additional_unit',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  AutoclassifiedDocsQty = 'autoclassified_docs_qty',
  /** column name */
  ChExpDecl = 'ch_exp_decl',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsClearanceType = 'customs_clearance_type',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsItemnumber = 'customs_itemnumber',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  Description = 'description',
  /** column name */
  DestTolldeptCode = 'dest_tolldept_code',
  /** column name */
  DestTolldeptName = 'dest_tolldept_name',
  /** column name */
  DocId = 'doc_id',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyTotal = 'duty_total',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GoodsItem = 'goods_item',
  /** column name */
  Grossmass = 'grossmass',
  /** column name */
  HsCode = 'hs_code',
  /** column name */
  ImpCustClr = 'imp_cust_clr',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Meta = 'meta',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  NonclassifiedDocsExists = 'nonclassified_docs_exists',
  /** column name */
  Origin = 'origin',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  Packaging = 'packaging',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PermissionsJs = 'permissions_js',
  /** column name */
  PermitObligation = 'permit_obligation',
  /** column name */
  Preference = 'preference',
  /** column name */
  ProducedDocument = 'produced_document',
  /** column name */
  Qty = 'qty',
  /** column name */
  Reference = 'reference',
  /** column name */
  RowNumber = 'row_number',
  /** column name */
  Statistic = 'statistic',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  StatisticalValue = 'statistical_value',
  /** column name */
  TollDep = 'toll_dep',
  /** column name */
  TrNo = 'tr_no',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransitdocType = 'transitdoc_type',
  /** column name */
  ValuationDetails = 'valuation_details',
  /** column name */
  Value = 'value',
  /** column name */
  VatTotal = 'vat_total',
  /** column name */
  Vatvalue = 'vatvalue',
  /** column name */
  WaNumber = 'wa_number'
}

/** Ordering options when selecting data from "goods_items_for_drs". */
export type Goods_Items_For_Drs_Order_By = {
  acceptance_date?: InputMaybe<Order_By>;
  account_number?: InputMaybe<Order_By>;
  additional_unit?: InputMaybe<Order_By>;
  arrival_time?: InputMaybe<Order_By>;
  arrival_type?: InputMaybe<Order_By>;
  autoclassified_docs_qty?: InputMaybe<Order_By>;
  ch_exp_decl?: InputMaybe<Order_By>;
  clearance_type?: InputMaybe<Order_By>;
  commercial_good?: InputMaybe<Order_By>;
  commodity_code?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_clearance_type?: InputMaybe<Order_By>;
  customs_declaration_number?: InputMaybe<Order_By>;
  customs_declaration_version?: InputMaybe<Order_By>;
  customs_itemnumber?: InputMaybe<Order_By>;
  declaration_request?: InputMaybe<Declaration_Request_Order_By>;
  declaration_status?: InputMaybe<Order_By>;
  declaration_type?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dest_tolldept_code?: InputMaybe<Order_By>;
  dest_tolldept_name?: InputMaybe<Order_By>;
  doc_id?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  dr_no?: InputMaybe<Order_By>;
  duty_total?: InputMaybe<Order_By>;
  eta?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  goods_item?: InputMaybe<Order_By>;
  grossmass?: InputMaybe<Order_By>;
  hs_code?: InputMaybe<Order_By>;
  imp_cust_clr?: InputMaybe<Order_By>;
  is_express?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  net_mass?: InputMaybe<Order_By>;
  non_customs_law_obligation?: InputMaybe<Order_By>;
  nonclassified_docs_exists?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  origin_country?: InputMaybe<Order_By>;
  packaging?: InputMaybe<Order_By>;
  payer_id?: InputMaybe<Order_By>;
  permissions_js?: InputMaybe<Order_By>;
  permit_obligation?: InputMaybe<Order_By>;
  preference?: InputMaybe<Order_By>;
  produced_document?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  row_number?: InputMaybe<Order_By>;
  statistic?: InputMaybe<Order_By>;
  statistical_code?: InputMaybe<Order_By>;
  statistical_value?: InputMaybe<Order_By>;
  toll_dep?: InputMaybe<Order_By>;
  tr_no?: InputMaybe<Order_By>;
  trader_reference?: InputMaybe<Order_By>;
  transitdoc_type?: InputMaybe<Order_By>;
  valuation_details?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
  vat_total?: InputMaybe<Order_By>;
  vatvalue?: InputMaybe<Order_By>;
  wa_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "goods_items_for_drs". All fields are combined with a logical 'AND'. */
export type Goods_Items_For_Drs_Bool_Exp = {
  _and?: InputMaybe<Array<Goods_Items_For_Drs_Bool_Exp>>;
  _not?: InputMaybe<Goods_Items_For_Drs_Bool_Exp>;
  _or?: InputMaybe<Array<Goods_Items_For_Drs_Bool_Exp>>;
  acceptance_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  additional_unit?: InputMaybe<Jsonb_Comparison_Exp>;
  arrival_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  arrival_type?: InputMaybe<String_Comparison_Exp>;
  autoclassified_docs_qty?: InputMaybe<Bigint_Comparison_Exp>;
  ch_exp_decl?: InputMaybe<Boolean_Comparison_Exp>;
  clearance_type?: InputMaybe<String_Comparison_Exp>;
  commercial_good?: InputMaybe<String_Comparison_Exp>;
  commodity_code?: InputMaybe<Jsonb_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_clearance_type?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_number?: InputMaybe<String_Comparison_Exp>;
  customs_declaration_version?: InputMaybe<Smallint_Comparison_Exp>;
  customs_itemnumber?: InputMaybe<Jsonb_Comparison_Exp>;
  declaration_request?: InputMaybe<Declaration_Request_Bool_Exp>;
  declaration_status?: InputMaybe<String_Comparison_Exp>;
  declaration_type?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<Jsonb_Comparison_Exp>;
  dest_tolldept_code?: InputMaybe<String_Comparison_Exp>;
  dest_tolldept_name?: InputMaybe<String_Comparison_Exp>;
  doc_id?: InputMaybe<Uuid_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  dr_no?: InputMaybe<Smallint_Comparison_Exp>;
  duty_total?: InputMaybe<String_Comparison_Exp>;
  eta?: InputMaybe<Timestamptz_Comparison_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  goods_item?: InputMaybe<Jsonb_Comparison_Exp>;
  grossmass?: InputMaybe<Jsonb_Comparison_Exp>;
  hs_code?: InputMaybe<String_Comparison_Exp>;
  imp_cust_clr?: InputMaybe<Boolean_Comparison_Exp>;
  is_express?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  net_mass?: InputMaybe<Jsonb_Comparison_Exp>;
  non_customs_law_obligation?: InputMaybe<Jsonb_Comparison_Exp>;
  nonclassified_docs_exists?: InputMaybe<Boolean_Comparison_Exp>;
  origin?: InputMaybe<Jsonb_Comparison_Exp>;
  origin_country?: InputMaybe<String_Comparison_Exp>;
  packaging?: InputMaybe<Jsonb_Comparison_Exp>;
  payer_id?: InputMaybe<Uuid_Comparison_Exp>;
  permissions_js?: InputMaybe<Json_Comparison_Exp>;
  permit_obligation?: InputMaybe<Jsonb_Comparison_Exp>;
  preference?: InputMaybe<String_Comparison_Exp>;
  produced_document?: InputMaybe<Jsonb_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  row_number?: InputMaybe<Bigint_Comparison_Exp>;
  statistic?: InputMaybe<Jsonb_Comparison_Exp>;
  statistical_code?: InputMaybe<Jsonb_Comparison_Exp>;
  statistical_value?: InputMaybe<String_Comparison_Exp>;
  toll_dep?: InputMaybe<String_Comparison_Exp>;
  tr_no?: InputMaybe<String_Comparison_Exp>;
  trader_reference?: InputMaybe<String_Comparison_Exp>;
  transitdoc_type?: InputMaybe<Transitdoc_Type_Comparison_Exp>;
  valuation_details?: InputMaybe<Jsonb_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
  vat_total?: InputMaybe<String_Comparison_Exp>;
  vatvalue?: InputMaybe<String_Comparison_Exp>;
  wa_number?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_Drs = {
  acceptance_date: Maybe<Scalars['timestamptz']>;
  account_number: Maybe<Scalars['String']>;
  additional_unit: Maybe<Scalars['jsonb']>;
  arrival_time: Maybe<Scalars['timestamptz']>;
  arrival_type: Maybe<Scalars['String']>;
  autoclassified_docs_qty: Maybe<Scalars['bigint']>;
  ch_exp_decl: Maybe<Scalars['Boolean']>;
  clearance_type: Maybe<Scalars['String']>;
  commercial_good: Maybe<Scalars['String']>;
  commodity_code: Maybe<Scalars['jsonb']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  customs_clearance_type: Maybe<Scalars['String']>;
  customs_declaration_number: Maybe<Scalars['String']>;
  customs_declaration_version: Maybe<Scalars['smallint']>;
  customs_itemnumber: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  declaration_request: Maybe<Declaration_Request>;
  declaration_status: Maybe<Scalars['String']>;
  declaration_type: Maybe<Scalars['String']>;
  description: Maybe<Scalars['jsonb']>;
  dest_tolldept_code: Maybe<Scalars['String']>;
  dest_tolldept_name: Maybe<Scalars['String']>;
  doc_id: Maybe<Scalars['uuid']>;
  document_type: Maybe<Scalars['String']>;
  dr_no: Maybe<Scalars['smallint']>;
  duty_total: Maybe<Scalars['String']>;
  eta: Maybe<Scalars['timestamptz']>;
  file_id: Maybe<Scalars['uuid']>;
  goods_item: Maybe<Scalars['jsonb']>;
  grossmass: Maybe<Scalars['jsonb']>;
  hs_code: Maybe<Scalars['String']>;
  imp_cust_clr: Maybe<Scalars['Boolean']>;
  is_express: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  meta: Maybe<Scalars['jsonb']>;
  net_mass: Maybe<Scalars['jsonb']>;
  non_customs_law_obligation: Maybe<Scalars['jsonb']>;
  nonclassified_docs_exists: Maybe<Scalars['Boolean']>;
  origin: Maybe<Scalars['jsonb']>;
  origin_country: Maybe<Scalars['String']>;
  packaging: Maybe<Scalars['jsonb']>;
  payer_id: Maybe<Scalars['uuid']>;
  permissions_js: Maybe<Scalars['json']>;
  permit_obligation: Maybe<Scalars['jsonb']>;
  preference: Maybe<Scalars['String']>;
  produced_document: Maybe<Scalars['jsonb']>;
  qty: Maybe<Scalars['bigint']>;
  reference: Maybe<Scalars['String']>;
  row_number: Maybe<Scalars['bigint']>;
  statistic: Maybe<Scalars['jsonb']>;
  statistical_code: Maybe<Scalars['jsonb']>;
  statistical_value: Maybe<Scalars['String']>;
  toll_dep: Maybe<Scalars['String']>;
  tr_no: Maybe<Scalars['String']>;
  trader_reference: Maybe<Scalars['String']>;
  transitdoc_type: Maybe<Scalars['transitdoc_type']>;
  valuation_details: Maybe<Scalars['jsonb']>;
  value: Maybe<Scalars['jsonb']>;
  vat_total: Maybe<Scalars['String']>;
  vatvalue: Maybe<Scalars['String']>;
  wa_number: Maybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsAdditional_UnitArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsCommodity_CodeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsCustoms_ItemnumberArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsDescriptionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsGoods_ItemArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsGrossmassArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsNet_MassArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsNon_Customs_Law_ObligationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsOriginArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsPackagingArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsPermissions_JsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsPermit_ObligationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsProduced_DocumentArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsStatisticArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsStatistical_CodeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsValuation_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "goods_items_for_drs" */
export type Goods_Items_For_DrsValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "intf.dr_payment_info" */
export enum Intf_Dr_Payment_Info_Select_Column {
  /** column name */
  Addresses = 'addresses',
  /** column name */
  AddressesQi = 'addresses_qi',
  /** column name */
  Payer = 'payer'
}

/** Ordering options when selecting data from "intf.dr_payment_info". */
export type Intf_Dr_Payment_Info_Order_By = {
  addresses?: InputMaybe<Order_By>;
  addresses_qi?: InputMaybe<Order_By>;
  payer?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "intf.dr_payment_info". All fields are combined with a logical 'AND'. */
export type Intf_Dr_Payment_Info_Bool_Exp = {
  _and?: InputMaybe<Array<Intf_Dr_Payment_Info_Bool_Exp>>;
  _not?: InputMaybe<Intf_Dr_Payment_Info_Bool_Exp>;
  _or?: InputMaybe<Array<Intf_Dr_Payment_Info_Bool_Exp>>;
  addresses?: InputMaybe<_Int4_Comparison_Exp>;
  addresses_qi?: InputMaybe<String_Comparison_Exp>;
  payer?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "intf.dr_payment_info" */
export type Intf_Dr_Payment_Info = {
  addresses: Maybe<Scalars['_int4']>;
  addresses_qi: Maybe<Scalars['String']>;
  payer: Maybe<Scalars['uuid']>;
};

/** select columns of table "json_type" */
export enum Json_Type_Select_Column {
  /** column name */
  JsonValue = 'json_value'
}

/** Ordering options when selecting data from "json_type". */
export type Json_Type_Order_By = {
  json_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "json_type". All fields are combined with a logical 'AND'. */
export type Json_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Json_Type_Bool_Exp>>;
  _not?: InputMaybe<Json_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Json_Type_Bool_Exp>>;
  json_value?: InputMaybe<Json_Comparison_Exp>;
};

/** SETOF-type used for json output. */
export type Json_Type = {
  json_value: Maybe<Scalars['json']>;
};


/** SETOF-type used for json output. */
export type Json_TypeJson_ValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "kc_users" */
export enum Kc_Users_Select_Column {
  /** column name */
  AditPermissions = 'adit_permissions',
  /** column name */
  AditPermissionsDesk = 'adit_permissions_desk',
  /** column name */
  AditPermissionsHex = 'adit_permissions_hex',
  /** column name */
  AditRoles = 'adit_roles',
  /** column name */
  Attrs = 'attrs',
  /** column name */
  Code = 'code',
  /** column name */
  Created = 'created',
  /** column name */
  DefaultRole = 'default_role',
  /** column name */
  Email = 'email',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FederationLink = 'federation_link',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LiberRoles = 'liber_roles',
  /** column name */
  Location = 'location',
  /** column name */
  NotBefore = 'not_before',
  /** column name */
  OrgIds = 'org_ids',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Qty = 'qty',
  /** column name */
  RealmId = 'realm_id',
  /** column name */
  RequiredActions = 'required_actions',
  /** column name */
  ServiceAccountClientLink = 'service_account_client_link',
  /** column name */
  Tenant = 'tenant',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserClientRoles = 'user_client_roles',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

/** Ordering options when selecting data from "kc_users". */
export type Kc_Users_Order_By = {
  adit_permissions?: InputMaybe<Order_By>;
  adit_permissions_desk?: InputMaybe<Order_By>;
  adit_permissions_hex?: InputMaybe<Order_By>;
  adit_roles?: InputMaybe<Order_By>;
  attrs?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  default_role?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  federation_link?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  liber_roles?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  not_before?: InputMaybe<Order_By>;
  org_ids?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  realm_id?: InputMaybe<Order_By>;
  required_actions?: InputMaybe<Order_By>;
  service_account_client_link?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_client_roles?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "kc_users". All fields are combined with a logical 'AND'. */
export type Kc_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Kc_Users_Bool_Exp>>;
  _not?: InputMaybe<Kc_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Kc_Users_Bool_Exp>>;
  adit_permissions?: InputMaybe<Bigint_Comparison_Exp>;
  adit_permissions_desk?: InputMaybe<_Txtcode_Comparison_Exp>;
  adit_permissions_hex?: InputMaybe<String_Comparison_Exp>;
  adit_roles?: InputMaybe<Jsonb_Comparison_Exp>;
  attrs?: InputMaybe<Jsonb_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  default_role?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  federation_link?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  liber_roles?: InputMaybe<Jsonb_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  not_before?: InputMaybe<Int_Comparison_Exp>;
  org_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  realm_id?: InputMaybe<String_Comparison_Exp>;
  required_actions?: InputMaybe<_Varchar_Comparison_Exp>;
  service_account_client_link?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<String_Comparison_Exp>;
  user_client_roles?: InputMaybe<Jsonb_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_txtcode". All fields are combined with logical 'AND'. */
export type _Txtcode_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_txtcode']>;
  _gt?: InputMaybe<Scalars['_txtcode']>;
  _gte?: InputMaybe<Scalars['_txtcode']>;
  _in?: InputMaybe<Array<Scalars['_txtcode']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_txtcode']>;
  _lte?: InputMaybe<Scalars['_txtcode']>;
  _neq?: InputMaybe<Scalars['_txtcode']>;
  _nin?: InputMaybe<Array<Scalars['_txtcode']>>;
};

/** columns and relationships of "kc_users" */
export type Kc_Users = {
  adit_permissions: Maybe<Scalars['bigint']>;
  adit_permissions_desk: Maybe<Scalars['_txtcode']>;
  adit_permissions_hex: Maybe<Scalars['String']>;
  adit_roles: Maybe<Scalars['jsonb']>;
  attrs: Maybe<Scalars['jsonb']>;
  code: Maybe<Scalars['String']>;
  created: Maybe<Scalars['timestamptz']>;
  default_role: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  enabled: Maybe<Scalars['Boolean']>;
  federation_link: Maybe<Scalars['String']>;
  first_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  last_name: Maybe<Scalars['String']>;
  liber_roles: Maybe<Scalars['jsonb']>;
  location: Maybe<Scalars['String']>;
  not_before: Maybe<Scalars['Int']>;
  org_ids: Maybe<Scalars['jsonb']>;
  phone_number: Maybe<Scalars['String']>;
  qty: Maybe<Scalars['bigint']>;
  realm_id: Maybe<Scalars['String']>;
  required_actions: Maybe<Scalars['_varchar']>;
  service_account_client_link: Maybe<Scalars['String']>;
  tenant: Maybe<Scalars['String']>;
  tenant_id: Maybe<Scalars['String']>;
  user_client_roles: Maybe<Scalars['jsonb']>;
  user_id: Maybe<Scalars['uuid']>;
  username: Maybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersAdit_RolesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersAttrsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersLiber_RolesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersOrg_IdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "kc_users" */
export type Kc_UsersUser_Client_RolesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "max_date_type" */
export enum Max_Date_Type_Select_Column {
  /** column name */
  MaxChangeDate = 'max_change_date'
}

/** Ordering options when selecting data from "max_date_type". */
export type Max_Date_Type_Order_By = {
  max_change_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "max_date_type". All fields are combined with a logical 'AND'. */
export type Max_Date_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Max_Date_Type_Bool_Exp>>;
  _not?: InputMaybe<Max_Date_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Max_Date_Type_Bool_Exp>>;
  max_change_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** SETOF-type for pp_file_max_date_hs and pp_doc_max_date_hs. */
export type Max_Date_Type = {
  max_change_date: Maybe<Scalars['timestamptz']>;
};

/** select columns of table "model_retrain" */
export enum Model_Retrain_Select_Column {
  /** column name */
  EndTime = 'end_time',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  RequestTime = 'request_time',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status'
}

/** Ordering options when selecting data from "model_retrain". */
export type Model_Retrain_Order_By = {
  end_time?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  request_time?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_retrain". All fields are combined with a logical 'AND'. */
export type Model_Retrain_Bool_Exp = {
  _and?: InputMaybe<Array<Model_Retrain_Bool_Exp>>;
  _not?: InputMaybe<Model_Retrain_Bool_Exp>;
  _or?: InputMaybe<Array<Model_Retrain_Bool_Exp>>;
  end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  request_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "model_retrain" */
export type Model_Retrain = {
  end_time: Maybe<Scalars['timestamptz']>;
  error_message: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  request_time: Maybe<Scalars['timestamptz']>;
  start_time: Maybe<Scalars['timestamptz']>;
  status: Maybe<Scalars['String']>;
};

/** select columns of table "org_ids" */
export enum Org_Ids_Select_Column {
  /** column name */
  AddressesDesc = 'addresses_desc',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DocsAffected = 'docs_affected',
  /** column name */
  FilesAffected = 'files_affected',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIdDescription = 'org_id_description',
  /** column name */
  OrgIdsDesc = 'org_ids_desc',
  /** column name */
  OrgParams = 'org_params',
  /** column name */
  Qty = 'qty',
  /** column name */
  UsersAffected = 'users_affected'
}

/** Ordering options when selecting data from "org_ids". */
export type Org_Ids_Order_By = {
  addresses_desc?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  docs_affected?: InputMaybe<Order_By>;
  files_affected?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  org_ids_desc?: InputMaybe<Order_By>;
  org_params?: InputMaybe<Order_By>;
  orgParams?: InputMaybe<Org_Params_Order_By>;
  qty?: InputMaybe<Order_By>;
  users_affected?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "org_params". */
export type Org_Params_Order_By = {
  addresses?: InputMaybe<Order_By>;
  file_ids?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_ids?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  orgIds_aggregate?: InputMaybe<Org_Params_Org_Id_Aggregate_Order_By>;
  search?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "org_params_org_id" */
export type Org_Params_Org_Id_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Params_Org_Id_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Params_Org_Id_Max_Order_By>;
  min?: InputMaybe<Org_Params_Org_Id_Min_Order_By>;
  stddev?: InputMaybe<Org_Params_Org_Id_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Params_Org_Id_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Params_Org_Id_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Params_Org_Id_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Params_Org_Id_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Params_Org_Id_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Params_Org_Id_Variance_Order_By>;
};

/** order by avg() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Avg_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Max_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Min_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Stddev_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Stddev_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Stddev_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Sum_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Var_Pop_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Var_Samp_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "org_params_org_id" */
export type Org_Params_Org_Id_Variance_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_ids". All fields are combined with a logical 'AND'. */
export type Org_Ids_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Ids_Bool_Exp>>;
  _not?: InputMaybe<Org_Ids_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Ids_Bool_Exp>>;
  addresses_desc?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  docs_affected?: InputMaybe<_Uuid_Comparison_Exp>;
  files_affected?: InputMaybe<_Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  org_id_description?: InputMaybe<String_Comparison_Exp>;
  org_ids_desc?: InputMaybe<String_Comparison_Exp>;
  org_params?: InputMaybe<Json_Comparison_Exp>;
  orgParams?: InputMaybe<Org_Params_Bool_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  users_affected?: InputMaybe<_Uuid_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "_uuid". All fields are combined with logical 'AND'. */
export type _Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_uuid']>;
  _gt?: InputMaybe<Scalars['_uuid']>;
  _gte?: InputMaybe<Scalars['_uuid']>;
  _in?: InputMaybe<Array<Scalars['_uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_uuid']>;
  _lte?: InputMaybe<Scalars['_uuid']>;
  _neq?: InputMaybe<Scalars['_uuid']>;
  _nin?: InputMaybe<Array<Scalars['_uuid']>>;
};

/** Boolean expression to filter rows from the table "org_params". All fields are combined with a logical 'AND'. */
export type Org_Params_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Params_Bool_Exp>>;
  _not?: InputMaybe<Org_Params_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Params_Bool_Exp>>;
  addresses?: InputMaybe<Query_Int_Comparison_Exp>;
  file_ids?: InputMaybe<_Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  org_ids?: InputMaybe<_Int2_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  orgIds?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
  search?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "query_int". All fields are combined with logical 'AND'. */
export type Query_Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['query_int']>;
  _gt?: InputMaybe<Scalars['query_int']>;
  _gte?: InputMaybe<Scalars['query_int']>;
  _in?: InputMaybe<Array<Scalars['query_int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['query_int']>;
  _lte?: InputMaybe<Scalars['query_int']>;
  _neq?: InputMaybe<Scalars['query_int']>;
  _nin?: InputMaybe<Array<Scalars['query_int']>>;
};

/** Boolean expression to compare columns of type "_int2". All fields are combined with logical 'AND'. */
export type _Int2_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_int2']>;
  _gt?: InputMaybe<Scalars['_int2']>;
  _gte?: InputMaybe<Scalars['_int2']>;
  _in?: InputMaybe<Array<Scalars['_int2']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['_int2']>;
  _lte?: InputMaybe<Scalars['_int2']>;
  _neq?: InputMaybe<Scalars['_int2']>;
  _nin?: InputMaybe<Array<Scalars['_int2']>>;
};

/** Boolean expression to filter rows from the table "org_params_org_id". All fields are combined with a logical 'AND'. */
export type Org_Params_Org_Id_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Params_Org_Id_Bool_Exp>>;
  _not?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Params_Org_Id_Bool_Exp>>;
  org_id?: InputMaybe<Int_Comparison_Exp>;
  param_org_id?: InputMaybe<Smallint_Comparison_Exp>;
  paramOrgId?: InputMaybe<Org_Id_Bool_Exp>;
};

/** columns and relationships of "org_ids" */
export type Org_Ids = {
  addresses_desc: Maybe<Scalars['String']>;
  display_name: Maybe<Scalars['String']>;
  docs_affected: Maybe<Scalars['_uuid']>;
  files_affected: Maybe<Scalars['_uuid']>;
  org_id: Maybe<Scalars['smallint']>;
  org_id_description: Maybe<Scalars['String']>;
  org_ids_desc: Maybe<Scalars['String']>;
  org_params: Maybe<Scalars['json']>;
  /** An object relationship */
  orgParams: Maybe<Org_Params>;
  qty: Maybe<Scalars['bigint']>;
  users_affected: Maybe<Scalars['_uuid']>;
};


/** columns and relationships of "org_ids" */
export type Org_IdsOrg_ParamsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "org_params" */
export type Org_Params = {
  addresses: Maybe<Scalars['query_int']>;
  file_ids: Maybe<Scalars['_uuid']>;
  org_id: Scalars['Int'];
  org_ids: Maybe<Scalars['_int2']>;
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  /** An array relationship */
  orgIds: Array<Org_Params_Org_Id>;
  search: Maybe<Scalars['String']>;
};


/** columns and relationships of "org_params" */
export type Org_ParamsOrgIdsArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Org_Id_Order_By>>;
  where?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
};

/** select columns of table "org_params_org_id" */
export enum Org_Params_Org_Id_Select_Column {
  /** column name */
  OrgId = 'org_id',
  /** column name */
  ParamOrgId = 'param_org_id'
}

/** Ordering options when selecting data from "org_params_org_id". */
export type Org_Params_Org_Id_Order_By = {
  org_id?: InputMaybe<Order_By>;
  param_org_id?: InputMaybe<Order_By>;
  paramOrgId?: InputMaybe<Org_Id_Order_By>;
};

/** columns and relationships of "org_params_org_id" */
export type Org_Params_Org_Id = {
  org_id: Maybe<Scalars['Int']>;
  param_org_id: Maybe<Scalars['smallint']>;
  /** An object relationship */
  paramOrgId: Maybe<Org_Id>;
};

/** select columns of table "org_params" */
export enum Org_Params_Select_Column {
  /** column name */
  Addresses = 'addresses',
  /** column name */
  FileIds = 'file_ids',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIds = 'org_ids',
  /** column name */
  Search = 'search'
}

/** select columns of table "page" */
export enum Page_Select_Column {
  /** column name */
  AiIgnoreRetraining = 'ai_ignore_retraining',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  OcrText = 'ocr_text',
  /** column name */
  PageStatus = 'page_status',
  /** column name */
  Rotate = 'rotate',
  /** column name */
  ThumbnailBigUrl = 'thumbnail_big_url',
  /** column name */
  ThumbnailSmallUrl = 'thumbnail_small_url'
}

/** select columns of table "page_status" */
export enum Page_Status_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Name = 'name'
}

/** Ordering options when selecting data from "page_status". */
export type Page_Status_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Boolean expression to filter rows from the table "page_status". All fields are combined with a logical 'AND'. */
export type Page_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Page_Status_Bool_Exp>>;
  _not?: InputMaybe<Page_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Page_Status_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Enum-like table for page.status. Questionable utility. */
export type Page_Status = {
  /** page_status creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** page_status creation user. */
  creation_user: Scalars['uuid'];
  display_name: Maybe<Scalars['String']>;
  /** page_status last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified page_status. */
  last_modified_user: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  /** An object relationship */
  user: User_Pp;
};

/** aggregated selection of "pages_m2m_cache" */
export type Pages_M2m_Cache_Aggregate = {
  aggregate: Maybe<Pages_M2m_Cache_Aggregate_Fields>;
  nodes: Array<Pages_M2m_Cache>;
};

/** aggregate fields of "pages_m2m_cache" */
export type Pages_M2m_Cache_Aggregate_Fields = {
  avg: Maybe<Pages_M2m_Cache_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Pages_M2m_Cache_Max_Fields>;
  min: Maybe<Pages_M2m_Cache_Min_Fields>;
  stddev: Maybe<Pages_M2m_Cache_Stddev_Fields>;
  stddev_pop: Maybe<Pages_M2m_Cache_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Pages_M2m_Cache_Stddev_Samp_Fields>;
  sum: Maybe<Pages_M2m_Cache_Sum_Fields>;
  var_pop: Maybe<Pages_M2m_Cache_Var_Pop_Fields>;
  var_samp: Maybe<Pages_M2m_Cache_Var_Samp_Fields>;
  variance: Maybe<Pages_M2m_Cache_Variance_Fields>;
};


/** aggregate fields of "pages_m2m_cache" */
export type Pages_M2m_Cache_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Pages_M2m_Cache_Avg_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Pages_M2m_Cache_Max_Fields = {
  document_id: Maybe<Scalars['uuid']>;
  page: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['bigint']>;
  page_status: Maybe<Scalars['String']>;
  rotate: Maybe<Scalars['Int']>;
  thumbnail_big_url: Maybe<Scalars['String']>;
  thumbnail_small_url: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Pages_M2m_Cache_Min_Fields = {
  document_id: Maybe<Scalars['uuid']>;
  page: Maybe<Scalars['uuid']>;
  page_number: Maybe<Scalars['bigint']>;
  page_status: Maybe<Scalars['String']>;
  rotate: Maybe<Scalars['Int']>;
  thumbnail_big_url: Maybe<Scalars['String']>;
  thumbnail_small_url: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Pages_M2m_Cache_Stddev_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Pages_M2m_Cache_Stddev_Pop_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Pages_M2m_Cache_Stddev_Samp_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Pages_M2m_Cache_Sum_Fields = {
  page_number: Maybe<Scalars['bigint']>;
  rotate: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Pages_M2m_Cache_Var_Pop_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Pages_M2m_Cache_Var_Samp_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Pages_M2m_Cache_Variance_Fields = {
  page_number: Maybe<Scalars['Float']>;
  rotate: Maybe<Scalars['Float']>;
};

export type Pp_Addresses_Args = {
  _address_ids?: InputMaybe<Scalars['_int4']>;
  _address_types?: InputMaybe<Scalars['_int4']>;
  _empty_address_type?: InputMaybe<Scalars['Boolean']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _show_deleted?: InputMaybe<Scalars['Boolean']>;
};

export type Pp_Ai_Stats_Args = {
  _crusers?: InputMaybe<Scalars['_uuid']>;
  _ended?: InputMaybe<Scalars['timestamptz']>;
  _only_ai_doctypes?: InputMaybe<Scalars['Boolean']>;
  _orgids?: InputMaybe<Scalars['_int2']>;
  _started?: InputMaybe<Scalars['timestamptz']>;
};

export type Pp_Ai_Stats_Dt_Args = {
  _crusers?: InputMaybe<Scalars['_uuid']>;
  _ended?: InputMaybe<Scalars['timestamptz']>;
  _only_ai_doctypes?: InputMaybe<Scalars['Boolean']>;
  _orgids?: InputMaybe<Scalars['_int2']>;
  _started?: InputMaybe<Scalars['timestamptz']>;
};

export type Pp_Check_Json_Param_Args = {
  _param?: InputMaybe<Scalars['json']>;
};

export type Pp_Declaration_Request_Args = {
  _file_ids?: InputMaybe<Scalars['_uuid']>;
};

export type DeclarationRequestsArgs = {
  _addresses?: InputMaybe<Array<AddressFilter>>;
  _addresses_qi?: InputMaybe<Scalars['String']>;
  _arrival_type?: InputMaybe<Scalars['String']>;
  _clr_type?: InputMaybe<Scalars['String']>;
  _date_max?: InputMaybe<Scalars['LocalDateTime']>;
  _date_min?: InputMaybe<Scalars['LocalDateTime']>;
  _decl_type?: InputMaybe<Scalars['String']>;
  _declaration_labels?: InputMaybe<Scalars['String']>;
  _declaration_statuses?: InputMaybe<Scalars['String']>;
  _evv_status?: InputMaybe<Scalars['String']>;
  _file_id?: InputMaybe<Scalars['UUID']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Array<Scalars['JSONObject']>>;
  _payer?: InputMaybe<Scalars['UUID']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_field?: InputMaybe<Scalars['String']>;
};

export type DeclarationRequestsReportArgs = {
  _addresses?: InputMaybe<Array<AddressFilter>>;
  _addresses_qi?: InputMaybe<Scalars['String']>;
  _arrival_type?: InputMaybe<Scalars['String']>;
  _clr_type?: InputMaybe<Scalars['String']>;
  _columns?: InputMaybe<Array<Scalars['String']>>;
  _date_max?: InputMaybe<Scalars['LocalDateTime']>;
  _date_min?: InputMaybe<Scalars['LocalDateTime']>;
  _decl_type?: InputMaybe<Scalars['String']>;
  _declaration_labels?: InputMaybe<Scalars['String']>;
  _declaration_statuses?: InputMaybe<Scalars['String']>;
  _evv_status?: InputMaybe<Scalars['String']>;
  _file_id?: InputMaybe<Scalars['UUID']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Array<Scalars['JSONObject']>>;
  _payer?: InputMaybe<Scalars['UUID']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_field?: InputMaybe<Scalars['String']>;
  _total_items?: InputMaybe<Scalars['Int']>;
};

export type Pp_Declaration_Tasks_Args = {
  _assigned_to?: InputMaybe<Scalars['uuid']>;
  _creation_date?: InputMaybe<Scalars['timestamptz']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _max_due_date?: InputMaybe<Scalars['timestamptz']>;
  _min_due_date?: InputMaybe<Scalars['timestamptz']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_lang?: InputMaybe<Scalars['String']>;
  _task_status_id?: InputMaybe<Scalars['Int']>;
  _task_type_id?: InputMaybe<Scalars['Int']>;
};

export type Pp_Declaration_Tasks_Agg_Args = {
  _assigned_to?: InputMaybe<Scalars['uuid']>;
  _creation_date?: InputMaybe<Scalars['timestamptz']>;
  _max_due_date?: InputMaybe<Scalars['timestamptz']>;
  _min_due_date?: InputMaybe<Scalars['timestamptz']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_lang?: InputMaybe<Scalars['String']>;
  _task_type_id?: InputMaybe<Scalars['Int']>;
};

export type Pp_Declaration_Tasks_Obj_Args = {
  _assigned_to?: InputMaybe<Scalars['uuid']>;
  _creation_date?: InputMaybe<Scalars['timestamptz']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _max_due_date?: InputMaybe<Scalars['timestamptz']>;
  _min_due_date?: InputMaybe<Scalars['timestamptz']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _search_lang?: InputMaybe<Scalars['String']>;
  _task_status_id?: InputMaybe<Scalars['Int']>;
  _task_type_id?: InputMaybe<Scalars['Int']>;
};

export type Pp_Declarations_Args = {
  _addresses?: InputMaybe<Scalars['_int4']>;
  _enddate?: InputMaybe<Scalars['timestamptz']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _orgids?: InputMaybe<Scalars['_int4']>;
  _search?: InputMaybe<Scalars['String']>;
  _startdate?: InputMaybe<Scalars['timestamptz']>;
};

export type Pp_Delete_Declaration_Requests_Args = {
  _file_ids?: InputMaybe<Scalars['_uuid']>;
};

export type Pp_Doc_Max_Date_V2_Args = {
  _my?: InputMaybe<Scalars['Boolean']>;
};

export type Pp_Doc_Search_Args = {
  _creationuser?: InputMaybe<Scalars['uuid']>;
  _curr_userid?: InputMaybe<Scalars['uuid']>;
  _docflags?: InputMaybe<Scalars['bigint']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _searchval?: InputMaybe<Scalars['String']>;
};

export type Pp_Doc_Search_Hs_Args = {
  _creationuser?: InputMaybe<Scalars['uuid']>;
  _docflags?: InputMaybe<Scalars['bigint']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _searchval?: InputMaybe<Scalars['String']>;
};

export type Pp_Doc_Stats_Args = {
  _crusers?: InputMaybe<Scalars['_uuid']>;
  _ended?: InputMaybe<Scalars['timestamptz']>;
  _orgids?: InputMaybe<Scalars['_int2']>;
  _started?: InputMaybe<Scalars['timestamptz']>;
  _tenant?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Docs_For_Validation_Args = {
  _doc_id?: InputMaybe<Scalars['uuid']>;
  _org_ids?: InputMaybe<Scalars['_int2']>;
};

export type Pp_Document_Args = {
  _ids?: InputMaybe<Scalars['_uuid']>;
};

export type Pp_Document_Flag_Args = {
  _ids?: InputMaybe<Scalars['_int8']>;
};

export type Pp_Document_Labels_Args = {
  _ids?: InputMaybe<Scalars['_int4']>;
};

export type Pp_Dr_Stats_Args = {
  _metric?: InputMaybe<Scalars['String']>;
  _tenant_id?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Email_Search_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _userid?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Email_Search_Hs_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
};

export type Pp_File_Max_Date_V2_Args = {
  _my?: InputMaybe<Scalars['Boolean']>;
};

export type Pp_File_Search_Args = {
  _addresses?: InputMaybe<Scalars['_int4']>;
  _curr_userid?: InputMaybe<Scalars['uuid']>;
  _file_flags?: InputMaybe<Scalars['_int8']>;
  _file_statuses?: InputMaybe<Scalars['_text']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _max_date?: InputMaybe<Scalars['timestamptz']>;
  _min_date?: InputMaybe<Scalars['timestamptz']>;
  _my_files_only?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _org_ids?: InputMaybe<Scalars['_int2']>;
  _searchval?: InputMaybe<Scalars['String']>;
};

/** select columns of table "pp_types.file_search" */
export enum Pp_Types_File_Search_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsRelevant = 'customs_relevant',
  /** column name */
  CustomsRelevantQty = 'customs_relevant_qty',
  /** column name */
  ExtractionCompletedQty = 'extraction_completed_qty',
  /** column name */
  ExtractionRequired = 'extraction_required',
  /** column name */
  ExtractionRequiredQty = 'extraction_required_qty',
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Identification = 'identification',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgIdDescription = 'org_id_description',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  TotalRows = 'total_rows'
}

/** Ordering options when selecting data from "pp_types.file_search". */
export type Pp_Types_File_Search_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  customs_relevant?: InputMaybe<Order_By>;
  customs_relevant_qty?: InputMaybe<Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  extraction_completed_qty?: InputMaybe<Order_By>;
  extraction_required?: InputMaybe<Order_By>;
  extraction_required_qty?: InputMaybe<Order_By>;
  file_flags?: InputMaybe<Order_By>;
  file_status?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org?: InputMaybe<Org_Id_Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_id_description?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "pp_types.file_search". All fields are combined with a logical 'AND'. */
export type Pp_Types_File_Search_Bool_Exp = {
  _and?: InputMaybe<Array<Pp_Types_File_Search_Bool_Exp>>;
  _not?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
  _or?: InputMaybe<Array<Pp_Types_File_Search_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  customs_relevant?: InputMaybe<Boolean_Comparison_Exp>;
  customs_relevant_qty?: InputMaybe<Bigint_Comparison_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  extraction_completed_qty?: InputMaybe<Bigint_Comparison_Exp>;
  extraction_required?: InputMaybe<Boolean_Comparison_Exp>;
  extraction_required_qty?: InputMaybe<Bigint_Comparison_Exp>;
  file_flags?: InputMaybe<Bigint_Comparison_Exp>;
  file_status?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identification?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org?: InputMaybe<Org_Id_Bool_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  org_id_description?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
};

/** types.file_search used as SETOF type for pp_file_search% functions. By itself is not very useful */
export type Pp_Types_File_Search = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Scalars['uuid'];
  customs_relevant: Maybe<Scalars['Boolean']>;
  customs_relevant_qty: Maybe<Scalars['bigint']>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  extraction_completed_qty: Maybe<Scalars['bigint']>;
  extraction_required: Maybe<Scalars['Boolean']>;
  extraction_required_qty: Maybe<Scalars['bigint']>;
  file_flags: Scalars['bigint'];
  file_status: Scalars['String'];
  file_url: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  identification: Maybe<Scalars['String']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Scalars['jsonb'];
  name: Maybe<Scalars['String']>;
  /** An object relationship */
  org: Maybe<Org_Id>;
  org_id: Scalars['smallint'];
  org_id_description: Scalars['String'];
  session_id: Scalars['String'];
  total_rows: Maybe<Scalars['bigint']>;
};


/** types.file_search used as SETOF type for pp_file_search% functions. By itself is not very useful */
export type Pp_Types_File_SearchDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** types.file_search used as SETOF type for pp_file_search% functions. By itself is not very useful */
export type Pp_Types_File_SearchDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** types.file_search used as SETOF type for pp_file_search% functions. By itself is not very useful */
export type Pp_Types_File_SearchMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type Pp_File_Search_Hs_Args = {
  _addresses?: InputMaybe<Scalars['_int4']>;
  _file_flags?: InputMaybe<Scalars['_int8']>;
  _file_statuses?: InputMaybe<Scalars['_text']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _max_date?: InputMaybe<Scalars['timestamptz']>;
  _min_date?: InputMaybe<Scalars['timestamptz']>;
  _my_files_only?: InputMaybe<Scalars['Boolean']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _org_ids?: InputMaybe<Scalars['_int2']>;
  _searchval?: InputMaybe<Scalars['String']>;
};

export type Pp_File_Stats_Args = {
  _crusers?: InputMaybe<Scalars['_uuid']>;
  _ended?: InputMaybe<Scalars['timestamptz']>;
  _orgids?: InputMaybe<Scalars['_int2']>;
  _started?: InputMaybe<Scalars['timestamptz']>;
};

export type CommodityCodeStatistics = {
  declarationCount: Scalars['Float'];
  goodsItemCount: Scalars['Float'];
  totalGrossMass: Scalars['Float'];
  totalNetMass: Scalars['Float'];
};

export type StatisticsDto = {
  avgCommodityCodesPerDeclaration: Scalars['Float'];
  commodityCodesChapters: Array<StatisticTariffNumberItem>;
  customsAgencies: Array<StatisticItem>;
  customsDeclarations: DateInterval;
};

export type StatisticTariffNumberItem = {
  chapter: Scalars['String'];
  declarationCount: Scalars['Float'];
  goodsItemCount: Scalars['Float'];
  heading: Scalars['String'];
  subheading: Scalars['String'];
  tariffNumber: Scalars['String'];
  totalGrossMass: Scalars['Float'];
  totalNetMass: Scalars['Float'];
};

export type StatisticItem = {
  count: Scalars['Float'];
  label: Scalars['String'];
  percentage: Scalars['Float'];
  traderIdentificationNumber: Scalars['String'];
};

export type DateInterval = {
  dateInterval: Array<DateIntervalItem>;
  tickInterval: Scalars['String'];
};

export type DateIntervalItem = {
  count: Scalars['Float'];
  date: Scalars['String'];
  lastYearCount: Scalars['Float'];
};

export type Pp_Kc_Users_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _tenants?: InputMaybe<Scalars['_uuid']>;
  _uid?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Last_Doc_In_Dr_Args = {
  _dr_no?: InputMaybe<Scalars['smallint']>;
  _file_id?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Org_Id_Delete_Args = {
  _force?: InputMaybe<Scalars['Boolean']>;
  _org_id?: InputMaybe<Scalars['smallint']>;
};

export type Pp_Org_Id_Insert_Args = {
  _desk?: InputMaybe<Scalars['String']>;
  _display_name?: InputMaybe<Scalars['String']>;
  _org_id?: InputMaybe<Scalars['smallint']>;
  _org_params?: InputMaybe<Scalars['json']>;
  _tenant?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Org_Id_Update_Args = {
  _desk?: InputMaybe<Scalars['String']>;
  _display_name?: InputMaybe<Scalars['String']>;
  _org_id?: InputMaybe<Scalars['smallint']>;
  _org_params?: InputMaybe<Scalars['json']>;
  _tenant?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Org_Ids_Args = {
  _id?: InputMaybe<Scalars['smallint']>;
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
};

export type Pp_Page_Extract_Grids_Text_Args = {
  _coordinates?: InputMaybe<Scalars['jsonb']>;
  _extract_type_id?: InputMaybe<Scalars['smallint']>;
  _page_id?: InputMaybe<Scalars['uuid']>;
};

export type Pp_Page_Extract_Text_Fragment_Args = {
  _extract_type_id?: InputMaybe<Scalars['smallint']>;
  _height?: InputMaybe<Scalars['numeric']>;
  _pageid?: InputMaybe<Scalars['uuid']>;
  _width?: InputMaybe<Scalars['numeric']>;
  _x?: InputMaybe<Scalars['numeric']>;
  _y?: InputMaybe<Scalars['numeric']>;
};

export type Pp_Page_Extract_Text_Fragment_V2_Args = {
  _extract_type_id?: InputMaybe<Scalars['smallint']>;
  _height?: InputMaybe<Scalars['numeric']>;
  _pageid?: InputMaybe<Scalars['uuid']>;
  _width?: InputMaybe<Scalars['numeric']>;
  _x?: InputMaybe<Scalars['numeric']>;
  _y?: InputMaybe<Scalars['numeric']>;
};

export type Pp_Tenants_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
  _tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** select columns of table "tenants" */
export enum Tenants_Select_Column {
  /** column name */
  AddressGroups = 'address_groups',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  PermissionsDesk = 'permissions_desk',
  /** column name */
  Qty = 'qty',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TenantName = 'tenant_name',
  /** column name */
  TenantType = 'tenant_type',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number'
}

/** Ordering options when selecting data from "tenants". */
export type Tenants_Order_By = {
  address?: InputMaybe<Address_Order_By>;
  address_groups?: InputMaybe<Order_By>;
  address_id?: InputMaybe<Order_By>;
  address_type?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  creationUser?: InputMaybe<User_Pp_Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  lastModifiedUser?: InputMaybe<User_Pp_Order_By>;
  permissions?: InputMaybe<Order_By>;
  permissions_desk?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_name?: InputMaybe<Order_By>;
  tenant_type?: InputMaybe<Order_By>;
  trader_identification_number?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<User_Pp_Aggregate_Order_By>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Tenants_Bool_Exp>>;
  _not?: InputMaybe<Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Tenants_Bool_Exp>>;
  address?: InputMaybe<Address_Bool_Exp>;
  address_groups?: InputMaybe<_Int2_Comparison_Exp>;
  address_id?: InputMaybe<Int_Comparison_Exp>;
  address_type?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  creationUser?: InputMaybe<User_Pp_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  lastModifiedUser?: InputMaybe<User_Pp_Bool_Exp>;
  permissions?: InputMaybe<String_Comparison_Exp>;
  permissions_desk?: InputMaybe<_Txtcode_Comparison_Exp>;
  qty?: InputMaybe<Bigint_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_name?: InputMaybe<String_Comparison_Exp>;
  tenant_type?: InputMaybe<Tenant_Type_Comparison_Exp>;
  trader_identification_number?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<User_Pp_Bool_Exp>;
};

/** SETOF type for pp_tenants() */
export type Tenants = {
  /** An object relationship */
  address: Maybe<Address>;
  address_groups: Maybe<Scalars['_int2']>;
  address_id: Scalars['Int'];
  address_type: Scalars['String'];
  company_name: Scalars['String'];
  creation_date: Scalars['timestamptz'];
  creation_user: Scalars['uuid'];
  /** An object relationship */
  creationUser: Maybe<User_Pp>;
  id: Scalars['uuid'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  /** An object relationship */
  lastModifiedUser: Maybe<User_Pp>;
  permissions: Maybe<Scalars['String']>;
  permissions_desk: Maybe<Scalars['_txtcode']>;
  qty: Maybe<Scalars['bigint']>;
  tenant_id: Maybe<Scalars['uuid']>;
  tenant_name: Scalars['String'];
  tenant_type: Maybe<Scalars['tenant_type']>;
  trader_identification_number: Maybe<Scalars['String']>;
  /** An array relationship */
  users: Array<User_Pp>;
};


/** SETOF type for pp_tenants() */
export type TenantsUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Pp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Pp_Order_By>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};

export type Pp_User_Org_Id_Args = {
  _uids?: InputMaybe<Scalars['_uuid']>;
};

export type Pp_User_Search_Args = {
  _limit?: InputMaybe<Scalars['Int']>;
  _offset?: InputMaybe<Scalars['Int']>;
  _orderby?: InputMaybe<Scalars['String']>;
  _search?: InputMaybe<Scalars['String']>;
};

/** select columns of table "user_search_type" */
export enum User_Search_Type_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Role = 'role',
  /** column name */
  TotalRows = 'total_rows'
}

/** Ordering options when selecting data from "user_search_type". */
export type User_Search_Type_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_search_type". All fields are combined with a logical 'AND'. */
export type User_Search_Type_Bool_Exp = {
  _and?: InputMaybe<Array<User_Search_Type_Bool_Exp>>;
  _not?: InputMaybe<User_Search_Type_Bool_Exp>;
  _or?: InputMaybe<Array<User_Search_Type_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<Json_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
};

/** SETOF-type used in pp_user_search and pp_user_search_hs */
export type User_Search_Type = {
  creation_date: Maybe<Scalars['timestamptz']>;
  display_name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  location: Maybe<Scalars['String']>;
  role: Maybe<Scalars['json']>;
  total_rows: Maybe<Scalars['bigint']>;
};


/** SETOF-type used in pp_user_search and pp_user_search_hs */
export type User_Search_TypeRoleArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type Pp_View_Document_History_Args = {
  _ids?: InputMaybe<Scalars['_uuid']>;
};

/** select columns of table "view_document_history" */
export enum View_Document_History_Select_Column {
  /** column name */
  ActionTitle = 'action_title',
  /** column name */
  ActionUser = 'action_user',
  /** column name */
  ActionValue = 'action_value',
  /** column name */
  Id = 'id',
  /** column name */
  OpDate = 'op_date'
}

/** Ordering options when selecting data from "view_document_history". */
export type View_Document_History_Order_By = {
  action_title?: InputMaybe<Order_By>;
  action_user?: InputMaybe<Order_By>;
  action_value?: InputMaybe<Order_By>;
  document?: InputMaybe<Document_Order_By>;
  id?: InputMaybe<Order_By>;
  op_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_document_history". All fields are combined with a logical 'AND'. */
export type View_Document_History_Bool_Exp = {
  _and?: InputMaybe<Array<View_Document_History_Bool_Exp>>;
  _not?: InputMaybe<View_Document_History_Bool_Exp>;
  _or?: InputMaybe<Array<View_Document_History_Bool_Exp>>;
  action_title?: InputMaybe<String_Comparison_Exp>;
  action_user?: InputMaybe<Uuid_Comparison_Exp>;
  action_value?: InputMaybe<String_Comparison_Exp>;
  document?: InputMaybe<Document_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  op_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** History of changes in document. */
export type View_Document_History = {
  action_title: Maybe<Scalars['String']>;
  action_user: Maybe<Scalars['uuid']>;
  action_value: Maybe<Scalars['String']>;
  /** An object relationship */
  document: Maybe<Document>;
  id: Scalars['uuid'];
  op_date: Scalars['timestamptz'];
};

export type Pp_View_File_History_Args = {
  _file_id?: InputMaybe<Scalars['uuid']>;
};

/** select columns of table "view_file_history" */
export enum View_File_History_Select_Column {
  /** column name */
  ActionTitle = 'action_title',
  /** column name */
  ActionUser = 'action_user',
  /** column name */
  ActionValue = 'action_value',
  /** column name */
  Id = 'id',
  /** column name */
  OpDate = 'op_date'
}

/** Ordering options when selecting data from "view_file_history". */
export type View_File_History_Order_By = {
  action_title?: InputMaybe<Order_By>;
  action_user?: InputMaybe<Order_By>;
  action_value?: InputMaybe<Order_By>;
  file?: InputMaybe<File_Order_By>;
  id?: InputMaybe<Order_By>;
  op_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_file_history". All fields are combined with a logical 'AND'. */
export type View_File_History_Bool_Exp = {
  _and?: InputMaybe<Array<View_File_History_Bool_Exp>>;
  _not?: InputMaybe<View_File_History_Bool_Exp>;
  _or?: InputMaybe<Array<View_File_History_Bool_Exp>>;
  action_title?: InputMaybe<String_Comparison_Exp>;
  action_user?: InputMaybe<Uuid_Comparison_Exp>;
  action_value?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<File_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  op_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** History of changes in table file. */
export type View_File_History = {
  action_title: Maybe<Scalars['String']>;
  action_user: Maybe<Scalars['uuid']>;
  action_value: Maybe<Scalars['String']>;
  /** An object relationship */
  file: Maybe<File>;
  id: Scalars['uuid'];
  op_date: Scalars['timestamptz'];
};

/** select columns of table "report" */
export enum Report_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Md5 = 'md5',
  /** column name */
  Status = 'status',
  /** column name */
  Url = 'url'
}

/** Ordering options when selecting data from "report". */
export type Report_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  md5?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "report". All fields are combined with a logical 'AND'. */
export type Report_Bool_Exp = {
  _and?: InputMaybe<Array<Report_Bool_Exp>>;
  _not?: InputMaybe<Report_Bool_Exp>;
  _or?: InputMaybe<Array<Report_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  md5?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "report" */
export type Report = {
  creation_date: Scalars['timestamptz'];
  creation_user: Scalars['uuid'];
  id: Scalars['uuid'];
  last_modified_date: Maybe<Scalars['timestamptz']>;
  md5: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** aggregated selection of "report" */
export type Report_Aggregate = {
  aggregate: Maybe<Report_Aggregate_Fields>;
  nodes: Array<Report>;
};

/** aggregate fields of "report" */
export type Report_Aggregate_Fields = {
  count: Scalars['Int'];
  max: Maybe<Report_Max_Fields>;
  min: Maybe<Report_Min_Fields>;
};


/** aggregate fields of "report" */
export type Report_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Report_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Report_Max_Fields = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  md5: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Report_Min_Fields = {
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  md5: Maybe<Scalars['String']>;
  status: Maybe<Scalars['String']>;
  url: Maybe<Scalars['String']>;
};

/** select columns of table "service" */
export enum Service_Select_Column {
  /** column name */
  SrvDesk = 'srv_desk',
  /** column name */
  SrvId = 'srv_id',
  /** column name */
  SrvType = 'srv_type',
  /** column name */
  Translation = 'translation'
}

/** select columns of table "service_tariff" */
export enum Service_Tariff_Select_Column {
  /** column name */
  DirectUploadCost = 'direct_upload_cost',
  /** column name */
  EmailUploadCost = 'email_upload_cost',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  PositionCost = 'position_cost',
  /** column name */
  PositionsIncluded = 'positions_included',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TenantId = 'tenant_id'
}

/** Ordering options when selecting data from "service_tariff". */
export type Service_Tariff_Order_By = {
  direct_upload_cost?: InputMaybe<Order_By>;
  email_upload_cost?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  position_cost?: InputMaybe<Order_By>;
  positions_included?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "service_tariff". All fields are combined with a logical 'AND'. */
export type Service_Tariff_Bool_Exp = {
  _and?: InputMaybe<Array<Service_Tariff_Bool_Exp>>;
  _not?: InputMaybe<Service_Tariff_Bool_Exp>;
  _or?: InputMaybe<Array<Service_Tariff_Bool_Exp>>;
  direct_upload_cost?: InputMaybe<Numeric_Comparison_Exp>;
  email_upload_cost?: InputMaybe<Numeric_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  position_cost?: InputMaybe<Numeric_Comparison_Exp>;
  positions_included?: InputMaybe<Int_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** columns and relationships of "service_tariff" */
export type Service_Tariff = {
  direct_upload_cost: Maybe<Scalars['numeric']>;
  email_upload_cost: Maybe<Scalars['numeric']>;
  end_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  position_cost: Maybe<Scalars['numeric']>;
  positions_included: Maybe<Scalars['Int']>;
  start_date: Maybe<Scalars['date']>;
  tenant_id: Maybe<Scalars['uuid']>;
};


/** columns and relationships of "service_tariff" */
export type Service_TariffMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "service_tariff" */
export type Service_Tariff_Aggregate = {
  aggregate: Maybe<Service_Tariff_Aggregate_Fields>;
  nodes: Array<Service_Tariff>;
};

/** aggregate fields of "service_tariff" */
export type Service_Tariff_Aggregate_Fields = {
  avg: Maybe<Service_Tariff_Avg_Fields>;
  count: Scalars['Int'];
  max: Maybe<Service_Tariff_Max_Fields>;
  min: Maybe<Service_Tariff_Min_Fields>;
  stddev: Maybe<Service_Tariff_Stddev_Fields>;
  stddev_pop: Maybe<Service_Tariff_Stddev_Pop_Fields>;
  stddev_samp: Maybe<Service_Tariff_Stddev_Samp_Fields>;
  sum: Maybe<Service_Tariff_Sum_Fields>;
  var_pop: Maybe<Service_Tariff_Var_Pop_Fields>;
  var_samp: Maybe<Service_Tariff_Var_Samp_Fields>;
  variance: Maybe<Service_Tariff_Variance_Fields>;
};


/** aggregate fields of "service_tariff" */
export type Service_Tariff_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Service_Tariff_Avg_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Service_Tariff_Max_Fields = {
  direct_upload_cost: Maybe<Scalars['numeric']>;
  email_upload_cost: Maybe<Scalars['numeric']>;
  end_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  position_cost: Maybe<Scalars['numeric']>;
  positions_included: Maybe<Scalars['Int']>;
  start_date: Maybe<Scalars['date']>;
  tenant_id: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Service_Tariff_Min_Fields = {
  direct_upload_cost: Maybe<Scalars['numeric']>;
  email_upload_cost: Maybe<Scalars['numeric']>;
  end_date: Maybe<Scalars['date']>;
  id: Maybe<Scalars['uuid']>;
  position_cost: Maybe<Scalars['numeric']>;
  positions_included: Maybe<Scalars['Int']>;
  start_date: Maybe<Scalars['date']>;
  tenant_id: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Service_Tariff_Stddev_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Service_Tariff_Stddev_Pop_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Service_Tariff_Stddev_Samp_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Service_Tariff_Sum_Fields = {
  direct_upload_cost: Maybe<Scalars['numeric']>;
  email_upload_cost: Maybe<Scalars['numeric']>;
  position_cost: Maybe<Scalars['numeric']>;
  positions_included: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Service_Tariff_Var_Pop_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Service_Tariff_Var_Samp_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Service_Tariff_Variance_Fields = {
  direct_upload_cost: Maybe<Scalars['Float']>;
  email_upload_cost: Maybe<Scalars['Float']>;
  position_cost: Maybe<Scalars['Float']>;
  positions_included: Maybe<Scalars['Float']>;
};

/** select columns of table "setting" */
export enum Setting_Select_Column {
  /** column name */
  Constrained = 'constrained',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DataType = 'data_type',
  /** column name */
  DefaultValue = 'default_value',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Identifier = 'identifier',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  MaxValue = 'max_value',
  /** column name */
  MinValue = 'min_value',
  /** column name */
  SettingGroupId = 'setting_group_id'
}

/** Ordering options when selecting data from "setting". */
export type Setting_Order_By = {
  constrained?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
  setting_group?: InputMaybe<Setting_Group_Order_By>;
  setting_group_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** Ordering options when selecting data from "setting_group". */
export type Setting_Group_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  settings_aggregate?: InputMaybe<Setting_Aggregate_Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
};

/** order by aggregate values of table "setting" */
export type Setting_Aggregate_Order_By = {
  avg?: InputMaybe<Setting_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Setting_Max_Order_By>;
  min?: InputMaybe<Setting_Min_Order_By>;
  stddev?: InputMaybe<Setting_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Setting_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Setting_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Setting_Sum_Order_By>;
  var_pop?: InputMaybe<Setting_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Setting_Var_Samp_Order_By>;
  variance?: InputMaybe<Setting_Variance_Order_By>;
};

/** order by avg() on columns of table "setting" */
export type Setting_Avg_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "setting" */
export type Setting_Max_Order_By = {
  /** setting creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** setting creation user. */
  creation_user?: InputMaybe<Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** id of setting. */
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  /** setting last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified setting. */
  last_modified_user?: InputMaybe<Order_By>;
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
  setting_group_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "setting" */
export type Setting_Min_Order_By = {
  /** setting creation date. */
  creation_date?: InputMaybe<Order_By>;
  /** setting creation user. */
  creation_user?: InputMaybe<Order_By>;
  data_type?: InputMaybe<Order_By>;
  default_value?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** id of setting. */
  id?: InputMaybe<Order_By>;
  identifier?: InputMaybe<Order_By>;
  /** setting last modification date. */
  last_modified_date?: InputMaybe<Order_By>;
  /** Last user that modified setting. */
  last_modified_user?: InputMaybe<Order_By>;
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
  setting_group_id?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "setting" */
export type Setting_Stddev_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "setting" */
export type Setting_Stddev_Pop_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "setting" */
export type Setting_Stddev_Samp_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "setting" */
export type Setting_Sum_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "setting" */
export type Setting_Var_Pop_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "setting" */
export type Setting_Var_Samp_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "setting" */
export type Setting_Variance_Order_By = {
  max_value?: InputMaybe<Order_By>;
  min_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "setting". All fields are combined with a logical 'AND'. */
export type Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Setting_Bool_Exp>>;
  _not?: InputMaybe<Setting_Bool_Exp>;
  _or?: InputMaybe<Array<Setting_Bool_Exp>>;
  constrained?: InputMaybe<Boolean_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  data_type?: InputMaybe<String_Comparison_Exp>;
  default_value?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identifier?: InputMaybe<String_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  max_value?: InputMaybe<Numeric_Comparison_Exp>;
  min_value?: InputMaybe<Numeric_Comparison_Exp>;
  setting_group?: InputMaybe<Setting_Group_Bool_Exp>;
  setting_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "setting_group". All fields are combined with a logical 'AND'. */
export type Setting_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Setting_Group_Bool_Exp>>;
  _not?: InputMaybe<Setting_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Setting_Group_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  settings?: InputMaybe<Setting_Bool_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
};

/** Settings. This thing is itself db-in-db. Never saw in usage. */
export type Setting = {
  constrained: Maybe<Scalars['Boolean']>;
  /** setting creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** setting creation user. */
  creation_user: Scalars['uuid'];
  data_type: Maybe<Scalars['String']>;
  default_value: Maybe<Scalars['String']>;
  description: Scalars['String'];
  /** id of setting. */
  id: Scalars['uuid'];
  identifier: Scalars['String'];
  /** setting last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified setting. */
  last_modified_user: Maybe<Scalars['uuid']>;
  max_value: Maybe<Scalars['numeric']>;
  min_value: Maybe<Scalars['numeric']>;
  /** An object relationship */
  setting_group: Maybe<Setting_Group>;
  setting_group_id: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user: User_Pp;
};

/** Settings has groupes. Nothing more could be said about them. */
export type Setting_Group = {
  /** setting_group creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** setting_group creation user. */
  creation_user: Scalars['uuid'];
  description: Scalars['String'];
  /** id of setting_group. */
  id: Scalars['uuid'];
  /** setting_group last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified setting_group. */
  last_modified_user: Maybe<Scalars['uuid']>;
  /** An array relationship */
  settings: Array<Setting>;
  /** An object relationship */
  user: User_Pp;
};


/** Settings has groupes. Nothing more could be said about them. */
export type Setting_GroupSettingsArgs = {
  distinct_on?: InputMaybe<Array<Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Order_By>>;
  where?: InputMaybe<Setting_Bool_Exp>;
};

/** select columns of table "setting_group" */
export enum Setting_Group_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user'
}

/** select columns of table "setting_value" */
export enum Setting_Value_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  ReferenceTypeId = 'reference_type_id',
  /** column name */
  SettingId = 'setting_id',
  /** column name */
  Value = 'value'
}

/** Ordering options when selecting data from "setting_value". */
export type Setting_Value_Order_By = {
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_template?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  reference_id?: InputMaybe<Order_By>;
  reference_type_id?: InputMaybe<Order_By>;
  setting_id?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Pp_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "setting_value". All fields are combined with a logical 'AND'. */
export type Setting_Value_Bool_Exp = {
  _and?: InputMaybe<Array<Setting_Value_Bool_Exp>>;
  _not?: InputMaybe<Setting_Value_Bool_Exp>;
  _or?: InputMaybe<Array<Setting_Value_Bool_Exp>>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_template?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  reference_id?: InputMaybe<String_Comparison_Exp>;
  reference_type_id?: InputMaybe<String_Comparison_Exp>;
  setting_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<User_Pp_Bool_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** DB in DB. Reason to think about deprecation. */
export type Setting_Value = {
  /** setting_value creation date. */
  creation_date: Maybe<Scalars['timestamptz']>;
  /** setting_value creation user. */
  creation_user: Scalars['uuid'];
  display_name: Scalars['String'];
  /** id of setting_value. */
  id: Scalars['uuid'];
  is_template: Scalars['Boolean'];
  /** setting_value last modification date. */
  last_modified_date: Maybe<Scalars['timestamptz']>;
  /** Last user that modified setting_value. */
  last_modified_user: Maybe<Scalars['uuid']>;
  reference_id: Scalars['String'];
  reference_type_id: Scalars['String'];
  setting_id: Scalars['uuid'];
  /** An object relationship */
  user: User_Pp;
  value: Maybe<Scalars['jsonb']>;
};


/** DB in DB. Reason to think about deprecation. */
export type Setting_ValueValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** select columns of table "tariff_number_description" */
export enum Tariff_Number_Description_Select_Column {
  /** column name */
  DescriptionDe = 'description_de',
  /** column name */
  HierarchyPath = 'hierarchy_path',
  /** column name */
  HierarchyVisual = 'hierarchy_visual',
  /** column name */
  Id = 'id',
  /** column name */
  ParentId = 'parent_id',
  /** column name */
  TariffNumber = 'tariff_number',
  /** column name */
  Tsv = 'tsv'
}

/** Ordering options when selecting data from "tariff_number_description". */
export type Tariff_Number_Description_Order_By = {
  description_de?: InputMaybe<Order_By>;
  hierarchy_path?: InputMaybe<Order_By>;
  hierarchy_visual?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_id?: InputMaybe<Order_By>;
  tariff_number?: InputMaybe<Order_By>;
  tsv?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tariff_number_description". All fields are combined with a logical 'AND'. */
export type Tariff_Number_Description_Bool_Exp = {
  _and?: InputMaybe<Array<Tariff_Number_Description_Bool_Exp>>;
  _not?: InputMaybe<Tariff_Number_Description_Bool_Exp>;
  _or?: InputMaybe<Array<Tariff_Number_Description_Bool_Exp>>;
  description_de?: InputMaybe<String_Comparison_Exp>;
  hierarchy_path?: InputMaybe<Ltree_Comparison_Exp>;
  hierarchy_visual?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  parent_id?: InputMaybe<Int_Comparison_Exp>;
  tariff_number?: InputMaybe<String_Comparison_Exp>;
  tsv?: InputMaybe<Tsvector_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type Ltree_Comparison_Exp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestor_any?: InputMaybe<Array<Scalars['ltree']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']>;
  /** does array contain a descendant of `ltree`? */
  _descendant_any?: InputMaybe<Array<Scalars['ltree']>>;
  _eq?: InputMaybe<Scalars['ltree']>;
  _gt?: InputMaybe<Scalars['ltree']>;
  _gte?: InputMaybe<Scalars['ltree']>;
  _in?: InputMaybe<Array<Scalars['ltree']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['ltree']>;
  _lte?: InputMaybe<Scalars['ltree']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']>;
  /** does `ltree` match any `lquery` in array? */
  _matches_any?: InputMaybe<Array<Scalars['String']>>;
  /** does `ltree` match `ltxtquery`? */
  _matches_fulltext?: InputMaybe<Scalars['ltxtquery']>;
  _neq?: InputMaybe<Scalars['ltree']>;
  _nin?: InputMaybe<Array<Scalars['ltree']>>;
};

/** columns and relationships of "tariff_number_description" */
export type Tariff_Number_Description = {
  description_de: Maybe<Scalars['String']>;
  hierarchy_path: Maybe<Scalars['ltree']>;
  hierarchy_visual: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  parent_id: Maybe<Scalars['Int']>;
  tariff_number: Maybe<Scalars['String']>;
  tsv: Maybe<Scalars['tsvector']>;
};

/** select columns of table "task_type" */
export enum Task_Type_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta'
}

/** select columns of table "tenant" */
export enum Tenant_Select_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  IsWdCustomer = 'is_wd_customer',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  PermissionsJs = 'permissions_js',
  /** column name */
  TenantName = 'tenant_name',
  /** column name */
  TenantType = 'tenant_type',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number'
}

/** select columns of table "transitdoc_type_descr" */
export enum Transitdoc_Type_Descr_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  TransitdocType = 'transitdoc_type'
}

/** Ordering options when selecting data from "transitdoc_type_descr". */
export type Transitdoc_Type_Descr_Order_By = {
  description?: InputMaybe<Order_By>;
  transitdoc_type?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transitdoc_type_descr". All fields are combined with a logical 'AND'. */
export type Transitdoc_Type_Descr_Bool_Exp = {
  _and?: InputMaybe<Array<Transitdoc_Type_Descr_Bool_Exp>>;
  _not?: InputMaybe<Transitdoc_Type_Descr_Bool_Exp>;
  _or?: InputMaybe<Array<Transitdoc_Type_Descr_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  transitdoc_type?: InputMaybe<Transitdoc_Type_Comparison_Exp>;
};

/** columns and relationships of "transitdoc_type_descr" */
export type Transitdoc_Type_Descr = {
  description: Maybe<Scalars['String']>;
  transitdoc_type: Maybe<Scalars['transitdoc_type']>;
};

/** select columns of table "view_history" */
export enum View_History_Select_Column {
  /** column name */
  ActionTitle = 'action_title',
  /** column name */
  ActionUser = 'action_user',
  /** column name */
  ActionValue = 'action_value',
  /** column name */
  Entity = 'entity',
  /** column name */
  Id = 'id',
  /** column name */
  OpDate = 'op_date'
}

/** Ordering options when selecting data from "view_history". */
export type View_History_Order_By = {
  action_title?: InputMaybe<Order_By>;
  action_user?: InputMaybe<Order_By>;
  action_value?: InputMaybe<Order_By>;
  entity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  op_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "view_history". All fields are combined with a logical 'AND'. */
export type View_History_Bool_Exp = {
  _and?: InputMaybe<Array<View_History_Bool_Exp>>;
  _not?: InputMaybe<View_History_Bool_Exp>;
  _or?: InputMaybe<Array<View_History_Bool_Exp>>;
  action_title?: InputMaybe<String_Comparison_Exp>;
  action_user?: InputMaybe<Uuid_Comparison_Exp>;
  action_value?: InputMaybe<String_Comparison_Exp>;
  entity?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  op_date?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** History of changes in documents and files. */
export type View_History = {
  action_title: Maybe<Scalars['String']>;
  action_user: Maybe<Scalars['uuid']>;
  action_value: Maybe<Scalars['String']>;
  entity: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  op_date: Scalars['timestamptz'];
};

/** select columns of table "vw_documents" */
export enum Vw_Documents_Select_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Sequence = 'sequence'
}

/** Ordering options when selecting data from "vw_documents". */
export type Vw_Documents_Order_By = {
  checksum?: InputMaybe<Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  document_blobs?: InputMaybe<Order_By>;
  document_extension?: InputMaybe<Order_By>;
  document_flags?: InputMaybe<Order_By>;
  document_name?: InputMaybe<Order_By>;
  document_status?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Order_By>;
  documentType?: InputMaybe<Document_Type_Order_By>;
  file?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_customs_relevant?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_generated?: InputMaybe<Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  number_of_pages?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Order_By>;
  sequence?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vw_documents". All fields are combined with a logical 'AND'. */
export type Vw_Documents_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Documents_Bool_Exp>>;
  _not?: InputMaybe<Vw_Documents_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Documents_Bool_Exp>>;
  checksum?: InputMaybe<String_Comparison_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  document_blobs?: InputMaybe<Jsonb_Comparison_Exp>;
  document_extension?: InputMaybe<String_Comparison_Exp>;
  document_flags?: InputMaybe<Bigint_Comparison_Exp>;
  document_name?: InputMaybe<String_Comparison_Exp>;
  document_status?: InputMaybe<String_Comparison_Exp>;
  document_type?: InputMaybe<String_Comparison_Exp>;
  documentType?: InputMaybe<Document_Type_Bool_Exp>;
  file?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_customs_relevant?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_generated?: InputMaybe<Boolean_Comparison_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  number_of_pages?: InputMaybe<Smallint_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  pages_m2m?: InputMaybe<Document_Page_Bool_Exp>;
  pages_m2m_aggregate?: InputMaybe<Document_Page_Aggregate_Bool_Exp>;
  sequence?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "vw_documents" */
export type Vw_Documents = {
  checksum: Maybe<Scalars['String']>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  document_blobs: Maybe<Scalars['jsonb']>;
  document_extension: Maybe<Scalars['String']>;
  document_flags: Maybe<Scalars['bigint']>;
  document_name: Maybe<Scalars['String']>;
  document_status: Maybe<Scalars['String']>;
  document_type: Maybe<Scalars['String']>;
  /** An object relationship */
  documentType: Maybe<Document_Type>;
  file: Maybe<Scalars['uuid']>;
  id: Maybe<Scalars['uuid']>;
  is_customs_relevant: Maybe<Scalars['Boolean']>;
  is_deleted: Maybe<Scalars['Boolean']>;
  is_generated: Maybe<Scalars['Boolean']>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  number_of_pages: Maybe<Scalars['smallint']>;
  org_id: Maybe<Scalars['smallint']>;
  /** An array relationship */
  pages_m2m: Array<Document_Page>;
  /** An aggregate relationship */
  pages_m2m_aggregate: Document_Page_Aggregate;
  sequence: Maybe<Scalars['Int']>;
};


/** columns and relationships of "vw_documents" */
export type Vw_DocumentsDocument_BlobsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "vw_documents" */
export type Vw_DocumentsMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "vw_documents" */
export type Vw_DocumentsPages_M2mArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


/** columns and relationships of "vw_documents" */
export type Vw_DocumentsPages_M2m_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};

/** select columns of table "vw_finished_files" */
export enum Vw_Finished_Files_Select_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Identification = 'identification',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SessionId = 'session_id'
}

/** Ordering options when selecting data from "vw_finished_files". */
export type Vw_Finished_Files_Order_By = {
  created_by_user?: InputMaybe<User_Pp_Order_By>;
  creation_date?: InputMaybe<Order_By>;
  creation_user?: InputMaybe<Order_By>;
  declarations_aggregate?: InputMaybe<Declaration_Request_Aggregate_Order_By>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Order_By>;
  file_flags?: InputMaybe<Order_By>;
  file_status?: InputMaybe<Order_By>;
  file_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification?: InputMaybe<Order_By>;
  last_modified_by_user?: InputMaybe<User_Pp_Order_By>;
  last_modified_date?: InputMaybe<Order_By>;
  last_modified_user?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Org_Id_Order_By>;
  session_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "vw_finished_files". All fields are combined with a logical 'AND'. */
export type Vw_Finished_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Vw_Finished_Files_Bool_Exp>>;
  _not?: InputMaybe<Vw_Finished_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Vw_Finished_Files_Bool_Exp>>;
  created_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  creation_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  creation_user?: InputMaybe<Uuid_Comparison_Exp>;
  declarations?: InputMaybe<Declaration_Request_Bool_Exp>;
  documents?: InputMaybe<Document_Bool_Exp>;
  documents_aggregate?: InputMaybe<Document_Aggregate_Bool_Exp>;
  file_flags?: InputMaybe<Bigint_Comparison_Exp>;
  file_status?: InputMaybe<String_Comparison_Exp>;
  file_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identification?: InputMaybe<String_Comparison_Exp>;
  last_modified_by_user?: InputMaybe<User_Pp_Bool_Exp>;
  last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_modified_user?: InputMaybe<Uuid_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  org_id?: InputMaybe<Smallint_Comparison_Exp>;
  orgId?: InputMaybe<Org_Id_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
};

/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_Files = {
  /** An object relationship */
  created_by_user: Maybe<User_Pp>;
  creation_date: Maybe<Scalars['timestamptz']>;
  creation_user: Maybe<Scalars['uuid']>;
  /** An array relationship */
  declarations: Array<Declaration_Request>;
  /** An array relationship */
  documents: Array<Document>;
  /** An aggregate relationship */
  documents_aggregate: Document_Aggregate;
  file_flags: Maybe<Scalars['bigint']>;
  file_status: Maybe<Scalars['String']>;
  file_url: Maybe<Scalars['String']>;
  id: Maybe<Scalars['uuid']>;
  identification: Maybe<Scalars['String']>;
  /** An object relationship */
  last_modified_by_user: Maybe<User_Pp>;
  last_modified_date: Maybe<Scalars['timestamptz']>;
  last_modified_user: Maybe<Scalars['uuid']>;
  meta: Maybe<Scalars['jsonb']>;
  name: Maybe<Scalars['String']>;
  org_id: Maybe<Scalars['smallint']>;
  /** An object relationship */
  orgId: Maybe<Org_Id>;
  session_id: Maybe<Scalars['String']>;
};


/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_FilesDeclarationsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_FilesDocumentsArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_FilesDocuments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


/** This view has no raison d'etre. It musr be deprecated. */
export type Vw_Finished_FilesMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** mutation root */
export type Mutation_Root = {
  acs_insert_address_one: Maybe<AddressAcs>;
  acs_update_address_visibility: Maybe<Array<Maybe<AddressVisibility>>>;
  activate2FA: UserResponse;
  addNotificationTrigger: Maybe<NotificationTrigger>;
  assignDeclarationLabels: Maybe<Array<Maybe<DeclarationLabelMutationOutput>>>;
  assignNotificationLabels: Maybe<Array<Maybe<NotificationLabelMutationOutput>>>;
  classifyWeDeclareDocument: Maybe<Scalars['JSON']>;
  copyDeclarationAndGoodsItems: Scalars['Boolean'];
  createAditUser: Scalars['Boolean'];
  createDeclarationMessage: Maybe<CreateDeclarationMessageResponse>;
  createDeclarationReq: Maybe<CreateDeclarationReqResponse>;
  createDeclarationRequest: CreateDeclarationRequestResponse;
  createDocument: Maybe<CreateDocumentResponse>;
  createDocumentType: Scalars['Boolean'];
  createEmptyDocument: Maybe<CreateEmptyDocumentResponse>;
  createTenantACS: Scalars['Boolean'];
  createWDUser: Scalars['Boolean'];
  /** delete data from the table: "address" */
  delete_address: Maybe<Address_Mutation_Response>;
  /** delete single row from the table: "address" */
  delete_address_by_pk: Maybe<Address>;
  /** delete data from the table: "containers" */
  delete_containers: Maybe<Containers_Mutation_Response>;
  /** delete single row from the table: "containers" */
  delete_containers_by_pk: Maybe<Containers>;
  /** delete data from the table: "declaration" */
  delete_declaration: Maybe<Declaration_Mutation_Response>;
  /** delete single row from the table: "declaration" */
  delete_declaration_by_pk: Maybe<Declaration>;
  /** delete data from the table: "declaration_discussion" */
  delete_declaration_discussion: Maybe<Declaration_Discussion_Mutation_Response>;
  /** delete single row from the table: "declaration_discussion" */
  delete_declaration_discussion_by_pk: Maybe<Declaration_Discussion>;
  /** delete data from the table: "declaration_message" */
  delete_declaration_message: Maybe<Declaration_Message_Mutation_Response>;
  /** delete single row from the table: "declaration_message" */
  delete_declaration_message_by_pk: Maybe<Declaration_Message>;
  /** delete data from the table: "declaration_request" */
  delete_declaration_request: Maybe<Declaration_Request_Mutation_Response>;
  /** delete data from the table: "declaration_request_address" */
  delete_declaration_request_address: Maybe<Declaration_Request_Address_Mutation_Response>;
  /** delete single row from the table: "declaration_request_address" */
  delete_declaration_request_address_by_pk: Maybe<Declaration_Request_Address>;
  /** delete single row from the table: "declaration_request" */
  delete_declaration_request_by_pk: Maybe<Declaration_Request>;
  /** delete data from the table: "declaration_special_mentions" */
  delete_declaration_special_mentions: Maybe<Declaration_Special_Mentions_Mutation_Response>;
  /** delete single row from the table: "declaration_special_mentions" */
  delete_declaration_special_mentions_by_pk: Maybe<Declaration_Special_Mentions>;
  /** delete data from the table: "doc_annotation" */
  delete_doc_annotation: Maybe<Doc_Annotation_Mutation_Response>;
  /** delete single row from the table: "doc_annotation" */
  delete_doc_annotation_by_pk: Maybe<Doc_Annotation>;
  /** delete data from the table: "document" */
  delete_document: Maybe<Document_Mutation_Response>;
  /** delete single row from the table: "document" */
  delete_document_by_pk: Maybe<Document>;
  /** delete data from the table: "document_labels" */
  delete_document_labels: Maybe<Document_Labels_Mutation_Response>;
  /** delete single row from the table: "document_labels" */
  delete_document_labels_by_pk: Maybe<Document_Labels>;
  /** delete data from the table: "document_type" */
  delete_document_type: Maybe<Document_Type_Mutation_Response>;
  /** delete single row from the table: "document_type" */
  delete_document_type_by_pk: Maybe<Document_Type>;
  /** delete data from the table: "document_type_tenant_settings" */
  delete_document_type_tenant_settings: Maybe<Document_Type_Tenant_Settings_Mutation_Response>;
  /** delete single row from the table: "document_type_tenant_settings" */
  delete_document_type_tenant_settings_by_pk: Maybe<Document_Type_Tenant_Settings>;
  /** delete data from the table: "file" */
  delete_file: Maybe<File_Mutation_Response>;
  /** delete single row from the table: "file" */
  delete_file_by_pk: Maybe<File>;
  /** delete data from the table: "goods_item" */
  delete_goods_item: Maybe<Goods_Item_Mutation_Response>;
  /** delete single row from the table: "goods_item" */
  delete_goods_item_by_pk: Maybe<Goods_Item>;
  /** delete data from the table: "import_list_trigger" */
  delete_import_list_trigger: Maybe<Import_List_Trigger_Mutation_Response>;
  /** delete single row from the table: "import_list_trigger" */
  delete_import_list_trigger_by_pk: Maybe<Import_List_Trigger>;
  /** delete data from the table: "packagings" */
  delete_packagings: Maybe<Packagings_Mutation_Response>;
  /** delete single row from the table: "packagings" */
  delete_packagings_by_pk: Maybe<Packagings>;
  /** delete data from the table: "page" */
  delete_page: Maybe<Page_Mutation_Response>;
  /** delete single row from the table: "page" */
  delete_page_by_pk: Maybe<Page>;
  /** delete data from the table: "page_extract" */
  delete_page_extract: Maybe<Page_Extract_Mutation_Response>;
  /** delete single row from the table: "page_extract" */
  delete_page_extract_by_pk: Maybe<Page_Extract>;
  /** delete data from the table: "previous_documents" */
  delete_previous_documents: Maybe<Previous_Documents_Mutation_Response>;
  /** delete single row from the table: "previous_documents" */
  delete_previous_documents_by_pk: Maybe<Previous_Documents>;
  /** delete data from the table: "produced_documents" */
  delete_produced_documents: Maybe<Produced_Documents_Mutation_Response>;
  /** delete single row from the table: "produced_documents" */
  delete_produced_documents_by_pk: Maybe<Produced_Documents>;
  /** delete data from the table: "service_tariff" */
  delete_service_tariff: Maybe<Service_Tariff_Mutation_Response>;
  /** delete data from the table: "setting_value" */
  delete_setting_value: Maybe<Setting_Value_Mutation_Response>;
  /** delete single row from the table: "setting_value" */
  delete_setting_value_by_pk: Maybe<Setting_Value>;
  /** delete data from the table: "user_pp" */
  delete_user_pp: Maybe<User_Pp_Mutation_Response>;
  /** delete single row from the table: "user_pp" */
  delete_user_pp_by_pk: Maybe<User_Pp>;
  deleteNotificationTrigger: Maybe<NotificationTrigger>;
  deleteTenantReport: Scalars['Boolean'];
  editAddressACS: AddressAcs;
  editDocumentType: Scalars['Boolean'];
  editTenantACS: Scalars['Boolean'];
  enqueueDocument: Maybe<CreateDocumentResponse>;
  exportDeclaration: Scalars['Boolean'];
  finishDocumentValidation: Maybe<Scalars['JSON']>;
  generate2FA: UserResponse;
  generateExcelCombinedReport: Scalars['Boolean'];
  generateExcelDeclarationReport: Scalars['Boolean'];
  /** insert data into the table: "address" */
  insert_address: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one: Maybe<Address>;
  /** insert data into the table: "address_override" */
  insert_address_override: Maybe<Address_Override_Mutation_Response>;
  /** insert a single row into the table: "address_override" */
  insert_address_override_one: Maybe<Address_Override>;
  /** insert data into the table: "bill_detail" */
  insert_bill_detail: Maybe<Bill_Detail_Mutation_Response>;
  /** insert a single row into the table: "bill_detail" */
  insert_bill_detail_one: Maybe<Bill_Detail>;
  /** insert data into the table: "containers" */
  insert_containers: Maybe<Containers_Mutation_Response>;
  /** insert a single row into the table: "containers" */
  insert_containers_one: Maybe<Containers>;
  /** insert data into the table: "declaration" */
  insert_declaration: Maybe<Declaration_Mutation_Response>;
  /** insert data into the table: "declaration_discussion" */
  insert_declaration_discussion: Maybe<Declaration_Discussion_Mutation_Response>;
  /** insert a single row into the table: "declaration_discussion" */
  insert_declaration_discussion_one: Maybe<Declaration_Discussion>;
  /** insert data into the table: "declaration_message" */
  insert_declaration_message: Maybe<Declaration_Message_Mutation_Response>;
  /** insert a single row into the table: "declaration_message" */
  insert_declaration_message_one: Maybe<Declaration_Message>;
  /** insert a single row into the table: "declaration" */
  insert_declaration_one: Maybe<Declaration>;
  /** insert data into the table: "declaration_request" */
  insert_declaration_request: Maybe<Declaration_Request_Mutation_Response>;
  /** insert data into the table: "declaration_request_address" */
  insert_declaration_request_address: Maybe<Declaration_Request_Address_Mutation_Response>;
  /** insert a single row into the table: "declaration_request_address" */
  insert_declaration_request_address_one: Maybe<Declaration_Request_Address>;
  /** insert a single row into the table: "declaration_request" */
  insert_declaration_request_one: Maybe<Declaration_Request>;
  /** insert data into the table: "declaration_special_mentions" */
  insert_declaration_special_mentions: Maybe<Declaration_Special_Mentions_Mutation_Response>;
  /** insert a single row into the table: "declaration_special_mentions" */
  insert_declaration_special_mentions_one: Maybe<Declaration_Special_Mentions>;
  /** insert data into the table: "doc_annotation" */
  insert_doc_annotation: Maybe<Doc_Annotation_Mutation_Response>;
  /** insert a single row into the table: "doc_annotation" */
  insert_doc_annotation_one: Maybe<Doc_Annotation>;
  /** insert data into the table: "document" */
  insert_document: Maybe<Document_Mutation_Response>;
  /** insert data into the table: "document_label_org_id" */
  insert_document_label_org_id: Maybe<Document_Label_Org_Id_Mutation_Response>;
  /** insert a single row into the table: "document_label_org_id" */
  insert_document_label_org_id_one: Maybe<Document_Label_Org_Id>;
  /** insert data into the table: "document_labels" */
  insert_document_labels: Maybe<Document_Labels_Mutation_Response>;
  /** insert a single row into the table: "document_labels" */
  insert_document_labels_one: Maybe<Document_Labels>;
  /** insert a single row into the table: "document" */
  insert_document_one: Maybe<Document>;
  /** insert data into the table: "document_type" */
  insert_document_type: Maybe<Document_Type_Mutation_Response>;
  /** insert a single row into the table: "document_type" */
  insert_document_type_one: Maybe<Document_Type>;
  /** insert data into the table: "document_type_tenant_settings" */
  insert_document_type_tenant_settings: Maybe<Document_Type_Tenant_Settings_Mutation_Response>;
  /** insert a single row into the table: "document_type_tenant_settings" */
  insert_document_type_tenant_settings_one: Maybe<Document_Type_Tenant_Settings>;
  /** insert data into the table: "file" */
  insert_file: Maybe<File_Mutation_Response>;
  /** insert a single row into the table: "file" */
  insert_file_one: Maybe<File>;
  /** insert data into the table: "goods_item" */
  insert_goods_item: Maybe<Goods_Item_Mutation_Response>;
  /** insert a single row into the table: "goods_item" */
  insert_goods_item_one: Maybe<Goods_Item>;
  /** insert data into the table: "import_list_trigger" */
  insert_import_list_trigger: Maybe<Import_List_Trigger_Mutation_Response>;
  /** insert a single row into the table: "import_list_trigger" */
  insert_import_list_trigger_one: Maybe<Import_List_Trigger>;
  /** insert data into the table: "model_retrain" */
  insert_model_retrain: Maybe<Model_Retrain_Mutation_Response>;
  /** insert a single row into the table: "model_retrain" */
  insert_model_retrain_one: Maybe<Model_Retrain>;
  /** insert data into the table: "packagings" */
  insert_packagings: Maybe<Packagings_Mutation_Response>;
  /** insert a single row into the table: "packagings" */
  insert_packagings_one: Maybe<Packagings>;
  /** insert data into the table: "page" */
  insert_page: Maybe<Page_Mutation_Response>;
  /** insert data into the table: "page_extract" */
  insert_page_extract: Maybe<Page_Extract_Mutation_Response>;
  /** insert a single row into the table: "page_extract" */
  insert_page_extract_one: Maybe<Page_Extract>;
  /** insert a single row into the table: "page" */
  insert_page_one: Maybe<Page>;
  /** insert data into the table: "previous_documents" */
  insert_previous_documents: Maybe<Previous_Documents_Mutation_Response>;
  /** insert a single row into the table: "previous_documents" */
  insert_previous_documents_one: Maybe<Previous_Documents>;
  /** insert data into the table: "produced_documents" */
  insert_produced_documents: Maybe<Produced_Documents_Mutation_Response>;
  /** insert a single row into the table: "produced_documents" */
  insert_produced_documents_one: Maybe<Produced_Documents>;
  /** insert data into the table: "service_tariff" */
  insert_service_tariff: Maybe<Service_Tariff_Mutation_Response>;
  /** insert a single row into the table: "service_tariff" */
  insert_service_tariff_one: Maybe<Service_Tariff>;
  /** insert data into the table: "setting_value" */
  insert_setting_value: Maybe<Setting_Value_Mutation_Response>;
  /** insert a single row into the table: "setting_value" */
  insert_setting_value_one: Maybe<Setting_Value>;
  /** insert data into the table: "tenant" */
  insert_tenant: Maybe<Tenant_Mutation_Response>;
  /** insert a single row into the table: "tenant" */
  insert_tenant_one: Maybe<Tenant>;
  /** insert data into the table: "user_org_id" */
  insert_user_org_id: Maybe<User_Org_Id_Mutation_Response>;
  /** insert a single row into the table: "user_org_id" */
  insert_user_org_id_one: Maybe<User_Org_Id>;
  /** insert data into the table: "user_pp" */
  insert_user_pp: Maybe<User_Pp_Mutation_Response>;
  /** insert a single row into the table: "user_pp" */
  insert_user_pp_one: Maybe<User_Pp>;
  linkAddressesACS: Array<AddressMappingEntity>;
  markDocumentAsTemplate: Maybe<Scalars['JSON']>;
  mergeDeclarations: Scalars['Boolean'];
  patchTenantConfig: Maybe<Scalars['JSON']>;
  patchUserConfig: Maybe<Scalars['JSON']>;
  refreshOrgIds: Scalars['Boolean'];
  refreshOrgIdsV2: Scalars['Boolean'];
  removeUser: Scalars['Boolean'];
  scheduleAldiSrvProcessing: Maybe<Scalars['JSON']>;
  scheduleDeclarationExport: Maybe<Scalars['JSON']>;
  scheduleDocAnnotationExport: Maybe<Scalars['JSON']>;
  scheduleDocuments: Maybe<Scalars['JSON']>;
  scheduleFileExport: Maybe<Scalars['JSON']>;
  scheduleFiles: Maybe<Scalars['JSON']>;
  scheduleTableCalculation: Maybe<Scalars['JSON']>;
  sendAditResetPasswordLink: Scalars['Boolean'];
  sendDeclarationArrivalNotification: Maybe<Scalars['JSON']>;
  sendWDResetPasswordLink: Scalars['Boolean'];
  transmitFile: Maybe<TransmitFileResponse>;
  triggerArticlesExtraction: Maybe<Scalars['JSON']>;
  unlinkAddressACS: Scalars['Boolean'];
  /** update data of the table: "address" */
  update_address: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "address_override" */
  update_address_override: Maybe<Address_Override_Mutation_Response>;
  /** update single row of the table: "address_override" */
  update_address_override_by_pk: Maybe<Address_Override>;
  /** update multiples rows of table: "address_override" */
  update_address_override_many: Maybe<Array<Maybe<Address_Override_Mutation_Response>>>;
  /** update data of the table: "bill_detail" */
  update_bill_detail: Maybe<Bill_Detail_Mutation_Response>;
  /** update single row of the table: "bill_detail" */
  update_bill_detail_by_pk: Maybe<Bill_Detail>;
  /** update multiples rows of table: "bill_detail" */
  update_bill_detail_many: Maybe<Array<Maybe<Bill_Detail_Mutation_Response>>>;
  /** update data of the table: "containers" */
  update_containers: Maybe<Containers_Mutation_Response>;
  /** update single row of the table: "containers" */
  update_containers_by_pk: Maybe<Containers>;
  /** update multiples rows of table: "containers" */
  update_containers_many: Maybe<Array<Maybe<Containers_Mutation_Response>>>;
  /** update data of the table: "declaration" */
  update_declaration: Maybe<Declaration_Mutation_Response>;
  /** update single row of the table: "declaration" */
  update_declaration_by_pk: Maybe<Declaration>;
  /** update data of the table: "declaration_discussions" */
  update_declaration_discussions: Maybe<Declaration_Discussions_Mutation_Response>;
  /** update multiples rows of table: "declaration_discussions" */
  update_declaration_discussions_many: Maybe<Array<Maybe<Declaration_Discussions_Mutation_Response>>>;
  /** update multiples rows of table: "declaration" */
  update_declaration_many: Maybe<Array<Maybe<Declaration_Mutation_Response>>>;
  /** update data of the table: "declaration_message" */
  update_declaration_message: Maybe<Declaration_Message_Mutation_Response>;
  /** update single row of the table: "declaration_message" */
  update_declaration_message_by_pk: Maybe<Declaration_Message>;
  /** update multiples rows of table: "declaration_message" */
  update_declaration_message_many: Maybe<Array<Maybe<Declaration_Message_Mutation_Response>>>;
  /** update data of the table: "declaration_request" */
  update_declaration_request: Maybe<Declaration_Request_Mutation_Response>;
  /** update data of the table: "declaration_request_address" */
  update_declaration_request_address: Maybe<Declaration_Request_Address_Mutation_Response>;
  /** update single row of the table: "declaration_request_address" */
  update_declaration_request_address_by_pk: Maybe<Declaration_Request_Address>;
  /** update multiples rows of table: "declaration_request_address" */
  update_declaration_request_address_many: Maybe<Array<Maybe<Declaration_Request_Address_Mutation_Response>>>;
  /** update single row of the table: "declaration_request" */
  update_declaration_request_by_pk: Maybe<Declaration_Request>;
  /** update multiples rows of table: "declaration_request" */
  update_declaration_request_many: Maybe<Array<Maybe<Declaration_Request_Mutation_Response>>>;
  /** update data of the table: "declaration_special_mentions" */
  update_declaration_special_mentions: Maybe<Declaration_Special_Mentions_Mutation_Response>;
  /** update single row of the table: "declaration_special_mentions" */
  update_declaration_special_mentions_by_pk: Maybe<Declaration_Special_Mentions>;
  /** update multiples rows of table: "declaration_special_mentions" */
  update_declaration_special_mentions_many: Maybe<Array<Maybe<Declaration_Special_Mentions_Mutation_Response>>>;
  /** update data of the table: "declaration_task" */
  update_declaration_task: Maybe<Declaration_Task_Mutation_Response>;
  /** update single row of the table: "declaration_task" */
  update_declaration_task_by_pk: Maybe<Declaration_Task>;
  /** update multiples rows of table: "declaration_task" */
  update_declaration_task_many: Maybe<Array<Maybe<Declaration_Task_Mutation_Response>>>;
  /** update data of the table: "doc_annotation" */
  update_doc_annotation: Maybe<Doc_Annotation_Mutation_Response>;
  /** update single row of the table: "doc_annotation" */
  update_doc_annotation_by_pk: Maybe<Doc_Annotation>;
  /** update multiples rows of table: "doc_annotation" */
  update_doc_annotation_many: Maybe<Array<Maybe<Doc_Annotation_Mutation_Response>>>;
  /** update data of the table: "document" */
  update_document: Maybe<Document_Mutation_Response>;
  /** update single row of the table: "document" */
  update_document_by_pk: Maybe<Document>;
  /** update data of the table: "document_labels" */
  update_document_labels: Maybe<Document_Labels_Mutation_Response>;
  /** update single row of the table: "document_labels" */
  update_document_labels_by_pk: Maybe<Document_Labels>;
  /** update multiples rows of table: "document_labels" */
  update_document_labels_many: Maybe<Array<Maybe<Document_Labels_Mutation_Response>>>;
  /** update multiples rows of table: "document" */
  update_document_many: Maybe<Array<Maybe<Document_Mutation_Response>>>;
  /** update data of the table: "document_type" */
  update_document_type: Maybe<Document_Type_Mutation_Response>;
  /** update single row of the table: "document_type" */
  update_document_type_by_pk: Maybe<Document_Type>;
  /** update multiples rows of table: "document_type" */
  update_document_type_many: Maybe<Array<Maybe<Document_Type_Mutation_Response>>>;
  /** update data of the table: "document_type_tenant_settings" */
  update_document_type_tenant_settings: Maybe<Document_Type_Tenant_Settings_Mutation_Response>;
  /** update single row of the table: "document_type_tenant_settings" */
  update_document_type_tenant_settings_by_pk: Maybe<Document_Type_Tenant_Settings>;
  /** update multiples rows of table: "document_type_tenant_settings" */
  update_document_type_tenant_settings_many: Maybe<Array<Maybe<Document_Type_Tenant_Settings_Mutation_Response>>>;
  /** update data of the table: "extraction_config" */
  update_extraction_config: Maybe<Extraction_Config_Mutation_Response>;
  /** update single row of the table: "extraction_config" */
  update_extraction_config_by_pk: Maybe<Extraction_Config>;
  /** update multiples rows of table: "extraction_config" */
  update_extraction_config_many: Maybe<Array<Maybe<Extraction_Config_Mutation_Response>>>;
  /** update data of the table: "file" */
  update_file: Maybe<File_Mutation_Response>;
  /** update single row of the table: "file" */
  update_file_by_pk: Maybe<File>;
  /** update multiples rows of table: "file" */
  update_file_many: Maybe<Array<Maybe<File_Mutation_Response>>>;
  /** update data of the table: "goods_item" */
  update_goods_item: Maybe<Goods_Item_Mutation_Response>;
  /** update single row of the table: "goods_item" */
  update_goods_item_by_pk: Maybe<Goods_Item>;
  /** update multiples rows of table: "goods_item" */
  update_goods_item_many: Maybe<Array<Maybe<Goods_Item_Mutation_Response>>>;
  /** update data of the table: "import_list_trigger" */
  update_import_list_trigger: Maybe<Import_List_Trigger_Mutation_Response>;
  /** update single row of the table: "import_list_trigger" */
  update_import_list_trigger_by_pk: Maybe<Import_List_Trigger>;
  /** update multiples rows of table: "import_list_trigger" */
  update_import_list_trigger_many: Maybe<Array<Maybe<Import_List_Trigger_Mutation_Response>>>;
  /** update data of the table: "model_retrain" */
  update_model_retrain: Maybe<Model_Retrain_Mutation_Response>;
  /** update single row of the table: "model_retrain" */
  update_model_retrain_by_pk: Maybe<Model_Retrain>;
  /** update multiples rows of table: "model_retrain" */
  update_model_retrain_many: Maybe<Array<Maybe<Model_Retrain_Mutation_Response>>>;
  /** update data of the table: "packagings" */
  update_packagings: Maybe<Packagings_Mutation_Response>;
  /** update single row of the table: "packagings" */
  update_packagings_by_pk: Maybe<Packagings>;
  /** update multiples rows of table: "packagings" */
  update_packagings_many: Maybe<Array<Maybe<Packagings_Mutation_Response>>>;
  /** update data of the table: "page" */
  update_page: Maybe<Page_Mutation_Response>;
  /** update single row of the table: "page" */
  update_page_by_pk: Maybe<Page>;
  /** update data of the table: "page_extract" */
  update_page_extract: Maybe<Page_Extract_Mutation_Response>;
  /** update single row of the table: "page_extract" */
  update_page_extract_by_pk: Maybe<Page_Extract>;
  /** update multiples rows of table: "page_extract" */
  update_page_extract_many: Maybe<Array<Maybe<Page_Extract_Mutation_Response>>>;
  /** update multiples rows of table: "page" */
  update_page_many: Maybe<Array<Maybe<Page_Mutation_Response>>>;
  /** update data of the table: "previous_documents" */
  update_previous_documents: Maybe<Previous_Documents_Mutation_Response>;
  /** update single row of the table: "previous_documents" */
  update_previous_documents_by_pk: Maybe<Previous_Documents>;
  /** update multiples rows of table: "previous_documents" */
  update_previous_documents_many: Maybe<Array<Maybe<Previous_Documents_Mutation_Response>>>;
  /** update data of the table: "produced_documents" */
  update_produced_documents: Maybe<Produced_Documents_Mutation_Response>;
  /** update single row of the table: "produced_documents" */
  update_produced_documents_by_pk: Maybe<Produced_Documents>;
  /** update multiples rows of table: "produced_documents" */
  update_produced_documents_many: Maybe<Array<Maybe<Produced_Documents_Mutation_Response>>>;
  /** update data of the table: "service_tariff" */
  update_service_tariff: Maybe<Service_Tariff_Mutation_Response>;
  /** update multiples rows of table: "service_tariff" */
  update_service_tariff_many: Maybe<Array<Maybe<Service_Tariff_Mutation_Response>>>;
  /** update data of the table: "setting_value" */
  update_setting_value: Maybe<Setting_Value_Mutation_Response>;
  /** update single row of the table: "setting_value" */
  update_setting_value_by_pk: Maybe<Setting_Value>;
  /** update multiples rows of table: "setting_value" */
  update_setting_value_many: Maybe<Array<Maybe<Setting_Value_Mutation_Response>>>;
  /** update data of the table: "tenant" */
  update_tenant: Maybe<Tenant_Mutation_Response>;
  /** update single row of the table: "tenant" */
  update_tenant_by_pk: Maybe<Tenant>;
  /** update multiples rows of table: "tenant" */
  update_tenant_many: Maybe<Array<Maybe<Tenant_Mutation_Response>>>;
  /** update data of the table: "user_pp" */
  update_user_pp: Maybe<User_Pp_Mutation_Response>;
  /** update single row of the table: "user_pp" */
  update_user_pp_by_pk: Maybe<User_Pp>;
  /** update multiples rows of table: "user_pp" */
  update_user_pp_many: Maybe<Array<Maybe<User_Pp_Mutation_Response>>>;
  updateAditUser: Scalars['Boolean'];
  updateFileNumber: Maybe<ReassignFileNumberResponse>;
  updateNotificationTrigger: Maybe<NotificationTrigger>;
  updatePassword: Scalars['Boolean'];
  updateWDUser: Scalars['Boolean'];
  upsertAddressByReference: AddressAcs;
  validateFileNumber: Maybe<ValidateFileNumberResponse>;
  validateJourneyNumber: Maybe<ValidateJourneyNumberResponse>;
};


/** mutation root */
export type Mutation_RootAcs_Insert_Address_OneArgs = {
  object: AddressInsertArgs;
  onConflict: Conflict;
};


/** mutation root */
export type Mutation_RootAcs_Update_Address_VisibilityArgs = {
  fileId: Scalars['UUID'];
};


/** mutation root */
export type Mutation_RootActivate2FaArgs = {
  activate2FAInput: Activate2FaDto;
};


/** mutation root */
export type Mutation_RootAddNotificationTriggerArgs = {
  data: NotificationTriggerInput;
};


/** mutation root */
export type Mutation_RootAssignDeclarationLabelsArgs = {
  labels: Array<DeclarationLabelInput>;
};


/** mutation root */
export type Mutation_RootAssignNotificationLabelsArgs = {
  labels: Array<NotificationLabelInput>;
};


/** mutation root */
export type Mutation_RootClassifyWeDeclareDocumentArgs = {
  doc_id: Scalars['ID'];
  document_type: Scalars['String'];
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootCopyDeclarationAndGoodsItemsArgs = {
  copyDeclarationInput: CopyDeclarationInputDto;
};


/** mutation root */
export type Mutation_RootCreateAditUserArgs = {
  createUserInput: AditUserDto;
};


/** mutation root */
export type Mutation_RootCreateDeclarationMessageArgs = {
  discussionId: Scalars['Int'];
  message: Scalars['String'];
  messageType: Scalars['String'];
  source: Scalars['String'];
  user: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootCreateDeclarationReqArgs = {
  data: CreateDeclarationReqInput;
};


/** mutation root */
export type Mutation_RootCreateDeclarationRequestArgs = {
  createDeclarationRequestV2Input: CreateDeclarationRequestDto;
};


/** mutation root */
export type Mutation_RootCreateDocumentArgs = {
  document: CreateDocumentInput;
};


/** mutation root */
export type Mutation_RootCreateDocumentTypeArgs = {
  createDocumentTypeInput: CreateDocumentTypeInput;
};


/** mutation root */
export type Mutation_RootCreateEmptyDocumentArgs = {
  document: CreateEmptyDocumentInput;
  fileId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootCreateTenantAcsArgs = {
  addressId: Scalars['Int'];
  externalTenantId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  tenantName: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateWdUserArgs = {
  createUserInput: WdCreateUserDto;
};


/** mutation root */
export type Mutation_RootDelete_AddressArgs = {
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Address_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ContainersArgs = {
  where: Containers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Containers_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_DeclarationArgs = {
  where: Declaration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_DiscussionArgs = {
  where: Declaration_Discussion_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Discussion_By_PkArgs = {
  discussion_id: Scalars['bigint'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_MessageArgs = {
  where: Declaration_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Message_By_PkArgs = {
  creation_user: Scalars['uuid'];
  discussion_id: Scalars['bigint'];
  msg_date: Scalars['timestamptz'];
  read_date: Scalars['timestamptz'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_RequestArgs = {
  where: Declaration_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Request_AddressArgs = {
  where: Declaration_Request_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Request_Address_By_PkArgs = {
  address_type: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Request_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Special_MentionsArgs = {
  where: Declaration_Special_Mentions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Declaration_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_AnnotationArgs = {
  where: Doc_Annotation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Annotation_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentArgs = {
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_By_PkArgs = {
  document_type: Scalars['String'];
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Document_LabelsArgs = {
  where: Document_Labels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Document_TypeArgs = {
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_Tenant_SettingsArgs = {
  where: Document_Type_Tenant_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Document_Type_Tenant_Settings_By_PkArgs = {
  document_type: Scalars['String'];
  tenant: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_FileArgs = {
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_File_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Goods_ItemArgs = {
  where: Goods_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Goods_Item_By_PkArgs = {
  customs_item_number: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Import_List_TriggerArgs = {
  where: Import_List_Trigger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Import_List_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PackagingsArgs = {
  where: Packagings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Packagings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_PageArgs = {
  where: Page_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Page_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Page_ExtractArgs = {
  where: Page_Extract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Page_Extract_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
  page_id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Previous_DocumentsArgs = {
  where: Previous_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Previous_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Produced_DocumentsArgs = {
  where: Produced_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Produced_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Service_TariffArgs = {
  where: Service_Tariff_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Setting_ValueArgs = {
  where: Setting_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Setting_Value_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_PpArgs = {
  where: User_Pp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Pp_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteNotificationTriggerArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDeleteTenantReportArgs = {
  reportId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootEditAddressAcsArgs = {
  additionalParams: EditAddressInputAcs;
  aoId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  newData: AddressInputRs;
};


/** mutation root */
export type Mutation_RootEditDocumentTypeArgs = {
  editDocumentTypeInput: EditDocumentTypeInput;
};


/** mutation root */
export type Mutation_RootEditTenantAcsArgs = {
  addressId: Scalars['Int'];
  externalTenantId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
};


/** mutation root */
export type Mutation_RootEnqueueDocumentArgs = {
  document: EnqueueDocumentInput;
};


/** mutation root */
export type Mutation_RootExportDeclarationArgs = {
  exportDeclarationInput: ExportDeclarationDto;
};


/** mutation root */
export type Mutation_RootFinishDocumentValidationArgs = {
  docId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootGenerateExcelCombinedReportArgs = {
  input: ExcelCombinedReportDto;
};


/** mutation root */
export type Mutation_RootGenerateExcelDeclarationReportArgs = {
  input: DeclarationRequestsReportArgs;
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OverrideArgs = {
  objects: Array<Address_Override_Insert_Input>;
  on_conflict?: InputMaybe<Address_Override_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_Override_OneArgs = {
  object: Address_Override_Insert_Input;
  on_conflict?: InputMaybe<Address_Override_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bill_DetailArgs = {
  objects: Array<Bill_Detail_Insert_Input>;
  on_conflict?: InputMaybe<Bill_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bill_Detail_OneArgs = {
  object: Bill_Detail_Insert_Input;
  on_conflict?: InputMaybe<Bill_Detail_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContainersArgs = {
  objects: Array<Containers_Insert_Input>;
  on_conflict?: InputMaybe<Containers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Containers_OneArgs = {
  object: Containers_Insert_Input;
  on_conflict?: InputMaybe<Containers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DeclarationArgs = {
  objects: Array<Declaration_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_DiscussionArgs = {
  objects: Array<Declaration_Discussion_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Discussion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Discussion_OneArgs = {
  object: Declaration_Discussion_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Discussion_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_MessageArgs = {
  objects: Array<Declaration_Message_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Message_OneArgs = {
  object: Declaration_Message_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Message_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_OneArgs = {
  object: Declaration_Insert_Input;
  on_conflict?: InputMaybe<Declaration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_RequestArgs = {
  objects: Array<Declaration_Request_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Request_AddressArgs = {
  objects: Array<Declaration_Request_Address_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Request_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Request_Address_OneArgs = {
  object: Declaration_Request_Address_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Request_Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Request_OneArgs = {
  object: Declaration_Request_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Special_MentionsArgs = {
  objects: Array<Declaration_Special_Mentions_Insert_Input>;
  on_conflict?: InputMaybe<Declaration_Special_Mentions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Declaration_Special_Mentions_OneArgs = {
  object: Declaration_Special_Mentions_Insert_Input;
  on_conflict?: InputMaybe<Declaration_Special_Mentions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_AnnotationArgs = {
  objects: Array<Doc_Annotation_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Annotation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Annotation_OneArgs = {
  object: Doc_Annotation_Insert_Input;
  on_conflict?: InputMaybe<Doc_Annotation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentArgs = {
  objects: Array<Document_Insert_Input>;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Label_Org_IdArgs = {
  objects: Array<Document_Label_Org_Id_Insert_Input>;
  on_conflict?: InputMaybe<Document_Label_Org_Id_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Label_Org_Id_OneArgs = {
  object: Document_Label_Org_Id_Insert_Input;
  on_conflict?: InputMaybe<Document_Label_Org_Id_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_LabelsArgs = {
  objects: Array<Document_Labels_Insert_Input>;
  on_conflict?: InputMaybe<Document_Labels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Labels_OneArgs = {
  object: Document_Labels_Insert_Input;
  on_conflict?: InputMaybe<Document_Labels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_OneArgs = {
  object: Document_Insert_Input;
  on_conflict?: InputMaybe<Document_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_TypeArgs = {
  objects: Array<Document_Type_Insert_Input>;
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_OneArgs = {
  object: Document_Type_Insert_Input;
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_Tenant_SettingsArgs = {
  objects: Array<Document_Type_Tenant_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Document_Type_Tenant_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Document_Type_Tenant_Settings_OneArgs = {
  object: Document_Type_Tenant_Settings_Insert_Input;
  on_conflict?: InputMaybe<Document_Type_Tenant_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileArgs = {
  objects: Array<File_Insert_Input>;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_File_OneArgs = {
  object: File_Insert_Input;
  on_conflict?: InputMaybe<File_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Goods_ItemArgs = {
  objects: Array<Goods_Item_Insert_Input>;
  on_conflict?: InputMaybe<Goods_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Goods_Item_OneArgs = {
  object: Goods_Item_Insert_Input;
  on_conflict?: InputMaybe<Goods_Item_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_List_TriggerArgs = {
  objects: Array<Import_List_Trigger_Insert_Input>;
  on_conflict?: InputMaybe<Import_List_Trigger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_List_Trigger_OneArgs = {
  object: Import_List_Trigger_Insert_Input;
  on_conflict?: InputMaybe<Import_List_Trigger_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_RetrainArgs = {
  objects: Array<Model_Retrain_Insert_Input>;
  on_conflict?: InputMaybe<Model_Retrain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Model_Retrain_OneArgs = {
  object: Model_Retrain_Insert_Input;
  on_conflict?: InputMaybe<Model_Retrain_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PackagingsArgs = {
  objects: Array<Packagings_Insert_Input>;
  on_conflict?: InputMaybe<Packagings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Packagings_OneArgs = {
  object: Packagings_Insert_Input;
  on_conflict?: InputMaybe<Packagings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PageArgs = {
  objects: Array<Page_Insert_Input>;
  on_conflict?: InputMaybe<Page_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_ExtractArgs = {
  objects: Array<Page_Extract_Insert_Input>;
  on_conflict?: InputMaybe<Page_Extract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_Extract_OneArgs = {
  object: Page_Extract_Insert_Input;
  on_conflict?: InputMaybe<Page_Extract_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_OneArgs = {
  object: Page_Insert_Input;
  on_conflict?: InputMaybe<Page_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Previous_DocumentsArgs = {
  objects: Array<Previous_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Previous_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Previous_Documents_OneArgs = {
  object: Previous_Documents_Insert_Input;
  on_conflict?: InputMaybe<Previous_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Produced_DocumentsArgs = {
  objects: Array<Produced_Documents_Insert_Input>;
  on_conflict?: InputMaybe<Produced_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Produced_Documents_OneArgs = {
  object: Produced_Documents_Insert_Input;
  on_conflict?: InputMaybe<Produced_Documents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Service_TariffArgs = {
  objects: Array<Service_Tariff_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Service_Tariff_OneArgs = {
  object: Service_Tariff_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Setting_ValueArgs = {
  objects: Array<Setting_Value_Insert_Input>;
  on_conflict?: InputMaybe<Setting_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Setting_Value_OneArgs = {
  object: Setting_Value_Insert_Input;
  on_conflict?: InputMaybe<Setting_Value_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TenantArgs = {
  objects: Array<Tenant_Insert_Input>;
  on_conflict?: InputMaybe<Tenant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tenant_OneArgs = {
  object: Tenant_Insert_Input;
  on_conflict?: InputMaybe<Tenant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Org_IdArgs = {
  objects: Array<User_Org_Id_Insert_Input>;
  on_conflict?: InputMaybe<User_Org_Id_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Org_Id_OneArgs = {
  object: User_Org_Id_Insert_Input;
  on_conflict?: InputMaybe<User_Org_Id_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_PpArgs = {
  objects: Array<User_Pp_Insert_Input>;
  on_conflict?: InputMaybe<User_Pp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Pp_OneArgs = {
  object: User_Pp_Insert_Input;
  on_conflict?: InputMaybe<User_Pp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLinkAddressesAcsArgs = {
  input: LinkAddressesInputAcs;
};


/** mutation root */
export type Mutation_RootMarkDocumentAsTemplateArgs = {
  docId: Scalars['ID'];
  isTemplate?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootMergeDeclarationsArgs = {
  copyDeclarationInput: CopyDeclarationInputDto;
};


/** mutation root */
export type Mutation_RootPatchTenantConfigArgs = {
  tenantId?: InputMaybe<Scalars['ID']>;
  value?: InputMaybe<Scalars['JSON']>;
};


/** mutation root */
export type Mutation_RootPatchUserConfigArgs = {
  value?: InputMaybe<Scalars['JSON']>;
};


/** mutation root */
export type Mutation_RootRefreshOrgIdsArgs = {
  ids: Array<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRefreshOrgIdsV2Args = {
  ids: Array<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootRemoveUserArgs = {
  id: Scalars['UUID'];
};


/** mutation root */
export type Mutation_RootScheduleAldiSrvProcessingArgs = {
  drNo: Scalars['Int'];
  fileId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootScheduleDeclarationExportArgs = {
  drNo: Scalars['Int'];
  fileId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootScheduleDocAnnotationExportArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootScheduleDocumentsArgs = {
  documentIds: Array<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootScheduleFileExportArgs = {
  fileId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootScheduleFilesArgs = {
  fileIds: Array<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootScheduleTableCalculationArgs = {
  docId: Scalars['ID'];
};


/** mutation root */
export type Mutation_RootSendAditResetPasswordLinkArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootSendDeclarationArrivalNotificationArgs = {
  data: SendDeclarationArrivalNotificationInput;
};


/** mutation root */
export type Mutation_RootSendWdResetPasswordLinkArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootTransmitFileArgs = {
  data: TransmitFileInput;
};


/** mutation root */
export type Mutation_RootTriggerArticlesExtractionArgs = {
  document_type: Scalars['String'];
  fileId?: InputMaybe<Scalars['ID']>;
};


/** mutation root */
export type Mutation_RootUnlinkAddressAcsArgs = {
  sourceAddressId?: InputMaybe<Scalars['Int']>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _append?: InputMaybe<Address_Append_Input>;
  _delete_at_path?: InputMaybe<Address_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Address_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Address_Delete_Key_Input>;
  _inc?: InputMaybe<Address_Inc_Input>;
  _prepend?: InputMaybe<Address_Prepend_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _append?: InputMaybe<Address_Append_Input>;
  _delete_at_path?: InputMaybe<Address_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Address_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Address_Delete_Key_Input>;
  _inc?: InputMaybe<Address_Inc_Input>;
  _prepend?: InputMaybe<Address_Prepend_Input>;
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Address_OverrideArgs = {
  _append?: InputMaybe<Address_Override_Append_Input>;
  _delete_at_path?: InputMaybe<Address_Override_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Address_Override_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Address_Override_Delete_Key_Input>;
  _inc?: InputMaybe<Address_Override_Inc_Input>;
  _prepend?: InputMaybe<Address_Override_Prepend_Input>;
  _set?: InputMaybe<Address_Override_Set_Input>;
  where: Address_Override_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Override_By_PkArgs = {
  _append?: InputMaybe<Address_Override_Append_Input>;
  _delete_at_path?: InputMaybe<Address_Override_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Address_Override_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Address_Override_Delete_Key_Input>;
  _inc?: InputMaybe<Address_Override_Inc_Input>;
  _prepend?: InputMaybe<Address_Override_Prepend_Input>;
  _set?: InputMaybe<Address_Override_Set_Input>;
  pk_columns: Address_Override_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_Override_ManyArgs = {
  updates: Array<Address_Override_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bill_DetailArgs = {
  _inc?: InputMaybe<Bill_Detail_Inc_Input>;
  _set?: InputMaybe<Bill_Detail_Set_Input>;
  where: Bill_Detail_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bill_Detail_By_PkArgs = {
  _inc?: InputMaybe<Bill_Detail_Inc_Input>;
  _set?: InputMaybe<Bill_Detail_Set_Input>;
  pk_columns: Bill_Detail_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bill_Detail_ManyArgs = {
  updates: Array<Bill_Detail_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContainersArgs = {
  _inc?: InputMaybe<Containers_Inc_Input>;
  _set?: InputMaybe<Containers_Set_Input>;
  where: Containers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Containers_By_PkArgs = {
  _inc?: InputMaybe<Containers_Inc_Input>;
  _set?: InputMaybe<Containers_Set_Input>;
  pk_columns: Containers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Containers_ManyArgs = {
  updates: Array<Containers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DeclarationArgs = {
  _append?: InputMaybe<Declaration_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Prepend_Input>;
  _set?: InputMaybe<Declaration_Set_Input>;
  where: Declaration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_By_PkArgs = {
  _append?: InputMaybe<Declaration_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Prepend_Input>;
  _set?: InputMaybe<Declaration_Set_Input>;
  pk_columns: Declaration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_DiscussionsArgs = {
  _set?: InputMaybe<Declaration_Discussions_Set_Input>;
  where: Declaration_Discussions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Discussions_ManyArgs = {
  updates: Array<Declaration_Discussions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_ManyArgs = {
  updates: Array<Declaration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_MessageArgs = {
  _append?: InputMaybe<Declaration_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Message_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Message_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Message_Prepend_Input>;
  _set?: InputMaybe<Declaration_Message_Set_Input>;
  where: Declaration_Message_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Message_By_PkArgs = {
  _append?: InputMaybe<Declaration_Message_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Message_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Message_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Message_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Message_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Message_Prepend_Input>;
  _set?: InputMaybe<Declaration_Message_Set_Input>;
  pk_columns: Declaration_Message_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Message_ManyArgs = {
  updates: Array<Declaration_Message_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_RequestArgs = {
  _append?: InputMaybe<Declaration_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Request_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Request_Prepend_Input>;
  _set?: InputMaybe<Declaration_Request_Set_Input>;
  where: Declaration_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_AddressArgs = {
  _inc?: InputMaybe<Declaration_Request_Address_Inc_Input>;
  _set?: InputMaybe<Declaration_Request_Address_Set_Input>;
  where: Declaration_Request_Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_Address_By_PkArgs = {
  _inc?: InputMaybe<Declaration_Request_Address_Inc_Input>;
  _set?: InputMaybe<Declaration_Request_Address_Set_Input>;
  pk_columns: Declaration_Request_Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_Address_ManyArgs = {
  updates: Array<Declaration_Request_Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_By_PkArgs = {
  _append?: InputMaybe<Declaration_Request_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Request_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Request_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Request_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Request_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Request_Prepend_Input>;
  _set?: InputMaybe<Declaration_Request_Set_Input>;
  pk_columns: Declaration_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Request_ManyArgs = {
  updates: Array<Declaration_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Special_MentionsArgs = {
  _inc?: InputMaybe<Declaration_Special_Mentions_Inc_Input>;
  _set?: InputMaybe<Declaration_Special_Mentions_Set_Input>;
  where: Declaration_Special_Mentions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Special_Mentions_By_PkArgs = {
  _inc?: InputMaybe<Declaration_Special_Mentions_Inc_Input>;
  _set?: InputMaybe<Declaration_Special_Mentions_Set_Input>;
  pk_columns: Declaration_Special_Mentions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Special_Mentions_ManyArgs = {
  updates: Array<Declaration_Special_Mentions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_TaskArgs = {
  _append?: InputMaybe<Declaration_Task_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Task_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Task_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Task_Prepend_Input>;
  _set?: InputMaybe<Declaration_Task_Set_Input>;
  where: Declaration_Task_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Task_By_PkArgs = {
  _append?: InputMaybe<Declaration_Task_Append_Input>;
  _delete_at_path?: InputMaybe<Declaration_Task_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Declaration_Task_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Declaration_Task_Delete_Key_Input>;
  _inc?: InputMaybe<Declaration_Task_Inc_Input>;
  _prepend?: InputMaybe<Declaration_Task_Prepend_Input>;
  _set?: InputMaybe<Declaration_Task_Set_Input>;
  pk_columns: Declaration_Task_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Declaration_Task_ManyArgs = {
  updates: Array<Declaration_Task_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_AnnotationArgs = {
  _append?: InputMaybe<Doc_Annotation_Append_Input>;
  _delete_at_path?: InputMaybe<Doc_Annotation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Doc_Annotation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Doc_Annotation_Delete_Key_Input>;
  _prepend?: InputMaybe<Doc_Annotation_Prepend_Input>;
  _set?: InputMaybe<Doc_Annotation_Set_Input>;
  where: Doc_Annotation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Annotation_By_PkArgs = {
  _append?: InputMaybe<Doc_Annotation_Append_Input>;
  _delete_at_path?: InputMaybe<Doc_Annotation_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Doc_Annotation_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Doc_Annotation_Delete_Key_Input>;
  _prepend?: InputMaybe<Doc_Annotation_Prepend_Input>;
  _set?: InputMaybe<Doc_Annotation_Set_Input>;
  pk_columns: Doc_Annotation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Annotation_ManyArgs = {
  updates: Array<Doc_Annotation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentArgs = {
  _append?: InputMaybe<Document_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Inc_Input>;
  _prepend?: InputMaybe<Document_Prepend_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_By_PkArgs = {
  _append?: InputMaybe<Document_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Inc_Input>;
  _prepend?: InputMaybe<Document_Prepend_Input>;
  _set?: InputMaybe<Document_Set_Input>;
  pk_columns: Document_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_LabelsArgs = {
  _append?: InputMaybe<Document_Labels_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Labels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Labels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Labels_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Labels_Inc_Input>;
  _prepend?: InputMaybe<Document_Labels_Prepend_Input>;
  _set?: InputMaybe<Document_Labels_Set_Input>;
  where: Document_Labels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Labels_By_PkArgs = {
  _append?: InputMaybe<Document_Labels_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Labels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Labels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Labels_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Labels_Inc_Input>;
  _prepend?: InputMaybe<Document_Labels_Prepend_Input>;
  _set?: InputMaybe<Document_Labels_Set_Input>;
  pk_columns: Document_Labels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Labels_ManyArgs = {
  updates: Array<Document_Labels_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_ManyArgs = {
  updates: Array<Document_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_TypeArgs = {
  _append?: InputMaybe<Document_Type_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Type_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Type_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Type_Delete_Key_Input>;
  _prepend?: InputMaybe<Document_Type_Prepend_Input>;
  _set?: InputMaybe<Document_Type_Set_Input>;
  where: Document_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_By_PkArgs = {
  _append?: InputMaybe<Document_Type_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Type_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Type_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Type_Delete_Key_Input>;
  _prepend?: InputMaybe<Document_Type_Prepend_Input>;
  _set?: InputMaybe<Document_Type_Set_Input>;
  pk_columns: Document_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_ManyArgs = {
  updates: Array<Document_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_Tenant_SettingsArgs = {
  _append?: InputMaybe<Document_Type_Tenant_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Type_Tenant_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Type_Tenant_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Type_Tenant_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Type_Tenant_Settings_Inc_Input>;
  _prepend?: InputMaybe<Document_Type_Tenant_Settings_Prepend_Input>;
  _set?: InputMaybe<Document_Type_Tenant_Settings_Set_Input>;
  where: Document_Type_Tenant_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_Tenant_Settings_By_PkArgs = {
  _append?: InputMaybe<Document_Type_Tenant_Settings_Append_Input>;
  _delete_at_path?: InputMaybe<Document_Type_Tenant_Settings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Document_Type_Tenant_Settings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Document_Type_Tenant_Settings_Delete_Key_Input>;
  _inc?: InputMaybe<Document_Type_Tenant_Settings_Inc_Input>;
  _prepend?: InputMaybe<Document_Type_Tenant_Settings_Prepend_Input>;
  _set?: InputMaybe<Document_Type_Tenant_Settings_Set_Input>;
  pk_columns: Document_Type_Tenant_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Document_Type_Tenant_Settings_ManyArgs = {
  updates: Array<Document_Type_Tenant_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Extraction_ConfigArgs = {
  _append?: InputMaybe<Extraction_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Extraction_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Extraction_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Extraction_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Extraction_Config_Inc_Input>;
  _prepend?: InputMaybe<Extraction_Config_Prepend_Input>;
  _set?: InputMaybe<Extraction_Config_Set_Input>;
  where: Extraction_Config_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Extraction_Config_By_PkArgs = {
  _append?: InputMaybe<Extraction_Config_Append_Input>;
  _delete_at_path?: InputMaybe<Extraction_Config_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Extraction_Config_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Extraction_Config_Delete_Key_Input>;
  _inc?: InputMaybe<Extraction_Config_Inc_Input>;
  _prepend?: InputMaybe<Extraction_Config_Prepend_Input>;
  _set?: InputMaybe<Extraction_Config_Set_Input>;
  pk_columns: Extraction_Config_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Extraction_Config_ManyArgs = {
  updates: Array<Extraction_Config_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileArgs = {
  _append?: InputMaybe<File_Append_Input>;
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  _inc?: InputMaybe<File_Inc_Input>;
  _prepend?: InputMaybe<File_Prepend_Input>;
  _set?: InputMaybe<File_Set_Input>;
  where: File_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_File_By_PkArgs = {
  _append?: InputMaybe<File_Append_Input>;
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  _inc?: InputMaybe<File_Inc_Input>;
  _prepend?: InputMaybe<File_Prepend_Input>;
  _set?: InputMaybe<File_Set_Input>;
  pk_columns: File_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_File_ManyArgs = {
  updates: Array<File_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Goods_ItemArgs = {
  _inc?: InputMaybe<Goods_Item_Inc_Input>;
  _set?: InputMaybe<Goods_Item_Set_Input>;
  where: Goods_Item_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Goods_Item_By_PkArgs = {
  _inc?: InputMaybe<Goods_Item_Inc_Input>;
  _set?: InputMaybe<Goods_Item_Set_Input>;
  pk_columns: Goods_Item_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Goods_Item_ManyArgs = {
  updates: Array<Goods_Item_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Import_List_TriggerArgs = {
  _append?: InputMaybe<Import_List_Trigger_Append_Input>;
  _delete_at_path?: InputMaybe<Import_List_Trigger_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Import_List_Trigger_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Import_List_Trigger_Delete_Key_Input>;
  _inc?: InputMaybe<Import_List_Trigger_Inc_Input>;
  _prepend?: InputMaybe<Import_List_Trigger_Prepend_Input>;
  _set?: InputMaybe<Import_List_Trigger_Set_Input>;
  where: Import_List_Trigger_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Import_List_Trigger_By_PkArgs = {
  _append?: InputMaybe<Import_List_Trigger_Append_Input>;
  _delete_at_path?: InputMaybe<Import_List_Trigger_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Import_List_Trigger_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Import_List_Trigger_Delete_Key_Input>;
  _inc?: InputMaybe<Import_List_Trigger_Inc_Input>;
  _prepend?: InputMaybe<Import_List_Trigger_Prepend_Input>;
  _set?: InputMaybe<Import_List_Trigger_Set_Input>;
  pk_columns: Import_List_Trigger_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Import_List_Trigger_ManyArgs = {
  updates: Array<Import_List_Trigger_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Model_RetrainArgs = {
  _inc?: InputMaybe<Model_Retrain_Inc_Input>;
  _set?: InputMaybe<Model_Retrain_Set_Input>;
  where: Model_Retrain_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Retrain_By_PkArgs = {
  _inc?: InputMaybe<Model_Retrain_Inc_Input>;
  _set?: InputMaybe<Model_Retrain_Set_Input>;
  pk_columns: Model_Retrain_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Model_Retrain_ManyArgs = {
  updates: Array<Model_Retrain_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PackagingsArgs = {
  _inc?: InputMaybe<Packagings_Inc_Input>;
  _set?: InputMaybe<Packagings_Set_Input>;
  where: Packagings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Packagings_By_PkArgs = {
  _inc?: InputMaybe<Packagings_Inc_Input>;
  _set?: InputMaybe<Packagings_Set_Input>;
  pk_columns: Packagings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Packagings_ManyArgs = {
  updates: Array<Packagings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PageArgs = {
  _append?: InputMaybe<Page_Append_Input>;
  _delete_at_path?: InputMaybe<Page_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Page_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Page_Delete_Key_Input>;
  _inc?: InputMaybe<Page_Inc_Input>;
  _prepend?: InputMaybe<Page_Prepend_Input>;
  _set?: InputMaybe<Page_Set_Input>;
  where: Page_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Page_By_PkArgs = {
  _append?: InputMaybe<Page_Append_Input>;
  _delete_at_path?: InputMaybe<Page_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Page_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Page_Delete_Key_Input>;
  _inc?: InputMaybe<Page_Inc_Input>;
  _prepend?: InputMaybe<Page_Prepend_Input>;
  _set?: InputMaybe<Page_Set_Input>;
  pk_columns: Page_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Page_ExtractArgs = {
  _append?: InputMaybe<Page_Extract_Append_Input>;
  _delete_at_path?: InputMaybe<Page_Extract_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Page_Extract_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Page_Extract_Delete_Key_Input>;
  _inc?: InputMaybe<Page_Extract_Inc_Input>;
  _prepend?: InputMaybe<Page_Extract_Prepend_Input>;
  _set?: InputMaybe<Page_Extract_Set_Input>;
  where: Page_Extract_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Extract_By_PkArgs = {
  _append?: InputMaybe<Page_Extract_Append_Input>;
  _delete_at_path?: InputMaybe<Page_Extract_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Page_Extract_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Page_Extract_Delete_Key_Input>;
  _inc?: InputMaybe<Page_Extract_Inc_Input>;
  _prepend?: InputMaybe<Page_Extract_Prepend_Input>;
  _set?: InputMaybe<Page_Extract_Set_Input>;
  pk_columns: Page_Extract_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Page_Extract_ManyArgs = {
  updates: Array<Page_Extract_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Page_ManyArgs = {
  updates: Array<Page_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Previous_DocumentsArgs = {
  _inc?: InputMaybe<Previous_Documents_Inc_Input>;
  _set?: InputMaybe<Previous_Documents_Set_Input>;
  where: Previous_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Previous_Documents_By_PkArgs = {
  _inc?: InputMaybe<Previous_Documents_Inc_Input>;
  _set?: InputMaybe<Previous_Documents_Set_Input>;
  pk_columns: Previous_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Previous_Documents_ManyArgs = {
  updates: Array<Previous_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Produced_DocumentsArgs = {
  _inc?: InputMaybe<Produced_Documents_Inc_Input>;
  _set?: InputMaybe<Produced_Documents_Set_Input>;
  where: Produced_Documents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Produced_Documents_By_PkArgs = {
  _inc?: InputMaybe<Produced_Documents_Inc_Input>;
  _set?: InputMaybe<Produced_Documents_Set_Input>;
  pk_columns: Produced_Documents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Produced_Documents_ManyArgs = {
  updates: Array<Produced_Documents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Service_TariffArgs = {
  _append?: InputMaybe<Service_Tariff_Append_Input>;
  _delete_at_path?: InputMaybe<Service_Tariff_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Service_Tariff_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Service_Tariff_Delete_Key_Input>;
  _inc?: InputMaybe<Service_Tariff_Inc_Input>;
  _prepend?: InputMaybe<Service_Tariff_Prepend_Input>;
  _set?: InputMaybe<Service_Tariff_Set_Input>;
  where: Service_Tariff_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Service_Tariff_ManyArgs = {
  updates: Array<Service_Tariff_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Setting_ValueArgs = {
  _append?: InputMaybe<Setting_Value_Append_Input>;
  _delete_at_path?: InputMaybe<Setting_Value_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Setting_Value_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Setting_Value_Delete_Key_Input>;
  _prepend?: InputMaybe<Setting_Value_Prepend_Input>;
  _set?: InputMaybe<Setting_Value_Set_Input>;
  where: Setting_Value_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Setting_Value_By_PkArgs = {
  _append?: InputMaybe<Setting_Value_Append_Input>;
  _delete_at_path?: InputMaybe<Setting_Value_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Setting_Value_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Setting_Value_Delete_Key_Input>;
  _prepend?: InputMaybe<Setting_Value_Prepend_Input>;
  _set?: InputMaybe<Setting_Value_Set_Input>;
  pk_columns: Setting_Value_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Setting_Value_ManyArgs = {
  updates: Array<Setting_Value_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantArgs = {
  _inc?: InputMaybe<Tenant_Inc_Input>;
  _set?: InputMaybe<Tenant_Set_Input>;
  where: Tenant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_By_PkArgs = {
  _inc?: InputMaybe<Tenant_Inc_Input>;
  _set?: InputMaybe<Tenant_Set_Input>;
  pk_columns: Tenant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenant_ManyArgs = {
  updates: Array<Tenant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_PpArgs = {
  _append?: InputMaybe<User_Pp_Append_Input>;
  _delete_at_path?: InputMaybe<User_Pp_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Pp_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Pp_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Pp_Prepend_Input>;
  _set?: InputMaybe<User_Pp_Set_Input>;
  where: User_Pp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Pp_By_PkArgs = {
  _append?: InputMaybe<User_Pp_Append_Input>;
  _delete_at_path?: InputMaybe<User_Pp_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<User_Pp_Delete_Elem_Input>;
  _delete_key?: InputMaybe<User_Pp_Delete_Key_Input>;
  _prepend?: InputMaybe<User_Pp_Prepend_Input>;
  _set?: InputMaybe<User_Pp_Set_Input>;
  pk_columns: User_Pp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Pp_ManyArgs = {
  updates: Array<User_Pp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdateAditUserArgs = {
  updateUserInput: AditUserDto;
};


/** mutation root */
export type Mutation_RootUpdateFileNumberArgs = {
  file_id?: InputMaybe<Scalars['ID']>;
  file_number?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootUpdateNotificationTriggerArgs = {
  data: NotificationTriggerInput;
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootUpdatePasswordArgs = {
  updatePasswordInput: UpdatePasswordDto;
};


/** mutation root */
export type Mutation_RootUpdateWdUserArgs = {
  updateUserInput: WdUpdateUserDto;
};


/** mutation root */
export type Mutation_RootUpsertAddressByReferenceArgs = {
  object: AddressUpsertArgs;
};


/** mutation root */
export type Mutation_RootValidateFileNumberArgs = {
  number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootValidateJourneyNumberArgs = {
  number: Scalars['String'];
};

export type AddressInsertArgs = {
  evvAddress: InsertAddressInputAcs;
  lbaseReference: Scalars['String'];
};

export type InsertAddressInputAcs = {
  addressId?: InputMaybe<Scalars['Int']>;
  addressType: Scalars['Int'];
  city: Scalars['String'];
  companyEmail?: InputMaybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyPhone?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  street: Scalars['String'];
  zipcode: Scalars['String'];
};

export type Conflict = {
  updateColumns: Array<Scalars['String']>;
};

export type AddressVisibility = {
  addressId: Scalars['Int'];
  visibleAddress: Scalars['Int'];
};

export type Activate2FaDto = {
  authCode: Scalars['String'];
};

export type UserResponse = {
  data: Maybe<Scalars['JSON']>;
  error: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type NotificationTriggerInput = {
  config: Config;
  displayName: Scalars['String'];
  labelId?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['JSON']>;
  notificationType: Scalars['String'];
};

export type Config = {
  checkPreference?: InputMaybe<Scalars['Boolean']>;
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countryOfOrigin?: InputMaybe<Scalars['String']>;
  feeAmount?: InputMaybe<Scalars['Float']>;
  hsCode?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  specificHsCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NotificationTrigger = {
  config: Maybe<Scalars['JSON']>;
  creationDate: Maybe<Scalars['DateTime']>;
  creationUser: UserPp;
  displayName: Scalars['String'];
  id: Scalars['Int'];
  lastModifiedDate: Maybe<Scalars['DateTime']>;
  lastModifiedUser: Maybe<UserPp>;
  meta: Maybe<Scalars['JSON']>;
  type: Scalars['String'];
};

export type DeclarationLabelInput = {
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelIds: Array<Scalars['Int']>;
};

export type DeclarationLabelMutationOutput = {
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelId: Scalars['Int'];
};

export type NotificationLabelInput = {
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelIds: Array<Scalars['Int']>;
};

export type NotificationLabelMutationOutput = {
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelId: Scalars['Int'];
};

export type CopyDeclarationInputDto = {
  sourceDrNo: Scalars['Int'];
  sourceFileId: Scalars['String'];
  targetDrNo: Scalars['Int'];
  targetFileId: Scalars['String'];
};

export type AditUserDto = {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  externalAuthProviderId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  modules?: InputMaybe<Array<Scalars['Float']>>;
  orgIds?: InputMaybe<Array<Scalars['Int']>>;
  permissions?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationMessageResponse = {
  affected_rows: Maybe<Scalars['Int']>;
};

export type CreateDeclarationReqInput = {
  declaration?: InputMaybe<DeclarationInput>;
  documents: Array<CreateDeclarationDocumentInput>;
  fileId?: InputMaybe<Scalars['ID']>;
  flags: Scalars['Int'];
  ignoreChecksum: Scalars['Boolean'];
  orgId: Scalars['Int'];
};

export type DeclarationInput = {
  addresses?: InputMaybe<Array<InputMaybe<DeclarationAddressInput>>>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['Int']>;
  eta?: InputMaybe<Scalars['String']>;
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<Scalars['JSON']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  payer_name?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  toll_dep?: InputMaybe<Scalars['String']>;
  tr_no?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['String']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

export type DeclarationAddressInput = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['JSON']>;
  reference?: InputMaybe<Scalars['String']>;
  refs?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationDocumentInput = {
  companyId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  documentVersion?: InputMaybe<Scalars['Int']>;
  erpSystemId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  flags?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationReqResponse = {
  documentIds: Maybe<Array<Maybe<Scalars['ID']>>>;
  error: Maybe<Scalars['String']>;
  fileId: Maybe<Scalars['ID']>;
  success: Maybe<Scalars['Boolean']>;
};

export type CreateDeclarationRequestDto = {
  declaration?: InputMaybe<DeclarationInputV2>;
  documents: Array<CreateDeclarationDocumentInputV2>;
  fileId?: InputMaybe<Scalars['ID']>;
  flags?: InputMaybe<Scalars['Int']>;
  ignoreChecksum: Scalars['Boolean'];
  orgId: Scalars['Int'];
};

export type DeclarationInputV2 = {
  addresses?: InputMaybe<Array<InputMaybe<DeclarationAddressInput>>>;
  arrival_time?: InputMaybe<Scalars['DateTime']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['Int']>;
  eta?: InputMaybe<Scalars['String']>;
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<Scalars['JSON']>;
  payer_id?: InputMaybe<Scalars['String']>;
  payer_name?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  toll_dep?: InputMaybe<Scalars['String']>;
  total_colis?: InputMaybe<Scalars['Int']>;
  total_gross_weight?: InputMaybe<Scalars['Float']>;
  tr_no?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['String']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationDocumentInputV2 = {
  companyId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  documentVersion?: InputMaybe<Scalars['Int']>;
  erpSystemId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  flags?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type CreateDeclarationRequestResponse = {
  documentIds: Maybe<Array<Maybe<Scalars['ID']>>>;
  error: Maybe<Scalars['String']>;
  fileId: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type CreateDocumentInput = {
  checksum?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  documentStatus?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  erpSystemId?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  flags?: InputMaybe<Scalars['Int']>;
  orgId?: InputMaybe<Scalars['Int']>;
  sequence?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type CreateDocumentResponse = {
  documentId: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  success: Maybe<Scalars['Boolean']>;
};

export type CreateDocumentTypeInput = {
  code: Scalars['String'];
  defaultFlags: Scalars['Int'];
  documentType: Scalars['String'];
  meta: DocumentTypeMetaInput;
  tenant: Scalars['String'];
};

export type DocumentTypeMetaInput = {
  color: Scalars['String'];
  labels: Array<Scalars['String']>;
};

export type CreateEmptyDocumentInput = {
  checksum?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  erpSystemId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  flags?: InputMaybe<Scalars['Int']>;
  numberOfPages: Scalars['Int'];
  orgId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

export type CreateEmptyDocumentResponse = {
  documentId: Maybe<Scalars['String']>;
  error: Maybe<Scalars['String']>;
  pageIds: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type WdCreateUserDto = {
  email?: InputMaybe<Scalars['String']>;
  externalAuthProvider?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  userId?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** response of any mutation on the table "containers" */
export type Containers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Containers>;
};

/** response of any mutation on the table "declaration" */
export type Declaration_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration>;
};

/** response of any mutation on the table "declaration_discussion" */
export type Declaration_Discussion_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Discussion>;
};

/** response of any mutation on the table "declaration_message" */
export type Declaration_Message_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Message>;
};

/** response of any mutation on the table "declaration_request" */
export type Declaration_Request_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Request>;
};

/** response of any mutation on the table "declaration_request_address" */
export type Declaration_Request_Address_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Request_Address>;
};

/** response of any mutation on the table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Special_Mentions>;
};

/** response of any mutation on the table "doc_annotation" */
export type Doc_Annotation_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Annotation>;
};

/** response of any mutation on the table "document" */
export type Document_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document>;
};

/** response of any mutation on the table "document_labels" */
export type Document_Labels_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Labels>;
};

/** response of any mutation on the table "document_type" */
export type Document_Type_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Type>;
};

/** response of any mutation on the table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Type_Tenant_Settings>;
};

/** response of any mutation on the table "file" */
export type File_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File>;
};

/** response of any mutation on the table "goods_item" */
export type Goods_Item_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Goods_Item>;
};

/** response of any mutation on the table "import_list_trigger" */
export type Import_List_Trigger_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Import_List_Trigger>;
};

/** response of any mutation on the table "packagings" */
export type Packagings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Packagings>;
};

/** response of any mutation on the table "page" */
export type Page_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Page>;
};

/** response of any mutation on the table "page_extract" */
export type Page_Extract_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Page_Extract>;
};

/** response of any mutation on the table "previous_documents" */
export type Previous_Documents_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Previous_Documents>;
};

/** response of any mutation on the table "produced_documents" */
export type Produced_Documents_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Produced_Documents>;
};

/** response of any mutation on the table "service_tariff" */
export type Service_Tariff_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Service_Tariff>;
};

/** response of any mutation on the table "setting_value" */
export type Setting_Value_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Setting_Value>;
};

/** response of any mutation on the table "user_pp" */
export type User_Pp_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Pp>;
};

export type EditAddressInputAcs = {
  source: Scalars['String'];
  tenantId: Scalars['String'];
};

export type AddressInputRs = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['JSON']>;
  reference?: InputMaybe<Scalars['String']>;
  refs?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type EditDocumentTypeInput = {
  code: Scalars['String'];
  defaultFlags: Scalars['Int'];
  documentType: Scalars['String'];
  meta: DocumentTypeMetaInput;
  tenant: Scalars['String'];
};

export type EnqueueDocumentInput = {
  documentId: Scalars['ID'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
};

export type ExportDeclarationDto = {
  drNo: Scalars['Float'];
  fileId: Scalars['String'];
};

export type ExcelCombinedReportDto = {
  addresses?: InputMaybe<Scalars['String']>;
  addressesQi?: InputMaybe<Scalars['String']>;
  arrivalType?: InputMaybe<Scalars['String']>;
  clearanceType?: InputMaybe<Scalars['String']>;
  columns?: InputMaybe<Array<Scalars['String']>>;
  declarationLabels?: InputMaybe<Scalars['String']>;
  declarationStatuses?: InputMaybe<Scalars['String']>;
  declarationType?: InputMaybe<Scalars['String']>;
  evvStatus?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  maxDate?: InputMaybe<Scalars['LocalDateTime']>;
  minDate?: InputMaybe<Scalars['LocalDateTime']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
  searchField?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  totalItems?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creationUser?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "user_pp" */
export type User_Pp_Obj_Rel_Insert_Input = {
  data: User_Pp_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Pp_On_Conflict>;
};

/** input type for inserting data into table "user_pp" */
export type User_Pp_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** User creation date */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_by_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  /** id of user_pp. */
  id?: InputMaybe<Scalars['uuid']>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  ldap_entry_dn?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  oauth_id?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Scalars['uuid']>;
  user_type?: InputMaybe<Scalars['String']>;
  userOrgIds?: InputMaybe<User_Org_Id_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "tenant" */
export type Tenant_Obj_Rel_Insert_Input = {
  data: Tenant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenant_On_Conflict>;
};

/** input type for inserting data into table "tenant" */
export type Tenant_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  /** tenant creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** tenant creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_labels?: InputMaybe<Document_Labels_Arr_Rel_Insert_Input>;
  /** id of tenant. */
  id?: InputMaybe<Scalars['uuid']>;
  import_list_triggers?: InputMaybe<Import_List_Trigger_Arr_Rel_Insert_Input>;
  /** tenant last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified tenant. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  tenant_type?: InputMaybe<Scalars['tenant_type']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  user_pps?: InputMaybe<User_Pp_Arr_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "address" */
export type Address_Obj_Rel_Insert_Input = {
  data: Address_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Address_On_Conflict>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  AddressType = 'address_type',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Meta = 'meta',
  /** column name */
  Reference = 'reference',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for inserting array relation for remote table "document_labels" */
export type Document_Labels_Arr_Rel_Insert_Input = {
  data: Array<Document_Labels_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Labels_On_Conflict>;
};

/** input type for inserting data into table "document_labels" */
export type Document_Labels_Insert_Input = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  document_label_org_ids?: InputMaybe<Document_Label_Org_Id_Arr_Rel_Insert_Input>;
  /** id of document_labels. */
  id?: InputMaybe<Scalars['Int']>;
  /** Marks document_labels record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  tenant?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "document_label_org_id" */
export type Document_Label_Org_Id_Arr_Rel_Insert_Input = {
  data: Array<Document_Label_Org_Id_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Label_Org_Id_On_Conflict>;
};

/** input type for inserting data into table "document_label_org_id" */
export type Document_Label_Org_Id_Insert_Input = {
  label_id?: InputMaybe<Scalars['Int']>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
};

/** on_conflict condition type for table "document_label_org_id" */
export type Document_Label_Org_Id_On_Conflict = {
  constraint: Document_Label_Org_Id_Constraint;
  update_columns?: Array<Document_Label_Org_Id_Update_Column>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};

/** unique or primary key constraints on table "document_label_org_id" */
export enum Document_Label_Org_Id_Constraint {
  /** unique or primary key constraint on columns "label_id", "org_id" */
  DocumentLabelOrgIdPkey = 'document_label_org_id_pkey'
}

/** placeholder for update columns of table "document_label_org_id" (current role has no relevant permissions) */
export enum Document_Label_Org_Id_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** on_conflict condition type for table "document_labels" */
export type Document_Labels_On_Conflict = {
  constraint: Document_Labels_Constraint;
  update_columns?: Array<Document_Labels_Update_Column>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};

/** unique or primary key constraints on table "document_labels" */
export enum Document_Labels_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocumentLabelsIdKey = 'document_labels_id_key',
  /** unique or primary key constraint on columns "id" */
  DocumentLabelsPkey = 'document_labels_pkey'
}

/** update columns of table "document_labels" */
export enum Document_Labels_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Title = 'title'
}

/** input type for inserting array relation for remote table "import_list_trigger" */
export type Import_List_Trigger_Arr_Rel_Insert_Input = {
  data: Array<Import_List_Trigger_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Import_List_Trigger_On_Conflict>;
};

/** input type for inserting data into table "import_list_trigger" */
export type Import_List_Trigger_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creationUser?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  lastModifiedUser?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  meta?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "import_list_trigger" */
export type Import_List_Trigger_On_Conflict = {
  constraint: Import_List_Trigger_Constraint;
  update_columns?: Array<Import_List_Trigger_Update_Column>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};

/** unique or primary key constraints on table "import_list_trigger" */
export enum Import_List_Trigger_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImportListTriggerPkey = 'import_list_trigger_pkey'
}

/** update columns of table "import_list_trigger" */
export enum Import_List_Trigger_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  Type = 'type'
}

/** input type for inserting array relation for remote table "user_pp" */
export type User_Pp_Arr_Rel_Insert_Input = {
  data: Array<User_Pp_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Pp_On_Conflict>;
};

/** on_conflict condition type for table "user_pp" */
export type User_Pp_On_Conflict = {
  constraint: User_Pp_Constraint;
  update_columns?: Array<User_Pp_Update_Column>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};

/** unique or primary key constraints on table "user_pp" */
export enum User_Pp_Constraint {
  /** unique or primary key constraint on columns "code" */
  UiUserPpCode = 'ui_user_pp_code',
  /** unique or primary key constraint on columns "tenant_id", "id" */
  UiUserPpId = 'ui_user_pp_id',
  /** unique or primary key constraint on columns "oauth_id" */
  UserIntOauthIdKey = 'user_int_oauth_id_key',
  /** unique or primary key constraint on columns "id" */
  UserIntPkey = 'user_int_pkey'
}

/** update columns of table "user_pp" */
export enum User_Pp_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  DeletedAt = 'deleted_at',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LdapEntryDn = 'ldap_entry_dn',
  /** column name */
  Location = 'location',
  /** column name */
  OauthId = 'oauth_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UiSettings = 'ui_settings',
  /** column name */
  UiSettingsTemplates = 'ui_settings_templates',
  /** column name */
  UserType = 'user_type'
}

/** on_conflict condition type for table "tenant" */
export type Tenant_On_Conflict = {
  constraint: Tenant_Constraint;
  update_columns?: Array<Tenant_Update_Column>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};

/** unique or primary key constraints on table "tenant" */
export enum Tenant_Constraint {
  /** unique or primary key constraint on columns "id" */
  TenantPkey = 'tenant_pkey',
  /** unique or primary key constraint on columns "address_id" */
  UiTenantAddressId = 'ui_tenant_address_id'
}

/** update columns of table "tenant" */
export enum Tenant_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  TenantName = 'tenant_name',
  /** column name */
  TenantType = 'tenant_type',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number'
}

/** input type for inserting array relation for remote table "user_org_id" */
export type User_Org_Id_Arr_Rel_Insert_Input = {
  data: Array<User_Org_Id_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Org_Id_On_Conflict>;
};

/** input type for inserting data into table "user_org_id" */
export type User_Org_Id_Insert_Input = {
  /** user_org_id creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_org_id creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** user_org_id last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_org_id. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
  user_pp?: InputMaybe<Scalars['uuid']>;
};

/** on_conflict condition type for table "user_org_id" */
export type User_Org_Id_On_Conflict = {
  constraint: User_Org_Id_Constraint;
  update_columns?: Array<User_Org_Id_Update_Column>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};

/** unique or primary key constraints on table "user_org_id" */
export enum User_Org_Id_Constraint {
  /** unique or primary key constraint on columns "org_id", "user_pp" */
  UserOrgIdPkey = 'user_org_id_pkey'
}

/** placeholder for update columns of table "user_org_id" (current role has no relevant permissions) */
export enum User_Org_Id_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** input type for inserting data into table "address_override" */
export type Address_Override_Insert_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "address_override" */
export type Address_Override_On_Conflict = {
  constraint: Address_Override_Constraint;
  update_columns?: Array<Address_Override_Update_Column>;
  where?: InputMaybe<Address_Override_Bool_Exp>;
};

/** unique or primary key constraints on table "address_override" */
export enum Address_Override_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressOverridePkey = 'address_override_pkey'
}

/** update columns of table "address_override" */
export enum Address_Override_Update_Column {
  /** column name */
  AddressType = 'address_type',
  /** column name */
  City = 'city',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContactWebsite = 'contact_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  Reference = 'reference',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  Zipcode = 'zipcode'
}

/** response of any mutation on the table "address_override" */
export type Address_Override_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address_Override>;
};

/** input type for inserting data into table "bill_detail" */
export type Bill_Detail_Insert_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  charged_items?: InputMaybe<Scalars['bigint']>;
  const_charge?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  remark?: InputMaybe<Scalars['String']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  var_charge?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting object relation for remote table "declaration_request" */
export type Declaration_Request_Obj_Rel_Insert_Input = {
  data: Declaration_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Request_On_Conflict>;
};

/** input type for inserting data into table "declaration_request" */
export type Declaration_Request_Insert_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Declaration_Request_Address_Arr_Rel_Insert_Input>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  bill_details?: InputMaybe<Bill_Detail_Arr_Rel_Insert_Input>;
  /** WeDeclare must create CH-Exportdeclaration */
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Scalars['String']>;
  clientCompany?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  declaration?: InputMaybe<Declaration_Obj_Rel_Insert_Input>;
  declaration_discussions?: InputMaybe<Declaration_Discussion_Arr_Rel_Insert_Input>;
  declaration_request_addresses?: InputMaybe<Declaration_Request_Address_Arr_Rel_Insert_Input>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Scalars['String']>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Scalars['smallint']>;
  edec?: InputMaybe<Scalars['jsonb']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** WeDeclare must create the Import customs clearance in the destination Country */
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  /** Service:  Standard  oder Express */
  is_express?: InputMaybe<Scalars['Boolean']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  payer?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Scalars['uuid']>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Scalars['String']>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  user_pp?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** input type for inserting array relation for remote table "declaration_request_address" */
export type Declaration_Request_Address_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Request_Address_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Request_Address_On_Conflict>;
};

/** input type for inserting data into table "declaration_request_address" */
export type Declaration_Request_Address_Insert_Input = {
  address?: InputMaybe<Address_Obj_Rel_Insert_Input>;
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['json']>;
  refs?: InputMaybe<Scalars['_text']>;
  search_refs?: InputMaybe<Scalars['_text']>;
};

/** on_conflict condition type for table "declaration_request_address" */
export type Declaration_Request_Address_On_Conflict = {
  constraint: Declaration_Request_Address_Constraint;
  update_columns?: Array<Declaration_Request_Address_Update_Column>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_request_address" */
export enum Declaration_Request_Address_Constraint {
  /** unique or primary key constraint on columns "dr_no", "address_type", "file_id" */
  DeclarationRequestAddressPkey = 'declaration_request_address_pkey'
}

/** update columns of table "declaration_request_address" */
export enum Declaration_Request_Address_Update_Column {
  /** column name */
  AddressId = 'address_id',
  /** column name */
  AddressType = 'address_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Refs = 'refs',
  /** column name */
  SearchRefs = 'search_refs'
}

/** input type for inserting array relation for remote table "bill_detail" */
export type Bill_Detail_Arr_Rel_Insert_Input = {
  data: Array<Bill_Detail_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Bill_Detail_On_Conflict>;
};

/** on_conflict condition type for table "bill_detail" */
export type Bill_Detail_On_Conflict = {
  constraint: Bill_Detail_Constraint;
  update_columns?: Array<Bill_Detail_Update_Column>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};

/** unique or primary key constraints on table "bill_detail" */
export enum Bill_Detail_Constraint {
  /** unique or primary key constraint on columns "srv_id", "dr_no", "file_id" */
  BillDetailFileIdDrNoSrvIdUindex = 'bill_detail_file_id_dr_no_srv_id_uindex',
  /** unique or primary key constraint on columns "detail_id" */
  BillDetailPk = 'bill_detail_pk',
  /** unique or primary key constraint on columns "srv_id", "dr_no", "file_id" */
  BillDetailUq = 'bill_detail_uq'
}

/** update columns of table "bill_detail" */
export enum Bill_Detail_Update_Column {
  /** column name */
  BillId = 'bill_id',
  /** column name */
  ChargedItems = 'charged_items',
  /** column name */
  ConstCharge = 'const_charge',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  DetailId = 'detail_id',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Remark = 'remark',
  /** column name */
  SrvId = 'srv_id',
  /** column name */
  VarCharge = 'var_charge'
}

/** input type for inserting object relation for remote table "declaration" */
export type Declaration_Obj_Rel_Insert_Input = {
  data: Declaration_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_On_Conflict>;
};

/** input type for inserting data into table "declaration" */
export type Declaration_Insert_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  access_code?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Declaration_Request_Address_Arr_Rel_Insert_Input>;
  agreed_location_of_goods?: InputMaybe<Scalars['String']>;
  ai_confirmed?: InputMaybe<Scalars['Boolean']>;
  ai_results?: InputMaybe<Scalars['jsonb']>;
  border_eau_number?: InputMaybe<Scalars['numeric']>;
  bunch_number?: InputMaybe<Scalars['Int']>;
  change_information?: InputMaybe<Scalars['date']>;
  clearance_location?: InputMaybe<Scalars['smallint']>;
  company_number_taxpayer?: InputMaybe<Scalars['String']>;
  containers?: InputMaybe<Containers_Arr_Rel_Insert_Input>;
  correction_code?: InputMaybe<Scalars['Int']>;
  correction_reason?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_address_type?: InputMaybe<Scalars['Int']>;
  customs_account_name?: InputMaybe<Scalars['String']>;
  customs_account_number?: InputMaybe<Scalars['bigint']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_office_number?: InputMaybe<Scalars['String']>;
  declarant_company_name?: InputMaybe<Scalars['String']>;
  declarant_number?: InputMaybe<Scalars['Int']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  declaration_special_mentions?: InputMaybe<Declaration_Special_Mentions_Arr_Rel_Insert_Input>;
  declaration_time?: InputMaybe<Scalars['smallint']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  delivery_destination?: InputMaybe<Scalars['bpchar']>;
  dispatch_country?: InputMaybe<Scalars['String']>;
  dispatch_country_confirmation?: InputMaybe<Scalars['Boolean']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_amount?: InputMaybe<Scalars['numeric']>;
  duty_total_amount?: InputMaybe<Scalars['numeric']>;
  evv_confirmed?: InputMaybe<Scalars['Boolean']>;
  evv_received?: InputMaybe<Scalars['Boolean']>;
  file?: InputMaybe<File_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']>;
  goods_items?: InputMaybe<Goods_Item_Arr_Rel_Insert_Input>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  incoterms?: InputMaybe<Scalars['String']>;
  initiator?: InputMaybe<Scalars['smallint']>;
  injunction_type?: InputMaybe<Scalars['smallint']>;
  inspection_code?: InputMaybe<Scalars['Boolean']>;
  invoice_currency_type?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  material_check?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  place_of_loading?: InputMaybe<Scalars['String']>;
  place_of_unloading?: InputMaybe<Scalars['String']>;
  postal_shipment_type?: InputMaybe<Scalars['String']>;
  previous_documents?: InputMaybe<Previous_Documents_Arr_Rel_Insert_Input>;
  procedure_type?: InputMaybe<Scalars['smallint']>;
  provisional_declaration_expiration_date?: InputMaybe<Scalars['date']>;
  reason?: InputMaybe<Scalars['String']>;
  receive_status?: InputMaybe<Scalars['Int']>;
  release?: InputMaybe<Scalars['Boolean']>;
  requestor_trader_identification_number?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<Scalars['Boolean']>;
  selection_correlation_id?: InputMaybe<Scalars['String']>;
  send_date?: InputMaybe<Scalars['timestamptz']>;
  send_status?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  show_in_wd?: InputMaybe<Scalars['Boolean']>;
  specific_circumstance_indicator?: InputMaybe<Scalars['bpchar']>;
  status?: InputMaybe<Scalars['Int']>;
  status_date?: InputMaybe<Scalars['date']>;
  status_time?: InputMaybe<Scalars['time']>;
  tara_factor?: InputMaybe<Scalars['numeric']>;
  total_goods_items?: InputMaybe<Scalars['Int']>;
  total_vat_value?: InputMaybe<Scalars['numeric']>;
  trader_declaration_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transfer_to_transit_system?: InputMaybe<Scalars['Boolean']>;
  transport_country?: InputMaybe<Scalars['String']>;
  transport_in_container?: InputMaybe<Scalars['Boolean']>;
  transport_mode?: InputMaybe<Scalars['Int']>;
  transport_number?: InputMaybe<Scalars['String']>;
  transport_type?: InputMaybe<Scalars['String']>;
  unique_consignment_reference_number?: InputMaybe<Scalars['String']>;
  vat_account_address_type?: InputMaybe<Scalars['Int']>;
  vat_account_name?: InputMaybe<Scalars['String']>;
  vat_account_number?: InputMaybe<Scalars['bigint']>;
  vat_number?: InputMaybe<Scalars['String']>;
  vat_suffix?: InputMaybe<Scalars['Boolean']>;
  vat_total_amount?: InputMaybe<Scalars['numeric']>;
  warehouse_coded?: InputMaybe<Scalars['smallint']>;
};

/** input type for inserting array relation for remote table "containers" */
export type Containers_Arr_Rel_Insert_Input = {
  data: Array<Containers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Containers_On_Conflict>;
};

/** input type for inserting data into table "containers" */
export type Containers_Insert_Input = {
  container_number?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** on_conflict condition type for table "containers" */
export type Containers_On_Conflict = {
  constraint: Containers_Constraint;
  update_columns?: Array<Containers_Update_Column>;
  where?: InputMaybe<Containers_Bool_Exp>;
};

/** unique or primary key constraints on table "containers" */
export enum Containers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContainersPkey = 'containers_pkey',
  /** unique or primary key constraint on columns "dr_no", "container_number", "file_id" */
  ContainersUn = 'containers_un'
}

/** update columns of table "containers" */
export enum Containers_Update_Column {
  /** column name */
  ContainerNumber = 'container_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id'
}

/** input type for inserting array relation for remote table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Special_Mentions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Special_Mentions_On_Conflict>;
};

/** input type for inserting data into table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Insert_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "declaration_special_mentions" */
export type Declaration_Special_Mentions_On_Conflict = {
  constraint: Declaration_Special_Mentions_Constraint;
  update_columns?: Array<Declaration_Special_Mentions_Update_Column>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_special_mentions" */
export enum Declaration_Special_Mentions_Constraint {
  /** unique or primary key constraint on columns "id" */
  DeclarationSpecialMentionsPkey = 'declaration_special_mentions_pkey',
  /** unique or primary key constraint on columns "dr_no", "file_id", "text" */
  DeclarationSpecialMentionsUn = 'declaration_special_mentions_un'
}

/** update columns of table "declaration_special_mentions" */
export enum Declaration_Special_Mentions_Update_Column {
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  SequenceNumber = 'sequence_number',
  /** column name */
  Text = 'text'
}

/** input type for inserting object relation for remote table "file" */
export type File_Obj_Rel_Insert_Input = {
  data: File_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<File_On_Conflict>;
};

/** input type for inserting data into table "file" */
export type File_Insert_Input = {
  created_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** file creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  declaration?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  declaration_requests?: InputMaybe<Declaration_Request_Arr_Rel_Insert_Input>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  /** id of file. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification?: InputMaybe<Scalars['String']>;
  /** Marks file record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** file last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id?: InputMaybe<Scalars['smallint']>;
  session_id?: InputMaybe<Scalars['String']>;
};

/** input type for inserting array relation for remote table "declaration_request" */
export type Declaration_Request_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Request_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Request_On_Conflict>;
};

/** on_conflict condition type for table "declaration_request" */
export type Declaration_Request_On_Conflict = {
  constraint: Declaration_Request_Constraint;
  update_columns?: Array<Declaration_Request_Update_Column>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_request" */
export enum Declaration_Request_Constraint {
  /** unique or primary key constraint on columns "dr_no", "file_id" */
  PkDeclarationRequestFileIdDrNo = 'pk_declaration_request_file_id_dr_no',
  /** unique or primary key constraint on columns "creation_date", "dr_no", "file_id" */
  UiDrFileIdCreationDate = 'ui_dr_file_id_creation_date'
}

/** update columns of table "declaration_request" */
export enum Declaration_Request_Update_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  ArrivalTime = 'arrival_time',
  /** column name */
  ArrivalType = 'arrival_type',
  /** column name */
  ChExpDecl = 'ch_exp_decl',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  DeclarationStatus = 'declaration_status',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DestTolldeptCode = 'dest_tolldept_code',
  /** column name */
  DestTolldeptName = 'dest_tolldept_name',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  Edec = 'edec',
  /** column name */
  Eta = 'eta',
  /** column name */
  FileId = 'file_id',
  /** column name */
  ImpCustClr = 'imp_cust_clr',
  /** column name */
  IsExpress = 'is_express',
  /** column name */
  Meta = 'meta',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  TollDep = 'toll_dep',
  /** column name */
  TrNo = 'tr_no',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransitdocType = 'transitdoc_type',
  /** column name */
  WaNumber = 'wa_number'
}

/** input type for inserting array relation for remote table "document" */
export type Document_Arr_Rel_Insert_Input = {
  data: Array<Document_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** input type for inserting data into table "document" */
export type Document_Insert_Input = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Scalars['String']>;
  created_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** document creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  docAnnotations?: InputMaybe<Doc_Annotation_Arr_Rel_Insert_Input>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  documentFile?: InputMaybe<File_Obj_Rel_Insert_Input>;
  documentType?: InputMaybe<Document_Type_Obj_Rel_Insert_Input>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file?: InputMaybe<Scalars['uuid']>;
  file_object?: InputMaybe<File_Obj_Rel_Insert_Input>;
  /** id of document. */
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  /** Marks document record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting array relation for remote table "doc_annotation" */
export type Doc_Annotation_Arr_Rel_Insert_Input = {
  data: Array<Doc_Annotation_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Annotation_On_Conflict>;
};

/** input type for inserting data into table "doc_annotation" */
export type Doc_Annotation_Insert_Input = {
  anno_type_id?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to doc_annotation. */
  doc_id?: InputMaybe<Scalars['uuid']>;
  document?: InputMaybe<Document_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting object relation for remote table "document" */
export type Document_Obj_Rel_Insert_Input = {
  data: Document_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_On_Conflict>;
};

/** on_conflict condition type for table "document" */
export type Document_On_Conflict = {
  constraint: Document_Constraint;
  update_columns?: Array<Document_Update_Column>;
  where?: InputMaybe<Document_Bool_Exp>;
};

/** unique or primary key constraints on table "document" */
export enum Document_Constraint {
  /** unique or primary key constraint on columns "document_type", "id" */
  DocumentPkey = 'document_pkey'
}

/** update columns of table "document" */
export enum Document_Update_Column {
  /** column name */
  Checksum = 'checksum',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DocumentBlobs = 'document_blobs',
  /** column name */
  DocumentExtension = 'document_extension',
  /** column name */
  DocumentFlags = 'document_flags',
  /** column name */
  DocumentName = 'document_name',
  /** column name */
  DocumentStatus = 'document_status',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  IsCustomsRelevant = 'is_customs_relevant',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsGenerated = 'is_generated',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  NumberOfPages = 'number_of_pages',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Sequence = 'sequence'
}

/** on_conflict condition type for table "doc_annotation" */
export type Doc_Annotation_On_Conflict = {
  constraint: Doc_Annotation_Constraint;
  update_columns?: Array<Doc_Annotation_Update_Column>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};

/** unique or primary key constraints on table "doc_annotation" */
export enum Doc_Annotation_Constraint {
  /** unique or primary key constraint on columns "anno_type_id", "doc_id" */
  PkDocAnnotationDocIdAnnoTypeId = 'pk_doc_annotation_doc_id_anno_type_id'
}

/** update columns of table "doc_annotation" */
export enum Doc_Annotation_Update_Column {
  /** column name */
  Value = 'value'
}

/** input type for inserting object relation for remote table "document_type" */
export type Document_Type_Obj_Rel_Insert_Input = {
  data: Document_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Type_On_Conflict>;
};

/** input type for inserting data into table "document_type" */
export type Document_Type_Insert_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  document_type_tenant_settings?: InputMaybe<Document_Type_Tenant_Settings_Arr_Rel_Insert_Input>;
  documents?: InputMaybe<Document_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Scalars['jsonb']>;
  user_pp?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  userPpByCreationUser?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
};

/** input type for inserting array relation for remote table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Arr_Rel_Insert_Input = {
  data: Array<Document_Type_Tenant_Settings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Document_Type_Tenant_Settings_On_Conflict>;
};

/** input type for inserting data into table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Insert_Input = {
  code?: InputMaybe<Scalars['String']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  document_schema?: InputMaybe<Scalars['jsonb']>;
  document_type?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Document_Type_Obj_Rel_Insert_Input>;
  meta?: InputMaybe<Scalars['jsonb']>;
  tenant?: InputMaybe<Scalars['uuid']>;
  Tenant?: InputMaybe<Tenant_Obj_Rel_Insert_Input>;
};

/** on_conflict condition type for table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_On_Conflict = {
  constraint: Document_Type_Tenant_Settings_Constraint;
  update_columns?: Array<Document_Type_Tenant_Settings_Update_Column>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};

/** unique or primary key constraints on table "document_type_tenant_settings" */
export enum Document_Type_Tenant_Settings_Constraint {
  /** unique or primary key constraint on columns "document_type", "tenant" */
  DocumentTypeTenantSettingsPkey = 'document_type_tenant_settings_pkey'
}

/** update columns of table "document_type_tenant_settings" */
export enum Document_Type_Tenant_Settings_Update_Column {
  /** column name */
  Code = 'code',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DefaultFlags = 'default_flags',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DocumentSchema = 'document_schema',
  /** column name */
  DocumentType = 'document_type',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta'
}

/** on_conflict condition type for table "document_type" */
export type Document_Type_On_Conflict = {
  constraint: Document_Type_Constraint;
  update_columns?: Array<Document_Type_Update_Column>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};

/** unique or primary key constraints on table "document_type" */
export enum Document_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  DocumentTypePkey = 'document_type_pkey'
}

/** update columns of table "document_type" */
export enum Document_Type_Update_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Name = 'name',
  /** column name */
  Translations = 'translations'
}

/** on_conflict condition type for table "file" */
export type File_On_Conflict = {
  constraint: File_Constraint;
  update_columns?: Array<File_Update_Column>;
  where?: InputMaybe<File_Bool_Exp>;
};

/** unique or primary key constraints on table "file" */
export enum File_Constraint {
  /** unique or primary key constraint on columns "id" */
  FilePkey = 'file_pkey',
  /** unique or primary key constraint on columns "session_id" */
  FileSessionIdKey = 'file_session_id_key',
  /** unique or primary key constraint on columns "identification" */
  FileUqIdentification = 'file_uq_identification',
  /** unique or primary key constraint on columns "org_id", "id" */
  UiFileIdOrgId = 'ui_file_id_org_id'
}

/** update columns of table "file" */
export enum File_Update_Column {
  /** column name */
  AiDocClassificationConfirmed = 'ai_doc_classification_confirmed',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  FileFlags = 'file_flags',
  /** column name */
  FileStatus = 'file_status',
  /** column name */
  FileType = 'file_type',
  /** column name */
  FileUrl = 'file_url',
  /** column name */
  Id = 'id',
  /** column name */
  Identification = 'identification',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  SessionId = 'session_id'
}

/** input type for inserting array relation for remote table "goods_item" */
export type Goods_Item_Arr_Rel_Insert_Input = {
  data: Array<Goods_Item_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Goods_Item_On_Conflict>;
};

/** input type for inserting data into table "goods_item" */
export type Goods_Item_Insert_Input = {
  additional_unit?: InputMaybe<Scalars['String']>;
  additional_unit_confirmation?: InputMaybe<Scalars['Boolean']>;
  billing_type?: InputMaybe<Scalars['smallint']>;
  clearance_type?: InputMaybe<Scalars['Int']>;
  commercial_good?: InputMaybe<Scalars['Boolean']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  commodity_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_favour_code?: InputMaybe<Scalars['Int']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  customs_net_weight?: InputMaybe<Scalars['numeric']>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_total?: InputMaybe<Scalars['numeric']>;
  duty_rate?: InputMaybe<Scalars['numeric']>;
  duty_total?: InputMaybe<Scalars['numeric']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  gross_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  net_duty?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  net_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  non_customs_law_obligation?: InputMaybe<Scalars['smallint']>;
  origin_country?: InputMaybe<Scalars['String']>;
  origin_preference?: InputMaybe<Scalars['Boolean']>;
  packagings?: InputMaybe<Packagings_Arr_Rel_Insert_Input>;
  permit_obligation_code?: InputMaybe<Scalars['Int']>;
  preference_confirmation?: InputMaybe<Scalars['Boolean']>;
  process_type?: InputMaybe<Scalars['smallint']>;
  produced_documents?: InputMaybe<Produced_Documents_Arr_Rel_Insert_Input>;
  rate_confirmation?: InputMaybe<Scalars['Boolean']>;
  refinement_type?: InputMaybe<Scalars['smallint']>;
  refund_type?: InputMaybe<Scalars['smallint']>;
  repair?: InputMaybe<Scalars['Boolean']>;
  repair_reason?: InputMaybe<Scalars['String']>;
  selection_result?: InputMaybe<Scalars['Int']>;
  statistical_code?: InputMaybe<Scalars['Int']>;
  statistical_value?: InputMaybe<Scalars['Int']>;
  statistical_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  storage_type?: InputMaybe<Scalars['smallint']>;
  tare_supplement?: InputMaybe<Scalars['numeric']>;
  tare_supplement_confirmation?: InputMaybe<Scalars['Boolean']>;
  un_dangerous_goods_code?: InputMaybe<Scalars['String']>;
  vat_code?: InputMaybe<Scalars['smallint']>;
  vat_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_total?: InputMaybe<Scalars['numeric']>;
  vat_value?: InputMaybe<Scalars['numeric']>;
  vat_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  voc_quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting array relation for remote table "packagings" */
export type Packagings_Arr_Rel_Insert_Input = {
  data: Array<Packagings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Packagings_On_Conflict>;
};

/** input type for inserting data into table "packagings" */
export type Packagings_Insert_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  packaging_reference_number?: InputMaybe<Scalars['String']>;
  packaging_type?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "packagings" */
export type Packagings_On_Conflict = {
  constraint: Packagings_Constraint;
  update_columns?: Array<Packagings_Update_Column>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};

/** unique or primary key constraints on table "packagings" */
export enum Packagings_Constraint {
  /** unique or primary key constraint on columns "id" */
  PackagingsPkey = 'packagings_pkey'
}

/** update columns of table "packagings" */
export enum Packagings_Update_Column {
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PackagingReferenceNumber = 'packaging_reference_number',
  /** column name */
  PackagingType = 'packaging_type'
}

/** input type for inserting array relation for remote table "produced_documents" */
export type Produced_Documents_Arr_Rel_Insert_Input = {
  data: Array<Produced_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Produced_Documents_On_Conflict>;
};

/** input type for inserting data into table "produced_documents" */
export type Produced_Documents_Insert_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  produced_document_issue_date?: InputMaybe<Scalars['date']>;
  produced_document_reference_number?: InputMaybe<Scalars['String']>;
  produced_document_type?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "produced_documents" */
export type Produced_Documents_On_Conflict = {
  constraint: Produced_Documents_Constraint;
  update_columns?: Array<Produced_Documents_Update_Column>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};

/** unique or primary key constraints on table "produced_documents" */
export enum Produced_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProducedDocumentsPkey = 'produced_documents_pkey',
  /** unique or primary key constraint on columns "customs_item_number", "dr_no", "produced_document_type", "produced_document_reference_number", "file_id" */
  ProducedDocumentsUn = 'produced_documents_un'
}

/** update columns of table "produced_documents" */
export enum Produced_Documents_Update_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProducedDocumentIssueDate = 'produced_document_issue_date',
  /** column name */
  ProducedDocumentReferenceNumber = 'produced_document_reference_number',
  /** column name */
  ProducedDocumentType = 'produced_document_type'
}

/** on_conflict condition type for table "goods_item" */
export type Goods_Item_On_Conflict = {
  constraint: Goods_Item_Constraint;
  update_columns?: Array<Goods_Item_Update_Column>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};

/** unique or primary key constraints on table "goods_item" */
export enum Goods_Item_Constraint {
  /** unique or primary key constraint on columns "customs_item_number", "dr_no", "file_id" */
  GoodsItemResponsePkey = 'goods_item_response_pkey'
}

/** update columns of table "goods_item" */
export enum Goods_Item_Update_Column {
  /** column name */
  AdditionalUnit = 'additional_unit',
  /** column name */
  AdditionalUnitConfirmation = 'additional_unit_confirmation',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  ClearanceType = 'clearance_type',
  /** column name */
  CommercialGood = 'commercial_good',
  /** column name */
  CommodityCode = 'commodity_code',
  /** column name */
  CommodityCodeConfirmation = 'commodity_code_confirmation',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsFavourCode = 'customs_favour_code',
  /** column name */
  CustomsItemNumber = 'customs_item_number',
  /** column name */
  CustomsNetWeight = 'customs_net_weight',
  /** column name */
  Description = 'description',
  /** column name */
  Direction = 'direction',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndOtherTaxesTotal = 'duty_and_other_taxes_total',
  /** column name */
  DutyRate = 'duty_rate',
  /** column name */
  DutyTotal = 'duty_total',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  GrossMassConfirmation = 'gross_mass_confirmation',
  /** column name */
  NetDuty = 'net_duty',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  NetMassConfirmation = 'net_mass_confirmation',
  /** column name */
  NonCustomsLawObligation = 'non_customs_law_obligation',
  /** column name */
  OriginCountry = 'origin_country',
  /** column name */
  OriginPreference = 'origin_preference',
  /** column name */
  PermitObligationCode = 'permit_obligation_code',
  /** column name */
  PreferenceConfirmation = 'preference_confirmation',
  /** column name */
  ProcessType = 'process_type',
  /** column name */
  RateConfirmation = 'rate_confirmation',
  /** column name */
  RefinementType = 'refinement_type',
  /** column name */
  RefundType = 'refund_type',
  /** column name */
  Repair = 'repair',
  /** column name */
  RepairReason = 'repair_reason',
  /** column name */
  SelectionResult = 'selection_result',
  /** column name */
  StatisticalCode = 'statistical_code',
  /** column name */
  StatisticalValue = 'statistical_value',
  /** column name */
  StatisticalValueConfirmation = 'statistical_value_confirmation',
  /** column name */
  StorageType = 'storage_type',
  /** column name */
  TareSupplement = 'tare_supplement',
  /** column name */
  TareSupplementConfirmation = 'tare_supplement_confirmation',
  /** column name */
  UnDangerousGoodsCode = 'un_dangerous_goods_code',
  /** column name */
  VatCode = 'vat_code',
  /** column name */
  VatCodeConfirmation = 'vat_code_confirmation',
  /** column name */
  VatRate = 'vat_rate',
  /** column name */
  VatTotal = 'vat_total',
  /** column name */
  VatValue = 'vat_value',
  /** column name */
  VatValueConfirmation = 'vat_value_confirmation',
  /** column name */
  VocQuantity = 'voc_quantity'
}

/** input type for inserting array relation for remote table "previous_documents" */
export type Previous_Documents_Arr_Rel_Insert_Input = {
  data: Array<Previous_Documents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Previous_Documents_On_Conflict>;
};

/** input type for inserting data into table "previous_documents" */
export type Previous_Documents_Insert_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_document_reference?: InputMaybe<Scalars['String']>;
  previous_document_type?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "previous_documents" */
export type Previous_Documents_On_Conflict = {
  constraint: Previous_Documents_Constraint;
  update_columns?: Array<Previous_Documents_Update_Column>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};

/** unique or primary key constraints on table "previous_documents" */
export enum Previous_Documents_Constraint {
  /** unique or primary key constraint on columns "id" */
  PreviousDocumentsPk = 'previous_documents_pk',
  /** unique or primary key constraint on columns "dr_no", "previous_document_reference", "previous_document_type", "file_id" */
  PreviousDocumentsUn = 'previous_documents_un'
}

/** update columns of table "previous_documents" */
export enum Previous_Documents_Update_Column {
  /** column name */
  AdditionalInformation = 'additional_information',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  PreviousDocumentReference = 'previous_document_reference',
  /** column name */
  PreviousDocumentType = 'previous_document_type'
}

/** on_conflict condition type for table "declaration" */
export type Declaration_On_Conflict = {
  constraint: Declaration_Constraint;
  update_columns?: Array<Declaration_Update_Column>;
  where?: InputMaybe<Declaration_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration" */
export enum Declaration_Constraint {
  /** unique or primary key constraint on columns "dr_no", "file_id" */
  CustomsResponsePkey = 'customs_response_pkey'
}

/** update columns of table "declaration" */
export enum Declaration_Update_Column {
  /** column name */
  AcceptanceDate = 'acceptance_date',
  /** column name */
  AccessCode = 'access_code',
  /** column name */
  AgreedLocationOfGoods = 'agreed_location_of_goods',
  /** column name */
  AiConfirmed = 'ai_confirmed',
  /** column name */
  AiResults = 'ai_results',
  /** column name */
  BorderEauNumber = 'border_eau_number',
  /** column name */
  BunchNumber = 'bunch_number',
  /** column name */
  ChangeInformation = 'change_information',
  /** column name */
  ClearanceLocation = 'clearance_location',
  /** column name */
  CompanyNumberTaxpayer = 'company_number_taxpayer',
  /** column name */
  CorrectionCode = 'correction_code',
  /** column name */
  CorrectionReason = 'correction_reason',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  CustomsAccountAddressType = 'customs_account_address_type',
  /** column name */
  CustomsAccountName = 'customs_account_name',
  /** column name */
  CustomsAccountNumber = 'customs_account_number',
  /** column name */
  CustomsDeclarationNumber = 'customs_declaration_number',
  /** column name */
  CustomsDeclarationVersion = 'customs_declaration_version',
  /** column name */
  CustomsOfficeNumber = 'customs_office_number',
  /** column name */
  DeclarantCompanyName = 'declarant_company_name',
  /** column name */
  DeclarantNumber = 'declarant_number',
  /** column name */
  DeclarationTime = 'declaration_time',
  /** column name */
  DeclarationType = 'declaration_type',
  /** column name */
  DeliveryDestination = 'delivery_destination',
  /** column name */
  DispatchCountry = 'dispatch_country',
  /** column name */
  DispatchCountryConfirmation = 'dispatch_country_confirmation',
  /** column name */
  DrNo = 'dr_no',
  /** column name */
  DutyAndOtherTaxesAmount = 'duty_and_other_taxes_amount',
  /** column name */
  DutyTotalAmount = 'duty_total_amount',
  /** column name */
  EvvConfirmed = 'evv_confirmed',
  /** column name */
  EvvReceived = 'evv_received',
  /** column name */
  FileId = 'file_id',
  /** column name */
  GrossMass = 'gross_mass',
  /** column name */
  Incoterms = 'incoterms',
  /** column name */
  Initiator = 'initiator',
  /** column name */
  InjunctionType = 'injunction_type',
  /** column name */
  InspectionCode = 'inspection_code',
  /** column name */
  InvoiceCurrencyType = 'invoice_currency_type',
  /** column name */
  Lang = 'lang',
  /** column name */
  MaterialCheck = 'material_check',
  /** column name */
  NetMass = 'net_mass',
  /** column name */
  PackagingQuantity = 'packaging_quantity',
  /** column name */
  PayerId = 'payer_id',
  /** column name */
  PlaceOfLoading = 'place_of_loading',
  /** column name */
  PlaceOfUnloading = 'place_of_unloading',
  /** column name */
  PostalShipmentType = 'postal_shipment_type',
  /** column name */
  ProcedureType = 'procedure_type',
  /** column name */
  ProvisionalDeclarationExpirationDate = 'provisional_declaration_expiration_date',
  /** column name */
  Reason = 'reason',
  /** column name */
  ReceiveStatus = 'receive_status',
  /** column name */
  Release = 'release',
  /** column name */
  RequestorTraderIdentificationNumber = 'requestor_trader_identification_number',
  /** column name */
  Security = 'security',
  /** column name */
  SelectionCorrelationId = 'selection_correlation_id',
  /** column name */
  SendDate = 'send_date',
  /** column name */
  SendStatus = 'send_status',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  ShowInWd = 'show_in_wd',
  /** column name */
  SpecificCircumstanceIndicator = 'specific_circumstance_indicator',
  /** column name */
  Status = 'status',
  /** column name */
  StatusDate = 'status_date',
  /** column name */
  StatusTime = 'status_time',
  /** column name */
  TaraFactor = 'tara_factor',
  /** column name */
  TotalGoodsItems = 'total_goods_items',
  /** column name */
  TotalVatValue = 'total_vat_value',
  /** column name */
  TraderDeclarationNumber = 'trader_declaration_number',
  /** column name */
  TraderIdentificationNumber = 'trader_identification_number',
  /** column name */
  TraderReference = 'trader_reference',
  /** column name */
  TransferToTransitSystem = 'transfer_to_transit_system',
  /** column name */
  TransportCountry = 'transport_country',
  /** column name */
  TransportInContainer = 'transport_in_container',
  /** column name */
  TransportMode = 'transport_mode',
  /** column name */
  TransportNumber = 'transport_number',
  /** column name */
  TransportType = 'transport_type',
  /** column name */
  UniqueConsignmentReferenceNumber = 'unique_consignment_reference_number',
  /** column name */
  VatAccountAddressType = 'vat_account_address_type',
  /** column name */
  VatAccountName = 'vat_account_name',
  /** column name */
  VatAccountNumber = 'vat_account_number',
  /** column name */
  VatNumber = 'vat_number',
  /** column name */
  VatSuffix = 'vat_suffix',
  /** column name */
  VatTotalAmount = 'vat_total_amount',
  /** column name */
  WarehouseCoded = 'warehouse_coded'
}

/** input type for inserting array relation for remote table "declaration_discussion" */
export type Declaration_Discussion_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Discussion_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Discussion_On_Conflict>;
};

/** input type for inserting data into table "declaration_discussion" */
export type Declaration_Discussion_Insert_Input = {
  /** Discussion is closed */
  closed?: InputMaybe<Scalars['Boolean']>;
  /** Creation date of discussion. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User initiated discussion. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_messages?: InputMaybe<Declaration_Message_Arr_Rel_Insert_Input>;
  declaration_request?: InputMaybe<Declaration_Request_Obj_Rel_Insert_Input>;
  /** Theme of discussion. */
  discussion_theme?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** File/Declaration related to discussion. */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  user_pp?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
};

/** input type for inserting array relation for remote table "declaration_message" */
export type Declaration_Message_Arr_Rel_Insert_Input = {
  data: Array<Declaration_Message_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Message_On_Conflict>;
};

/** input type for inserting data into table "declaration_message" */
export type Declaration_Message_Insert_Input = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_discussion?: InputMaybe<Declaration_Discussion_Obj_Rel_Insert_Input>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  message?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  msg_date?: InputMaybe<Scalars['timestamptz']>;
  read_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
};

/** input type for inserting object relation for remote table "declaration_discussion" */
export type Declaration_Discussion_Obj_Rel_Insert_Input = {
  data: Declaration_Discussion_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Declaration_Discussion_On_Conflict>;
};

/** on_conflict condition type for table "declaration_discussion" */
export type Declaration_Discussion_On_Conflict = {
  constraint: Declaration_Discussion_Constraint;
  update_columns?: Array<Declaration_Discussion_Update_Column>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_discussion" */
export enum Declaration_Discussion_Constraint {
  /** unique or primary key constraint on columns "discussion_id" */
  PkDeclarationDiscussionDiscussionId = 'pk_declaration_discussion_discussion_id'
}

/** placeholder for update columns of table "declaration_discussion" (current role has no relevant permissions) */
export enum Declaration_Discussion_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** on_conflict condition type for table "declaration_message" */
export type Declaration_Message_On_Conflict = {
  constraint: Declaration_Message_Constraint;
  update_columns?: Array<Declaration_Message_Update_Column>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};

/** unique or primary key constraints on table "declaration_message" */
export enum Declaration_Message_Constraint {
  /** unique or primary key constraint on columns "msg_date", "creation_user", "discussion_id", "read_date" */
  PkDeclarationMessageDiscussionIdMsgDateCreationUser = 'pk_declaration_message_discussion_id_msg_date_creation_user'
}

/** update columns of table "declaration_message" */
export enum Declaration_Message_Update_Column {
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DiscussionId = 'discussion_id',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  MsgDate = 'msg_date',
  /** column name */
  ReadDate = 'read_date',
  /** column name */
  Type = 'type'
}

/** response of any mutation on the table "bill_detail" */
export type Bill_Detail_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bill_Detail>;
};

/** response of any mutation on the table "document_label_org_id" */
export type Document_Label_Org_Id_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Document_Label_Org_Id>;
};

/** input type for inserting data into table "model_retrain" */
export type Model_Retrain_Insert_Input = {
  end_time?: InputMaybe<Scalars['timestamptz']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  request_time?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** on_conflict condition type for table "model_retrain" */
export type Model_Retrain_On_Conflict = {
  constraint: Model_Retrain_Constraint;
  update_columns?: Array<Model_Retrain_Update_Column>;
  where?: InputMaybe<Model_Retrain_Bool_Exp>;
};

/** unique or primary key constraints on table "model_retrain" */
export enum Model_Retrain_Constraint {
  /** unique or primary key constraint on columns "id" */
  ModelRetrainPkey = 'model_retrain_pkey'
}

/** update columns of table "model_retrain" */
export enum Model_Retrain_Update_Column {
  /** column name */
  EndTime = 'end_time',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Id = 'id',
  /** column name */
  RequestTime = 'request_time',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status'
}

/** response of any mutation on the table "model_retrain" */
export type Model_Retrain_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Model_Retrain>;
};

/** input type for inserting data into table "page" */
export type Page_Insert_Input = {
  created_by_user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  /** page creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** page creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of page. */
  id?: InputMaybe<Scalars['uuid']>;
  /** page last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified page. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  ocr_text?: InputMaybe<Scalars['String']>;
  page_extracts?: InputMaybe<Page_Extract_Arr_Rel_Insert_Input>;
  page_status?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['smallint']>;
  thumbnail_big_url?: InputMaybe<Scalars['String']>;
  thumbnail_small_url?: InputMaybe<Scalars['String']>;
};

/** input type for inserting array relation for remote table "page_extract" */
export type Page_Extract_Arr_Rel_Insert_Input = {
  data: Array<Page_Extract_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Page_Extract_On_Conflict>;
};

/** input type for inserting data into table "page_extract" */
export type Page_Extract_Insert_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  page?: InputMaybe<Page_Obj_Rel_Insert_Input>;
  page_id?: InputMaybe<Scalars['uuid']>;
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting object relation for remote table "page" */
export type Page_Obj_Rel_Insert_Input = {
  data: Page_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Page_On_Conflict>;
};

/** on_conflict condition type for table "page" */
export type Page_On_Conflict = {
  constraint: Page_Constraint;
  update_columns?: Array<Page_Update_Column>;
  where?: InputMaybe<Page_Bool_Exp>;
};

/** unique or primary key constraints on table "page" */
export enum Page_Constraint {
  /** unique or primary key constraint on columns "id" */
  PagePkey = 'page_pkey',
  /** unique or primary key constraint on columns "id", "page_status" */
  UiPageId = 'ui_page_id'
}

/** update columns of table "page" */
export enum Page_Update_Column {
  /** column name */
  AiIgnoreRetraining = 'ai_ignore_retraining',
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  Id = 'id',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  Meta = 'meta',
  /** column name */
  OcrText = 'ocr_text',
  /** column name */
  PageStatus = 'page_status',
  /** column name */
  Rotate = 'rotate',
  /** column name */
  ThumbnailBigUrl = 'thumbnail_big_url',
  /** column name */
  ThumbnailSmallUrl = 'thumbnail_small_url'
}

/** on_conflict condition type for table "page_extract" */
export type Page_Extract_On_Conflict = {
  constraint: Page_Extract_Constraint;
  update_columns?: Array<Page_Extract_Update_Column>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};

/** unique or primary key constraints on table "page_extract" */
export enum Page_Extract_Constraint {
  /** unique or primary key constraint on columns "extract_type_id", "page_id" */
  PageExtractPk = 'page_extract_pk'
}

/** update columns of table "page_extract" */
export enum Page_Extract_Update_Column {
  /** column name */
  ExtractTypeId = 'extract_type_id',
  /** column name */
  PageId = 'page_id',
  /** column name */
  Tables = 'tables',
  /** column name */
  Value = 'value'
}

/** input type for inserting data into table "service_tariff" */
export type Service_Tariff_Insert_Input = {
  direct_upload_cost?: InputMaybe<Scalars['numeric']>;
  email_upload_cost?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  position_cost?: InputMaybe<Scalars['numeric']>;
  positions_included?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** input type for inserting data into table "setting_value" */
export type Setting_Value_Insert_Input = {
  /** setting_value creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting_value creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** id of setting_value. */
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  /** setting_value last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting_value. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<User_Pp_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** on_conflict condition type for table "setting_value" */
export type Setting_Value_On_Conflict = {
  constraint: Setting_Value_Constraint;
  update_columns?: Array<Setting_Value_Update_Column>;
  where?: InputMaybe<Setting_Value_Bool_Exp>;
};

/** unique or primary key constraints on table "setting_value" */
export enum Setting_Value_Constraint {
  /** unique or primary key constraint on columns "id" */
  SettingTemplatePkey = 'setting_template_pkey'
}

/** update columns of table "setting_value" */
export enum Setting_Value_Update_Column {
  /** column name */
  CreationDate = 'creation_date',
  /** column name */
  CreationUser = 'creation_user',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  IsTemplate = 'is_template',
  /** column name */
  LastModifiedDate = 'last_modified_date',
  /** column name */
  LastModifiedUser = 'last_modified_user',
  /** column name */
  ReferenceId = 'reference_id',
  /** column name */
  ReferenceTypeId = 'reference_type_id',
  /** column name */
  SettingId = 'setting_id',
  /** column name */
  Value = 'value'
}

/** response of any mutation on the table "tenant" */
export type Tenant_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenant>;
};

/** response of any mutation on the table "user_org_id" */
export type User_Org_Id_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Org_Id>;
};

export type LinkAddressesInputAcs = {
  linkAddressId: Scalars['Int'];
  linkAoId?: InputMaybe<Scalars['Int']>;
  linkedToAddressId: Scalars['Int'];
  linkedToAoId?: InputMaybe<Scalars['Int']>;
  sourceLink: Scalars['String'];
  sourceLinkedTo: Scalars['String'];
  tenantId: Scalars['String'];
};

export type AddressMappingEntity = {
  address_id: Scalars['Int'];
  address_override_id: Scalars['Int'];
  is_cross_address: Maybe<Scalars['Boolean']>;
  tenant_id: Scalars['String'];
};

export type SendDeclarationArrivalNotificationInput = {
  arrival_time: Scalars['timestamptz'];
  dr_no: Scalars['Int'];
  file_id: Scalars['uuid'];
};

export type TransmitFileInput = {
  files: Array<TransmitFileEntry>;
  keepDocuments: Array<InputMaybe<Scalars['ID']>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type TransmitFileEntry = {
  declaration_creation_assigned_to?: InputMaybe<Scalars['ID']>;
  declarationData?: InputMaybe<DeclarationData>;
  documents: Array<InputMaybe<TransmitFileDocument>>;
  documentsToDelete?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  existingDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  fileId?: InputMaybe<Scalars['String']>;
  fileNumber?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  flags: Scalars['Int'];
  notify_after_extraction?: InputMaybe<Array<Scalars['ID']>>;
  orgId: Scalars['Int'];
  reviewedAndVerified?: InputMaybe<Scalars['Boolean']>;
  scheduleFileExport?: InputMaybe<Scalars['Boolean']>;
};

export type DeclarationData = {
  consigneeAddressId?: InputMaybe<Scalars['Int']>;
  consignorAddressId?: InputMaybe<Scalars['Int']>;
  customsOfficeNumber?: InputMaybe<Scalars['String']>;
  etaDate?: InputMaybe<Scalars['timestamptz']>;
  importerAddressId?: InputMaybe<Scalars['Int']>;
  payerAddressId?: InputMaybe<Scalars['Int']>;
  payerName?: InputMaybe<Scalars['String']>;
  payerReference?: InputMaybe<Scalars['String']>;
  totalColis?: InputMaybe<Scalars['Int']>;
  totalGrossWeight?: InputMaybe<Scalars['Float']>;
};

export type TransmitFileDocument = {
  documentType?: InputMaybe<Scalars['String']>;
  flags?: InputMaybe<Scalars['Int']>;
  manual_annotation_due_date?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['JSON']>;
  selectedPages: Array<Scalars['ID']>;
};

export type TransmitFileResponse = {
  error: Maybe<Scalars['String']>;
  fileIds: Maybe<Array<Maybe<Scalars['ID']>>>;
  success: Maybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Address_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Address_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Address_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Address_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "address" */
export type Address_Inc_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Address_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Address_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Address_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Address_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Address_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Address_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Address_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Address_Override_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Address_Override_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Address_Override_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Address_Override_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "address_override" */
export type Address_Override_Inc_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Address_Override_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "address_override" */
export type Address_Override_Set_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: address_override */
export type Address_Override_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Address_Override_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Address_Override_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Address_Override_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Address_Override_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Address_Override_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Address_Override_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Address_Override_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Override_Set_Input>;
  where: Address_Override_Bool_Exp;
};

/** input type for incrementing numeric columns in table "bill_detail" */
export type Bill_Detail_Inc_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  charged_items?: InputMaybe<Scalars['bigint']>;
  const_charge?: InputMaybe<Scalars['numeric']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  var_charge?: InputMaybe<Scalars['numeric']>;
};

/** input type for updating data in table "bill_detail" */
export type Bill_Detail_Set_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  charged_items?: InputMaybe<Scalars['bigint']>;
  const_charge?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  remark?: InputMaybe<Scalars['String']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  var_charge?: InputMaybe<Scalars['numeric']>;
};

/** primary key columns input for table: bill_detail */
export type Bill_Detail_Pk_Columns_Input = {
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id: Scalars['bigint'];
};

export type Bill_Detail_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bill_Detail_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bill_Detail_Set_Input>;
  where: Bill_Detail_Bool_Exp;
};

/** input type for incrementing numeric columns in table "containers" */
export type Containers_Inc_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "containers" */
export type Containers_Set_Input = {
  container_number?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** primary key columns input for table: containers */
export type Containers_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Containers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Containers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Containers_Set_Input>;
  where: Containers_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Append_Input = {
  ai_results?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Declaration_Delete_At_Path_Input = {
  ai_results?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Declaration_Delete_Elem_Input = {
  ai_results?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Declaration_Delete_Key_Input = {
  ai_results?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration" */
export type Declaration_Inc_Input = {
  border_eau_number?: InputMaybe<Scalars['numeric']>;
  bunch_number?: InputMaybe<Scalars['Int']>;
  clearance_location?: InputMaybe<Scalars['smallint']>;
  correction_code?: InputMaybe<Scalars['Int']>;
  customs_account_address_type?: InputMaybe<Scalars['Int']>;
  customs_account_number?: InputMaybe<Scalars['bigint']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  declarant_number?: InputMaybe<Scalars['Int']>;
  declaration_time?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_amount?: InputMaybe<Scalars['numeric']>;
  duty_total_amount?: InputMaybe<Scalars['numeric']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  initiator?: InputMaybe<Scalars['smallint']>;
  injunction_type?: InputMaybe<Scalars['smallint']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  procedure_type?: InputMaybe<Scalars['smallint']>;
  receive_status?: InputMaybe<Scalars['Int']>;
  send_status?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['Int']>;
  tara_factor?: InputMaybe<Scalars['numeric']>;
  total_goods_items?: InputMaybe<Scalars['Int']>;
  total_vat_value?: InputMaybe<Scalars['numeric']>;
  transport_mode?: InputMaybe<Scalars['Int']>;
  vat_account_address_type?: InputMaybe<Scalars['Int']>;
  vat_account_number?: InputMaybe<Scalars['bigint']>;
  vat_total_amount?: InputMaybe<Scalars['numeric']>;
  warehouse_coded?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Prepend_Input = {
  ai_results?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "declaration" */
export type Declaration_Set_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  access_code?: InputMaybe<Scalars['String']>;
  agreed_location_of_goods?: InputMaybe<Scalars['String']>;
  ai_confirmed?: InputMaybe<Scalars['Boolean']>;
  ai_results?: InputMaybe<Scalars['jsonb']>;
  border_eau_number?: InputMaybe<Scalars['numeric']>;
  bunch_number?: InputMaybe<Scalars['Int']>;
  change_information?: InputMaybe<Scalars['date']>;
  clearance_location?: InputMaybe<Scalars['smallint']>;
  company_number_taxpayer?: InputMaybe<Scalars['String']>;
  correction_code?: InputMaybe<Scalars['Int']>;
  correction_reason?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_address_type?: InputMaybe<Scalars['Int']>;
  customs_account_name?: InputMaybe<Scalars['String']>;
  customs_account_number?: InputMaybe<Scalars['bigint']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_office_number?: InputMaybe<Scalars['String']>;
  declarant_company_name?: InputMaybe<Scalars['String']>;
  declarant_number?: InputMaybe<Scalars['Int']>;
  declaration_time?: InputMaybe<Scalars['smallint']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  delivery_destination?: InputMaybe<Scalars['bpchar']>;
  dispatch_country?: InputMaybe<Scalars['String']>;
  dispatch_country_confirmation?: InputMaybe<Scalars['Boolean']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_amount?: InputMaybe<Scalars['numeric']>;
  duty_total_amount?: InputMaybe<Scalars['numeric']>;
  evv_confirmed?: InputMaybe<Scalars['Boolean']>;
  evv_received?: InputMaybe<Scalars['Boolean']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  incoterms?: InputMaybe<Scalars['String']>;
  initiator?: InputMaybe<Scalars['smallint']>;
  injunction_type?: InputMaybe<Scalars['smallint']>;
  inspection_code?: InputMaybe<Scalars['Boolean']>;
  invoice_currency_type?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  material_check?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  place_of_loading?: InputMaybe<Scalars['String']>;
  place_of_unloading?: InputMaybe<Scalars['String']>;
  postal_shipment_type?: InputMaybe<Scalars['String']>;
  procedure_type?: InputMaybe<Scalars['smallint']>;
  provisional_declaration_expiration_date?: InputMaybe<Scalars['date']>;
  reason?: InputMaybe<Scalars['String']>;
  receive_status?: InputMaybe<Scalars['Int']>;
  release?: InputMaybe<Scalars['Boolean']>;
  requestor_trader_identification_number?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<Scalars['Boolean']>;
  selection_correlation_id?: InputMaybe<Scalars['String']>;
  send_date?: InputMaybe<Scalars['timestamptz']>;
  send_status?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  show_in_wd?: InputMaybe<Scalars['Boolean']>;
  specific_circumstance_indicator?: InputMaybe<Scalars['bpchar']>;
  status?: InputMaybe<Scalars['Int']>;
  status_date?: InputMaybe<Scalars['date']>;
  status_time?: InputMaybe<Scalars['time']>;
  tara_factor?: InputMaybe<Scalars['numeric']>;
  total_goods_items?: InputMaybe<Scalars['Int']>;
  total_vat_value?: InputMaybe<Scalars['numeric']>;
  trader_declaration_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transfer_to_transit_system?: InputMaybe<Scalars['Boolean']>;
  transport_country?: InputMaybe<Scalars['String']>;
  transport_in_container?: InputMaybe<Scalars['Boolean']>;
  transport_mode?: InputMaybe<Scalars['Int']>;
  transport_number?: InputMaybe<Scalars['String']>;
  transport_type?: InputMaybe<Scalars['String']>;
  unique_consignment_reference_number?: InputMaybe<Scalars['String']>;
  vat_account_address_type?: InputMaybe<Scalars['Int']>;
  vat_account_name?: InputMaybe<Scalars['String']>;
  vat_account_number?: InputMaybe<Scalars['bigint']>;
  vat_number?: InputMaybe<Scalars['String']>;
  vat_suffix?: InputMaybe<Scalars['Boolean']>;
  vat_total_amount?: InputMaybe<Scalars['numeric']>;
  warehouse_coded?: InputMaybe<Scalars['smallint']>;
};

/** primary key columns input for table: declaration */
export type Declaration_Pk_Columns_Input = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};

/** input type for updating data in table "declaration_discussions" */
export type Declaration_Discussions_Set_Input = {
  last_read_date?: InputMaybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "declaration_discussions" */
export type Declaration_Discussions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Discussions>;
};

export type Declaration_Discussions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Discussions_Set_Input>;
  where: Declaration_Discussions_Bool_Exp;
};

export type Declaration_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Declaration_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Declaration_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Declaration_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Declaration_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Declaration_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Set_Input>;
  where: Declaration_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Message_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Declaration_Message_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Declaration_Message_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Declaration_Message_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration_message" */
export type Declaration_Message_Inc_Input = {
  discussion_id?: InputMaybe<Scalars['bigint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Message_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "declaration_message" */
export type Declaration_Message_Set_Input = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  message?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  msg_date?: InputMaybe<Scalars['timestamptz']>;
  read_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: declaration_message */
export type Declaration_Message_Pk_Columns_Input = {
  /** declaration_message creation user. */
  creation_user: Scalars['uuid'];
  discussion_id: Scalars['bigint'];
  msg_date: Scalars['timestamptz'];
  read_date: Scalars['timestamptz'];
};

export type Declaration_Message_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Declaration_Message_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Declaration_Message_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Declaration_Message_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Declaration_Message_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Message_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Declaration_Message_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Message_Set_Input>;
  where: Declaration_Message_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Request_Append_Input = {
  edec?: InputMaybe<Scalars['jsonb']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Declaration_Request_Delete_At_Path_Input = {
  edec?: InputMaybe<Array<Scalars['String']>>;
  /** additional attributes */
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Declaration_Request_Delete_Elem_Input = {
  edec?: InputMaybe<Scalars['Int']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Declaration_Request_Delete_Key_Input = {
  edec?: InputMaybe<Scalars['String']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration_request" */
export type Declaration_Request_Inc_Input = {
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Request_Prepend_Input = {
  edec?: InputMaybe<Scalars['jsonb']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "declaration_request" */
export type Declaration_Request_Set_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Scalars['String']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  /** WeDeclare must create CH-Exportdeclaration */
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Scalars['String']>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Scalars['String']>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Scalars['smallint']>;
  edec?: InputMaybe<Scalars['jsonb']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** WeDeclare must create the Import customs clearance in the destination Country */
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  /** Service:  Standard  oder Express */
  is_express?: InputMaybe<Scalars['Boolean']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Scalars['uuid']>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Scalars['String']>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration_request_address" */
export type Declaration_Request_Address_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
};

/** input type for updating data in table "declaration_request_address" */
export type Declaration_Request_Address_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['json']>;
  refs?: InputMaybe<Scalars['_text']>;
  search_refs?: InputMaybe<Scalars['_text']>;
};

/** primary key columns input for table: declaration_request_address */
export type Declaration_Request_Address_Pk_Columns_Input = {
  address_type: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};

export type Declaration_Request_Address_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Request_Address_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Request_Address_Set_Input>;
  where: Declaration_Request_Address_Bool_Exp;
};

/** primary key columns input for table: declaration_request */
export type Declaration_Request_Pk_Columns_Input = {
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no: Scalars['smallint'];
  /** File related to declaration request. Part of primary key */
  file_id: Scalars['uuid'];
};

export type Declaration_Request_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Declaration_Request_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Declaration_Request_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Declaration_Request_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Declaration_Request_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Request_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Declaration_Request_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Request_Set_Input>;
  where: Declaration_Request_Bool_Exp;
};

/** input type for incrementing numeric columns in table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Inc_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Set_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: declaration_special_mentions */
export type Declaration_Special_Mentions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Declaration_Special_Mentions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Special_Mentions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Special_Mentions_Set_Input>;
  where: Declaration_Special_Mentions_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Task_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Declaration_Task_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Declaration_Task_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Declaration_Task_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "declaration_task" */
export type Declaration_Task_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Scalars['Int']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Declaration_Task_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "declaration_task" */
export type Declaration_Task_Set_Input = {
  assigned_to?: InputMaybe<Scalars['uuid']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['uuid']>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Scalars['Int']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "declaration_task" */
export type Declaration_Task_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Declaration_Task>;
};

/** primary key columns input for table: declaration_task */
export type Declaration_Task_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Declaration_Task_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Declaration_Task_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Declaration_Task_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Declaration_Task_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Declaration_Task_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Declaration_Task_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Declaration_Task_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Declaration_Task_Set_Input>;
  where: Declaration_Task_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Doc_Annotation_Append_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Doc_Annotation_Delete_At_Path_Input = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Doc_Annotation_Delete_Elem_Input = {
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Doc_Annotation_Delete_Key_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Doc_Annotation_Prepend_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "doc_annotation" */
export type Doc_Annotation_Set_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: doc_annotation */
export type Doc_Annotation_Pk_Columns_Input = {
  anno_type_id: Scalars['smallint'];
  /** Document Id related to doc_annotation. */
  doc_id: Scalars['uuid'];
};

export type Doc_Annotation_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Doc_Annotation_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Doc_Annotation_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Doc_Annotation_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Doc_Annotation_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Doc_Annotation_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Annotation_Set_Input>;
  where: Doc_Annotation_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Append_Input = {
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Delete_At_Path_Input = {
  document_blobs?: InputMaybe<Array<Scalars['String']>>;
  /** additional attributes */
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Delete_Elem_Input = {
  document_blobs?: InputMaybe<Scalars['Int']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Delete_Key_Input = {
  document_blobs?: InputMaybe<Scalars['String']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "document" */
export type Document_Inc_Input = {
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Scalars['bigint']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Prepend_Input = {
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "document" */
export type Document_Set_Input = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Scalars['String']>;
  /** document creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file?: InputMaybe<Scalars['uuid']>;
  /** id of document. */
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  /** Marks document record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** primary key columns input for table: document */
export type Document_Pk_Columns_Input = {
  document_type: Scalars['String'];
  /** id of document. */
  id: Scalars['uuid'];
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Labels_Append_Input = {
  description?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Labels_Delete_At_Path_Input = {
  description?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Labels_Delete_Elem_Input = {
  description?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Labels_Delete_Key_Input = {
  description?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "document_labels" */
export type Document_Labels_Inc_Input = {
  /** id of document_labels. */
  id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Labels_Prepend_Input = {
  description?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "document_labels" */
export type Document_Labels_Set_Input = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  /** id of document_labels. */
  id?: InputMaybe<Scalars['Int']>;
  /** Marks document_labels record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: document_labels */
export type Document_Labels_Pk_Columns_Input = {
  /** id of document_labels. */
  id: Scalars['Int'];
};

export type Document_Labels_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Labels_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Labels_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Labels_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Labels_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Labels_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Labels_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Labels_Set_Input>;
  where: Document_Labels_Bool_Exp;
};

export type Document_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Set_Input>;
  where: Document_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Type_Append_Input = {
  translations?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Type_Delete_At_Path_Input = {
  translations?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Type_Delete_Elem_Input = {
  translations?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Type_Delete_Key_Input = {
  translations?: InputMaybe<Scalars['String']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Type_Prepend_Input = {
  translations?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "document_type" */
export type Document_Type_Set_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: document_type */
export type Document_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

export type Document_Type_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Type_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Type_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Type_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Type_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Type_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Type_Set_Input>;
  where: Document_Type_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Document_Type_Tenant_Settings_Append_Input = {
  document_schema?: InputMaybe<Scalars['jsonb']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Document_Type_Tenant_Settings_Delete_At_Path_Input = {
  document_schema?: InputMaybe<Array<Scalars['String']>>;
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Document_Type_Tenant_Settings_Delete_Elem_Input = {
  document_schema?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Document_Type_Tenant_Settings_Delete_Key_Input = {
  document_schema?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Inc_Input = {
  default_flags?: InputMaybe<Scalars['bigint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Document_Type_Tenant_Settings_Prepend_Input = {
  document_schema?: InputMaybe<Scalars['jsonb']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  document_schema?: InputMaybe<Scalars['jsonb']>;
  document_type?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: document_type_tenant_settings */
export type Document_Type_Tenant_Settings_Pk_Columns_Input = {
  document_type: Scalars['String'];
  tenant: Scalars['uuid'];
};

export type Document_Type_Tenant_Settings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Document_Type_Tenant_Settings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Document_Type_Tenant_Settings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Document_Type_Tenant_Settings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Document_Type_Tenant_Settings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Document_Type_Tenant_Settings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Document_Type_Tenant_Settings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Document_Type_Tenant_Settings_Set_Input>;
  where: Document_Type_Tenant_Settings_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Extraction_Config_Append_Input = {
  aliases?: InputMaybe<Scalars['jsonb']>;
  document_templates?: InputMaybe<Scalars['jsonb']>;
  foun_config?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Extraction_Config_Delete_At_Path_Input = {
  aliases?: InputMaybe<Array<Scalars['String']>>;
  document_templates?: InputMaybe<Array<Scalars['String']>>;
  foun_config?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Extraction_Config_Delete_Elem_Input = {
  aliases?: InputMaybe<Scalars['Int']>;
  document_templates?: InputMaybe<Scalars['Int']>;
  foun_config?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Extraction_Config_Delete_Key_Input = {
  aliases?: InputMaybe<Scalars['String']>;
  document_templates?: InputMaybe<Scalars['String']>;
  foun_config?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "extraction_config" */
export type Extraction_Config_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Extraction_Config_Prepend_Input = {
  aliases?: InputMaybe<Scalars['jsonb']>;
  document_templates?: InputMaybe<Scalars['jsonb']>;
  foun_config?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "extraction_config" */
export type Extraction_Config_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  aliases?: InputMaybe<Scalars['jsonb']>;
  document_templates?: InputMaybe<Scalars['jsonb']>;
  foun_config?: InputMaybe<Scalars['jsonb']>;
};

/** response of any mutation on the table "extraction_config" */
export type Extraction_Config_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Extraction_Config>;
};

/** primary key columns input for table: extraction_config */
export type Extraction_Config_Pk_Columns_Input = {
  address_id: Scalars['Int'];
};

export type Extraction_Config_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Extraction_Config_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Extraction_Config_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Extraction_Config_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Extraction_Config_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Extraction_Config_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Extraction_Config_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Extraction_Config_Set_Input>;
  where: Extraction_Config_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type File_Append_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type File_Delete_At_Path_Input = {
  /** additional attributes */
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type File_Delete_Elem_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type File_Delete_Key_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "file" */
export type File_Inc_Input = {
  file_flags?: InputMaybe<Scalars['bigint']>;
  /** Org_id related to file. */
  org_id?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type File_Prepend_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "file" */
export type File_Set_Input = {
  ai_doc_classification_confirmed?: InputMaybe<Scalars['Boolean']>;
  /** file creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  /** id of file. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification?: InputMaybe<Scalars['String']>;
  /** Marks file record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  /** file last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id?: InputMaybe<Scalars['smallint']>;
  session_id?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: file */
export type File_Pk_Columns_Input = {
  /** id of file. */
  id: Scalars['uuid'];
};

export type File_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<File_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<File_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<File_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<File_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<File_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<File_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Set_Input>;
  where: File_Bool_Exp;
};

/** input type for incrementing numeric columns in table "goods_item" */
export type Goods_Item_Inc_Input = {
  billing_type?: InputMaybe<Scalars['smallint']>;
  clearance_type?: InputMaybe<Scalars['Int']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_favour_code?: InputMaybe<Scalars['Int']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  customs_net_weight?: InputMaybe<Scalars['numeric']>;
  direction?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_total?: InputMaybe<Scalars['numeric']>;
  duty_rate?: InputMaybe<Scalars['numeric']>;
  duty_total?: InputMaybe<Scalars['numeric']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  non_customs_law_obligation?: InputMaybe<Scalars['smallint']>;
  permit_obligation_code?: InputMaybe<Scalars['Int']>;
  process_type?: InputMaybe<Scalars['smallint']>;
  refinement_type?: InputMaybe<Scalars['smallint']>;
  refund_type?: InputMaybe<Scalars['smallint']>;
  selection_result?: InputMaybe<Scalars['Int']>;
  statistical_code?: InputMaybe<Scalars['Int']>;
  statistical_value?: InputMaybe<Scalars['Int']>;
  storage_type?: InputMaybe<Scalars['smallint']>;
  tare_supplement?: InputMaybe<Scalars['numeric']>;
  vat_code?: InputMaybe<Scalars['smallint']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_total?: InputMaybe<Scalars['numeric']>;
  vat_value?: InputMaybe<Scalars['numeric']>;
  voc_quantity?: InputMaybe<Scalars['numeric']>;
};

/** input type for updating data in table "goods_item" */
export type Goods_Item_Set_Input = {
  additional_unit?: InputMaybe<Scalars['String']>;
  additional_unit_confirmation?: InputMaybe<Scalars['Boolean']>;
  billing_type?: InputMaybe<Scalars['smallint']>;
  clearance_type?: InputMaybe<Scalars['Int']>;
  commercial_good?: InputMaybe<Scalars['Boolean']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  commodity_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_favour_code?: InputMaybe<Scalars['Int']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  customs_net_weight?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_total?: InputMaybe<Scalars['numeric']>;
  duty_rate?: InputMaybe<Scalars['numeric']>;
  duty_total?: InputMaybe<Scalars['numeric']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  gross_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  net_duty?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  net_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  non_customs_law_obligation?: InputMaybe<Scalars['smallint']>;
  origin_country?: InputMaybe<Scalars['String']>;
  origin_preference?: InputMaybe<Scalars['Boolean']>;
  permit_obligation_code?: InputMaybe<Scalars['Int']>;
  preference_confirmation?: InputMaybe<Scalars['Boolean']>;
  process_type?: InputMaybe<Scalars['smallint']>;
  rate_confirmation?: InputMaybe<Scalars['Boolean']>;
  refinement_type?: InputMaybe<Scalars['smallint']>;
  refund_type?: InputMaybe<Scalars['smallint']>;
  repair?: InputMaybe<Scalars['Boolean']>;
  repair_reason?: InputMaybe<Scalars['String']>;
  selection_result?: InputMaybe<Scalars['Int']>;
  statistical_code?: InputMaybe<Scalars['Int']>;
  statistical_value?: InputMaybe<Scalars['Int']>;
  statistical_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  storage_type?: InputMaybe<Scalars['smallint']>;
  tare_supplement?: InputMaybe<Scalars['numeric']>;
  tare_supplement_confirmation?: InputMaybe<Scalars['Boolean']>;
  un_dangerous_goods_code?: InputMaybe<Scalars['String']>;
  vat_code?: InputMaybe<Scalars['smallint']>;
  vat_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_total?: InputMaybe<Scalars['numeric']>;
  vat_value?: InputMaybe<Scalars['numeric']>;
  vat_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  voc_quantity?: InputMaybe<Scalars['numeric']>;
};

/** primary key columns input for table: goods_item */
export type Goods_Item_Pk_Columns_Input = {
  customs_item_number: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};

export type Goods_Item_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Goods_Item_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Goods_Item_Set_Input>;
  where: Goods_Item_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Import_List_Trigger_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Import_List_Trigger_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Import_List_Trigger_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Import_List_Trigger_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "import_list_trigger" */
export type Import_List_Trigger_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Import_List_Trigger_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "import_list_trigger" */
export type Import_List_Trigger_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: import_list_trigger */
export type Import_List_Trigger_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Import_List_Trigger_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Import_List_Trigger_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Import_List_Trigger_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Import_List_Trigger_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Import_List_Trigger_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Import_List_Trigger_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Import_List_Trigger_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Import_List_Trigger_Set_Input>;
  where: Import_List_Trigger_Bool_Exp;
};

/** input type for incrementing numeric columns in table "model_retrain" */
export type Model_Retrain_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "model_retrain" */
export type Model_Retrain_Set_Input = {
  end_time?: InputMaybe<Scalars['timestamptz']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  request_time?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: model_retrain */
export type Model_Retrain_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Model_Retrain_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Model_Retrain_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Model_Retrain_Set_Input>;
  where: Model_Retrain_Bool_Exp;
};

/** input type for incrementing numeric columns in table "packagings" */
export type Packagings_Inc_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "packagings" */
export type Packagings_Set_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  packaging_reference_number?: InputMaybe<Scalars['String']>;
  packaging_type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: packagings */
export type Packagings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Packagings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Packagings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Packagings_Set_Input>;
  where: Packagings_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Page_Append_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Page_Delete_At_Path_Input = {
  /** additional attributes */
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Page_Delete_Elem_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Page_Delete_Key_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "page" */
export type Page_Inc_Input = {
  rotate?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Page_Prepend_Input = {
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "page" */
export type Page_Set_Input = {
  ai_ignore_retraining?: InputMaybe<Scalars['Boolean']>;
  /** page creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** page creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of page. */
  id?: InputMaybe<Scalars['uuid']>;
  /** page last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified page. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  ocr_text?: InputMaybe<Scalars['String']>;
  page_status?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['smallint']>;
  thumbnail_big_url?: InputMaybe<Scalars['String']>;
  thumbnail_small_url?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: page */
export type Page_Pk_Columns_Input = {
  /** id of page. */
  id: Scalars['uuid'];
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Page_Extract_Append_Input = {
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Page_Extract_Delete_At_Path_Input = {
  tables?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Page_Extract_Delete_Elem_Input = {
  tables?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Page_Extract_Delete_Key_Input = {
  tables?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "page_extract" */
export type Page_Extract_Inc_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Page_Extract_Prepend_Input = {
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "page_extract" */
export type Page_Extract_Set_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: page_extract */
export type Page_Extract_Pk_Columns_Input = {
  extract_type_id: Scalars['smallint'];
  page_id: Scalars['uuid'];
};

export type Page_Extract_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Page_Extract_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Page_Extract_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Page_Extract_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Page_Extract_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Page_Extract_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Page_Extract_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Page_Extract_Set_Input>;
  where: Page_Extract_Bool_Exp;
};

export type Page_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Page_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Page_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Page_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Page_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Page_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Page_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Page_Set_Input>;
  where: Page_Bool_Exp;
};

/** input type for incrementing numeric columns in table "previous_documents" */
export type Previous_Documents_Inc_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "previous_documents" */
export type Previous_Documents_Set_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_document_reference?: InputMaybe<Scalars['String']>;
  previous_document_type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: previous_documents */
export type Previous_Documents_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Previous_Documents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Previous_Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Previous_Documents_Set_Input>;
  where: Previous_Documents_Bool_Exp;
};

/** input type for incrementing numeric columns in table "produced_documents" */
export type Produced_Documents_Inc_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "produced_documents" */
export type Produced_Documents_Set_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  produced_document_issue_date?: InputMaybe<Scalars['date']>;
  produced_document_reference_number?: InputMaybe<Scalars['String']>;
  produced_document_type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: produced_documents */
export type Produced_Documents_Pk_Columns_Input = {
  id: Scalars['Int'];
};

export type Produced_Documents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Produced_Documents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Produced_Documents_Set_Input>;
  where: Produced_Documents_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Service_Tariff_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Service_Tariff_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Service_Tariff_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Service_Tariff_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "service_tariff" */
export type Service_Tariff_Inc_Input = {
  direct_upload_cost?: InputMaybe<Scalars['numeric']>;
  email_upload_cost?: InputMaybe<Scalars['numeric']>;
  position_cost?: InputMaybe<Scalars['numeric']>;
  positions_included?: InputMaybe<Scalars['Int']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Service_Tariff_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "service_tariff" */
export type Service_Tariff_Set_Input = {
  direct_upload_cost?: InputMaybe<Scalars['numeric']>;
  email_upload_cost?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  position_cost?: InputMaybe<Scalars['numeric']>;
  positions_included?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

export type Service_Tariff_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Service_Tariff_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Service_Tariff_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Service_Tariff_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Service_Tariff_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Service_Tariff_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Service_Tariff_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Service_Tariff_Set_Input>;
  where: Service_Tariff_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Setting_Value_Append_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Setting_Value_Delete_At_Path_Input = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Setting_Value_Delete_Elem_Input = {
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Setting_Value_Delete_Key_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Setting_Value_Prepend_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "setting_value" */
export type Setting_Value_Set_Input = {
  /** setting_value creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting_value creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** id of setting_value. */
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  /** setting_value last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting_value. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** primary key columns input for table: setting_value */
export type Setting_Value_Pk_Columns_Input = {
  /** id of setting_value. */
  id: Scalars['uuid'];
};

export type Setting_Value_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Setting_Value_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Setting_Value_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Setting_Value_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Setting_Value_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Setting_Value_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Setting_Value_Set_Input>;
  where: Setting_Value_Bool_Exp;
};

/** input type for incrementing numeric columns in table "tenant" */
export type Tenant_Inc_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
};

/** input type for updating data in table "tenant" */
export type Tenant_Set_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  /** tenant creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** tenant creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of tenant. */
  id?: InputMaybe<Scalars['uuid']>;
  /** tenant last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified tenant. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  tenant_type?: InputMaybe<Scalars['tenant_type']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: tenant */
export type Tenant_Pk_Columns_Input = {
  /** id of tenant. */
  id: Scalars['uuid'];
};

export type Tenant_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenant_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenant_Set_Input>;
  where: Tenant_Bool_Exp;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type User_Pp_Append_Input = {
  ui_settings?: InputMaybe<Scalars['jsonb']>;
  ui_settings_templates?: InputMaybe<Scalars['jsonb']>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type User_Pp_Delete_At_Path_Input = {
  ui_settings?: InputMaybe<Array<Scalars['String']>>;
  ui_settings_templates?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type User_Pp_Delete_Elem_Input = {
  ui_settings?: InputMaybe<Scalars['Int']>;
  ui_settings_templates?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type User_Pp_Delete_Key_Input = {
  ui_settings?: InputMaybe<Scalars['String']>;
  ui_settings_templates?: InputMaybe<Scalars['String']>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type User_Pp_Prepend_Input = {
  ui_settings?: InputMaybe<Scalars['jsonb']>;
  ui_settings_templates?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "user_pp" */
export type User_Pp_Set_Input = {
  code?: InputMaybe<Scalars['String']>;
  /** User creation date */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_by_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  /** id of user_pp. */
  id?: InputMaybe<Scalars['uuid']>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  ldap_entry_dn?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  oauth_id?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Scalars['uuid']>;
  ui_settings?: InputMaybe<Scalars['jsonb']>;
  ui_settings_templates?: InputMaybe<Scalars['jsonb']>;
  user_type?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: user_pp */
export type User_Pp_Pk_Columns_Input = {
  /** id of user_pp. */
  id: Scalars['uuid'];
};

export type User_Pp_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<User_Pp_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<User_Pp_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<User_Pp_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<User_Pp_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<User_Pp_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Pp_Set_Input>;
  where: User_Pp_Bool_Exp;
};

export type ReassignFileNumberResponse = {
  file_id: Maybe<Scalars['ID']>;
  file_status: Maybe<Scalars['String']>;
  identification: Maybe<Scalars['String']>;
};

export type UpdatePasswordDto = {
  id: Scalars['String'];
  newPassword: Scalars['PASSWORD_REGEX'];
  oldPassword: Scalars['String'];
};

export type WdUpdateUserDto = {
  externalAuthProvider?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type AddressUpsertArgs = {
  evvAddress: UpsertAddressInputAcs;
  lbaseReference: Scalars['String'];
};

export type UpsertAddressInputAcs = {
  additionalValues?: InputMaybe<Scalars['JSON']>;
  city: Scalars['String'];
  companyEmail?: InputMaybe<Scalars['String']>;
  companyName: Scalars['String'];
  companyName2: Scalars['String'];
  companyPhone?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  customsAccountNumber?: InputMaybe<Scalars['String']>;
  errorEmailAddress?: InputMaybe<Scalars['String']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  status: Scalars['Int'];
  street: Scalars['String'];
  traderIdentificationNumber?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  vatAccountNumber?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type ValidateFileNumberResponse = {
  data: Maybe<ShipmentData>;
  error_code: Maybe<Scalars['String']>;
  error_description: Maybe<Scalars['String']>;
};

export type ShipmentData = {
  consignee: Maybe<ShipmentInfoAddress>;
  consignor: Maybe<ShipmentInfoAddress>;
  importer: Maybe<ShipmentInfoAddress>;
  lines: Maybe<Array<Maybe<Line>>>;
  orderedBy: Maybe<ShipmentInfoAddress>;
  orgId: Maybe<Scalars['String']>;
  shipmentNumber: Maybe<Scalars['String']>;
  shipper: Maybe<ShipmentInfoAddress>;
  traffic: Maybe<Scalars['String']>;
};

export type ShipmentInfoAddress = {
  adrID: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  consigneeAdrID: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  state: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
};

export type Line = {
  grossWeight: Maybe<Scalars['String']>;
  packaging: Maybe<Scalars['String']>;
  quantity: Maybe<Scalars['String']>;
};

export type ValidateJourneyNumberResponse = {
  data: Maybe<Scalars['JSON']>;
  error_code: Maybe<Scalars['String']>;
  error_description: Maybe<Scalars['String']>;
};

export type Subscription_Root = {
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk: Maybe<Address>;
  /** fetch data from the table: "address_groups" */
  address_groups: Array<Address_Groups>;
  /** fetch data from the table in a streaming manner: "address_groups" */
  address_groups_stream: Array<Address_Groups>;
  /** fetch data from the table: "address_mapping" */
  address_mapping: Array<Address_Mapping>;
  /** fetch data from the table: "address_mapping" using primary key columns */
  address_mapping_by_pk: Maybe<Address_Mapping>;
  /** fetch data from the table in a streaming manner: "address_mapping" */
  address_mapping_stream: Array<Address_Mapping>;
  /** fetch data from the table: "address_override" */
  address_override: Array<Address_Override>;
  /** fetch data from the table: "address_override" using primary key columns */
  address_override_by_pk: Maybe<Address_Override>;
  /** fetch data from the table in a streaming manner: "address_override" */
  address_override_stream: Array<Address_Override>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>;
  /** fetch data from the table: "address_type" */
  address_type: Array<Address_Type>;
  /** fetch data from the table: "address_type" using primary key columns */
  address_type_by_pk: Maybe<Address_Type>;
  /** fetch data from the table in a streaming manner: "address_type" */
  address_type_stream: Array<Address_Type>;
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch data from the table in a streaming manner: "addresses" */
  addresses_stream: Array<Addresses>;
  /** fetch data from the table: "ai_stats_dt_type" */
  ai_stats_dt_type: Array<Ai_Stats_Dt_Type>;
  /** fetch data from the table in a streaming manner: "ai_stats_dt_type" */
  ai_stats_dt_type_stream: Array<Ai_Stats_Dt_Type>;
  /** fetch data from the table: "ai_stats_type" */
  ai_stats_type: Array<Ai_Stats_Type>;
  /** fetch data from the table in a streaming manner: "ai_stats_type" */
  ai_stats_type_stream: Array<Ai_Stats_Type>;
  /** fetch data from the table: "annotation_provider" */
  annotation_provider: Array<Annotation_Provider>;
  /** fetch data from the table: "annotation_provider" using primary key columns */
  annotation_provider_by_pk: Maybe<Annotation_Provider>;
  /** fetch data from the table in a streaming manner: "annotation_provider" */
  annotation_provider_stream: Array<Annotation_Provider>;
  /** fetch data from the table: "annotation_type" */
  annotation_type: Array<Annotation_Type>;
  /** fetch data from the table: "annotation_type" using primary key columns */
  annotation_type_by_pk: Maybe<Annotation_Type>;
  /** fetch data from the table in a streaming manner: "annotation_type" */
  annotation_type_stream: Array<Annotation_Type>;
  /** fetch data from the table: "api_key" */
  api_key: Array<Api_Key>;
  /** fetch data from the table: "api_key" using primary key columns */
  api_key_by_pk: Maybe<Api_Key>;
  /** fetch data from the table in a streaming manner: "api_key" */
  api_key_stream: Array<Api_Key>;
  /** fetch data from the table: "arrival_type" */
  arrival_type: Array<Arrival_Type>;
  /** fetch data from the table: "arrival_type" using primary key columns */
  arrival_type_by_pk: Maybe<Arrival_Type>;
  /** fetch data from the table in a streaming manner: "arrival_type" */
  arrival_type_stream: Array<Arrival_Type>;
  /** fetch data from the table: "article" */
  article: Array<Article>;
  /** fetch data from the table: "article" using primary key columns */
  article_by_pk: Maybe<Article>;
  /** fetch data from the table in a streaming manner: "article" */
  article_stream: Array<Article>;
  /** fetch data from the table: "bill" */
  bill: Array<Bill>;
  /** fetch aggregated fields from the table: "bill" */
  bill_aggregate: Bill_Aggregate;
  /** fetch data from the table: "bill" using primary key columns */
  bill_by_pk: Maybe<Bill>;
  /** fetch data from the table: "bill_detail" */
  bill_detail: Array<Bill_Detail>;
  /** fetch data from the table: "bill_detail" using primary key columns */
  bill_detail_by_pk: Maybe<Bill_Detail>;
  /** fetch data from the table in a streaming manner: "bill_detail" */
  bill_detail_stream: Array<Bill_Detail>;
  /** fetch data from the table in a streaming manner: "bill" */
  bill_stream: Array<Bill>;
  /** fetch data from the table: "clearance_type" */
  clearance_type: Array<Clearance_Type>;
  /** fetch data from the table: "clearance_type" using primary key columns */
  clearance_type_by_pk: Maybe<Clearance_Type>;
  /** fetch data from the table in a streaming manner: "clearance_type" */
  clearance_type_stream: Array<Clearance_Type>;
  /** An array relationship */
  containers: Array<Containers>;
  /** fetch data from the table: "containers" using primary key columns */
  containers_by_pk: Maybe<Containers>;
  /** fetch data from the table in a streaming manner: "containers" */
  containers_stream: Array<Containers>;
  /** fetch data from the table: "count_type" */
  count_type: Array<Count_Type>;
  /** fetch data from the table in a streaming manner: "count_type" */
  count_type_stream: Array<Count_Type>;
  /** fetch data from the table: "customs_office" */
  customs_office: Array<Customs_Office>;
  /** fetch data from the table: "customs_office" using primary key columns */
  customs_office_by_pk: Maybe<Customs_Office>;
  /** fetch data from the table in a streaming manner: "customs_office" */
  customs_office_stream: Array<Customs_Office>;
  /** fetch data from the table: "customs_offices" */
  customs_offices: Array<Customs_Offices>;
  /** fetch data from the table: "customs_offices" using primary key columns */
  customs_offices_by_pk: Maybe<Customs_Offices>;
  /** fetch data from the table in a streaming manner: "customs_offices" */
  customs_offices_stream: Array<Customs_Offices>;
  /** fetch data from the table: "declaration" */
  declaration: Array<Declaration>;
  /** fetch data from the table: "declaration" using primary key columns */
  declaration_by_pk: Maybe<Declaration>;
  /** fetch data from the table: "declaration_discussion" */
  declaration_discussion: Array<Declaration_Discussion>;
  /** fetch aggregated fields from the table: "declaration_discussion" */
  declaration_discussion_aggregate: Declaration_Discussion_Aggregate;
  /** fetch data from the table: "declaration_discussion" using primary key columns */
  declaration_discussion_by_pk: Maybe<Declaration_Discussion>;
  /** fetch data from the table in a streaming manner: "declaration_discussion" */
  declaration_discussion_stream: Array<Declaration_Discussion>;
  /** fetch data from the table: "declaration_discussions" */
  declaration_discussions: Array<Declaration_Discussions>;
  /** fetch data from the table in a streaming manner: "declaration_discussions" */
  declaration_discussions_stream: Array<Declaration_Discussions>;
  /** fetch data from the table: "declaration_document" */
  declaration_document: Array<Declaration_Document>;
  /** fetch data from the table: "declaration_document" using primary key columns */
  declaration_document_by_pk: Maybe<Declaration_Document>;
  /** fetch data from the table in a streaming manner: "declaration_document" */
  declaration_document_stream: Array<Declaration_Document>;
  /** An array relationship */
  declaration_labels: Array<Declaration_Labels>;
  /** fetch data from the table: "declaration_labels" using primary key columns */
  declaration_labels_by_pk: Maybe<Declaration_Labels>;
  /** fetch data from the table in a streaming manner: "declaration_labels" */
  declaration_labels_stream: Array<Declaration_Labels>;
  /** fetch data from the table: "declaration_message" */
  declaration_message: Array<Declaration_Message>;
  /** fetch aggregated fields from the table: "declaration_message" */
  declaration_message_aggregate: Declaration_Message_Aggregate;
  /** fetch data from the table: "declaration_message" using primary key columns */
  declaration_message_by_pk: Maybe<Declaration_Message>;
  /** fetch data from the table in a streaming manner: "declaration_message" */
  declaration_message_stream: Array<Declaration_Message>;
  /** fetch data from the table: "declaration_request" */
  declaration_request: Array<Declaration_Request>;
  /** fetch data from the table: "declaration_request_address" */
  declaration_request_address: Array<Declaration_Request_Address>;
  /** fetch data from the table: "declaration_request_address_ai" */
  declaration_request_address_ai: Array<Declaration_Request_Address_Ai>;
  /** fetch data from the table: "declaration_request_address_ai" using primary key columns */
  declaration_request_address_ai_by_pk: Maybe<Declaration_Request_Address_Ai>;
  /** fetch data from the table in a streaming manner: "declaration_request_address_ai" */
  declaration_request_address_ai_stream: Array<Declaration_Request_Address_Ai>;
  /** fetch data from the table: "declaration_request_address" using primary key columns */
  declaration_request_address_by_pk: Maybe<Declaration_Request_Address>;
  /** fetch data from the table in a streaming manner: "declaration_request_address" */
  declaration_request_address_stream: Array<Declaration_Request_Address>;
  /** fetch data from the table: "declaration_request" using primary key columns */
  declaration_request_by_pk: Maybe<Declaration_Request>;
  /** An array relationship */
  declaration_request_labels: Array<Declaration_Request_Labels>;
  /** fetch data from the table: "declaration_request_labels" using primary key columns */
  declaration_request_labels_by_pk: Maybe<Declaration_Request_Labels>;
  /** fetch data from the table in a streaming manner: "declaration_request_labels" */
  declaration_request_labels_stream: Array<Declaration_Request_Labels>;
  /** fetch data from the table in a streaming manner: "declaration_request" */
  declaration_request_stream: Array<Declaration_Request>;
  /** fetch data from the table: "declaration_requests" */
  declaration_requests: Array<Declaration_Requests>;
  /** fetch data from the table in a streaming manner: "declaration_requests" */
  declaration_requests_stream: Array<Declaration_Requests>;
  /** fetch data from the table: "declaration_search" */
  declaration_search: Array<Declaration_Search>;
  /** fetch data from the table in a streaming manner: "declaration_search" */
  declaration_search_stream: Array<Declaration_Search>;
  /** An array relationship */
  declaration_special_mentions: Array<Declaration_Special_Mentions>;
  /** fetch data from the table: "declaration_special_mentions" using primary key columns */
  declaration_special_mentions_by_pk: Maybe<Declaration_Special_Mentions>;
  /** fetch data from the table in a streaming manner: "declaration_special_mentions" */
  declaration_special_mentions_stream: Array<Declaration_Special_Mentions>;
  /** fetch data from the table: "declaration_status" */
  declaration_status: Array<Declaration_Status>;
  /** fetch data from the table: "declaration_status" using primary key columns */
  declaration_status_by_pk: Maybe<Declaration_Status>;
  /** fetch data from the table in a streaming manner: "declaration_status" */
  declaration_status_stream: Array<Declaration_Status>;
  /** fetch data from the table in a streaming manner: "declaration" */
  declaration_stream: Array<Declaration>;
  /** fetch data from the table: "declaration_task" */
  declaration_task: Array<Declaration_Task>;
  /** fetch aggregated fields from the table: "declaration_task" */
  declaration_task_aggregate: Declaration_Task_Aggregate;
  /** fetch data from the table: "declaration_task" using primary key columns */
  declaration_task_by_pk: Maybe<Declaration_Task>;
  /** fetch data from the table in a streaming manner: "declaration_task" */
  declaration_task_stream: Array<Declaration_Task>;
  /** fetch data from the table: "declaration_tasks" */
  declaration_tasks: Array<Declaration_Tasks>;
  /** fetch data from the table: "declaration_tasks_obj" */
  declaration_tasks_obj: Array<Declaration_Tasks_Obj>;
  /** fetch data from the table in a streaming manner: "declaration_tasks_obj" */
  declaration_tasks_obj_stream: Array<Declaration_Tasks_Obj>;
  /** fetch data from the table in a streaming manner: "declaration_tasks" */
  declaration_tasks_stream: Array<Declaration_Tasks>;
  /** fetch data from the table: "declaration_type" */
  declaration_type: Array<Declaration_Type>;
  /** fetch data from the table: "declaration_type" using primary key columns */
  declaration_type_by_pk: Maybe<Declaration_Type>;
  /** fetch data from the table in a streaming manner: "declaration_type" */
  declaration_type_stream: Array<Declaration_Type>;
  /** fetch data from the table: "discussion_changes" */
  discussion_changes: Array<Discussion_Changes>;
  /** fetch data from the table in a streaming manner: "discussion_changes" */
  discussion_changes_stream: Array<Discussion_Changes>;
  /** fetch data from the table: "doc_annotation" */
  doc_annotation: Array<Doc_Annotation>;
  /** fetch data from the table: "doc_annotation" using primary key columns */
  doc_annotation_by_pk: Maybe<Doc_Annotation>;
  /** fetch data from the table in a streaming manner: "doc_annotation" */
  doc_annotation_stream: Array<Doc_Annotation>;
  /** fetch data from the table: "doc_search_type" */
  doc_search_type: Array<Doc_Search_Type>;
  /** fetch data from the table in a streaming manner: "doc_search_type" */
  doc_search_type_stream: Array<Doc_Search_Type>;
  /** fetch data from the table: "doc_stats_type" */
  doc_stats_type: Array<Doc_Stats_Type>;
  /** fetch data from the table in a streaming manner: "doc_stats_type" */
  doc_stats_type_stream: Array<Doc_Stats_Type>;
  /** fetch data from the table: "docs_for_validation" */
  docs_for_validation: Array<Docs_For_Validation>;
  /** fetch data from the table in a streaming manner: "docs_for_validation" */
  docs_for_validation_stream: Array<Docs_For_Validation>;
  /** fetch data from the table: "document" */
  document: Array<Document>;
  /** fetch aggregated fields from the table: "document" */
  document_aggregate: Document_Aggregate;
  /** fetch data from the table: "document" using primary key columns */
  document_by_pk: Maybe<Document>;
  /** fetch data from the table: "document_extension" */
  document_extension: Array<Document_Extension>;
  /** fetch data from the table: "document_extension" using primary key columns */
  document_extension_by_pk: Maybe<Document_Extension>;
  /** fetch data from the table in a streaming manner: "document_extension" */
  document_extension_stream: Array<Document_Extension>;
  /** fetch data from the table: "document_flag" */
  document_flag: Array<Document_Flag>;
  /** fetch data from the table: "document_flag" using primary key columns */
  document_flag_by_pk: Maybe<Document_Flag>;
  /** fetch data from the table in a streaming manner: "document_flag" */
  document_flag_stream: Array<Document_Flag>;
  /** fetch data from the table: "document_label_org_id" */
  document_label_org_id: Array<Document_Label_Org_Id>;
  /** fetch data from the table: "document_label_org_id" using primary key columns */
  document_label_org_id_by_pk: Maybe<Document_Label_Org_Id>;
  /** fetch data from the table in a streaming manner: "document_label_org_id" */
  document_label_org_id_stream: Array<Document_Label_Org_Id>;
  /** An array relationship */
  document_labels: Array<Document_Labels>;
  /** fetch data from the table: "document_labels" using primary key columns */
  document_labels_by_pk: Maybe<Document_Labels>;
  /** fetch data from the table in a streaming manner: "document_labels" */
  document_labels_stream: Array<Document_Labels>;
  /** fetch data from the table: "document_page" */
  document_page: Array<Document_Page>;
  /** fetch aggregated fields from the table: "document_page" */
  document_page_aggregate: Document_Page_Aggregate;
  /** fetch data from the table: "document_page" using primary key columns */
  document_page_by_pk: Maybe<Document_Page>;
  /** fetch data from the table in a streaming manner: "document_page" */
  document_page_stream: Array<Document_Page>;
  /** fetch data from the table: "document_status" */
  document_status: Array<Document_Status>;
  /** fetch data from the table: "document_status" using primary key columns */
  document_status_by_pk: Maybe<Document_Status>;
  /** fetch data from the table in a streaming manner: "document_status" */
  document_status_stream: Array<Document_Status>;
  /** fetch data from the table in a streaming manner: "document" */
  document_stream: Array<Document>;
  /** fetch data from the table: "document_type" */
  document_type: Array<Document_Type>;
  /** fetch aggregated fields from the table: "document_type" */
  document_type_aggregate: Document_Type_Aggregate;
  /** An array relationship */
  document_type_all_tenant_settings: Array<Document_Type_All_Tenant_Settings>;
  /** fetch data from the table in a streaming manner: "document_type_all_tenant_settings" */
  document_type_all_tenant_settings_stream: Array<Document_Type_All_Tenant_Settings>;
  /** fetch data from the table: "document_type" using primary key columns */
  document_type_by_pk: Maybe<Document_Type>;
  /** fetch data from the table in a streaming manner: "document_type" */
  document_type_stream: Array<Document_Type>;
  /** An array relationship */
  document_type_tenant_settings: Array<Document_Type_Tenant_Settings>;
  /** fetch data from the table: "document_type_tenant_settings" using primary key columns */
  document_type_tenant_settings_by_pk: Maybe<Document_Type_Tenant_Settings>;
  /** fetch data from the table in a streaming manner: "document_type_tenant_settings" */
  document_type_tenant_settings_stream: Array<Document_Type_Tenant_Settings>;
  /** fetch data from the table: "dr_stats" */
  dr_stats: Array<Dr_Stats>;
  /** fetch data from the table in a streaming manner: "dr_stats" */
  dr_stats_stream: Array<Dr_Stats>;
  /** fetch data from the table: "edec_countries" */
  edec_countries: Array<Edec_Countries>;
  /** fetch data from the table: "edec_countries" using primary key columns */
  edec_countries_by_pk: Maybe<Edec_Countries>;
  /** fetch data from the table in a streaming manner: "edec_countries" */
  edec_countries_stream: Array<Edec_Countries>;
  /** fetch data from the table: "edec_customs_offices" */
  edec_customs_offices: Array<Edec_Customs_Offices>;
  /** fetch data from the table: "edec_customs_offices" using primary key columns */
  edec_customs_offices_by_pk: Maybe<Edec_Customs_Offices>;
  /** fetch data from the table in a streaming manner: "edec_customs_offices" */
  edec_customs_offices_stream: Array<Edec_Customs_Offices>;
  /** fetch data from the table: "edec_domains" */
  edec_domains: Array<Edec_Domains>;
  /** fetch data from the table: "edec_domains" using primary key columns */
  edec_domains_by_pk: Maybe<Edec_Domains>;
  /** fetch data from the table in a streaming manner: "edec_domains" */
  edec_domains_stream: Array<Edec_Domains>;
  /** fetch data from the table: "edec_tariff_commodity_code" */
  edec_tariff_commodity_code: Array<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table: "edec_tariff_commodity_code" using primary key columns */
  edec_tariff_commodity_code_by_pk: Maybe<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table in a streaming manner: "edec_tariff_commodity_code" */
  edec_tariff_commodity_code_stream: Array<Edec_Tariff_Commodity_Code>;
  /** fetch data from the table: "edec_tariff_statistical_code" */
  edec_tariff_statistical_code: Array<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table: "edec_tariff_statistical_code" using primary key columns */
  edec_tariff_statistical_code_by_pk: Maybe<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table in a streaming manner: "edec_tariff_statistical_code" */
  edec_tariff_statistical_code_stream: Array<Edec_Tariff_Statistical_Code>;
  /** fetch data from the table: "email_search_type" */
  email_search_type: Array<Email_Search_Type>;
  /** fetch aggregated fields from the table: "email_search_type" */
  email_search_type_aggregate: Email_Search_Type_Aggregate;
  /** fetch data from the table in a streaming manner: "email_search_type" */
  email_search_type_stream: Array<Email_Search_Type>;
  /** fetch data from the table: "extract_type" */
  extract_type: Array<Extract_Type>;
  /** fetch data from the table: "extract_type" using primary key columns */
  extract_type_by_pk: Maybe<Extract_Type>;
  /** fetch data from the table in a streaming manner: "extract_type" */
  extract_type_stream: Array<Extract_Type>;
  /** fetch data from the table: "extraction_config" */
  extraction_config: Array<Extraction_Config>;
  /** fetch data from the table: "extraction_config" using primary key columns */
  extraction_config_by_pk: Maybe<Extraction_Config>;
  /** fetch data from the table in a streaming manner: "extraction_config" */
  extraction_config_stream: Array<Extraction_Config>;
  /** fetch data from the table: "file" */
  file: Array<File>;
  /** fetch aggregated fields from the table: "file" */
  file_aggregate: File_Aggregate;
  /** fetch data from the table: "file" using primary key columns */
  file_by_pk: Maybe<File>;
  /** fetch data from the table: "file_stats_type" */
  file_stats_type: Array<File_Stats_Type>;
  /** fetch data from the table in a streaming manner: "file_stats_type" */
  file_stats_type_stream: Array<File_Stats_Type>;
  /** fetch data from the table in a streaming manner: "file" */
  file_stream: Array<File>;
  /** fetch data from the table: "file_type" */
  file_type: Array<File_Type>;
  /** fetch data from the table: "file_type" using primary key columns */
  file_type_by_pk: Maybe<File_Type>;
  /** fetch data from the table in a streaming manner: "file_type" */
  file_type_stream: Array<File_Type>;
  /** fetch data from the table: "goods_item" */
  goods_item: Array<Goods_Item>;
  /** fetch aggregated fields from the table: "goods_item" */
  goods_item_aggregate: Goods_Item_Aggregate;
  /** fetch data from the table: "goods_item" using primary key columns */
  goods_item_by_pk: Maybe<Goods_Item>;
  /** An array relationship */
  goods_item_special_mentions: Array<Goods_Item_Special_Mentions>;
  /** An aggregate relationship */
  goods_item_special_mentions_aggregate: Goods_Item_Special_Mentions_Aggregate;
  /** fetch data from the table: "goods_item_special_mentions" using primary key columns */
  goods_item_special_mentions_by_pk: Maybe<Goods_Item_Special_Mentions>;
  /** fetch data from the table in a streaming manner: "goods_item_special_mentions" */
  goods_item_special_mentions_stream: Array<Goods_Item_Special_Mentions>;
  /** fetch data from the table in a streaming manner: "goods_item" */
  goods_item_stream: Array<Goods_Item>;
  /** fetch data from the table: "goods_items_for_drs" */
  goods_items_for_drs: Array<Goods_Items_For_Drs>;
  /** fetch data from the table in a streaming manner: "goods_items_for_drs" */
  goods_items_for_drs_stream: Array<Goods_Items_For_Drs>;
  /** fetch data from the table: "import_list_trigger" */
  import_list_trigger: Array<Import_List_Trigger>;
  /** fetch aggregated fields from the table: "import_list_trigger" */
  import_list_trigger_aggregate: Import_List_Trigger_Aggregate;
  /** fetch data from the table: "import_list_trigger" using primary key columns */
  import_list_trigger_by_pk: Maybe<Import_List_Trigger>;
  /** fetch data from the table in a streaming manner: "import_list_trigger" */
  import_list_trigger_stream: Array<Import_List_Trigger>;
  /** fetch data from the table: "intf.dr_payment_info" */
  intf_dr_payment_info: Array<Intf_Dr_Payment_Info>;
  /** fetch data from the table in a streaming manner: "intf.dr_payment_info" */
  intf_dr_payment_info_stream: Array<Intf_Dr_Payment_Info>;
  /** fetch data from the table: "json_type" */
  json_type: Array<Json_Type>;
  /** fetch data from the table in a streaming manner: "json_type" */
  json_type_stream: Array<Json_Type>;
  /** fetch data from the table: "kc_users" */
  kc_users: Array<Kc_Users>;
  /** fetch data from the table in a streaming manner: "kc_users" */
  kc_users_stream: Array<Kc_Users>;
  /** fetch data from the table: "max_date_type" */
  max_date_type: Array<Max_Date_Type>;
  /** fetch data from the table in a streaming manner: "max_date_type" */
  max_date_type_stream: Array<Max_Date_Type>;
  /** fetch data from the table: "model_retrain" */
  model_retrain: Array<Model_Retrain>;
  /** fetch data from the table: "model_retrain" using primary key columns */
  model_retrain_by_pk: Maybe<Model_Retrain>;
  /** fetch data from the table in a streaming manner: "model_retrain" */
  model_retrain_stream: Array<Model_Retrain>;
  /** fetch data from the table: "org_id" */
  org_id: Array<Org_Id>;
  /** fetch data from the table: "org_id" using primary key columns */
  org_id_by_pk: Maybe<Org_Id>;
  /** fetch data from the table in a streaming manner: "org_id" */
  org_id_stream: Array<Org_Id>;
  /** fetch data from the table: "org_ids" */
  org_ids: Array<Org_Ids>;
  /** fetch data from the table in a streaming manner: "org_ids" */
  org_ids_stream: Array<Org_Ids>;
  /** fetch data from the table: "org_params" */
  org_params: Array<Org_Params>;
  /** fetch data from the table: "org_params" using primary key columns */
  org_params_by_pk: Maybe<Org_Params>;
  /** fetch data from the table: "org_params_org_id" */
  org_params_org_id: Array<Org_Params_Org_Id>;
  /** fetch data from the table in a streaming manner: "org_params_org_id" */
  org_params_org_id_stream: Array<Org_Params_Org_Id>;
  /** fetch data from the table in a streaming manner: "org_params" */
  org_params_stream: Array<Org_Params>;
  /** An array relationship */
  packagings: Array<Packagings>;
  /** An aggregate relationship */
  packagings_aggregate: Packagings_Aggregate;
  /** fetch data from the table: "packagings" using primary key columns */
  packagings_by_pk: Maybe<Packagings>;
  /** fetch data from the table in a streaming manner: "packagings" */
  packagings_stream: Array<Packagings>;
  /** fetch data from the table: "page" */
  page: Array<Page>;
  /** fetch data from the table: "page" using primary key columns */
  page_by_pk: Maybe<Page>;
  /** fetch data from the table: "page_extract" */
  page_extract: Array<Page_Extract>;
  /** fetch data from the table: "page_extract" using primary key columns */
  page_extract_by_pk: Maybe<Page_Extract>;
  /** fetch data from the table in a streaming manner: "page_extract" */
  page_extract_stream: Array<Page_Extract>;
  /** fetch data from the table: "page_status" */
  page_status: Array<Page_Status>;
  /** fetch data from the table: "page_status" using primary key columns */
  page_status_by_pk: Maybe<Page_Status>;
  /** fetch data from the table in a streaming manner: "page_status" */
  page_status_stream: Array<Page_Status>;
  /** fetch data from the table in a streaming manner: "page" */
  page_stream: Array<Page>;
  /** fetch data from the table: "pages_m2m_cache" */
  pages_m2m_cache: Array<Pages_M2m_Cache>;
  /** fetch aggregated fields from the table: "pages_m2m_cache" */
  pages_m2m_cache_aggregate: Pages_M2m_Cache_Aggregate;
  /** fetch data from the table in a streaming manner: "pages_m2m_cache" */
  pages_m2m_cache_stream: Array<Pages_M2m_Cache>;
  /** An array relationship */
  permits: Array<Permits>;
  /** An aggregate relationship */
  permits_aggregate: Permits_Aggregate;
  /** fetch data from the table: "permits" using primary key columns */
  permits_by_pk: Maybe<Permits>;
  /** fetch data from the table in a streaming manner: "permits" */
  permits_stream: Array<Permits>;
  /** execute function "pp_address_groups" which returns "address_groups" */
  pp_address_groups: Array<Address_Groups>;
  /** execute function "pp_addresses" which returns "addresses" */
  pp_addresses: Array<Addresses>;
  /** execute function "pp_ai_stats" which returns "ai_stats_type" */
  pp_ai_stats: Array<Ai_Stats_Type>;
  /** execute function "pp_ai_stats_dt" which returns "ai_stats_dt_type" */
  pp_ai_stats_dt: Array<Ai_Stats_Dt_Type>;
  /** execute function "pp_check_json_param" which returns "json_type" */
  pp_check_json_param: Array<Json_Type>;
  /** execute function "pp_declaration_request" which returns "declaration_request" */
  pp_declaration_request: Array<Declaration_Request>;
  /** execute function "pp_declaration_tasks" which returns "declaration_tasks" */
  pp_declaration_tasks: Array<Declaration_Tasks>;
  /** execute function "pp_declaration_tasks_agg" which returns "json_type" */
  pp_declaration_tasks_agg: Maybe<Json_Type>;
  /** execute function "pp_declaration_tasks_obj" which returns "declaration_tasks_obj" */
  pp_declaration_tasks_obj: Maybe<Declaration_Tasks_Obj>;
  /** execute function "pp_declarations" which returns "declaration_search" */
  pp_declarations: Array<Declaration_Search>;
  /** execute function "pp_delete_declaration_requests" which returns "json_type" */
  pp_delete_declaration_requests: Array<Json_Type>;
  /** execute function "pp_doc_max_date_hs" which returns "max_date_type" */
  pp_doc_max_date_hs: Array<Max_Date_Type>;
  /** execute function "pp_doc_max_date_v2" which returns "max_date_type" */
  pp_doc_max_date_v2: Array<Max_Date_Type>;
  /** execute function "pp_doc_search" which returns "doc_search_type" */
  pp_doc_search: Array<Doc_Search_Type>;
  /** execute function "pp_doc_search_hs" which returns "doc_search_type" */
  pp_doc_search_hs: Array<Doc_Search_Type>;
  /** execute function "pp_doc_stats" which returns "doc_stats_type" */
  pp_doc_stats: Array<Doc_Stats_Type>;
  /** execute function "pp_docs_for_validation" which returns "docs_for_validation" */
  pp_docs_for_validation: Array<Docs_For_Validation>;
  /** execute function "pp_document" which returns "document" */
  pp_document: Array<Document>;
  /** execute function "pp_document" and query aggregates on result of table type "document" */
  pp_document_aggregate: Document_Aggregate;
  /** execute function "pp_document_flag" which returns "document_flag" */
  pp_document_flag: Array<Document_Flag>;
  /** execute function "pp_document_labels" which returns "document_labels" */
  pp_document_labels: Array<Document_Labels>;
  /** execute function "pp_dr_max_date" which returns "max_date_type" */
  pp_dr_max_date: Array<Max_Date_Type>;
  /** execute function "pp_dr_stats" which returns "dr_stats" */
  pp_dr_stats: Array<Dr_Stats>;
  /** execute function "pp_email_search" which returns "email_search_type" */
  pp_email_search: Array<Email_Search_Type>;
  /** execute function "pp_email_search" and query aggregates on result of table type "email_search_type" */
  pp_email_search_aggregate: Email_Search_Type_Aggregate;
  /** execute function "pp_email_search_hs" which returns "email_search_type" */
  pp_email_search_hs: Array<Email_Search_Type>;
  /** execute function "pp_email_search_hs" and query aggregates on result of table type "email_search_type" */
  pp_email_search_hs_aggregate: Email_Search_Type_Aggregate;
  /** execute function "pp_file_max_date_hs" which returns "max_date_type" */
  pp_file_max_date_hs: Array<Max_Date_Type>;
  /** execute function "pp_file_max_date_v2" which returns "max_date_type" */
  pp_file_max_date_v2: Array<Max_Date_Type>;
  /** execute function "pp_file_search" which returns "pp_types.file_search" */
  pp_file_search: Array<Pp_Types_File_Search>;
  /** execute function "pp_file_search_hs" which returns "pp_types.file_search" */
  pp_file_search_hs: Array<Pp_Types_File_Search>;
  /** execute function "pp_file_stats" which returns "file_stats_type" */
  pp_file_stats: Array<File_Stats_Type>;
  /** execute function "pp_hasura_session" which returns "json_type" */
  pp_hasura_session: Array<Json_Type>;
  /** execute function "pp_kc_users" which returns "kc_users" */
  pp_kc_users: Array<Kc_Users>;
  /** execute function "pp_last_doc_in_dr" which returns "document" */
  pp_last_doc_in_dr: Array<Document>;
  /** execute function "pp_last_doc_in_dr" and query aggregates on result of table type "document" */
  pp_last_doc_in_dr_aggregate: Document_Aggregate;
  /** execute function "pp_menu_indicators" which returns "json_type" */
  pp_menu_indicators: Array<Json_Type>;
  /** execute function "pp_org_id_delete" which returns "json_type" */
  pp_org_id_delete: Array<Json_Type>;
  /** execute function "pp_org_id_insert" which returns "json_type" */
  pp_org_id_insert: Array<Json_Type>;
  /** execute function "pp_org_id_update" which returns "json_type" */
  pp_org_id_update: Array<Json_Type>;
  /** execute function "pp_org_ids" which returns "org_ids" */
  pp_org_ids: Array<Org_Ids>;
  /** execute function "pp_page_extract_grids_text" which returns "json_type" */
  pp_page_extract_grids_text: Array<Json_Type>;
  /** execute function "pp_page_extract_text_fragment" which returns "json_type" */
  pp_page_extract_text_fragment: Array<Json_Type>;
  /** execute function "pp_page_extract_text_fragment_v2" which returns "json_type" */
  pp_page_extract_text_fragment_v2: Array<Json_Type>;
  /** execute function "pp_tenants" which returns "tenants" */
  pp_tenants: Array<Tenants>;
  /** fetch data from the table: "pp_types.file_search" */
  pp_types_file_search: Array<Pp_Types_File_Search>;
  /** fetch data from the table in a streaming manner: "pp_types.file_search" */
  pp_types_file_search_stream: Array<Pp_Types_File_Search>;
  /** execute function "pp_user_org_id" which returns "user_org_id" */
  pp_user_org_id: Array<User_Org_Id>;
  /** execute function "pp_user_search" which returns "user_search_type" */
  pp_user_search: Array<User_Search_Type>;
  /** execute function "pp_view_document_history" which returns "view_document_history" */
  pp_view_document_history: Array<View_Document_History>;
  /** execute function "pp_view_file_history" which returns "view_file_history" */
  pp_view_file_history: Array<View_File_History>;
  /** An array relationship */
  previous_documents: Array<Previous_Documents>;
  /** fetch data from the table: "previous_documents" using primary key columns */
  previous_documents_by_pk: Maybe<Previous_Documents>;
  /** fetch data from the table in a streaming manner: "previous_documents" */
  previous_documents_stream: Array<Previous_Documents>;
  /** An array relationship */
  produced_documents: Array<Produced_Documents>;
  /** An aggregate relationship */
  produced_documents_aggregate: Produced_Documents_Aggregate;
  /** fetch data from the table: "produced_documents" using primary key columns */
  produced_documents_by_pk: Maybe<Produced_Documents>;
  /** fetch data from the table in a streaming manner: "produced_documents" */
  produced_documents_stream: Array<Produced_Documents>;
  /** fetch data from the table: "report" */
  report: Array<Report>;
  /** fetch aggregated fields from the table: "report" */
  report_aggregate: Report_Aggregate;
  /** fetch data from the table: "report" using primary key columns */
  report_by_pk: Maybe<Report>;
  /** fetch data from the table in a streaming manner: "report" */
  report_stream: Array<Report>;
  /** fetch data from the table: "service" */
  service: Array<Service>;
  /** fetch data from the table: "service" using primary key columns */
  service_by_pk: Maybe<Service>;
  /** fetch data from the table: "service_rate" */
  service_rate: Array<Service_Rate>;
  /** fetch data from the table in a streaming manner: "service_rate" */
  service_rate_stream: Array<Service_Rate>;
  /** fetch data from the table in a streaming manner: "service" */
  service_stream: Array<Service>;
  /** fetch data from the table: "service_tariff" */
  service_tariff: Array<Service_Tariff>;
  /** fetch aggregated fields from the table: "service_tariff" */
  service_tariff_aggregate: Service_Tariff_Aggregate;
  /** fetch data from the table in a streaming manner: "service_tariff" */
  service_tariff_stream: Array<Service_Tariff>;
  /** fetch data from the table: "setting" */
  setting: Array<Setting>;
  /** fetch data from the table: "setting" using primary key columns */
  setting_by_pk: Maybe<Setting>;
  /** fetch data from the table: "setting_group" */
  setting_group: Array<Setting_Group>;
  /** fetch data from the table: "setting_group" using primary key columns */
  setting_group_by_pk: Maybe<Setting_Group>;
  /** fetch data from the table in a streaming manner: "setting_group" */
  setting_group_stream: Array<Setting_Group>;
  /** fetch data from the table in a streaming manner: "setting" */
  setting_stream: Array<Setting>;
  /** fetch data from the table: "setting_value" */
  setting_value: Array<Setting_Value>;
  /** fetch data from the table: "setting_value" using primary key columns */
  setting_value_by_pk: Maybe<Setting_Value>;
  /** fetch data from the table in a streaming manner: "setting_value" */
  setting_value_stream: Array<Setting_Value>;
  /** fetch data from the table: "tariff_number_description" */
  tariff_number_description: Array<Tariff_Number_Description>;
  /** fetch data from the table: "tariff_number_description" using primary key columns */
  tariff_number_description_by_pk: Maybe<Tariff_Number_Description>;
  /** fetch data from the table in a streaming manner: "tariff_number_description" */
  tariff_number_description_stream: Array<Tariff_Number_Description>;
  /** fetch data from the table: "task_type" */
  task_type: Array<Task_Type>;
  /** fetch data from the table: "task_type" using primary key columns */
  task_type_by_pk: Maybe<Task_Type>;
  /** fetch data from the table in a streaming manner: "task_type" */
  task_type_stream: Array<Task_Type>;
  /** fetch data from the table: "tenant" */
  tenant: Array<Tenant>;
  /** fetch data from the table: "tenant" using primary key columns */
  tenant_by_pk: Maybe<Tenant>;
  /** fetch data from the table in a streaming manner: "tenant" */
  tenant_stream: Array<Tenant>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch data from the table in a streaming manner: "tenants" */
  tenants_stream: Array<Tenants>;
  /** fetch data from the table: "transitdoc_type_descr" */
  transitdoc_type_descr: Array<Transitdoc_Type_Descr>;
  /** fetch data from the table in a streaming manner: "transitdoc_type_descr" */
  transitdoc_type_descr_stream: Array<Transitdoc_Type_Descr>;
  /** fetch data from the table: "user_org_id" */
  user_org_id: Array<User_Org_Id>;
  /** fetch data from the table: "user_org_id" using primary key columns */
  user_org_id_by_pk: Maybe<User_Org_Id>;
  /** fetch data from the table in a streaming manner: "user_org_id" */
  user_org_id_stream: Array<User_Org_Id>;
  /** fetch data from the table: "user_pp" */
  user_pp: Array<User_Pp>;
  /** fetch data from the table: "user_pp" using primary key columns */
  user_pp_by_pk: Maybe<User_Pp>;
  /** fetch data from the table in a streaming manner: "user_pp" */
  user_pp_stream: Array<User_Pp>;
  /** fetch data from the table: "user_search_type" */
  user_search_type: Array<User_Search_Type>;
  /** fetch data from the table in a streaming manner: "user_search_type" */
  user_search_type_stream: Array<User_Search_Type>;
  /** fetch data from the table: "view_document_history" */
  view_document_history: Array<View_Document_History>;
  /** fetch data from the table in a streaming manner: "view_document_history" */
  view_document_history_stream: Array<View_Document_History>;
  /** fetch data from the table: "view_file_history" */
  view_file_history: Array<View_File_History>;
  /** fetch data from the table in a streaming manner: "view_file_history" */
  view_file_history_stream: Array<View_File_History>;
  /** fetch data from the table: "view_history" */
  view_history: Array<View_History>;
  /** fetch data from the table in a streaming manner: "view_history" */
  view_history_stream: Array<View_History>;
  /** fetch data from the table: "vw_documents" */
  vw_documents: Array<Vw_Documents>;
  /** fetch data from the table in a streaming manner: "vw_documents" */
  vw_documents_stream: Array<Vw_Documents>;
  /** fetch data from the table: "vw_finished_files" */
  vw_finished_files: Array<Vw_Finished_Files>;
  /** fetch data from the table in a streaming manner: "vw_finished_files" */
  vw_finished_files_stream: Array<Vw_Finished_Files>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Address_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Groups_Order_By>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Subscription_RootAddress_Groups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Subscription_RootAddress_MappingArgs = {
  distinct_on?: InputMaybe<Array<Address_Mapping_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Mapping_Order_By>>;
  where?: InputMaybe<Address_Mapping_Bool_Exp>;
};


export type Subscription_RootAddress_Mapping_By_PkArgs = {
  address_id: Scalars['Int'];
  tenant_id: Scalars['uuid'];
};


export type Subscription_RootAddress_Mapping_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Mapping_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Mapping_Bool_Exp>;
};


export type Subscription_RootAddress_OverrideArgs = {
  distinct_on?: InputMaybe<Array<Address_Override_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Override_Order_By>>;
  where?: InputMaybe<Address_Override_Bool_Exp>;
};


export type Subscription_RootAddress_Override_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_Override_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Override_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Override_Bool_Exp>;
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_TypeArgs = {
  distinct_on?: InputMaybe<Array<Address_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Type_Order_By>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Subscription_RootAddress_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddress_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Type_Bool_Exp>;
};


export type Subscription_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAi_Stats_Dt_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ai_Stats_Dt_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Dt_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Subscription_RootAi_Stats_Dt_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ai_Stats_Dt_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Subscription_RootAi_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ai_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Subscription_RootAi_Stats_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ai_Stats_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Subscription_RootAnnotation_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Provider_Order_By>>;
  where?: InputMaybe<Annotation_Provider_Bool_Exp>;
};


export type Subscription_RootAnnotation_Provider_By_PkArgs = {
  annotation_provider_id: Scalars['smallint'];
};


export type Subscription_RootAnnotation_Provider_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Annotation_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Annotation_Provider_Bool_Exp>;
};


export type Subscription_RootAnnotation_TypeArgs = {
  distinct_on?: InputMaybe<Array<Annotation_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Annotation_Type_Order_By>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


export type Subscription_RootAnnotation_Type_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  annotation_provider_id: Scalars['smallint'];
  document_type: Scalars['String'];
};


export type Subscription_RootAnnotation_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Annotation_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Annotation_Type_Bool_Exp>;
};


export type Subscription_RootApi_KeyArgs = {
  distinct_on?: InputMaybe<Array<Api_Key_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Api_Key_Order_By>>;
  where?: InputMaybe<Api_Key_Bool_Exp>;
};


export type Subscription_RootApi_Key_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootApi_Key_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Api_Key_Stream_Cursor_Input>>;
  where?: InputMaybe<Api_Key_Bool_Exp>;
};


export type Subscription_RootArrival_TypeArgs = {
  distinct_on?: InputMaybe<Array<Arrival_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Arrival_Type_Order_By>>;
  where?: InputMaybe<Arrival_Type_Bool_Exp>;
};


export type Subscription_RootArrival_Type_By_PkArgs = {
  arrival_type: Scalars['String'];
};


export type Subscription_RootArrival_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Arrival_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Arrival_Type_Bool_Exp>;
};


export type Subscription_RootArticleArgs = {
  distinct_on?: InputMaybe<Array<Article_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Article_Order_By>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Subscription_RootArticle_By_PkArgs = {
  article_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


export type Subscription_RootArticle_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Article_Stream_Cursor_Input>>;
  where?: InputMaybe<Article_Bool_Exp>;
};


export type Subscription_RootBillArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Order_By>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Subscription_RootBill_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bill_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Order_By>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Subscription_RootBill_By_PkArgs = {
  bill_id: Scalars['bigint'];
};


export type Subscription_RootBill_DetailArgs = {
  distinct_on?: InputMaybe<Array<Bill_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bill_Detail_Order_By>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


export type Subscription_RootBill_Detail_By_PkArgs = {
  detail_id: Scalars['bigint'];
};


export type Subscription_RootBill_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bill_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Bill_Detail_Bool_Exp>;
};


export type Subscription_RootBill_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bill_Stream_Cursor_Input>>;
  where?: InputMaybe<Bill_Bool_Exp>;
};


export type Subscription_RootClearance_TypeArgs = {
  distinct_on?: InputMaybe<Array<Clearance_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Clearance_Type_Order_By>>;
  where?: InputMaybe<Clearance_Type_Bool_Exp>;
};


export type Subscription_RootClearance_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootClearance_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Clearance_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Clearance_Type_Bool_Exp>;
};


export type Subscription_RootContainersArgs = {
  distinct_on?: InputMaybe<Array<Containers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Containers_Order_By>>;
  where?: InputMaybe<Containers_Bool_Exp>;
};


export type Subscription_RootContainers_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootContainers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Containers_Stream_Cursor_Input>>;
  where?: InputMaybe<Containers_Bool_Exp>;
};


export type Subscription_RootCount_TypeArgs = {
  distinct_on?: InputMaybe<Array<Count_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Count_Type_Order_By>>;
  where?: InputMaybe<Count_Type_Bool_Exp>;
};


export type Subscription_RootCount_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Count_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Count_Type_Bool_Exp>;
};


export type Subscription_RootCustoms_OfficeArgs = {
  distinct_on?: InputMaybe<Array<Customs_Office_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Office_Order_By>>;
  where?: InputMaybe<Customs_Office_Bool_Exp>;
};


export type Subscription_RootCustoms_Office_By_PkArgs = {
  office_number: Scalars['String'];
  valid_from: Scalars['timestamptz'];
};


export type Subscription_RootCustoms_Office_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customs_Office_Stream_Cursor_Input>>;
  where?: InputMaybe<Customs_Office_Bool_Exp>;
};


export type Subscription_RootCustoms_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Customs_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customs_Offices_Order_By>>;
  where?: InputMaybe<Customs_Offices_Bool_Exp>;
};


export type Subscription_RootCustoms_Offices_By_PkArgs = {
  office_number: Scalars['String'];
};


export type Subscription_RootCustoms_Offices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customs_Offices_Stream_Cursor_Input>>;
  where?: InputMaybe<Customs_Offices_Bool_Exp>;
};


export type Subscription_RootDeclarationArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Order_By>>;
  where?: InputMaybe<Declaration_Bool_Exp>;
};


export type Subscription_RootDeclaration_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootDeclaration_DiscussionArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Subscription_RootDeclaration_Discussion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussion_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussion_Order_By>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Subscription_RootDeclaration_Discussion_By_PkArgs = {
  discussion_id: Scalars['bigint'];
};


export type Subscription_RootDeclaration_Discussion_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Discussion_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Discussion_Bool_Exp>;
};


export type Subscription_RootDeclaration_DiscussionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Discussions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Discussions_Order_By>>;
  where?: InputMaybe<Declaration_Discussions_Bool_Exp>;
};


export type Subscription_RootDeclaration_Discussions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Discussions_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Discussions_Bool_Exp>;
};


export type Subscription_RootDeclaration_DocumentArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Document_Order_By>>;
  where?: InputMaybe<Declaration_Document_Bool_Exp>;
};


export type Subscription_RootDeclaration_Document_By_PkArgs = {
  doc_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootDeclaration_Document_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Document_Bool_Exp>;
};


export type Subscription_RootDeclaration_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Labels_Bool_Exp>;
};


export type Subscription_RootDeclaration_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Labels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Labels_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Labels_Bool_Exp>;
};


export type Subscription_RootDeclaration_MessageArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Subscription_RootDeclaration_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Message_Order_By>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Subscription_RootDeclaration_Message_By_PkArgs = {
  creation_user: Scalars['uuid'];
  discussion_id: Scalars['bigint'];
  msg_date: Scalars['timestamptz'];
  read_date?: InputMaybe<Scalars['timestamptz']>;
};


export type Subscription_RootDeclaration_Message_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Message_Bool_Exp>;
};


export type Subscription_RootDeclaration_RequestArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_AddressArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_Address_AiArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Address_Ai_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Address_Ai_Order_By>>;
  where?: InputMaybe<Declaration_Request_Address_Ai_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_Address_Ai_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Request_Address_Ai_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Request_Address_Ai_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Request_Address_Ai_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_Address_By_PkArgs = {
  address_type: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootDeclaration_Request_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Request_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Request_Address_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootDeclaration_Request_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Request_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Labels_Order_By>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_Labels_By_PkArgs = {
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
  label_id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Request_Labels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Request_Labels_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Request_Labels_Bool_Exp>;
};


export type Subscription_RootDeclaration_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Subscription_RootDeclaration_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Requests_Order_By>>;
  where?: InputMaybe<Declaration_Requests_Bool_Exp>;
};


export type Subscription_RootDeclaration_Requests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Requests_Bool_Exp>;
};


export type Subscription_RootDeclaration_SearchArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Search_Order_By>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Subscription_RootDeclaration_Search_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Search_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Subscription_RootDeclaration_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Special_Mentions_Order_By>>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootDeclaration_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Special_Mentions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Special_Mentions_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootDeclaration_StatusArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Status_Order_By>>;
  where?: InputMaybe<Declaration_Status_Bool_Exp>;
};


export type Subscription_RootDeclaration_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDeclaration_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Status_Bool_Exp>;
};


export type Subscription_RootDeclaration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Bool_Exp>;
};


export type Subscription_RootDeclaration_TaskArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Subscription_RootDeclaration_Task_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Task_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Task_Order_By>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Subscription_RootDeclaration_Task_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDeclaration_Task_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Task_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Task_Bool_Exp>;
};


export type Subscription_RootDeclaration_TasksArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Subscription_RootDeclaration_Tasks_ObjArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Obj_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Obj_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Subscription_RootDeclaration_Tasks_Obj_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Tasks_Obj_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Subscription_RootDeclaration_Tasks_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Tasks_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Subscription_RootDeclaration_TypeArgs = {
  distinct_on?: InputMaybe<Array<Declaration_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Type_Order_By>>;
  where?: InputMaybe<Declaration_Type_Bool_Exp>;
};


export type Subscription_RootDeclaration_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDeclaration_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Declaration_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Declaration_Type_Bool_Exp>;
};


export type Subscription_RootDiscussion_ChangesArgs = {
  distinct_on?: InputMaybe<Array<Discussion_Changes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Discussion_Changes_Order_By>>;
  where?: InputMaybe<Discussion_Changes_Bool_Exp>;
};


export type Subscription_RootDiscussion_Changes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Discussion_Changes_Stream_Cursor_Input>>;
  where?: InputMaybe<Discussion_Changes_Bool_Exp>;
};


export type Subscription_RootDoc_AnnotationArgs = {
  distinct_on?: InputMaybe<Array<Doc_Annotation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Annotation_Order_By>>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};


export type Subscription_RootDoc_Annotation_By_PkArgs = {
  anno_type_id: Scalars['smallint'];
  doc_id: Scalars['uuid'];
};


export type Subscription_RootDoc_Annotation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Doc_Annotation_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Annotation_Bool_Exp>;
};


export type Subscription_RootDoc_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Subscription_RootDoc_Search_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Doc_Search_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Subscription_RootDoc_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<Doc_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Stats_Type_Order_By>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Subscription_RootDoc_Stats_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Doc_Stats_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Subscription_RootDocs_For_ValidationArgs = {
  distinct_on?: InputMaybe<Array<Docs_For_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Docs_For_Validation_Order_By>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Subscription_RootDocs_For_Validation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Docs_For_Validation_Stream_Cursor_Input>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Subscription_RootDocumentArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_By_PkArgs = {
  document_type: Scalars['String'];
  id: Scalars['uuid'];
};


export type Subscription_RootDocument_ExtensionArgs = {
  distinct_on?: InputMaybe<Array<Document_Extension_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Extension_Order_By>>;
  where?: InputMaybe<Document_Extension_Bool_Exp>;
};


export type Subscription_RootDocument_Extension_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDocument_Extension_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Extension_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Extension_Bool_Exp>;
};


export type Subscription_RootDocument_FlagArgs = {
  distinct_on?: InputMaybe<Array<Document_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Flag_Order_By>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Subscription_RootDocument_Flag_By_PkArgs = {
  id: Scalars['bigint'];
};


export type Subscription_RootDocument_Flag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Flag_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Subscription_RootDocument_Label_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<Document_Label_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Label_Org_Id_Order_By>>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};


export type Subscription_RootDocument_Label_Org_Id_By_PkArgs = {
  label_id: Scalars['Int'];
  org_id: Scalars['smallint'];
};


export type Subscription_RootDocument_Label_Org_Id_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Label_Org_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Label_Org_Id_Bool_Exp>;
};


export type Subscription_RootDocument_LabelsArgs = {
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Subscription_RootDocument_Labels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootDocument_Labels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Labels_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Subscription_RootDocument_PageArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Subscription_RootDocument_Page_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Page_Order_By>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Subscription_RootDocument_Page_By_PkArgs = {
  document_id: Scalars['uuid'];
  page_id: Scalars['uuid'];
  page_number: Scalars['smallint'];
};


export type Subscription_RootDocument_Page_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Page_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Page_Bool_Exp>;
};


export type Subscription_RootDocument_StatusArgs = {
  distinct_on?: InputMaybe<Array<Document_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Status_Order_By>>;
  where?: InputMaybe<Document_Status_Bool_Exp>;
};


export type Subscription_RootDocument_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDocument_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Status_Bool_Exp>;
};


export type Subscription_RootDocument_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootDocument_TypeArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Order_By>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_All_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_All_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


export type Subscription_RootDocument_Type_All_Tenant_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Type_All_Tenant_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_All_Tenant_Settings_Bool_Exp>;
};


export type Subscription_RootDocument_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootDocument_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_Bool_Exp>;
};


export type Subscription_RootDocument_Type_Tenant_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Document_Type_Tenant_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Type_Tenant_Settings_Order_By>>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};


export type Subscription_RootDocument_Type_Tenant_Settings_By_PkArgs = {
  document_type: Scalars['String'];
  tenant: Scalars['uuid'];
};


export type Subscription_RootDocument_Type_Tenant_Settings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Document_Type_Tenant_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Document_Type_Tenant_Settings_Bool_Exp>;
};


export type Subscription_RootDr_StatsArgs = {
  distinct_on?: InputMaybe<Array<Dr_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Stats_Order_By>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Subscription_RootDr_Stats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dr_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Subscription_RootEdec_CountriesArgs = {
  distinct_on?: InputMaybe<Array<Edec_Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Countries_Order_By>>;
  where?: InputMaybe<Edec_Countries_Bool_Exp>;
};


export type Subscription_RootEdec_Countries_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Countries_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Countries_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Countries_Bool_Exp>;
};


export type Subscription_RootEdec_Customs_OfficesArgs = {
  distinct_on?: InputMaybe<Array<Edec_Customs_Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Customs_Offices_Order_By>>;
  where?: InputMaybe<Edec_Customs_Offices_Bool_Exp>;
};


export type Subscription_RootEdec_Customs_Offices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Customs_Offices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Customs_Offices_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Customs_Offices_Bool_Exp>;
};


export type Subscription_RootEdec_DomainsArgs = {
  distinct_on?: InputMaybe<Array<Edec_Domains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Domains_Order_By>>;
  where?: InputMaybe<Edec_Domains_Bool_Exp>;
};


export type Subscription_RootEdec_Domains_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Domains_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Domains_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Domains_Bool_Exp>;
};


export type Subscription_RootEdec_Tariff_Commodity_CodeArgs = {
  distinct_on?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Tariff_Commodity_Code_Order_By>>;
  where?: InputMaybe<Edec_Tariff_Commodity_Code_Bool_Exp>;
};


export type Subscription_RootEdec_Tariff_Commodity_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Tariff_Commodity_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Tariff_Commodity_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Tariff_Commodity_Code_Bool_Exp>;
};


export type Subscription_RootEdec_Tariff_Statistical_CodeArgs = {
  distinct_on?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Edec_Tariff_Statistical_Code_Order_By>>;
  where?: InputMaybe<Edec_Tariff_Statistical_Code_Bool_Exp>;
};


export type Subscription_RootEdec_Tariff_Statistical_Code_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootEdec_Tariff_Statistical_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Edec_Tariff_Statistical_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Edec_Tariff_Statistical_Code_Bool_Exp>;
};


export type Subscription_RootEmail_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootEmail_Search_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootEmail_Search_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Search_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootExtract_TypeArgs = {
  distinct_on?: InputMaybe<Array<Extract_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Extract_Type_Order_By>>;
  where?: InputMaybe<Extract_Type_Bool_Exp>;
};


export type Subscription_RootExtract_Type_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
};


export type Subscription_RootExtract_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Extract_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Extract_Type_Bool_Exp>;
};


export type Subscription_RootExtraction_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Extraction_Config_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Extraction_Config_Order_By>>;
  where?: InputMaybe<Extraction_Config_Bool_Exp>;
};


export type Subscription_RootExtraction_Config_By_PkArgs = {
  address_id: Scalars['Int'];
};


export type Subscription_RootExtraction_Config_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Extraction_Config_Stream_Cursor_Input>>;
  where?: InputMaybe<Extraction_Config_Bool_Exp>;
};


export type Subscription_RootFileArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Order_By>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootFile_Stats_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Stats_Type_Order_By>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Subscription_RootFile_Stats_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Stats_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Subscription_RootFile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Bool_Exp>;
};


export type Subscription_RootFile_TypeArgs = {
  distinct_on?: InputMaybe<Array<File_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Type_Order_By>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Subscription_RootFile_Type_By_PkArgs = {
  doc_types?: InputMaybe<Scalars['_varchar']>;
  file_type: Scalars['String'];
};


export type Subscription_RootFile_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<File_Type_Bool_Exp>;
};


export type Subscription_RootGoods_ItemArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Subscription_RootGoods_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Order_By>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Subscription_RootGoods_Item_By_PkArgs = {
  customs_item_number: Scalars['Int'];
  dr_no: Scalars['smallint'];
  file_id: Scalars['uuid'];
};


export type Subscription_RootGoods_Item_Special_MentionsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootGoods_Item_Special_Mentions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Goods_Item_Special_Mentions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Item_Special_Mentions_Order_By>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootGoods_Item_Special_Mentions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootGoods_Item_Special_Mentions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Goods_Item_Special_Mentions_Stream_Cursor_Input>>;
  where?: InputMaybe<Goods_Item_Special_Mentions_Bool_Exp>;
};


export type Subscription_RootGoods_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Goods_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Goods_Item_Bool_Exp>;
};


export type Subscription_RootGoods_Items_For_DrsArgs = {
  distinct_on?: InputMaybe<Array<Goods_Items_For_Drs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Goods_Items_For_Drs_Order_By>>;
  where?: InputMaybe<Goods_Items_For_Drs_Bool_Exp>;
};


export type Subscription_RootGoods_Items_For_Drs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Goods_Items_For_Drs_Stream_Cursor_Input>>;
  where?: InputMaybe<Goods_Items_For_Drs_Bool_Exp>;
};


export type Subscription_RootImport_List_TriggerArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Subscription_RootImport_List_Trigger_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_List_Trigger_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_List_Trigger_Order_By>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Subscription_RootImport_List_Trigger_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootImport_List_Trigger_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Import_List_Trigger_Stream_Cursor_Input>>;
  where?: InputMaybe<Import_List_Trigger_Bool_Exp>;
};


export type Subscription_RootIntf_Dr_Payment_InfoArgs = {
  distinct_on?: InputMaybe<Array<Intf_Dr_Payment_Info_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Intf_Dr_Payment_Info_Order_By>>;
  where?: InputMaybe<Intf_Dr_Payment_Info_Bool_Exp>;
};


export type Subscription_RootIntf_Dr_Payment_Info_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Intf_Dr_Payment_Info_Stream_Cursor_Input>>;
  where?: InputMaybe<Intf_Dr_Payment_Info_Bool_Exp>;
};


export type Subscription_RootJson_TypeArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootJson_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Json_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootKc_UsersArgs = {
  distinct_on?: InputMaybe<Array<Kc_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kc_Users_Order_By>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Subscription_RootKc_Users_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Kc_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Subscription_RootMax_Date_TypeArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootMax_Date_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Max_Date_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootModel_RetrainArgs = {
  distinct_on?: InputMaybe<Array<Model_Retrain_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Model_Retrain_Order_By>>;
  where?: InputMaybe<Model_Retrain_Bool_Exp>;
};


export type Subscription_RootModel_Retrain_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootModel_Retrain_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Model_Retrain_Stream_Cursor_Input>>;
  where?: InputMaybe<Model_Retrain_Bool_Exp>;
};


export type Subscription_RootOrg_IdArgs = {
  distinct_on?: InputMaybe<Array<Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Id_Order_By>>;
  where?: InputMaybe<Org_Id_Bool_Exp>;
};


export type Subscription_RootOrg_Id_By_PkArgs = {
  org_id: Scalars['smallint'];
};


export type Subscription_RootOrg_Id_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Id_Bool_Exp>;
};


export type Subscription_RootOrg_IdsArgs = {
  distinct_on?: InputMaybe<Array<Org_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Ids_Order_By>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Subscription_RootOrg_Ids_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Ids_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Subscription_RootOrg_ParamsArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Order_By>>;
  where?: InputMaybe<Org_Params_Bool_Exp>;
};


export type Subscription_RootOrg_Params_By_PkArgs = {
  org_id: Scalars['Int'];
};


export type Subscription_RootOrg_Params_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<Org_Params_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Params_Org_Id_Order_By>>;
  where?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
};


export type Subscription_RootOrg_Params_Org_Id_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Params_Org_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Params_Org_Id_Bool_Exp>;
};


export type Subscription_RootOrg_Params_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Params_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Params_Bool_Exp>;
};


export type Subscription_RootPackagingsArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Subscription_RootPackagings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Packagings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Packagings_Order_By>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Subscription_RootPackagings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPackagings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Packagings_Stream_Cursor_Input>>;
  where?: InputMaybe<Packagings_Bool_Exp>;
};


export type Subscription_RootPageArgs = {
  distinct_on?: InputMaybe<Array<Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Order_By>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Subscription_RootPage_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPage_ExtractArgs = {
  distinct_on?: InputMaybe<Array<Page_Extract_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Extract_Order_By>>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};


export type Subscription_RootPage_Extract_By_PkArgs = {
  extract_type_id: Scalars['smallint'];
  page_id: Scalars['uuid'];
};


export type Subscription_RootPage_Extract_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Page_Extract_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Extract_Bool_Exp>;
};


export type Subscription_RootPage_StatusArgs = {
  distinct_on?: InputMaybe<Array<Page_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Status_Order_By>>;
  where?: InputMaybe<Page_Status_Bool_Exp>;
};


export type Subscription_RootPage_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPage_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Page_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Status_Bool_Exp>;
};


export type Subscription_RootPage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Page_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Subscription_RootPages_M2m_CacheArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Subscription_RootPages_M2m_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pages_M2m_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pages_M2m_Cache_Order_By>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Subscription_RootPages_M2m_Cache_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pages_M2m_Cache_Stream_Cursor_Input>>;
  where?: InputMaybe<Pages_M2m_Cache_Bool_Exp>;
};


export type Subscription_RootPermitsArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Subscription_RootPermits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Permits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Permits_Order_By>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Subscription_RootPermits_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPermits_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Permits_Stream_Cursor_Input>>;
  where?: InputMaybe<Permits_Bool_Exp>;
};


export type Subscription_RootPp_Address_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Address_Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Groups_Order_By>>;
  where?: InputMaybe<Address_Groups_Bool_Exp>;
};


export type Subscription_RootPp_AddressesArgs = {
  args: Pp_Addresses_Args;
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootPp_Ai_StatsArgs = {
  args: Pp_Ai_Stats_Args;
  distinct_on?: InputMaybe<Array<Ai_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Type_Bool_Exp>;
};


export type Subscription_RootPp_Ai_Stats_DtArgs = {
  args: Pp_Ai_Stats_Dt_Args;
  distinct_on?: InputMaybe<Array<Ai_Stats_Dt_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ai_Stats_Dt_Type_Order_By>>;
  where?: InputMaybe<Ai_Stats_Dt_Type_Bool_Exp>;
};


export type Subscription_RootPp_Check_Json_ParamArgs = {
  args: Pp_Check_Json_Param_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Declaration_RequestArgs = {
  args: Pp_Declaration_Request_Args;
  distinct_on?: InputMaybe<Array<Declaration_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Request_Order_By>>;
  where?: InputMaybe<Declaration_Request_Bool_Exp>;
};


export type Subscription_RootPp_Declaration_TasksArgs = {
  args: Pp_Declaration_Tasks_Args;
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Bool_Exp>;
};


export type Subscription_RootPp_Declaration_Tasks_AggArgs = {
  args: Pp_Declaration_Tasks_Agg_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Declaration_Tasks_ObjArgs = {
  args: Pp_Declaration_Tasks_Obj_Args;
  distinct_on?: InputMaybe<Array<Declaration_Tasks_Obj_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Tasks_Obj_Order_By>>;
  where?: InputMaybe<Declaration_Tasks_Obj_Bool_Exp>;
};


export type Subscription_RootPp_DeclarationsArgs = {
  args: Pp_Declarations_Args;
  distinct_on?: InputMaybe<Array<Declaration_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Declaration_Search_Order_By>>;
  where?: InputMaybe<Declaration_Search_Bool_Exp>;
};


export type Subscription_RootPp_Delete_Declaration_RequestsArgs = {
  args: Pp_Delete_Declaration_Requests_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_Max_Date_HsArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_Max_Date_V2Args = {
  args: Pp_Doc_Max_Date_V2_Args;
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_SearchArgs = {
  args: Pp_Doc_Search_Args;
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_Search_HsArgs = {
  args: Pp_Doc_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Doc_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Search_Type_Order_By>>;
  where?: InputMaybe<Doc_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Doc_StatsArgs = {
  args: Pp_Doc_Stats_Args;
  distinct_on?: InputMaybe<Array<Doc_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Doc_Stats_Type_Order_By>>;
  where?: InputMaybe<Doc_Stats_Type_Bool_Exp>;
};


export type Subscription_RootPp_Docs_For_ValidationArgs = {
  args: Pp_Docs_For_Validation_Args;
  distinct_on?: InputMaybe<Array<Docs_For_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Docs_For_Validation_Order_By>>;
  where?: InputMaybe<Docs_For_Validation_Bool_Exp>;
};


export type Subscription_RootPp_DocumentArgs = {
  args: Pp_Document_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootPp_Document_AggregateArgs = {
  args: Pp_Document_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootPp_Document_FlagArgs = {
  args: Pp_Document_Flag_Args;
  distinct_on?: InputMaybe<Array<Document_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Flag_Order_By>>;
  where?: InputMaybe<Document_Flag_Bool_Exp>;
};


export type Subscription_RootPp_Document_LabelsArgs = {
  args: Pp_Document_Labels_Args;
  distinct_on?: InputMaybe<Array<Document_Labels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Labels_Order_By>>;
  where?: InputMaybe<Document_Labels_Bool_Exp>;
};


export type Subscription_RootPp_Dr_Max_DateArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_Dr_StatsArgs = {
  args: Pp_Dr_Stats_Args;
  distinct_on?: InputMaybe<Array<Dr_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dr_Stats_Order_By>>;
  where?: InputMaybe<Dr_Stats_Bool_Exp>;
};


export type Subscription_RootPp_Email_SearchArgs = {
  args: Pp_Email_Search_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Email_Search_AggregateArgs = {
  args: Pp_Email_Search_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Email_Search_HsArgs = {
  args: Pp_Email_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_Email_Search_Hs_AggregateArgs = {
  args: Pp_Email_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Email_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Search_Type_Order_By>>;
  where?: InputMaybe<Email_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_File_Max_Date_HsArgs = {
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_File_Max_Date_V2Args = {
  args: Pp_File_Max_Date_V2_Args;
  distinct_on?: InputMaybe<Array<Max_Date_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Max_Date_Type_Order_By>>;
  where?: InputMaybe<Max_Date_Type_Bool_Exp>;
};


export type Subscription_RootPp_File_SearchArgs = {
  args: Pp_File_Search_Args;
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Subscription_RootPp_File_Search_HsArgs = {
  args: Pp_File_Search_Hs_Args;
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Subscription_RootPp_File_StatsArgs = {
  args: Pp_File_Stats_Args;
  distinct_on?: InputMaybe<Array<File_Stats_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Stats_Type_Order_By>>;
  where?: InputMaybe<File_Stats_Type_Bool_Exp>;
};


export type Subscription_RootPp_Hasura_SessionArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Kc_UsersArgs = {
  args: Pp_Kc_Users_Args;
  distinct_on?: InputMaybe<Array<Kc_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kc_Users_Order_By>>;
  where?: InputMaybe<Kc_Users_Bool_Exp>;
};


export type Subscription_RootPp_Last_Doc_In_DrArgs = {
  args: Pp_Last_Doc_In_Dr_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootPp_Last_Doc_In_Dr_AggregateArgs = {
  args: Pp_Last_Doc_In_Dr_Args;
  distinct_on?: InputMaybe<Array<Document_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Document_Order_By>>;
  where?: InputMaybe<Document_Bool_Exp>;
};


export type Subscription_RootPp_Menu_IndicatorsArgs = {
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Org_Id_DeleteArgs = {
  args: Pp_Org_Id_Delete_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Org_Id_InsertArgs = {
  args: Pp_Org_Id_Insert_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Org_Id_UpdateArgs = {
  args: Pp_Org_Id_Update_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Org_IdsArgs = {
  args: Pp_Org_Ids_Args;
  distinct_on?: InputMaybe<Array<Org_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Ids_Order_By>>;
  where?: InputMaybe<Org_Ids_Bool_Exp>;
};


export type Subscription_RootPp_Page_Extract_Grids_TextArgs = {
  args: Pp_Page_Extract_Grids_Text_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Page_Extract_Text_FragmentArgs = {
  args: Pp_Page_Extract_Text_Fragment_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_Page_Extract_Text_Fragment_V2Args = {
  args: Pp_Page_Extract_Text_Fragment_V2_Args;
  distinct_on?: InputMaybe<Array<Json_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Json_Type_Order_By>>;
  where?: InputMaybe<Json_Type_Bool_Exp>;
};


export type Subscription_RootPp_TenantsArgs = {
  args: Pp_Tenants_Args;
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootPp_Types_File_SearchArgs = {
  distinct_on?: InputMaybe<Array<Pp_Types_File_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pp_Types_File_Search_Order_By>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Subscription_RootPp_Types_File_Search_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pp_Types_File_Search_Stream_Cursor_Input>>;
  where?: InputMaybe<Pp_Types_File_Search_Bool_Exp>;
};


export type Subscription_RootPp_User_Org_IdArgs = {
  args: Pp_User_Org_Id_Args;
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Subscription_RootPp_User_SearchArgs = {
  args: Pp_User_Search_Args;
  distinct_on?: InputMaybe<Array<User_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Search_Type_Order_By>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Subscription_RootPp_View_Document_HistoryArgs = {
  args: Pp_View_Document_History_Args;
  distinct_on?: InputMaybe<Array<View_Document_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Document_History_Order_By>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Subscription_RootPp_View_File_HistoryArgs = {
  args: Pp_View_File_History_Args;
  distinct_on?: InputMaybe<Array<View_File_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_File_History_Order_By>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Subscription_RootPrevious_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Previous_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Previous_Documents_Order_By>>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};


export type Subscription_RootPrevious_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootPrevious_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Previous_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Previous_Documents_Bool_Exp>;
};


export type Subscription_RootProduced_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Subscription_RootProduced_Documents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Produced_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Produced_Documents_Order_By>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Subscription_RootProduced_Documents_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProduced_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Produced_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Produced_Documents_Bool_Exp>;
};


export type Subscription_RootReportArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Report_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Report_Order_By>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootReport_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootReport_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Report_Stream_Cursor_Input>>;
  where?: InputMaybe<Report_Bool_Exp>;
};


export type Subscription_RootServiceArgs = {
  distinct_on?: InputMaybe<Array<Service_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Order_By>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Subscription_RootService_By_PkArgs = {
  srv_id: Scalars['Int'];
};


export type Subscription_RootService_RateArgs = {
  distinct_on?: InputMaybe<Array<Service_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Rate_Order_By>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


export type Subscription_RootService_Rate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Service_Rate_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Rate_Bool_Exp>;
};


export type Subscription_RootService_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Service_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Bool_Exp>;
};


export type Subscription_RootService_TariffArgs = {
  distinct_on?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Tariff_Order_By>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Subscription_RootService_Tariff_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Service_Tariff_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Service_Tariff_Order_By>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Subscription_RootService_Tariff_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Service_Tariff_Stream_Cursor_Input>>;
  where?: InputMaybe<Service_Tariff_Bool_Exp>;
};


export type Subscription_RootSettingArgs = {
  distinct_on?: InputMaybe<Array<Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Order_By>>;
  where?: InputMaybe<Setting_Bool_Exp>;
};


export type Subscription_RootSetting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSetting_GroupArgs = {
  distinct_on?: InputMaybe<Array<Setting_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Group_Order_By>>;
  where?: InputMaybe<Setting_Group_Bool_Exp>;
};


export type Subscription_RootSetting_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSetting_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setting_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Setting_Group_Bool_Exp>;
};


export type Subscription_RootSetting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setting_Stream_Cursor_Input>>;
  where?: InputMaybe<Setting_Bool_Exp>;
};


export type Subscription_RootSetting_ValueArgs = {
  distinct_on?: InputMaybe<Array<Setting_Value_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Setting_Value_Order_By>>;
  where?: InputMaybe<Setting_Value_Bool_Exp>;
};


export type Subscription_RootSetting_Value_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSetting_Value_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Setting_Value_Stream_Cursor_Input>>;
  where?: InputMaybe<Setting_Value_Bool_Exp>;
};


export type Subscription_RootTariff_Number_DescriptionArgs = {
  distinct_on?: InputMaybe<Array<Tariff_Number_Description_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tariff_Number_Description_Order_By>>;
  where?: InputMaybe<Tariff_Number_Description_Bool_Exp>;
};


export type Subscription_RootTariff_Number_Description_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTariff_Number_Description_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tariff_Number_Description_Stream_Cursor_Input>>;
  where?: InputMaybe<Tariff_Number_Description_Bool_Exp>;
};


export type Subscription_RootTask_TypeArgs = {
  distinct_on?: InputMaybe<Array<Task_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Task_Type_Order_By>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Subscription_RootTask_Type_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTask_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Task_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Task_Type_Bool_Exp>;
};


export type Subscription_RootTenantArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenant_Order_By>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Subscription_RootTenant_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTenant_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tenant_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenant_Bool_Exp>;
};


export type Subscription_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenants_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTransitdoc_Type_DescrArgs = {
  distinct_on?: InputMaybe<Array<Transitdoc_Type_Descr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Transitdoc_Type_Descr_Order_By>>;
  where?: InputMaybe<Transitdoc_Type_Descr_Bool_Exp>;
};


export type Subscription_RootTransitdoc_Type_Descr_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Transitdoc_Type_Descr_Stream_Cursor_Input>>;
  where?: InputMaybe<Transitdoc_Type_Descr_Bool_Exp>;
};


export type Subscription_RootUser_Org_IdArgs = {
  distinct_on?: InputMaybe<Array<User_Org_Id_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Org_Id_Order_By>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Subscription_RootUser_Org_Id_By_PkArgs = {
  org_id: Scalars['smallint'];
  user_pp: Scalars['uuid'];
};


export type Subscription_RootUser_Org_Id_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Org_Id_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Org_Id_Bool_Exp>;
};


export type Subscription_RootUser_PpArgs = {
  distinct_on?: InputMaybe<Array<User_Pp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Pp_Order_By>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};


export type Subscription_RootUser_Pp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Pp_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Pp_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Pp_Bool_Exp>;
};


export type Subscription_RootUser_Search_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Search_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Search_Type_Order_By>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Subscription_RootUser_Search_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Search_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Search_Type_Bool_Exp>;
};


export type Subscription_RootView_Document_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_Document_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_Document_History_Order_By>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Subscription_RootView_Document_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<View_Document_History_Stream_Cursor_Input>>;
  where?: InputMaybe<View_Document_History_Bool_Exp>;
};


export type Subscription_RootView_File_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_File_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_File_History_Order_By>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Subscription_RootView_File_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<View_File_History_Stream_Cursor_Input>>;
  where?: InputMaybe<View_File_History_Bool_Exp>;
};


export type Subscription_RootView_HistoryArgs = {
  distinct_on?: InputMaybe<Array<View_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<View_History_Order_By>>;
  where?: InputMaybe<View_History_Bool_Exp>;
};


export type Subscription_RootView_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<View_History_Stream_Cursor_Input>>;
  where?: InputMaybe<View_History_Bool_Exp>;
};


export type Subscription_RootVw_DocumentsArgs = {
  distinct_on?: InputMaybe<Array<Vw_Documents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vw_Documents_Order_By>>;
  where?: InputMaybe<Vw_Documents_Bool_Exp>;
};


export type Subscription_RootVw_Documents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vw_Documents_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Documents_Bool_Exp>;
};


export type Subscription_RootVw_Finished_FilesArgs = {
  distinct_on?: InputMaybe<Array<Vw_Finished_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Vw_Finished_Files_Order_By>>;
  where?: InputMaybe<Vw_Finished_Files_Bool_Exp>;
};


export type Subscription_RootVw_Finished_Files_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Vw_Finished_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Vw_Finished_Files_Bool_Exp>;
};

/** Streaming cursor of the table "address_groups" */
export type Address_Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Groups_Stream_Cursor_Value_Input = {
  business_case?: InputMaybe<Scalars['bc_name']>;
  group_id?: InputMaybe<Scalars['smallint']>;
  group_name?: InputMaybe<Scalars['String']>;
  payer_address?: InputMaybe<Scalars['Int']>;
  payer_name?: InputMaybe<Scalars['String']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Streaming cursor of the table "address_mapping" */
export type Address_Mapping_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Mapping_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Mapping_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_override_id?: InputMaybe<Scalars['Int']>;
  is_cross_address?: InputMaybe<Scalars['Boolean']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "address_override" */
export type Address_Override_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Override_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Override_Stream_Cursor_Value_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  additional_values?: InputMaybe<Scalars['jsonb']>;
  address_type?: InputMaybe<Scalars['Int']>;
  ao_id?: InputMaybe<Scalars['smallint']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  company_name_2?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_number?: InputMaybe<Scalars['String']>;
  error_email_address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imported?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_locked?: InputMaybe<Scalars['Boolean']>;
  is_platform_user?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
  search_vector?: InputMaybe<Scalars['tsvector']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  uid_number?: InputMaybe<Scalars['String']>;
  usage_frequency?: InputMaybe<Scalars['Int']>;
  vat_account_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "address_type" */
export type Address_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "addresses" */
export type Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Addresses_Stream_Cursor_Value_Input = {
  address_type?: InputMaybe<Scalars['Int']>;
  address_types?: InputMaybe<Scalars['_int4']>;
  ao_id?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  contact_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_number?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  qty?: InputMaybe<Scalars['bigint']>;
  reference?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_number?: InputMaybe<Scalars['String']>;
  vat_account_number?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "ai_stats_dt_type" */
export type Ai_Stats_Dt_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Stats_Dt_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Stats_Dt_Type_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['date']>;
  docs_qty?: InputMaybe<Scalars['bigint']>;
  document_type?: InputMaybe<Scalars['String']>;
  pages_qty?: InputMaybe<Scalars['bigint']>;
  success_ratio?: InputMaybe<Scalars['numeric']>;
  types_match?: InputMaybe<Scalars['numeric']>;
  unknowns?: InputMaybe<Scalars['numeric']>;
  unknowns_pct?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "ai_stats_type" */
export type Ai_Stats_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ai_Stats_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ai_Stats_Type_Stream_Cursor_Value_Input = {
  document_type?: InputMaybe<Scalars['String']>;
  success_ratio?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['bigint']>;
  types_match?: InputMaybe<Scalars['numeric']>;
  unknowns?: InputMaybe<Scalars['numeric']>;
  unknowns_pct?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "annotation_provider" */
export type Annotation_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Annotation_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Annotation_Provider_Stream_Cursor_Value_Input = {
  annotation_provider?: InputMaybe<Scalars['String']>;
  annotation_provider_id?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "annotation_type" */
export type Annotation_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Annotation_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Annotation_Type_Stream_Cursor_Value_Input = {
  anno_schema?: InputMaybe<Scalars['json']>;
  anno_type_id?: InputMaybe<Scalars['smallint']>;
  annotation_provider_id?: InputMaybe<Scalars['smallint']>;
  annotation_schema?: InputMaybe<Scalars['jsonb']>;
  annotation_type?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  ui_schema?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "api_key" */
export type Api_Key_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Api_Key_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Api_Key_Stream_Cursor_Value_Input = {
  api_key?: InputMaybe<Scalars['String']>;
  dsplay_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "arrival_type" */
export type Arrival_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Arrival_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Arrival_Type_Stream_Cursor_Value_Input = {
  arrival_type?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "article" */
export type Article_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Article_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Stream_Cursor_Value_Input = {
  article_id?: InputMaybe<Scalars['smallint']>;
  code?: InputMaybe<Scalars['String']>;
  coords?: InputMaybe<Scalars['_int4']>;
  country_of_origin?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  doc_id?: InputMaybe<Scalars['uuid']>;
  gross_weight?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['String']>;
  hscode?: InputMaybe<Scalars['String']>;
  length?: InputMaybe<Scalars['String']>;
  marks?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  net_weight?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  price?: InputMaybe<Scalars['String']>;
  purchase_order_number?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  total_price?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  volume?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "bill_detail" */
export type Bill_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bill_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bill_Detail_Stream_Cursor_Value_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  charged_items?: InputMaybe<Scalars['bigint']>;
  const_charge?: InputMaybe<Scalars['numeric']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  detail_id?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  remark?: InputMaybe<Scalars['String']>;
  /** Sequence of bill_detail, 1,2,3, etc within one bill */
  sequence?: InputMaybe<Scalars['smallint']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  var_charge?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "bill" */
export type Bill_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bill_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bill_Stream_Cursor_Value_Input = {
  bill_id?: InputMaybe<Scalars['bigint']>;
  /**
   * type of bill, e.g.
   *  - regular - ordianry bill.
   * also might be
   *  - correction
   *  - account_close
   *
   */
  bill_type?: InputMaybe<Scalars['name']>;
  from_ts?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  payment_terms?: InputMaybe<Scalars['smallint']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  to_ts?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "clearance_type" */
export type Clearance_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Clearance_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Clearance_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "containers" */
export type Containers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Containers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Containers_Stream_Cursor_Value_Input = {
  container_number?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "count_type" */
export type Count_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Count_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Count_Type_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "customs_office" */
export type Customs_Office_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customs_Office_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customs_Office_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  office_number?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "customs_offices" */
export type Customs_Offices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customs_Offices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customs_Offices_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  office_number?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['timestamptz']>;
  valid_to?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "declaration_discussion" */
export type Declaration_Discussion_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Discussion_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Discussion_Stream_Cursor_Value_Input = {
  /** Discussion is closed */
  closed?: InputMaybe<Scalars['Boolean']>;
  /** Creation date of discussion. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User initiated discussion. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** Unique identificator of discussion. */
  discussion_id?: InputMaybe<Scalars['bigint']>;
  /** Theme of discussion. */
  discussion_theme?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** File/Declaration related to discussion. */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "declaration_discussions" */
export type Declaration_Discussions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Discussions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Discussions_Stream_Cursor_Value_Input = {
  closed?: InputMaybe<Scalars['Boolean']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  discussion_theme?: InputMaybe<Scalars['String']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  last_read_date?: InputMaybe<Scalars['timestamptz']>;
  liber_user?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_document" */
export type Declaration_Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Document_Stream_Cursor_Value_Input = {
  doc_id?: InputMaybe<Scalars['uuid']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "declaration_labels" */
export type Declaration_Labels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Labels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Labels_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "declaration_message" */
export type Declaration_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Message_Stream_Cursor_Value_Input = {
  /** declaration_message creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  message?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  msg_date?: InputMaybe<Scalars['timestamptz']>;
  read_date?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_request_address_ai" */
export type Declaration_Request_Address_Ai_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Request_Address_Ai_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Request_Address_Ai_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "declaration_request_address" */
export type Declaration_Request_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Request_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Request_Address_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['json']>;
  refs?: InputMaybe<Scalars['_text']>;
  search_refs?: InputMaybe<Scalars['_text']>;
};

/** Streaming cursor of the table "declaration_request_labels" */
export type Declaration_Request_Labels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Request_Labels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Request_Labels_Stream_Cursor_Value_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  label_id?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "declaration_request" */
export type Declaration_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Request_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  /** Account number in CH customs */
  account_number?: InputMaybe<Scalars['String']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  cev_status?: InputMaybe<Scalars['String']>;
  /** WeDeclare must create CH-Exportdeclaration */
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  /** Refer to values in table clearance_type. */
  clearance_type?: InputMaybe<Scalars['String']>;
  /** Date of creation of declaration request. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** User created declaration request. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  /** Refer to values in table declaration_status. */
  declaration_status?: InputMaybe<Scalars['String']>;
  /** Refer to values in table declaration_type. */
  declaration_type?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Code */
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  /** Destination Tolldept Name */
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  /** Declaration request number. Unique inside file: 1,2..n. Part of primary key */
  dr_no?: InputMaybe<Scalars['smallint']>;
  edec?: InputMaybe<Scalars['jsonb']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  /** File related to declaration request. Part of primary key */
  file_id?: InputMaybe<Scalars['uuid']>;
  /** WeDeclare must create the Import customs clearance in the destination Country */
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  /** Service:  Standard  oder Express */
  is_express?: InputMaybe<Scalars['Boolean']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  mrn_number?: InputMaybe<Scalars['String']>;
  /** Who is paying for customs declaration (tenant) */
  payer_id?: InputMaybe<Scalars['uuid']>;
  service_type?: InputMaybe<Scalars['String']>;
  /** Customs office number. Refer to customs_office table.office_number. */
  toll_dep?: InputMaybe<Scalars['String']>;
  /** Truck and Trailer Plate No. */
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  /** Type Transitdocument */
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_requests" */
export type Declaration_Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Requests_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  account_number?: InputMaybe<Scalars['String']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  autoclassified_docs_qty?: InputMaybe<Scalars['bigint']>;
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  permissions_js?: InputMaybe<Scalars['json']>;
  qty?: InputMaybe<Scalars['bigint']>;
  reference?: InputMaybe<Scalars['String']>;
  row_number?: InputMaybe<Scalars['bigint']>;
  toll_dep?: InputMaybe<Scalars['String']>;
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_search" */
export type Declaration_Search_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Search_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Search_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  autoclassified_docs_qty?: InputMaybe<Scalars['bigint']>;
  classified_docs_qty?: InputMaybe<Scalars['bigint']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  company_id?: InputMaybe<Scalars['Int']>;
  company_name?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  docs_qty?: InputMaybe<Scalars['bigint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  identification?: InputMaybe<Scalars['String']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  qty?: InputMaybe<Scalars['bigint']>;
  reference?: InputMaybe<Scalars['String']>;
  user_display_name?: InputMaybe<Scalars['String']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_special_mentions" */
export type Declaration_Special_Mentions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Special_Mentions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Special_Mentions_Stream_Cursor_Value_Input = {
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_status" */
export type Declaration_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration" */
export type Declaration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  access_code?: InputMaybe<Scalars['String']>;
  agreed_location_of_goods?: InputMaybe<Scalars['String']>;
  ai_confirmed?: InputMaybe<Scalars['Boolean']>;
  ai_results?: InputMaybe<Scalars['jsonb']>;
  border_eau_number?: InputMaybe<Scalars['numeric']>;
  bunch_number?: InputMaybe<Scalars['Int']>;
  change_information?: InputMaybe<Scalars['date']>;
  clearance_location?: InputMaybe<Scalars['smallint']>;
  company_number_taxpayer?: InputMaybe<Scalars['String']>;
  correction_code?: InputMaybe<Scalars['Int']>;
  correction_reason?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_account_address_type?: InputMaybe<Scalars['Int']>;
  customs_account_name?: InputMaybe<Scalars['String']>;
  customs_account_number?: InputMaybe<Scalars['bigint']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_office_number?: InputMaybe<Scalars['String']>;
  declarant_company_name?: InputMaybe<Scalars['String']>;
  declarant_number?: InputMaybe<Scalars['Int']>;
  declaration_time?: InputMaybe<Scalars['smallint']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  delivery_destination?: InputMaybe<Scalars['bpchar']>;
  dispatch_country?: InputMaybe<Scalars['String']>;
  dispatch_country_confirmation?: InputMaybe<Scalars['Boolean']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_amount?: InputMaybe<Scalars['numeric']>;
  duty_total_amount?: InputMaybe<Scalars['numeric']>;
  evv_confirmed?: InputMaybe<Scalars['Boolean']>;
  evv_received?: InputMaybe<Scalars['Boolean']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  incoterms?: InputMaybe<Scalars['String']>;
  initiator?: InputMaybe<Scalars['smallint']>;
  injunction_type?: InputMaybe<Scalars['smallint']>;
  inspection_code?: InputMaybe<Scalars['Boolean']>;
  invoice_currency_type?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
  material_check?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  place_of_loading?: InputMaybe<Scalars['String']>;
  place_of_unloading?: InputMaybe<Scalars['String']>;
  postal_shipment_type?: InputMaybe<Scalars['String']>;
  procedure_type?: InputMaybe<Scalars['smallint']>;
  provisional_declaration_expiration_date?: InputMaybe<Scalars['date']>;
  reason?: InputMaybe<Scalars['String']>;
  receive_status?: InputMaybe<Scalars['Int']>;
  release?: InputMaybe<Scalars['Boolean']>;
  requestor_trader_identification_number?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<Scalars['Boolean']>;
  selection_correlation_id?: InputMaybe<Scalars['String']>;
  send_date?: InputMaybe<Scalars['timestamptz']>;
  send_status?: InputMaybe<Scalars['Int']>;
  service_type?: InputMaybe<Scalars['String']>;
  show_in_wd?: InputMaybe<Scalars['Boolean']>;
  specific_circumstance_indicator?: InputMaybe<Scalars['bpchar']>;
  status?: InputMaybe<Scalars['Int']>;
  status_date?: InputMaybe<Scalars['date']>;
  status_time?: InputMaybe<Scalars['time']>;
  tara_factor?: InputMaybe<Scalars['numeric']>;
  total_colis?: InputMaybe<Scalars['Int']>;
  total_goods_items?: InputMaybe<Scalars['Int']>;
  total_gross_weight?: InputMaybe<Scalars['numeric']>;
  total_vat_value?: InputMaybe<Scalars['numeric']>;
  trader_declaration_number?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transfer_to_transit_system?: InputMaybe<Scalars['Boolean']>;
  transport_country?: InputMaybe<Scalars['String']>;
  transport_in_container?: InputMaybe<Scalars['Boolean']>;
  transport_mode?: InputMaybe<Scalars['Int']>;
  transport_number?: InputMaybe<Scalars['String']>;
  transport_type?: InputMaybe<Scalars['String']>;
  unique_consignment_reference_number?: InputMaybe<Scalars['String']>;
  vat_account_address_type?: InputMaybe<Scalars['Int']>;
  vat_account_name?: InputMaybe<Scalars['String']>;
  vat_account_number?: InputMaybe<Scalars['bigint']>;
  vat_number?: InputMaybe<Scalars['String']>;
  vat_suffix?: InputMaybe<Scalars['Boolean']>;
  vat_total_amount?: InputMaybe<Scalars['numeric']>;
  warehouse_coded?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "declaration_task" */
export type Declaration_Task_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Task_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Task_Stream_Cursor_Value_Input = {
  assigned_to?: InputMaybe<Scalars['uuid']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['uuid']>;
  /** 1 = finished, 0 = open */
  task_status_id?: InputMaybe<Scalars['Int']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_tasks_obj" */
export type Declaration_Tasks_Obj_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Tasks_Obj_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Tasks_Obj_Stream_Cursor_Value_Input = {
  tasks?: InputMaybe<Scalars['_declaration_tasks_data']>;
  total_finished?: InputMaybe<Scalars['bigint']>;
  total_opened?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "declaration_tasks" */
export type Declaration_Tasks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Tasks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Tasks_Stream_Cursor_Value_Input = {
  assigned_to?: InputMaybe<Scalars['uuid']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  due_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  object_id?: InputMaybe<Scalars['uuid']>;
  qty?: InputMaybe<Scalars['bigint']>;
  rn?: InputMaybe<Scalars['bigint']>;
  task_status_id?: InputMaybe<Scalars['Int']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "declaration_type" */
export type Declaration_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Declaration_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Declaration_Type_Stream_Cursor_Value_Input = {
  document_schema?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "discussion_changes" */
export type Discussion_Changes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Discussion_Changes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Discussion_Changes_Stream_Cursor_Value_Input = {
  adit_user?: InputMaybe<Scalars['uuid']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  discussion_closed?: InputMaybe<Scalars['Boolean']>;
  discussion_id?: InputMaybe<Scalars['bigint']>;
  discussion_theme?: InputMaybe<Scalars['String']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  file_name?: InputMaybe<Scalars['String']>;
  last_msg_date?: InputMaybe<Scalars['timestamptz']>;
  last_user?: InputMaybe<Scalars['uuid']>;
  liber_user?: InputMaybe<Scalars['uuid']>;
  reference?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "doc_annotation" */
export type Doc_Annotation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Annotation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Annotation_Stream_Cursor_Value_Input = {
  anno_type_id?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to doc_annotation. */
  doc_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "doc_search_type" */
export type Doc_Search_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Search_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Search_Type_Stream_Cursor_Value_Input = {
  checksum?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  org_id_description?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
  user_code?: InputMaybe<Scalars['String']>;
  user_display_name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "doc_stats_type" */
export type Doc_Stats_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Stats_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Stats_Type_Stream_Cursor_Value_Input = {
  docs_qty?: InputMaybe<Scalars['bigint']>;
  document_type?: InputMaybe<Scalars['String']>;
  total_pages?: InputMaybe<Scalars['bigint']>;
  users_qty?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "docs_for_validation" */
export type Docs_For_Validation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Docs_For_Validation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Docs_For_Validation_Stream_Cursor_Value_Input = {
  checksum?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  doc_order?: InputMaybe<Scalars['bigint']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "document_extension" */
export type Document_Extension_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Extension_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Extension_Stream_Cursor_Value_Input = {
  /** document_extension creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document_extension creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** document_extension last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document_extension. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  thumbnails_supported?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "document_flag" */
export type Document_Flag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Flag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Flag_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  display?: InputMaybe<Scalars['Int']>;
  /** id of document_flag. */
  id?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "document_label_org_id" */
export type Document_Label_Org_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Label_Org_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Label_Org_Id_Stream_Cursor_Value_Input = {
  label_id?: InputMaybe<Scalars['Int']>;
  /** Org_id related to document_label_org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "document_labels" */
export type Document_Labels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Labels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Labels_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  /** id of document_labels. */
  id?: InputMaybe<Scalars['Int']>;
  /** Marks document_labels record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "document_page" */
export type Document_Page_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Page_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Page_Stream_Cursor_Value_Input = {
  /** Document Id related to document_page. */
  document_id?: InputMaybe<Scalars['uuid']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  page_number?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "document_status" */
export type Document_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Status_Stream_Cursor_Value_Input = {
  /** document_status creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document_status creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** document_status last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document_status. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "document" */
export type Document_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Stream_Cursor_Value_Input = {
  /** MD5-checksum of document. */
  checksum?: InputMaybe<Scalars['String']>;
  /** document creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  /** Bitmask-field with bits from table document_flag. Use pp_enc_df/pp_dec_df for constructing values. */
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  /** Document status. Partially deprecated. Refer to table document_status for values */
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  document_version?: InputMaybe<Scalars['Int']>;
  /** Declaration number, if the document is on file level, then dr_no is null. */
  dr_no?: InputMaybe<Scalars['smallint']>;
  /** Document Id related to document. */
  file?: InputMaybe<Scalars['uuid']>;
  /** id of document. */
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  /** Marks document record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  /** document last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  /** Number of pages in documnent. */
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  /** Org_id related to document. */
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "document_type_all_tenant_settings" */
export type Document_Type_All_Tenant_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_All_Tenant_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_All_Tenant_Settings_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  document_schema?: InputMaybe<Scalars['jsonb']>;
  document_type?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  tenant?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "document_type" */
export type Document_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_Stream_Cursor_Value_Input = {
  /** document_type creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** document_type creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** document_type last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified document_type. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "document_type_tenant_settings" */
export type Document_Type_Tenant_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Document_Type_Tenant_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Document_Type_Tenant_Settings_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  default_flags?: InputMaybe<Scalars['bigint']>;
  display_name?: InputMaybe<Scalars['String']>;
  document_schema?: InputMaybe<Scalars['jsonb']>;
  document_type?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  tenant?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "dr_stats" */
export type Dr_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dr_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dr_Stats_Stream_Cursor_Value_Input = {
  metric_id?: InputMaybe<Scalars['String']>;
  metric_label?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "edec_countries" */
export type Edec_Countries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Countries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Countries_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  iso_code?: InputMaybe<Scalars['bpchar']>;
  name_de?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_fr?: InputMaybe<Scalars['String']>;
  name_it?: InputMaybe<Scalars['String']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "edec_customs_offices" */
export type Edec_Customs_Offices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Customs_Offices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Customs_Offices_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "edec_domains" */
export type Edec_Domains_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Domains_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Domains_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  domain_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  meaning_de?: InputMaybe<Scalars['String']>;
  meaning_en?: InputMaybe<Scalars['String']>;
  meaning_fr?: InputMaybe<Scalars['String']>;
  meaning_it?: InputMaybe<Scalars['String']>;
  valid_for_export?: InputMaybe<Scalars['Boolean']>;
  valid_for_import?: InputMaybe<Scalars['Boolean']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  value?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "edec_tariff_commodity_code" */
export type Edec_Tariff_Commodity_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Tariff_Commodity_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Tariff_Commodity_Code_Stream_Cursor_Value_Input = {
  created?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  valid_for_export?: InputMaybe<Scalars['Boolean']>;
  valid_for_import?: InputMaybe<Scalars['Boolean']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  value?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "edec_tariff_statistical_code" */
export type Edec_Tariff_Statistical_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Edec_Tariff_Statistical_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Edec_Tariff_Statistical_Code_Stream_Cursor_Value_Input = {
  commodity_code_id?: InputMaybe<Scalars['Int']>;
  created?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['Int']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  lower_scale_weight?: InputMaybe<Scalars['numeric']>;
  scale_weight_code?: InputMaybe<Scalars['Int']>;
  storage_type?: InputMaybe<Scalars['String']>;
  upper_scale_weight?: InputMaybe<Scalars['numeric']>;
  valid_for_export?: InputMaybe<Scalars['Boolean']>;
  valid_for_import?: InputMaybe<Scalars['Boolean']>;
  valid_from?: InputMaybe<Scalars['date']>;
  valid_to?: InputMaybe<Scalars['date']>;
  value?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "email_search_type" */
export type Email_Search_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Search_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Search_Type_Stream_Cursor_Value_Input = {
  attachments?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  sender?: InputMaybe<Scalars['String']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "extract_type" */
export type Extract_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Extract_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Extract_Type_Stream_Cursor_Value_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Scalars['json']>;
};

/** Streaming cursor of the table "extraction_config" */
export type Extraction_Config_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Extraction_Config_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Extraction_Config_Stream_Cursor_Value_Input = {
  address_id?: InputMaybe<Scalars['Int']>;
  aliases?: InputMaybe<Scalars['jsonb']>;
  document_templates?: InputMaybe<Scalars['jsonb']>;
  foun_config?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "file_stats_type" */
export type File_Stats_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Stats_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Stats_Type_Stream_Cursor_Value_Input = {
  file_flags?: InputMaybe<Scalars['String']>;
  file_flags_id?: InputMaybe<Scalars['bigint']>;
  qty?: InputMaybe<Scalars['bigint']>;
  users_qty?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "file" */
export type File_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Stream_Cursor_Value_Input = {
  ai_doc_classification_confirmed?: InputMaybe<Scalars['Boolean']>;
  /** file creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** file creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_type?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  /** id of file. */
  id?: InputMaybe<Scalars['uuid']>;
  /**
   * Is usually set automatically by AQW.IdentificationProvider.
   *
   * AQW.IdentificationProvider can be set in tenant settings either DefaultProvider (random uuid) or a company specific provider which calls an external API endpoint.
   *
   */
  identification?: InputMaybe<Scalars['String']>;
  /** Marks file record as deleted. */
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  /** file last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified file. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  /** Org_id related to file. */
  org_id?: InputMaybe<Scalars['smallint']>;
  session_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "file_type" */
export type File_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_Type_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  doc_types?: InputMaybe<Scalars['_varchar']>;
  file_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "goods_item_special_mentions" */
export type Goods_Item_Special_Mentions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Goods_Item_Special_Mentions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Goods_Item_Special_Mentions_Stream_Cursor_Value_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  sequence_number?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "goods_item" */
export type Goods_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Goods_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Goods_Item_Stream_Cursor_Value_Input = {
  additional_unit?: InputMaybe<Scalars['String']>;
  additional_unit_confirmation?: InputMaybe<Scalars['Boolean']>;
  billing_type?: InputMaybe<Scalars['smallint']>;
  clearance_type?: InputMaybe<Scalars['Int']>;
  commercial_good?: InputMaybe<Scalars['Boolean']>;
  commodity_code?: InputMaybe<Scalars['String']>;
  commodity_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_declaration_version?: InputMaybe<Scalars['Int']>;
  customs_favour_code?: InputMaybe<Scalars['Int']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  customs_net_weight?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  direction?: InputMaybe<Scalars['smallint']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_and_other_taxes_total?: InputMaybe<Scalars['numeric']>;
  duty_rate?: InputMaybe<Scalars['numeric']>;
  duty_total?: InputMaybe<Scalars['numeric']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  gross_mass?: InputMaybe<Scalars['numeric']>;
  gross_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  net_duty?: InputMaybe<Scalars['Boolean']>;
  net_mass?: InputMaybe<Scalars['numeric']>;
  net_mass_confirmation?: InputMaybe<Scalars['Boolean']>;
  non_customs_law_obligation?: InputMaybe<Scalars['smallint']>;
  origin_country?: InputMaybe<Scalars['String']>;
  origin_preference?: InputMaybe<Scalars['Boolean']>;
  permit_obligation_code?: InputMaybe<Scalars['Int']>;
  preference_confirmation?: InputMaybe<Scalars['Boolean']>;
  process_type?: InputMaybe<Scalars['smallint']>;
  rate_confirmation?: InputMaybe<Scalars['Boolean']>;
  refinement_type?: InputMaybe<Scalars['smallint']>;
  refund_type?: InputMaybe<Scalars['smallint']>;
  repair?: InputMaybe<Scalars['Boolean']>;
  repair_reason?: InputMaybe<Scalars['String']>;
  selection_result?: InputMaybe<Scalars['Int']>;
  statistical_code?: InputMaybe<Scalars['Int']>;
  statistical_value?: InputMaybe<Scalars['Int']>;
  statistical_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  storage_type?: InputMaybe<Scalars['smallint']>;
  tare_supplement?: InputMaybe<Scalars['numeric']>;
  tare_supplement_confirmation?: InputMaybe<Scalars['Boolean']>;
  un_dangerous_goods_code?: InputMaybe<Scalars['String']>;
  vat_code?: InputMaybe<Scalars['smallint']>;
  vat_code_confirmation?: InputMaybe<Scalars['Boolean']>;
  vat_rate?: InputMaybe<Scalars['numeric']>;
  vat_total?: InputMaybe<Scalars['numeric']>;
  vat_value?: InputMaybe<Scalars['numeric']>;
  vat_value_confirmation?: InputMaybe<Scalars['Boolean']>;
  voc_quantity?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "goods_items_for_drs" */
export type Goods_Items_For_Drs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Goods_Items_For_Drs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Goods_Items_For_Drs_Stream_Cursor_Value_Input = {
  acceptance_date?: InputMaybe<Scalars['timestamptz']>;
  account_number?: InputMaybe<Scalars['String']>;
  additional_unit?: InputMaybe<Scalars['jsonb']>;
  arrival_time?: InputMaybe<Scalars['timestamptz']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  autoclassified_docs_qty?: InputMaybe<Scalars['bigint']>;
  ch_exp_decl?: InputMaybe<Scalars['Boolean']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  commercial_good?: InputMaybe<Scalars['String']>;
  commodity_code?: InputMaybe<Scalars['jsonb']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_clearance_type?: InputMaybe<Scalars['String']>;
  customs_declaration_number?: InputMaybe<Scalars['String']>;
  customs_declaration_version?: InputMaybe<Scalars['smallint']>;
  customs_itemnumber?: InputMaybe<Scalars['jsonb']>;
  declaration_status?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  dest_tolldept_code?: InputMaybe<Scalars['String']>;
  dest_tolldept_name?: InputMaybe<Scalars['String']>;
  doc_id?: InputMaybe<Scalars['uuid']>;
  document_type?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  duty_total?: InputMaybe<Scalars['String']>;
  eta?: InputMaybe<Scalars['timestamptz']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  goods_item?: InputMaybe<Scalars['jsonb']>;
  grossmass?: InputMaybe<Scalars['jsonb']>;
  hs_code?: InputMaybe<Scalars['String']>;
  imp_cust_clr?: InputMaybe<Scalars['Boolean']>;
  is_express?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  net_mass?: InputMaybe<Scalars['jsonb']>;
  non_customs_law_obligation?: InputMaybe<Scalars['jsonb']>;
  nonclassified_docs_exists?: InputMaybe<Scalars['Boolean']>;
  origin?: InputMaybe<Scalars['jsonb']>;
  origin_country?: InputMaybe<Scalars['String']>;
  packaging?: InputMaybe<Scalars['jsonb']>;
  payer_id?: InputMaybe<Scalars['uuid']>;
  permissions_js?: InputMaybe<Scalars['json']>;
  permit_obligation?: InputMaybe<Scalars['jsonb']>;
  preference?: InputMaybe<Scalars['String']>;
  produced_document?: InputMaybe<Scalars['jsonb']>;
  qty?: InputMaybe<Scalars['bigint']>;
  reference?: InputMaybe<Scalars['String']>;
  row_number?: InputMaybe<Scalars['bigint']>;
  statistic?: InputMaybe<Scalars['jsonb']>;
  statistical_code?: InputMaybe<Scalars['jsonb']>;
  statistical_value?: InputMaybe<Scalars['String']>;
  toll_dep?: InputMaybe<Scalars['String']>;
  tr_no?: InputMaybe<Scalars['String']>;
  trader_reference?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
  valuation_details?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
  vat_total?: InputMaybe<Scalars['String']>;
  vatvalue?: InputMaybe<Scalars['String']>;
  wa_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "import_list_trigger" */
export type Import_List_Trigger_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Import_List_Trigger_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Import_List_Trigger_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  label_id?: InputMaybe<Scalars['Int']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "intf_dr_payment_info" */
export type Intf_Dr_Payment_Info_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Intf_Dr_Payment_Info_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Intf_Dr_Payment_Info_Stream_Cursor_Value_Input = {
  addresses?: InputMaybe<Scalars['_int4']>;
  addresses_qi?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "json_type" */
export type Json_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Json_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Json_Type_Stream_Cursor_Value_Input = {
  json_value?: InputMaybe<Scalars['json']>;
};

/** Streaming cursor of the table "kc_users" */
export type Kc_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Kc_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Kc_Users_Stream_Cursor_Value_Input = {
  adit_permissions?: InputMaybe<Scalars['bigint']>;
  adit_permissions_desk?: InputMaybe<Scalars['_txtcode']>;
  adit_permissions_hex?: InputMaybe<Scalars['String']>;
  adit_roles?: InputMaybe<Scalars['jsonb']>;
  attrs?: InputMaybe<Scalars['jsonb']>;
  code?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['timestamptz']>;
  default_role?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  federation_link?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  liber_roles?: InputMaybe<Scalars['jsonb']>;
  location?: InputMaybe<Scalars['String']>;
  not_before?: InputMaybe<Scalars['Int']>;
  org_ids?: InputMaybe<Scalars['jsonb']>;
  phone_number?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['bigint']>;
  realm_id?: InputMaybe<Scalars['String']>;
  required_actions?: InputMaybe<Scalars['_varchar']>;
  service_account_client_link?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  user_client_roles?: InputMaybe<Scalars['jsonb']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "max_date_type" */
export type Max_Date_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Max_Date_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Max_Date_Type_Stream_Cursor_Value_Input = {
  max_change_date?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "model_retrain" */
export type Model_Retrain_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Model_Retrain_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Model_Retrain_Stream_Cursor_Value_Input = {
  end_time?: InputMaybe<Scalars['timestamptz']>;
  error_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  request_time?: InputMaybe<Scalars['timestamptz']>;
  start_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "org_id" */
export type Org_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Id_Stream_Cursor_Value_Input = {
  /** can org_id be used to create new files in adit. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** org_id creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** org_id creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** org_id last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified org_id. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** Org_id related to org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
  org_id_description?: InputMaybe<Scalars['String']>;
  /** Tenant of org_id. */
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "org_ids" */
export type Org_Ids_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Ids_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Ids_Stream_Cursor_Value_Input = {
  addresses_desc?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  docs_affected?: InputMaybe<Scalars['_uuid']>;
  files_affected?: InputMaybe<Scalars['_uuid']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  org_id_description?: InputMaybe<Scalars['String']>;
  org_ids_desc?: InputMaybe<Scalars['String']>;
  org_params?: InputMaybe<Scalars['json']>;
  qty?: InputMaybe<Scalars['bigint']>;
  users_affected?: InputMaybe<Scalars['_uuid']>;
};

/** Streaming cursor of the table "org_params_org_id" */
export type Org_Params_Org_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Params_Org_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Params_Org_Id_Stream_Cursor_Value_Input = {
  org_id?: InputMaybe<Scalars['Int']>;
  param_org_id?: InputMaybe<Scalars['smallint']>;
};

/** Streaming cursor of the table "org_params" */
export type Org_Params_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Params_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Params_Stream_Cursor_Value_Input = {
  addresses?: InputMaybe<Scalars['query_int']>;
  file_ids?: InputMaybe<Scalars['_uuid']>;
  org_id?: InputMaybe<Scalars['Int']>;
  org_ids?: InputMaybe<Scalars['_int2']>;
  search?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "packagings" */
export type Packagings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Packagings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Packagings_Stream_Cursor_Value_Input = {
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  packaging_quantity?: InputMaybe<Scalars['Int']>;
  packaging_reference_number?: InputMaybe<Scalars['String']>;
  packaging_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "page_extract" */
export type Page_Extract_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Page_Extract_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Extract_Stream_Cursor_Value_Input = {
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  page_id?: InputMaybe<Scalars['uuid']>;
  tables?: InputMaybe<Scalars['jsonb']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "page_status" */
export type Page_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Page_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Status_Stream_Cursor_Value_Input = {
  /** page_status creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** page_status creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** page_status last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified page_status. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "page" */
export type Page_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Page_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Stream_Cursor_Value_Input = {
  ai_ignore_retraining?: InputMaybe<Scalars['Boolean']>;
  /** page creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** page creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of page. */
  id?: InputMaybe<Scalars['uuid']>;
  /** page last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified page. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** additional attributes */
  meta?: InputMaybe<Scalars['jsonb']>;
  ocr_text?: InputMaybe<Scalars['String']>;
  page_status?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['smallint']>;
  thumbnail_big_url?: InputMaybe<Scalars['String']>;
  thumbnail_small_url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "pages_m2m_cache" */
export type Pages_M2m_Cache_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pages_M2m_Cache_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pages_M2m_Cache_Stream_Cursor_Value_Input = {
  document_id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  page?: InputMaybe<Scalars['uuid']>;
  page_number?: InputMaybe<Scalars['bigint']>;
  page_status?: InputMaybe<Scalars['String']>;
  rotate?: InputMaybe<Scalars['Int']>;
  thumbnail_big_url?: InputMaybe<Scalars['String']>;
  thumbnail_small_url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "permits" */
export type Permits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Permits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Permits_Stream_Cursor_Value_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  issue_date?: InputMaybe<Scalars['date']>;
  permit_authority?: InputMaybe<Scalars['Int']>;
  permit_item_details?: InputMaybe<Scalars['jsonb']>;
  permit_number?: InputMaybe<Scalars['String']>;
  permit_type?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "pp_types_file_search" */
export type Pp_Types_File_Search_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pp_Types_File_Search_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pp_Types_File_Search_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  customs_relevant?: InputMaybe<Scalars['Boolean']>;
  customs_relevant_qty?: InputMaybe<Scalars['bigint']>;
  extraction_completed_qty?: InputMaybe<Scalars['bigint']>;
  extraction_required?: InputMaybe<Scalars['Boolean']>;
  extraction_required_qty?: InputMaybe<Scalars['bigint']>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  identification?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  org_id_description?: InputMaybe<Scalars['String']>;
  session_id?: InputMaybe<Scalars['String']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "previous_documents" */
export type Previous_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Previous_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Previous_Documents_Stream_Cursor_Value_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  previous_document_reference?: InputMaybe<Scalars['String']>;
  previous_document_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "produced_documents" */
export type Produced_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Produced_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Produced_Documents_Stream_Cursor_Value_Input = {
  additional_information?: InputMaybe<Scalars['String']>;
  customs_item_number?: InputMaybe<Scalars['Int']>;
  dr_no?: InputMaybe<Scalars['smallint']>;
  file_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['Int']>;
  produced_document_issue_date?: InputMaybe<Scalars['date']>;
  produced_document_reference_number?: InputMaybe<Scalars['String']>;
  produced_document_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "report" */
export type Report_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Report_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Report_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  md5?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "service_rate" */
export type Service_Rate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Rate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Rate_Stream_Cursor_Value_Input = {
  const_included?: InputMaybe<Scalars['Int']>;
  const_rate?: InputMaybe<Scalars['numeric']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  var_rate?: InputMaybe<Scalars['numeric']>;
};

/** Streaming cursor of the table "service" */
export type Service_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Stream_Cursor_Value_Input = {
  srv_desk?: InputMaybe<Scalars['String']>;
  srv_id?: InputMaybe<Scalars['Int']>;
  srv_type?: InputMaybe<Scalars['String']>;
  translation?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "service_tariff" */
export type Service_Tariff_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Service_Tariff_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Service_Tariff_Stream_Cursor_Value_Input = {
  direct_upload_cost?: InputMaybe<Scalars['numeric']>;
  email_upload_cost?: InputMaybe<Scalars['numeric']>;
  end_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  position_cost?: InputMaybe<Scalars['numeric']>;
  positions_included?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "setting_group" */
export type Setting_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setting_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setting_Group_Stream_Cursor_Value_Input = {
  /** setting_group creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting_group creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  /** id of setting_group. */
  id?: InputMaybe<Scalars['uuid']>;
  /** setting_group last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting_group. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "setting" */
export type Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setting_Stream_Cursor_Value_Input = {
  constrained?: InputMaybe<Scalars['Boolean']>;
  /** setting creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  data_type?: InputMaybe<Scalars['String']>;
  default_value?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** id of setting. */
  id?: InputMaybe<Scalars['uuid']>;
  identifier?: InputMaybe<Scalars['String']>;
  /** setting last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  max_value?: InputMaybe<Scalars['numeric']>;
  min_value?: InputMaybe<Scalars['numeric']>;
  setting_group_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "setting_value" */
export type Setting_Value_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Setting_Value_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Setting_Value_Stream_Cursor_Value_Input = {
  /** setting_value creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** setting_value creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  /** id of setting_value. */
  id?: InputMaybe<Scalars['uuid']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
  /** setting_value last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified setting_value. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "tariff_number_description" */
export type Tariff_Number_Description_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tariff_Number_Description_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tariff_Number_Description_Stream_Cursor_Value_Input = {
  description_de?: InputMaybe<Scalars['String']>;
  hierarchy_path?: InputMaybe<Scalars['ltree']>;
  hierarchy_visual?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  tariff_number?: InputMaybe<Scalars['String']>;
  tsv?: InputMaybe<Scalars['tsvector']>;
};

/** Streaming cursor of the table "task_type" */
export type Task_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Task_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Type_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "tenant" */
export type Tenant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenant_Stream_Cursor_Value_Input = {
  /** Swiss Customs account number */
  account_number?: InputMaybe<Scalars['String']>;
  address_id?: InputMaybe<Scalars['Int']>;
  /** tenant creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** tenant creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** id of tenant. */
  id?: InputMaybe<Scalars['uuid']>;
  is_wd_customer?: InputMaybe<Scalars['Boolean']>;
  /** tenant last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified tenant. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  permissions?: InputMaybe<Scalars['bit']>;
  permissions_js?: InputMaybe<Scalars['jsonb']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  tenant_type?: InputMaybe<Scalars['tenant_type']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "tenants" */
export type Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenants_Stream_Cursor_Value_Input = {
  address_groups?: InputMaybe<Scalars['_int2']>;
  address_id?: InputMaybe<Scalars['Int']>;
  address_type?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  permissions?: InputMaybe<Scalars['String']>;
  permissions_desk?: InputMaybe<Scalars['_txtcode']>;
  qty?: InputMaybe<Scalars['bigint']>;
  tenant_id?: InputMaybe<Scalars['uuid']>;
  tenant_name?: InputMaybe<Scalars['String']>;
  tenant_type?: InputMaybe<Scalars['tenant_type']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "transitdoc_type_descr" */
export type Transitdoc_Type_Descr_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transitdoc_Type_Descr_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transitdoc_Type_Descr_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']>;
  transitdoc_type?: InputMaybe<Scalars['transitdoc_type']>;
};

/** Streaming cursor of the table "user_org_id" */
export type User_Org_Id_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Org_Id_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Org_Id_Stream_Cursor_Value_Input = {
  /** user_org_id creation date. */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_org_id creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  /** user_org_id last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_org_id. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  /** Org_id related to user_org_id. */
  org_id?: InputMaybe<Scalars['smallint']>;
  user_pp?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "user_pp" */
export type User_Pp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Pp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Pp_Stream_Cursor_Value_Input = {
  code?: InputMaybe<Scalars['String']>;
  /** User creation date */
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  /** user_pp creation user. */
  creation_user?: InputMaybe<Scalars['uuid']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  deleted_at?: InputMaybe<Scalars['timestamptz']>;
  deleted_by_user?: InputMaybe<Scalars['uuid']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  /** id of user_pp. */
  id?: InputMaybe<Scalars['uuid']>;
  /** user_pp last modification date. */
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  /** Last user that modified user_pp. */
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  last_name?: InputMaybe<Scalars['String']>;
  ldap_entry_dn?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  oauth_id?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['bit']>;
  phone_number?: InputMaybe<Scalars['String']>;
  /** Tenant of user_pp. */
  tenant_id?: InputMaybe<Scalars['uuid']>;
  ui_settings?: InputMaybe<Scalars['jsonb']>;
  ui_settings_templates?: InputMaybe<Scalars['jsonb']>;
  user_type?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_search_type" */
export type User_Search_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Search_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Search_Type_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  display_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  location?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['json']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
};

/** Streaming cursor of the table "view_document_history" */
export type View_Document_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_Document_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_Document_History_Stream_Cursor_Value_Input = {
  action_title?: InputMaybe<Scalars['String']>;
  action_user?: InputMaybe<Scalars['uuid']>;
  action_value?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  op_date?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "view_file_history" */
export type View_File_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_File_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_File_History_Stream_Cursor_Value_Input = {
  action_title?: InputMaybe<Scalars['String']>;
  action_user?: InputMaybe<Scalars['uuid']>;
  action_value?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  op_date?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "view_history" */
export type View_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: View_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type View_History_Stream_Cursor_Value_Input = {
  action_title?: InputMaybe<Scalars['String']>;
  action_user?: InputMaybe<Scalars['uuid']>;
  action_value?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  op_date?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "vw_documents" */
export type Vw_Documents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Documents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Documents_Stream_Cursor_Value_Input = {
  checksum?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  document_blobs?: InputMaybe<Scalars['jsonb']>;
  document_extension?: InputMaybe<Scalars['String']>;
  document_flags?: InputMaybe<Scalars['bigint']>;
  document_name?: InputMaybe<Scalars['String']>;
  document_status?: InputMaybe<Scalars['String']>;
  document_type?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_customs_relevant?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_generated?: InputMaybe<Scalars['Boolean']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  number_of_pages?: InputMaybe<Scalars['smallint']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  sequence?: InputMaybe<Scalars['Int']>;
};

/** Streaming cursor of the table "vw_finished_files" */
export type Vw_Finished_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Vw_Finished_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Vw_Finished_Files_Stream_Cursor_Value_Input = {
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  creation_user?: InputMaybe<Scalars['uuid']>;
  file_flags?: InputMaybe<Scalars['bigint']>;
  file_status?: InputMaybe<Scalars['String']>;
  file_url?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  identification?: InputMaybe<Scalars['String']>;
  last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  last_modified_user?: InputMaybe<Scalars['uuid']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  org_id?: InputMaybe<Scalars['smallint']>;
  session_id?: InputMaybe<Scalars['String']>;
};

export type ClearDocumentChecksumMutationVariables = Exact<{
  checksums: Array<Scalars['String']> | Scalars['String'];
}>;


export type ClearDocumentChecksumMutation = { update_document: { affected_rows: number } | null };

export type CreateDocumentMutationVariables = Exact<{
  document: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { createDocument: { success: boolean | null, error: string | null, documentId: string | null } | null };

export type GetDocumentsByChecksumQueryVariables = Exact<{
  checksums: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetDocumentsByChecksumQuery = { documents: Array<{ id: any, document_name: string | null, checksum: string | null }> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { user: { permissionsDesk: Array<string> | null, firstName: string | null, lastName: string | null, email: string, phoneNumber: string | null, uiSettings: any, uiSettingsTemplates: any, externalAuthProvider: boolean, tenantId: any, userId: string, tenant: { id: any, tenant_name: string, permissions_js: any | null, tenantDocumentTypes: Array<{ meta: any | null, code: string | null, document_type: string, default_flags: number | null }>, declaration_labels: Array<{ id: number, title: any | null, description: string | null, color: string, is_deleted: boolean | null }>, address: { id: number, country: string | null, city: string | null, street: string | null, zipcode: string | null, street_number: string | null, address_type: number | null, company_name: string } }, modules: Array<{ name: string }> | null } };

export type GetCurrentUserTenantConfigQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type GetCurrentUserTenantConfigQuery = { getTenantConfig: any | null };

export type UpdateCurrentUserUiSettingsMutationVariables = Exact<{
  id: Scalars['uuid'];
  ui_settings: Scalars['jsonb'];
}>;


export type UpdateCurrentUserUiSettingsMutation = { update_user_pp_by_pk: { id: any } | null };

export type UpdateCurrentUserUiSettingsTemplatesMutationVariables = Exact<{
  id: Scalars['uuid'];
  ui_settings_templates: Scalars['jsonb'];
}>;


export type UpdateCurrentUserUiSettingsTemplatesMutation = { update_user_pp_by_pk: { id: any } | null };

export type WdGetAddressesListQueryVariables = Exact<{
  addressIds?: InputMaybe<Scalars['_int4']>;
  search?: InputMaybe<Scalars['String']>;
  addressTypes?: InputMaybe<Scalars['_int4']>;
  emptyAddressType?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type WdGetAddressesListQuery = { addresses: Array<{ id: number, country: string | null, city: string | null, street: string | null, zipcode: string | null, address_type: number | null, reference: string | null, source: string | null, aoId: number | null, companyName: string, streetNumber: string | null, tenant: { id: any, permissions_js: any } | null }> };

export type AditGetAddressesListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AditGetAddressesListQuery = { addresses: Array<{ id: number, companyName: string, companyName2: string | null, country: string | null, city: string | null, street: string | null, zipcode: string | null, usageFrequency: number, customsAccountNumber: string | null, traderIdentificationNumber: string | null, vatAccountNumber: string | null, uidNumber: string | null, isLocked: boolean, reference: string | null, isPlatformUser: boolean }> };

export type AdiAddressesListFragmentFragment = { id: number, companyName: string, companyName2: string | null, country: string | null, city: string | null, street: string | null, zipcode: string | null, usageFrequency: number, customsAccountNumber: string | null, traderIdentificationNumber: string | null, vatAccountNumber: string | null, uidNumber: string | null, isLocked: boolean, reference: string | null, isPlatformUser: boolean };

export type EditAddressMutationVariables = Exact<{
  id: Scalars['Int'];
  aoId?: InputMaybe<Scalars['Int']>;
  newData: AddressInputRs;
  additionalParams: EditAddressInputAcs;
}>;


export type EditAddressMutation = { editAddressACS: { id: number, city: string | null, companyName: string, contactEmail: string | null, contactPhone: string | null, contactWebsite: string | null, country: string | null, reference: string | null, street: string | null, streetNumber: string | null, zipcode: string | null, meta: any | null } };

export type WdInsertAddressMutationVariables = Exact<{
  objects: Array<Address_Insert_Input> | Address_Insert_Input;
}>;


export type WdInsertAddressMutation = { insert_address: { affected_rows: number } | null };

export type LinkAddressesMutationVariables = Exact<{
  input: LinkAddressesInputAcs;
}>;


export type LinkAddressesMutation = { linkAddressesACS: Array<{ address_id: number, address_override_id: number }> };

export type Update_AddressMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  values?: InputMaybe<Address_Set_Input>;
}>;


export type Update_AddressMutation = { update_address: { affected_rows: number } | null };

export type Update_Address_OverrideMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
  values?: InputMaybe<Address_Override_Set_Input>;
}>;


export type Update_Address_OverrideMutation = { update_address_override: { affected_rows: number } | null };

export type AditGetCommodityCodesListQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AditGetCommodityCodesListQuery = { commodityCodes: Array<{ id: number, commodityCode: string | null, descriptionDe: string, hierarchyVisual: string | null }> };

export type AditUpdateDeclarationAiConfirmedMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  ai_confirmed: Scalars['Boolean'];
}>;


export type AditUpdateDeclarationAiConfirmedMutation = { update_declaration_by_pk: { file_id: any, dr_no: any } | null };

export type AditGetDeclarationQueryVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
}>;


export type AditGetDeclarationQuery = { declarations: Array<{ file_id: any, dr_no: any, ai_results: any, ai_confirmed: boolean | null, file: { identification: string | null }, declaration_request: { cev_status: string | null } | null }>, declarationsForm: Array<{ file_id: any, dr_no: any, send_status: number | null, declarant_number: number | null, trader_identification_number: string | null, send_date: any | null, receive_status: number | null, acceptance_date: any | null, customs_declaration_number: string | null, trader_reference: string | null, duty_total_amount: any | null, vat_total_amount: any | null, customs_declaration_version: number | null, material_check: boolean | null, release: boolean | null, gross_mass: any | null, net_mass: any | null, transport_mode: number | null, transport_type: string | null, transport_country: string | null, transport_number: string | null, service_type: string | null, invoice_currency_type: string | null, clearance_location: any | null, place_of_unloading: string | null, declaration_time: any | null, declaration_type: string | null, reason: string | null, lang: string | null, customs_office_number: string | null, dispatch_country: string | null, dispatch_country_confirmation: boolean | null, correction_code: number | null, correction_reason: string | null, transport_in_container: boolean | null, incoterms: string | null, customs_account_address_type: number | null, customs_account_number: any | null, vat_account_address_type: number | null, vat_account_number: any | null, vat_number: string | null, addresses: Array<{ address_type: number, address_id: number | null, refs: any, address: { id: number, company_name: string, street: string | null, street_number: string | null, country: string | null, zipcode: string | null, city: string | null, reference: string | null, customs_account_number: string | null, vat_account_number: string | null } | null }>, previous_documents: Array<{ id: number, previous_document_type: string | null, previous_document_reference: string | null, additional_information: string | null }>, containers: Array<{ id: number, container_number: string | null }>, declaration_special_mentions: Array<{ id: number, sequence_number: number | null, text: string | null }>, goods_items: Array<{ customs_item_number: number, selection_result: number | null, commodity_code: string | null, commodity_code_confirmation: boolean | null, statistical_code: number | null, duty_rate: any | null, rate_confirmation: boolean | null, description: string | null, net_duty: boolean | null, net_mass: any | null, net_mass_confirmation: boolean | null, tare_supplement: any | null, tare_supplement_confirmation: boolean | null, gross_mass: any | null, gross_mass_confirmation: boolean | null, customs_net_weight: any | null, additional_unit: string | null, additional_unit_confirmation: boolean | null, commercial_good: boolean | null, clearance_type: number | null, customs_favour_code: number | null, origin_country: string | null, origin_preference: boolean | null, preference_confirmation: boolean | null, vat_code: any | null, vat_code_confirmation: boolean | null, statistical_value: number | null, statistical_value_confirmation: boolean | null, vat_value: any | null, vat_value_confirmation: boolean | null, repair: boolean | null, packagings: Array<{ id: number, packaging_type: string | null, packaging_quantity: number | null, packaging_reference_number: string | null }>, produced_documents: Array<{ id: number, produced_document_type: string | null, produced_document_reference_number: string | null, produced_document_issue_date: any | null, additional_information: string | null }> }> }> };

export type AditUpsertDeclarationMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  object: Declaration_Insert_Input;
  constraint: Declaration_Constraint;
  update_columns: Array<Declaration_Update_Column> | Declaration_Update_Column;
  goodsItemsToDeleteExp: Array<Goods_Item_Bool_Exp> | Goods_Item_Bool_Exp;
  previousDocumentsToDeleteExp: Array<Previous_Documents_Bool_Exp> | Previous_Documents_Bool_Exp;
  containersToDeleteExp: Array<Containers_Bool_Exp> | Containers_Bool_Exp;
  declarationSpecialMentionsToDeleteExp: Array<Declaration_Special_Mentions_Bool_Exp> | Declaration_Special_Mentions_Bool_Exp;
  packagingsToDeleteExp: Array<Packagings_Bool_Exp> | Packagings_Bool_Exp;
  producedDocumentsToDeleteExp: Array<Produced_Documents_Bool_Exp> | Produced_Documents_Bool_Exp;
}>;


export type AditUpsertDeclarationMutation = { insert_declaration_one: { file_id: any, dr_no: any } | null, delete_previous_documents: { affected_rows: number } | null, delete_containers: { affected_rows: number } | null, delete_declaration_special_mentions: { affected_rows: number } | null, delete_goods_item: { affected_rows: number } | null, delete_packagings: { affected_rows: number } | null, delete_produced_documents: { affected_rows: number } | null };

export type WdAssignDeclarationLabelsMutationVariables = Exact<{
  drNo: Scalars['Int'];
  fileId: Scalars['UUID'];
  labelIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type WdAssignDeclarationLabelsMutation = { assignDeclarationLabels: Array<{ fileId: any, drNo: number, labelId: number } | null> | null };

export type Change_Declaration_StatusMutationVariables = Exact<{
  fileId: Scalars['uuid'];
  status?: InputMaybe<Scalars['String']>;
}>;


export type Change_Declaration_StatusMutation = { update_declaration_request: { affected_rows: number } | null };

export type WdCreateDeclarationMutationVariables = Exact<{
  documents: Array<CreateDeclarationDocumentInput> | CreateDeclarationDocumentInput;
  declaration?: InputMaybe<DeclarationInput>;
  fileId?: InputMaybe<Scalars['ID']>;
}>;


export type WdCreateDeclarationMutation = { createDeclarationReq: { success: boolean | null, error: string | null, documentIds: Array<string | null> | null, fileId: string | null } | null };

export type WdDownloadGoodItemsStatisticsQueryVariables = Exact<{
  addresses_qi?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  declaration_statuses?: InputMaybe<Scalars['String']>;
  declaration_type?: InputMaybe<Scalars['String']>;
  max_date?: InputMaybe<Scalars['timestamptz']>;
  min_date?: InputMaybe<Scalars['timestamptz']>;
  payer?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  evv_status?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  search_field?: InputMaybe<Scalars['String']>;
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  total_items?: InputMaybe<Scalars['Int']>;
  declaration_labels?: InputMaybe<Scalars['String']>;
}>;


export type WdDownloadGoodItemsStatisticsQuery = { getDeclarationGoodItemsStatistics: any | null };

export type WdUpdateDeclarationEvvConfirmationMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  evv_confirmed: Scalars['Boolean'];
}>;


export type WdUpdateDeclarationEvvConfirmationMutation = { update_declaration_request_by_pk: { file_id: any } | null };

export type Update_Declaration_RequestMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  arrival_time: Scalars['timestamptz'];
  declaration_status?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
}>;


export type Update_Declaration_RequestMutation = { update_declaration_request_by_pk: { file_id: any } | null };

export type SendDeclarationArrivalNotificationMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  arrival_time: Scalars['timestamptz'];
}>;


export type SendDeclarationArrivalNotificationMutation = { sendDeclarationArrivalNotification: any | null };

export type Adit_Get_Validation_V2_DocumentQueryVariables = Exact<{
  id: Scalars['uuid'];
  tenantId: Scalars['uuid'];
}>;


export type Adit_Get_Validation_V2_DocumentQuery = { file: { identification: string | null, documents: Array<{ id: any, meta: any, document_extension: string, document_blobs: any, document_flags: any, document_type: string, sequence: number | null, name: string | null, annotationType: Array<{ annotation_schema: any | null }>, pages: Array<{ page: { id: any, page_status: string, rotate: any, meta: any, creation_user: any, thumbnailBigUrl: string | null, pageExtracts: Array<{ page_id: any, extract_type_id: any, tables: any | null, dataPoints: any | null, extract_type: { extract_type_id: any, translations: any | null } }> } | null }>, documentType: { translations: any, document_type_tenant_settings: Array<{ documentSchema: any | null }> } }> } | null };

export type Upsert_TableMutationVariables = Exact<{
  pageId: Scalars['uuid'];
  extractTypeId: Scalars['smallint'];
  tables: Scalars['jsonb'];
}>;


export type Upsert_TableMutation = { insert_page_extract_one: { page_id: any } | null };

export type AditDeleteDocumentMutationVariables = Exact<{
  id: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type AditDeleteDocumentMutation = { update_document: { affected_rows: number } | null };

export type AditScheduleDocumentsMutationVariables = Exact<{
  documentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AditScheduleDocumentsMutation = { scheduleDocuments: any | null };

export type ScheduleDocAnnotationExportMutationVariables = Exact<{
  documentID: Scalars['ID'];
}>;


export type ScheduleDocAnnotationExportMutation = { scheduleDocAnnotationExport: any | null };

export type AditGetDocumentsForSubscriptionQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  creationUser?: InputMaybe<Scalars['uuid']>;
  search?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type AditGetDocumentsForSubscriptionQuery = { documents: Array<{ id: any | null, document_extension: string | null, document_name: string | null, creation_date: any | null, creation_user: any | null, org_id: any | null, org_id_description: string | null, document_status: string | null, document_flags: any | null, document_blobs: any | null, total_rows: any | null, user_display_name: string | null, pages_m2m_aggregate: { aggregate: { count: number } | null } }> };

export type GetDocumentUpdatesSubscriptionVariables = Exact<{
  my?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDocumentUpdatesSubscription = { pp_doc_max_date_hs: Array<{ max_change_date: any | null }> };

export type Adit_Get_Document_TypesQueryVariables = Exact<{
  tenantId: Scalars['uuid'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  where: Document_Type_Bool_Exp;
}>;


export type Adit_Get_Document_TypesQuery = { document_type: Array<{ name: string, display_name: string | null, translations: any, last_modified_date: any | null, document_type_tenant_settings: Array<{ code: string | null, default_flags: any | null, meta: any | null }> }>, document_type_aggregate: { aggregate: { count: number } | null } };

export type Adit_Get_Document_Type_FlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type Adit_Get_Document_Type_FlagsQuery = { document_flag: Array<{ id: any, name: string, translation: any, color: string | null }> };

export type UpdateFileMutationVariables = Exact<{
  id: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type UpdateFileMutation = { update_file: { affected_rows: number } | null };

export type Adit_Get_EmailQueryVariables = Exact<{
  id: Scalars['uuid'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type Adit_Get_EmailQuery = { emails: Array<{ id: any | null, name: string | null, meta: any | null, file_status: string | null, creation_user: any | null, creation_date: any | null, file_url: string | null, company: string | null, sender: string | null, total_rows: any | null, documents: Array<{ id: any, document_type: string, document_status: string, document_name: string | null, document_extension: string, document_flags: any, creation_date: any | null, sequence: number | null, meta: any, document_blobs: any, created_by_user: { display_name: string | null }, computedPagesM2M: Array<{ thumbnail_small_url: string | null, thumbnail_big_url: string | null, page_status: string | null, rotate: number | null, meta: any | null, id: any | null }> | null }> }> };

export type GetEmailsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEmailsQuery = { pp_email_search_hs: Array<{ id: any | null, name: string | null, meta: any | null, file_status: string | null, creation_user: any | null, creation_date: any | null, file_url: string | null, company: string | null, sender: string | null, total_rows: any | null, documents: Array<{ id: any, document_type: string, document_status: string, document_name: string | null, document_extension: string, document_flags: any, creation_date: any | null, sequence: number | null, meta: any, document_blobs: any, created_by_user: { display_name: string | null }, pages_m2m_aggregate: { aggregate: { count: number } | null } }> }> };

export type GetFileByIdentificationQueryVariables = Exact<{
  fileNumber: Scalars['String'];
}>;


export type GetFileByIdentificationQuery = { file: Array<{ id: any, file_status: string, identification: string | null, file_flags: any }> };

export type GetFilesForSubscriptionQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  currUserId?: InputMaybe<Scalars['uuid']>;
  orderBy?: InputMaybe<Scalars['String']>;
  fileFlags?: InputMaybe<Scalars['_int8']>;
  minDate?: InputMaybe<Scalars['timestamptz']>;
  maxDate?: InputMaybe<Scalars['timestamptz']>;
  search?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
  myFilesOnly?: InputMaybe<Scalars['Boolean']>;
  fileStatuses?: InputMaybe<Scalars['_text']>;
}>;


export type GetFilesForSubscriptionQuery = { files: Array<{ id: any, identification: string | null, name: string | null, org_id: any, org_id_description: string, meta: any, file_flags: any, file_status: string, creation_user: any, creation_date: any | null, last_modified_date: any | null, file_url: string | null, total_rows: any | null, customs_relevant: boolean | null, extraction_required: boolean | null }> };

export type Adit_Schedule_Data_ExtractionMutationVariables = Exact<{
  fileId: Scalars['ID'];
  drNo: Scalars['Int'];
}>;


export type Adit_Schedule_Data_ExtractionMutation = { scheduleAldiSrvProcessing: any | null };

export type AditUpdateFileNumberMutationVariables = Exact<{
  file_id: Scalars['ID'];
  file_number: Scalars['String'];
}>;


export type AditUpdateFileNumberMutation = { updateFileNumber: { file_id: string | null } | null };

export type Wd_Get_Import_List_TriggersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type Wd_Get_Import_List_TriggersQuery = { import_list_trigger: Array<{ id: number, display_name: string, type: string, config: any, creation_date: any, creation_user: any | null, last_modified_date: any | null, last_modified_user: any | null, meta: any, label_id: number | null, creationUser: { display_name: string | null } | null, lastModifiedUser: { display_name: string | null } | null, label: { id: number, title: any, description: string | null, color: string, is_deleted: boolean } | null }>, import_list_trigger_aggregate: { aggregate: { totalCount: number } | null } };

export type AditGetOrgIdsListQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AditGetOrgIdsListQuery = { orgIds: Array<{ orgId: number, orgIdDescription: string }> };

export type AditGetUserOrgIdsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetUserOrgIdsListQuery = { userOrgIds: Array<{ orgId: number, orgIdDescription: string }> };

export type OrgIdsListFragmentFragment = { orgId: number, orgIdDescription: string };

export type GetTenantAddressesListQueryVariables = Exact<{
  addressType: Scalars['Int'];
  tenantId?: InputMaybe<Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetTenantAddressesListQuery = { tenantAddresses: Array<{ id: number, companyName: string, country: string | null, city: string | null, street: string | null, streetNumber: string | null, zipcode: string | null, reference: string | null }> };

export type WdGetTenantsListQueryVariables = Exact<{ [key: string]: never; }>;


export type WdGetTenantsListQuery = { tenants: Array<{ id: any, tenant_name: string, permissions_js: any, address: { id: number, company_name: string, address_type: number | null } }> };

export type AditGetRolesListQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetRolesListQuery = { roles: Array<{ id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any }> };

export type WdGetRolesListQueryVariables = Exact<{ [key: string]: never; }>;


export type WdGetRolesListQuery = { roles: Array<{ id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any }> };

export type RolesListFragment = { id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any };

export type Update_Page_Extract_ValueMutationVariables = Exact<{
  value: Page_Extract_Append_Input;
  pageId: Scalars['uuid'];
  extract_type_id: Scalars['smallint'];
}>;


export type Update_Page_Extract_ValueMutation = { update_page_extract_by_pk: { value: any | null } | null };

export type Upsert_Page_Extract_ValueMutationVariables = Exact<{
  pageId: Scalars['uuid'];
  value: Scalars['jsonb'];
  extract_type_id: Scalars['smallint'];
}>;


export type Upsert_Page_Extract_ValueMutation = { insert_page_extract: { affected_rows: number, returning: Array<{ page_id: any }> } | null, update_page_extract_by_pk: { page_id: any } | null };

export type Update_Page_ClobMutationVariables = Exact<{
  pageId: Scalars['uuid'];
  dataPointId: Scalars['String'];
  extract_type_id: Scalars['smallint'];
}>;


export type Update_Page_ClobMutation = { update_page_extract: { returning: Array<{ page_id: any }> } | null };

export type Pp_Page_Extract_Text_Fragment_V2QueryVariables = Exact<{
  pageId: Scalars['uuid'];
  x: Scalars['numeric'];
  y: Scalars['numeric'];
  width: Scalars['numeric'];
  height: Scalars['numeric'];
  extract_type_id: Scalars['smallint'];
}>;


export type Pp_Page_Extract_Text_Fragment_V2Query = { pp_page_extract_text_fragment_v2: Array<{ json_value: any | null }> };

export type Delete_AddressMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type Delete_AddressMutation = { delete_address: { affected_rows: number } | null };

export type Delete_Org_IdQueryVariables = Exact<{
  org_id: Scalars['smallint'];
}>;


export type Delete_Org_IdQuery = { pp_org_id_delete: Array<{ json_value: any | null }> };

export type AditExportDeclarationMutationVariables = Exact<{
  fileId: Scalars['String'];
  drNo: Scalars['Float'];
}>;


export type AditExportDeclarationMutation = { exportDeclaration: boolean };

export type Adit_Get_Pp_AddressQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  address_types?: InputMaybe<Scalars['_int4']>;
}>;


export type Adit_Get_Pp_AddressQuery = { pp_addresses: Array<{ company_name: string, address_type: number | null, city: string | null, contact_email: string | null, contact_phone: string | null, contact_website: string | null, country: string | null, id: number, street: string | null, street_number: string | null, zipcode: string | null, reference: string | null, creation_date: any | null, creation_user: any, last_modified_date: any | null, last_modified_user: any | null, qty: any | null }> };

export type Get_Address_TypeQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Address_TypeQuery = { address_type: Array<{ id: number, name: string, translation: any }> };

export type GetAiStatsQueryVariables = Exact<{
  started?: InputMaybe<Scalars['timestamptz']>;
  ended?: InputMaybe<Scalars['timestamptz']>;
  onlyAiDoctypes?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Scalars['_uuid']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
}>;


export type GetAiStatsQuery = { pp_ai_stats: Array<{ document_type: string | null, success_ratio: any | null, total: any | null, types_match: any | null, unknowns: any | null, unknowns_pct: any | null }> };

export type GetAiStatsByDayQueryVariables = Exact<{
  started?: InputMaybe<Scalars['timestamptz']>;
  ended?: InputMaybe<Scalars['timestamptz']>;
  onlyAiDoctypes?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Scalars['_uuid']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
}>;


export type GetAiStatsByDayQuery = { pp_ai_stats_dt: Array<{ creation_date: any | null, docs_qty: any | null, document_type: string | null, pages_qty: any | null, success_ratio: any | null, types_match: any | null, unknowns: any | null, unknowns_pct: any | null }> };

export type Get_Api_KeysQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Api_KeysQuery = { accessTokens: Array<{ id: number, api_key: string, meta: any, display_name: string }> };

export type GetDeclarationWithDocumentsQueryVariables = Exact<{
  declarationId?: InputMaybe<Scalars['_uuid']>;
}>;


export type GetDeclarationWithDocumentsQuery = { declaration_request: Array<{ toll_dep: string | null, eta: any | null, file: { id: any, identification: string | null, documents: Array<{ id: any, meta: any, document_status: string, document_type: string, document_blobs: any, document_flags: any, name: string | null, pages: Array<{ page_number: any, page: { id: any, page_status: string, rotate: any, meta: any, creation_user: any, thumbnailBigUrl: string | null } | null }> }> }, declaration_discussions: Array<{ discussion_id: any, creation_user: any }>, payer: { id: any, tenantName: string }, declaration_request_addresses: Array<{ address_id: number | null, refs: any, address_type: number, address: { id: number, company_name: string, company_name_2: string | null, country: string | null, street: string | null, city: string | null, zipcode: string | null, reference: string | null, street_number: string | null, customs_account_number: string | null, is_locked: boolean | null, uid_number: string | null, usage_frequency: number | null, vat_account_number: string | null, trader_identification_number: string | null, is_platform_user: boolean } | null }>, declaration: { total_gross_weight: any | null, total_colis: number | null, customs_office_number: string | null } | null }> };

export type Adit_Get_Declaration_Tasks_V2QueryVariables = Exact<{
  assigned_to?: InputMaybe<Scalars['uuid']>;
  min_due_date?: InputMaybe<Scalars['timestamptz']>;
  max_due_date?: InputMaybe<Scalars['timestamptz']>;
  task_type_id?: InputMaybe<Scalars['Int']>;
  creation_date?: InputMaybe<Scalars['timestamptz']>;
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  task_status_id?: InputMaybe<Scalars['Int']>;
  orderby?: InputMaybe<Scalars['String']>;
}>;


export type Adit_Get_Declaration_Tasks_V2Query = { declaration_task: Array<{ id: number, title: string, assigned_to: any | null, creation_date: any, task_type_id: number, due_date: any | null, meta: any, object_id: any, task_status_id: number, rn: any | null, qty: any | null, assigned_user: { __typename: 'user_pp', id: any, display_name: string | null } | null, task_type: { __typename: 'task_type', display_name: string } | null, document: { __typename: 'document', document_flags: any, documentFile: { __typename: 'file', id: any, identification: string | null } | null, documentType: { __typename: 'document_type', translations: any } } | null, file: { __typename: 'file', id: any, identification: string | null } | null }> };

export type GetDocumentPagesQueryVariables = Exact<{
  documentId: Scalars['uuid'];
}>;


export type GetDocumentPagesQuery = { document: Array<{ pages: Array<{ page_number: any, page: { id: any, rotate: any, meta: any, thumbnailBigUrl: string | null, thumbnailSmallUrl: string | null } | null }> }> };

export type GetDocumentStatsQueryVariables = Exact<{
  started?: InputMaybe<Scalars['timestamptz']>;
  ended?: InputMaybe<Scalars['timestamptz']>;
  userIds?: InputMaybe<Scalars['_uuid']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
  tenant?: InputMaybe<Scalars['uuid']>;
}>;


export type GetDocumentStatsQuery = { pp_doc_stats: Array<{ docs_qty: any | null, document_type: string | null, total_pages: any | null, users_qty: any | null }> };

export type GetDocumentsQueryVariables = Exact<{
  ids?: InputMaybe<Scalars['_uuid']>;
}>;


export type GetDocumentsQuery = { documents: Array<{ id: any, meta: any, document_blobs: any, document_flags: any, name: string | null, pages: Array<{ page_number: any, page: { id: any, page_status: string, rotate: any, meta: any, creation_user: any, thumbnailBigUrl: string | null } | null }> }> };

export type GetFilesPagesQueryVariables = Exact<{
  fileNumber: Scalars['uuid'];
}>;


export type GetFilesPagesQuery = { files: Array<{ documents: Array<{ id: any, document_type: string, document_status: string, document_name: string | null, document_flags: any, last_modified_date: any | null, sequence: number | null, meta: any, document_blobs: any, created_by_user: { display_name: string | null }, documentType: { translations: any }, pages: Array<{ page_number: any, page: { id: any, rotate: any, page_status: string, meta: any, thumbnailBigUrl: string | null, thumbnailSmallUrl: string | null } | null }> }> }> };

export type GetFileStatsQueryVariables = Exact<{
  started?: InputMaybe<Scalars['timestamptz']>;
  ended?: InputMaybe<Scalars['timestamptz']>;
  userIds?: InputMaybe<Scalars['_uuid']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
}>;


export type GetFileStatsQuery = { pp_file_stats: Array<{ file_flags: string | null, file_flags_id: any | null, qty: any | null, users_qty: any | null }> };

export type GetFilesQueryVariables = Exact<{
  fileNumber?: InputMaybe<Scalars['String']>;
}>;


export type GetFilesQuery = { files: Array<{ id: any | null, identification: string | null, name: string | null, type: any | null, declarations: Array<{ file_id: any, dr_no: any }>, documents: Array<{ id: any, document_type: string, document_flags: any, document_blobs: any, document_name: string | null, sequence: number | null, documentType: { translations: any, document_type_tenant_settings: Array<{ meta: any | null }> }, pages: Array<{ page_number: any, page: { id: any, rotate: any, meta: any, thumbnailBigUrl: string | null } | null }> }> }> };

export type GetFilesForSubscriptionForAnnotationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  currUserId?: InputMaybe<Scalars['uuid']>;
  orderBy?: InputMaybe<Scalars['String']>;
  fileFlags?: InputMaybe<Scalars['_int8']>;
  minDate?: InputMaybe<Scalars['timestamptz']>;
  maxDate?: InputMaybe<Scalars['timestamptz']>;
  search?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Scalars['_int2']>;
  myFilesOnly?: InputMaybe<Scalars['Boolean']>;
  fileStatuses?: InputMaybe<Scalars['_text']>;
}>;


export type GetFilesForSubscriptionForAnnotationQuery = { files: Array<{ id: any, identification: string | null, name: string | null, org_id: any, org_id_description: string, meta: any, total_rows: any | null, customs_relevant: boolean | null, extraction_required: boolean | null, type: any, status: string, userId: any, creationDate: any | null, lastUpdate: any | null, fileUrl: string | null }> };

export type GetFileUpdatesSubscriptionForAnnotationSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type GetFileUpdatesSubscriptionForAnnotationSubscription = { pp_file_max_date_hs: Array<{ max_change_date: any | null }> };

export type Get_Full_File_HistoryQueryVariables = Exact<{
  fileId?: InputMaybe<Scalars['uuid']>;
  documentIds?: InputMaybe<Scalars['_uuid']>;
}>;


export type Get_Full_File_HistoryQuery = { file_history: Array<{ action_title: string | null, action_value: string | null, op_date: any, action_user: any | null, entityId: any }>, document_history: Array<{ action_title: string | null, action_value: string | null, op_date: any, action_user: any | null, entityId: any, document: { sequence: number | null, documentType: { translations: any } } | null }> };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { notifications: any | null };

export type Get_Org_IdsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['smallint']>;
}>;


export type Get_Org_IdsQuery = { org_ids: Array<{ org_id: any | null, display_name: string | null, org_id_description: string | null, qty: any | null, org_params: any | null, addresses_desc: string | null, org_ids_desc: string | null }> };

export type Get_Setting_ValueQueryVariables = Exact<{
  setting_id?: InputMaybe<Scalars['uuid']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  reference_id?: InputMaybe<Scalars['String']>;
}>;


export type Get_Setting_ValueQuery = { setting_value: Array<{ id: any, display_name: string, value: any | null, setting_id: any, is_template: boolean }> };

export type Get_Tenant_SettingQueryVariables = Exact<{
  tenantId: Scalars['ID'];
}>;


export type Get_Tenant_SettingQuery = { getTenantConfig: any | null };

export type Get_UsersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['uuid']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type Get_UsersQuery = { user_pp: Array<{ id: any, display_name: string | null, location: string | null, email: string | null, tenant_id: any }> };

export type Get_Validation_DocumentsQueryVariables = Exact<{
  id: Scalars['uuid'];
  extract_type_id?: InputMaybe<Scalars['smallint']>;
  tenantId: Scalars['uuid'];
}>;


export type Get_Validation_DocumentsQuery = { document: Array<{ id: any, meta: any, document_blobs: any, document_flags: any, document_type: string, name: string | null, annotationType: Array<{ annotation_schema: any | null }>, pages: Array<{ page: { id: any, page_status: string, rotate: any, meta: any, creation_user: any, thumbnailBigUrl: string | null, pageExtracts: Array<{ extract_type_id: any, dataPoints: any | null }> } | null }>, documentType: { translations: any, document_type_tenant_settings: Array<{ documentSchema: any | null }> } }> };

export type Insert_AddressMutationVariables = Exact<{
  objects: Array<Address_Insert_Input> | Address_Insert_Input;
}>;


export type Insert_AddressMutation = { insert_address: { affected_rows: number } | null };

export type Insert_Org_IdQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['smallint']>;
  display_name?: InputMaybe<Scalars['String']>;
  org_params?: InputMaybe<Scalars['json']>;
  org_id_description?: InputMaybe<Scalars['String']>;
}>;


export type Insert_Org_IdQuery = { pp_org_id_insert: Array<{ json_value: any | null }> };

export type Patch_Update_Tenant_SettingMutationVariables = Exact<{
  tenantId: Scalars['ID'];
  settings?: InputMaybe<Scalars['JSON']>;
}>;


export type Patch_Update_Tenant_SettingMutation = { patchTenantConfig: any | null };

export type Adit_Create_Declaration_MessageMutationVariables = Exact<{
  discussionId: Scalars['Int'];
  message: Scalars['String'];
  user: Scalars['ID'];
  source: Scalars['String'];
}>;


export type Adit_Create_Declaration_MessageMutation = { createDeclarationMessage: { affected_rows: number | null } | null };

export type Adit_Start_DiscussionMutationVariables = Exact<{
  fileId: Scalars['uuid'];
  theme: Scalars['String'];
  user: Scalars['uuid'];
}>;


export type Adit_Start_DiscussionMutation = { insert_declaration_discussion_one: { discussion_id: any, discussion_theme: string | null, file_id: any } | null };

export type AditSubscribeDeclarationChangesSubscriptionVariables = Exact<{
  discussionId: Scalars['bigint'];
}>;


export type AditSubscribeDeclarationChangesSubscription = { declaration_message: Array<{ creation_user: any, message: string, msg_date: any, read_date: any | null, type: string | null, user: { tenant_id: any, display_name: string | null, first_name: string | null, last_name: string | null, email: string | null, tenant: { tenant_name: string } } | null, declaration_discussion: { discussion_theme: string | null } }> };

export type AditSubscribeDiscussionChangesSubscriptionVariables = Exact<{
  user: Scalars['uuid'];
  date: Scalars['timestamptz'];
}>;


export type AditSubscribeDiscussionChangesSubscription = { discussion_changes: Array<{ file_name: string | null, liber_user: any | null, last_msg_date: any | null, file_id: any | null, discussion_theme: string | null, discussion_id: any | null, adit_user: any | null, reference: string | null }> };

export type Adit_Update_Declaration_Task_By_PkMutationVariables = Exact<{
  id: Scalars['Int'];
  _set?: InputMaybe<Declaration_Task_Set_Input>;
}>;


export type Adit_Update_Declaration_Task_By_PkMutation = { update_declaration_task_by_pk: { id: number } | null };

export type Update_Org_IdQueryVariables = Exact<{
  org_id?: InputMaybe<Scalars['smallint']>;
  display_name?: InputMaybe<Scalars['String']>;
  org_params?: InputMaybe<Scalars['json']>;
  org_id_description?: InputMaybe<Scalars['String']>;
}>;


export type Update_Org_IdQuery = { pp_org_id_update: Array<{ json_value: any | null }> };

export type ValidateFileNumberMutationVariables = Exact<{
  number: Scalars['String'];
}>;


export type ValidateFileNumberMutation = { validateFileNumber: { error_code: string | null, error_description: string | null, data: { orgId: string | null, shipmentNumber: string | null, traffic: string | null, lines: Array<{ grossWeight: string | null, packaging: string | null, quantity: string | null } | null> | null, consignee: { adrID: string | null, city: string | null, consigneeAdrID: string | null, country: string | null, name: string | null, postalCode: string | null, state: string | null, street: string | null } | null, shipper: { adrID: string | null, city: string | null, consigneeAdrID: string | null, country: string | null, name: string | null, postalCode: string | null, state: string | null, street: string | null } | null, orderedBy: { adrID: string | null, city: string | null, consigneeAdrID: string | null, country: string | null, name: string | null, postalCode: string | null, state: string | null, street: string | null } | null } | null } | null };

export type ValidateJourneyNumberMutationVariables = Exact<{
  number: Scalars['String'];
}>;


export type ValidateJourneyNumberMutation = { validateJourneyNumber: { error_code: string | null, error_description: string | null, data: any | null } | null };

export type Adit_Mark_Declaration_Discussion_As_ReadMutationVariables = Exact<{
  disc_id?: InputMaybe<Scalars['bigint']>;
  read_date: Scalars['timestamptz'];
}>;


export type Adit_Mark_Declaration_Discussion_As_ReadMutation = { update_declaration_message: { returning: Array<{ discussion_id: any }> } | null };

export type GetUsersOrgIdsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['_uuid']>;
}>;


export type GetUsersOrgIdsQuery = { orgIds: Array<{ org_id: any, orgId: { org_id: any, org_id_description: string, active: boolean | null } | null }> };

export type UpdateRotationMutationVariables = Exact<{
  objects: Array<Page_Insert_Input> | Page_Insert_Input;
}>;


export type UpdateRotationMutation = { insert_page: { affected_rows: number } | null };

export type TransmitFileMutationVariables = Exact<{
  data: TransmitFileInput;
}>;


export type TransmitFileMutation = { transmitFile: { success: boolean | null, error: string | null, fileIds: Array<string | null> | null } | null };

export type AditSearchAddressQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type AditSearchAddressQuery = { addresses: Array<{ id: number, company_name: string, street: string | null, street_number: string | null, country: string | null, zipcode: string | null, city: string | null, reference: string | null, customs_account_number: string | null, vat_account_number: string | null }> };

export type Adit_MarkDocumentAsTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  isTemplate?: InputMaybe<Scalars['Boolean']>;
}>;


export type Adit_MarkDocumentAsTemplateMutation = { markDocumentAsTemplate: any | null };

export type Adit_ScheduleTableCalculationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Adit_ScheduleTableCalculationMutation = { scheduleTableCalculation: any | null };

export type AditGetDeclarationsListQueryVariables = Exact<{
  _like?: InputMaybe<Scalars['String']>;
}>;


export type AditGetDeclarationsListQuery = { declarations: Array<{ file_id: any, dr_no: any, file: { identification: string | null } }> };

export type AditCopyDeclarationAndGoodsItemsMutationVariables = Exact<{
  sourceFileId: Scalars['String'];
  sourceDrNo: Scalars['Int'];
  targetFileId: Scalars['String'];
  targetDrNo: Scalars['Int'];
}>;


export type AditCopyDeclarationAndGoodsItemsMutation = { copyDeclarationAndGoodsItems: boolean };

export type Adit_Get_DocumentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type Adit_Get_DocumentQuery = { documents: Array<{ id: any, document_extension: string, document_name: string | null, creation_date: any | null, creation_user: any, org_id: any | null, document_status: string, document_flags: any, document_blobs: any, pages_m2m: Array<{ page: { id: any, thumbnail_small_url: string | null, thumbnail_big_url: string | null, page_status: string, rotate: any, meta: any } | null }>, orgId: { org_id_description: string } | null }> };

export type ScheduleFilesMutationVariables = Exact<{
  fileIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ScheduleFilesMutation = { scheduleFiles: any | null };

export type Append_Meta_DocumentMutationVariables = Exact<{
  id: Array<Scalars['uuid']> | Scalars['uuid'];
  meta?: InputMaybe<Scalars['jsonb']>;
}>;


export type Append_Meta_DocumentMutation = { update_document: { affected_rows: number } | null };

export type AditGetDeclarationDocumentsTableQueryVariables = Exact<{
  fileId?: InputMaybe<Scalars['UUID']>;
  documentStatus?: InputMaybe<Array<DocumentStatus> | DocumentStatus>;
}>;


export type AditGetDeclarationDocumentsTableQuery = { documents: Array<{ creationUser: string | null, documentExtension: string, documentFlags: number, documentName: string, documentStatus: string, documentType: string, documentTypeTranslations: any | null, id: any, lastModifiedDate: any | null, meta: any | null, sequence: number | null, pages: Array<{ creationDate: any | null, creationUser: any, id: any, lastModifiedDate: any | null, lastModifiedUser: any | null, meta: any, ocrText: string | null, pageNumber: number | null, pageStatus: string, rotate: number, thumbnailBigUrl: string | null, thumbnailSmallUrl: string | null }>, blobs: Array<{ url: string, initial: boolean, extension: string }> | null }> };

export type AditGetDeclarationTableDiscussionsSubscriptionVariables = Exact<{
  fileIds: Array<Scalars['uuid']> | Scalars['uuid'];
}>;


export type AditGetDeclarationTableDiscussionsSubscription = { declarationsDiscussions: Array<{ file_id: any, messages: { aggregate: { count: number } | null } }> };

export type AditGetDeclarationsTableQueryVariables = Exact<{
  nonclassifiedDocsExists?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<Scalars['JSONObject']> | Scalars['JSONObject']>;
  declarationStatus?: InputMaybe<Array<DeclarationStatus> | DeclarationStatus>;
  search?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<AddressFilter> | AddressFilter>;
  dateMin?: InputMaybe<Scalars['LocalDateTime']>;
  dateMax?: InputMaybe<Scalars['LocalDateTime']>;
  maxTotalColis?: InputMaybe<Scalars['Int']>;
  maxTotalGrossWeight?: InputMaybe<Scalars['Float']>;
  minTotalColis?: InputMaybe<Scalars['Int']>;
  minTotalGrossWeight?: InputMaybe<Scalars['Float']>;
  orgIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type AditGetDeclarationsTableQuery = { declarations: Array<{ consigneeName: string | null, autoclassifiedDocsQty: number, consigneeRef: string | null, consignorName: string | null, consignorRef: string | null, creationDate: any | null, creationUser: string | null, customsOfficeNumber: string | null, declarationStatus: DeclarationStatus, drNo: number, evvReceived: boolean | null, fileId: string, identification: string | null, importerRef: string | null, messageCount: number, nonclassifiedDocsExists: number, payerName: string | null, payerRef: string | null, totalColis: number | null, totalGrossWeight: number | null, discussionId: number | null, orgId: number | null, addressReferences: string | null }> };

export type UpdateSettingValueByIdMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateSettingValueByIdMutation = { update_setting_value: { returning: Array<{ id: any, value: any | null, display_name: string }> } | null };

export type UpdateSettingValueMutationVariables = Exact<{
  reference_id?: InputMaybe<Scalars['String']>;
  reference_type_id?: InputMaybe<Scalars['String']>;
  setting_id?: InputMaybe<Scalars['uuid']>;
  value?: InputMaybe<Scalars['jsonb']>;
  is_template?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateSettingValueMutation = { update_setting_value: { returning: Array<{ id: any, value: any | null, display_name: string }> } | null };

export type CreateSettingValueMutationVariables = Exact<{
  setting_value: Array<Setting_Value_Insert_Input> | Setting_Value_Insert_Input;
}>;


export type CreateSettingValueMutation = { insert_setting_value: { returning: Array<{ id: any, display_name: string, value: any | null }> } | null };

export type DeleteSettingValueMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteSettingValueMutation = { delete_setting_value: { returning: Array<{ id: any }> } | null };

export type AditUpdatePasswordMutationVariables = Exact<{
  updatePasswordInput: UpdatePasswordDto;
}>;


export type AditUpdatePasswordMutation = { updatePassword: boolean };

export type ToggleAiConfirmedMutationVariables = Exact<{
  file_id: Scalars['uuid'];
  dr_no: Scalars['smallint'];
  value: Scalars['Boolean'];
}>;


export type ToggleAiConfirmedMutation = { update_declaration: { affected_rows: number } | null };

export type UpdateAiIgnoreRetrainingMutationVariables = Exact<{
  id: Scalars['uuid'];
  value: Scalars['Boolean'];
}>;


export type UpdateAiIgnoreRetrainingMutation = { update_page_by_pk: { id: any, ai_ignore_retraining: boolean | null } | null };

export type AditGetAiConfirmedDeclarationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetAiConfirmedDeclarationsQuery = { declarations: Array<{ file_id: any, dr_no: any, ai_confirmed: boolean | null, file: { identification: string | null }, declaration_request: { payer: { tenant_name: string }, declaration_request_addresses: Array<{ address: { company_name: string } | null }>, documents: Array<{ id: any, document_type: string, document_extension: string, pages_m2m: Array<{ page_number: any, page: { id: any, thumbnail_big_url: string | null, ai_ignore_retraining: boolean | null, rotate: any } | null }> }> } | null }> };

export type AditGetModelRetrainsQueryVariables = Exact<{ [key: string]: never; }>;


export type AditGetModelRetrainsQuery = { model_retrains: Array<{ id: number, request_time: any | null, status: string | null, start_time: any | null, end_time: any | null, error_message: string | null }> };

export type AditTriggerModelRetrainingMutationVariables = Exact<{
  requestTime: Scalars['timestamptz'];
}>;


export type AditTriggerModelRetrainingMutation = { insert_model_retrain_one: { id: number } | null };

export type AditGetTenantDocumentTypesTableQueryVariables = Exact<{
  tenantId: Scalars['uuid'];
  where: Document_Type_Bool_Exp;
}>;


export type AditGetTenantDocumentTypesTableQuery = { document_type: Array<{ name: string, display_name: string | null, translations: any, document_type_tenant_settings: Array<{ tenant: any, code: string | null, default_flags: any | null, meta: any | null, creation_date: any | null, creation_user: any | null, last_modified_date: any | null, last_modified_user: any | null }> }>, document_flag: Array<{ id: any, name: string, translation: any, color: string | null }> };

export type Adit_Upsert_Document_Type_Tenant_SettingMutationVariables = Exact<{
  document_type_tenant_setting: Document_Type_Tenant_Settings_Insert_Input;
}>;


export type Adit_Upsert_Document_Type_Tenant_SettingMutation = { insert_document_type_tenant_settings: { affected_rows: number } | null };

export type AditCreatTenantUserMutationVariables = Exact<{
  object: AditUserDto;
}>;


export type AditCreatTenantUserMutation = { createAditUser: boolean };

export type AditDeleteTenantUserMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type AditDeleteTenantUserMutation = { removeUser: boolean };

export type AditGetTenantUsersTableQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<Scalars['UUID']>;
}>;


export type AditGetTenantUsersTableQuery = { users: Array<{ id: string, tenantId: any, firstName: string | null, lastName: string | null, displayName: string | null, email: string, location: string | null, isEnabled: boolean, externalAuthProvider: boolean, creationDate: any | null, lastModifiedDate: any | null, orgIds: Array<{ orgId: number, orgIdDescription: string }>, roles: Array<{ id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any }> }> };

export type AditSendResetPasswordLinkMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type AditSendResetPasswordLinkMutation = { sendAditResetPasswordLink: boolean };

export type AditUpdateTenantUserMutationVariables = Exact<{
  object: AditUserDto;
}>;


export type AditUpdateTenantUserMutation = { updateAditUser: boolean };

export type AditCreateTenantMutationVariables = Exact<{
  addressId: Scalars['Int'];
  externalTenantId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  tenantName: Scalars['String'];
}>;


export type AditCreateTenantMutation = { createTenantACS: boolean };

export type AditUpdateTenantMutationVariables = Exact<{
  tenantId: Scalars['String'];
  addressId: Scalars['Int'];
  externalTenantId?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  tenantName: Scalars['String'];
}>;


export type AditUpdateTenantMutation = { editTenantACS: boolean };

export type AditGetTenantsTableQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type AditGetTenantsTableQuery = { tenants: Array<{ accountNumber: string | null, addressId: number, creationDate: any | null, externalTenantId: string | null, id: any, isWdCustomer: boolean, lastModifiedDate: any | null, permissions: string | null, tenantName: string, tenantType: TenantType, traderIdentificationNumber: string | null, address: { id: number, companyName: string, companyName2: string | null, country: string | null, city: string | null, street: string | null, zipcode: string | null, usageFrequency: number, customsAccountNumber: string | null, traderIdentificationNumber: string | null, vatAccountNumber: string | null, uidNumber: string | null, isLocked: boolean, reference: string | null, isPlatformUser: boolean }, roles: Array<{ id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any }> | null }> };

export type WeDeclareSubscribeDiscussionChangesSubscriptionVariables = Exact<{
  user: Scalars['uuid'];
  date: Scalars['timestamptz'];
}>;


export type WeDeclareSubscribeDiscussionChangesSubscription = { discussion_changes: Array<{ file_name: string | null, liber_user: any | null, last_msg_date: any | null, file_id: any | null, discussion_theme: string | null, discussion_id: any | null, adit_user: any | null, reference: string | null }> };

export type WdGetAddressesManagementQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  address_types?: InputMaybe<Scalars['_int4']>;
}>;


export type WdGetAddressesManagementQuery = { pp_addresses: Array<{ address_types: any | null, city: string | null, country: string | null, id: number, ao_id: number | null, street: string | null, zipcode: string | null, qty: any | null, street_number: string | null, source: string | null, reference: string | null, companyName: string, creationDate: any | null, streetNumber: string | null, aoId: number | null }> };

export type WdGetLinkedAddressesManagementQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type WdGetLinkedAddressesManagementQuery = { linkedAddresses: Array<{ qty: number, sourceAddress: { id: number, aoId: number | null, companyName: string, street: string | null, streetNumber: string | null, zipcode: string | null, city: string | null, country: string | null }, targetAddress: { id: number, companyName: string, street: string | null, streetNumber: string | null, zipcode: string | null, city: string | null, country: string | null } }> };

export type WdUnlinkAddressMutationVariables = Exact<{
  sourceAddressId: Scalars['Int'];
}>;


export type WdUnlinkAddressMutation = { unlinkAddressACS: boolean };

export type WdGetBordereausQueryVariables = Exact<{
  args?: InputMaybe<BordereauArgs>;
}>;


export type WdGetBordereausQuery = { getBordereaus: { bordereausCount: number | null, bordereaus: Array<{ documentNumber: string, documentTitle: string | null, documentDate: any | null, documentTime: any | null, accountNumber: string | null, status: boolean | null, duties: number | null, vat: number | null, numberOfDocuments: number | null, amount: number | null, consignee: string | null, bordereauXmlDoc: { document_blobs: any | null } | null, bordereauPdfDoc: { document_blobs: any | null } | null, bordereauItems: Array<{ id: number, customsReference: string, documentTypeAbbreviation: string | null, traderReference: string | null, customsDeclarationVersion: number | null, status: boolean | null, amount: number | null, drNo: number | null, customOffice: { name: string | null, officeNumber: string } | null, documentTypeNameTranslations: { de: string | null, en: string | null } | null, file: { id: any } | null } | null> | null } | null> | null } | null };

export type WdGetDeclarationTableDiscussionsSubscriptionVariables = Exact<{
  fileIds: Array<Scalars['uuid']> | Scalars['uuid'];
  tenantId: Scalars['uuid'];
}>;


export type WdGetDeclarationTableDiscussionsSubscription = { declarationsDiscussions: Array<{ file_id: any, messages: { aggregate: { count: number } | null } }> };

export type WdGetDeclarationsDashboardQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  min_date?: InputMaybe<Scalars['LocalDateTime']>;
  max_date?: InputMaybe<Scalars['LocalDateTime']>;
  search?: InputMaybe<Scalars['String']>;
  declaration_statuses?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<AddressFilter> | AddressFilter>;
  declaration_type?: InputMaybe<Scalars['String']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  orderby?: InputMaybe<Array<Scalars['JSONObject']> | Scalars['JSONObject']>;
  payer?: InputMaybe<Scalars['UUID']>;
  evv_status?: InputMaybe<Scalars['String']>;
  declaration_labels?: InputMaybe<Scalars['String']>;
}>;


export type WdGetDeclarationsDashboardQuery = { pp_declaration_requests: Array<{ addressReferences: string | null, fileId: string, drNo: number, declarationStatus: DeclarationStatus, searchReferences: string | null, declarationRequest: { arrivalTime: any | null, arrivalType: ArrivalType | null, clearanceType: string, creationDate: any, acceptanceDate: any | null, creationUser: string, declarationType: string, drNo: number, eta: any | null, fileId: string, meta: any, waNumber: string | null }, declarationLabels: Array<{ id: number, title: any | null, description: string | null, color: string, isDeleted: boolean | null }>, file: { identification: string | null, isDeleted: boolean | null }, customsOffice: { name: string | null, number: string | null } | null, declaration: { acceptanceDate: any | null, customsDeclarationNumber: string | null, customsDeclarationVersion: number | null, evvReceived: boolean, customsOfficeNumber: string | null, declarationType: string | null, borderEauNumber: number | null }, addresses: Array<{ addressTypeId: number | null, companyName: string }> | null, payer: { address: { id: number, companyName: string } }, userPp: { displayName: string | null, email: string } | null }> | null };

export type WdGetDocumentsQueryVariables = Exact<{
  file_id?: InputMaybe<Scalars['uuid']>;
}>;


export type WdGetDocumentsQuery = { documents: Array<{ id: any, document_type: string, creation_date: any | null, document_blobs: any, document_extension: string, documentType: { translations: any } }> };

export type Get_Document_TypesQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Document_TypesQuery = { document_types: Array<{ name: string, display_name: string | null, translations: any, lastModifiedDate: any | null }> };

export type Classify_We_Declare_DocumentMutationVariables = Exact<{
  document_type: Scalars['String'];
  doc_id: Scalars['ID'];
}>;


export type Classify_We_Declare_DocumentMutation = { classifyWeDeclareDocument: any | null };

export type Delete_DocumentMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type Delete_DocumentMutation = { update_document: { affected_rows: number } | null };

export type Delete_Document_And_Update_Dec_StatusMutationVariables = Exact<{
  id: Scalars['uuid'];
  fileId: Scalars['uuid'];
}>;


export type Delete_Document_And_Update_Dec_StatusMutation = { update_document: { affected_rows: number } | null, update_declaration_request: { affected_rows: number } | null };

export type Get_Declaration_Request_DocumentsQueryVariables = Exact<{
  declarationId: Scalars['uuid'];
}>;


export type Get_Declaration_Request_DocumentsQuery = { declaration_request: Array<{ file: { documents: Array<{ id: any, document_type: string, is_generated: boolean, is_deleted: boolean }> } }> };

export type WdMarkDeclarationMessagesAsReadMutationVariables = Exact<{
  disc_id?: InputMaybe<Scalars['bigint']>;
  read_date: Scalars['timestamptz'];
  tenant_id: Scalars['uuid'];
}>;


export type WdMarkDeclarationMessagesAsReadMutation = { update_declaration_message: { returning: Array<{ discussion_id: any }> } | null };

export type We_Declare_Create_Declaration_MessageMutationVariables = Exact<{
  discussionId: Scalars['Int'];
  message: Scalars['String'];
  user: Scalars['ID'];
  source: Scalars['String'];
  messageType: Scalars['String'];
}>;


export type We_Declare_Create_Declaration_MessageMutation = { createDeclarationMessage: { affected_rows: number | null } | null };

export type We_Declare_Start_DiscussionMutationVariables = Exact<{
  fileId: Scalars['uuid'];
  theme: Scalars['String'];
  user: Scalars['uuid'];
}>;


export type We_Declare_Start_DiscussionMutation = { insert_declaration_discussion_one: { discussion_id: any, discussion_theme: string | null, file_id: any } | null };

export type SubscribeDeclarationDiscussionsSubscriptionVariables = Exact<{
  file_id?: InputMaybe<Scalars['uuid']>;
}>;


export type SubscribeDeclarationDiscussionsSubscription = { declaration_discussion: Array<{ discussion_id: any, discussion_theme: string | null, declaration_messages: Array<{ creation_user: any, message: string, msg_date: any, read_date: any | null, type: string | null, user: { tenant_id: any, display_name: string | null, first_name: string | null, last_name: string | null, email: string | null, tenant: { tenant_name: string } } | null }> }> };

export type WdGetDeclarationDetailsQueryVariables = Exact<{
  file_id: Scalars['UUID'];
}>;


export type WdGetDeclarationDetailsQuery = { pp_declaration_requests: Array<{ fileId: string, drNo: number, declarationStatus: DeclarationStatus, addressReferences: string | null, declarationLabels: Array<{ id: number, title: any | null, description: string | null, color: string, isDeleted: boolean | null }>, declarationRequest: { fileId: string, drNo: number, trNo: string | null, chExpDecl: boolean | null, impCustClr: boolean | null, transitdocType: string | null, destTolldeptCode: string | null, destTolldeptName: string | null, isExpress: boolean, declarationType: string, creationUser: string, creationDate: any, clearanceType: string, arrivalTime: any | null, arrivalType: ArrivalType | null, eta: any | null, waNumber: string | null, meta: any }, customsOffice: { name: string | null, number: string | null } | null, addresses: Array<{ id: number, addressTypeId: number | null, companyName: string, country: string | null, city: string | null, street: string | null, streetNumber: string | null, zipcode: string | null, reference: string | null, drReference: string | null }> | null, userPp: { displayName: string | null, phoneNumber: string | null, email: string } | null, file: { identification: string | null, meta: any | null }, declaration: { acceptanceDate: any | null, customsDeclarationNumber: string | null, customsDeclarationVersion: number | null, customsOfficeNumber: string | null, requestorTraderIdentificationNumber: string | null, release: boolean | null, status: number | null, statusTime: string | null, statusDate: any | null, materialCheck: boolean | null, traderDeclarationNumber: string | null, traderReference: string | null, totalGoodsItems: number | null, vatSuffix: boolean | null, placeOfUnloading: string | null, totalVatValue: number | null, dutyTotalAmount: number | null, dutyAndOtherTaxesAmount: number | null, transportMode: number | null, transportNumber: string | null, transportType: string | null, transportCountry: string | null, customsAccountName: string | null, customsAccountNumber: number | null, incoterms: string | null, invoiceCurrencyType: string | null, vatAccountName: string | null, vatAccountNumber: number | null, vatTotalAmount: number | null, vatNumber: string | null, dispatchCountry: string | null, packagingQuantity: number | null, grossMass: number | null, evvReceived: boolean, specialMention: Array<{ id: string, text: string }> | null, previousDocument: Array<{ id: string, previousDocumentType: string | null, previousDocumentReference: string | null }> | null }, payer: { id: any, address: { id: number } } }> | null };

export type WdGetDeclarationDetailsDocumentsQueryVariables = Exact<{
  file: Scalars['UUID'];
}>;


export type WdGetDeclarationDetailsDocumentsQuery = { documents: Array<{ id: any, document_name: string | null, document_type: string, document_blobs: any | null, document_extension: string, is_deleted: boolean, number_of_pages: number | null, document_flags: any, last_modified_date: any | null, sequence: number | null, document_version: number, documentType: { name: string, translations: any | null } | null, pages_m2m: Array<{ pageNumber: number, page: { id: any, rotate: number, thumbnailBigUrl: string | null, thumbnailSmallUrl: string | null, pageStatus: string } } | null> | null, customs_response_data: { document_version: number } | null }> | null };

export type WdGetDocumentUpdatesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type WdGetDocumentUpdatesSubscription = { pp_doc_max_date_hs: Array<{ max_change_date: any | null }> };

export type WdGetDeclarationDetailsGoodsItemsQueryVariables = Exact<{
  where?: InputMaybe<Goods_Item_Bool_Exp>;
}>;


export type WdGetDeclarationDetailsGoodsItemsQuery = { goodsItems: Array<{ customs_item_number: number, commodity_code: string | null, description: string | null, additional_unit: string | null, net_mass: any | null, gross_mass: any | null, vat_value: any | null, vat_total: any | null, duty_total: any | null, commercial_good: boolean | null, clearance_type: number | null, origin_preference: boolean | null, origin_country: string | null, repair: boolean | null, repair_reason: string | null, statistical_code: number | null, statistical_value: number | null, vat_rate: any | null, duty_rate: any | null, permit_obligation_code: number | null, selection_result: number | null, duty_and_other_taxes_total: any | null, packagings: Array<{ packaging_type: string | null, packaging_quantity: number | null, packaging_reference_number: string | null }>, produced_documents: Array<{ produced_document_type: string | null, produced_document_reference_number: string | null, produced_document_issue_date: any | null }>, goods_item_special_mentions: Array<{ text: string | null }>, permits: Array<{ permit_type: number | null, permit_authority: number | null, permit_number: string | null }> }> };

export type WdAddNotificationTriggerMutationVariables = Exact<{
  data: NotificationTriggerInput;
}>;


export type WdAddNotificationTriggerMutation = { addNotificationTrigger: { id: number, type: string, config: any | null, creationDate: any | null, lastModifiedDate: any | null, meta: any | null, creationUser: { id: string }, lastModifiedUser: { id: string } | null } | null };

export type WdDeleteNotificationTriggerMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type WdDeleteNotificationTriggerMutation = { deleteNotificationTrigger: { id: number } | null };

export type WdGetImportListTriggersQueryVariables = Exact<{ [key: string]: never; }>;


export type WdGetImportListTriggersQuery = { import_list_triggers: Array<{ id: number, display_name: string, type: string, config: any, creation_date: any, creation_user: any | null, last_modified_date: any | null, last_modified_user: any | null, meta: any, label_id: number | null, creationUser: { display_name: string | null } | null, lastModifiedUser: { display_name: string | null } | null, label: { id: number, title: any, description: string | null, color: string, is_deleted: boolean } | null }> };

export type WdUpdateNotificationTriggerMutationVariables = Exact<{
  id: Scalars['Int'];
  data: NotificationTriggerInput;
}>;


export type WdUpdateNotificationTriggerMutation = { updateNotificationTrigger: { id: number, displayName: string, type: string, config: any | null, creationDate: any | null, lastModifiedDate: any | null, meta: any | null, creationUser: { id: string }, lastModifiedUser: { id: string } | null } | null };

export type WdGetKpiQueryVariables = Exact<{
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  interval: Scalars['String'];
  tenant_id?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
}>;


export type WdGetKpiQuery = { kpis: { avgCommodityCodesPerDeclaration: number, customsDeclarations: { tickInterval: string, dateInterval: Array<{ date: string, count: number, lastYearCount: number }> }, commodityCodesChapters: Array<{ chapter: string, heading: string, subheading: string, tariffNumber: string, totalNetMass: number, totalGrossMass: number, declarationCount: number, goodsItemCount: number }>, customsAgencies: Array<{ label: string, count: number, percentage: number, traderIdentificationNumber: string }> } | null };

export type WdGetKpiCommodityCodeQueryVariables = Exact<{
  date_from: Scalars['String'];
  date_to: Scalars['String'];
  commodity_code?: InputMaybe<Scalars['String']>;
  tenant_id?: InputMaybe<Scalars['String']>;
  trader_identification_number?: InputMaybe<Scalars['String']>;
}>;


export type WdGetKpiCommodityCodeQuery = { pp_get_kpi_commodity_code: { declarationCount: number, goodsItemCount: number, totalNetMass: number, totalGrossMass: number } | null };

export type WdUpdateMyProfileMutationVariables = Exact<{
  id: Scalars['uuid'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type WdUpdateMyProfileMutation = { update_user_pp_by_pk: { id: any } | null };

export type WdGetDeclarationsGoodsItemsStatisticsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  min_date?: InputMaybe<Scalars['LocalDateTime']>;
  max_date?: InputMaybe<Scalars['LocalDateTime']>;
  search?: InputMaybe<Scalars['String']>;
  search_field?: InputMaybe<Scalars['String']>;
  declaration_statuses?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<AddressFilter> | AddressFilter>;
  declaration_type?: InputMaybe<Scalars['String']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  orderby?: InputMaybe<Array<Scalars['JSONObject']> | Scalars['JSONObject']>;
  payer?: InputMaybe<Scalars['UUID']>;
  evv_status?: InputMaybe<Scalars['String']>;
  declaration_labels?: InputMaybe<Scalars['String']>;
}>;


export type WdGetDeclarationsGoodsItemsStatisticsQuery = { acs_goods_items_for_drs: Array<{ refs: string | null, fileId: any, drNo: number, myDuties: number | null, identification: string | null, customsItemNumber: number, declarationStatus: DeclarationStatus, declarationLabels: Array<{ id: number } | null> | null, addresses: Array<{ addressTypeId: number | null, country: string | null, companyName: string, city: string | null, street: string | null, vatNumber: string | null, zipcode: string | null }> | null, declarationSpecialMentions: Array<{ text: string }> | null, previousDocuments: Array<{ id: string, previousDocumentType: string | null, previousDocumentReference: string | null }> | null, customsOffice: { number: string | null, name: string | null } | null, declaration: { customsDeclarationNumber: string | null, customsDeclarationVersion: number | null, incoterms: string | null, invoiceCurrencyType: string | null, declarationType: string | null, dutyTotalAmount: number | null, requestorTraderIdentificationNumber: string | null, traderDeclarationNumber: string | null, traderReference: string | null, totalGoodsItems: number | null, vatNumber: string | null, vatSuffix: boolean | null, placeOfUnloading: string | null, dispatchCountry: string | null, packagingQuantity: number | null, grossMass: number | null, totalVatValue: number | null, customsAccountNumber: number | null, customsAccountName: string | null, vatAccountNumber: number | null, vatAccountName: string | null, transportMode: number | null, transportType: string | null, transportCountry: string | null, transportNumber: string | null, dutyAndOtherTaxesAmount: number | null, status: number | null, serviceType: string | null, release: boolean | null, statusDate: any | null, statusTime: string | null, materialCheck: boolean | null, vatTotalAmount: number | null } | null, userPp: { firstName: string | null, email: string } | null, declarationRequest: { fileId: string, drNo: number, creationDate: any, eta: any | null, arrivalTime: any | null, meta: any, creationUser: string, acceptanceDate: any | null, declarationType: string, arrivalType: ArrivalType | null, clearanceType: string }, producedDocuments: Array<{ id: string, producedDocumentType: string | null, producedDocumentReferenceNumber: string | null, producedDocumentIssueDate: any | null }> | null, permits: Array<{ id: string, permitType: number | null, permitAuthority: number | null, permitNumber: string | null }> | null, packagings: Array<{ id: number, packagingType: string | null, packagingQuantity: number | null, packagingReferenceNumber: string | null }> | null, goodsItemSpecialMentions: Array<{ text: string | null }> | null, goodsItems: { netMass: number | null, grossMass: number | null, description: string | null, commodityCode: string | null, fileId: any, vatValue: number | null, originCountry: string | null, drNo: number, dutyTotal: number | null, customsItemNumber: number, commercialGood: boolean | null, clearanceType: number | null, originPreference: boolean | null, repair: boolean | null, repairReason: string | null, additionalUnit: string | null, statisticalCode: number | null, statisticalValue: number | null, vatRate: number | null, vatTotal: number | null, dutyRate: number | null, permitObligationCode: number | null, selectionResult: number | null, dutyAndOtherTaxesTotal: number | null } | null } | null> | null };

export type WdGetDeclarationsGoodsItemsStatisticsCountQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  min_date?: InputMaybe<Scalars['LocalDateTime']>;
  max_date?: InputMaybe<Scalars['LocalDateTime']>;
  search?: InputMaybe<Scalars['String']>;
  search_field?: InputMaybe<Scalars['String']>;
  declaration_statuses?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<AddressFilter> | AddressFilter>;
  declaration_type?: InputMaybe<Scalars['String']>;
  clearance_type?: InputMaybe<Scalars['String']>;
  arrival_type?: InputMaybe<Scalars['String']>;
  payer?: InputMaybe<Scalars['UUID']>;
  evv_status?: InputMaybe<Scalars['String']>;
  declaration_labels?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['UUID']>;
}>;


export type WdGetDeclarationsGoodsItemsStatisticsCountQuery = { acs_goods_items_for_drs_count: { resultSetCount: number | null } | null };

export type WdCreateUserMutationVariables = Exact<{
  object: WdCreateUserDto;
}>;


export type WdCreateUserMutation = { createUser: boolean };

export type WdGetUsersManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type WdGetUsersManagementQuery = { users: Array<{ isEnabled: boolean, externalAuthProvider: boolean, id: string, tenantId: any, firstName: string | null, lastName: string | null, displayName: string | null, email: string, location: string | null, creationDate: any | null, lastModifiedDate: any | null, roles: Array<{ id: number, name: string, isWdRelevant: boolean | null, description: string | null, translations: any }> }> };

export type WdSendResetPasswordLinkMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type WdSendResetPasswordLinkMutation = { sendResetPasswordLink: boolean };

export type WdUpdateUserMutationVariables = Exact<{
  object: WdUpdateUserDto;
}>;


export type WdUpdateUserMutation = { updateWDUser: boolean };

export type GetSasTokenQueryVariables = Exact<{
  container: Scalars['String'];
  contentType?: InputMaybe<Scalars['String']>;
  contentDisposition?: InputMaybe<Scalars['String']>;
}>;


export type GetSasTokenQuery = { getSASToken: { container: string | null, sasToken: string | null, expiryDate: string | null } | null };

export const AdiAddressesListFragmentFragmentDoc = gql`
    fragment AdiAddressesListFragment on AddressACS {
  id
  companyName
  companyName2
  country
  city
  street
  zipcode
  usageFrequency
  customsAccountNumber
  traderIdentificationNumber
  vatAccountNumber
  uidNumber
  isLocked
  reference
  isPlatformUser
}
    `;
export const OrgIdsListFragmentFragmentDoc = gql`
    fragment OrgIdsListFragment on OrgIdEntity {
  orgId
  orgIdDescription
}
    `;
export const RolesListFragmentDoc = gql`
    fragment RolesList on Role {
  id
  name
  isWdRelevant
  description
  translations
}
    `;
export const ClearDocumentChecksumDocument = gql`
    mutation clearDocumentChecksum($checksums: [String!]!) {
  update_document(where: {checksum: {_in: $checksums}, document_type: {_eq: "unknown"}}, _set: {checksum: null}) {
    affected_rows
  }
}
    `;
export type ClearDocumentChecksumMutationFn = Apollo.MutationFunction<ClearDocumentChecksumMutation, ClearDocumentChecksumMutationVariables>;

/**
 * __useClearDocumentChecksumMutation__
 *
 * To run a mutation, you first call `useClearDocumentChecksumMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearDocumentChecksumMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearDocumentChecksumMutation, { data, loading, error }] = useClearDocumentChecksumMutation({
 *   variables: {
 *      checksums: // value for 'checksums'
 *   },
 * });
 */
export function useClearDocumentChecksumMutation(baseOptions?: Apollo.MutationHookOptions<ClearDocumentChecksumMutation, ClearDocumentChecksumMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearDocumentChecksumMutation, ClearDocumentChecksumMutationVariables>(ClearDocumentChecksumDocument, options);
      }
export type ClearDocumentChecksumMutationHookResult = ReturnType<typeof useClearDocumentChecksumMutation>;
export type ClearDocumentChecksumMutationResult = Apollo.MutationResult<ClearDocumentChecksumMutation>;
export type ClearDocumentChecksumMutationOptions = Apollo.BaseMutationOptions<ClearDocumentChecksumMutation, ClearDocumentChecksumMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation createDocument($document: CreateDocumentInput!) {
  createDocument(document: $document) {
    success
    error
    documentId
  }
}
    `;
export type CreateDocumentMutationFn = Apollo.MutationFunction<CreateDocumentMutation, CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      document: // value for 'document'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const GetDocumentsByChecksumDocument = gql`
    query getDocumentsByChecksum($checksums: [String!]!) {
  documents: document(where: {_and: [{checksum: {_in: $checksums}}, {document_type: {_eq: "unknown"}}]}) {
    id
    document_name
    checksum
  }
}
    `;

/**
 * __useGetDocumentsByChecksumQuery__
 *
 * To run a query within a React component, call `useGetDocumentsByChecksumQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsByChecksumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsByChecksumQuery({
 *   variables: {
 *      checksums: // value for 'checksums'
 *   },
 * });
 */
export function useGetDocumentsByChecksumQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsByChecksumQuery, GetDocumentsByChecksumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsByChecksumQuery, GetDocumentsByChecksumQueryVariables>(GetDocumentsByChecksumDocument, options);
      }
export function useGetDocumentsByChecksumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsByChecksumQuery, GetDocumentsByChecksumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsByChecksumQuery, GetDocumentsByChecksumQueryVariables>(GetDocumentsByChecksumDocument, options);
        }
export type GetDocumentsByChecksumQueryHookResult = ReturnType<typeof useGetDocumentsByChecksumQuery>;
export type GetDocumentsByChecksumLazyQueryHookResult = ReturnType<typeof useGetDocumentsByChecksumLazyQuery>;
export type GetDocumentsByChecksumQueryResult = Apollo.QueryResult<GetDocumentsByChecksumQuery, GetDocumentsByChecksumQueryVariables>;
export const GetCurrentUserDocument = gql`
    query getCurrentUser {
  user: getCurrentUser {
    permissionsDesk
    userId: id
    firstName
    lastName
    email
    phoneNumber
    uiSettings
    uiSettingsTemplates
    externalAuthProvider
    tenantId
    tenant {
      id
      tenant_name: tenantName
      permissions_js: permissionsJs
      tenantDocumentTypes: documentTypeTenantSettings {
        document_type: documentType
        default_flags: defaultFlags
        meta
        code
      }
      declaration_labels: declarationLabels {
        id
        title
        description
        color
        is_deleted: isDeleted
      }
      address {
        id
        country
        city
        street
        street_number: streetNumber
        zipcode
        address_type: addressTypeId
        company_name: companyName
      }
    }
    modules {
      name
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetCurrentUserTenantConfigDocument = gql`
    query getCurrentUserTenantConfig($tenantId: ID!) {
  getTenantConfig(tenantId: $tenantId)
}
    `;

/**
 * __useGetCurrentUserTenantConfigQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserTenantConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserTenantConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserTenantConfigQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetCurrentUserTenantConfigQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserTenantConfigQuery, GetCurrentUserTenantConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserTenantConfigQuery, GetCurrentUserTenantConfigQueryVariables>(GetCurrentUserTenantConfigDocument, options);
      }
export function useGetCurrentUserTenantConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserTenantConfigQuery, GetCurrentUserTenantConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserTenantConfigQuery, GetCurrentUserTenantConfigQueryVariables>(GetCurrentUserTenantConfigDocument, options);
        }
export type GetCurrentUserTenantConfigQueryHookResult = ReturnType<typeof useGetCurrentUserTenantConfigQuery>;
export type GetCurrentUserTenantConfigLazyQueryHookResult = ReturnType<typeof useGetCurrentUserTenantConfigLazyQuery>;
export type GetCurrentUserTenantConfigQueryResult = Apollo.QueryResult<GetCurrentUserTenantConfigQuery, GetCurrentUserTenantConfigQueryVariables>;
export const UpdateCurrentUserUiSettingsDocument = gql`
    mutation updateCurrentUserUiSettings($id: uuid!, $ui_settings: jsonb!) {
  update_user_pp_by_pk(pk_columns: {id: $id}, _append: {ui_settings: $ui_settings}) {
    id
  }
}
    `;
export type UpdateCurrentUserUiSettingsMutationFn = Apollo.MutationFunction<UpdateCurrentUserUiSettingsMutation, UpdateCurrentUserUiSettingsMutationVariables>;

/**
 * __useUpdateCurrentUserUiSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserUiSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserUiSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserUiSettingsMutation, { data, loading, error }] = useUpdateCurrentUserUiSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ui_settings: // value for 'ui_settings'
 *   },
 * });
 */
export function useUpdateCurrentUserUiSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserUiSettingsMutation, UpdateCurrentUserUiSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserUiSettingsMutation, UpdateCurrentUserUiSettingsMutationVariables>(UpdateCurrentUserUiSettingsDocument, options);
      }
export type UpdateCurrentUserUiSettingsMutationHookResult = ReturnType<typeof useUpdateCurrentUserUiSettingsMutation>;
export type UpdateCurrentUserUiSettingsMutationResult = Apollo.MutationResult<UpdateCurrentUserUiSettingsMutation>;
export type UpdateCurrentUserUiSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserUiSettingsMutation, UpdateCurrentUserUiSettingsMutationVariables>;
export const UpdateCurrentUserUiSettingsTemplatesDocument = gql`
    mutation updateCurrentUserUiSettingsTemplates($id: uuid!, $ui_settings_templates: jsonb!) {
  update_user_pp_by_pk(pk_columns: {id: $id}, _append: {ui_settings_templates: $ui_settings_templates}) {
    id
  }
}
    `;
export type UpdateCurrentUserUiSettingsTemplatesMutationFn = Apollo.MutationFunction<UpdateCurrentUserUiSettingsTemplatesMutation, UpdateCurrentUserUiSettingsTemplatesMutationVariables>;

/**
 * __useUpdateCurrentUserUiSettingsTemplatesMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserUiSettingsTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserUiSettingsTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserUiSettingsTemplatesMutation, { data, loading, error }] = useUpdateCurrentUserUiSettingsTemplatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ui_settings_templates: // value for 'ui_settings_templates'
 *   },
 * });
 */
export function useUpdateCurrentUserUiSettingsTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserUiSettingsTemplatesMutation, UpdateCurrentUserUiSettingsTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserUiSettingsTemplatesMutation, UpdateCurrentUserUiSettingsTemplatesMutationVariables>(UpdateCurrentUserUiSettingsTemplatesDocument, options);
      }
export type UpdateCurrentUserUiSettingsTemplatesMutationHookResult = ReturnType<typeof useUpdateCurrentUserUiSettingsTemplatesMutation>;
export type UpdateCurrentUserUiSettingsTemplatesMutationResult = Apollo.MutationResult<UpdateCurrentUserUiSettingsTemplatesMutation>;
export type UpdateCurrentUserUiSettingsTemplatesMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserUiSettingsTemplatesMutation, UpdateCurrentUserUiSettingsTemplatesMutationVariables>;
export const WdGetAddressesListDocument = gql`
    query WdGetAddressesList($addressIds: _int4, $search: String, $addressTypes: _int4, $emptyAddressType: Boolean, $limit: Int) {
  addresses: pp_addresses(args: {_address_ids: $addressIds, _search: $search, _address_types: $addressTypes, _empty_address_type: $emptyAddressType, _limit: $limit}) {
    id
    aoId: ao_id
    companyName: company_name
    country
    city
    street
    streetNumber: street_number
    zipcode
    address_type
    reference
    source
    tenant {
      id
      permissions_js
    }
  }
}
    `;

/**
 * __useWdGetAddressesListQuery__
 *
 * To run a query within a React component, call `useWdGetAddressesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetAddressesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetAddressesListQuery({
 *   variables: {
 *      addressIds: // value for 'addressIds'
 *      search: // value for 'search'
 *      addressTypes: // value for 'addressTypes'
 *      emptyAddressType: // value for 'emptyAddressType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWdGetAddressesListQuery(baseOptions?: Apollo.QueryHookOptions<WdGetAddressesListQuery, WdGetAddressesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetAddressesListQuery, WdGetAddressesListQueryVariables>(WdGetAddressesListDocument, options);
      }
export function useWdGetAddressesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetAddressesListQuery, WdGetAddressesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetAddressesListQuery, WdGetAddressesListQueryVariables>(WdGetAddressesListDocument, options);
        }
export type WdGetAddressesListQueryHookResult = ReturnType<typeof useWdGetAddressesListQuery>;
export type WdGetAddressesListLazyQueryHookResult = ReturnType<typeof useWdGetAddressesListLazyQuery>;
export type WdGetAddressesListQueryResult = Apollo.QueryResult<WdGetAddressesListQuery, WdGetAddressesListQueryVariables>;
export const AditGetAddressesListDocument = gql`
    query AditGetAddressesList($search: String, $limit: Int = 10, $ids: [Int!]) {
  addresses: getAddressesByFrequency(search: $search, limit: $limit, ids: $ids) {
    ...AdiAddressesListFragment
  }
}
    ${AdiAddressesListFragmentFragmentDoc}`;

/**
 * __useAditGetAddressesListQuery__
 *
 * To run a query within a React component, call `useAditGetAddressesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetAddressesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetAddressesListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAditGetAddressesListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>(AditGetAddressesListDocument, options);
      }
export function useAditGetAddressesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>(AditGetAddressesListDocument, options);
        }
export type AditGetAddressesListQueryHookResult = ReturnType<typeof useAditGetAddressesListQuery>;
export type AditGetAddressesListLazyQueryHookResult = ReturnType<typeof useAditGetAddressesListLazyQuery>;
export type AditGetAddressesListQueryResult = Apollo.QueryResult<AditGetAddressesListQuery, AditGetAddressesListQueryVariables>;
export const EditAddressDocument = gql`
    mutation EditAddress($id: Int!, $aoId: Int, $newData: AddressInputRS!, $additionalParams: EditAddressInputACS!) {
  editAddressACS(id: $id, aoId: $aoId, newData: $newData, additionalParams: $additionalParams) {
    id
    city
    companyName
    contactEmail
    contactPhone
    contactWebsite
    country
    reference
    street
    streetNumber
    zipcode
    meta
  }
}
    `;
export type EditAddressMutationFn = Apollo.MutationFunction<EditAddressMutation, EditAddressMutationVariables>;

/**
 * __useEditAddressMutation__
 *
 * To run a mutation, you first call `useEditAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAddressMutation, { data, loading, error }] = useEditAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aoId: // value for 'aoId'
 *      newData: // value for 'newData'
 *      additionalParams: // value for 'additionalParams'
 *   },
 * });
 */
export function useEditAddressMutation(baseOptions?: Apollo.MutationHookOptions<EditAddressMutation, EditAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAddressMutation, EditAddressMutationVariables>(EditAddressDocument, options);
      }
export type EditAddressMutationHookResult = ReturnType<typeof useEditAddressMutation>;
export type EditAddressMutationResult = Apollo.MutationResult<EditAddressMutation>;
export type EditAddressMutationOptions = Apollo.BaseMutationOptions<EditAddressMutation, EditAddressMutationVariables>;
export const WdInsertAddressDocument = gql`
    mutation WdInsertAddress($objects: [address_insert_input!]!) {
  insert_address(objects: $objects) {
    affected_rows
  }
}
    `;
export type WdInsertAddressMutationFn = Apollo.MutationFunction<WdInsertAddressMutation, WdInsertAddressMutationVariables>;

/**
 * __useWdInsertAddressMutation__
 *
 * To run a mutation, you first call `useWdInsertAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdInsertAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdInsertAddressMutation, { data, loading, error }] = useWdInsertAddressMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useWdInsertAddressMutation(baseOptions?: Apollo.MutationHookOptions<WdInsertAddressMutation, WdInsertAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdInsertAddressMutation, WdInsertAddressMutationVariables>(WdInsertAddressDocument, options);
      }
export type WdInsertAddressMutationHookResult = ReturnType<typeof useWdInsertAddressMutation>;
export type WdInsertAddressMutationResult = Apollo.MutationResult<WdInsertAddressMutation>;
export type WdInsertAddressMutationOptions = Apollo.BaseMutationOptions<WdInsertAddressMutation, WdInsertAddressMutationVariables>;
export const LinkAddressesDocument = gql`
    mutation LinkAddresses($input: LinkAddressesInputACS!) {
  linkAddressesACS(input: $input) {
    address_id
    address_override_id
  }
}
    `;
export type LinkAddressesMutationFn = Apollo.MutationFunction<LinkAddressesMutation, LinkAddressesMutationVariables>;

/**
 * __useLinkAddressesMutation__
 *
 * To run a mutation, you first call `useLinkAddressesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkAddressesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkAddressesMutation, { data, loading, error }] = useLinkAddressesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkAddressesMutation(baseOptions?: Apollo.MutationHookOptions<LinkAddressesMutation, LinkAddressesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkAddressesMutation, LinkAddressesMutationVariables>(LinkAddressesDocument, options);
      }
export type LinkAddressesMutationHookResult = ReturnType<typeof useLinkAddressesMutation>;
export type LinkAddressesMutationResult = Apollo.MutationResult<LinkAddressesMutation>;
export type LinkAddressesMutationOptions = Apollo.BaseMutationOptions<LinkAddressesMutation, LinkAddressesMutationVariables>;
export const Update_AddressDocument = gql`
    mutation UPDATE_ADDRESS($id: Int, $values: address_set_input) {
  update_address(where: {id: {_eq: $id}}, _set: $values) {
    affected_rows
  }
}
    `;
export type Update_AddressMutationFn = Apollo.MutationFunction<Update_AddressMutation, Update_AddressMutationVariables>;

/**
 * __useUpdate_AddressMutation__
 *
 * To run a mutation, you first call `useUpdate_AddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_AddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdate_AddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdate_AddressMutation(baseOptions?: Apollo.MutationHookOptions<Update_AddressMutation, Update_AddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_AddressMutation, Update_AddressMutationVariables>(Update_AddressDocument, options);
      }
export type Update_AddressMutationHookResult = ReturnType<typeof useUpdate_AddressMutation>;
export type Update_AddressMutationResult = Apollo.MutationResult<Update_AddressMutation>;
export type Update_AddressMutationOptions = Apollo.BaseMutationOptions<Update_AddressMutation, Update_AddressMutationVariables>;
export const Update_Address_OverrideDocument = gql`
    mutation UPDATE_ADDRESS_OVERRIDE($id: Int, $values: address_override_set_input) {
  update_address_override(where: {id: {_eq: $id}}, _set: $values) {
    affected_rows
  }
}
    `;
export type Update_Address_OverrideMutationFn = Apollo.MutationFunction<Update_Address_OverrideMutation, Update_Address_OverrideMutationVariables>;

/**
 * __useUpdate_Address_OverrideMutation__
 *
 * To run a mutation, you first call `useUpdate_Address_OverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Address_OverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressOverrideMutation, { data, loading, error }] = useUpdate_Address_OverrideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      values: // value for 'values'
 *   },
 * });
 */
export function useUpdate_Address_OverrideMutation(baseOptions?: Apollo.MutationHookOptions<Update_Address_OverrideMutation, Update_Address_OverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Address_OverrideMutation, Update_Address_OverrideMutationVariables>(Update_Address_OverrideDocument, options);
      }
export type Update_Address_OverrideMutationHookResult = ReturnType<typeof useUpdate_Address_OverrideMutation>;
export type Update_Address_OverrideMutationResult = Apollo.MutationResult<Update_Address_OverrideMutation>;
export type Update_Address_OverrideMutationOptions = Apollo.BaseMutationOptions<Update_Address_OverrideMutation, Update_Address_OverrideMutationVariables>;
export const AditGetCommodityCodesListDocument = gql`
    query aditGetCommodityCodesList($ids: [String!], $search: String, $limit: Int) {
  commodityCodes: getCommodityCodes(ids: $ids, search: $search, limit: $limit) {
    id
    commodityCode
    descriptionDe
    hierarchyVisual
  }
}
    `;

/**
 * __useAditGetCommodityCodesListQuery__
 *
 * To run a query within a React component, call `useAditGetCommodityCodesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetCommodityCodesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetCommodityCodesListQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAditGetCommodityCodesListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>(AditGetCommodityCodesListDocument, options);
      }
export function useAditGetCommodityCodesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>(AditGetCommodityCodesListDocument, options);
        }
export type AditGetCommodityCodesListQueryHookResult = ReturnType<typeof useAditGetCommodityCodesListQuery>;
export type AditGetCommodityCodesListLazyQueryHookResult = ReturnType<typeof useAditGetCommodityCodesListLazyQuery>;
export type AditGetCommodityCodesListQueryResult = Apollo.QueryResult<AditGetCommodityCodesListQuery, AditGetCommodityCodesListQueryVariables>;
export const AditUpdateDeclarationAiConfirmedDocument = gql`
    mutation AditUpdateDeclarationAiConfirmed($file_id: uuid!, $dr_no: smallint!, $ai_confirmed: Boolean!) {
  update_declaration_by_pk(pk_columns: {file_id: $file_id, dr_no: $dr_no}, _set: {ai_confirmed: $ai_confirmed}) {
    file_id
    dr_no
  }
}
    `;
export type AditUpdateDeclarationAiConfirmedMutationFn = Apollo.MutationFunction<AditUpdateDeclarationAiConfirmedMutation, AditUpdateDeclarationAiConfirmedMutationVariables>;

/**
 * __useAditUpdateDeclarationAiConfirmedMutation__
 *
 * To run a mutation, you first call `useAditUpdateDeclarationAiConfirmedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateDeclarationAiConfirmedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateDeclarationAiConfirmedMutation, { data, loading, error }] = useAditUpdateDeclarationAiConfirmedMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *      ai_confirmed: // value for 'ai_confirmed'
 *   },
 * });
 */
export function useAditUpdateDeclarationAiConfirmedMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateDeclarationAiConfirmedMutation, AditUpdateDeclarationAiConfirmedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateDeclarationAiConfirmedMutation, AditUpdateDeclarationAiConfirmedMutationVariables>(AditUpdateDeclarationAiConfirmedDocument, options);
      }
export type AditUpdateDeclarationAiConfirmedMutationHookResult = ReturnType<typeof useAditUpdateDeclarationAiConfirmedMutation>;
export type AditUpdateDeclarationAiConfirmedMutationResult = Apollo.MutationResult<AditUpdateDeclarationAiConfirmedMutation>;
export type AditUpdateDeclarationAiConfirmedMutationOptions = Apollo.BaseMutationOptions<AditUpdateDeclarationAiConfirmedMutation, AditUpdateDeclarationAiConfirmedMutationVariables>;
export const AditGetDeclarationDocument = gql`
    query AditGetDeclaration($file_id: uuid!, $dr_no: smallint!) {
  declarations: declaration(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}}) {
    file_id
    dr_no
    file {
      identification
    }
    ai_results
    ai_confirmed
    declaration_request {
      cev_status
    }
  }
  declarationsForm: declaration(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}}) {
    file_id
    dr_no
    send_status
    declarant_number
    trader_identification_number
    send_date
    receive_status
    acceptance_date
    customs_declaration_number
    trader_reference
    duty_total_amount
    vat_total_amount
    customs_declaration_version
    material_check
    release
    gross_mass
    net_mass
    transport_mode
    transport_type
    transport_country
    transport_number
    service_type
    invoice_currency_type
    clearance_location
    place_of_unloading
    declaration_time
    declaration_type
    reason
    lang
    customs_office_number
    dispatch_country
    dispatch_country_confirmation
    correction_code
    correction_reason
    addresses {
      address_type
      address_id
      refs
      address {
        id
        company_name
        street
        street_number
        country
        zipcode
        city
        reference
        customs_account_number
        vat_account_number
      }
    }
    transport_in_container
    incoterms
    customs_account_address_type
    customs_account_number
    vat_account_address_type
    vat_account_number
    vat_number
    previous_documents {
      id
      previous_document_type
      previous_document_reference
      additional_information
    }
    containers {
      id
      container_number
    }
    declaration_special_mentions(order_by: {sequence_number: asc}) {
      id
      sequence_number
      text
    }
    goods_items {
      customs_item_number
      selection_result
      commodity_code
      commodity_code_confirmation
      statistical_code
      duty_rate
      rate_confirmation
      description
      net_duty
      net_mass
      net_mass_confirmation
      tare_supplement
      tare_supplement_confirmation
      gross_mass
      gross_mass_confirmation
      customs_net_weight
      additional_unit
      additional_unit_confirmation
      commercial_good
      clearance_type
      customs_favour_code
      origin_country
      origin_preference
      preference_confirmation
      vat_code
      vat_code_confirmation
      statistical_value
      statistical_value_confirmation
      vat_value
      vat_value_confirmation
      repair
      packagings {
        id
        packaging_type
        packaging_quantity
        packaging_reference_number
      }
      produced_documents {
        id
        produced_document_type
        produced_document_reference_number
        produced_document_issue_date
        additional_information
      }
    }
  }
}
    `;

/**
 * __useAditGetDeclarationQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationQuery({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *   },
 * });
 */
export function useAditGetDeclarationQuery(baseOptions: Apollo.QueryHookOptions<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>(AditGetDeclarationDocument, options);
      }
export function useAditGetDeclarationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>(AditGetDeclarationDocument, options);
        }
export type AditGetDeclarationQueryHookResult = ReturnType<typeof useAditGetDeclarationQuery>;
export type AditGetDeclarationLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationLazyQuery>;
export type AditGetDeclarationQueryResult = Apollo.QueryResult<AditGetDeclarationQuery, AditGetDeclarationQueryVariables>;
export const AditUpsertDeclarationDocument = gql`
    mutation AditUpsertDeclaration($file_id: uuid!, $dr_no: smallint!, $object: declaration_insert_input!, $constraint: declaration_constraint!, $update_columns: [declaration_update_column!]!, $goodsItemsToDeleteExp: [goods_item_bool_exp!]!, $previousDocumentsToDeleteExp: [previous_documents_bool_exp!]!, $containersToDeleteExp: [containers_bool_exp!]!, $declarationSpecialMentionsToDeleteExp: [declaration_special_mentions_bool_exp!]!, $packagingsToDeleteExp: [packagings_bool_exp!]!, $producedDocumentsToDeleteExp: [produced_documents_bool_exp!]!) {
  insert_declaration_one(object: $object, on_conflict: {constraint: $constraint, update_columns: $update_columns}) {
    file_id
    dr_no
  }
  delete_previous_documents(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $previousDocumentsToDeleteExp}) {
    affected_rows
  }
  delete_containers(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $containersToDeleteExp}) {
    affected_rows
  }
  delete_declaration_special_mentions(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $declarationSpecialMentionsToDeleteExp}) {
    affected_rows
  }
  delete_goods_item(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $goodsItemsToDeleteExp}) {
    affected_rows
  }
  delete_packagings(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $packagingsToDeleteExp}) {
    affected_rows
  }
  delete_produced_documents(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}, _or: $producedDocumentsToDeleteExp}) {
    affected_rows
  }
}
    `;
export type AditUpsertDeclarationMutationFn = Apollo.MutationFunction<AditUpsertDeclarationMutation, AditUpsertDeclarationMutationVariables>;

/**
 * __useAditUpsertDeclarationMutation__
 *
 * To run a mutation, you first call `useAditUpsertDeclarationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpsertDeclarationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpsertDeclarationMutation, { data, loading, error }] = useAditUpsertDeclarationMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *      object: // value for 'object'
 *      constraint: // value for 'constraint'
 *      update_columns: // value for 'update_columns'
 *      goodsItemsToDeleteExp: // value for 'goodsItemsToDeleteExp'
 *      previousDocumentsToDeleteExp: // value for 'previousDocumentsToDeleteExp'
 *      containersToDeleteExp: // value for 'containersToDeleteExp'
 *      declarationSpecialMentionsToDeleteExp: // value for 'declarationSpecialMentionsToDeleteExp'
 *      packagingsToDeleteExp: // value for 'packagingsToDeleteExp'
 *      producedDocumentsToDeleteExp: // value for 'producedDocumentsToDeleteExp'
 *   },
 * });
 */
export function useAditUpsertDeclarationMutation(baseOptions?: Apollo.MutationHookOptions<AditUpsertDeclarationMutation, AditUpsertDeclarationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpsertDeclarationMutation, AditUpsertDeclarationMutationVariables>(AditUpsertDeclarationDocument, options);
      }
export type AditUpsertDeclarationMutationHookResult = ReturnType<typeof useAditUpsertDeclarationMutation>;
export type AditUpsertDeclarationMutationResult = Apollo.MutationResult<AditUpsertDeclarationMutation>;
export type AditUpsertDeclarationMutationOptions = Apollo.BaseMutationOptions<AditUpsertDeclarationMutation, AditUpsertDeclarationMutationVariables>;
export const WdAssignDeclarationLabelsDocument = gql`
    mutation WdAssignDeclarationLabels($drNo: Int!, $fileId: UUID!, $labelIds: [Int!]!) {
  assignDeclarationLabels(labels: {drNo: $drNo, fileId: $fileId, labelIds: $labelIds}) {
    fileId
    drNo
    labelId
  }
}
    `;
export type WdAssignDeclarationLabelsMutationFn = Apollo.MutationFunction<WdAssignDeclarationLabelsMutation, WdAssignDeclarationLabelsMutationVariables>;

/**
 * __useWdAssignDeclarationLabelsMutation__
 *
 * To run a mutation, you first call `useWdAssignDeclarationLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdAssignDeclarationLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdAssignDeclarationLabelsMutation, { data, loading, error }] = useWdAssignDeclarationLabelsMutation({
 *   variables: {
 *      drNo: // value for 'drNo'
 *      fileId: // value for 'fileId'
 *      labelIds: // value for 'labelIds'
 *   },
 * });
 */
export function useWdAssignDeclarationLabelsMutation(baseOptions?: Apollo.MutationHookOptions<WdAssignDeclarationLabelsMutation, WdAssignDeclarationLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdAssignDeclarationLabelsMutation, WdAssignDeclarationLabelsMutationVariables>(WdAssignDeclarationLabelsDocument, options);
      }
export type WdAssignDeclarationLabelsMutationHookResult = ReturnType<typeof useWdAssignDeclarationLabelsMutation>;
export type WdAssignDeclarationLabelsMutationResult = Apollo.MutationResult<WdAssignDeclarationLabelsMutation>;
export type WdAssignDeclarationLabelsMutationOptions = Apollo.BaseMutationOptions<WdAssignDeclarationLabelsMutation, WdAssignDeclarationLabelsMutationVariables>;
export const Change_Declaration_StatusDocument = gql`
    mutation CHANGE_DECLARATION_STATUS($fileId: uuid!, $status: String) {
  update_declaration_request(_set: {declaration_status: $status}, where: {file_id: {_eq: $fileId}}) {
    affected_rows
  }
}
    `;
export type Change_Declaration_StatusMutationFn = Apollo.MutationFunction<Change_Declaration_StatusMutation, Change_Declaration_StatusMutationVariables>;

/**
 * __useChange_Declaration_StatusMutation__
 *
 * To run a mutation, you first call `useChange_Declaration_StatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChange_Declaration_StatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDeclarationStatusMutation, { data, loading, error }] = useChange_Declaration_StatusMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChange_Declaration_StatusMutation(baseOptions?: Apollo.MutationHookOptions<Change_Declaration_StatusMutation, Change_Declaration_StatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Change_Declaration_StatusMutation, Change_Declaration_StatusMutationVariables>(Change_Declaration_StatusDocument, options);
      }
export type Change_Declaration_StatusMutationHookResult = ReturnType<typeof useChange_Declaration_StatusMutation>;
export type Change_Declaration_StatusMutationResult = Apollo.MutationResult<Change_Declaration_StatusMutation>;
export type Change_Declaration_StatusMutationOptions = Apollo.BaseMutationOptions<Change_Declaration_StatusMutation, Change_Declaration_StatusMutationVariables>;
export const WdCreateDeclarationDocument = gql`
    mutation WdCreateDeclaration($documents: [CreateDeclarationDocumentInput!]!, $declaration: DeclarationInput, $fileId: ID = null) {
  createDeclarationReq(data: {documents: $documents, fileId: $fileId, flags: 8, orgId: 651, ignoreChecksum: true, declaration: $declaration}) {
    success
    error
    documentIds
    fileId
  }
}
    `;
export type WdCreateDeclarationMutationFn = Apollo.MutationFunction<WdCreateDeclarationMutation, WdCreateDeclarationMutationVariables>;

/**
 * __useWdCreateDeclarationMutation__
 *
 * To run a mutation, you first call `useWdCreateDeclarationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdCreateDeclarationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdCreateDeclarationMutation, { data, loading, error }] = useWdCreateDeclarationMutation({
 *   variables: {
 *      documents: // value for 'documents'
 *      declaration: // value for 'declaration'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useWdCreateDeclarationMutation(baseOptions?: Apollo.MutationHookOptions<WdCreateDeclarationMutation, WdCreateDeclarationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdCreateDeclarationMutation, WdCreateDeclarationMutationVariables>(WdCreateDeclarationDocument, options);
      }
export type WdCreateDeclarationMutationHookResult = ReturnType<typeof useWdCreateDeclarationMutation>;
export type WdCreateDeclarationMutationResult = Apollo.MutationResult<WdCreateDeclarationMutation>;
export type WdCreateDeclarationMutationOptions = Apollo.BaseMutationOptions<WdCreateDeclarationMutation, WdCreateDeclarationMutationVariables>;
export const WdDownloadGoodItemsStatisticsDocument = gql`
    query WDDownloadGoodItemsStatistics($addresses_qi: String, $arrival_type: String, $clearance_type: String, $declaration_statuses: String, $declaration_type: String, $max_date: timestamptz, $min_date: timestamptz, $payer: ID, $tenantId: ID!, $evv_status: String, $search: String, $search_field: String, $columns: [String], $total_items: Int, $declaration_labels: String) {
  getDeclarationGoodItemsStatistics(tenantId: $tenantId, addresses_qi: $addresses_qi, arrival_type: $arrival_type, clearance_type: $clearance_type, declaration_statuses: $declaration_statuses, declaration_type: $declaration_type, max_date: $max_date, min_date: $min_date, payer: $payer, evv_status: $evv_status, search: $search, search_field: $search_field, columns: $columns, total_items: $total_items, declaration_labels: $declaration_labels)
}
    `;

/**
 * __useWdDownloadGoodItemsStatisticsQuery__
 *
 * To run a query within a React component, call `useWdDownloadGoodItemsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdDownloadGoodItemsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdDownloadGoodItemsStatisticsQuery({
 *   variables: {
 *      addresses_qi: // value for 'addresses_qi'
 *      arrival_type: // value for 'arrival_type'
 *      clearance_type: // value for 'clearance_type'
 *      declaration_statuses: // value for 'declaration_statuses'
 *      declaration_type: // value for 'declaration_type'
 *      max_date: // value for 'max_date'
 *      min_date: // value for 'min_date'
 *      payer: // value for 'payer'
 *      tenantId: // value for 'tenantId'
 *      evv_status: // value for 'evv_status'
 *      search: // value for 'search'
 *      search_field: // value for 'search_field'
 *      columns: // value for 'columns'
 *      total_items: // value for 'total_items'
 *      declaration_labels: // value for 'declaration_labels'
 *   },
 * });
 */
export function useWdDownloadGoodItemsStatisticsQuery(baseOptions: Apollo.QueryHookOptions<WdDownloadGoodItemsStatisticsQuery, WdDownloadGoodItemsStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdDownloadGoodItemsStatisticsQuery, WdDownloadGoodItemsStatisticsQueryVariables>(WdDownloadGoodItemsStatisticsDocument, options);
      }
export function useWdDownloadGoodItemsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdDownloadGoodItemsStatisticsQuery, WdDownloadGoodItemsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdDownloadGoodItemsStatisticsQuery, WdDownloadGoodItemsStatisticsQueryVariables>(WdDownloadGoodItemsStatisticsDocument, options);
        }
export type WdDownloadGoodItemsStatisticsQueryHookResult = ReturnType<typeof useWdDownloadGoodItemsStatisticsQuery>;
export type WdDownloadGoodItemsStatisticsLazyQueryHookResult = ReturnType<typeof useWdDownloadGoodItemsStatisticsLazyQuery>;
export type WdDownloadGoodItemsStatisticsQueryResult = Apollo.QueryResult<WdDownloadGoodItemsStatisticsQuery, WdDownloadGoodItemsStatisticsQueryVariables>;
export const WdUpdateDeclarationEvvConfirmationDocument = gql`
    mutation WdUpdateDeclarationEVVConfirmation($file_id: uuid!, $dr_no: smallint!, $evv_confirmed: Boolean!) {
  update_declaration_request_by_pk(pk_columns: {file_id: $file_id, dr_no: $dr_no}, _append: {meta: {evv_confirmed: $evv_confirmed}}) {
    file_id
  }
}
    `;
export type WdUpdateDeclarationEvvConfirmationMutationFn = Apollo.MutationFunction<WdUpdateDeclarationEvvConfirmationMutation, WdUpdateDeclarationEvvConfirmationMutationVariables>;

/**
 * __useWdUpdateDeclarationEvvConfirmationMutation__
 *
 * To run a mutation, you first call `useWdUpdateDeclarationEvvConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdUpdateDeclarationEvvConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdUpdateDeclarationEvvConfirmationMutation, { data, loading, error }] = useWdUpdateDeclarationEvvConfirmationMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *      evv_confirmed: // value for 'evv_confirmed'
 *   },
 * });
 */
export function useWdUpdateDeclarationEvvConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<WdUpdateDeclarationEvvConfirmationMutation, WdUpdateDeclarationEvvConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdUpdateDeclarationEvvConfirmationMutation, WdUpdateDeclarationEvvConfirmationMutationVariables>(WdUpdateDeclarationEvvConfirmationDocument, options);
      }
export type WdUpdateDeclarationEvvConfirmationMutationHookResult = ReturnType<typeof useWdUpdateDeclarationEvvConfirmationMutation>;
export type WdUpdateDeclarationEvvConfirmationMutationResult = Apollo.MutationResult<WdUpdateDeclarationEvvConfirmationMutation>;
export type WdUpdateDeclarationEvvConfirmationMutationOptions = Apollo.BaseMutationOptions<WdUpdateDeclarationEvvConfirmationMutation, WdUpdateDeclarationEvvConfirmationMutationVariables>;
export const Update_Declaration_RequestDocument = gql`
    mutation UPDATE_DECLARATION_REQUEST($file_id: uuid!, $arrival_time: timestamptz!, $declaration_status: String, $arrival_type: String) {
  update_declaration_request_by_pk(pk_columns: {file_id: $file_id, dr_no: 1}, _set: {arrival_time: $arrival_time, declaration_status: $declaration_status, arrival_type: $arrival_type}) {
    file_id
  }
}
    `;
export type Update_Declaration_RequestMutationFn = Apollo.MutationFunction<Update_Declaration_RequestMutation, Update_Declaration_RequestMutationVariables>;

/**
 * __useUpdate_Declaration_RequestMutation__
 *
 * To run a mutation, you first call `useUpdate_Declaration_RequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Declaration_RequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeclarationRequestMutation, { data, loading, error }] = useUpdate_Declaration_RequestMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      arrival_time: // value for 'arrival_time'
 *      declaration_status: // value for 'declaration_status'
 *      arrival_type: // value for 'arrival_type'
 *   },
 * });
 */
export function useUpdate_Declaration_RequestMutation(baseOptions?: Apollo.MutationHookOptions<Update_Declaration_RequestMutation, Update_Declaration_RequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Declaration_RequestMutation, Update_Declaration_RequestMutationVariables>(Update_Declaration_RequestDocument, options);
      }
export type Update_Declaration_RequestMutationHookResult = ReturnType<typeof useUpdate_Declaration_RequestMutation>;
export type Update_Declaration_RequestMutationResult = Apollo.MutationResult<Update_Declaration_RequestMutation>;
export type Update_Declaration_RequestMutationOptions = Apollo.BaseMutationOptions<Update_Declaration_RequestMutation, Update_Declaration_RequestMutationVariables>;
export const SendDeclarationArrivalNotificationDocument = gql`
    mutation sendDeclarationArrivalNotification($file_id: uuid!, $arrival_time: timestamptz!) {
  sendDeclarationArrivalNotification(data: {file_id: $file_id, dr_no: 1, arrival_time: $arrival_time})
}
    `;
export type SendDeclarationArrivalNotificationMutationFn = Apollo.MutationFunction<SendDeclarationArrivalNotificationMutation, SendDeclarationArrivalNotificationMutationVariables>;

/**
 * __useSendDeclarationArrivalNotificationMutation__
 *
 * To run a mutation, you first call `useSendDeclarationArrivalNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDeclarationArrivalNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDeclarationArrivalNotificationMutation, { data, loading, error }] = useSendDeclarationArrivalNotificationMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      arrival_time: // value for 'arrival_time'
 *   },
 * });
 */
export function useSendDeclarationArrivalNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendDeclarationArrivalNotificationMutation, SendDeclarationArrivalNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDeclarationArrivalNotificationMutation, SendDeclarationArrivalNotificationMutationVariables>(SendDeclarationArrivalNotificationDocument, options);
      }
export type SendDeclarationArrivalNotificationMutationHookResult = ReturnType<typeof useSendDeclarationArrivalNotificationMutation>;
export type SendDeclarationArrivalNotificationMutationResult = Apollo.MutationResult<SendDeclarationArrivalNotificationMutation>;
export type SendDeclarationArrivalNotificationMutationOptions = Apollo.BaseMutationOptions<SendDeclarationArrivalNotificationMutation, SendDeclarationArrivalNotificationMutationVariables>;
export const Adit_Get_Validation_V2_DocumentDocument = gql`
    query ADIT_GET_VALIDATION_V2_DOCUMENT($id: uuid!, $tenantId: uuid!) {
  file: file_by_pk(id: $id) {
    identification
    documents {
      id
      name: document_name
      meta
      document_extension
      annotationType(where: {annotation_provider_id: {_eq: 5}}) {
        annotation_schema
      }
      pages: pages_m2m(order_by: {page_number: asc}) {
        page {
          id
          thumbnailBigUrl: thumbnail_big_url
          page_status
          rotate
          meta
          creation_user
          pageExtracts: page_extracts {
            page_id
            extract_type_id
            extract_type {
              extract_type_id
              translations
            }
            dataPoints: value
            tables
          }
        }
      }
      document_blobs
      document_flags
      document_type
      sequence
      documentType {
        translations
        document_type_tenant_settings(where: {tenant: {_eq: $tenantId}}) {
          documentSchema: document_schema
        }
      }
    }
  }
}
    `;

/**
 * __useAdit_Get_Validation_V2_DocumentQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Validation_V2_DocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Validation_V2_DocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Validation_V2_DocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useAdit_Get_Validation_V2_DocumentQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>(Adit_Get_Validation_V2_DocumentDocument, options);
      }
export function useAdit_Get_Validation_V2_DocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>(Adit_Get_Validation_V2_DocumentDocument, options);
        }
export type Adit_Get_Validation_V2_DocumentQueryHookResult = ReturnType<typeof useAdit_Get_Validation_V2_DocumentQuery>;
export type Adit_Get_Validation_V2_DocumentLazyQueryHookResult = ReturnType<typeof useAdit_Get_Validation_V2_DocumentLazyQuery>;
export type Adit_Get_Validation_V2_DocumentQueryResult = Apollo.QueryResult<Adit_Get_Validation_V2_DocumentQuery, Adit_Get_Validation_V2_DocumentQueryVariables>;
export const Upsert_TableDocument = gql`
    mutation UPSERT_TABLE($pageId: uuid!, $extractTypeId: smallint!, $tables: jsonb!) {
  insert_page_extract_one(object: {page_id: $pageId, extract_type_id: $extractTypeId, tables: $tables}, on_conflict: {constraint: page_extract_pk, update_columns: [tables]}) {
    page_id
  }
}
    `;
export type Upsert_TableMutationFn = Apollo.MutationFunction<Upsert_TableMutation, Upsert_TableMutationVariables>;

/**
 * __useUpsert_TableMutation__
 *
 * To run a mutation, you first call `useUpsert_TableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsert_TableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTableMutation, { data, loading, error }] = useUpsert_TableMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      extractTypeId: // value for 'extractTypeId'
 *      tables: // value for 'tables'
 *   },
 * });
 */
export function useUpsert_TableMutation(baseOptions?: Apollo.MutationHookOptions<Upsert_TableMutation, Upsert_TableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Upsert_TableMutation, Upsert_TableMutationVariables>(Upsert_TableDocument, options);
      }
export type Upsert_TableMutationHookResult = ReturnType<typeof useUpsert_TableMutation>;
export type Upsert_TableMutationResult = Apollo.MutationResult<Upsert_TableMutation>;
export type Upsert_TableMutationOptions = Apollo.BaseMutationOptions<Upsert_TableMutation, Upsert_TableMutationVariables>;
export const AditDeleteDocumentDocument = gql`
    mutation aditDeleteDocument($id: [uuid!]!) {
  update_document(where: {id: {_in: $id}}, _set: {is_deleted: true, checksum: null}) {
    affected_rows
  }
}
    `;
export type AditDeleteDocumentMutationFn = Apollo.MutationFunction<AditDeleteDocumentMutation, AditDeleteDocumentMutationVariables>;

/**
 * __useAditDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useAditDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditDeleteDocumentMutation, { data, loading, error }] = useAditDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAditDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AditDeleteDocumentMutation, AditDeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditDeleteDocumentMutation, AditDeleteDocumentMutationVariables>(AditDeleteDocumentDocument, options);
      }
export type AditDeleteDocumentMutationHookResult = ReturnType<typeof useAditDeleteDocumentMutation>;
export type AditDeleteDocumentMutationResult = Apollo.MutationResult<AditDeleteDocumentMutation>;
export type AditDeleteDocumentMutationOptions = Apollo.BaseMutationOptions<AditDeleteDocumentMutation, AditDeleteDocumentMutationVariables>;
export const AditScheduleDocumentsDocument = gql`
    mutation aditScheduleDocuments($documentIds: [ID!]!) {
  scheduleDocuments(documentIds: $documentIds)
}
    `;
export type AditScheduleDocumentsMutationFn = Apollo.MutationFunction<AditScheduleDocumentsMutation, AditScheduleDocumentsMutationVariables>;

/**
 * __useAditScheduleDocumentsMutation__
 *
 * To run a mutation, you first call `useAditScheduleDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditScheduleDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditScheduleDocumentsMutation, { data, loading, error }] = useAditScheduleDocumentsMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useAditScheduleDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<AditScheduleDocumentsMutation, AditScheduleDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditScheduleDocumentsMutation, AditScheduleDocumentsMutationVariables>(AditScheduleDocumentsDocument, options);
      }
export type AditScheduleDocumentsMutationHookResult = ReturnType<typeof useAditScheduleDocumentsMutation>;
export type AditScheduleDocumentsMutationResult = Apollo.MutationResult<AditScheduleDocumentsMutation>;
export type AditScheduleDocumentsMutationOptions = Apollo.BaseMutationOptions<AditScheduleDocumentsMutation, AditScheduleDocumentsMutationVariables>;
export const ScheduleDocAnnotationExportDocument = gql`
    mutation scheduleDocAnnotationExport($documentID: ID!) {
  scheduleDocAnnotationExport(id: $documentID)
}
    `;
export type ScheduleDocAnnotationExportMutationFn = Apollo.MutationFunction<ScheduleDocAnnotationExportMutation, ScheduleDocAnnotationExportMutationVariables>;

/**
 * __useScheduleDocAnnotationExportMutation__
 *
 * To run a mutation, you first call `useScheduleDocAnnotationExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleDocAnnotationExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleDocAnnotationExportMutation, { data, loading, error }] = useScheduleDocAnnotationExportMutation({
 *   variables: {
 *      documentID: // value for 'documentID'
 *   },
 * });
 */
export function useScheduleDocAnnotationExportMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleDocAnnotationExportMutation, ScheduleDocAnnotationExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleDocAnnotationExportMutation, ScheduleDocAnnotationExportMutationVariables>(ScheduleDocAnnotationExportDocument, options);
      }
export type ScheduleDocAnnotationExportMutationHookResult = ReturnType<typeof useScheduleDocAnnotationExportMutation>;
export type ScheduleDocAnnotationExportMutationResult = Apollo.MutationResult<ScheduleDocAnnotationExportMutation>;
export type ScheduleDocAnnotationExportMutationOptions = Apollo.BaseMutationOptions<ScheduleDocAnnotationExportMutation, ScheduleDocAnnotationExportMutationVariables>;
export const AditGetDocumentsForSubscriptionDocument = gql`
    query AditGetDocumentsForSubscription($offset: Int, $limit: Int, $creationUser: uuid, $search: String, $orderBy: String) {
  documents: pp_doc_search_hs(args: {_creationuser: $creationUser, _limit: $limit, _offset: $offset, _searchval: $search, _orderby: $orderBy}) {
    id
    document_extension
    document_name
    creation_date
    creation_user
    pages_m2m_aggregate(where: {page: {page_status: {_neq: "classified"}}}) {
      aggregate {
        count
      }
    }
    org_id
    org_id_description
    document_status
    document_flags
    document_blobs
    total_rows
    user_display_name
  }
}
    `;

/**
 * __useAditGetDocumentsForSubscriptionQuery__
 *
 * To run a query within a React component, call `useAditGetDocumentsForSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDocumentsForSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDocumentsForSubscriptionQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      creationUser: // value for 'creationUser'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAditGetDocumentsForSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>(AditGetDocumentsForSubscriptionDocument, options);
      }
export function useAditGetDocumentsForSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>(AditGetDocumentsForSubscriptionDocument, options);
        }
export type AditGetDocumentsForSubscriptionQueryHookResult = ReturnType<typeof useAditGetDocumentsForSubscriptionQuery>;
export type AditGetDocumentsForSubscriptionLazyQueryHookResult = ReturnType<typeof useAditGetDocumentsForSubscriptionLazyQuery>;
export type AditGetDocumentsForSubscriptionQueryResult = Apollo.QueryResult<AditGetDocumentsForSubscriptionQuery, AditGetDocumentsForSubscriptionQueryVariables>;
export const GetDocumentUpdatesDocument = gql`
    subscription getDocumentUpdates($my: Boolean) {
  pp_doc_max_date_hs: pp_doc_max_date_v2(args: {_my: $my}) {
    max_change_date
  }
}
    `;

/**
 * __useGetDocumentUpdatesSubscription__
 *
 * To run a query within a React component, call `useGetDocumentUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentUpdatesSubscription({
 *   variables: {
 *      my: // value for 'my'
 *   },
 * });
 */
export function useGetDocumentUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetDocumentUpdatesSubscription, GetDocumentUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetDocumentUpdatesSubscription, GetDocumentUpdatesSubscriptionVariables>(GetDocumentUpdatesDocument, options);
      }
export type GetDocumentUpdatesSubscriptionHookResult = ReturnType<typeof useGetDocumentUpdatesSubscription>;
export type GetDocumentUpdatesSubscriptionResult = Apollo.SubscriptionResult<GetDocumentUpdatesSubscription>;
export const Adit_Get_Document_TypesDocument = gql`
    query ADIT_GET_DOCUMENT_TYPES($tenantId: uuid!, $limit: Int, $offset: Int, $where: document_type_bool_exp!) {
  document_type(order_by: {creation_date: asc}, where: $where, limit: $limit, offset: $offset) {
    document_type_tenant_settings(where: {tenant: {_eq: $tenantId}}) {
      code
      default_flags
      meta
    }
    last_modified_date: last_modified_date
    name
    display_name
    translations
  }
  document_type_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdit_Get_Document_TypesQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Document_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Document_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Document_TypesQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdit_Get_Document_TypesQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>(Adit_Get_Document_TypesDocument, options);
      }
export function useAdit_Get_Document_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>(Adit_Get_Document_TypesDocument, options);
        }
export type Adit_Get_Document_TypesQueryHookResult = ReturnType<typeof useAdit_Get_Document_TypesQuery>;
export type Adit_Get_Document_TypesLazyQueryHookResult = ReturnType<typeof useAdit_Get_Document_TypesLazyQuery>;
export type Adit_Get_Document_TypesQueryResult = Apollo.QueryResult<Adit_Get_Document_TypesQuery, Adit_Get_Document_TypesQueryVariables>;
export const Adit_Get_Document_Type_FlagsDocument = gql`
    query ADIT_GET_DOCUMENT_TYPE_FLAGS {
  document_flag(where: {id: {_neq: 0}}, order_by: {id: asc}) {
    id
    name
    translation
    color
  }
}
    `;

/**
 * __useAdit_Get_Document_Type_FlagsQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Document_Type_FlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Document_Type_FlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Document_Type_FlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdit_Get_Document_Type_FlagsQuery(baseOptions?: Apollo.QueryHookOptions<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>(Adit_Get_Document_Type_FlagsDocument, options);
      }
export function useAdit_Get_Document_Type_FlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>(Adit_Get_Document_Type_FlagsDocument, options);
        }
export type Adit_Get_Document_Type_FlagsQueryHookResult = ReturnType<typeof useAdit_Get_Document_Type_FlagsQuery>;
export type Adit_Get_Document_Type_FlagsLazyQueryHookResult = ReturnType<typeof useAdit_Get_Document_Type_FlagsLazyQuery>;
export type Adit_Get_Document_Type_FlagsQueryResult = Apollo.QueryResult<Adit_Get_Document_Type_FlagsQuery, Adit_Get_Document_Type_FlagsQueryVariables>;
export const UpdateFileDocument = gql`
    mutation updateFile($id: [uuid!]!) {
  update_file(where: {id: {_in: $id}}, _set: {is_deleted: true}) {
    affected_rows
  }
}
    `;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const Adit_Get_EmailDocument = gql`
    query ADIT_GET_EMAIL($id: uuid!, $offset: Int, $limit: Int, $orderBy: String, $search: String) {
  emails: pp_email_search_hs(args: {_offset: $offset, _limit: $limit, _search: $search, _orderby: $orderBy}, where: {id: {_eq: $id}}) {
    id
    name
    meta
    file_status
    creation_user
    creation_date
    file_url
    company
    sender
    total_rows
    documents(where: {_or: {is_deleted: {_eq: false}, document_status: {_neq: "classified"}}}) {
      id
      document_type
      document_status
      document_name
      document_extension
      document_flags
      creation_date
      sequence
      meta
      document_blobs
      created_by_user {
        display_name
      }
      computedPagesM2M(where: {page_status: {_neq: "classified"}}) {
        id: page
        thumbnail_small_url
        thumbnail_big_url
        page_status
        rotate
        meta
      }
    }
  }
}
    `;

/**
 * __useAdit_Get_EmailQuery__
 *
 * To run a query within a React component, call `useAdit_Get_EmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_EmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_EmailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAdit_Get_EmailQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>(Adit_Get_EmailDocument, options);
      }
export function useAdit_Get_EmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>(Adit_Get_EmailDocument, options);
        }
export type Adit_Get_EmailQueryHookResult = ReturnType<typeof useAdit_Get_EmailQuery>;
export type Adit_Get_EmailLazyQueryHookResult = ReturnType<typeof useAdit_Get_EmailLazyQuery>;
export type Adit_Get_EmailQueryResult = Apollo.QueryResult<Adit_Get_EmailQuery, Adit_Get_EmailQueryVariables>;
export const GetEmailsDocument = gql`
    query getEmails($offset: Int, $limit: Int, $orderBy: String, $search: String) {
  pp_email_search_hs(args: {_offset: $offset, _limit: $limit, _search: $search, _orderby: $orderBy}, where: {documents: {_and: [{is_deleted: {_eq: false}}, {document_status: {_neq: "classified"}}, {document_status: {_neq: "classified_pending"}}]}}) {
    id
    name
    meta
    file_status
    creation_user
    creation_date
    file_url
    company
    sender
    total_rows
    documents(where: {_or: {is_deleted: {_eq: false}, document_status: {_neq: "classified"}}}) {
      id
      document_type
      document_status
      document_name
      document_extension
      document_flags
      creation_date
      sequence
      meta
      document_blobs
      created_by_user {
        display_name
      }
      pages_m2m_aggregate(where: {page: {page_status: {_neq: "classified"}}}) {
        aggregate {
          count
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmailsQuery__
 *
 * To run a query within a React component, call `useGetEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEmailsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailsQuery, GetEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailsQuery, GetEmailsQueryVariables>(GetEmailsDocument, options);
      }
export function useGetEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailsQuery, GetEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailsQuery, GetEmailsQueryVariables>(GetEmailsDocument, options);
        }
export type GetEmailsQueryHookResult = ReturnType<typeof useGetEmailsQuery>;
export type GetEmailsLazyQueryHookResult = ReturnType<typeof useGetEmailsLazyQuery>;
export type GetEmailsQueryResult = Apollo.QueryResult<GetEmailsQuery, GetEmailsQueryVariables>;
export const GetFileByIdentificationDocument = gql`
    query getFileByIdentification($fileNumber: String!) {
  file(where: {identification: {_eq: $fileNumber}}) {
    id
    file_status
    identification
    file_flags
  }
}
    `;

/**
 * __useGetFileByIdentificationQuery__
 *
 * To run a query within a React component, call `useGetFileByIdentificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileByIdentificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileByIdentificationQuery({
 *   variables: {
 *      fileNumber: // value for 'fileNumber'
 *   },
 * });
 */
export function useGetFileByIdentificationQuery(baseOptions: Apollo.QueryHookOptions<GetFileByIdentificationQuery, GetFileByIdentificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileByIdentificationQuery, GetFileByIdentificationQueryVariables>(GetFileByIdentificationDocument, options);
      }
export function useGetFileByIdentificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileByIdentificationQuery, GetFileByIdentificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileByIdentificationQuery, GetFileByIdentificationQueryVariables>(GetFileByIdentificationDocument, options);
        }
export type GetFileByIdentificationQueryHookResult = ReturnType<typeof useGetFileByIdentificationQuery>;
export type GetFileByIdentificationLazyQueryHookResult = ReturnType<typeof useGetFileByIdentificationLazyQuery>;
export type GetFileByIdentificationQueryResult = Apollo.QueryResult<GetFileByIdentificationQuery, GetFileByIdentificationQueryVariables>;
export const GetFilesForSubscriptionDocument = gql`
    query getFilesForSubscription($offset: Int, $limit: Int, $currUserId: uuid, $orderBy: String, $fileFlags: _int8, $minDate: timestamptz, $maxDate: timestamptz, $search: String, $orgIds: _int2, $myFilesOnly: Boolean, $fileStatuses: _text) {
  files: pp_file_search(args: {_limit: $limit, _offset: $offset, _orderby: $orderBy, _file_flags: $fileFlags, _max_date: $maxDate, _min_date: $minDate, _searchval: $search, _curr_userid: $currUserId, _org_ids: $orgIds, _my_files_only: $myFilesOnly, _file_statuses: $fileStatuses}) {
    id
    identification
    name
    org_id
    org_id_description
    meta
    file_flags
    file_status
    creation_user
    creation_date
    last_modified_date
    file_url
    total_rows
    customs_relevant
    extraction_required
  }
}
    `;

/**
 * __useGetFilesForSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetFilesForSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesForSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesForSubscriptionQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      currUserId: // value for 'currUserId'
 *      orderBy: // value for 'orderBy'
 *      fileFlags: // value for 'fileFlags'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      search: // value for 'search'
 *      orgIds: // value for 'orgIds'
 *      myFilesOnly: // value for 'myFilesOnly'
 *      fileStatuses: // value for 'fileStatuses'
 *   },
 * });
 */
export function useGetFilesForSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>(GetFilesForSubscriptionDocument, options);
      }
export function useGetFilesForSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>(GetFilesForSubscriptionDocument, options);
        }
export type GetFilesForSubscriptionQueryHookResult = ReturnType<typeof useGetFilesForSubscriptionQuery>;
export type GetFilesForSubscriptionLazyQueryHookResult = ReturnType<typeof useGetFilesForSubscriptionLazyQuery>;
export type GetFilesForSubscriptionQueryResult = Apollo.QueryResult<GetFilesForSubscriptionQuery, GetFilesForSubscriptionQueryVariables>;
export const Adit_Schedule_Data_ExtractionDocument = gql`
    mutation ADIT_SCHEDULE_DATA_EXTRACTION($fileId: ID!, $drNo: Int!) {
  scheduleAldiSrvProcessing(fileId: $fileId, drNo: $drNo)
}
    `;
export type Adit_Schedule_Data_ExtractionMutationFn = Apollo.MutationFunction<Adit_Schedule_Data_ExtractionMutation, Adit_Schedule_Data_ExtractionMutationVariables>;

/**
 * __useAdit_Schedule_Data_ExtractionMutation__
 *
 * To run a mutation, you first call `useAdit_Schedule_Data_ExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Schedule_Data_ExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditScheduleDataExtractionMutation, { data, loading, error }] = useAdit_Schedule_Data_ExtractionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      drNo: // value for 'drNo'
 *   },
 * });
 */
export function useAdit_Schedule_Data_ExtractionMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Schedule_Data_ExtractionMutation, Adit_Schedule_Data_ExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Schedule_Data_ExtractionMutation, Adit_Schedule_Data_ExtractionMutationVariables>(Adit_Schedule_Data_ExtractionDocument, options);
      }
export type Adit_Schedule_Data_ExtractionMutationHookResult = ReturnType<typeof useAdit_Schedule_Data_ExtractionMutation>;
export type Adit_Schedule_Data_ExtractionMutationResult = Apollo.MutationResult<Adit_Schedule_Data_ExtractionMutation>;
export type Adit_Schedule_Data_ExtractionMutationOptions = Apollo.BaseMutationOptions<Adit_Schedule_Data_ExtractionMutation, Adit_Schedule_Data_ExtractionMutationVariables>;
export const AditUpdateFileNumberDocument = gql`
    mutation ADITUpdateFileNumber($file_id: ID!, $file_number: String!) {
  updateFileNumber(file_id: $file_id, file_number: $file_number) {
    file_id
  }
}
    `;
export type AditUpdateFileNumberMutationFn = Apollo.MutationFunction<AditUpdateFileNumberMutation, AditUpdateFileNumberMutationVariables>;

/**
 * __useAditUpdateFileNumberMutation__
 *
 * To run a mutation, you first call `useAditUpdateFileNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateFileNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateFileNumberMutation, { data, loading, error }] = useAditUpdateFileNumberMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      file_number: // value for 'file_number'
 *   },
 * });
 */
export function useAditUpdateFileNumberMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateFileNumberMutation, AditUpdateFileNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateFileNumberMutation, AditUpdateFileNumberMutationVariables>(AditUpdateFileNumberDocument, options);
      }
export type AditUpdateFileNumberMutationHookResult = ReturnType<typeof useAditUpdateFileNumberMutation>;
export type AditUpdateFileNumberMutationResult = Apollo.MutationResult<AditUpdateFileNumberMutation>;
export type AditUpdateFileNumberMutationOptions = Apollo.BaseMutationOptions<AditUpdateFileNumberMutation, AditUpdateFileNumberMutationVariables>;
export const Wd_Get_Import_List_TriggersDocument = gql`
    query WD_GET_IMPORT_LIST_TRIGGERS($limit: Int, $offset: Int) {
  import_list_trigger: import_list_trigger(limit: $limit, offset: $offset, order_by: {creation_date: desc_nulls_first}) {
    id
    display_name
    type
    config
    creation_date
    creation_user
    last_modified_date
    last_modified_user
    creationUser {
      display_name
    }
    lastModifiedUser {
      display_name
    }
    meta
    label_id
    label {
      id
      title
      description
      color
      is_deleted
    }
  }
  import_list_trigger_aggregate {
    aggregate {
      totalCount: count
    }
  }
}
    `;

/**
 * __useWd_Get_Import_List_TriggersQuery__
 *
 * To run a query within a React component, call `useWd_Get_Import_List_TriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWd_Get_Import_List_TriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWd_Get_Import_List_TriggersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useWd_Get_Import_List_TriggersQuery(baseOptions?: Apollo.QueryHookOptions<Wd_Get_Import_List_TriggersQuery, Wd_Get_Import_List_TriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Wd_Get_Import_List_TriggersQuery, Wd_Get_Import_List_TriggersQueryVariables>(Wd_Get_Import_List_TriggersDocument, options);
      }
export function useWd_Get_Import_List_TriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Wd_Get_Import_List_TriggersQuery, Wd_Get_Import_List_TriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Wd_Get_Import_List_TriggersQuery, Wd_Get_Import_List_TriggersQueryVariables>(Wd_Get_Import_List_TriggersDocument, options);
        }
export type Wd_Get_Import_List_TriggersQueryHookResult = ReturnType<typeof useWd_Get_Import_List_TriggersQuery>;
export type Wd_Get_Import_List_TriggersLazyQueryHookResult = ReturnType<typeof useWd_Get_Import_List_TriggersLazyQuery>;
export type Wd_Get_Import_List_TriggersQueryResult = Apollo.QueryResult<Wd_Get_Import_List_TriggersQuery, Wd_Get_Import_List_TriggersQueryVariables>;
export const AditGetOrgIdsListDocument = gql`
    query AditGetOrgIdsList($ids: [Int!]) {
  orgIds: getOrgIds(ids: $ids) {
    ...OrgIdsListFragment
  }
}
    ${OrgIdsListFragmentFragmentDoc}`;

/**
 * __useAditGetOrgIdsListQuery__
 *
 * To run a query within a React component, call `useAditGetOrgIdsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetOrgIdsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetOrgIdsListQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAditGetOrgIdsListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>(AditGetOrgIdsListDocument, options);
      }
export function useAditGetOrgIdsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>(AditGetOrgIdsListDocument, options);
        }
export type AditGetOrgIdsListQueryHookResult = ReturnType<typeof useAditGetOrgIdsListQuery>;
export type AditGetOrgIdsListLazyQueryHookResult = ReturnType<typeof useAditGetOrgIdsListLazyQuery>;
export type AditGetOrgIdsListQueryResult = Apollo.QueryResult<AditGetOrgIdsListQuery, AditGetOrgIdsListQueryVariables>;
export const AditGetUserOrgIdsListDocument = gql`
    query AditGetUserOrgIdsList {
  userOrgIds: getUserOrgIds {
    ...OrgIdsListFragment
  }
}
    ${OrgIdsListFragmentFragmentDoc}`;

/**
 * __useAditGetUserOrgIdsListQuery__
 *
 * To run a query within a React component, call `useAditGetUserOrgIdsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetUserOrgIdsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetUserOrgIdsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetUserOrgIdsListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>(AditGetUserOrgIdsListDocument, options);
      }
export function useAditGetUserOrgIdsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>(AditGetUserOrgIdsListDocument, options);
        }
export type AditGetUserOrgIdsListQueryHookResult = ReturnType<typeof useAditGetUserOrgIdsListQuery>;
export type AditGetUserOrgIdsListLazyQueryHookResult = ReturnType<typeof useAditGetUserOrgIdsListLazyQuery>;
export type AditGetUserOrgIdsListQueryResult = Apollo.QueryResult<AditGetUserOrgIdsListQuery, AditGetUserOrgIdsListQueryVariables>;
export const GetTenantAddressesListDocument = gql`
    query GetTenantAddressesList($addressType: Int!, $tenantId: UUID, $search: String) {
  tenantAddresses: getTenantAddresses(limit: 50, addressType: $addressType, selectedTenantId: $tenantId, search: $search) {
    id
    companyName
    country
    city
    street
    streetNumber
    zipcode
    reference
  }
}
    `;

/**
 * __useGetTenantAddressesListQuery__
 *
 * To run a query within a React component, call `useGetTenantAddressesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantAddressesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantAddressesListQuery({
 *   variables: {
 *      addressType: // value for 'addressType'
 *      tenantId: // value for 'tenantId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTenantAddressesListQuery(baseOptions: Apollo.QueryHookOptions<GetTenantAddressesListQuery, GetTenantAddressesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantAddressesListQuery, GetTenantAddressesListQueryVariables>(GetTenantAddressesListDocument, options);
      }
export function useGetTenantAddressesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantAddressesListQuery, GetTenantAddressesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantAddressesListQuery, GetTenantAddressesListQueryVariables>(GetTenantAddressesListDocument, options);
        }
export type GetTenantAddressesListQueryHookResult = ReturnType<typeof useGetTenantAddressesListQuery>;
export type GetTenantAddressesListLazyQueryHookResult = ReturnType<typeof useGetTenantAddressesListLazyQuery>;
export type GetTenantAddressesListQueryResult = Apollo.QueryResult<GetTenantAddressesListQuery, GetTenantAddressesListQueryVariables>;
export const WdGetTenantsListDocument = gql`
    query WdGetTenantsList {
  tenants: tenant {
    id
    tenant_name
    permissions_js
    address {
      id
      company_name
      address_type
    }
  }
}
    `;

/**
 * __useWdGetTenantsListQuery__
 *
 * To run a query within a React component, call `useWdGetTenantsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetTenantsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetTenantsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useWdGetTenantsListQuery(baseOptions?: Apollo.QueryHookOptions<WdGetTenantsListQuery, WdGetTenantsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetTenantsListQuery, WdGetTenantsListQueryVariables>(WdGetTenantsListDocument, options);
      }
export function useWdGetTenantsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetTenantsListQuery, WdGetTenantsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetTenantsListQuery, WdGetTenantsListQueryVariables>(WdGetTenantsListDocument, options);
        }
export type WdGetTenantsListQueryHookResult = ReturnType<typeof useWdGetTenantsListQuery>;
export type WdGetTenantsListLazyQueryHookResult = ReturnType<typeof useWdGetTenantsListLazyQuery>;
export type WdGetTenantsListQueryResult = Apollo.QueryResult<WdGetTenantsListQuery, WdGetTenantsListQueryVariables>;
export const AditGetRolesListDocument = gql`
    query AditGetRolesList {
  roles: getAditRoles {
    ...RolesList
  }
}
    ${RolesListFragmentDoc}`;

/**
 * __useAditGetRolesListQuery__
 *
 * To run a query within a React component, call `useAditGetRolesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetRolesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetRolesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetRolesListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetRolesListQuery, AditGetRolesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetRolesListQuery, AditGetRolesListQueryVariables>(AditGetRolesListDocument, options);
      }
export function useAditGetRolesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetRolesListQuery, AditGetRolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetRolesListQuery, AditGetRolesListQueryVariables>(AditGetRolesListDocument, options);
        }
export type AditGetRolesListQueryHookResult = ReturnType<typeof useAditGetRolesListQuery>;
export type AditGetRolesListLazyQueryHookResult = ReturnType<typeof useAditGetRolesListLazyQuery>;
export type AditGetRolesListQueryResult = Apollo.QueryResult<AditGetRolesListQuery, AditGetRolesListQueryVariables>;
export const WdGetRolesListDocument = gql`
    query WdGetRolesList {
  roles: getWDRoles {
    ...RolesList
  }
}
    ${RolesListFragmentDoc}`;

/**
 * __useWdGetRolesListQuery__
 *
 * To run a query within a React component, call `useWdGetRolesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetRolesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetRolesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useWdGetRolesListQuery(baseOptions?: Apollo.QueryHookOptions<WdGetRolesListQuery, WdGetRolesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetRolesListQuery, WdGetRolesListQueryVariables>(WdGetRolesListDocument, options);
      }
export function useWdGetRolesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetRolesListQuery, WdGetRolesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetRolesListQuery, WdGetRolesListQueryVariables>(WdGetRolesListDocument, options);
        }
export type WdGetRolesListQueryHookResult = ReturnType<typeof useWdGetRolesListQuery>;
export type WdGetRolesListLazyQueryHookResult = ReturnType<typeof useWdGetRolesListLazyQuery>;
export type WdGetRolesListQueryResult = Apollo.QueryResult<WdGetRolesListQuery, WdGetRolesListQueryVariables>;
export const Update_Page_Extract_ValueDocument = gql`
    mutation UPDATE_PAGE_EXTRACT_VALUE($value: page_extract_append_input!, $pageId: uuid!, $extract_type_id: smallint!) {
  update_page_extract_by_pk(pk_columns: {extract_type_id: $extract_type_id, page_id: $pageId}, _append: $value) {
    value
  }
}
    `;
export type Update_Page_Extract_ValueMutationFn = Apollo.MutationFunction<Update_Page_Extract_ValueMutation, Update_Page_Extract_ValueMutationVariables>;

/**
 * __useUpdate_Page_Extract_ValueMutation__
 *
 * To run a mutation, you first call `useUpdate_Page_Extract_ValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Page_Extract_ValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageExtractValueMutation, { data, loading, error }] = useUpdate_Page_Extract_ValueMutation({
 *   variables: {
 *      value: // value for 'value'
 *      pageId: // value for 'pageId'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function useUpdate_Page_Extract_ValueMutation(baseOptions?: Apollo.MutationHookOptions<Update_Page_Extract_ValueMutation, Update_Page_Extract_ValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Page_Extract_ValueMutation, Update_Page_Extract_ValueMutationVariables>(Update_Page_Extract_ValueDocument, options);
      }
export type Update_Page_Extract_ValueMutationHookResult = ReturnType<typeof useUpdate_Page_Extract_ValueMutation>;
export type Update_Page_Extract_ValueMutationResult = Apollo.MutationResult<Update_Page_Extract_ValueMutation>;
export type Update_Page_Extract_ValueMutationOptions = Apollo.BaseMutationOptions<Update_Page_Extract_ValueMutation, Update_Page_Extract_ValueMutationVariables>;
export const Upsert_Page_Extract_ValueDocument = gql`
    mutation UPSERT_PAGE_EXTRACT_VALUE($pageId: uuid!, $value: jsonb!, $extract_type_id: smallint!) {
  insert_page_extract(objects: {extract_type_id: $extract_type_id, page_id: $pageId, value: {}}, on_conflict: {constraint: page_extract_pk, update_columns: []}) {
    returning {
      page_id
    }
    affected_rows
  }
  update_page_extract_by_pk(pk_columns: {extract_type_id: $extract_type_id, page_id: $pageId}, _append: {value: $value}) {
    page_id
  }
}
    `;
export type Upsert_Page_Extract_ValueMutationFn = Apollo.MutationFunction<Upsert_Page_Extract_ValueMutation, Upsert_Page_Extract_ValueMutationVariables>;

/**
 * __useUpsert_Page_Extract_ValueMutation__
 *
 * To run a mutation, you first call `useUpsert_Page_Extract_ValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsert_Page_Extract_ValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPageExtractValueMutation, { data, loading, error }] = useUpsert_Page_Extract_ValueMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      value: // value for 'value'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function useUpsert_Page_Extract_ValueMutation(baseOptions?: Apollo.MutationHookOptions<Upsert_Page_Extract_ValueMutation, Upsert_Page_Extract_ValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Upsert_Page_Extract_ValueMutation, Upsert_Page_Extract_ValueMutationVariables>(Upsert_Page_Extract_ValueDocument, options);
      }
export type Upsert_Page_Extract_ValueMutationHookResult = ReturnType<typeof useUpsert_Page_Extract_ValueMutation>;
export type Upsert_Page_Extract_ValueMutationResult = Apollo.MutationResult<Upsert_Page_Extract_ValueMutation>;
export type Upsert_Page_Extract_ValueMutationOptions = Apollo.BaseMutationOptions<Upsert_Page_Extract_ValueMutation, Upsert_Page_Extract_ValueMutationVariables>;
export const Update_Page_ClobDocument = gql`
    mutation update_page_clob($pageId: uuid!, $dataPointId: String!, $extract_type_id: smallint!) {
  update_page_extract(where: {_and: [{page_id: {_eq: $pageId}}, {extract_type_id: {_eq: $extract_type_id}}]}, _delete_key: {value: $dataPointId}) {
    returning {
      page_id
    }
  }
}
    `;
export type Update_Page_ClobMutationFn = Apollo.MutationFunction<Update_Page_ClobMutation, Update_Page_ClobMutationVariables>;

/**
 * __useUpdate_Page_ClobMutation__
 *
 * To run a mutation, you first call `useUpdate_Page_ClobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Page_ClobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageClobMutation, { data, loading, error }] = useUpdate_Page_ClobMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      dataPointId: // value for 'dataPointId'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function useUpdate_Page_ClobMutation(baseOptions?: Apollo.MutationHookOptions<Update_Page_ClobMutation, Update_Page_ClobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Update_Page_ClobMutation, Update_Page_ClobMutationVariables>(Update_Page_ClobDocument, options);
      }
export type Update_Page_ClobMutationHookResult = ReturnType<typeof useUpdate_Page_ClobMutation>;
export type Update_Page_ClobMutationResult = Apollo.MutationResult<Update_Page_ClobMutation>;
export type Update_Page_ClobMutationOptions = Apollo.BaseMutationOptions<Update_Page_ClobMutation, Update_Page_ClobMutationVariables>;
export const Pp_Page_Extract_Text_Fragment_V2Document = gql`
    query pp_page_extract_text_fragment_v2($pageId: uuid!, $x: numeric!, $y: numeric!, $width: numeric!, $height: numeric!, $extract_type_id: smallint!) {
  pp_page_extract_text_fragment_v2(args: {_pageid: $pageId, _x: $x, _y: $y, _width: $width, _height: $height, _extract_type_id: $extract_type_id}) {
    json_value
  }
}
    `;

/**
 * __usePp_Page_Extract_Text_Fragment_V2Query__
 *
 * To run a query within a React component, call `usePp_Page_Extract_Text_Fragment_V2Query` and pass it any options that fit your needs.
 * When your component renders, `usePp_Page_Extract_Text_Fragment_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePp_Page_Extract_Text_Fragment_V2Query({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      extract_type_id: // value for 'extract_type_id'
 *   },
 * });
 */
export function usePp_Page_Extract_Text_Fragment_V2Query(baseOptions: Apollo.QueryHookOptions<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>(Pp_Page_Extract_Text_Fragment_V2Document, options);
      }
export function usePp_Page_Extract_Text_Fragment_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>(Pp_Page_Extract_Text_Fragment_V2Document, options);
        }
export type Pp_Page_Extract_Text_Fragment_V2QueryHookResult = ReturnType<typeof usePp_Page_Extract_Text_Fragment_V2Query>;
export type Pp_Page_Extract_Text_Fragment_V2LazyQueryHookResult = ReturnType<typeof usePp_Page_Extract_Text_Fragment_V2LazyQuery>;
export type Pp_Page_Extract_Text_Fragment_V2QueryResult = Apollo.QueryResult<Pp_Page_Extract_Text_Fragment_V2Query, Pp_Page_Extract_Text_Fragment_V2QueryVariables>;
export const Delete_AddressDocument = gql`
    mutation DELETE_ADDRESS($id: Int) {
  delete_address(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type Delete_AddressMutationFn = Apollo.MutationFunction<Delete_AddressMutation, Delete_AddressMutationVariables>;

/**
 * __useDelete_AddressMutation__
 *
 * To run a mutation, you first call `useDelete_AddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_AddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAddressMutation, { data, loading, error }] = useDelete_AddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_AddressMutation(baseOptions?: Apollo.MutationHookOptions<Delete_AddressMutation, Delete_AddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_AddressMutation, Delete_AddressMutationVariables>(Delete_AddressDocument, options);
      }
export type Delete_AddressMutationHookResult = ReturnType<typeof useDelete_AddressMutation>;
export type Delete_AddressMutationResult = Apollo.MutationResult<Delete_AddressMutation>;
export type Delete_AddressMutationOptions = Apollo.BaseMutationOptions<Delete_AddressMutation, Delete_AddressMutationVariables>;
export const Delete_Org_IdDocument = gql`
    query DELETE_ORG_ID($org_id: smallint!) {
  pp_org_id_delete(args: {_org_id: $org_id, _force: false}) {
    json_value
  }
}
    `;

/**
 * __useDelete_Org_IdQuery__
 *
 * To run a query within a React component, call `useDelete_Org_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDelete_Org_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDelete_Org_IdQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *   },
 * });
 */
export function useDelete_Org_IdQuery(baseOptions: Apollo.QueryHookOptions<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>(Delete_Org_IdDocument, options);
      }
export function useDelete_Org_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>(Delete_Org_IdDocument, options);
        }
export type Delete_Org_IdQueryHookResult = ReturnType<typeof useDelete_Org_IdQuery>;
export type Delete_Org_IdLazyQueryHookResult = ReturnType<typeof useDelete_Org_IdLazyQuery>;
export type Delete_Org_IdQueryResult = Apollo.QueryResult<Delete_Org_IdQuery, Delete_Org_IdQueryVariables>;
export const AditExportDeclarationDocument = gql`
    mutation AditExportDeclaration($fileId: String!, $drNo: Float!) {
  exportDeclaration(exportDeclarationInput: {fileId: $fileId, drNo: $drNo})
}
    `;
export type AditExportDeclarationMutationFn = Apollo.MutationFunction<AditExportDeclarationMutation, AditExportDeclarationMutationVariables>;

/**
 * __useAditExportDeclarationMutation__
 *
 * To run a mutation, you first call `useAditExportDeclarationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditExportDeclarationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditExportDeclarationMutation, { data, loading, error }] = useAditExportDeclarationMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      drNo: // value for 'drNo'
 *   },
 * });
 */
export function useAditExportDeclarationMutation(baseOptions?: Apollo.MutationHookOptions<AditExportDeclarationMutation, AditExportDeclarationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditExportDeclarationMutation, AditExportDeclarationMutationVariables>(AditExportDeclarationDocument, options);
      }
export type AditExportDeclarationMutationHookResult = ReturnType<typeof useAditExportDeclarationMutation>;
export type AditExportDeclarationMutationResult = Apollo.MutationResult<AditExportDeclarationMutation>;
export type AditExportDeclarationMutationOptions = Apollo.BaseMutationOptions<AditExportDeclarationMutation, AditExportDeclarationMutationVariables>;
export const Adit_Get_Pp_AddressDocument = gql`
    query ADIT_GET_PP_ADDRESS($search: String, $offset: Int, $limit: Int, $address_types: _int4) {
  pp_addresses(args: {_search: $search, _offset: $offset, _limit: $limit, _address_types: $address_types}) {
    company_name
    address_type
    city
    contact_email
    contact_phone
    contact_website
    country
    id
    street
    street_number
    zipcode
    reference
    creation_date
    creation_user
    last_modified_date
    last_modified_user
    qty
  }
}
    `;

/**
 * __useAdit_Get_Pp_AddressQuery__
 *
 * To run a query within a React component, call `useAdit_Get_Pp_AddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Pp_AddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Pp_AddressQuery({
 *   variables: {
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      address_types: // value for 'address_types'
 *   },
 * });
 */
export function useAdit_Get_Pp_AddressQuery(baseOptions?: Apollo.QueryHookOptions<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>(Adit_Get_Pp_AddressDocument, options);
      }
export function useAdit_Get_Pp_AddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>(Adit_Get_Pp_AddressDocument, options);
        }
export type Adit_Get_Pp_AddressQueryHookResult = ReturnType<typeof useAdit_Get_Pp_AddressQuery>;
export type Adit_Get_Pp_AddressLazyQueryHookResult = ReturnType<typeof useAdit_Get_Pp_AddressLazyQuery>;
export type Adit_Get_Pp_AddressQueryResult = Apollo.QueryResult<Adit_Get_Pp_AddressQuery, Adit_Get_Pp_AddressQueryVariables>;
export const Get_Address_TypeDocument = gql`
    query GET_ADDRESS_TYPE {
  address_type {
    id
    name
    translation
  }
}
    `;

/**
 * __useGet_Address_TypeQuery__
 *
 * To run a query within a React component, call `useGet_Address_TypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Address_TypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Address_TypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_Address_TypeQuery(baseOptions?: Apollo.QueryHookOptions<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>(Get_Address_TypeDocument, options);
      }
export function useGet_Address_TypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>(Get_Address_TypeDocument, options);
        }
export type Get_Address_TypeQueryHookResult = ReturnType<typeof useGet_Address_TypeQuery>;
export type Get_Address_TypeLazyQueryHookResult = ReturnType<typeof useGet_Address_TypeLazyQuery>;
export type Get_Address_TypeQueryResult = Apollo.QueryResult<Get_Address_TypeQuery, Get_Address_TypeQueryVariables>;
export const GetAiStatsDocument = gql`
    query getAiStats($started: timestamptz, $ended: timestamptz, $onlyAiDoctypes: Boolean, $userIds: _uuid, $orgIds: _int2) {
  pp_ai_stats(args: {_started: $started, _ended: $ended, _only_ai_doctypes: $onlyAiDoctypes, _orgids: $orgIds, _crusers: $userIds}, where: {_not: {document_type: {_eq: "TOTAL"}}}) {
    document_type
    success_ratio
    total
    types_match
    unknowns
    unknowns_pct
  }
}
    `;

/**
 * __useGetAiStatsQuery__
 *
 * To run a query within a React component, call `useGetAiStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiStatsQuery({
 *   variables: {
 *      started: // value for 'started'
 *      ended: // value for 'ended'
 *      onlyAiDoctypes: // value for 'onlyAiDoctypes'
 *      userIds: // value for 'userIds'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetAiStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAiStatsQuery, GetAiStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiStatsQuery, GetAiStatsQueryVariables>(GetAiStatsDocument, options);
      }
export function useGetAiStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiStatsQuery, GetAiStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiStatsQuery, GetAiStatsQueryVariables>(GetAiStatsDocument, options);
        }
export type GetAiStatsQueryHookResult = ReturnType<typeof useGetAiStatsQuery>;
export type GetAiStatsLazyQueryHookResult = ReturnType<typeof useGetAiStatsLazyQuery>;
export type GetAiStatsQueryResult = Apollo.QueryResult<GetAiStatsQuery, GetAiStatsQueryVariables>;
export const GetAiStatsByDayDocument = gql`
    query getAiStatsByDay($started: timestamptz, $ended: timestamptz, $onlyAiDoctypes: Boolean, $userIds: _uuid, $orgIds: _int2) {
  pp_ai_stats_dt(args: {_started: $started, _ended: $ended, _only_ai_doctypes: $onlyAiDoctypes, _orgids: $orgIds, _crusers: $userIds}) {
    creation_date
    docs_qty
    document_type
    pages_qty
    success_ratio
    types_match
    unknowns
    unknowns_pct
  }
}
    `;

/**
 * __useGetAiStatsByDayQuery__
 *
 * To run a query within a React component, call `useGetAiStatsByDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiStatsByDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiStatsByDayQuery({
 *   variables: {
 *      started: // value for 'started'
 *      ended: // value for 'ended'
 *      onlyAiDoctypes: // value for 'onlyAiDoctypes'
 *      userIds: // value for 'userIds'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetAiStatsByDayQuery(baseOptions?: Apollo.QueryHookOptions<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>(GetAiStatsByDayDocument, options);
      }
export function useGetAiStatsByDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>(GetAiStatsByDayDocument, options);
        }
export type GetAiStatsByDayQueryHookResult = ReturnType<typeof useGetAiStatsByDayQuery>;
export type GetAiStatsByDayLazyQueryHookResult = ReturnType<typeof useGetAiStatsByDayLazyQuery>;
export type GetAiStatsByDayQueryResult = Apollo.QueryResult<GetAiStatsByDayQuery, GetAiStatsByDayQueryVariables>;
export const Get_Api_KeysDocument = gql`
    query GET_API_KEYS {
  accessTokens: api_key(order_by: {dsplay_name: asc}) {
    id
    api_key
    meta
    display_name: dsplay_name
  }
}
    `;

/**
 * __useGet_Api_KeysQuery__
 *
 * To run a query within a React component, call `useGet_Api_KeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Api_KeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Api_KeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_Api_KeysQuery(baseOptions?: Apollo.QueryHookOptions<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>(Get_Api_KeysDocument, options);
      }
export function useGet_Api_KeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>(Get_Api_KeysDocument, options);
        }
export type Get_Api_KeysQueryHookResult = ReturnType<typeof useGet_Api_KeysQuery>;
export type Get_Api_KeysLazyQueryHookResult = ReturnType<typeof useGet_Api_KeysLazyQuery>;
export type Get_Api_KeysQueryResult = Apollo.QueryResult<Get_Api_KeysQuery, Get_Api_KeysQueryVariables>;
export const GetDeclarationWithDocumentsDocument = gql`
    query getDeclarationWithDocuments($declarationId: _uuid) {
  declaration_request: pp_declaration_request(args: {_file_ids: $declarationId}) {
    file {
      id
      identification
      documents(where: {pages_m2m: {page: {page_status: {_neq: "classified"}}}, document_status: {_neq: "classified"}, is_deleted: {_eq: false}}) {
        id
        name: document_name
        meta
        document_status
        document_type
        pages: pages_m2m(order_by: {page_number: asc}, where: {page: {page_status: {_neq: "classified"}}}) {
          page {
            id
            thumbnailBigUrl: thumbnail_big_url
            page_status
            rotate
            meta
            creation_user
          }
          page_number
        }
        document_blobs
        document_flags
      }
    }
    declaration_discussions {
      discussion_id
      creation_user
    }
    payer {
      id
      tenantName: tenant_name
    }
    toll_dep
    eta
    declaration_request_addresses {
      address_id
      refs
      address_type
      address {
        id
        company_name
        company_name_2
        country
        street
        city
        zipcode
        reference
        street_number
        customs_account_number
        is_locked
        uid_number
        usage_frequency
        vat_account_number
        trader_identification_number
        is_platform_user
      }
    }
    declaration {
      total_gross_weight
      total_colis
      customs_office_number
    }
  }
}
    `;

/**
 * __useGetDeclarationWithDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDeclarationWithDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeclarationWithDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeclarationWithDocumentsQuery({
 *   variables: {
 *      declarationId: // value for 'declarationId'
 *   },
 * });
 */
export function useGetDeclarationWithDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>(GetDeclarationWithDocumentsDocument, options);
      }
export function useGetDeclarationWithDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>(GetDeclarationWithDocumentsDocument, options);
        }
export type GetDeclarationWithDocumentsQueryHookResult = ReturnType<typeof useGetDeclarationWithDocumentsQuery>;
export type GetDeclarationWithDocumentsLazyQueryHookResult = ReturnType<typeof useGetDeclarationWithDocumentsLazyQuery>;
export type GetDeclarationWithDocumentsQueryResult = Apollo.QueryResult<GetDeclarationWithDocumentsQuery, GetDeclarationWithDocumentsQueryVariables>;
export const Adit_Get_Declaration_Tasks_V2Document = gql`
    query ADIT_GET_DECLARATION_TASKS_V2($assigned_to: uuid, $min_due_date: timestamptz, $max_due_date: timestamptz, $task_type_id: Int, $creation_date: timestamptz, $search: String, $limit: Int = 6, $offset: Int = 0, $task_status_id: Int = 0, $orderby: String) {
  declaration_task: pp_declaration_tasks(args: {_assigned_to: $assigned_to, _min_due_date: $min_due_date, _max_due_date: $max_due_date, _task_type_id: $task_type_id, _creation_date: $creation_date, _search: $search, _task_status_id: $task_status_id, _limit: $limit, _offset: $offset, _orderby: $orderby}) {
    id
    title
    assigned_to
    assigned_user {
      id
      display_name
      __typename
    }
    creation_date
    task_type_id
    due_date
    meta
    object_id
    task_status_id
    task_type {
      display_name
      __typename
    }
    document {
      document_flags
      documentFile {
        id
        identification
        __typename
      }
      documentType {
        translations
        __typename
      }
      __typename
    }
    file {
      id
      identification
      __typename
    }
    rn
    qty
  }
}
    `;

/**
 * __useAdit_Get_Declaration_Tasks_V2Query__
 *
 * To run a query within a React component, call `useAdit_Get_Declaration_Tasks_V2Query` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_Declaration_Tasks_V2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_Declaration_Tasks_V2Query({
 *   variables: {
 *      assigned_to: // value for 'assigned_to'
 *      min_due_date: // value for 'min_due_date'
 *      max_due_date: // value for 'max_due_date'
 *      task_type_id: // value for 'task_type_id'
 *      creation_date: // value for 'creation_date'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      task_status_id: // value for 'task_status_id'
 *      orderby: // value for 'orderby'
 *   },
 * });
 */
export function useAdit_Get_Declaration_Tasks_V2Query(baseOptions?: Apollo.QueryHookOptions<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>(Adit_Get_Declaration_Tasks_V2Document, options);
      }
export function useAdit_Get_Declaration_Tasks_V2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>(Adit_Get_Declaration_Tasks_V2Document, options);
        }
export type Adit_Get_Declaration_Tasks_V2QueryHookResult = ReturnType<typeof useAdit_Get_Declaration_Tasks_V2Query>;
export type Adit_Get_Declaration_Tasks_V2LazyQueryHookResult = ReturnType<typeof useAdit_Get_Declaration_Tasks_V2LazyQuery>;
export type Adit_Get_Declaration_Tasks_V2QueryResult = Apollo.QueryResult<Adit_Get_Declaration_Tasks_V2Query, Adit_Get_Declaration_Tasks_V2QueryVariables>;
export const GetDocumentPagesDocument = gql`
    query getDocumentPages($documentId: uuid!) {
  document(where: {id: {_eq: $documentId}}) {
    pages: pages_m2m(where: {page: {page_status: {_neq: "classified"}}}) {
      page {
        id
        rotate
        thumbnailBigUrl: thumbnail_big_url
        thumbnailSmallUrl: thumbnail_small_url
        meta
      }
      page_number
    }
  }
}
    `;

/**
 * __useGetDocumentPagesQuery__
 *
 * To run a query within a React component, call `useGetDocumentPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentPagesQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetDocumentPagesQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>(GetDocumentPagesDocument, options);
      }
export function useGetDocumentPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>(GetDocumentPagesDocument, options);
        }
export type GetDocumentPagesQueryHookResult = ReturnType<typeof useGetDocumentPagesQuery>;
export type GetDocumentPagesLazyQueryHookResult = ReturnType<typeof useGetDocumentPagesLazyQuery>;
export type GetDocumentPagesQueryResult = Apollo.QueryResult<GetDocumentPagesQuery, GetDocumentPagesQueryVariables>;
export const GetDocumentStatsDocument = gql`
    query getDocumentStats($started: timestamptz, $ended: timestamptz, $userIds: _uuid, $orgIds: _int2, $tenant: uuid) {
  pp_doc_stats(args: {_started: $started, _ended: $ended, _orgids: $orgIds, _crusers: $userIds, _tenant: $tenant}) {
    docs_qty
    document_type
    total_pages
    users_qty
  }
}
    `;

/**
 * __useGetDocumentStatsQuery__
 *
 * To run a query within a React component, call `useGetDocumentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentStatsQuery({
 *   variables: {
 *      started: // value for 'started'
 *      ended: // value for 'ended'
 *      userIds: // value for 'userIds'
 *      orgIds: // value for 'orgIds'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useGetDocumentStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>(GetDocumentStatsDocument, options);
      }
export function useGetDocumentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>(GetDocumentStatsDocument, options);
        }
export type GetDocumentStatsQueryHookResult = ReturnType<typeof useGetDocumentStatsQuery>;
export type GetDocumentStatsLazyQueryHookResult = ReturnType<typeof useGetDocumentStatsLazyQuery>;
export type GetDocumentStatsQueryResult = Apollo.QueryResult<GetDocumentStatsQuery, GetDocumentStatsQueryVariables>;
export const GetDocumentsDocument = gql`
    query getDocuments($ids: _uuid) {
  documents: pp_document(args: {_ids: $ids}, limit: 1024) {
    id
    name: document_name
    meta
    pages: pages_m2m(order_by: {page_number: asc}) {
      page {
        id
        thumbnailBigUrl: thumbnail_big_url
        page_status
        rotate
        meta
        creation_user
      }
      page_number
    }
    document_blobs
    document_flags
  }
}
    `;

/**
 * __useGetDocumentsQuery__
 *
 * To run a query within a React component, call `useGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
      }
export function useGetDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsQuery, GetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsQuery, GetDocumentsQueryVariables>(GetDocumentsDocument, options);
        }
export type GetDocumentsQueryHookResult = ReturnType<typeof useGetDocumentsQuery>;
export type GetDocumentsLazyQueryHookResult = ReturnType<typeof useGetDocumentsLazyQuery>;
export type GetDocumentsQueryResult = Apollo.QueryResult<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const GetFilesPagesDocument = gql`
    query getFilesPages($fileNumber: uuid!) {
  files: vw_finished_files(where: {id: {_eq: $fileNumber}}) {
    documents(limit: 30, order_by: {creation_date: desc}, where: {_and: {document_type: {_neq: "customs_overview"}, document_status: {_neq: "classified"}, is_deleted: {_eq: false}}}) {
      id
      document_type
      document_status
      document_name
      document_flags
      last_modified_date
      sequence
      meta
      created_by_user {
        display_name
      }
      document_blobs(path: "blobs")
      documentType {
        translations
      }
      pages: pages_m2m(order_by: {page_number: asc}) {
        page {
          id
          rotate
          thumbnailBigUrl: thumbnail_big_url
          thumbnailSmallUrl: thumbnail_small_url
          page_status
          meta
        }
        page_number
      }
    }
  }
}
    `;

/**
 * __useGetFilesPagesQuery__
 *
 * To run a query within a React component, call `useGetFilesPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesPagesQuery({
 *   variables: {
 *      fileNumber: // value for 'fileNumber'
 *   },
 * });
 */
export function useGetFilesPagesQuery(baseOptions: Apollo.QueryHookOptions<GetFilesPagesQuery, GetFilesPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesPagesQuery, GetFilesPagesQueryVariables>(GetFilesPagesDocument, options);
      }
export function useGetFilesPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesPagesQuery, GetFilesPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesPagesQuery, GetFilesPagesQueryVariables>(GetFilesPagesDocument, options);
        }
export type GetFilesPagesQueryHookResult = ReturnType<typeof useGetFilesPagesQuery>;
export type GetFilesPagesLazyQueryHookResult = ReturnType<typeof useGetFilesPagesLazyQuery>;
export type GetFilesPagesQueryResult = Apollo.QueryResult<GetFilesPagesQuery, GetFilesPagesQueryVariables>;
export const GetFileStatsDocument = gql`
    query getFileStats($started: timestamptz, $ended: timestamptz, $userIds: _uuid, $orgIds: _int2) {
  pp_file_stats(args: {_started: $started, _ended: $ended, _orgids: $orgIds, _crusers: $userIds}) {
    file_flags
    file_flags_id
    qty
    users_qty
  }
}
    `;

/**
 * __useGetFileStatsQuery__
 *
 * To run a query within a React component, call `useGetFileStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileStatsQuery({
 *   variables: {
 *      started: // value for 'started'
 *      ended: // value for 'ended'
 *      userIds: // value for 'userIds'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useGetFileStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetFileStatsQuery, GetFileStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileStatsQuery, GetFileStatsQueryVariables>(GetFileStatsDocument, options);
      }
export function useGetFileStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileStatsQuery, GetFileStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileStatsQuery, GetFileStatsQueryVariables>(GetFileStatsDocument, options);
        }
export type GetFileStatsQueryHookResult = ReturnType<typeof useGetFileStatsQuery>;
export type GetFileStatsLazyQueryHookResult = ReturnType<typeof useGetFileStatsLazyQuery>;
export type GetFileStatsQueryResult = Apollo.QueryResult<GetFileStatsQuery, GetFileStatsQueryVariables>;
export const GetFilesDocument = gql`
    query getFiles($fileNumber: String) {
  files: vw_finished_files(order_by: {last_modified_date: desc, id: asc}, where: {_and: {identification: {_eq: $fileNumber}, file_status: {_in: ["transmission_pending", "transmission_generated", "transmission_failed", "archived_pending", "archived_failed", "archived", "ready_for_archive", "pending"]}}}) {
    id
    identification
    name
    type: file_flags
    declarations {
      file_id
      dr_no
    }
    documents(order_by: {creation_date: desc}, where: {document_type: {_neq: "customs_overview"}, is_deleted: {_eq: false}}) {
      id
      document_type
      documentType {
        translations
        document_type_tenant_settings {
          meta
        }
      }
      document_flags
      document_blobs
      document_name
      sequence
      pages: pages_m2m {
        page {
          id
          rotate
          thumbnailBigUrl: thumbnail_big_url
          meta
        }
        page_number
      }
    }
  }
}
    `;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *      fileNumber: // value for 'fileNumber'
 *   },
 * });
 */
export function useGetFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
      }
export function useGetFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesQuery, GetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument, options);
        }
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<typeof useGetFilesLazyQuery>;
export type GetFilesQueryResult = Apollo.QueryResult<GetFilesQuery, GetFilesQueryVariables>;
export const GetFilesForSubscriptionForAnnotationDocument = gql`
    query getFilesForSubscriptionForAnnotation($offset: Int, $limit: Int, $currUserId: uuid, $orderBy: String, $fileFlags: _int8, $minDate: timestamptz, $maxDate: timestamptz, $search: String, $orgIds: _int2, $myFilesOnly: Boolean, $fileStatuses: _text) {
  files: pp_file_search(args: {_limit: $limit, _offset: $offset, _orderby: $orderBy, _file_flags: $fileFlags, _max_date: $maxDate, _min_date: $minDate, _searchval: $search, _curr_userid: $currUserId, _org_ids: $orgIds, _my_files_only: $myFilesOnly, _file_statuses: $fileStatuses}) {
    id
    identification
    name
    org_id
    org_id_description
    meta
    type: file_flags
    status: file_status
    userId: creation_user
    creationDate: creation_date
    lastUpdate: last_modified_date
    fileUrl: file_url
    total_rows
    customs_relevant
    extraction_required
  }
}
    `;

/**
 * __useGetFilesForSubscriptionForAnnotationQuery__
 *
 * To run a query within a React component, call `useGetFilesForSubscriptionForAnnotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesForSubscriptionForAnnotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesForSubscriptionForAnnotationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      currUserId: // value for 'currUserId'
 *      orderBy: // value for 'orderBy'
 *      fileFlags: // value for 'fileFlags'
 *      minDate: // value for 'minDate'
 *      maxDate: // value for 'maxDate'
 *      search: // value for 'search'
 *      orgIds: // value for 'orgIds'
 *      myFilesOnly: // value for 'myFilesOnly'
 *      fileStatuses: // value for 'fileStatuses'
 *   },
 * });
 */
export function useGetFilesForSubscriptionForAnnotationQuery(baseOptions?: Apollo.QueryHookOptions<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>(GetFilesForSubscriptionForAnnotationDocument, options);
      }
export function useGetFilesForSubscriptionForAnnotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>(GetFilesForSubscriptionForAnnotationDocument, options);
        }
export type GetFilesForSubscriptionForAnnotationQueryHookResult = ReturnType<typeof useGetFilesForSubscriptionForAnnotationQuery>;
export type GetFilesForSubscriptionForAnnotationLazyQueryHookResult = ReturnType<typeof useGetFilesForSubscriptionForAnnotationLazyQuery>;
export type GetFilesForSubscriptionForAnnotationQueryResult = Apollo.QueryResult<GetFilesForSubscriptionForAnnotationQuery, GetFilesForSubscriptionForAnnotationQueryVariables>;
export const GetFileUpdatesSubscriptionForAnnotationDocument = gql`
    subscription getFileUpdatesSubscriptionForAnnotation {
  pp_file_max_date_hs {
    max_change_date
  }
}
    `;

/**
 * __useGetFileUpdatesSubscriptionForAnnotationSubscription__
 *
 * To run a query within a React component, call `useGetFileUpdatesSubscriptionForAnnotationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetFileUpdatesSubscriptionForAnnotationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileUpdatesSubscriptionForAnnotationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetFileUpdatesSubscriptionForAnnotationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetFileUpdatesSubscriptionForAnnotationSubscription, GetFileUpdatesSubscriptionForAnnotationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetFileUpdatesSubscriptionForAnnotationSubscription, GetFileUpdatesSubscriptionForAnnotationSubscriptionVariables>(GetFileUpdatesSubscriptionForAnnotationDocument, options);
      }
export type GetFileUpdatesSubscriptionForAnnotationSubscriptionHookResult = ReturnType<typeof useGetFileUpdatesSubscriptionForAnnotationSubscription>;
export type GetFileUpdatesSubscriptionForAnnotationSubscriptionResult = Apollo.SubscriptionResult<GetFileUpdatesSubscriptionForAnnotationSubscription>;
export const Get_Full_File_HistoryDocument = gql`
    query GET_FULL_FILE_HISTORY($fileId: uuid, $documentIds: _uuid) {
  file_history: pp_view_file_history(args: {_file_id: $fileId}, where: {action_title: {_nin: ["other", "file_transmission_generated", "document_added", "transmission_failed"]}}) {
    action_title
    action_value
    entityId: id
    op_date
    action_user
  }
  document_history: pp_view_document_history(args: {_ids: $documentIds}, where: {action_title: {_nin: ["other", "document_flags_changed", "document_thumbnails_generated", "document_thumbnails_generated_frontend", "document_thumbnails_pending", "document_classified"]}}) {
    action_title
    action_value
    entityId: id
    op_date
    action_user
    document {
      sequence
      documentType {
        translations
      }
    }
  }
}
    `;

/**
 * __useGet_Full_File_HistoryQuery__
 *
 * To run a query within a React component, call `useGet_Full_File_HistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Full_File_HistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Full_File_HistoryQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGet_Full_File_HistoryQuery(baseOptions?: Apollo.QueryHookOptions<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>(Get_Full_File_HistoryDocument, options);
      }
export function useGet_Full_File_HistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>(Get_Full_File_HistoryDocument, options);
        }
export type Get_Full_File_HistoryQueryHookResult = ReturnType<typeof useGet_Full_File_HistoryQuery>;
export type Get_Full_File_HistoryLazyQueryHookResult = ReturnType<typeof useGet_Full_File_HistoryLazyQuery>;
export type Get_Full_File_HistoryQueryResult = Apollo.QueryResult<Get_Full_File_HistoryQuery, Get_Full_File_HistoryQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications {
  notifications(count: 10)
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const Get_Org_IdsDocument = gql`
    query GET_ORG_IDS($limit: Int, $offset: Int, $search: String, $id: smallint) {
  org_ids: pp_org_ids(args: {_limit: $limit, _offset: $offset, _search: $search, _id: $id}) {
    org_id
    display_name
    org_id_description
    qty
    org_params
    addresses_desc
    org_ids_desc
  }
}
    `;

/**
 * __useGet_Org_IdsQuery__
 *
 * To run a query within a React component, call `useGet_Org_IdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Org_IdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Org_IdsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGet_Org_IdsQuery(baseOptions?: Apollo.QueryHookOptions<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>(Get_Org_IdsDocument, options);
      }
export function useGet_Org_IdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>(Get_Org_IdsDocument, options);
        }
export type Get_Org_IdsQueryHookResult = ReturnType<typeof useGet_Org_IdsQuery>;
export type Get_Org_IdsLazyQueryHookResult = ReturnType<typeof useGet_Org_IdsLazyQuery>;
export type Get_Org_IdsQueryResult = Apollo.QueryResult<Get_Org_IdsQuery, Get_Org_IdsQueryVariables>;
export const Get_Setting_ValueDocument = gql`
    query GET_SETTING_VALUE($setting_id: uuid, $reference_type_id: String, $reference_id: String) {
  setting_value(where: {setting_id: {_eq: $setting_id}, reference_type_id: {_eq: $reference_type_id}, reference_id: {_eq: $reference_id}}, order_by: {display_name: asc}) {
    id
    display_name
    value
    setting_id
    is_template
  }
}
    `;

/**
 * __useGet_Setting_ValueQuery__
 *
 * To run a query within a React component, call `useGet_Setting_ValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Setting_ValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Setting_ValueQuery({
 *   variables: {
 *      setting_id: // value for 'setting_id'
 *      reference_type_id: // value for 'reference_type_id'
 *      reference_id: // value for 'reference_id'
 *   },
 * });
 */
export function useGet_Setting_ValueQuery(baseOptions?: Apollo.QueryHookOptions<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>(Get_Setting_ValueDocument, options);
      }
export function useGet_Setting_ValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>(Get_Setting_ValueDocument, options);
        }
export type Get_Setting_ValueQueryHookResult = ReturnType<typeof useGet_Setting_ValueQuery>;
export type Get_Setting_ValueLazyQueryHookResult = ReturnType<typeof useGet_Setting_ValueLazyQuery>;
export type Get_Setting_ValueQueryResult = Apollo.QueryResult<Get_Setting_ValueQuery, Get_Setting_ValueQueryVariables>;
export const Get_Tenant_SettingDocument = gql`
    query GET_TENANT_SETTING($tenantId: ID!) {
  getTenantConfig(tenantId: $tenantId)
}
    `;

/**
 * __useGet_Tenant_SettingQuery__
 *
 * To run a query within a React component, call `useGet_Tenant_SettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Tenant_SettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Tenant_SettingQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGet_Tenant_SettingQuery(baseOptions: Apollo.QueryHookOptions<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>(Get_Tenant_SettingDocument, options);
      }
export function useGet_Tenant_SettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>(Get_Tenant_SettingDocument, options);
        }
export type Get_Tenant_SettingQueryHookResult = ReturnType<typeof useGet_Tenant_SettingQuery>;
export type Get_Tenant_SettingLazyQueryHookResult = ReturnType<typeof useGet_Tenant_SettingLazyQuery>;
export type Get_Tenant_SettingQueryResult = Apollo.QueryResult<Get_Tenant_SettingQuery, Get_Tenant_SettingQueryVariables>;
export const Get_UsersDocument = gql`
    query GET_USERS($limit: Int = 10, $offset: Int = 0, $tenantId: uuid = "00000000-0000-0000-0000-000000000000", $search: String = "%") {
  user_pp(limit: $limit, offset: $offset, where: {tenant_id: {_eq: $tenantId}, deleted: {_eq: false}, display_name: {_ilike: $search}}) {
    id
    display_name
    location
    email
    tenant_id
  }
}
    `;

/**
 * __useGet_UsersQuery__
 *
 * To run a query within a React component, call `useGet_UsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_UsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_UsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      tenantId: // value for 'tenantId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGet_UsersQuery(baseOptions?: Apollo.QueryHookOptions<Get_UsersQuery, Get_UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_UsersQuery, Get_UsersQueryVariables>(Get_UsersDocument, options);
      }
export function useGet_UsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_UsersQuery, Get_UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_UsersQuery, Get_UsersQueryVariables>(Get_UsersDocument, options);
        }
export type Get_UsersQueryHookResult = ReturnType<typeof useGet_UsersQuery>;
export type Get_UsersLazyQueryHookResult = ReturnType<typeof useGet_UsersLazyQuery>;
export type Get_UsersQueryResult = Apollo.QueryResult<Get_UsersQuery, Get_UsersQueryVariables>;
export const Get_Validation_DocumentsDocument = gql`
    query GET_VALIDATION_DOCUMENTS($id: uuid!, $extract_type_id: smallint, $tenantId: uuid!) {
  document(where: {id: {_eq: $id}}) {
    id
    name: document_name
    meta
    annotationType(where: {annotation_provider_id: {_eq: 5}}) {
      annotation_schema
    }
    pages: pages_m2m(order_by: {page_number: asc}) {
      page {
        id
        thumbnailBigUrl: thumbnail_big_url
        page_status
        rotate
        meta
        creation_user
        pageExtracts: page_extracts(where: {extract_type_id: {_eq: $extract_type_id}}) {
          extract_type_id
          dataPoints: value
        }
      }
    }
    document_blobs
    document_flags
    document_type
    documentType {
      translations
      document_type_tenant_settings(where: {tenant: {_eq: $tenantId}}) {
        documentSchema: document_schema
      }
    }
  }
}
    `;

/**
 * __useGet_Validation_DocumentsQuery__
 *
 * To run a query within a React component, call `useGet_Validation_DocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Validation_DocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Validation_DocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      extract_type_id: // value for 'extract_type_id'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGet_Validation_DocumentsQuery(baseOptions: Apollo.QueryHookOptions<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>(Get_Validation_DocumentsDocument, options);
      }
export function useGet_Validation_DocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>(Get_Validation_DocumentsDocument, options);
        }
export type Get_Validation_DocumentsQueryHookResult = ReturnType<typeof useGet_Validation_DocumentsQuery>;
export type Get_Validation_DocumentsLazyQueryHookResult = ReturnType<typeof useGet_Validation_DocumentsLazyQuery>;
export type Get_Validation_DocumentsQueryResult = Apollo.QueryResult<Get_Validation_DocumentsQuery, Get_Validation_DocumentsQueryVariables>;
export const Insert_AddressDocument = gql`
    mutation INSERT_ADDRESS($objects: [address_insert_input!]!) {
  insert_address(objects: $objects) {
    affected_rows
  }
}
    `;
export type Insert_AddressMutationFn = Apollo.MutationFunction<Insert_AddressMutation, Insert_AddressMutationVariables>;

/**
 * __useInsert_AddressMutation__
 *
 * To run a mutation, you first call `useInsert_AddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsert_AddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAddressMutation, { data, loading, error }] = useInsert_AddressMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsert_AddressMutation(baseOptions?: Apollo.MutationHookOptions<Insert_AddressMutation, Insert_AddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Insert_AddressMutation, Insert_AddressMutationVariables>(Insert_AddressDocument, options);
      }
export type Insert_AddressMutationHookResult = ReturnType<typeof useInsert_AddressMutation>;
export type Insert_AddressMutationResult = Apollo.MutationResult<Insert_AddressMutation>;
export type Insert_AddressMutationOptions = Apollo.BaseMutationOptions<Insert_AddressMutation, Insert_AddressMutationVariables>;
export const Insert_Org_IdDocument = gql`
    query INSERT_ORG_ID($org_id: smallint, $display_name: String, $org_params: json, $org_id_description: String) {
  pp_org_id_insert(args: {_org_id: $org_id, _display_name: $display_name, _org_params: $org_params, _desk: $org_id_description}) {
    json_value
  }
}
    `;

/**
 * __useInsert_Org_IdQuery__
 *
 * To run a query within a React component, call `useInsert_Org_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsert_Org_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsert_Org_IdQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      display_name: // value for 'display_name'
 *      org_params: // value for 'org_params'
 *      org_id_description: // value for 'org_id_description'
 *   },
 * });
 */
export function useInsert_Org_IdQuery(baseOptions?: Apollo.QueryHookOptions<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>(Insert_Org_IdDocument, options);
      }
export function useInsert_Org_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>(Insert_Org_IdDocument, options);
        }
export type Insert_Org_IdQueryHookResult = ReturnType<typeof useInsert_Org_IdQuery>;
export type Insert_Org_IdLazyQueryHookResult = ReturnType<typeof useInsert_Org_IdLazyQuery>;
export type Insert_Org_IdQueryResult = Apollo.QueryResult<Insert_Org_IdQuery, Insert_Org_IdQueryVariables>;
export const Patch_Update_Tenant_SettingDocument = gql`
    mutation PATCH_UPDATE_TENANT_SETTING($tenantId: ID!, $settings: JSON) {
  patchTenantConfig(tenantId: $tenantId, value: $settings)
}
    `;
export type Patch_Update_Tenant_SettingMutationFn = Apollo.MutationFunction<Patch_Update_Tenant_SettingMutation, Patch_Update_Tenant_SettingMutationVariables>;

/**
 * __usePatch_Update_Tenant_SettingMutation__
 *
 * To run a mutation, you first call `usePatch_Update_Tenant_SettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatch_Update_Tenant_SettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchUpdateTenantSettingMutation, { data, loading, error }] = usePatch_Update_Tenant_SettingMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function usePatch_Update_Tenant_SettingMutation(baseOptions?: Apollo.MutationHookOptions<Patch_Update_Tenant_SettingMutation, Patch_Update_Tenant_SettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Patch_Update_Tenant_SettingMutation, Patch_Update_Tenant_SettingMutationVariables>(Patch_Update_Tenant_SettingDocument, options);
      }
export type Patch_Update_Tenant_SettingMutationHookResult = ReturnType<typeof usePatch_Update_Tenant_SettingMutation>;
export type Patch_Update_Tenant_SettingMutationResult = Apollo.MutationResult<Patch_Update_Tenant_SettingMutation>;
export type Patch_Update_Tenant_SettingMutationOptions = Apollo.BaseMutationOptions<Patch_Update_Tenant_SettingMutation, Patch_Update_Tenant_SettingMutationVariables>;
export const Adit_Create_Declaration_MessageDocument = gql`
    mutation ADIT_CREATE_DECLARATION_MESSAGE($discussionId: Int!, $message: String!, $user: ID!, $source: String!) {
  createDeclarationMessage(discussionId: $discussionId, message: $message, user: $user, source: $source, messageType: "message") {
    affected_rows
  }
}
    `;
export type Adit_Create_Declaration_MessageMutationFn = Apollo.MutationFunction<Adit_Create_Declaration_MessageMutation, Adit_Create_Declaration_MessageMutationVariables>;

/**
 * __useAdit_Create_Declaration_MessageMutation__
 *
 * To run a mutation, you first call `useAdit_Create_Declaration_MessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Create_Declaration_MessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditCreateDeclarationMessageMutation, { data, loading, error }] = useAdit_Create_Declaration_MessageMutation({
 *   variables: {
 *      discussionId: // value for 'discussionId'
 *      message: // value for 'message'
 *      user: // value for 'user'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAdit_Create_Declaration_MessageMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Create_Declaration_MessageMutation, Adit_Create_Declaration_MessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Create_Declaration_MessageMutation, Adit_Create_Declaration_MessageMutationVariables>(Adit_Create_Declaration_MessageDocument, options);
      }
export type Adit_Create_Declaration_MessageMutationHookResult = ReturnType<typeof useAdit_Create_Declaration_MessageMutation>;
export type Adit_Create_Declaration_MessageMutationResult = Apollo.MutationResult<Adit_Create_Declaration_MessageMutation>;
export type Adit_Create_Declaration_MessageMutationOptions = Apollo.BaseMutationOptions<Adit_Create_Declaration_MessageMutation, Adit_Create_Declaration_MessageMutationVariables>;
export const Adit_Start_DiscussionDocument = gql`
    mutation ADIT_START_DISCUSSION($fileId: uuid!, $theme: String!, $user: uuid!) {
  insert_declaration_discussion_one(object: {file_id: $fileId, discussion_theme: $theme, creation_user: $user}) {
    discussion_id
    discussion_theme
    file_id
  }
}
    `;
export type Adit_Start_DiscussionMutationFn = Apollo.MutationFunction<Adit_Start_DiscussionMutation, Adit_Start_DiscussionMutationVariables>;

/**
 * __useAdit_Start_DiscussionMutation__
 *
 * To run a mutation, you first call `useAdit_Start_DiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Start_DiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditStartDiscussionMutation, { data, loading, error }] = useAdit_Start_DiscussionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      theme: // value for 'theme'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useAdit_Start_DiscussionMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Start_DiscussionMutation, Adit_Start_DiscussionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Start_DiscussionMutation, Adit_Start_DiscussionMutationVariables>(Adit_Start_DiscussionDocument, options);
      }
export type Adit_Start_DiscussionMutationHookResult = ReturnType<typeof useAdit_Start_DiscussionMutation>;
export type Adit_Start_DiscussionMutationResult = Apollo.MutationResult<Adit_Start_DiscussionMutation>;
export type Adit_Start_DiscussionMutationOptions = Apollo.BaseMutationOptions<Adit_Start_DiscussionMutation, Adit_Start_DiscussionMutationVariables>;
export const AditSubscribeDeclarationChangesDocument = gql`
    subscription AditSubscribeDeclarationChanges($discussionId: bigint!) {
  declaration_message(where: {discussion_id: {_eq: $discussionId}}, order_by: {msg_date: asc}) {
    creation_user
    message
    msg_date
    read_date
    type
    user {
      tenant_id
      display_name
      first_name
      last_name
      email
      tenant {
        tenant_name
      }
    }
    declaration_discussion {
      discussion_theme
    }
  }
}
    `;

/**
 * __useAditSubscribeDeclarationChangesSubscription__
 *
 * To run a query within a React component, call `useAditSubscribeDeclarationChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAditSubscribeDeclarationChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditSubscribeDeclarationChangesSubscription({
 *   variables: {
 *      discussionId: // value for 'discussionId'
 *   },
 * });
 */
export function useAditSubscribeDeclarationChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<AditSubscribeDeclarationChangesSubscription, AditSubscribeDeclarationChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AditSubscribeDeclarationChangesSubscription, AditSubscribeDeclarationChangesSubscriptionVariables>(AditSubscribeDeclarationChangesDocument, options);
      }
export type AditSubscribeDeclarationChangesSubscriptionHookResult = ReturnType<typeof useAditSubscribeDeclarationChangesSubscription>;
export type AditSubscribeDeclarationChangesSubscriptionResult = Apollo.SubscriptionResult<AditSubscribeDeclarationChangesSubscription>;
export const AditSubscribeDiscussionChangesDocument = gql`
    subscription aditSubscribeDiscussionChanges($user: uuid!, $date: timestamptz!) {
  discussion_changes(where: {adit_user: {_eq: $user}, last_msg_date: {_gt: $date}, last_user: {_neq: $user}}, distinct_on: file_id) {
    file_name
    liber_user
    last_msg_date
    file_id
    discussion_theme
    discussion_id
    adit_user
    reference
  }
}
    `;

/**
 * __useAditSubscribeDiscussionChangesSubscription__
 *
 * To run a query within a React component, call `useAditSubscribeDiscussionChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAditSubscribeDiscussionChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditSubscribeDiscussionChangesSubscription({
 *   variables: {
 *      user: // value for 'user'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAditSubscribeDiscussionChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<AditSubscribeDiscussionChangesSubscription, AditSubscribeDiscussionChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AditSubscribeDiscussionChangesSubscription, AditSubscribeDiscussionChangesSubscriptionVariables>(AditSubscribeDiscussionChangesDocument, options);
      }
export type AditSubscribeDiscussionChangesSubscriptionHookResult = ReturnType<typeof useAditSubscribeDiscussionChangesSubscription>;
export type AditSubscribeDiscussionChangesSubscriptionResult = Apollo.SubscriptionResult<AditSubscribeDiscussionChangesSubscription>;
export const Adit_Update_Declaration_Task_By_PkDocument = gql`
    mutation ADIT_UPDATE_DECLARATION_TASK_BY_PK($id: Int!, $_set: declaration_task_set_input) {
  update_declaration_task_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export type Adit_Update_Declaration_Task_By_PkMutationFn = Apollo.MutationFunction<Adit_Update_Declaration_Task_By_PkMutation, Adit_Update_Declaration_Task_By_PkMutationVariables>;

/**
 * __useAdit_Update_Declaration_Task_By_PkMutation__
 *
 * To run a mutation, you first call `useAdit_Update_Declaration_Task_By_PkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Update_Declaration_Task_By_PkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateDeclarationTaskByPkMutation, { data, loading, error }] = useAdit_Update_Declaration_Task_By_PkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdit_Update_Declaration_Task_By_PkMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Update_Declaration_Task_By_PkMutation, Adit_Update_Declaration_Task_By_PkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Update_Declaration_Task_By_PkMutation, Adit_Update_Declaration_Task_By_PkMutationVariables>(Adit_Update_Declaration_Task_By_PkDocument, options);
      }
export type Adit_Update_Declaration_Task_By_PkMutationHookResult = ReturnType<typeof useAdit_Update_Declaration_Task_By_PkMutation>;
export type Adit_Update_Declaration_Task_By_PkMutationResult = Apollo.MutationResult<Adit_Update_Declaration_Task_By_PkMutation>;
export type Adit_Update_Declaration_Task_By_PkMutationOptions = Apollo.BaseMutationOptions<Adit_Update_Declaration_Task_By_PkMutation, Adit_Update_Declaration_Task_By_PkMutationVariables>;
export const Update_Org_IdDocument = gql`
    query UPDATE_ORG_ID($org_id: smallint, $display_name: String, $org_params: json, $org_id_description: String) {
  pp_org_id_update(args: {_org_id: $org_id, _display_name: $display_name, _org_params: $org_params, _desk: $org_id_description}) {
    json_value
  }
}
    `;

/**
 * __useUpdate_Org_IdQuery__
 *
 * To run a query within a React component, call `useUpdate_Org_IdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdate_Org_IdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdate_Org_IdQuery({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      display_name: // value for 'display_name'
 *      org_params: // value for 'org_params'
 *      org_id_description: // value for 'org_id_description'
 *   },
 * });
 */
export function useUpdate_Org_IdQuery(baseOptions?: Apollo.QueryHookOptions<Update_Org_IdQuery, Update_Org_IdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Update_Org_IdQuery, Update_Org_IdQueryVariables>(Update_Org_IdDocument, options);
      }
export function useUpdate_Org_IdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Update_Org_IdQuery, Update_Org_IdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Update_Org_IdQuery, Update_Org_IdQueryVariables>(Update_Org_IdDocument, options);
        }
export type Update_Org_IdQueryHookResult = ReturnType<typeof useUpdate_Org_IdQuery>;
export type Update_Org_IdLazyQueryHookResult = ReturnType<typeof useUpdate_Org_IdLazyQuery>;
export type Update_Org_IdQueryResult = Apollo.QueryResult<Update_Org_IdQuery, Update_Org_IdQueryVariables>;
export const ValidateFileNumberDocument = gql`
    mutation ValidateFileNumber($number: String!) {
  validateFileNumber(number: $number) {
    error_code
    error_description
    data {
      orgId
      shipmentNumber
      traffic
      lines {
        grossWeight
        packaging
        quantity
      }
      consignee {
        adrID
        city
        consigneeAdrID
        country
        name
        postalCode
        state
        street
      }
      shipper {
        adrID
        city
        consigneeAdrID
        country
        name
        postalCode
        state
        street
      }
      orderedBy {
        adrID
        city
        consigneeAdrID
        country
        name
        postalCode
        state
        street
      }
    }
  }
}
    `;
export type ValidateFileNumberMutationFn = Apollo.MutationFunction<ValidateFileNumberMutation, ValidateFileNumberMutationVariables>;

/**
 * __useValidateFileNumberMutation__
 *
 * To run a mutation, you first call `useValidateFileNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateFileNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateFileNumberMutation, { data, loading, error }] = useValidateFileNumberMutation({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useValidateFileNumberMutation(baseOptions?: Apollo.MutationHookOptions<ValidateFileNumberMutation, ValidateFileNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateFileNumberMutation, ValidateFileNumberMutationVariables>(ValidateFileNumberDocument, options);
      }
export type ValidateFileNumberMutationHookResult = ReturnType<typeof useValidateFileNumberMutation>;
export type ValidateFileNumberMutationResult = Apollo.MutationResult<ValidateFileNumberMutation>;
export type ValidateFileNumberMutationOptions = Apollo.BaseMutationOptions<ValidateFileNumberMutation, ValidateFileNumberMutationVariables>;
export const ValidateJourneyNumberDocument = gql`
    mutation ValidateJourneyNumber($number: String!) {
  validateJourneyNumber(number: $number) {
    error_code
    error_description
    data
  }
}
    `;
export type ValidateJourneyNumberMutationFn = Apollo.MutationFunction<ValidateJourneyNumberMutation, ValidateJourneyNumberMutationVariables>;

/**
 * __useValidateJourneyNumberMutation__
 *
 * To run a mutation, you first call `useValidateJourneyNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateJourneyNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateJourneyNumberMutation, { data, loading, error }] = useValidateJourneyNumberMutation({
 *   variables: {
 *      number: // value for 'number'
 *   },
 * });
 */
export function useValidateJourneyNumberMutation(baseOptions?: Apollo.MutationHookOptions<ValidateJourneyNumberMutation, ValidateJourneyNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateJourneyNumberMutation, ValidateJourneyNumberMutationVariables>(ValidateJourneyNumberDocument, options);
      }
export type ValidateJourneyNumberMutationHookResult = ReturnType<typeof useValidateJourneyNumberMutation>;
export type ValidateJourneyNumberMutationResult = Apollo.MutationResult<ValidateJourneyNumberMutation>;
export type ValidateJourneyNumberMutationOptions = Apollo.BaseMutationOptions<ValidateJourneyNumberMutation, ValidateJourneyNumberMutationVariables>;
export const Adit_Mark_Declaration_Discussion_As_ReadDocument = gql`
    mutation ADIT_MARK_DECLARATION_DISCUSSION_AS_READ($disc_id: bigint, $read_date: timestamptz!) {
  update_declaration_message(_set: {read_date: $read_date}, where: {discussion_id: {_eq: $disc_id}, read_date: {_is_null: true}, user: {tenant_id: {_neq: "b4b61b73-4f38-45a0-b460-7e38b2777479"}}}) {
    returning {
      discussion_id
    }
  }
}
    `;
export type Adit_Mark_Declaration_Discussion_As_ReadMutationFn = Apollo.MutationFunction<Adit_Mark_Declaration_Discussion_As_ReadMutation, Adit_Mark_Declaration_Discussion_As_ReadMutationVariables>;

/**
 * __useAdit_Mark_Declaration_Discussion_As_ReadMutation__
 *
 * To run a mutation, you first call `useAdit_Mark_Declaration_Discussion_As_ReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Mark_Declaration_Discussion_As_ReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditMarkDeclarationDiscussionAsReadMutation, { data, loading, error }] = useAdit_Mark_Declaration_Discussion_As_ReadMutation({
 *   variables: {
 *      disc_id: // value for 'disc_id'
 *      read_date: // value for 'read_date'
 *   },
 * });
 */
export function useAdit_Mark_Declaration_Discussion_As_ReadMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Mark_Declaration_Discussion_As_ReadMutation, Adit_Mark_Declaration_Discussion_As_ReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Mark_Declaration_Discussion_As_ReadMutation, Adit_Mark_Declaration_Discussion_As_ReadMutationVariables>(Adit_Mark_Declaration_Discussion_As_ReadDocument, options);
      }
export type Adit_Mark_Declaration_Discussion_As_ReadMutationHookResult = ReturnType<typeof useAdit_Mark_Declaration_Discussion_As_ReadMutation>;
export type Adit_Mark_Declaration_Discussion_As_ReadMutationResult = Apollo.MutationResult<Adit_Mark_Declaration_Discussion_As_ReadMutation>;
export type Adit_Mark_Declaration_Discussion_As_ReadMutationOptions = Apollo.BaseMutationOptions<Adit_Mark_Declaration_Discussion_As_ReadMutation, Adit_Mark_Declaration_Discussion_As_ReadMutationVariables>;
export const GetUsersOrgIdsDocument = gql`
    query getUsersOrgIds($userId: _uuid) {
  orgIds: pp_user_org_id(args: {_uids: $userId}) {
    org_id
    orgId {
      org_id
      org_id_description
      active
    }
  }
}
    `;

/**
 * __useGetUsersOrgIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersOrgIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersOrgIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersOrgIdsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUsersOrgIdsQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>(GetUsersOrgIdsDocument, options);
      }
export function useGetUsersOrgIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>(GetUsersOrgIdsDocument, options);
        }
export type GetUsersOrgIdsQueryHookResult = ReturnType<typeof useGetUsersOrgIdsQuery>;
export type GetUsersOrgIdsLazyQueryHookResult = ReturnType<typeof useGetUsersOrgIdsLazyQuery>;
export type GetUsersOrgIdsQueryResult = Apollo.QueryResult<GetUsersOrgIdsQuery, GetUsersOrgIdsQueryVariables>;
export const UpdateRotationDocument = gql`
    mutation updateRotation($objects: [page_insert_input!]!) {
  insert_page(objects: $objects, on_conflict: {constraint: page_pkey, update_columns: rotate}) {
    affected_rows
  }
}
    `;
export type UpdateRotationMutationFn = Apollo.MutationFunction<UpdateRotationMutation, UpdateRotationMutationVariables>;

/**
 * __useUpdateRotationMutation__
 *
 * To run a mutation, you first call `useUpdateRotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRotationMutation, { data, loading, error }] = useUpdateRotationMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateRotationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRotationMutation, UpdateRotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRotationMutation, UpdateRotationMutationVariables>(UpdateRotationDocument, options);
      }
export type UpdateRotationMutationHookResult = ReturnType<typeof useUpdateRotationMutation>;
export type UpdateRotationMutationResult = Apollo.MutationResult<UpdateRotationMutation>;
export type UpdateRotationMutationOptions = Apollo.BaseMutationOptions<UpdateRotationMutation, UpdateRotationMutationVariables>;
export const TransmitFileDocument = gql`
    mutation transmitFile($data: TransmitFileInput!) {
  transmitFile(data: $data) {
    success
    error
    fileIds
  }
}
    `;
export type TransmitFileMutationFn = Apollo.MutationFunction<TransmitFileMutation, TransmitFileMutationVariables>;

/**
 * __useTransmitFileMutation__
 *
 * To run a mutation, you first call `useTransmitFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransmitFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transmitFileMutation, { data, loading, error }] = useTransmitFileMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useTransmitFileMutation(baseOptions?: Apollo.MutationHookOptions<TransmitFileMutation, TransmitFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransmitFileMutation, TransmitFileMutationVariables>(TransmitFileDocument, options);
      }
export type TransmitFileMutationHookResult = ReturnType<typeof useTransmitFileMutation>;
export type TransmitFileMutationResult = Apollo.MutationResult<TransmitFileMutation>;
export type TransmitFileMutationOptions = Apollo.BaseMutationOptions<TransmitFileMutation, TransmitFileMutationVariables>;
export const AditSearchAddressDocument = gql`
    query AditSearchAddress($search: String) {
  addresses: pp_addresses(args: {_search: $search, _limit: 10}) {
    id
    company_name
    street
    street_number
    country
    zipcode
    city
    reference
    customs_account_number
    vat_account_number
  }
}
    `;

/**
 * __useAditSearchAddressQuery__
 *
 * To run a query within a React component, call `useAditSearchAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditSearchAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditSearchAddressQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useAditSearchAddressQuery(baseOptions?: Apollo.QueryHookOptions<AditSearchAddressQuery, AditSearchAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditSearchAddressQuery, AditSearchAddressQueryVariables>(AditSearchAddressDocument, options);
      }
export function useAditSearchAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditSearchAddressQuery, AditSearchAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditSearchAddressQuery, AditSearchAddressQueryVariables>(AditSearchAddressDocument, options);
        }
export type AditSearchAddressQueryHookResult = ReturnType<typeof useAditSearchAddressQuery>;
export type AditSearchAddressLazyQueryHookResult = ReturnType<typeof useAditSearchAddressLazyQuery>;
export type AditSearchAddressQueryResult = Apollo.QueryResult<AditSearchAddressQuery, AditSearchAddressQueryVariables>;
export const Adit_MarkDocumentAsTemplateDocument = gql`
    mutation ADIT_markDocumentAsTemplate($id: ID!, $isTemplate: Boolean) {
  markDocumentAsTemplate(docId: $id, isTemplate: $isTemplate)
}
    `;
export type Adit_MarkDocumentAsTemplateMutationFn = Apollo.MutationFunction<Adit_MarkDocumentAsTemplateMutation, Adit_MarkDocumentAsTemplateMutationVariables>;

/**
 * __useAdit_MarkDocumentAsTemplateMutation__
 *
 * To run a mutation, you first call `useAdit_MarkDocumentAsTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_MarkDocumentAsTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditMarkDocumentAsTemplateMutation, { data, loading, error }] = useAdit_MarkDocumentAsTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isTemplate: // value for 'isTemplate'
 *   },
 * });
 */
export function useAdit_MarkDocumentAsTemplateMutation(baseOptions?: Apollo.MutationHookOptions<Adit_MarkDocumentAsTemplateMutation, Adit_MarkDocumentAsTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_MarkDocumentAsTemplateMutation, Adit_MarkDocumentAsTemplateMutationVariables>(Adit_MarkDocumentAsTemplateDocument, options);
      }
export type Adit_MarkDocumentAsTemplateMutationHookResult = ReturnType<typeof useAdit_MarkDocumentAsTemplateMutation>;
export type Adit_MarkDocumentAsTemplateMutationResult = Apollo.MutationResult<Adit_MarkDocumentAsTemplateMutation>;
export type Adit_MarkDocumentAsTemplateMutationOptions = Apollo.BaseMutationOptions<Adit_MarkDocumentAsTemplateMutation, Adit_MarkDocumentAsTemplateMutationVariables>;
export const Adit_ScheduleTableCalculationDocument = gql`
    mutation ADIT_scheduleTableCalculation($id: ID!) {
  scheduleTableCalculation(docId: $id)
}
    `;
export type Adit_ScheduleTableCalculationMutationFn = Apollo.MutationFunction<Adit_ScheduleTableCalculationMutation, Adit_ScheduleTableCalculationMutationVariables>;

/**
 * __useAdit_ScheduleTableCalculationMutation__
 *
 * To run a mutation, you first call `useAdit_ScheduleTableCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_ScheduleTableCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditScheduleTableCalculationMutation, { data, loading, error }] = useAdit_ScheduleTableCalculationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdit_ScheduleTableCalculationMutation(baseOptions?: Apollo.MutationHookOptions<Adit_ScheduleTableCalculationMutation, Adit_ScheduleTableCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_ScheduleTableCalculationMutation, Adit_ScheduleTableCalculationMutationVariables>(Adit_ScheduleTableCalculationDocument, options);
      }
export type Adit_ScheduleTableCalculationMutationHookResult = ReturnType<typeof useAdit_ScheduleTableCalculationMutation>;
export type Adit_ScheduleTableCalculationMutationResult = Apollo.MutationResult<Adit_ScheduleTableCalculationMutation>;
export type Adit_ScheduleTableCalculationMutationOptions = Apollo.BaseMutationOptions<Adit_ScheduleTableCalculationMutation, Adit_ScheduleTableCalculationMutationVariables>;
export const AditGetDeclarationsListDocument = gql`
    query AditGetDeclarationsList($_like: String) {
  declarations: declaration_request(where: {file: {identification: {_is_null: false, _ilike: $_like}}}) {
    file_id
    dr_no
    file {
      identification
    }
  }
}
    `;

/**
 * __useAditGetDeclarationsListQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationsListQuery({
 *   variables: {
 *      _like: // value for '_like'
 *   },
 * });
 */
export function useAditGetDeclarationsListQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>(AditGetDeclarationsListDocument, options);
      }
export function useAditGetDeclarationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>(AditGetDeclarationsListDocument, options);
        }
export type AditGetDeclarationsListQueryHookResult = ReturnType<typeof useAditGetDeclarationsListQuery>;
export type AditGetDeclarationsListLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationsListLazyQuery>;
export type AditGetDeclarationsListQueryResult = Apollo.QueryResult<AditGetDeclarationsListQuery, AditGetDeclarationsListQueryVariables>;
export const AditCopyDeclarationAndGoodsItemsDocument = gql`
    mutation AditCopyDeclarationAndGoodsItems($sourceFileId: String!, $sourceDrNo: Int!, $targetFileId: String!, $targetDrNo: Int!) {
  copyDeclarationAndGoodsItems(copyDeclarationInput: {sourceFileId: $sourceFileId, sourceDrNo: $sourceDrNo, targetFileId: $targetFileId, targetDrNo: $targetDrNo})
}
    `;
export type AditCopyDeclarationAndGoodsItemsMutationFn = Apollo.MutationFunction<AditCopyDeclarationAndGoodsItemsMutation, AditCopyDeclarationAndGoodsItemsMutationVariables>;

/**
 * __useAditCopyDeclarationAndGoodsItemsMutation__
 *
 * To run a mutation, you first call `useAditCopyDeclarationAndGoodsItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditCopyDeclarationAndGoodsItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditCopyDeclarationAndGoodsItemsMutation, { data, loading, error }] = useAditCopyDeclarationAndGoodsItemsMutation({
 *   variables: {
 *      sourceFileId: // value for 'sourceFileId'
 *      sourceDrNo: // value for 'sourceDrNo'
 *      targetFileId: // value for 'targetFileId'
 *      targetDrNo: // value for 'targetDrNo'
 *   },
 * });
 */
export function useAditCopyDeclarationAndGoodsItemsMutation(baseOptions?: Apollo.MutationHookOptions<AditCopyDeclarationAndGoodsItemsMutation, AditCopyDeclarationAndGoodsItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditCopyDeclarationAndGoodsItemsMutation, AditCopyDeclarationAndGoodsItemsMutationVariables>(AditCopyDeclarationAndGoodsItemsDocument, options);
      }
export type AditCopyDeclarationAndGoodsItemsMutationHookResult = ReturnType<typeof useAditCopyDeclarationAndGoodsItemsMutation>;
export type AditCopyDeclarationAndGoodsItemsMutationResult = Apollo.MutationResult<AditCopyDeclarationAndGoodsItemsMutation>;
export type AditCopyDeclarationAndGoodsItemsMutationOptions = Apollo.BaseMutationOptions<AditCopyDeclarationAndGoodsItemsMutation, AditCopyDeclarationAndGoodsItemsMutationVariables>;
export const Adit_Get_DocumentDocument = gql`
    query ADIT_GET_DOCUMENT($id: uuid!) {
  documents: document(where: {id: {_eq: $id}}) {
    id
    document_extension
    document_name
    creation_date
    creation_user
    pages_m2m(order_by: {page_number: asc}) {
      page {
        id
        thumbnail_small_url
        thumbnail_big_url
        page_status
        rotate
        meta
      }
    }
    org_id
    orgId {
      org_id_description
    }
    document_status
    document_flags
    document_blobs
  }
}
    `;

/**
 * __useAdit_Get_DocumentQuery__
 *
 * To run a query within a React component, call `useAdit_Get_DocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdit_Get_DocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdit_Get_DocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdit_Get_DocumentQuery(baseOptions: Apollo.QueryHookOptions<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>(Adit_Get_DocumentDocument, options);
      }
export function useAdit_Get_DocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>(Adit_Get_DocumentDocument, options);
        }
export type Adit_Get_DocumentQueryHookResult = ReturnType<typeof useAdit_Get_DocumentQuery>;
export type Adit_Get_DocumentLazyQueryHookResult = ReturnType<typeof useAdit_Get_DocumentLazyQuery>;
export type Adit_Get_DocumentQueryResult = Apollo.QueryResult<Adit_Get_DocumentQuery, Adit_Get_DocumentQueryVariables>;
export const ScheduleFilesDocument = gql`
    mutation scheduleFiles($fileIds: [ID!]!) {
  scheduleFiles(fileIds: $fileIds)
}
    `;
export type ScheduleFilesMutationFn = Apollo.MutationFunction<ScheduleFilesMutation, ScheduleFilesMutationVariables>;

/**
 * __useScheduleFilesMutation__
 *
 * To run a mutation, you first call `useScheduleFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleFilesMutation, { data, loading, error }] = useScheduleFilesMutation({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useScheduleFilesMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleFilesMutation, ScheduleFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleFilesMutation, ScheduleFilesMutationVariables>(ScheduleFilesDocument, options);
      }
export type ScheduleFilesMutationHookResult = ReturnType<typeof useScheduleFilesMutation>;
export type ScheduleFilesMutationResult = Apollo.MutationResult<ScheduleFilesMutation>;
export type ScheduleFilesMutationOptions = Apollo.BaseMutationOptions<ScheduleFilesMutation, ScheduleFilesMutationVariables>;
export const Append_Meta_DocumentDocument = gql`
    mutation APPEND_META_DOCUMENT($id: [uuid!]!, $meta: jsonb) {
  update_document(where: {id: {_in: $id}}, _append: {meta: $meta}) {
    affected_rows
  }
}
    `;
export type Append_Meta_DocumentMutationFn = Apollo.MutationFunction<Append_Meta_DocumentMutation, Append_Meta_DocumentMutationVariables>;

/**
 * __useAppend_Meta_DocumentMutation__
 *
 * To run a mutation, you first call `useAppend_Meta_DocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppend_Meta_DocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendMetaDocumentMutation, { data, loading, error }] = useAppend_Meta_DocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useAppend_Meta_DocumentMutation(baseOptions?: Apollo.MutationHookOptions<Append_Meta_DocumentMutation, Append_Meta_DocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Append_Meta_DocumentMutation, Append_Meta_DocumentMutationVariables>(Append_Meta_DocumentDocument, options);
      }
export type Append_Meta_DocumentMutationHookResult = ReturnType<typeof useAppend_Meta_DocumentMutation>;
export type Append_Meta_DocumentMutationResult = Apollo.MutationResult<Append_Meta_DocumentMutation>;
export type Append_Meta_DocumentMutationOptions = Apollo.BaseMutationOptions<Append_Meta_DocumentMutation, Append_Meta_DocumentMutationVariables>;
export const AditGetDeclarationDocumentsTableDocument = gql`
    query AditGetDeclarationDocumentsTable($fileId: UUID, $documentStatus: [DocumentStatus!]) {
  documents: getFileDocuments(fileId: $fileId, documentStatus: $documentStatus) {
    pages {
      creationDate
      creationUser
      id
      lastModifiedDate
      lastModifiedUser
      meta
      ocrText
      pageNumber
      pageStatus
      rotate
      thumbnailBigUrl
      thumbnailSmallUrl
    }
    blobs {
      url
      initial
      extension
    }
    creationUser
    documentExtension
    documentFlags
    documentName
    documentStatus
    documentType
    documentTypeTranslations
    id
    lastModifiedDate
    meta
    sequence
  }
}
    `;

/**
 * __useAditGetDeclarationDocumentsTableQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationDocumentsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationDocumentsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationDocumentsTableQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      documentStatus: // value for 'documentStatus'
 *   },
 * });
 */
export function useAditGetDeclarationDocumentsTableQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>(AditGetDeclarationDocumentsTableDocument, options);
      }
export function useAditGetDeclarationDocumentsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>(AditGetDeclarationDocumentsTableDocument, options);
        }
export type AditGetDeclarationDocumentsTableQueryHookResult = ReturnType<typeof useAditGetDeclarationDocumentsTableQuery>;
export type AditGetDeclarationDocumentsTableLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationDocumentsTableLazyQuery>;
export type AditGetDeclarationDocumentsTableQueryResult = Apollo.QueryResult<AditGetDeclarationDocumentsTableQuery, AditGetDeclarationDocumentsTableQueryVariables>;
export const AditGetDeclarationTableDiscussionsDocument = gql`
    subscription AditGetDeclarationTableDiscussions($fileIds: [uuid!]!) {
  declarationsDiscussions: declaration_discussion(where: {file_id: {_in: $fileIds}}) {
    file_id
    messages: declaration_messages_aggregate(where: {read_date: {_is_null: true}, user: {tenant_id: {_neq: "b4b61b73-4f38-45a0-b460-7e38b2777479"}}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useAditGetDeclarationTableDiscussionsSubscription__
 *
 * To run a query within a React component, call `useAditGetDeclarationTableDiscussionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationTableDiscussionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationTableDiscussionsSubscription({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useAditGetDeclarationTableDiscussionsSubscription(baseOptions: Apollo.SubscriptionHookOptions<AditGetDeclarationTableDiscussionsSubscription, AditGetDeclarationTableDiscussionsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AditGetDeclarationTableDiscussionsSubscription, AditGetDeclarationTableDiscussionsSubscriptionVariables>(AditGetDeclarationTableDiscussionsDocument, options);
      }
export type AditGetDeclarationTableDiscussionsSubscriptionHookResult = ReturnType<typeof useAditGetDeclarationTableDiscussionsSubscription>;
export type AditGetDeclarationTableDiscussionsSubscriptionResult = Apollo.SubscriptionResult<AditGetDeclarationTableDiscussionsSubscription>;
export const AditGetDeclarationsTableDocument = gql`
    query AditGetDeclarationsTable($nonclassifiedDocsExists: Boolean, $limit: Int, $offset: Int, $orderBy: [JSONObject!], $declarationStatus: [DeclarationStatus!], $search: String, $addresses: [AddressFilter!], $dateMin: LocalDateTime, $dateMax: LocalDateTime, $maxTotalColis: Int, $maxTotalGrossWeight: Float, $minTotalColis: Int, $minTotalGrossWeight: Float, $orgIds: [Int!]) {
  declarations: getDeclarationRequestsAdit(nonclassifiedDocsExists: $nonclassifiedDocsExists, limit: $limit, offset: $offset, orderBy: $orderBy, declarationStatus: $declarationStatus, search: $search, addresses: $addresses, dateMin: $dateMin, dateMax: $dateMax, maxTotalColis: $maxTotalColis, maxTotalGrossWeight: $maxTotalGrossWeight, minTotalColis: $minTotalColis, minTotalGrossWeight: $minTotalGrossWeight, orgIds: $orgIds) {
    consigneeName
    autoclassifiedDocsQty
    consigneeRef
    consignorName
    consignorRef
    creationDate
    creationUser
    customsOfficeNumber
    declarationStatus
    drNo
    evvReceived
    fileId
    identification
    importerRef
    messageCount
    nonclassifiedDocsExists
    payerName
    payerRef
    totalColis
    totalGrossWeight
    discussionId
    orgId
    addressReferences
  }
}
    `;

/**
 * __useAditGetDeclarationsTableQuery__
 *
 * To run a query within a React component, call `useAditGetDeclarationsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetDeclarationsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetDeclarationsTableQuery({
 *   variables: {
 *      nonclassifiedDocsExists: // value for 'nonclassifiedDocsExists'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      declarationStatus: // value for 'declarationStatus'
 *      search: // value for 'search'
 *      addresses: // value for 'addresses'
 *      dateMin: // value for 'dateMin'
 *      dateMax: // value for 'dateMax'
 *      maxTotalColis: // value for 'maxTotalColis'
 *      maxTotalGrossWeight: // value for 'maxTotalGrossWeight'
 *      minTotalColis: // value for 'minTotalColis'
 *      minTotalGrossWeight: // value for 'minTotalGrossWeight'
 *      orgIds: // value for 'orgIds'
 *   },
 * });
 */
export function useAditGetDeclarationsTableQuery(baseOptions?: Apollo.QueryHookOptions<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>(AditGetDeclarationsTableDocument, options);
      }
export function useAditGetDeclarationsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>(AditGetDeclarationsTableDocument, options);
        }
export type AditGetDeclarationsTableQueryHookResult = ReturnType<typeof useAditGetDeclarationsTableQuery>;
export type AditGetDeclarationsTableLazyQueryHookResult = ReturnType<typeof useAditGetDeclarationsTableLazyQuery>;
export type AditGetDeclarationsTableQueryResult = Apollo.QueryResult<AditGetDeclarationsTableQuery, AditGetDeclarationsTableQueryVariables>;
export const UpdateSettingValueByIdDocument = gql`
    mutation updateSettingValueById($id: uuid, $reference_id: String, $reference_type_id: String, $setting_id: uuid, $value: jsonb, $is_template: Boolean) {
  update_setting_value(where: {id: {_eq: $id}, reference_id: {_eq: $reference_id}, reference_type_id: {_eq: $reference_type_id}, setting_id: {_eq: $setting_id}, is_template: {_eq: $is_template}}, _set: {value: $value}) {
    returning {
      id
      value
      display_name
    }
  }
}
    `;
export type UpdateSettingValueByIdMutationFn = Apollo.MutationFunction<UpdateSettingValueByIdMutation, UpdateSettingValueByIdMutationVariables>;

/**
 * __useUpdateSettingValueByIdMutation__
 *
 * To run a mutation, you first call `useUpdateSettingValueByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingValueByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingValueByIdMutation, { data, loading, error }] = useUpdateSettingValueByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reference_id: // value for 'reference_id'
 *      reference_type_id: // value for 'reference_type_id'
 *      setting_id: // value for 'setting_id'
 *      value: // value for 'value'
 *      is_template: // value for 'is_template'
 *   },
 * });
 */
export function useUpdateSettingValueByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingValueByIdMutation, UpdateSettingValueByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingValueByIdMutation, UpdateSettingValueByIdMutationVariables>(UpdateSettingValueByIdDocument, options);
      }
export type UpdateSettingValueByIdMutationHookResult = ReturnType<typeof useUpdateSettingValueByIdMutation>;
export type UpdateSettingValueByIdMutationResult = Apollo.MutationResult<UpdateSettingValueByIdMutation>;
export type UpdateSettingValueByIdMutationOptions = Apollo.BaseMutationOptions<UpdateSettingValueByIdMutation, UpdateSettingValueByIdMutationVariables>;
export const UpdateSettingValueDocument = gql`
    mutation updateSettingValue($reference_id: String, $reference_type_id: String, $setting_id: uuid, $value: jsonb, $is_template: Boolean) {
  update_setting_value(where: {reference_id: {_eq: $reference_id}, reference_type_id: {_eq: $reference_type_id}, setting_id: {_eq: $setting_id}, is_template: {_eq: $is_template}}, _set: {value: $value}) {
    returning {
      id
      value
      display_name
    }
  }
}
    `;
export type UpdateSettingValueMutationFn = Apollo.MutationFunction<UpdateSettingValueMutation, UpdateSettingValueMutationVariables>;

/**
 * __useUpdateSettingValueMutation__
 *
 * To run a mutation, you first call `useUpdateSettingValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingValueMutation, { data, loading, error }] = useUpdateSettingValueMutation({
 *   variables: {
 *      reference_id: // value for 'reference_id'
 *      reference_type_id: // value for 'reference_type_id'
 *      setting_id: // value for 'setting_id'
 *      value: // value for 'value'
 *      is_template: // value for 'is_template'
 *   },
 * });
 */
export function useUpdateSettingValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingValueMutation, UpdateSettingValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingValueMutation, UpdateSettingValueMutationVariables>(UpdateSettingValueDocument, options);
      }
export type UpdateSettingValueMutationHookResult = ReturnType<typeof useUpdateSettingValueMutation>;
export type UpdateSettingValueMutationResult = Apollo.MutationResult<UpdateSettingValueMutation>;
export type UpdateSettingValueMutationOptions = Apollo.BaseMutationOptions<UpdateSettingValueMutation, UpdateSettingValueMutationVariables>;
export const CreateSettingValueDocument = gql`
    mutation createSettingValue($setting_value: [setting_value_insert_input!]!) {
  insert_setting_value(objects: $setting_value) {
    returning {
      id
      display_name
      value
    }
  }
}
    `;
export type CreateSettingValueMutationFn = Apollo.MutationFunction<CreateSettingValueMutation, CreateSettingValueMutationVariables>;

/**
 * __useCreateSettingValueMutation__
 *
 * To run a mutation, you first call `useCreateSettingValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSettingValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSettingValueMutation, { data, loading, error }] = useCreateSettingValueMutation({
 *   variables: {
 *      setting_value: // value for 'setting_value'
 *   },
 * });
 */
export function useCreateSettingValueMutation(baseOptions?: Apollo.MutationHookOptions<CreateSettingValueMutation, CreateSettingValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSettingValueMutation, CreateSettingValueMutationVariables>(CreateSettingValueDocument, options);
      }
export type CreateSettingValueMutationHookResult = ReturnType<typeof useCreateSettingValueMutation>;
export type CreateSettingValueMutationResult = Apollo.MutationResult<CreateSettingValueMutation>;
export type CreateSettingValueMutationOptions = Apollo.BaseMutationOptions<CreateSettingValueMutation, CreateSettingValueMutationVariables>;
export const DeleteSettingValueDocument = gql`
    mutation deleteSettingValue($id: uuid!) {
  delete_setting_value(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteSettingValueMutationFn = Apollo.MutationFunction<DeleteSettingValueMutation, DeleteSettingValueMutationVariables>;

/**
 * __useDeleteSettingValueMutation__
 *
 * To run a mutation, you first call `useDeleteSettingValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSettingValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSettingValueMutation, { data, loading, error }] = useDeleteSettingValueMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSettingValueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSettingValueMutation, DeleteSettingValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSettingValueMutation, DeleteSettingValueMutationVariables>(DeleteSettingValueDocument, options);
      }
export type DeleteSettingValueMutationHookResult = ReturnType<typeof useDeleteSettingValueMutation>;
export type DeleteSettingValueMutationResult = Apollo.MutationResult<DeleteSettingValueMutation>;
export type DeleteSettingValueMutationOptions = Apollo.BaseMutationOptions<DeleteSettingValueMutation, DeleteSettingValueMutationVariables>;
export const AditUpdatePasswordDocument = gql`
    mutation AditUpdatePassword($updatePasswordInput: UpdatePasswordDto!) {
  updatePassword(updatePasswordInput: $updatePasswordInput)
}
    `;
export type AditUpdatePasswordMutationFn = Apollo.MutationFunction<AditUpdatePasswordMutation, AditUpdatePasswordMutationVariables>;

/**
 * __useAditUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useAditUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdatePasswordMutation, { data, loading, error }] = useAditUpdatePasswordMutation({
 *   variables: {
 *      updatePasswordInput: // value for 'updatePasswordInput'
 *   },
 * });
 */
export function useAditUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdatePasswordMutation, AditUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdatePasswordMutation, AditUpdatePasswordMutationVariables>(AditUpdatePasswordDocument, options);
      }
export type AditUpdatePasswordMutationHookResult = ReturnType<typeof useAditUpdatePasswordMutation>;
export type AditUpdatePasswordMutationResult = Apollo.MutationResult<AditUpdatePasswordMutation>;
export type AditUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<AditUpdatePasswordMutation, AditUpdatePasswordMutationVariables>;
export const ToggleAiConfirmedDocument = gql`
    mutation ToggleAiConfirmed($file_id: uuid!, $dr_no: smallint!, $value: Boolean!) {
  update_declaration(where: {file_id: {_eq: $file_id}, dr_no: {_eq: $dr_no}}, _set: {ai_confirmed: $value}) {
    affected_rows
  }
}
    `;
export type ToggleAiConfirmedMutationFn = Apollo.MutationFunction<ToggleAiConfirmedMutation, ToggleAiConfirmedMutationVariables>;

/**
 * __useToggleAiConfirmedMutation__
 *
 * To run a mutation, you first call `useToggleAiConfirmedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAiConfirmedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAiConfirmedMutation, { data, loading, error }] = useToggleAiConfirmedMutation({
 *   variables: {
 *      file_id: // value for 'file_id'
 *      dr_no: // value for 'dr_no'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useToggleAiConfirmedMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAiConfirmedMutation, ToggleAiConfirmedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleAiConfirmedMutation, ToggleAiConfirmedMutationVariables>(ToggleAiConfirmedDocument, options);
      }
export type ToggleAiConfirmedMutationHookResult = ReturnType<typeof useToggleAiConfirmedMutation>;
export type ToggleAiConfirmedMutationResult = Apollo.MutationResult<ToggleAiConfirmedMutation>;
export type ToggleAiConfirmedMutationOptions = Apollo.BaseMutationOptions<ToggleAiConfirmedMutation, ToggleAiConfirmedMutationVariables>;
export const UpdateAiIgnoreRetrainingDocument = gql`
    mutation UpdateAiIgnoreRetraining($id: uuid!, $value: Boolean!) {
  update_page_by_pk(pk_columns: {id: $id}, _set: {ai_ignore_retraining: $value}) {
    id
    ai_ignore_retraining
  }
}
    `;
export type UpdateAiIgnoreRetrainingMutationFn = Apollo.MutationFunction<UpdateAiIgnoreRetrainingMutation, UpdateAiIgnoreRetrainingMutationVariables>;

/**
 * __useUpdateAiIgnoreRetrainingMutation__
 *
 * To run a mutation, you first call `useUpdateAiIgnoreRetrainingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiIgnoreRetrainingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiIgnoreRetrainingMutation, { data, loading, error }] = useUpdateAiIgnoreRetrainingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateAiIgnoreRetrainingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiIgnoreRetrainingMutation, UpdateAiIgnoreRetrainingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiIgnoreRetrainingMutation, UpdateAiIgnoreRetrainingMutationVariables>(UpdateAiIgnoreRetrainingDocument, options);
      }
export type UpdateAiIgnoreRetrainingMutationHookResult = ReturnType<typeof useUpdateAiIgnoreRetrainingMutation>;
export type UpdateAiIgnoreRetrainingMutationResult = Apollo.MutationResult<UpdateAiIgnoreRetrainingMutation>;
export type UpdateAiIgnoreRetrainingMutationOptions = Apollo.BaseMutationOptions<UpdateAiIgnoreRetrainingMutation, UpdateAiIgnoreRetrainingMutationVariables>;
export const AditGetAiConfirmedDeclarationsDocument = gql`
    query AditGetAiConfirmedDeclarations {
  declarations: declaration(where: {ai_confirmed: {_eq: true}}) {
    file_id
    dr_no
    ai_confirmed
    file {
      identification
    }
    declaration_request {
      payer {
        tenant_name
      }
      declaration_request_addresses(where: {address_type: {_eq: 3}}) {
        address {
          company_name
        }
      }
      documents(where: {document_type: {_neq: "unknown"}}) {
        id
        document_type
        document_extension
        pages_m2m {
          page_number
          page {
            id
            thumbnail_big_url
            ai_ignore_retraining
            rotate
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAditGetAiConfirmedDeclarationsQuery__
 *
 * To run a query within a React component, call `useAditGetAiConfirmedDeclarationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetAiConfirmedDeclarationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetAiConfirmedDeclarationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetAiConfirmedDeclarationsQuery(baseOptions?: Apollo.QueryHookOptions<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>(AditGetAiConfirmedDeclarationsDocument, options);
      }
export function useAditGetAiConfirmedDeclarationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>(AditGetAiConfirmedDeclarationsDocument, options);
        }
export type AditGetAiConfirmedDeclarationsQueryHookResult = ReturnType<typeof useAditGetAiConfirmedDeclarationsQuery>;
export type AditGetAiConfirmedDeclarationsLazyQueryHookResult = ReturnType<typeof useAditGetAiConfirmedDeclarationsLazyQuery>;
export type AditGetAiConfirmedDeclarationsQueryResult = Apollo.QueryResult<AditGetAiConfirmedDeclarationsQuery, AditGetAiConfirmedDeclarationsQueryVariables>;
export const AditGetModelRetrainsDocument = gql`
    query AditGetModelRetrains {
  model_retrains: model_retrain {
    id
    request_time
    status
    start_time
    end_time
    error_message
  }
}
    `;

/**
 * __useAditGetModelRetrainsQuery__
 *
 * To run a query within a React component, call `useAditGetModelRetrainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetModelRetrainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetModelRetrainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAditGetModelRetrainsQuery(baseOptions?: Apollo.QueryHookOptions<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>(AditGetModelRetrainsDocument, options);
      }
export function useAditGetModelRetrainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>(AditGetModelRetrainsDocument, options);
        }
export type AditGetModelRetrainsQueryHookResult = ReturnType<typeof useAditGetModelRetrainsQuery>;
export type AditGetModelRetrainsLazyQueryHookResult = ReturnType<typeof useAditGetModelRetrainsLazyQuery>;
export type AditGetModelRetrainsQueryResult = Apollo.QueryResult<AditGetModelRetrainsQuery, AditGetModelRetrainsQueryVariables>;
export const AditTriggerModelRetrainingDocument = gql`
    mutation AditTriggerModelRetraining($requestTime: timestamptz!) {
  insert_model_retrain_one(object: {request_time: $requestTime, status: "pending"}) {
    id
  }
}
    `;
export type AditTriggerModelRetrainingMutationFn = Apollo.MutationFunction<AditTriggerModelRetrainingMutation, AditTriggerModelRetrainingMutationVariables>;

/**
 * __useAditTriggerModelRetrainingMutation__
 *
 * To run a mutation, you first call `useAditTriggerModelRetrainingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditTriggerModelRetrainingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditTriggerModelRetrainingMutation, { data, loading, error }] = useAditTriggerModelRetrainingMutation({
 *   variables: {
 *      requestTime: // value for 'requestTime'
 *   },
 * });
 */
export function useAditTriggerModelRetrainingMutation(baseOptions?: Apollo.MutationHookOptions<AditTriggerModelRetrainingMutation, AditTriggerModelRetrainingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditTriggerModelRetrainingMutation, AditTriggerModelRetrainingMutationVariables>(AditTriggerModelRetrainingDocument, options);
      }
export type AditTriggerModelRetrainingMutationHookResult = ReturnType<typeof useAditTriggerModelRetrainingMutation>;
export type AditTriggerModelRetrainingMutationResult = Apollo.MutationResult<AditTriggerModelRetrainingMutation>;
export type AditTriggerModelRetrainingMutationOptions = Apollo.BaseMutationOptions<AditTriggerModelRetrainingMutation, AditTriggerModelRetrainingMutationVariables>;
export const AditGetTenantDocumentTypesTableDocument = gql`
    query AditGetTenantDocumentTypesTable($tenantId: uuid!, $where: document_type_bool_exp!) {
  document_type(order_by: {creation_date: asc}, where: $where) {
    document_type_tenant_settings(where: {tenant: {_eq: $tenantId}}) {
      tenant
      code
      default_flags
      meta
      creation_date
      creation_user
      last_modified_date
      last_modified_user
    }
    name
    display_name
    translations
  }
  document_flag {
    id
    name
    translation
    color
  }
}
    `;

/**
 * __useAditGetTenantDocumentTypesTableQuery__
 *
 * To run a query within a React component, call `useAditGetTenantDocumentTypesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetTenantDocumentTypesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetTenantDocumentTypesTableQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAditGetTenantDocumentTypesTableQuery(baseOptions: Apollo.QueryHookOptions<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>(AditGetTenantDocumentTypesTableDocument, options);
      }
export function useAditGetTenantDocumentTypesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>(AditGetTenantDocumentTypesTableDocument, options);
        }
export type AditGetTenantDocumentTypesTableQueryHookResult = ReturnType<typeof useAditGetTenantDocumentTypesTableQuery>;
export type AditGetTenantDocumentTypesTableLazyQueryHookResult = ReturnType<typeof useAditGetTenantDocumentTypesTableLazyQuery>;
export type AditGetTenantDocumentTypesTableQueryResult = Apollo.QueryResult<AditGetTenantDocumentTypesTableQuery, AditGetTenantDocumentTypesTableQueryVariables>;
export const Adit_Upsert_Document_Type_Tenant_SettingDocument = gql`
    mutation ADIT_UPSERT_DOCUMENT_TYPE_TENANT_SETTING($document_type_tenant_setting: document_type_tenant_settings_insert_input!) {
  insert_document_type_tenant_settings(on_conflict: {constraint: document_type_tenant_settings_pkey, update_columns: [code, meta, default_flags]}, objects: [$document_type_tenant_setting]) {
    affected_rows
  }
}
    `;
export type Adit_Upsert_Document_Type_Tenant_SettingMutationFn = Apollo.MutationFunction<Adit_Upsert_Document_Type_Tenant_SettingMutation, Adit_Upsert_Document_Type_Tenant_SettingMutationVariables>;

/**
 * __useAdit_Upsert_Document_Type_Tenant_SettingMutation__
 *
 * To run a mutation, you first call `useAdit_Upsert_Document_Type_Tenant_SettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdit_Upsert_Document_Type_Tenant_SettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpsertDocumentTypeTenantSettingMutation, { data, loading, error }] = useAdit_Upsert_Document_Type_Tenant_SettingMutation({
 *   variables: {
 *      document_type_tenant_setting: // value for 'document_type_tenant_setting'
 *   },
 * });
 */
export function useAdit_Upsert_Document_Type_Tenant_SettingMutation(baseOptions?: Apollo.MutationHookOptions<Adit_Upsert_Document_Type_Tenant_SettingMutation, Adit_Upsert_Document_Type_Tenant_SettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Adit_Upsert_Document_Type_Tenant_SettingMutation, Adit_Upsert_Document_Type_Tenant_SettingMutationVariables>(Adit_Upsert_Document_Type_Tenant_SettingDocument, options);
      }
export type Adit_Upsert_Document_Type_Tenant_SettingMutationHookResult = ReturnType<typeof useAdit_Upsert_Document_Type_Tenant_SettingMutation>;
export type Adit_Upsert_Document_Type_Tenant_SettingMutationResult = Apollo.MutationResult<Adit_Upsert_Document_Type_Tenant_SettingMutation>;
export type Adit_Upsert_Document_Type_Tenant_SettingMutationOptions = Apollo.BaseMutationOptions<Adit_Upsert_Document_Type_Tenant_SettingMutation, Adit_Upsert_Document_Type_Tenant_SettingMutationVariables>;
export const AditCreatTenantUserDocument = gql`
    mutation aditCreatTenantUser($object: AditUserDto!) {
  createAditUser(createUserInput: $object)
}
    `;
export type AditCreatTenantUserMutationFn = Apollo.MutationFunction<AditCreatTenantUserMutation, AditCreatTenantUserMutationVariables>;

/**
 * __useAditCreatTenantUserMutation__
 *
 * To run a mutation, you first call `useAditCreatTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditCreatTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditCreatTenantUserMutation, { data, loading, error }] = useAditCreatTenantUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAditCreatTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<AditCreatTenantUserMutation, AditCreatTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditCreatTenantUserMutation, AditCreatTenantUserMutationVariables>(AditCreatTenantUserDocument, options);
      }
export type AditCreatTenantUserMutationHookResult = ReturnType<typeof useAditCreatTenantUserMutation>;
export type AditCreatTenantUserMutationResult = Apollo.MutationResult<AditCreatTenantUserMutation>;
export type AditCreatTenantUserMutationOptions = Apollo.BaseMutationOptions<AditCreatTenantUserMutation, AditCreatTenantUserMutationVariables>;
export const AditDeleteTenantUserDocument = gql`
    mutation AditDeleteTenantUser($id: UUID!) {
  removeUser(id: $id)
}
    `;
export type AditDeleteTenantUserMutationFn = Apollo.MutationFunction<AditDeleteTenantUserMutation, AditDeleteTenantUserMutationVariables>;

/**
 * __useAditDeleteTenantUserMutation__
 *
 * To run a mutation, you first call `useAditDeleteTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditDeleteTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditDeleteTenantUserMutation, { data, loading, error }] = useAditDeleteTenantUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAditDeleteTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<AditDeleteTenantUserMutation, AditDeleteTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditDeleteTenantUserMutation, AditDeleteTenantUserMutationVariables>(AditDeleteTenantUserDocument, options);
      }
export type AditDeleteTenantUserMutationHookResult = ReturnType<typeof useAditDeleteTenantUserMutation>;
export type AditDeleteTenantUserMutationResult = Apollo.MutationResult<AditDeleteTenantUserMutation>;
export type AditDeleteTenantUserMutationOptions = Apollo.BaseMutationOptions<AditDeleteTenantUserMutation, AditDeleteTenantUserMutationVariables>;
export const AditGetTenantUsersTableDocument = gql`
    query aditGetTenantUsersTable($limit: Int, $offset: Int, $search: String, $tenant: UUID) {
  users: getUsers(args: {limit: $limit, offset: $offset, search: $search, tenant: $tenant}) {
    id
    tenantId
    firstName
    lastName
    displayName
    email
    location
    isEnabled
    externalAuthProvider
    creationDate
    lastModifiedDate
    orgIds: orgIdEntities {
      ...OrgIdsListFragment
    }
    roles {
      ...RolesList
    }
  }
}
    ${OrgIdsListFragmentFragmentDoc}
${RolesListFragmentDoc}`;

/**
 * __useAditGetTenantUsersTableQuery__
 *
 * To run a query within a React component, call `useAditGetTenantUsersTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetTenantUsersTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetTenantUsersTableQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useAditGetTenantUsersTableQuery(baseOptions?: Apollo.QueryHookOptions<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>(AditGetTenantUsersTableDocument, options);
      }
export function useAditGetTenantUsersTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>(AditGetTenantUsersTableDocument, options);
        }
export type AditGetTenantUsersTableQueryHookResult = ReturnType<typeof useAditGetTenantUsersTableQuery>;
export type AditGetTenantUsersTableLazyQueryHookResult = ReturnType<typeof useAditGetTenantUsersTableLazyQuery>;
export type AditGetTenantUsersTableQueryResult = Apollo.QueryResult<AditGetTenantUsersTableQuery, AditGetTenantUsersTableQueryVariables>;
export const AditSendResetPasswordLinkDocument = gql`
    mutation AditSendResetPasswordLink($email: String!) {
  sendAditResetPasswordLink(email: $email)
}
    `;
export type AditSendResetPasswordLinkMutationFn = Apollo.MutationFunction<AditSendResetPasswordLinkMutation, AditSendResetPasswordLinkMutationVariables>;

/**
 * __useAditSendResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useAditSendResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditSendResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditSendResetPasswordLinkMutation, { data, loading, error }] = useAditSendResetPasswordLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAditSendResetPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<AditSendResetPasswordLinkMutation, AditSendResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditSendResetPasswordLinkMutation, AditSendResetPasswordLinkMutationVariables>(AditSendResetPasswordLinkDocument, options);
      }
export type AditSendResetPasswordLinkMutationHookResult = ReturnType<typeof useAditSendResetPasswordLinkMutation>;
export type AditSendResetPasswordLinkMutationResult = Apollo.MutationResult<AditSendResetPasswordLinkMutation>;
export type AditSendResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<AditSendResetPasswordLinkMutation, AditSendResetPasswordLinkMutationVariables>;
export const AditUpdateTenantUserDocument = gql`
    mutation aditUpdateTenantUser($object: AditUserDto!) {
  updateAditUser(updateUserInput: $object)
}
    `;
export type AditUpdateTenantUserMutationFn = Apollo.MutationFunction<AditUpdateTenantUserMutation, AditUpdateTenantUserMutationVariables>;

/**
 * __useAditUpdateTenantUserMutation__
 *
 * To run a mutation, you first call `useAditUpdateTenantUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateTenantUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateTenantUserMutation, { data, loading, error }] = useAditUpdateTenantUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAditUpdateTenantUserMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateTenantUserMutation, AditUpdateTenantUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateTenantUserMutation, AditUpdateTenantUserMutationVariables>(AditUpdateTenantUserDocument, options);
      }
export type AditUpdateTenantUserMutationHookResult = ReturnType<typeof useAditUpdateTenantUserMutation>;
export type AditUpdateTenantUserMutationResult = Apollo.MutationResult<AditUpdateTenantUserMutation>;
export type AditUpdateTenantUserMutationOptions = Apollo.BaseMutationOptions<AditUpdateTenantUserMutation, AditUpdateTenantUserMutationVariables>;
export const AditCreateTenantDocument = gql`
    mutation AditCreateTenant($addressId: Int!, $externalTenantId: String, $roles: [Int!], $tenantName: String!) {
  createTenantACS(addressId: $addressId, externalTenantId: $externalTenantId, roles: $roles, tenantName: $tenantName)
}
    `;
export type AditCreateTenantMutationFn = Apollo.MutationFunction<AditCreateTenantMutation, AditCreateTenantMutationVariables>;

/**
 * __useAditCreateTenantMutation__
 *
 * To run a mutation, you first call `useAditCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditCreateTenantMutation, { data, loading, error }] = useAditCreateTenantMutation({
 *   variables: {
 *      addressId: // value for 'addressId'
 *      externalTenantId: // value for 'externalTenantId'
 *      roles: // value for 'roles'
 *      tenantName: // value for 'tenantName'
 *   },
 * });
 */
export function useAditCreateTenantMutation(baseOptions?: Apollo.MutationHookOptions<AditCreateTenantMutation, AditCreateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditCreateTenantMutation, AditCreateTenantMutationVariables>(AditCreateTenantDocument, options);
      }
export type AditCreateTenantMutationHookResult = ReturnType<typeof useAditCreateTenantMutation>;
export type AditCreateTenantMutationResult = Apollo.MutationResult<AditCreateTenantMutation>;
export type AditCreateTenantMutationOptions = Apollo.BaseMutationOptions<AditCreateTenantMutation, AditCreateTenantMutationVariables>;
export const AditUpdateTenantDocument = gql`
    mutation AditUpdateTenant($tenantId: String!, $addressId: Int!, $externalTenantId: String, $roles: [Int!], $tenantName: String!) {
  editTenantACS(tenantId: $tenantId, addressId: $addressId, externalTenantId: $externalTenantId, roles: $roles, tenantName: $tenantName)
}
    `;
export type AditUpdateTenantMutationFn = Apollo.MutationFunction<AditUpdateTenantMutation, AditUpdateTenantMutationVariables>;

/**
 * __useAditUpdateTenantMutation__
 *
 * To run a mutation, you first call `useAditUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAditUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aditUpdateTenantMutation, { data, loading, error }] = useAditUpdateTenantMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      addressId: // value for 'addressId'
 *      externalTenantId: // value for 'externalTenantId'
 *      roles: // value for 'roles'
 *      tenantName: // value for 'tenantName'
 *   },
 * });
 */
export function useAditUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<AditUpdateTenantMutation, AditUpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AditUpdateTenantMutation, AditUpdateTenantMutationVariables>(AditUpdateTenantDocument, options);
      }
export type AditUpdateTenantMutationHookResult = ReturnType<typeof useAditUpdateTenantMutation>;
export type AditUpdateTenantMutationResult = Apollo.MutationResult<AditUpdateTenantMutation>;
export type AditUpdateTenantMutationOptions = Apollo.BaseMutationOptions<AditUpdateTenantMutation, AditUpdateTenantMutationVariables>;
export const AditGetTenantsTableDocument = gql`
    query AditGetTenantsTable($id: String) {
  tenants: getTenants(id: $id) {
    accountNumber
    addressId
    creationDate
    externalTenantId
    id
    isWdCustomer
    lastModifiedDate
    permissions
    tenantName
    tenantType
    traderIdentificationNumber
    address {
      ...AdiAddressesListFragment
    }
    roles {
      ...RolesList
    }
  }
}
    ${AdiAddressesListFragmentFragmentDoc}
${RolesListFragmentDoc}`;

/**
 * __useAditGetTenantsTableQuery__
 *
 * To run a query within a React component, call `useAditGetTenantsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAditGetTenantsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAditGetTenantsTableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAditGetTenantsTableQuery(baseOptions?: Apollo.QueryHookOptions<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>(AditGetTenantsTableDocument, options);
      }
export function useAditGetTenantsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>(AditGetTenantsTableDocument, options);
        }
export type AditGetTenantsTableQueryHookResult = ReturnType<typeof useAditGetTenantsTableQuery>;
export type AditGetTenantsTableLazyQueryHookResult = ReturnType<typeof useAditGetTenantsTableLazyQuery>;
export type AditGetTenantsTableQueryResult = Apollo.QueryResult<AditGetTenantsTableQuery, AditGetTenantsTableQueryVariables>;
export const WeDeclareSubscribeDiscussionChangesDocument = gql`
    subscription weDeclareSubscribeDiscussionChanges($user: uuid!, $date: timestamptz!) {
  discussion_changes(where: {liber_user: {_eq: $user}, last_msg_date: {_gt: $date}, last_user: {_neq: $user}}) {
    file_name
    liber_user
    last_msg_date
    file_id
    discussion_theme
    discussion_id
    adit_user
    reference
  }
}
    `;

/**
 * __useWeDeclareSubscribeDiscussionChangesSubscription__
 *
 * To run a query within a React component, call `useWeDeclareSubscribeDiscussionChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWeDeclareSubscribeDiscussionChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeDeclareSubscribeDiscussionChangesSubscription({
 *   variables: {
 *      user: // value for 'user'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useWeDeclareSubscribeDiscussionChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<WeDeclareSubscribeDiscussionChangesSubscription, WeDeclareSubscribeDiscussionChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WeDeclareSubscribeDiscussionChangesSubscription, WeDeclareSubscribeDiscussionChangesSubscriptionVariables>(WeDeclareSubscribeDiscussionChangesDocument, options);
      }
export type WeDeclareSubscribeDiscussionChangesSubscriptionHookResult = ReturnType<typeof useWeDeclareSubscribeDiscussionChangesSubscription>;
export type WeDeclareSubscribeDiscussionChangesSubscriptionResult = Apollo.SubscriptionResult<WeDeclareSubscribeDiscussionChangesSubscription>;
export const WdGetAddressesManagementDocument = gql`
    query WdGetAddressesManagement($limit: Int, $offset: Int, $search: String, $address_types: _int4) {
  pp_addresses(args: {_limit: $limit, _offset: $offset, _search: $search, _address_types: $address_types}) {
    companyName: company_name
    creationDate: creation_date
    address_types
    city
    country
    id
    ao_id
    street
    streetNumber: street_number
    zipcode
    qty
    country
    city
    street
    street_number
    zipcode
    source
    aoId: ao_id
    reference
  }
}
    `;

/**
 * __useWdGetAddressesManagementQuery__
 *
 * To run a query within a React component, call `useWdGetAddressesManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetAddressesManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetAddressesManagementQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *      address_types: // value for 'address_types'
 *   },
 * });
 */
export function useWdGetAddressesManagementQuery(baseOptions?: Apollo.QueryHookOptions<WdGetAddressesManagementQuery, WdGetAddressesManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetAddressesManagementQuery, WdGetAddressesManagementQueryVariables>(WdGetAddressesManagementDocument, options);
      }
export function useWdGetAddressesManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetAddressesManagementQuery, WdGetAddressesManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetAddressesManagementQuery, WdGetAddressesManagementQueryVariables>(WdGetAddressesManagementDocument, options);
        }
export type WdGetAddressesManagementQueryHookResult = ReturnType<typeof useWdGetAddressesManagementQuery>;
export type WdGetAddressesManagementLazyQueryHookResult = ReturnType<typeof useWdGetAddressesManagementLazyQuery>;
export type WdGetAddressesManagementQueryResult = Apollo.QueryResult<WdGetAddressesManagementQuery, WdGetAddressesManagementQueryVariables>;
export const WdGetLinkedAddressesManagementDocument = gql`
    query WdGetLinkedAddressesManagement($limit: Int, $offset: Int, $search: String) {
  linkedAddresses: getAddressOverrides(limit: $limit, offset: $offset, search: $search) {
    sourceAddress {
      id
      aoId
      companyName
      street
      streetNumber
      zipcode
      city
      country
    }
    targetAddress {
      id
      companyName
      street
      streetNumber
      zipcode
      city
      country
    }
    qty
  }
}
    `;

/**
 * __useWdGetLinkedAddressesManagementQuery__
 *
 * To run a query within a React component, call `useWdGetLinkedAddressesManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetLinkedAddressesManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetLinkedAddressesManagementQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useWdGetLinkedAddressesManagementQuery(baseOptions?: Apollo.QueryHookOptions<WdGetLinkedAddressesManagementQuery, WdGetLinkedAddressesManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetLinkedAddressesManagementQuery, WdGetLinkedAddressesManagementQueryVariables>(WdGetLinkedAddressesManagementDocument, options);
      }
export function useWdGetLinkedAddressesManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetLinkedAddressesManagementQuery, WdGetLinkedAddressesManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetLinkedAddressesManagementQuery, WdGetLinkedAddressesManagementQueryVariables>(WdGetLinkedAddressesManagementDocument, options);
        }
export type WdGetLinkedAddressesManagementQueryHookResult = ReturnType<typeof useWdGetLinkedAddressesManagementQuery>;
export type WdGetLinkedAddressesManagementLazyQueryHookResult = ReturnType<typeof useWdGetLinkedAddressesManagementLazyQuery>;
export type WdGetLinkedAddressesManagementQueryResult = Apollo.QueryResult<WdGetLinkedAddressesManagementQuery, WdGetLinkedAddressesManagementQueryVariables>;
export const WdUnlinkAddressDocument = gql`
    mutation WdUnlinkAddress($sourceAddressId: Int!) {
  unlinkAddressACS(sourceAddressId: $sourceAddressId)
}
    `;
export type WdUnlinkAddressMutationFn = Apollo.MutationFunction<WdUnlinkAddressMutation, WdUnlinkAddressMutationVariables>;

/**
 * __useWdUnlinkAddressMutation__
 *
 * To run a mutation, you first call `useWdUnlinkAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdUnlinkAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdUnlinkAddressMutation, { data, loading, error }] = useWdUnlinkAddressMutation({
 *   variables: {
 *      sourceAddressId: // value for 'sourceAddressId'
 *   },
 * });
 */
export function useWdUnlinkAddressMutation(baseOptions?: Apollo.MutationHookOptions<WdUnlinkAddressMutation, WdUnlinkAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdUnlinkAddressMutation, WdUnlinkAddressMutationVariables>(WdUnlinkAddressDocument, options);
      }
export type WdUnlinkAddressMutationHookResult = ReturnType<typeof useWdUnlinkAddressMutation>;
export type WdUnlinkAddressMutationResult = Apollo.MutationResult<WdUnlinkAddressMutation>;
export type WdUnlinkAddressMutationOptions = Apollo.BaseMutationOptions<WdUnlinkAddressMutation, WdUnlinkAddressMutationVariables>;
export const WdGetBordereausDocument = gql`
    query WdGetBordereaus($args: BordereauArgs) {
  getBordereaus(args: $args) {
    bordereausCount: count
    bordereaus: data {
      documentNumber
      documentTitle
      documentDate
      documentTime
      accountNumber
      status
      duties
      vat
      numberOfDocuments
      amount
      consignee
      bordereauXmlDoc {
        document_blobs
      }
      bordereauPdfDoc {
        document_blobs
      }
      bordereauItems {
        id
        customsReference
        customOffice {
          name
          officeNumber
        }
        documentTypeNameTranslations {
          de
          en
        }
        documentTypeAbbreviation
        traderReference
        customsDeclarationVersion
        status
        amount
        drNo
        file {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useWdGetBordereausQuery__
 *
 * To run a query within a React component, call `useWdGetBordereausQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetBordereausQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetBordereausQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useWdGetBordereausQuery(baseOptions?: Apollo.QueryHookOptions<WdGetBordereausQuery, WdGetBordereausQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetBordereausQuery, WdGetBordereausQueryVariables>(WdGetBordereausDocument, options);
      }
export function useWdGetBordereausLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetBordereausQuery, WdGetBordereausQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetBordereausQuery, WdGetBordereausQueryVariables>(WdGetBordereausDocument, options);
        }
export type WdGetBordereausQueryHookResult = ReturnType<typeof useWdGetBordereausQuery>;
export type WdGetBordereausLazyQueryHookResult = ReturnType<typeof useWdGetBordereausLazyQuery>;
export type WdGetBordereausQueryResult = Apollo.QueryResult<WdGetBordereausQuery, WdGetBordereausQueryVariables>;
export const WdGetDeclarationTableDiscussionsDocument = gql`
    subscription WdGetDeclarationTableDiscussions($fileIds: [uuid!]!, $tenantId: uuid!) {
  declarationsDiscussions: declaration_discussion(where: {file_id: {_in: $fileIds}}) {
    file_id
    messages: declaration_messages_aggregate(where: {read_date: {_is_null: true}, user: {tenant_id: {_neq: $tenantId}}}) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useWdGetDeclarationTableDiscussionsSubscription__
 *
 * To run a query within a React component, call `useWdGetDeclarationTableDiscussionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDeclarationTableDiscussionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDeclarationTableDiscussionsSubscription({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useWdGetDeclarationTableDiscussionsSubscription(baseOptions: Apollo.SubscriptionHookOptions<WdGetDeclarationTableDiscussionsSubscription, WdGetDeclarationTableDiscussionsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WdGetDeclarationTableDiscussionsSubscription, WdGetDeclarationTableDiscussionsSubscriptionVariables>(WdGetDeclarationTableDiscussionsDocument, options);
      }
export type WdGetDeclarationTableDiscussionsSubscriptionHookResult = ReturnType<typeof useWdGetDeclarationTableDiscussionsSubscription>;
export type WdGetDeclarationTableDiscussionsSubscriptionResult = Apollo.SubscriptionResult<WdGetDeclarationTableDiscussionsSubscription>;
export const WdGetDeclarationsDashboardDocument = gql`
    query WdGetDeclarationsDashboard($limit: Int, $offset: Int, $min_date: LocalDateTime, $max_date: LocalDateTime, $search: String, $declaration_statuses: String, $addresses: [AddressFilter!], $declaration_type: String, $clearance_type: String, $arrival_type: String, $orderby: [JSONObject!], $payer: UUID, $evv_status: String, $declaration_labels: String) {
  pp_declaration_requests(args: {_limit: $limit, _offset: $offset, _date_min: $min_date, _date_max: $max_date, _search: $search, _declaration_statuses: $declaration_statuses, _orderby: $orderby, _addresses: $addresses, _decl_type: $declaration_type, _clr_type: $clearance_type, _arrival_type: $arrival_type, _payer: $payer, _evv_status: $evv_status, _declaration_labels: $declaration_labels}) {
    addressReferences
    fileId
    drNo
    declarationStatus
    searchReferences
    declarationRequest {
      arrivalTime
      arrivalType
      clearanceType
      creationDate
      acceptanceDate
      creationUser
      declarationType
      drNo
      eta
      fileId
      meta
      waNumber
    }
    declarationLabels {
      id
      title
      description
      color
      isDeleted
    }
    file {
      identification
      isDeleted
    }
    customsOffice {
      name
      number
    }
    declaration {
      acceptanceDate
      customsDeclarationNumber
      customsDeclarationVersion
      evvReceived
      customsOfficeNumber
      declarationType
      borderEauNumber
    }
    addresses {
      addressTypeId
      companyName
    }
    payer {
      address {
        id
        companyName
      }
    }
    userPp {
      displayName
      email
    }
  }
}
    `;

/**
 * __useWdGetDeclarationsDashboardQuery__
 *
 * To run a query within a React component, call `useWdGetDeclarationsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDeclarationsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDeclarationsDashboardQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      min_date: // value for 'min_date'
 *      max_date: // value for 'max_date'
 *      search: // value for 'search'
 *      declaration_statuses: // value for 'declaration_statuses'
 *      addresses: // value for 'addresses'
 *      declaration_type: // value for 'declaration_type'
 *      clearance_type: // value for 'clearance_type'
 *      arrival_type: // value for 'arrival_type'
 *      orderby: // value for 'orderby'
 *      payer: // value for 'payer'
 *      evv_status: // value for 'evv_status'
 *      declaration_labels: // value for 'declaration_labels'
 *   },
 * });
 */
export function useWdGetDeclarationsDashboardQuery(baseOptions?: Apollo.QueryHookOptions<WdGetDeclarationsDashboardQuery, WdGetDeclarationsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetDeclarationsDashboardQuery, WdGetDeclarationsDashboardQueryVariables>(WdGetDeclarationsDashboardDocument, options);
      }
export function useWdGetDeclarationsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetDeclarationsDashboardQuery, WdGetDeclarationsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetDeclarationsDashboardQuery, WdGetDeclarationsDashboardQueryVariables>(WdGetDeclarationsDashboardDocument, options);
        }
export type WdGetDeclarationsDashboardQueryHookResult = ReturnType<typeof useWdGetDeclarationsDashboardQuery>;
export type WdGetDeclarationsDashboardLazyQueryHookResult = ReturnType<typeof useWdGetDeclarationsDashboardLazyQuery>;
export type WdGetDeclarationsDashboardQueryResult = Apollo.QueryResult<WdGetDeclarationsDashboardQuery, WdGetDeclarationsDashboardQueryVariables>;
export const WdGetDocumentsDocument = gql`
    query WdGetDocuments($file_id: uuid) {
  documents: document(where: {is_deleted: {_eq: false}, file: {_eq: $file_id}}) {
    id
    document_type
    creation_date
    document_blobs(path: "blobs")
    document_extension
    documentType {
      translations
    }
  }
}
    `;

/**
 * __useWdGetDocumentsQuery__
 *
 * To run a query within a React component, call `useWdGetDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDocumentsQuery({
 *   variables: {
 *      file_id: // value for 'file_id'
 *   },
 * });
 */
export function useWdGetDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<WdGetDocumentsQuery, WdGetDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetDocumentsQuery, WdGetDocumentsQueryVariables>(WdGetDocumentsDocument, options);
      }
export function useWdGetDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetDocumentsQuery, WdGetDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetDocumentsQuery, WdGetDocumentsQueryVariables>(WdGetDocumentsDocument, options);
        }
export type WdGetDocumentsQueryHookResult = ReturnType<typeof useWdGetDocumentsQuery>;
export type WdGetDocumentsLazyQueryHookResult = ReturnType<typeof useWdGetDocumentsLazyQuery>;
export type WdGetDocumentsQueryResult = Apollo.QueryResult<WdGetDocumentsQuery, WdGetDocumentsQueryVariables>;
export const Get_Document_TypesDocument = gql`
    query GET_DOCUMENT_TYPES {
  document_types: document_type(order_by: {creation_date: asc}) {
    lastModifiedDate: last_modified_date
    name
    display_name
    translations
  }
}
    `;

/**
 * __useGet_Document_TypesQuery__
 *
 * To run a query within a React component, call `useGet_Document_TypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Document_TypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Document_TypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGet_Document_TypesQuery(baseOptions?: Apollo.QueryHookOptions<Get_Document_TypesQuery, Get_Document_TypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Document_TypesQuery, Get_Document_TypesQueryVariables>(Get_Document_TypesDocument, options);
      }
export function useGet_Document_TypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Document_TypesQuery, Get_Document_TypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Document_TypesQuery, Get_Document_TypesQueryVariables>(Get_Document_TypesDocument, options);
        }
export type Get_Document_TypesQueryHookResult = ReturnType<typeof useGet_Document_TypesQuery>;
export type Get_Document_TypesLazyQueryHookResult = ReturnType<typeof useGet_Document_TypesLazyQuery>;
export type Get_Document_TypesQueryResult = Apollo.QueryResult<Get_Document_TypesQuery, Get_Document_TypesQueryVariables>;
export const Classify_We_Declare_DocumentDocument = gql`
    mutation CLASSIFY_WE_DECLARE_DOCUMENT($document_type: String!, $doc_id: ID!) {
  classifyWeDeclareDocument(doc_id: $doc_id, document_type: $document_type, is_customs_relevant: true)
}
    `;
export type Classify_We_Declare_DocumentMutationFn = Apollo.MutationFunction<Classify_We_Declare_DocumentMutation, Classify_We_Declare_DocumentMutationVariables>;

/**
 * __useClassify_We_Declare_DocumentMutation__
 *
 * To run a mutation, you first call `useClassify_We_Declare_DocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClassify_We_Declare_DocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [classifyWeDeclareDocumentMutation, { data, loading, error }] = useClassify_We_Declare_DocumentMutation({
 *   variables: {
 *      document_type: // value for 'document_type'
 *      doc_id: // value for 'doc_id'
 *   },
 * });
 */
export function useClassify_We_Declare_DocumentMutation(baseOptions?: Apollo.MutationHookOptions<Classify_We_Declare_DocumentMutation, Classify_We_Declare_DocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Classify_We_Declare_DocumentMutation, Classify_We_Declare_DocumentMutationVariables>(Classify_We_Declare_DocumentDocument, options);
      }
export type Classify_We_Declare_DocumentMutationHookResult = ReturnType<typeof useClassify_We_Declare_DocumentMutation>;
export type Classify_We_Declare_DocumentMutationResult = Apollo.MutationResult<Classify_We_Declare_DocumentMutation>;
export type Classify_We_Declare_DocumentMutationOptions = Apollo.BaseMutationOptions<Classify_We_Declare_DocumentMutation, Classify_We_Declare_DocumentMutationVariables>;
export const Delete_DocumentDocument = gql`
    mutation DELETE_DOCUMENT($id: uuid!) {
  update_document(where: {id: {_eq: $id}}, _set: {is_deleted: true}) {
    affected_rows
  }
}
    `;
export type Delete_DocumentMutationFn = Apollo.MutationFunction<Delete_DocumentMutation, Delete_DocumentMutationVariables>;

/**
 * __useDelete_DocumentMutation__
 *
 * To run a mutation, you first call `useDelete_DocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_DocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDelete_DocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete_DocumentMutation(baseOptions?: Apollo.MutationHookOptions<Delete_DocumentMutation, Delete_DocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_DocumentMutation, Delete_DocumentMutationVariables>(Delete_DocumentDocument, options);
      }
export type Delete_DocumentMutationHookResult = ReturnType<typeof useDelete_DocumentMutation>;
export type Delete_DocumentMutationResult = Apollo.MutationResult<Delete_DocumentMutation>;
export type Delete_DocumentMutationOptions = Apollo.BaseMutationOptions<Delete_DocumentMutation, Delete_DocumentMutationVariables>;
export const Delete_Document_And_Update_Dec_StatusDocument = gql`
    mutation DELETE_DOCUMENT_AND_UPDATE_DEC_STATUS($id: uuid!, $fileId: uuid!) {
  update_document(where: {id: {_eq: $id}}, _set: {is_deleted: true}) {
    affected_rows
  }
  update_declaration_request(_set: {declaration_status: "information_missing"}, where: {file_id: {_eq: $fileId}}) {
    affected_rows
  }
}
    `;
export type Delete_Document_And_Update_Dec_StatusMutationFn = Apollo.MutationFunction<Delete_Document_And_Update_Dec_StatusMutation, Delete_Document_And_Update_Dec_StatusMutationVariables>;

/**
 * __useDelete_Document_And_Update_Dec_StatusMutation__
 *
 * To run a mutation, you first call `useDelete_Document_And_Update_Dec_StatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete_Document_And_Update_Dec_StatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentAndUpdateDecStatusMutation, { data, loading, error }] = useDelete_Document_And_Update_Dec_StatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDelete_Document_And_Update_Dec_StatusMutation(baseOptions?: Apollo.MutationHookOptions<Delete_Document_And_Update_Dec_StatusMutation, Delete_Document_And_Update_Dec_StatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete_Document_And_Update_Dec_StatusMutation, Delete_Document_And_Update_Dec_StatusMutationVariables>(Delete_Document_And_Update_Dec_StatusDocument, options);
      }
export type Delete_Document_And_Update_Dec_StatusMutationHookResult = ReturnType<typeof useDelete_Document_And_Update_Dec_StatusMutation>;
export type Delete_Document_And_Update_Dec_StatusMutationResult = Apollo.MutationResult<Delete_Document_And_Update_Dec_StatusMutation>;
export type Delete_Document_And_Update_Dec_StatusMutationOptions = Apollo.BaseMutationOptions<Delete_Document_And_Update_Dec_StatusMutation, Delete_Document_And_Update_Dec_StatusMutationVariables>;
export const Get_Declaration_Request_DocumentsDocument = gql`
    query GET_DECLARATION_REQUEST_DOCUMENTS($declarationId: uuid!) {
  declaration_request(where: {file_id: {_eq: $declarationId}}) {
    file {
      documents {
        id
        document_type
        is_generated
        is_deleted
      }
    }
  }
}
    `;

/**
 * __useGet_Declaration_Request_DocumentsQuery__
 *
 * To run a query within a React component, call `useGet_Declaration_Request_DocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGet_Declaration_Request_DocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGet_Declaration_Request_DocumentsQuery({
 *   variables: {
 *      declarationId: // value for 'declarationId'
 *   },
 * });
 */
export function useGet_Declaration_Request_DocumentsQuery(baseOptions: Apollo.QueryHookOptions<Get_Declaration_Request_DocumentsQuery, Get_Declaration_Request_DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Get_Declaration_Request_DocumentsQuery, Get_Declaration_Request_DocumentsQueryVariables>(Get_Declaration_Request_DocumentsDocument, options);
      }
export function useGet_Declaration_Request_DocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Get_Declaration_Request_DocumentsQuery, Get_Declaration_Request_DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Get_Declaration_Request_DocumentsQuery, Get_Declaration_Request_DocumentsQueryVariables>(Get_Declaration_Request_DocumentsDocument, options);
        }
export type Get_Declaration_Request_DocumentsQueryHookResult = ReturnType<typeof useGet_Declaration_Request_DocumentsQuery>;
export type Get_Declaration_Request_DocumentsLazyQueryHookResult = ReturnType<typeof useGet_Declaration_Request_DocumentsLazyQuery>;
export type Get_Declaration_Request_DocumentsQueryResult = Apollo.QueryResult<Get_Declaration_Request_DocumentsQuery, Get_Declaration_Request_DocumentsQueryVariables>;
export const WdMarkDeclarationMessagesAsReadDocument = gql`
    mutation WdMarkDeclarationMessagesAsRead($disc_id: bigint, $read_date: timestamptz!, $tenant_id: uuid!) {
  update_declaration_message(_set: {read_date: $read_date}, where: {discussion_id: {_eq: $disc_id}, read_date: {_is_null: true}, user: {tenant_id: {_neq: $tenant_id}}}) {
    returning {
      discussion_id
    }
  }
}
    `;
export type WdMarkDeclarationMessagesAsReadMutationFn = Apollo.MutationFunction<WdMarkDeclarationMessagesAsReadMutation, WdMarkDeclarationMessagesAsReadMutationVariables>;

/**
 * __useWdMarkDeclarationMessagesAsReadMutation__
 *
 * To run a mutation, you first call `useWdMarkDeclarationMessagesAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdMarkDeclarationMessagesAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdMarkDeclarationMessagesAsReadMutation, { data, loading, error }] = useWdMarkDeclarationMessagesAsReadMutation({
 *   variables: {
 *      disc_id: // value for 'disc_id'
 *      read_date: // value for 'read_date'
 *      tenant_id: // value for 'tenant_id'
 *   },
 * });
 */
export function useWdMarkDeclarationMessagesAsReadMutation(baseOptions?: Apollo.MutationHookOptions<WdMarkDeclarationMessagesAsReadMutation, WdMarkDeclarationMessagesAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdMarkDeclarationMessagesAsReadMutation, WdMarkDeclarationMessagesAsReadMutationVariables>(WdMarkDeclarationMessagesAsReadDocument, options);
      }
export type WdMarkDeclarationMessagesAsReadMutationHookResult = ReturnType<typeof useWdMarkDeclarationMessagesAsReadMutation>;
export type WdMarkDeclarationMessagesAsReadMutationResult = Apollo.MutationResult<WdMarkDeclarationMessagesAsReadMutation>;
export type WdMarkDeclarationMessagesAsReadMutationOptions = Apollo.BaseMutationOptions<WdMarkDeclarationMessagesAsReadMutation, WdMarkDeclarationMessagesAsReadMutationVariables>;
export const We_Declare_Create_Declaration_MessageDocument = gql`
    mutation WE_DECLARE_CREATE_DECLARATION_MESSAGE($discussionId: Int!, $message: String!, $user: ID!, $source: String!, $messageType: String!) {
  createDeclarationMessage(discussionId: $discussionId, message: $message, user: $user, source: $source, messageType: $messageType) {
    affected_rows
  }
}
    `;
export type We_Declare_Create_Declaration_MessageMutationFn = Apollo.MutationFunction<We_Declare_Create_Declaration_MessageMutation, We_Declare_Create_Declaration_MessageMutationVariables>;

/**
 * __useWe_Declare_Create_Declaration_MessageMutation__
 *
 * To run a mutation, you first call `useWe_Declare_Create_Declaration_MessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWe_Declare_Create_Declaration_MessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [weDeclareCreateDeclarationMessageMutation, { data, loading, error }] = useWe_Declare_Create_Declaration_MessageMutation({
 *   variables: {
 *      discussionId: // value for 'discussionId'
 *      message: // value for 'message'
 *      user: // value for 'user'
 *      source: // value for 'source'
 *      messageType: // value for 'messageType'
 *   },
 * });
 */
export function useWe_Declare_Create_Declaration_MessageMutation(baseOptions?: Apollo.MutationHookOptions<We_Declare_Create_Declaration_MessageMutation, We_Declare_Create_Declaration_MessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<We_Declare_Create_Declaration_MessageMutation, We_Declare_Create_Declaration_MessageMutationVariables>(We_Declare_Create_Declaration_MessageDocument, options);
      }
export type We_Declare_Create_Declaration_MessageMutationHookResult = ReturnType<typeof useWe_Declare_Create_Declaration_MessageMutation>;
export type We_Declare_Create_Declaration_MessageMutationResult = Apollo.MutationResult<We_Declare_Create_Declaration_MessageMutation>;
export type We_Declare_Create_Declaration_MessageMutationOptions = Apollo.BaseMutationOptions<We_Declare_Create_Declaration_MessageMutation, We_Declare_Create_Declaration_MessageMutationVariables>;
export const We_Declare_Start_DiscussionDocument = gql`
    mutation WE_DECLARE_START_DISCUSSION($fileId: uuid!, $theme: String!, $user: uuid!) {
  insert_declaration_discussion_one(object: {file_id: $fileId, discussion_theme: $theme, creation_user: $user}) {
    discussion_id
    discussion_theme
    file_id
  }
}
    `;
export type We_Declare_Start_DiscussionMutationFn = Apollo.MutationFunction<We_Declare_Start_DiscussionMutation, We_Declare_Start_DiscussionMutationVariables>;

/**
 * __useWe_Declare_Start_DiscussionMutation__
 *
 * To run a mutation, you first call `useWe_Declare_Start_DiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWe_Declare_Start_DiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [weDeclareStartDiscussionMutation, { data, loading, error }] = useWe_Declare_Start_DiscussionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      theme: // value for 'theme'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useWe_Declare_Start_DiscussionMutation(baseOptions?: Apollo.MutationHookOptions<We_Declare_Start_DiscussionMutation, We_Declare_Start_DiscussionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<We_Declare_Start_DiscussionMutation, We_Declare_Start_DiscussionMutationVariables>(We_Declare_Start_DiscussionDocument, options);
      }
export type We_Declare_Start_DiscussionMutationHookResult = ReturnType<typeof useWe_Declare_Start_DiscussionMutation>;
export type We_Declare_Start_DiscussionMutationResult = Apollo.MutationResult<We_Declare_Start_DiscussionMutation>;
export type We_Declare_Start_DiscussionMutationOptions = Apollo.BaseMutationOptions<We_Declare_Start_DiscussionMutation, We_Declare_Start_DiscussionMutationVariables>;
export const SubscribeDeclarationDiscussionsDocument = gql`
    subscription subscribeDeclarationDiscussions($file_id: uuid) {
  declaration_discussion(where: {file_id: {_eq: $file_id}}) {
    discussion_id
    discussion_theme
    declaration_messages(order_by: {msg_date: asc}) {
      creation_user
      message
      msg_date
      read_date
      type
      user {
        tenant_id
        display_name
        first_name
        last_name
        email
        tenant {
          tenant_name
        }
      }
    }
  }
}
    `;

/**
 * __useSubscribeDeclarationDiscussionsSubscription__
 *
 * To run a query within a React component, call `useSubscribeDeclarationDiscussionsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeDeclarationDiscussionsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeDeclarationDiscussionsSubscription({
 *   variables: {
 *      file_id: // value for 'file_id'
 *   },
 * });
 */
export function useSubscribeDeclarationDiscussionsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeDeclarationDiscussionsSubscription, SubscribeDeclarationDiscussionsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeDeclarationDiscussionsSubscription, SubscribeDeclarationDiscussionsSubscriptionVariables>(SubscribeDeclarationDiscussionsDocument, options);
      }
export type SubscribeDeclarationDiscussionsSubscriptionHookResult = ReturnType<typeof useSubscribeDeclarationDiscussionsSubscription>;
export type SubscribeDeclarationDiscussionsSubscriptionResult = Apollo.SubscriptionResult<SubscribeDeclarationDiscussionsSubscription>;
export const WdGetDeclarationDetailsDocument = gql`
    query WdGetDeclarationDetails($file_id: UUID!) {
  pp_declaration_requests(args: {_file_id: $file_id}) {
    fileId
    drNo
    declarationLabels {
      id
      title
      description
      color
      isDeleted
    }
    declarationRequest {
      fileId
      drNo
      trNo
      chExpDecl
      impCustClr
      transitdocType
      destTolldeptCode
      destTolldeptName
      isExpress
      declarationType
      creationUser
      creationDate
      clearanceType
      arrivalTime
      arrivalType
      eta
      waNumber
      meta
    }
    customsOffice {
      name
      number
    }
    declarationStatus
    addressReferences
    addresses {
      id
      addressTypeId
      companyName
      country
      city
      street
      streetNumber
      zipcode
      reference
      drReference
    }
    userPp {
      displayName
      phoneNumber
      email
    }
    file {
      identification
      meta
    }
    declaration {
      acceptanceDate
      customsDeclarationNumber
      customsDeclarationVersion
      customsOfficeNumber
      requestorTraderIdentificationNumber
      release
      status
      statusTime
      statusDate
      materialCheck
      traderDeclarationNumber
      traderReference
      totalGoodsItems
      specialMention {
        id
        text
      }
      vatSuffix
      placeOfUnloading
      totalVatValue
      dutyTotalAmount
      dutyAndOtherTaxesAmount
      transportMode
      transportNumber
      transportType
      transportCountry
      customsAccountName
      customsAccountNumber
      incoterms
      invoiceCurrencyType
      vatAccountName
      vatAccountNumber
      vatTotalAmount
      vatNumber
      dispatchCountry
      packagingQuantity
      grossMass
      evvReceived
      previousDocument {
        id
        previousDocumentType
        previousDocumentReference
      }
    }
    payer {
      id
      address {
        id
      }
    }
  }
}
    `;

/**
 * __useWdGetDeclarationDetailsQuery__
 *
 * To run a query within a React component, call `useWdGetDeclarationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDeclarationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDeclarationDetailsQuery({
 *   variables: {
 *      file_id: // value for 'file_id'
 *   },
 * });
 */
export function useWdGetDeclarationDetailsQuery(baseOptions: Apollo.QueryHookOptions<WdGetDeclarationDetailsQuery, WdGetDeclarationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetDeclarationDetailsQuery, WdGetDeclarationDetailsQueryVariables>(WdGetDeclarationDetailsDocument, options);
      }
export function useWdGetDeclarationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetDeclarationDetailsQuery, WdGetDeclarationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetDeclarationDetailsQuery, WdGetDeclarationDetailsQueryVariables>(WdGetDeclarationDetailsDocument, options);
        }
export type WdGetDeclarationDetailsQueryHookResult = ReturnType<typeof useWdGetDeclarationDetailsQuery>;
export type WdGetDeclarationDetailsLazyQueryHookResult = ReturnType<typeof useWdGetDeclarationDetailsLazyQuery>;
export type WdGetDeclarationDetailsQueryResult = Apollo.QueryResult<WdGetDeclarationDetailsQuery, WdGetDeclarationDetailsQueryVariables>;
export const WdGetDeclarationDetailsDocumentsDocument = gql`
    query WdGetDeclarationDetailsDocuments($file: UUID!) {
  documents(file: $file, filters: {operator: "AND", filters: [{field: "DocumentEntity.is_deleted", op: "EQ", values: ["false"]}, {field: "document_type", op: "NOT_IN", values: ["edec_response_xml", "customs_overview", "customs_declaration"]}]}) {
    id
    document_name
    document_type
    document_blobs(path: "blobs")
    document_extension
    is_deleted
    number_of_pages
    document_flags
    last_modified_date
    documentType {
      name
      translations
    }
    sequence
    document_version
    pages_m2m {
      pageNumber
      page {
        id
        rotate
        thumbnailBigUrl
        thumbnailSmallUrl
        pageStatus
      }
    }
    customs_response_data {
      document_version
    }
  }
}
    `;

/**
 * __useWdGetDeclarationDetailsDocumentsQuery__
 *
 * To run a query within a React component, call `useWdGetDeclarationDetailsDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDeclarationDetailsDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDeclarationDetailsDocumentsQuery({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useWdGetDeclarationDetailsDocumentsQuery(baseOptions: Apollo.QueryHookOptions<WdGetDeclarationDetailsDocumentsQuery, WdGetDeclarationDetailsDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetDeclarationDetailsDocumentsQuery, WdGetDeclarationDetailsDocumentsQueryVariables>(WdGetDeclarationDetailsDocumentsDocument, options);
      }
export function useWdGetDeclarationDetailsDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetDeclarationDetailsDocumentsQuery, WdGetDeclarationDetailsDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetDeclarationDetailsDocumentsQuery, WdGetDeclarationDetailsDocumentsQueryVariables>(WdGetDeclarationDetailsDocumentsDocument, options);
        }
export type WdGetDeclarationDetailsDocumentsQueryHookResult = ReturnType<typeof useWdGetDeclarationDetailsDocumentsQuery>;
export type WdGetDeclarationDetailsDocumentsLazyQueryHookResult = ReturnType<typeof useWdGetDeclarationDetailsDocumentsLazyQuery>;
export type WdGetDeclarationDetailsDocumentsQueryResult = Apollo.QueryResult<WdGetDeclarationDetailsDocumentsQuery, WdGetDeclarationDetailsDocumentsQueryVariables>;
export const WdGetDocumentUpdatesDocument = gql`
    subscription WdGetDocumentUpdates {
  pp_doc_max_date_hs: pp_doc_max_date_v2(args: {_my: false}) {
    max_change_date
  }
}
    `;

/**
 * __useWdGetDocumentUpdatesSubscription__
 *
 * To run a query within a React component, call `useWdGetDocumentUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDocumentUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDocumentUpdatesSubscription({
 *   variables: {
 *   },
 * });
 */
export function useWdGetDocumentUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<WdGetDocumentUpdatesSubscription, WdGetDocumentUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WdGetDocumentUpdatesSubscription, WdGetDocumentUpdatesSubscriptionVariables>(WdGetDocumentUpdatesDocument, options);
      }
export type WdGetDocumentUpdatesSubscriptionHookResult = ReturnType<typeof useWdGetDocumentUpdatesSubscription>;
export type WdGetDocumentUpdatesSubscriptionResult = Apollo.SubscriptionResult<WdGetDocumentUpdatesSubscription>;
export const WdGetDeclarationDetailsGoodsItemsDocument = gql`
    query WdGetDeclarationDetailsGoodsItems($where: goods_item_bool_exp) {
  goodsItems: goods_item(where: $where) {
    customs_item_number
    commodity_code
    description
    packagings {
      packaging_type
      packaging_quantity
      packaging_reference_number
    }
    additional_unit
    net_mass
    gross_mass
    vat_value
    vat_total
    duty_total
    commercial_good
    clearance_type
    origin_preference
    origin_country
    repair
    repair_reason
    produced_documents {
      produced_document_type
      produced_document_reference_number
      produced_document_issue_date
    }
    statistical_code
    statistical_value
    vat_rate
    duty_rate
    goods_item_special_mentions(order_by: {sequence_number: asc}) {
      text
    }
    permit_obligation_code
    permits {
      permit_type
      permit_authority
      permit_number
    }
    selection_result
    duty_and_other_taxes_total
  }
}
    `;

/**
 * __useWdGetDeclarationDetailsGoodsItemsQuery__
 *
 * To run a query within a React component, call `useWdGetDeclarationDetailsGoodsItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDeclarationDetailsGoodsItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDeclarationDetailsGoodsItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useWdGetDeclarationDetailsGoodsItemsQuery(baseOptions?: Apollo.QueryHookOptions<WdGetDeclarationDetailsGoodsItemsQuery, WdGetDeclarationDetailsGoodsItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetDeclarationDetailsGoodsItemsQuery, WdGetDeclarationDetailsGoodsItemsQueryVariables>(WdGetDeclarationDetailsGoodsItemsDocument, options);
      }
export function useWdGetDeclarationDetailsGoodsItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetDeclarationDetailsGoodsItemsQuery, WdGetDeclarationDetailsGoodsItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetDeclarationDetailsGoodsItemsQuery, WdGetDeclarationDetailsGoodsItemsQueryVariables>(WdGetDeclarationDetailsGoodsItemsDocument, options);
        }
export type WdGetDeclarationDetailsGoodsItemsQueryHookResult = ReturnType<typeof useWdGetDeclarationDetailsGoodsItemsQuery>;
export type WdGetDeclarationDetailsGoodsItemsLazyQueryHookResult = ReturnType<typeof useWdGetDeclarationDetailsGoodsItemsLazyQuery>;
export type WdGetDeclarationDetailsGoodsItemsQueryResult = Apollo.QueryResult<WdGetDeclarationDetailsGoodsItemsQuery, WdGetDeclarationDetailsGoodsItemsQueryVariables>;
export const WdAddNotificationTriggerDocument = gql`
    mutation WdAddNotificationTrigger($data: NotificationTriggerInput!) {
  addNotificationTrigger(data: $data) {
    id
    type
    config
    creationUser {
      id
    }
    creationDate
    lastModifiedUser {
      id
    }
    lastModifiedDate
    meta
  }
}
    `;
export type WdAddNotificationTriggerMutationFn = Apollo.MutationFunction<WdAddNotificationTriggerMutation, WdAddNotificationTriggerMutationVariables>;

/**
 * __useWdAddNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useWdAddNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdAddNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdAddNotificationTriggerMutation, { data, loading, error }] = useWdAddNotificationTriggerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useWdAddNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<WdAddNotificationTriggerMutation, WdAddNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdAddNotificationTriggerMutation, WdAddNotificationTriggerMutationVariables>(WdAddNotificationTriggerDocument, options);
      }
export type WdAddNotificationTriggerMutationHookResult = ReturnType<typeof useWdAddNotificationTriggerMutation>;
export type WdAddNotificationTriggerMutationResult = Apollo.MutationResult<WdAddNotificationTriggerMutation>;
export type WdAddNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<WdAddNotificationTriggerMutation, WdAddNotificationTriggerMutationVariables>;
export const WdDeleteNotificationTriggerDocument = gql`
    mutation WdDeleteNotificationTrigger($id: Int!) {
  deleteNotificationTrigger(id: $id) {
    id
  }
}
    `;
export type WdDeleteNotificationTriggerMutationFn = Apollo.MutationFunction<WdDeleteNotificationTriggerMutation, WdDeleteNotificationTriggerMutationVariables>;

/**
 * __useWdDeleteNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useWdDeleteNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdDeleteNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdDeleteNotificationTriggerMutation, { data, loading, error }] = useWdDeleteNotificationTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWdDeleteNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<WdDeleteNotificationTriggerMutation, WdDeleteNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdDeleteNotificationTriggerMutation, WdDeleteNotificationTriggerMutationVariables>(WdDeleteNotificationTriggerDocument, options);
      }
export type WdDeleteNotificationTriggerMutationHookResult = ReturnType<typeof useWdDeleteNotificationTriggerMutation>;
export type WdDeleteNotificationTriggerMutationResult = Apollo.MutationResult<WdDeleteNotificationTriggerMutation>;
export type WdDeleteNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<WdDeleteNotificationTriggerMutation, WdDeleteNotificationTriggerMutationVariables>;
export const WdGetImportListTriggersDocument = gql`
    query WdGetImportListTriggers {
  import_list_triggers: import_list_trigger(order_by: {creation_date: desc_nulls_first}) {
    id
    display_name
    type
    config
    creation_date
    creation_user
    last_modified_date
    last_modified_user
    creationUser {
      display_name
    }
    lastModifiedUser {
      display_name
    }
    meta
    label_id
    label {
      id
      title
      description
      color
      is_deleted
    }
  }
}
    `;

/**
 * __useWdGetImportListTriggersQuery__
 *
 * To run a query within a React component, call `useWdGetImportListTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetImportListTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetImportListTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useWdGetImportListTriggersQuery(baseOptions?: Apollo.QueryHookOptions<WdGetImportListTriggersQuery, WdGetImportListTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetImportListTriggersQuery, WdGetImportListTriggersQueryVariables>(WdGetImportListTriggersDocument, options);
      }
export function useWdGetImportListTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetImportListTriggersQuery, WdGetImportListTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetImportListTriggersQuery, WdGetImportListTriggersQueryVariables>(WdGetImportListTriggersDocument, options);
        }
export type WdGetImportListTriggersQueryHookResult = ReturnType<typeof useWdGetImportListTriggersQuery>;
export type WdGetImportListTriggersLazyQueryHookResult = ReturnType<typeof useWdGetImportListTriggersLazyQuery>;
export type WdGetImportListTriggersQueryResult = Apollo.QueryResult<WdGetImportListTriggersQuery, WdGetImportListTriggersQueryVariables>;
export const WdUpdateNotificationTriggerDocument = gql`
    mutation WdUpdateNotificationTrigger($id: Int!, $data: NotificationTriggerInput!) {
  updateNotificationTrigger(id: $id, data: $data) {
    id
    displayName
    type
    config
    creationUser {
      id
    }
    creationDate
    lastModifiedUser {
      id
    }
    lastModifiedDate
    meta
  }
}
    `;
export type WdUpdateNotificationTriggerMutationFn = Apollo.MutationFunction<WdUpdateNotificationTriggerMutation, WdUpdateNotificationTriggerMutationVariables>;

/**
 * __useWdUpdateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useWdUpdateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdUpdateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdUpdateNotificationTriggerMutation, { data, loading, error }] = useWdUpdateNotificationTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useWdUpdateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<WdUpdateNotificationTriggerMutation, WdUpdateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdUpdateNotificationTriggerMutation, WdUpdateNotificationTriggerMutationVariables>(WdUpdateNotificationTriggerDocument, options);
      }
export type WdUpdateNotificationTriggerMutationHookResult = ReturnType<typeof useWdUpdateNotificationTriggerMutation>;
export type WdUpdateNotificationTriggerMutationResult = Apollo.MutationResult<WdUpdateNotificationTriggerMutation>;
export type WdUpdateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<WdUpdateNotificationTriggerMutation, WdUpdateNotificationTriggerMutationVariables>;
export const WdGetKpiDocument = gql`
    query WdGetKPI($date_from: String!, $date_to: String!, $interval: String!, $tenant_id: String, $trader_identification_number: String) {
  kpis: pp_get_kpis(date_from: $date_from, date_to: $date_to, interval: $interval, tenant_id: $tenant_id, trader_identification_number: $trader_identification_number) {
    customsDeclarations {
      tickInterval
      dateInterval {
        date
        count
        lastYearCount
      }
    }
    avgCommodityCodesPerDeclaration
    commodityCodesChapters {
      chapter
      heading
      subheading
      tariffNumber
      totalNetMass
      totalGrossMass
      declarationCount
      goodsItemCount
    }
    customsAgencies {
      label
      count
      percentage
      traderIdentificationNumber
    }
  }
}
    `;

/**
 * __useWdGetKpiQuery__
 *
 * To run a query within a React component, call `useWdGetKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetKpiQuery({
 *   variables: {
 *      date_from: // value for 'date_from'
 *      date_to: // value for 'date_to'
 *      interval: // value for 'interval'
 *      tenant_id: // value for 'tenant_id'
 *      trader_identification_number: // value for 'trader_identification_number'
 *   },
 * });
 */
export function useWdGetKpiQuery(baseOptions: Apollo.QueryHookOptions<WdGetKpiQuery, WdGetKpiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetKpiQuery, WdGetKpiQueryVariables>(WdGetKpiDocument, options);
      }
export function useWdGetKpiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetKpiQuery, WdGetKpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetKpiQuery, WdGetKpiQueryVariables>(WdGetKpiDocument, options);
        }
export type WdGetKpiQueryHookResult = ReturnType<typeof useWdGetKpiQuery>;
export type WdGetKpiLazyQueryHookResult = ReturnType<typeof useWdGetKpiLazyQuery>;
export type WdGetKpiQueryResult = Apollo.QueryResult<WdGetKpiQuery, WdGetKpiQueryVariables>;
export const WdGetKpiCommodityCodeDocument = gql`
    query WdGetKpiCommodityCode($date_from: String!, $date_to: String!, $commodity_code: String, $tenant_id: String, $trader_identification_number: String) {
  pp_get_kpi_commodity_code(date_from: $date_from, date_to: $date_to, commodity_code: $commodity_code, tenant_id: $tenant_id, trader_identification_number: $trader_identification_number) {
    declarationCount
    goodsItemCount
    totalNetMass
    totalGrossMass
  }
}
    `;

/**
 * __useWdGetKpiCommodityCodeQuery__
 *
 * To run a query within a React component, call `useWdGetKpiCommodityCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetKpiCommodityCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetKpiCommodityCodeQuery({
 *   variables: {
 *      date_from: // value for 'date_from'
 *      date_to: // value for 'date_to'
 *      commodity_code: // value for 'commodity_code'
 *      tenant_id: // value for 'tenant_id'
 *      trader_identification_number: // value for 'trader_identification_number'
 *   },
 * });
 */
export function useWdGetKpiCommodityCodeQuery(baseOptions: Apollo.QueryHookOptions<WdGetKpiCommodityCodeQuery, WdGetKpiCommodityCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetKpiCommodityCodeQuery, WdGetKpiCommodityCodeQueryVariables>(WdGetKpiCommodityCodeDocument, options);
      }
export function useWdGetKpiCommodityCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetKpiCommodityCodeQuery, WdGetKpiCommodityCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetKpiCommodityCodeQuery, WdGetKpiCommodityCodeQueryVariables>(WdGetKpiCommodityCodeDocument, options);
        }
export type WdGetKpiCommodityCodeQueryHookResult = ReturnType<typeof useWdGetKpiCommodityCodeQuery>;
export type WdGetKpiCommodityCodeLazyQueryHookResult = ReturnType<typeof useWdGetKpiCommodityCodeLazyQuery>;
export type WdGetKpiCommodityCodeQueryResult = Apollo.QueryResult<WdGetKpiCommodityCodeQuery, WdGetKpiCommodityCodeQueryVariables>;
export const WdUpdateMyProfileDocument = gql`
    mutation WdUpdateMyProfile($id: uuid!, $firstName: String!, $lastName: String!, $email: String!, $phoneNumber: String!) {
  update_user_pp_by_pk(pk_columns: {id: $id}, _set: {first_name: $firstName, last_name: $lastName, email: $email, phone_number: $phoneNumber}) {
    id
  }
}
    `;
export type WdUpdateMyProfileMutationFn = Apollo.MutationFunction<WdUpdateMyProfileMutation, WdUpdateMyProfileMutationVariables>;

/**
 * __useWdUpdateMyProfileMutation__
 *
 * To run a mutation, you first call `useWdUpdateMyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdUpdateMyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdUpdateMyProfileMutation, { data, loading, error }] = useWdUpdateMyProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useWdUpdateMyProfileMutation(baseOptions?: Apollo.MutationHookOptions<WdUpdateMyProfileMutation, WdUpdateMyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdUpdateMyProfileMutation, WdUpdateMyProfileMutationVariables>(WdUpdateMyProfileDocument, options);
      }
export type WdUpdateMyProfileMutationHookResult = ReturnType<typeof useWdUpdateMyProfileMutation>;
export type WdUpdateMyProfileMutationResult = Apollo.MutationResult<WdUpdateMyProfileMutation>;
export type WdUpdateMyProfileMutationOptions = Apollo.BaseMutationOptions<WdUpdateMyProfileMutation, WdUpdateMyProfileMutationVariables>;
export const WdGetDeclarationsGoodsItemsStatisticsDocument = gql`
    query WDGetDeclarationsGoodsItemsStatistics($limit: Int, $offset: Int, $min_date: LocalDateTime, $max_date: LocalDateTime, $search: String, $search_field: String, $declaration_statuses: String, $addresses: [AddressFilter!], $declaration_type: String, $clearance_type: String, $arrival_type: String, $orderby: [JSONObject!], $payer: UUID, $evv_status: String, $declaration_labels: String) {
  acs_goods_items_for_drs(args: {_limit: $limit, _offset: $offset, _date_min: $min_date, _date_max: $max_date, _search: $search, _search_field: $search_field, _declaration_statuses: $declaration_statuses, _orderby: $orderby, _addresses: $addresses, _decl_type: $declaration_type, _clr_type: $clearance_type, _arrival_type: $arrival_type, _payer: $payer, _evv_status: $evv_status, _declaration_labels: $declaration_labels}) {
    refs
    fileId
    drNo
    myDuties
    identification
    customsItemNumber
    declarationStatus
    declarationLabels {
      id
    }
    addresses {
      addressTypeId
      country
      companyName
      city
      street
      vatNumber
      zipcode
    }
    declarationSpecialMentions {
      text
    }
    previousDocuments {
      id
      previousDocumentType
      previousDocumentReference
    }
    customsOffice {
      number
      name
    }
    declaration {
      customsDeclarationNumber
      customsDeclarationVersion
      incoterms
      invoiceCurrencyType
      declarationType
      dutyTotalAmount
      requestorTraderIdentificationNumber
      traderDeclarationNumber
      traderReference
      totalGoodsItems
      vatNumber
      vatSuffix
      placeOfUnloading
      dispatchCountry
      packagingQuantity
      grossMass
      totalVatValue
      customsAccountNumber
      customsAccountName
      vatAccountNumber
      vatAccountName
      transportMode
      transportType
      transportCountry
      transportNumber
      dutyAndOtherTaxesAmount
      status
      serviceType
      release
      statusDate
      statusTime
      materialCheck
      vatTotalAmount
    }
    userPp {
      firstName
      email
    }
    declarationRequest {
      fileId
      drNo
      creationDate
      eta
      arrivalTime
      meta
      creationUser
      acceptanceDate
      declarationType
      arrivalType
      clearanceType
    }
    producedDocuments {
      id
      producedDocumentType
      producedDocumentReferenceNumber
      producedDocumentIssueDate
    }
    permits {
      id
      permitType
      permitAuthority
      permitNumber
    }
    packagings {
      id
      packagingType
      packagingQuantity
      packagingReferenceNumber
    }
    goodsItemSpecialMentions {
      text
    }
    goodsItems {
      netMass
      grossMass
      description
      commodityCode
      fileId
      vatValue
      originCountry
      drNo
      dutyTotal
      customsItemNumber
      commercialGood
      clearanceType
      originPreference
      repair
      repairReason
      additionalUnit
      statisticalCode
      statisticalValue
      vatRate
      vatTotal
      dutyRate
      permitObligationCode
      selectionResult
      dutyAndOtherTaxesTotal
    }
  }
}
    `;

/**
 * __useWdGetDeclarationsGoodsItemsStatisticsQuery__
 *
 * To run a query within a React component, call `useWdGetDeclarationsGoodsItemsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDeclarationsGoodsItemsStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDeclarationsGoodsItemsStatisticsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      min_date: // value for 'min_date'
 *      max_date: // value for 'max_date'
 *      search: // value for 'search'
 *      search_field: // value for 'search_field'
 *      declaration_statuses: // value for 'declaration_statuses'
 *      addresses: // value for 'addresses'
 *      declaration_type: // value for 'declaration_type'
 *      clearance_type: // value for 'clearance_type'
 *      arrival_type: // value for 'arrival_type'
 *      orderby: // value for 'orderby'
 *      payer: // value for 'payer'
 *      evv_status: // value for 'evv_status'
 *      declaration_labels: // value for 'declaration_labels'
 *   },
 * });
 */
export function useWdGetDeclarationsGoodsItemsStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<WdGetDeclarationsGoodsItemsStatisticsQuery, WdGetDeclarationsGoodsItemsStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetDeclarationsGoodsItemsStatisticsQuery, WdGetDeclarationsGoodsItemsStatisticsQueryVariables>(WdGetDeclarationsGoodsItemsStatisticsDocument, options);
      }
export function useWdGetDeclarationsGoodsItemsStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetDeclarationsGoodsItemsStatisticsQuery, WdGetDeclarationsGoodsItemsStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetDeclarationsGoodsItemsStatisticsQuery, WdGetDeclarationsGoodsItemsStatisticsQueryVariables>(WdGetDeclarationsGoodsItemsStatisticsDocument, options);
        }
export type WdGetDeclarationsGoodsItemsStatisticsQueryHookResult = ReturnType<typeof useWdGetDeclarationsGoodsItemsStatisticsQuery>;
export type WdGetDeclarationsGoodsItemsStatisticsLazyQueryHookResult = ReturnType<typeof useWdGetDeclarationsGoodsItemsStatisticsLazyQuery>;
export type WdGetDeclarationsGoodsItemsStatisticsQueryResult = Apollo.QueryResult<WdGetDeclarationsGoodsItemsStatisticsQuery, WdGetDeclarationsGoodsItemsStatisticsQueryVariables>;
export const WdGetDeclarationsGoodsItemsStatisticsCountDocument = gql`
    query WDGetDeclarationsGoodsItemsStatisticsCount($limit: Int, $offset: Int, $min_date: LocalDateTime, $max_date: LocalDateTime, $search: String, $search_field: String, $declaration_statuses: String, $addresses: [AddressFilter!], $declaration_type: String, $clearance_type: String, $arrival_type: String, $payer: UUID, $evv_status: String, $declaration_labels: String, $file: UUID) {
  acs_goods_items_for_drs_count(args: {_limit: $limit, _offset: $offset, _date_min: $min_date, _date_max: $max_date, _search: $search, _search_field: $search_field, _declaration_statuses: $declaration_statuses, _addresses: $addresses, _decl_type: $declaration_type, _clr_type: $clearance_type, _arrival_type: $arrival_type, _payer: $payer, _evv_status: $evv_status, _declaration_labels: $declaration_labels, _file_id: $file}) {
    resultSetCount
  }
}
    `;

/**
 * __useWdGetDeclarationsGoodsItemsStatisticsCountQuery__
 *
 * To run a query within a React component, call `useWdGetDeclarationsGoodsItemsStatisticsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetDeclarationsGoodsItemsStatisticsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetDeclarationsGoodsItemsStatisticsCountQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      min_date: // value for 'min_date'
 *      max_date: // value for 'max_date'
 *      search: // value for 'search'
 *      search_field: // value for 'search_field'
 *      declaration_statuses: // value for 'declaration_statuses'
 *      addresses: // value for 'addresses'
 *      declaration_type: // value for 'declaration_type'
 *      clearance_type: // value for 'clearance_type'
 *      arrival_type: // value for 'arrival_type'
 *      payer: // value for 'payer'
 *      evv_status: // value for 'evv_status'
 *      declaration_labels: // value for 'declaration_labels'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useWdGetDeclarationsGoodsItemsStatisticsCountQuery(baseOptions?: Apollo.QueryHookOptions<WdGetDeclarationsGoodsItemsStatisticsCountQuery, WdGetDeclarationsGoodsItemsStatisticsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetDeclarationsGoodsItemsStatisticsCountQuery, WdGetDeclarationsGoodsItemsStatisticsCountQueryVariables>(WdGetDeclarationsGoodsItemsStatisticsCountDocument, options);
      }
export function useWdGetDeclarationsGoodsItemsStatisticsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetDeclarationsGoodsItemsStatisticsCountQuery, WdGetDeclarationsGoodsItemsStatisticsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetDeclarationsGoodsItemsStatisticsCountQuery, WdGetDeclarationsGoodsItemsStatisticsCountQueryVariables>(WdGetDeclarationsGoodsItemsStatisticsCountDocument, options);
        }
export type WdGetDeclarationsGoodsItemsStatisticsCountQueryHookResult = ReturnType<typeof useWdGetDeclarationsGoodsItemsStatisticsCountQuery>;
export type WdGetDeclarationsGoodsItemsStatisticsCountLazyQueryHookResult = ReturnType<typeof useWdGetDeclarationsGoodsItemsStatisticsCountLazyQuery>;
export type WdGetDeclarationsGoodsItemsStatisticsCountQueryResult = Apollo.QueryResult<WdGetDeclarationsGoodsItemsStatisticsCountQuery, WdGetDeclarationsGoodsItemsStatisticsCountQueryVariables>;
export const WdCreateUserDocument = gql`
    mutation WdCreateUser($object: WDCreateUserDto!) {
  createUser: createWDUser(createUserInput: $object)
}
    `;
export type WdCreateUserMutationFn = Apollo.MutationFunction<WdCreateUserMutation, WdCreateUserMutationVariables>;

/**
 * __useWdCreateUserMutation__
 *
 * To run a mutation, you first call `useWdCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdCreateUserMutation, { data, loading, error }] = useWdCreateUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useWdCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<WdCreateUserMutation, WdCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdCreateUserMutation, WdCreateUserMutationVariables>(WdCreateUserDocument, options);
      }
export type WdCreateUserMutationHookResult = ReturnType<typeof useWdCreateUserMutation>;
export type WdCreateUserMutationResult = Apollo.MutationResult<WdCreateUserMutation>;
export type WdCreateUserMutationOptions = Apollo.BaseMutationOptions<WdCreateUserMutation, WdCreateUserMutationVariables>;
export const WdGetUsersManagementDocument = gql`
    query WdGetUsersManagement {
  users: getWDUsers {
    isEnabled
    externalAuthProvider
    id
    tenantId
    firstName
    lastName
    displayName
    email
    location
    creationDate
    lastModifiedDate
    roles {
      ...RolesList
    }
  }
}
    ${RolesListFragmentDoc}`;

/**
 * __useWdGetUsersManagementQuery__
 *
 * To run a query within a React component, call `useWdGetUsersManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useWdGetUsersManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWdGetUsersManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useWdGetUsersManagementQuery(baseOptions?: Apollo.QueryHookOptions<WdGetUsersManagementQuery, WdGetUsersManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WdGetUsersManagementQuery, WdGetUsersManagementQueryVariables>(WdGetUsersManagementDocument, options);
      }
export function useWdGetUsersManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WdGetUsersManagementQuery, WdGetUsersManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WdGetUsersManagementQuery, WdGetUsersManagementQueryVariables>(WdGetUsersManagementDocument, options);
        }
export type WdGetUsersManagementQueryHookResult = ReturnType<typeof useWdGetUsersManagementQuery>;
export type WdGetUsersManagementLazyQueryHookResult = ReturnType<typeof useWdGetUsersManagementLazyQuery>;
export type WdGetUsersManagementQueryResult = Apollo.QueryResult<WdGetUsersManagementQuery, WdGetUsersManagementQueryVariables>;
export const WdSendResetPasswordLinkDocument = gql`
    mutation WdSendResetPasswordLink($email: String!) {
  sendResetPasswordLink: sendWDResetPasswordLink(email: $email)
}
    `;
export type WdSendResetPasswordLinkMutationFn = Apollo.MutationFunction<WdSendResetPasswordLinkMutation, WdSendResetPasswordLinkMutationVariables>;

/**
 * __useWdSendResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useWdSendResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdSendResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdSendResetPasswordLinkMutation, { data, loading, error }] = useWdSendResetPasswordLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useWdSendResetPasswordLinkMutation(baseOptions?: Apollo.MutationHookOptions<WdSendResetPasswordLinkMutation, WdSendResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdSendResetPasswordLinkMutation, WdSendResetPasswordLinkMutationVariables>(WdSendResetPasswordLinkDocument, options);
      }
export type WdSendResetPasswordLinkMutationHookResult = ReturnType<typeof useWdSendResetPasswordLinkMutation>;
export type WdSendResetPasswordLinkMutationResult = Apollo.MutationResult<WdSendResetPasswordLinkMutation>;
export type WdSendResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<WdSendResetPasswordLinkMutation, WdSendResetPasswordLinkMutationVariables>;
export const WdUpdateUserDocument = gql`
    mutation WdUpdateUser($object: WDUpdateUserDto!) {
  updateWDUser(updateUserInput: $object)
}
    `;
export type WdUpdateUserMutationFn = Apollo.MutationFunction<WdUpdateUserMutation, WdUpdateUserMutationVariables>;

/**
 * __useWdUpdateUserMutation__
 *
 * To run a mutation, you first call `useWdUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWdUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wdUpdateUserMutation, { data, loading, error }] = useWdUpdateUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useWdUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<WdUpdateUserMutation, WdUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WdUpdateUserMutation, WdUpdateUserMutationVariables>(WdUpdateUserDocument, options);
      }
export type WdUpdateUserMutationHookResult = ReturnType<typeof useWdUpdateUserMutation>;
export type WdUpdateUserMutationResult = Apollo.MutationResult<WdUpdateUserMutation>;
export type WdUpdateUserMutationOptions = Apollo.BaseMutationOptions<WdUpdateUserMutation, WdUpdateUserMutationVariables>;
export const GetSasTokenDocument = gql`
    query getSASToken($container: String!, $contentType: String, $contentDisposition: String) {
  getSASToken(container: $container, contentType: $contentType, contentDisposition: $contentDisposition) {
    container
    sasToken
    expiryDate
  }
}
    `;

/**
 * __useGetSasTokenQuery__
 *
 * To run a query within a React component, call `useGetSasTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSasTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSasTokenQuery({
 *   variables: {
 *      container: // value for 'container'
 *      contentType: // value for 'contentType'
 *      contentDisposition: // value for 'contentDisposition'
 *   },
 * });
 */
export function useGetSasTokenQuery(baseOptions: Apollo.QueryHookOptions<GetSasTokenQuery, GetSasTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSasTokenQuery, GetSasTokenQueryVariables>(GetSasTokenDocument, options);
      }
export function useGetSasTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSasTokenQuery, GetSasTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSasTokenQuery, GetSasTokenQueryVariables>(GetSasTokenDocument, options);
        }
export type GetSasTokenQueryHookResult = ReturnType<typeof useGetSasTokenQuery>;
export type GetSasTokenLazyQueryHookResult = ReturnType<typeof useGetSasTokenLazyQuery>;
export type GetSasTokenQueryResult = Apollo.QueryResult<GetSasTokenQuery, GetSasTokenQueryVariables>;
export type query_rootKeySpecifier = ('acs_goods_items_for_drs' | 'acs_goods_items_for_drs_count' | 'address' | 'address_by_pk' | 'address_groups' | 'address_mapping' | 'address_mapping_by_pk' | 'address_override' | 'address_override_by_pk' | 'address_type' | 'address_type_by_pk' | 'addresses' | 'ai_stats_dt_type' | 'ai_stats_type' | 'annotation_provider' | 'annotation_provider_by_pk' | 'annotation_type' | 'annotation_type_by_pk' | 'api_key' | 'api_key_by_pk' | 'arrival_type' | 'arrival_type_by_pk' | 'article' | 'article_by_pk' | 'bill' | 'bill_aggregate' | 'bill_by_pk' | 'bill_detail' | 'bill_detail_by_pk' | 'clearance_type' | 'clearance_type_by_pk' | 'containers' | 'containers_by_pk' | 'count_type' | 'customs_office' | 'customs_office_by_pk' | 'customs_offices' | 'customs_offices_by_pk' | 'declaration' | 'declaration_by_pk' | 'declaration_discussion' | 'declaration_discussion_aggregate' | 'declaration_discussion_by_pk' | 'declaration_discussions' | 'declaration_document' | 'declaration_document_by_pk' | 'declaration_labels' | 'declaration_labels_by_pk' | 'declaration_message' | 'declaration_message_aggregate' | 'declaration_message_by_pk' | 'declaration_request' | 'declaration_request_address' | 'declaration_request_address_ai' | 'declaration_request_address_ai_by_pk' | 'declaration_request_address_by_pk' | 'declaration_request_by_pk' | 'declaration_request_labels' | 'declaration_request_labels_by_pk' | 'declaration_requests' | 'declaration_search' | 'declaration_special_mentions' | 'declaration_special_mentions_by_pk' | 'declaration_status' | 'declaration_status_by_pk' | 'declaration_task' | 'declaration_task_aggregate' | 'declaration_task_by_pk' | 'declaration_tasks' | 'declaration_tasks_obj' | 'declaration_type' | 'declaration_type_by_pk' | 'discussion_changes' | 'doc_annotation' | 'doc_annotation_by_pk' | 'doc_search_type' | 'doc_stats_type' | 'docs_for_validation' | 'document' | 'document_aggregate' | 'document_by_pk' | 'document_extension' | 'document_extension_by_pk' | 'document_flag' | 'document_flag_by_pk' | 'document_label_org_id' | 'document_label_org_id_by_pk' | 'document_labels' | 'document_labels_by_pk' | 'document_page' | 'document_page_aggregate' | 'document_page_by_pk' | 'document_status' | 'document_status_by_pk' | 'document_type' | 'document_type_aggregate' | 'document_type_all_tenant_settings' | 'document_type_by_pk' | 'document_type_tenant_settings' | 'document_type_tenant_settings_by_pk' | 'documents' | 'dr_stats' | 'edec_countries' | 'edec_countries_by_pk' | 'edec_customs_offices' | 'edec_customs_offices_by_pk' | 'edec_domains' | 'edec_domains_by_pk' | 'edec_tariff_commodity_code' | 'edec_tariff_commodity_code_by_pk' | 'edec_tariff_statistical_code' | 'edec_tariff_statistical_code_by_pk' | 'email_search_type' | 'email_search_type_aggregate' | 'extract_type' | 'extract_type_by_pk' | 'extraction_config' | 'extraction_config_by_pk' | 'file' | 'file_aggregate' | 'file_by_pk' | 'file_stats_type' | 'file_type' | 'file_type_by_pk' | 'getAddressesByFrequency' | 'getAddressesOrOverrideACS' | 'getAddressOverrides' | 'getAditRoles' | 'getAppModules' | 'getBordereaus' | 'getCommodityCodes' | 'getCurrentUser' | 'getDeclaraionLabels' | 'getDeclarationGoodItemsStatistics' | 'getDeclarationRequestAddressEntity' | 'getDeclarationRequestsAdit' | 'getDeclarationRequestStatistics' | 'getFileDocuments' | 'getFiles' | 'getGoodItemsStatistics' | 'getOrgIds' | 'getPageFragmentText' | 'getSASToken' | 'getTenantAddresses' | 'getTenantConfig' | 'getTenantReports' | 'getTenants' | 'getUserConfig' | 'getUserOrgIds' | 'getUserPermissions' | 'getUsers' | 'getWDCustomers' | 'getWDRoles' | 'getWDUsers' | 'goods_item' | 'goods_item_aggregate' | 'goods_item_by_pk' | 'goods_item_special_mentions' | 'goods_item_special_mentions_aggregate' | 'goods_item_special_mentions_by_pk' | 'goods_items_for_drs' | 'import_list_trigger' | 'import_list_trigger_aggregate' | 'import_list_trigger_by_pk' | 'intf_dr_payment_info' | 'json_type' | 'kc_users' | 'max_date_type' | 'model_retrain' | 'model_retrain_by_pk' | 'notifications' | 'org_id' | 'org_id_by_pk' | 'org_ids' | 'org_params' | 'org_params_by_pk' | 'org_params_org_id' | 'packagings' | 'packagings_aggregate' | 'packagings_by_pk' | 'page' | 'page_by_pk' | 'page_extract' | 'page_extract_by_pk' | 'page_status' | 'page_status_by_pk' | 'pages_m2m_cache' | 'pages_m2m_cache_aggregate' | 'permits' | 'permits_aggregate' | 'permits_by_pk' | 'pp_address_groups' | 'pp_addresses' | 'pp_ai_stats' | 'pp_ai_stats_dt' | 'pp_check_json_param' | 'pp_declaration_request' | 'pp_declaration_requests' | 'pp_declaration_requests_count' | 'pp_declaration_requests_report' | 'pp_declaration_tasks' | 'pp_declaration_tasks_agg' | 'pp_declaration_tasks_obj' | 'pp_declarations' | 'pp_delete_declaration_requests' | 'pp_doc_max_date_hs' | 'pp_doc_max_date_v2' | 'pp_doc_search' | 'pp_doc_search_hs' | 'pp_doc_stats' | 'pp_docs_for_validation' | 'pp_document' | 'pp_document_aggregate' | 'pp_document_flag' | 'pp_document_labels' | 'pp_dr_max_date' | 'pp_dr_stats' | 'pp_email_search' | 'pp_email_search_aggregate' | 'pp_email_search_hs' | 'pp_email_search_hs_aggregate' | 'pp_file_max_date_hs' | 'pp_file_max_date_v2' | 'pp_file_search' | 'pp_file_search_hs' | 'pp_file_stats' | 'pp_get_kpi_commodity_code' | 'pp_get_kpis' | 'pp_hasura_session' | 'pp_kc_users' | 'pp_last_doc_in_dr' | 'pp_last_doc_in_dr_aggregate' | 'pp_menu_indicators' | 'pp_org_id_delete' | 'pp_org_id_insert' | 'pp_org_id_update' | 'pp_org_ids' | 'pp_page_extract_grids_text' | 'pp_page_extract_text_fragment' | 'pp_page_extract_text_fragment_v2' | 'pp_tenants' | 'pp_types_file_search' | 'pp_user_org_id' | 'pp_user_search' | 'pp_view_document_history' | 'pp_view_file_history' | 'previous_documents' | 'previous_documents_by_pk' | 'produced_documents' | 'produced_documents_aggregate' | 'produced_documents_by_pk' | 'report' | 'report_aggregate' | 'report_by_pk' | 'service' | 'service_by_pk' | 'service_rate' | 'service_tariff' | 'service_tariff_aggregate' | 'setting' | 'setting_by_pk' | 'setting_group' | 'setting_group_by_pk' | 'setting_value' | 'setting_value_by_pk' | 'tariff_number_description' | 'tariff_number_description_by_pk' | 'task_type' | 'task_type_by_pk' | 'tenant' | 'tenant_by_pk' | 'tenants' | 'transitdoc_type_descr' | 'user_org_id' | 'user_org_id_by_pk' | 'user_pp' | 'user_pp_by_pk' | 'user_search_type' | 'view_document_history' | 'view_file_history' | 'view_history' | 'vw_documents' | 'vw_finished_files' | query_rootKeySpecifier)[];
export type query_rootFieldPolicy = {
	acs_goods_items_for_drs?: FieldPolicy<any> | FieldReadFunction<any>,
	acs_goods_items_for_drs_count?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	address_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	address_groups?: FieldPolicy<any> | FieldReadFunction<any>,
	address_mapping?: FieldPolicy<any> | FieldReadFunction<any>,
	address_mapping_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	address_override?: FieldPolicy<any> | FieldReadFunction<any>,
	address_override_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	ai_stats_dt_type?: FieldPolicy<any> | FieldReadFunction<any>,
	ai_stats_type?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_provider?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_provider_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_type?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	api_key?: FieldPolicy<any> | FieldReadFunction<any>,
	api_key_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	article?: FieldPolicy<any> | FieldReadFunction<any>,
	article_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bill?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_detail?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_detail_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	containers?: FieldPolicy<any> | FieldReadFunction<any>,
	containers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	count_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_office?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_office_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_offices?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_offices_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussion?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussion_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussion_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussions?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_document?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_document_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_labels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_message?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_message_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address_ai?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address_ai_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_labels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_requests?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_search?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_special_mentions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_task?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_task_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_task_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_tasks_obj?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_changes?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_annotation?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_annotation_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_search_type?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_stats_type?: FieldPolicy<any> | FieldReadFunction<any>,
	docs_for_validation?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	document_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	document_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flag?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flag_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_label_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	document_label_org_id_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	document_labels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_page?: FieldPolicy<any> | FieldReadFunction<any>,
	document_page_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	document_page_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_all_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_tenant_settings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_countries?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_countries_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_customs_offices?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_customs_offices_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_domains?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_domains_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_commodity_code?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_commodity_code_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_statistical_code_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	email_search_type?: FieldPolicy<any> | FieldReadFunction<any>,
	email_search_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	extract_type?: FieldPolicy<any> | FieldReadFunction<any>,
	extract_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_config?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_config_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	file_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	file_stats_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	getAddressesByFrequency?: FieldPolicy<any> | FieldReadFunction<any>,
	getAddressesOrOverrideACS?: FieldPolicy<any> | FieldReadFunction<any>,
	getAddressOverrides?: FieldPolicy<any> | FieldReadFunction<any>,
	getAditRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	getAppModules?: FieldPolicy<any> | FieldReadFunction<any>,
	getBordereaus?: FieldPolicy<any> | FieldReadFunction<any>,
	getCommodityCodes?: FieldPolicy<any> | FieldReadFunction<any>,
	getCurrentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	getDeclaraionLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	getDeclarationGoodItemsStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	getDeclarationRequestAddressEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	getDeclarationRequestsAdit?: FieldPolicy<any> | FieldReadFunction<any>,
	getDeclarationRequestStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	getFileDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	getFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	getGoodItemsStatistics?: FieldPolicy<any> | FieldReadFunction<any>,
	getOrgIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getPageFragmentText?: FieldPolicy<any> | FieldReadFunction<any>,
	getSASToken?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantAddresses?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenantReports?: FieldPolicy<any> | FieldReadFunction<any>,
	getTenants?: FieldPolicy<any> | FieldReadFunction<any>,
	getUserConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	getUserOrgIds?: FieldPolicy<any> | FieldReadFunction<any>,
	getUserPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	getUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	getWDCustomers?: FieldPolicy<any> | FieldReadFunction<any>,
	getWDRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	getWDUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_items_for_drs?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_trigger?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_trigger_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_trigger_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	intf_dr_payment_info?: FieldPolicy<any> | FieldReadFunction<any>,
	json_type?: FieldPolicy<any> | FieldReadFunction<any>,
	kc_users?: FieldPolicy<any> | FieldReadFunction<any>,
	max_date_type?: FieldPolicy<any> | FieldReadFunction<any>,
	model_retrain?: FieldPolicy<any> | FieldReadFunction<any>,
	model_retrain_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	org_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	page_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	page_extract?: FieldPolicy<any> | FieldReadFunction<any>,
	page_extract_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m_cache?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m_cache_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	permits?: FieldPolicy<any> | FieldReadFunction<any>,
	permits_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	permits_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_address_groups?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_ai_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_ai_stats_dt?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_check_json_param?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_requests?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_requests_count?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_requests_report?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_tasks_agg?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_tasks_obj?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declarations?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_delete_declaration_requests?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_max_date_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_max_date_v2?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_search_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_docs_for_validation?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_document?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_document_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_document_flag?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_document_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_dr_max_date?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_dr_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_email_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_email_search_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_email_search_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_email_search_hs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_max_date_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_max_date_v2?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_search_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_get_kpi_commodity_code?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_get_kpis?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_hasura_session?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_kc_users?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_last_doc_in_dr?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_last_doc_in_dr_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_menu_indicators?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_org_id_delete?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_org_id_insert?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_org_id_update?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_org_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_page_extract_grids_text?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_page_extract_text_fragment?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_page_extract_text_fragment_v2?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_tenants?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_types_file_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_user_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_user_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_view_document_history?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_view_file_history?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_documents_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	report?: FieldPolicy<any> | FieldReadFunction<any>,
	report_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	report_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	service_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	service_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	service_tariff?: FieldPolicy<any> | FieldReadFunction<any>,
	service_tariff_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	setting?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_group?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_group_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_value?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_value_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	tariff_number_description?: FieldPolicy<any> | FieldReadFunction<any>,
	tariff_number_description_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	tenants?: FieldPolicy<any> | FieldReadFunction<any>,
	transitdoc_type_descr?: FieldPolicy<any> | FieldReadFunction<any>,
	user_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	user_org_id_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	user_search_type?: FieldPolicy<any> | FieldReadFunction<any>,
	view_document_history?: FieldPolicy<any> | FieldReadFunction<any>,
	view_file_history?: FieldPolicy<any> | FieldReadFunction<any>,
	view_history?: FieldPolicy<any> | FieldReadFunction<any>,
	vw_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	vw_finished_files?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationGoodsItemsKeySpecifier = ('addresses' | 'customsItemNumber' | 'customsOffice' | 'declaration' | 'declarationLabels' | 'declarationRequest' | 'declarationSpecialMentions' | 'declarationStatus' | 'documents' | 'drNo' | 'fileId' | 'goodsItems' | 'goodsItemSpecialMentions' | 'identification' | 'isDeleted' | 'myDuties' | 'packagings' | 'permits' | 'previousDocuments' | 'producedDocuments' | 'refs' | 'userPp' | DeclarationGoodsItemsKeySpecifier)[];
export type DeclarationGoodsItemsFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	customsItemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	customsOffice?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationSpecialMentions?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	goodsItems?: FieldPolicy<any> | FieldReadFunction<any>,
	goodsItemSpecialMentions?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	myDuties?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings?: FieldPolicy<any> | FieldReadFunction<any>,
	permits?: FieldPolicy<any> | FieldReadFunction<any>,
	previousDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	producedDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	refs?: FieldPolicy<any> | FieldReadFunction<any>,
	userPp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressACSKeySpecifier = ('additionalValues' | 'addressType' | 'addressTypeId' | 'aoId' | 'city' | 'companyName' | 'companyName2' | 'contactEmail' | 'contactPhone' | 'contactWebsite' | 'country' | 'creationDate' | 'creationUser' | 'customsAccountNumber' | 'drReference' | 'errorEmailAddress' | 'id' | 'isDeleted' | 'isLocked' | 'isPlatformUser' | 'lastModifiedDate' | 'lastModifiedUser' | 'meta' | 'reference' | 'street' | 'streetNumber' | 'traderIdentificationNumber' | 'uidNumber' | 'usageFrequency' | 'vatAccountNumber' | 'vatNumber' | 'zipcode' | AddressACSKeySpecifier)[];
export type AddressACSFieldPolicy = {
	additionalValues?: FieldPolicy<any> | FieldReadFunction<any>,
	addressType?: FieldPolicy<any> | FieldReadFunction<any>,
	addressTypeId?: FieldPolicy<any> | FieldReadFunction<any>,
	aoId?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName?: FieldPolicy<any> | FieldReadFunction<any>,
	companyName2?: FieldPolicy<any> | FieldReadFunction<any>,
	contactEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	contactPhone?: FieldPolicy<any> | FieldReadFunction<any>,
	contactWebsite?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	customsAccountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	drReference?: FieldPolicy<any> | FieldReadFunction<any>,
	errorEmailAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	isLocked?: FieldPolicy<any> | FieldReadFunction<any>,
	isPlatformUser?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	streetNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	traderIdentificationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	uidNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	usageFrequency?: FieldPolicy<any> | FieldReadFunction<any>,
	vatAccountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vatNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	zipcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressTypeACSKeySpecifier = ('id' | 'meta' | 'name' | 'translation' | AddressTypeACSKeySpecifier)[];
export type AddressTypeACSFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EdecCustomsOfficesKeySpecifier = ('address' | 'city' | 'created' | 'id' | 'isActive' | 'name' | 'number' | 'prefix' | 'updatedAt' | 'validFrom' | 'validTo' | 'version' | EdecCustomsOfficesKeySpecifier)[];
export type EdecCustomsOfficesFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isActive?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	validFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	validTo?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationEntityKeySpecifier = ('acceptanceDate' | 'accessCode' | 'agreedLocationOfGoods' | 'borderEauNumber' | 'bunchNumber' | 'changeInformation' | 'clearanceLocation' | 'companyNumberTaxpayer' | 'correctionCode' | 'correctionReason' | 'customsAccountName' | 'customsAccountNumber' | 'customsDeclarationNumber' | 'customsDeclarationVersion' | 'customsOfficeNumber' | 'declarantNumber' | 'declarationTime' | 'declarationType' | 'deliveryDestination' | 'dispatchCountry' | 'dispatchCountryConfirmation' | 'drNo' | 'dutyAndOtherTaxesAmount' | 'dutyTotalAmount' | 'evvConfirmed' | 'evvReceived' | 'fileId' | 'goodsItems' | 'grossMass' | 'incoterms' | 'initiator' | 'inspectionCode' | 'invoiceCurrencyType' | 'lang' | 'materialCheck' | 'packagingQuantity' | 'placeOfLoading' | 'placeOfUnloading' | 'postalShipmentType' | 'previousDocument' | 'procedureType' | 'provisionalDeclarationExpirationDate' | 'reason' | 'receiveStatus' | 'release' | 'requestorTraderIdentificationNumber' | 'security' | 'selectionCorrelationId' | 'sendStatus' | 'serviceType' | 'showInWd' | 'specialMention' | 'specificCircumstanceIndicator' | 'status' | 'statusDate' | 'statusTime' | 'totalColis' | 'totalGoodsItems' | 'totalGrossWeight' | 'totalVatValue' | 'traderDeclarationNumber' | 'traderIdentificationNumber' | 'traderReference' | 'transferToTransitSystem' | 'transportCountry' | 'transportInContainer' | 'transportMode' | 'transportNumber' | 'transportType' | 'uniqueConsignmentReferenceNumber' | 'vatAccountName' | 'vatAccountNumber' | 'vatNumber' | 'vatSuffix' | 'vatTotalAmount' | 'warehouseCoded' | DeclarationEntityKeySpecifier)[];
export type DeclarationEntityFieldPolicy = {
	acceptanceDate?: FieldPolicy<any> | FieldReadFunction<any>,
	accessCode?: FieldPolicy<any> | FieldReadFunction<any>,
	agreedLocationOfGoods?: FieldPolicy<any> | FieldReadFunction<any>,
	borderEauNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	bunchNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	changeInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	clearanceLocation?: FieldPolicy<any> | FieldReadFunction<any>,
	companyNumberTaxpayer?: FieldPolicy<any> | FieldReadFunction<any>,
	correctionCode?: FieldPolicy<any> | FieldReadFunction<any>,
	correctionReason?: FieldPolicy<any> | FieldReadFunction<any>,
	customsAccountName?: FieldPolicy<any> | FieldReadFunction<any>,
	customsAccountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	customsDeclarationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	customsDeclarationVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	customsOfficeNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	declarantNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationTime?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationType?: FieldPolicy<any> | FieldReadFunction<any>,
	deliveryDestination?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatchCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatchCountryConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	dutyAndOtherTaxesAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	dutyTotalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	evvConfirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	evvReceived?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	goodsItems?: FieldPolicy<any> | FieldReadFunction<any>,
	grossMass?: FieldPolicy<any> | FieldReadFunction<any>,
	incoterms?: FieldPolicy<any> | FieldReadFunction<any>,
	initiator?: FieldPolicy<any> | FieldReadFunction<any>,
	inspectionCode?: FieldPolicy<any> | FieldReadFunction<any>,
	invoiceCurrencyType?: FieldPolicy<any> | FieldReadFunction<any>,
	lang?: FieldPolicy<any> | FieldReadFunction<any>,
	materialCheck?: FieldPolicy<any> | FieldReadFunction<any>,
	packagingQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	placeOfLoading?: FieldPolicy<any> | FieldReadFunction<any>,
	placeOfUnloading?: FieldPolicy<any> | FieldReadFunction<any>,
	postalShipmentType?: FieldPolicy<any> | FieldReadFunction<any>,
	previousDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	procedureType?: FieldPolicy<any> | FieldReadFunction<any>,
	provisionalDeclarationExpirationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	receiveStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	release?: FieldPolicy<any> | FieldReadFunction<any>,
	requestorTraderIdentificationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	security?: FieldPolicy<any> | FieldReadFunction<any>,
	selectionCorrelationId?: FieldPolicy<any> | FieldReadFunction<any>,
	sendStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	showInWd?: FieldPolicy<any> | FieldReadFunction<any>,
	specialMention?: FieldPolicy<any> | FieldReadFunction<any>,
	specificCircumstanceIndicator?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	statusDate?: FieldPolicy<any> | FieldReadFunction<any>,
	statusTime?: FieldPolicy<any> | FieldReadFunction<any>,
	totalColis?: FieldPolicy<any> | FieldReadFunction<any>,
	totalGoodsItems?: FieldPolicy<any> | FieldReadFunction<any>,
	totalGrossWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	totalVatValue?: FieldPolicy<any> | FieldReadFunction<any>,
	traderDeclarationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	traderIdentificationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	traderReference?: FieldPolicy<any> | FieldReadFunction<any>,
	transferToTransitSystem?: FieldPolicy<any> | FieldReadFunction<any>,
	transportCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	transportInContainer?: FieldPolicy<any> | FieldReadFunction<any>,
	transportMode?: FieldPolicy<any> | FieldReadFunction<any>,
	transportNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	transportType?: FieldPolicy<any> | FieldReadFunction<any>,
	uniqueConsignmentReferenceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vatAccountName?: FieldPolicy<any> | FieldReadFunction<any>,
	vatAccountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vatNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vatSuffix?: FieldPolicy<any> | FieldReadFunction<any>,
	vatTotalAmount?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouseCoded?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GoodsItemACSKeySpecifier = ('additionalUnit' | 'additionalUnitConfirmation' | 'billingType' | 'clearanceType' | 'commercialGood' | 'commodityCode' | 'commodityCodeConfirmation' | 'customsDeclarationVersion' | 'customsFavourCode' | 'customsItemNumber' | 'customsNetWeight' | 'description' | 'direction' | 'drNo' | 'dutyAndOtherTaxesTotal' | 'dutyRate' | 'dutyTotal' | 'fileId' | 'grossMass' | 'grossMassConfirmation' | 'netDuty' | 'netMass' | 'netMassConfirmation' | 'nonCustomsLawObligation' | 'originCountry' | 'originPreference' | 'packaging' | 'permitObligationCode' | 'preferenceConfirmation' | 'processType' | 'rateConfirmation' | 'refinementType' | 'refundType' | 'repair' | 'repairReason' | 'selectionResult' | 'statisticalCode' | 'statisticalValue' | 'storageType' | 'tareSupplement' | 'tareSupplementConfirmation' | 'unDangerousGoodsCode' | 'vatCode' | 'vatCodeConfirmation' | 'vatRate' | 'vatTotal' | 'vatValue' | 'vatValueConfirmation' | 'vocQuantity' | GoodsItemACSKeySpecifier)[];
export type GoodsItemACSFieldPolicy = {
	additionalUnit?: FieldPolicy<any> | FieldReadFunction<any>,
	additionalUnitConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	billingType?: FieldPolicy<any> | FieldReadFunction<any>,
	clearanceType?: FieldPolicy<any> | FieldReadFunction<any>,
	commercialGood?: FieldPolicy<any> | FieldReadFunction<any>,
	commodityCode?: FieldPolicy<any> | FieldReadFunction<any>,
	commodityCodeConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	customsDeclarationVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	customsFavourCode?: FieldPolicy<any> | FieldReadFunction<any>,
	customsItemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	customsNetWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	dutyAndOtherTaxesTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	dutyRate?: FieldPolicy<any> | FieldReadFunction<any>,
	dutyTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	grossMass?: FieldPolicy<any> | FieldReadFunction<any>,
	grossMassConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	netDuty?: FieldPolicy<any> | FieldReadFunction<any>,
	netMass?: FieldPolicy<any> | FieldReadFunction<any>,
	netMassConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	nonCustomsLawObligation?: FieldPolicy<any> | FieldReadFunction<any>,
	originCountry?: FieldPolicy<any> | FieldReadFunction<any>,
	originPreference?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging?: FieldPolicy<any> | FieldReadFunction<any>,
	permitObligationCode?: FieldPolicy<any> | FieldReadFunction<any>,
	preferenceConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	processType?: FieldPolicy<any> | FieldReadFunction<any>,
	rateConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	refinementType?: FieldPolicy<any> | FieldReadFunction<any>,
	refundType?: FieldPolicy<any> | FieldReadFunction<any>,
	repair?: FieldPolicy<any> | FieldReadFunction<any>,
	repairReason?: FieldPolicy<any> | FieldReadFunction<any>,
	selectionResult?: FieldPolicy<any> | FieldReadFunction<any>,
	statisticalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	statisticalValue?: FieldPolicy<any> | FieldReadFunction<any>,
	storageType?: FieldPolicy<any> | FieldReadFunction<any>,
	tareSupplement?: FieldPolicy<any> | FieldReadFunction<any>,
	tareSupplementConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	unDangerousGoodsCode?: FieldPolicy<any> | FieldReadFunction<any>,
	vatCode?: FieldPolicy<any> | FieldReadFunction<any>,
	vatCodeConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	vatRate?: FieldPolicy<any> | FieldReadFunction<any>,
	vatTotal?: FieldPolicy<any> | FieldReadFunction<any>,
	vatValue?: FieldPolicy<any> | FieldReadFunction<any>,
	vatValueConfirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	vocQuantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PackagingEntityKeySpecifier = ('customsItemNumber' | 'drNo' | 'fileId' | 'id' | 'packagingQuantity' | 'packagingReferenceNumber' | 'packagingType' | PackagingEntityKeySpecifier)[];
export type PackagingEntityFieldPolicy = {
	customsItemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packagingQuantity?: FieldPolicy<any> | FieldReadFunction<any>,
	packagingReferenceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	packagingType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PreviousDocumentEntityKeySpecifier = ('additionalInformation' | 'drNo' | 'fileId' | 'id' | 'previousDocumentReference' | 'previousDocumentType' | PreviousDocumentEntityKeySpecifier)[];
export type PreviousDocumentEntityFieldPolicy = {
	additionalInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	previousDocumentReference?: FieldPolicy<any> | FieldReadFunction<any>,
	previousDocumentType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationSpecialMentionEntityKeySpecifier = ('drNo' | 'fileId' | 'id' | 'sequenceNumber' | 'text' | DeclarationSpecialMentionEntityKeySpecifier)[];
export type DeclarationSpecialMentionEntityFieldPolicy = {
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequenceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationLabelKeySpecifier = ('color' | 'description' | 'id' | 'isDeleted' | 'title' | DeclarationLabelKeySpecifier)[];
export type DeclarationLabelFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationRequestACSKeySpecifier = ('acceptanceDate' | 'accountNumber' | 'aiAutodec' | 'aiDate' | 'arrivalTime' | 'arrivalType' | 'cevStatus' | 'chExpDecl' | 'clearanceType' | 'creationDate' | 'creationUser' | 'customsDeclarationNumber' | 'customsDeclarationVersion' | 'declarationType' | 'destTolldeptCode' | 'destTolldeptName' | 'drNo' | 'edec' | 'eta' | 'fileId' | 'impCustClr' | 'isExpress' | 'meta' | 'serviceType' | 'tollDep' | 'traderReference' | 'transitdocType' | 'trNo' | 'userPp' | 'waNumber' | DeclarationRequestACSKeySpecifier)[];
export type DeclarationRequestACSFieldPolicy = {
	acceptanceDate?: FieldPolicy<any> | FieldReadFunction<any>,
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	aiAutodec?: FieldPolicy<any> | FieldReadFunction<any>,
	aiDate?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalTime?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalType?: FieldPolicy<any> | FieldReadFunction<any>,
	cevStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	chExpDecl?: FieldPolicy<any> | FieldReadFunction<any>,
	clearanceType?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	customsDeclarationNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	customsDeclarationVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationType?: FieldPolicy<any> | FieldReadFunction<any>,
	destTolldeptCode?: FieldPolicy<any> | FieldReadFunction<any>,
	destTolldeptName?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	edec?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	impCustClr?: FieldPolicy<any> | FieldReadFunction<any>,
	isExpress?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	serviceType?: FieldPolicy<any> | FieldReadFunction<any>,
	tollDep?: FieldPolicy<any> | FieldReadFunction<any>,
	traderReference?: FieldPolicy<any> | FieldReadFunction<any>,
	transitdocType?: FieldPolicy<any> | FieldReadFunction<any>,
	trNo?: FieldPolicy<any> | FieldReadFunction<any>,
	userPp?: FieldPolicy<any> | FieldReadFunction<any>,
	waNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserPPKeySpecifier = ('code' | 'creationDate' | 'creationUser' | 'defaultRoleId' | 'deleted' | 'deletedAt' | 'deletedByUser' | 'displayName' | 'email' | 'externalAuthProvider' | 'firstName' | 'id' | 'isEnabled' | 'lastModifiedDate' | 'lastModifiedUser' | 'lastName' | 'ldapEntryDn' | 'location' | 'modules' | 'oauthId' | 'orgIdEntities' | 'permissions' | 'permissionsDesk' | 'phoneNumber' | 'roles' | 'tenant' | 'tenantId' | 'uiSettings' | 'uiSettingsTemplates' | 'userModules' | 'userType' | UserPPKeySpecifier)[];
export type UserPPFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultRoleId?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedByUser?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	externalAuthProvider?: FieldPolicy<any> | FieldReadFunction<any>,
	firstName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	lastName?: FieldPolicy<any> | FieldReadFunction<any>,
	ldapEntryDn?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	modules?: FieldPolicy<any> | FieldReadFunction<any>,
	oauthId?: FieldPolicy<any> | FieldReadFunction<any>,
	orgIdEntities?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionsDesk?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	uiSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	uiSettingsTemplates?: FieldPolicy<any> | FieldReadFunction<any>,
	userModules?: FieldPolicy<any> | FieldReadFunction<any>,
	userType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ModuleEntityKeySpecifier = ('id' | 'name' | ModuleEntityKeySpecifier)[];
export type ModuleEntityFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrgIdEntityKeySpecifier = ('creationDate' | 'displayName' | 'lastModifiedDate' | 'orgId' | 'orgIdDescription' | OrgIdEntityKeySpecifier)[];
export type OrgIdEntityFieldPolicy = {
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	orgIdDescription?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleKeySpecifier = ('description' | 'grantedPermissions' | 'id' | 'isWdRelevant' | 'name' | 'translations' | RoleKeySpecifier)[];
export type RoleFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	grantedPermissions?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isWdRelevant?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GrantedPermissionKeySpecifier = ('permission' | 'permissionId' | 'roleId' | GrantedPermissionKeySpecifier)[];
export type GrantedPermissionFieldPolicy = {
	permission?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionId?: FieldPolicy<any> | FieldReadFunction<any>,
	roleId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermissionEntityKeySpecifier = ('action' | 'conditions' | 'description' | 'permissionId' | 'subject' | PermissionEntityKeySpecifier)[];
export type PermissionEntityFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	conditions?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionId?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TenantEntityKeySpecifier = ('accountNumber' | 'address' | 'addressId' | 'creationDate' | 'declarationLabels' | 'documentTypeTenantSettings' | 'externalTenantId' | 'id' | 'isWdCustomer' | 'lastModifiedDate' | 'permissions' | 'permissionsJs' | 'roles' | 'tenantName' | 'tenantType' | 'traderIdentificationNumber' | TenantEntityKeySpecifier)[];
export type TenantEntityFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressId?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	documentTypeTenantSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	externalTenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isWdCustomer?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	permissionsJs?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantName?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantType?: FieldPolicy<any> | FieldReadFunction<any>,
	traderIdentificationNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentTypeTenantSettingsACSKeySpecifier = ('code' | 'creationDate' | 'creationUser' | 'defaultFlags' | 'displayName' | 'documentType' | 'lastModifiedDate' | 'lastModifiedUser' | 'meta' | DocumentTypeTenantSettingsACSKeySpecifier)[];
export type DocumentTypeTenantSettingsACSFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserModuleEntityKeySpecifier = ('moduleId' | 'userId' | UserModuleEntityKeySpecifier)[];
export type UserModuleEntityFieldPolicy = {
	moduleId?: FieldPolicy<any> | FieldReadFunction<any>,
	userId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentsKeySpecifier = ('checksum' | 'creation_date' | 'creation_user' | 'customs_response_data' | 'document_blobs' | 'document_extension' | 'document_flags' | 'document_name' | 'document_status' | 'document_type' | 'document_version' | 'documentType' | 'file' | 'id' | 'is_customs_relevant' | 'is_deleted' | 'is_generated' | 'is_template' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'number_of_pages' | 'org_id' | 'pages_m2m' | 'sequence' | DocumentsKeySpecifier)[];
export type DocumentsFieldPolicy = {
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_response_data?: FieldPolicy<any> | FieldReadFunction<any>,
	document_blobs?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_customs_relevant?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	is_generated?: FieldPolicy<any> | FieldReadFunction<any>,
	is_template?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomsResponseDataKeySpecifier = ('acceptance_date' | 'acceptance_time' | 'access_code' | 'consignee' | 'consignor' | 'correction_code' | 'creation_date' | 'customs_account' | 'customs_clearance_type' | 'customs_office' | 'declarant' | 'declaration_type' | 'dispatch_country' | 'doc_id' | 'doctype_detected' | 'document_type' | 'document_version' | 'dr_no' | 'duty_and_additional_taxes' | 'file_id' | 'ft_search' | 'goods_item' | 'goods_items_tbl' | 'gross_mass' | 'importer' | 'incoterms' | 'invoice_currency_type' | 'message' | 'meta' | 'number_of_goods_items' | 'packaging_quantity' | 'previous_document' | 'special_mention' | 'trader_declaration_number' | 'trader_identification_number' | 'traderreference' | 'transport_in_container' | 'transport_means' | 'valuation_summary' | 'value' | 'vat' | 'vat_account' | 'vatnumber' | 'vatvalue' | CustomsResponseDataKeySpecifier)[];
export type CustomsResponseDataFieldPolicy = {
	acceptance_date?: FieldPolicy<any> | FieldReadFunction<any>,
	acceptance_time?: FieldPolicy<any> | FieldReadFunction<any>,
	access_code?: FieldPolicy<any> | FieldReadFunction<any>,
	consignee?: FieldPolicy<any> | FieldReadFunction<any>,
	consignor?: FieldPolicy<any> | FieldReadFunction<any>,
	correction_code?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_account?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_office?: FieldPolicy<any> | FieldReadFunction<any>,
	declarant?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatch_country?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_id?: FieldPolicy<any> | FieldReadFunction<any>,
	doctype_detected?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_additional_taxes?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	ft_search?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_items_tbl?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	importer?: FieldPolicy<any> | FieldReadFunction<any>,
	incoterms?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice_currency_type?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_goods_items?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_document?: FieldPolicy<any> | FieldReadFunction<any>,
	special_mention?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_declaration_number?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_identification_number?: FieldPolicy<any> | FieldReadFunction<any>,
	traderreference?: FieldPolicy<any> | FieldReadFunction<any>,
	transport_in_container?: FieldPolicy<any> | FieldReadFunction<any>,
	transport_means?: FieldPolicy<any> | FieldReadFunction<any>,
	valuation_summary?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	vat?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_account?: FieldPolicy<any> | FieldReadFunction<any>,
	vatnumber?: FieldPolicy<any> | FieldReadFunction<any>,
	vatvalue?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EvvAddressKeySpecifier = ('city' | 'country' | 'name' | 'postalCode' | 'street' | EvvAddressKeySpecifier)[];
export type EvvAddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentTypeKeySpecifier = ('creationDate' | 'creationUser' | 'displayName' | 'document_type_all_tenant_settings' | 'lastModifiedDate' | 'lastModifiedUser' | 'name' | 'translations' | DocumentTypeKeySpecifier)[];
export type DocumentTypeFieldPolicy = {
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_all_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentTypeTenantSettingsKeySpecifier = ('code' | 'creationDate' | 'creationUser' | 'defaultFlags' | 'displayName' | 'documentSchema' | 'documentType' | 'lastModifiedDate' | 'lastModifiedUser' | 'meta' | 'tenant' | DocumentTypeTenantSettingsKeySpecifier)[];
export type DocumentTypeTenantSettingsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	documentSchema?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentPageKeySpecifier = ('documentId' | 'page' | 'pageId' | 'pageNumber' | DocumentPageKeySpecifier)[];
export type DocumentPageFieldPolicy = {
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageId?: FieldPolicy<any> | FieldReadFunction<any>,
	pageNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PageACSKeySpecifier = ('creationDate' | 'creationUser' | 'id' | 'lastModifiedDate' | 'lastModifiedUser' | 'meta' | 'ocrText' | 'pageNumber' | 'pageStatus' | 'rotate' | 'thumbnailBigUrl' | 'thumbnailSmallUrl' | PageACSKeySpecifier)[];
export type PageACSFieldPolicy = {
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	ocrText?: FieldPolicy<any> | FieldReadFunction<any>,
	pageNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	pageStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailBigUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailSmallUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GoodsItemSpecialMentionEntityKeySpecifier = ('customsItemNumber' | 'drNo' | 'fileId' | 'id' | 'sequenceNumber' | 'text' | GoodsItemSpecialMentionEntityKeySpecifier)[];
export type GoodsItemSpecialMentionEntityFieldPolicy = {
	customsItemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequenceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PermitEntityKeySpecifier = ('additionalInformation' | 'customsItemNumber' | 'drNo' | 'fileId' | 'id' | 'issueDate' | 'permitAuthority' | 'permitItemDetails' | 'permitNumber' | 'permitType' | PermitEntityKeySpecifier)[];
export type PermitEntityFieldPolicy = {
	additionalInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	customsItemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	permitAuthority?: FieldPolicy<any> | FieldReadFunction<any>,
	permitItemDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	permitNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	permitType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProducedDocumentEntityKeySpecifier = ('additionalInformation' | 'customsItemNumber' | 'drNo' | 'fileId' | 'id' | 'producedDocumentIssueDate' | 'producedDocumentReferenceNumber' | 'producedDocumentType' | ProducedDocumentEntityKeySpecifier)[];
export type ProducedDocumentEntityFieldPolicy = {
	additionalInformation?: FieldPolicy<any> | FieldReadFunction<any>,
	customsItemNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	producedDocumentIssueDate?: FieldPolicy<any> | FieldReadFunction<any>,
	producedDocumentReferenceNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	producedDocumentType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CountKeySpecifier = ('resultSetCount' | CountKeySpecifier)[];
export type CountFieldPolicy = {
	resultSetCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type addressKeySpecifier = ('additional_values' | 'address_type' | 'addressType' | 'ao_id' | 'city' | 'company_name' | 'company_name_2' | 'contact_email' | 'contact_phone' | 'contact_website' | 'country' | 'creation_date' | 'creation_user' | 'creationUser' | 'customs_account_number' | 'error_email_address' | 'extraction_config' | 'id' | 'imported' | 'is_active' | 'is_deleted' | 'is_locked' | 'is_platform_user' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'payer_id' | 'reference' | 'search_vector' | 'street' | 'street_number' | 'tenant' | 'trader_identification_number' | 'uid_number' | 'usage_frequency' | 'vat_account_number' | 'vat_number' | 'zipcode' | addressKeySpecifier)[];
export type addressFieldPolicy = {
	additional_values?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	addressType?: FieldPolicy<any> | FieldReadFunction<any>,
	ao_id?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	company_name?: FieldPolicy<any> | FieldReadFunction<any>,
	company_name_2?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_email?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_phone?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_website?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	error_email_address?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_config?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	imported?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	is_locked?: FieldPolicy<any> | FieldReadFunction<any>,
	is_platform_user?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	payer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	search_vector?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	street_number?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_identification_number?: FieldPolicy<any> | FieldReadFunction<any>,
	uid_number?: FieldPolicy<any> | FieldReadFunction<any>,
	usage_frequency?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_number?: FieldPolicy<any> | FieldReadFunction<any>,
	zipcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type address_typeKeySpecifier = ('id' | 'meta' | 'name' | 'translation' | address_typeKeySpecifier)[];
export type address_typeFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type user_ppKeySpecifier = ('code' | 'created_by_user' | 'creation_date' | 'creation_user' | 'deleted' | 'deleted_at' | 'deleted_by_user' | 'display_name' | 'email' | 'first_name' | 'id' | 'last_modified_date' | 'last_modified_user' | 'last_name' | 'ldap_entry_dn' | 'location' | 'oauth_id' | 'permissions' | 'phone_number' | 'tenant' | 'tenant_id' | 'ui_settings' | 'ui_settings_templates' | 'user_type' | 'userOrgIds' | user_ppKeySpecifier)[];
export type user_ppFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	created_by_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted_at?: FieldPolicy<any> | FieldReadFunction<any>,
	deleted_by_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	first_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	last_name?: FieldPolicy<any> | FieldReadFunction<any>,
	ldap_entry_dn?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	oauth_id?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	ui_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	ui_settings_templates?: FieldPolicy<any> | FieldReadFunction<any>,
	user_type?: FieldPolicy<any> | FieldReadFunction<any>,
	userOrgIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type tenantKeySpecifier = ('account_number' | 'address' | 'address_id' | 'api_keys' | 'creation_date' | 'creation_user' | 'declaration_labels' | 'document_labels' | 'id' | 'import_list_triggers' | 'import_list_triggers_aggregate' | 'is_wd_customer' | 'last_modified_date' | 'last_modified_user' | 'org_ids' | 'permissions' | 'permissions_js' | 'service_rates' | 'tenant_name' | 'tenant_type' | 'tenantDocumentTypes' | 'trader_identification_number' | 'user_pps' | tenantKeySpecifier)[];
export type tenantFieldPolicy = {
	account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	address_id?: FieldPolicy<any> | FieldReadFunction<any>,
	api_keys?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	document_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_triggers?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_triggers_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	is_wd_customer?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	org_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions_js?: FieldPolicy<any> | FieldReadFunction<any>,
	service_rates?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_name?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantDocumentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_identification_number?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pps?: FieldPolicy<any> | FieldReadFunction<any>
};
export type api_keyKeySpecifier = ('api_key' | 'dsplay_name' | 'id' | 'meta' | api_keyKeySpecifier)[];
export type api_keyFieldPolicy = {
	api_key?: FieldPolicy<any> | FieldReadFunction<any>,
	dsplay_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_labelsKeySpecifier = ('color' | 'description' | 'id' | 'is_deleted' | 'tenant' | 'tenant_id' | 'title' | declaration_labelsKeySpecifier)[];
export type declaration_labelsFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_labelsKeySpecifier = ('color' | 'description' | 'document_label_org_ids' | 'id' | 'is_deleted' | 'tenant' | 'tenantId' | 'title' | document_labelsKeySpecifier)[];
export type document_labelsFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	document_label_org_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_label_org_idKeySpecifier = ('label_id' | 'org_id' | 'orgId' | document_label_org_idKeySpecifier)[];
export type document_label_org_idFieldPolicy = {
	label_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type org_idKeySpecifier = ('active' | 'creation_date' | 'creation_user' | 'display_name' | 'documents' | 'documents_aggregate' | 'last_modified_date' | 'last_modified_user' | 'org_id' | 'org_id_description' | 'orgIdUsers' | 'tenant_id' | 'userOrgId' | org_idKeySpecifier)[];
export type org_idFieldPolicy = {
	active?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id_description?: FieldPolicy<any> | FieldReadFunction<any>,
	orgIdUsers?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	userOrgId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type documentKeySpecifier = ('annotationType' | 'articles' | 'checksum' | 'computedPagesM2M' | 'created_by_user' | 'creation_date' | 'creation_user' | 'doc_tasks' | 'doc_tasks_aggregate' | 'docAnnotations' | 'document_blobs' | 'document_extension' | 'document_flags' | 'document_name' | 'document_status' | 'document_type' | 'document_version' | 'documentExtensionByDocumentExtension' | 'documentFile' | 'documentType' | 'dr_no' | 'file' | 'file_object' | 'id' | 'is_customs_relevant' | 'is_deleted' | 'is_generated' | 'is_template' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'number_of_pages' | 'org_id' | 'organization' | 'orgId' | 'pages_m2m' | 'pages_m2m_aggregate' | 'sequence' | 'status' | documentKeySpecifier)[];
export type documentFieldPolicy = {
	annotationType?: FieldPolicy<any> | FieldReadFunction<any>,
	articles?: FieldPolicy<any> | FieldReadFunction<any>,
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	computedPagesM2M?: FieldPolicy<any> | FieldReadFunction<any>,
	created_by_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_tasks_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	docAnnotations?: FieldPolicy<any> | FieldReadFunction<any>,
	document_blobs?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	documentExtensionByDocumentExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	documentFile?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	file_object?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_customs_relevant?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	is_generated?: FieldPolicy<any> | FieldReadFunction<any>,
	is_template?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type annotation_typeKeySpecifier = ('anno_schema' | 'anno_type_id' | 'annotation_provider' | 'annotation_provider_id' | 'annotation_schema' | 'annotation_type' | 'document_type' | 'documentType' | 'meta' | 'ui_schema' | annotation_typeKeySpecifier)[];
export type annotation_typeFieldPolicy = {
	anno_schema?: FieldPolicy<any> | FieldReadFunction<any>,
	anno_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_provider?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_provider_id?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_schema?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	ui_schema?: FieldPolicy<any> | FieldReadFunction<any>
};
export type annotation_providerKeySpecifier = ('annotation_provider' | 'annotation_provider_id' | annotation_providerKeySpecifier)[];
export type annotation_providerFieldPolicy = {
	annotation_provider?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_provider_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_typeKeySpecifier = ('annotation_types' | 'creation_date' | 'creation_user' | 'display_name' | 'document_type_all_tenant_settings' | 'document_type_tenant_settings' | 'documents' | 'documents_aggregate' | 'last_modified_date' | 'last_modified_user' | 'name' | 'translations' | 'user_pp' | 'userPpByCreationUser' | document_typeKeySpecifier)[];
export type document_typeFieldPolicy = {
	annotation_types?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_all_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp?: FieldPolicy<any> | FieldReadFunction<any>,
	userPpByCreationUser?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_type_all_tenant_settingsKeySpecifier = ('code' | 'creation_date' | 'creation_user' | 'default_flags' | 'display_name' | 'document_schema' | 'document_type' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'tenant' | document_type_all_tenant_settingsKeySpecifier)[];
export type document_type_all_tenant_settingsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	default_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_schema?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_type_tenant_settingsKeySpecifier = ('code' | 'creation_date' | 'creation_user' | 'default_flags' | 'display_name' | 'document_schema' | 'document_type' | 'documentType' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'tenant' | 'Tenant' | document_type_tenant_settingsKeySpecifier)[];
export type document_type_tenant_settingsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	default_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_schema?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	Tenant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_aggregateKeySpecifier = ('aggregate' | 'nodes' | document_aggregateKeySpecifier)[];
export type document_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | document_aggregate_fieldsKeySpecifier)[];
export type document_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_avg_fieldsKeySpecifier = ('document_flags' | 'document_version' | 'dr_no' | 'number_of_pages' | 'org_id' | 'sequence' | document_avg_fieldsKeySpecifier)[];
export type document_avg_fieldsFieldPolicy = {
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_max_fieldsKeySpecifier = ('checksum' | 'creation_date' | 'creation_user' | 'document_extension' | 'document_flags' | 'document_name' | 'document_status' | 'document_type' | 'document_version' | 'dr_no' | 'file' | 'id' | 'last_modified_date' | 'last_modified_user' | 'number_of_pages' | 'org_id' | 'sequence' | document_max_fieldsKeySpecifier)[];
export type document_max_fieldsFieldPolicy = {
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_min_fieldsKeySpecifier = ('checksum' | 'creation_date' | 'creation_user' | 'document_extension' | 'document_flags' | 'document_name' | 'document_status' | 'document_type' | 'document_version' | 'dr_no' | 'file' | 'id' | 'last_modified_date' | 'last_modified_user' | 'number_of_pages' | 'org_id' | 'sequence' | document_min_fieldsKeySpecifier)[];
export type document_min_fieldsFieldPolicy = {
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_stddev_fieldsKeySpecifier = ('document_flags' | 'document_version' | 'dr_no' | 'number_of_pages' | 'org_id' | 'sequence' | document_stddev_fieldsKeySpecifier)[];
export type document_stddev_fieldsFieldPolicy = {
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_stddev_pop_fieldsKeySpecifier = ('document_flags' | 'document_version' | 'dr_no' | 'number_of_pages' | 'org_id' | 'sequence' | document_stddev_pop_fieldsKeySpecifier)[];
export type document_stddev_pop_fieldsFieldPolicy = {
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_stddev_samp_fieldsKeySpecifier = ('document_flags' | 'document_version' | 'dr_no' | 'number_of_pages' | 'org_id' | 'sequence' | document_stddev_samp_fieldsKeySpecifier)[];
export type document_stddev_samp_fieldsFieldPolicy = {
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_sum_fieldsKeySpecifier = ('document_flags' | 'document_version' | 'dr_no' | 'number_of_pages' | 'org_id' | 'sequence' | document_sum_fieldsKeySpecifier)[];
export type document_sum_fieldsFieldPolicy = {
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_var_pop_fieldsKeySpecifier = ('document_flags' | 'document_version' | 'dr_no' | 'number_of_pages' | 'org_id' | 'sequence' | document_var_pop_fieldsKeySpecifier)[];
export type document_var_pop_fieldsFieldPolicy = {
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_var_samp_fieldsKeySpecifier = ('document_flags' | 'document_version' | 'dr_no' | 'number_of_pages' | 'org_id' | 'sequence' | document_var_samp_fieldsKeySpecifier)[];
export type document_var_samp_fieldsFieldPolicy = {
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_variance_fieldsKeySpecifier = ('document_flags' | 'document_version' | 'dr_no' | 'number_of_pages' | 'org_id' | 'sequence' | document_variance_fieldsKeySpecifier)[];
export type document_variance_fieldsFieldPolicy = {
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type articleKeySpecifier = ('article_id' | 'code' | 'coords' | 'country_of_origin' | 'description' | 'doc_id' | 'document' | 'gross_weight' | 'height' | 'hscode' | 'length' | 'marks' | 'meta' | 'net_weight' | 'number' | 'page_id' | 'price' | 'purchase_order_number' | 'quantity' | 'size' | 'total_price' | 'unit' | 'volume' | 'width' | articleKeySpecifier)[];
export type articleFieldPolicy = {
	article_id?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	coords?: FieldPolicy<any> | FieldReadFunction<any>,
	country_of_origin?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_id?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	hscode?: FieldPolicy<any> | FieldReadFunction<any>,
	length?: FieldPolicy<any> | FieldReadFunction<any>,
	marks?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	page_id?: FieldPolicy<any> | FieldReadFunction<any>,
	price?: FieldPolicy<any> | FieldReadFunction<any>,
	purchase_order_number?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	size?: FieldPolicy<any> | FieldReadFunction<any>,
	total_price?: FieldPolicy<any> | FieldReadFunction<any>,
	unit?: FieldPolicy<any> | FieldReadFunction<any>,
	volume?: FieldPolicy<any> | FieldReadFunction<any>,
	width?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cacheKeySpecifier = ('document_id' | 'meta' | 'page' | 'page_number' | 'page_status' | 'rotate' | 'thumbnail_big_url' | 'thumbnail_small_url' | pages_m2m_cacheKeySpecifier)[];
export type pages_m2m_cacheFieldPolicy = {
	document_id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_big_url?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_small_url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_taskKeySpecifier = ('assigned_to' | 'assigned_user' | 'creation_date' | 'document' | 'due_date' | 'file' | 'id' | 'meta' | 'object_id' | 'task_status_id' | 'task_type' | 'task_type_id' | 'title' | declaration_taskKeySpecifier)[];
export type declaration_taskFieldPolicy = {
	assigned_to?: FieldPolicy<any> | FieldReadFunction<any>,
	assigned_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	due_date?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	object_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type fileKeySpecifier = ('ai_doc_classification_confirmed' | 'created_by_user' | 'creation_date' | 'creation_user' | 'declaration' | 'declaration_requests' | 'documents' | 'documents_aggregate' | 'file_flags' | 'file_status' | 'file_tasks' | 'file_tasks_aggregate' | 'file_type' | 'file_url' | 'id' | 'identification' | 'is_deleted' | 'last_modified_by_user' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'name' | 'org_id' | 'orgId' | 'session_id' | fileKeySpecifier)[];
export type fileFieldPolicy = {
	ai_doc_classification_confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	created_by_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_requests?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	file_tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	file_tasks_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file_url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_by_user?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	session_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_requestKeySpecifier = ('acceptance_date' | 'account_number' | 'addresses' | 'arrival_time' | 'arrival_type' | 'arrivalType' | 'bill_details' | 'cev_status' | 'ch_exp_decl' | 'clearance_type' | 'clearanceTypeByClearanceType' | 'clientCompany' | 'creation_date' | 'creation_user' | 'customs_declaration_number' | 'customs_declaration_version' | 'customsOffices' | 'declaration' | 'declaration_discussions' | 'declaration_discussions_aggregate' | 'declaration_documents' | 'declaration_request_addresses' | 'declaration_request_labels' | 'declaration_status' | 'declaration_type' | 'declarationStatusByDeclarationStatus' | 'declarationTypeByDeclarationType' | 'dest_tolldept_code' | 'dest_tolldept_name' | 'documents' | 'documents_aggregate' | 'dr_no' | 'edec' | 'eta' | 'file' | 'file_id' | 'imp_cust_clr' | 'is_express' | 'meta' | 'mrn_number' | 'payer' | 'payer_id' | 'service_type' | 'toll_dep' | 'tr_no' | 'trader_reference' | 'transitdoc_type' | 'user_pp' | 'wa_number' | declaration_requestKeySpecifier)[];
export type declaration_requestFieldPolicy = {
	acceptance_date?: FieldPolicy<any> | FieldReadFunction<any>,
	account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_time?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalType?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_details?: FieldPolicy<any> | FieldReadFunction<any>,
	cev_status?: FieldPolicy<any> | FieldReadFunction<any>,
	ch_exp_decl?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearanceTypeByClearanceType?: FieldPolicy<any> | FieldReadFunction<any>,
	clientCompany?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customsOffices?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussions?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationStatusByDeclarationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationTypeByDeclarationType?: FieldPolicy<any> | FieldReadFunction<any>,
	dest_tolldept_code?: FieldPolicy<any> | FieldReadFunction<any>,
	dest_tolldept_name?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	edec?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	imp_cust_clr?: FieldPolicy<any> | FieldReadFunction<any>,
	is_express?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	mrn_number?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>,
	payer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	service_type?: FieldPolicy<any> | FieldReadFunction<any>,
	toll_dep?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_reference?: FieldPolicy<any> | FieldReadFunction<any>,
	transitdoc_type?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_request_addressKeySpecifier = ('address' | 'address_id' | 'address_type' | 'creation_date' | 'creation_user' | 'declaration_request' | 'dr_no' | 'file_id' | 'meta' | 'refs' | 'search_refs' | declaration_request_addressKeySpecifier)[];
export type declaration_request_addressFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	address_id?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	refs?: FieldPolicy<any> | FieldReadFunction<any>,
	search_refs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type arrival_typeKeySpecifier = ('arrival_type' | 'creation_date' | 'creation_user' | 'description' | 'meta' | arrival_typeKeySpecifier)[];
export type arrival_typeFieldPolicy = {
	arrival_type?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_detailKeySpecifier = ('bill' | 'bill_id' | 'charged_items' | 'const_charge' | 'creation_date' | 'declaration_request' | 'detail_id' | 'dr_no' | 'file_id' | 'remark' | 'sequence' | 'service' | 'srv_id' | 'var_charge' | bill_detailKeySpecifier)[];
export type bill_detailFieldPolicy = {
	bill?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	charged_items?: FieldPolicy<any> | FieldReadFunction<any>,
	const_charge?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	detail_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	remark?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	srv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	var_charge?: FieldPolicy<any> | FieldReadFunction<any>
};
export type billKeySpecifier = ('bill_details' | 'bill_id' | 'bill_type' | 'from_ts' | 'meta' | 'payment_terms' | 'tenant' | 'tenant_id' | 'to_ts' | billKeySpecifier)[];
export type billFieldPolicy = {
	bill_details?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_type?: FieldPolicy<any> | FieldReadFunction<any>,
	from_ts?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	to_ts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type serviceKeySpecifier = ('service_rates' | 'srv_desk' | 'srv_id' | 'srv_type' | 'translation' | serviceKeySpecifier)[];
export type serviceFieldPolicy = {
	service_rates?: FieldPolicy<any> | FieldReadFunction<any>,
	srv_desk?: FieldPolicy<any> | FieldReadFunction<any>,
	srv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	srv_type?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_rateKeySpecifier = ('const_included' | 'const_rate' | 'service' | 'srv_id' | 'start_date' | 'tenant_id' | 'var_rate' | service_rateKeySpecifier)[];
export type service_rateFieldPolicy = {
	const_included?: FieldPolicy<any> | FieldReadFunction<any>,
	const_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	srv_id?: FieldPolicy<any> | FieldReadFunction<any>,
	start_date?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	var_rate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type clearance_typeKeySpecifier = ('declaration_requests' | 'name' | clearance_typeKeySpecifier)[];
export type clearance_typeFieldPolicy = {
	declaration_requests?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customs_officesKeySpecifier = ('address' | 'city' | 'name' | 'office_number' | 'prefix' | 'valid_from' | 'valid_to' | customs_officesKeySpecifier)[];
export type customs_officesFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	office_number?: FieldPolicy<any> | FieldReadFunction<any>,
	prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_from?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declarationKeySpecifier = ('acceptance_date' | 'access_code' | 'addresses' | 'agreed_location_of_goods' | 'ai_confirmed' | 'ai_results' | 'border_eau_number' | 'bunch_number' | 'change_information' | 'clearance_location' | 'company_number_taxpayer' | 'containers' | 'correction_code' | 'correction_reason' | 'creation_date' | 'creation_user' | 'customs_account_address_type' | 'customs_account_name' | 'customs_account_number' | 'customs_declaration_number' | 'customs_declaration_version' | 'customs_office_number' | 'declarant_company_name' | 'declarant_number' | 'declaration_request' | 'declaration_special_mentions' | 'declaration_time' | 'declaration_type' | 'delivery_destination' | 'dispatch_country' | 'dispatch_country_confirmation' | 'dr_no' | 'duty_and_other_taxes_amount' | 'duty_total_amount' | 'evv_confirmed' | 'evv_received' | 'file' | 'file_id' | 'goods_items' | 'goods_items_aggregate' | 'gross_mass' | 'incoterms' | 'initiator' | 'injunction_type' | 'inspection_code' | 'invoice_currency_type' | 'lang' | 'material_check' | 'net_mass' | 'packaging_quantity' | 'payer_id' | 'place_of_loading' | 'place_of_unloading' | 'postal_shipment_type' | 'previous_documents' | 'procedure_type' | 'provisional_declaration_expiration_date' | 'reason' | 'receive_status' | 'release' | 'requestor_trader_identification_number' | 'security' | 'selection_correlation_id' | 'send_date' | 'send_status' | 'service_type' | 'show_in_wd' | 'specific_circumstance_indicator' | 'status' | 'status_date' | 'status_time' | 'tara_factor' | 'total_colis' | 'total_goods_items' | 'total_gross_weight' | 'total_vat_value' | 'trader_declaration_number' | 'trader_identification_number' | 'trader_reference' | 'transfer_to_transit_system' | 'transport_country' | 'transport_in_container' | 'transport_mode' | 'transport_number' | 'transport_type' | 'unique_consignment_reference_number' | 'vat_account_address_type' | 'vat_account_name' | 'vat_account_number' | 'vat_number' | 'vat_suffix' | 'vat_total_amount' | 'warehouse_coded' | declarationKeySpecifier)[];
export type declarationFieldPolicy = {
	acceptance_date?: FieldPolicy<any> | FieldReadFunction<any>,
	access_code?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	agreed_location_of_goods?: FieldPolicy<any> | FieldReadFunction<any>,
	ai_confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	ai_results?: FieldPolicy<any> | FieldReadFunction<any>,
	border_eau_number?: FieldPolicy<any> | FieldReadFunction<any>,
	bunch_number?: FieldPolicy<any> | FieldReadFunction<any>,
	change_information?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_location?: FieldPolicy<any> | FieldReadFunction<any>,
	company_number_taxpayer?: FieldPolicy<any> | FieldReadFunction<any>,
	containers?: FieldPolicy<any> | FieldReadFunction<any>,
	correction_code?: FieldPolicy<any> | FieldReadFunction<any>,
	correction_reason?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_account_address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_account_name?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_office_number?: FieldPolicy<any> | FieldReadFunction<any>,
	declarant_company_name?: FieldPolicy<any> | FieldReadFunction<any>,
	declarant_number?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_time?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type?: FieldPolicy<any> | FieldReadFunction<any>,
	delivery_destination?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatch_country?: FieldPolicy<any> | FieldReadFunction<any>,
	dispatch_country_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_amount?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total_amount?: FieldPolicy<any> | FieldReadFunction<any>,
	evv_confirmed?: FieldPolicy<any> | FieldReadFunction<any>,
	evv_received?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_items?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_items_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	incoterms?: FieldPolicy<any> | FieldReadFunction<any>,
	initiator?: FieldPolicy<any> | FieldReadFunction<any>,
	injunction_type?: FieldPolicy<any> | FieldReadFunction<any>,
	inspection_code?: FieldPolicy<any> | FieldReadFunction<any>,
	invoice_currency_type?: FieldPolicy<any> | FieldReadFunction<any>,
	lang?: FieldPolicy<any> | FieldReadFunction<any>,
	material_check?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	payer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	place_of_loading?: FieldPolicy<any> | FieldReadFunction<any>,
	place_of_unloading?: FieldPolicy<any> | FieldReadFunction<any>,
	postal_shipment_type?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	procedure_type?: FieldPolicy<any> | FieldReadFunction<any>,
	provisional_declaration_expiration_date?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	receive_status?: FieldPolicy<any> | FieldReadFunction<any>,
	release?: FieldPolicy<any> | FieldReadFunction<any>,
	requestor_trader_identification_number?: FieldPolicy<any> | FieldReadFunction<any>,
	security?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_correlation_id?: FieldPolicy<any> | FieldReadFunction<any>,
	send_date?: FieldPolicy<any> | FieldReadFunction<any>,
	send_status?: FieldPolicy<any> | FieldReadFunction<any>,
	service_type?: FieldPolicy<any> | FieldReadFunction<any>,
	show_in_wd?: FieldPolicy<any> | FieldReadFunction<any>,
	specific_circumstance_indicator?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	status_date?: FieldPolicy<any> | FieldReadFunction<any>,
	status_time?: FieldPolicy<any> | FieldReadFunction<any>,
	tara_factor?: FieldPolicy<any> | FieldReadFunction<any>,
	total_colis?: FieldPolicy<any> | FieldReadFunction<any>,
	total_goods_items?: FieldPolicy<any> | FieldReadFunction<any>,
	total_gross_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	total_vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_declaration_number?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_identification_number?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_reference?: FieldPolicy<any> | FieldReadFunction<any>,
	transfer_to_transit_system?: FieldPolicy<any> | FieldReadFunction<any>,
	transport_country?: FieldPolicy<any> | FieldReadFunction<any>,
	transport_in_container?: FieldPolicy<any> | FieldReadFunction<any>,
	transport_mode?: FieldPolicy<any> | FieldReadFunction<any>,
	transport_number?: FieldPolicy<any> | FieldReadFunction<any>,
	transport_type?: FieldPolicy<any> | FieldReadFunction<any>,
	unique_consignment_reference_number?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_account_address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_account_name?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_number?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_suffix?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total_amount?: FieldPolicy<any> | FieldReadFunction<any>,
	warehouse_coded?: FieldPolicy<any> | FieldReadFunction<any>
};
export type containersKeySpecifier = ('container_number' | 'dr_no' | 'file_id' | 'id' | containersKeySpecifier)[];
export type containersFieldPolicy = {
	container_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_special_mentionsKeySpecifier = ('dr_no' | 'file_id' | 'id' | 'sequence_number' | 'text' | declaration_special_mentionsKeySpecifier)[];
export type declaration_special_mentionsFieldPolicy = {
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_itemKeySpecifier = ('additional_unit' | 'additional_unit_confirmation' | 'billing_type' | 'clearance_type' | 'commercial_good' | 'commodity_code' | 'commodity_code_confirmation' | 'creation_date' | 'creation_user' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'declaration_request' | 'description' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'file_id' | 'goods_item_special_mentions' | 'goods_item_special_mentions_aggregate' | 'gross_mass' | 'gross_mass_confirmation' | 'net_duty' | 'net_mass' | 'net_mass_confirmation' | 'non_customs_law_obligation' | 'origin_country' | 'origin_preference' | 'packagings' | 'packagings_aggregate' | 'permit_obligation_code' | 'permits' | 'permits_aggregate' | 'preference_confirmation' | 'process_type' | 'produced_documents' | 'produced_documents_aggregate' | 'rate_confirmation' | 'refinement_type' | 'refund_type' | 'repair' | 'repair_reason' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'statistical_value_confirmation' | 'storage_type' | 'tare_supplement' | 'tare_supplement_confirmation' | 'un_dangerous_goods_code' | 'vat_code' | 'vat_code_confirmation' | 'vat_rate' | 'vat_total' | 'vat_value' | 'vat_value_confirmation' | 'voc_quantity' | goods_itemKeySpecifier)[];
export type goods_itemFieldPolicy = {
	additional_unit?: FieldPolicy<any> | FieldReadFunction<any>,
	additional_unit_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	commercial_good?: FieldPolicy<any> | FieldReadFunction<any>,
	commodity_code?: FieldPolicy<any> | FieldReadFunction<any>,
	commodity_code_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	net_duty?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_country?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_preference?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	permits?: FieldPolicy<any> | FieldReadFunction<any>,
	permits_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	preference_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	rate_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	repair?: FieldPolicy<any> | FieldReadFunction<any>,
	repair_reason?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	un_dangerous_goods_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value_confirmation?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentionsKeySpecifier = ('customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'sequence_number' | 'text' | goods_item_special_mentionsKeySpecifier)[];
export type goods_item_special_mentionsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_aggregateKeySpecifier = ('aggregate' | 'nodes' | goods_item_special_mentions_aggregateKeySpecifier)[];
export type goods_item_special_mentions_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | goods_item_special_mentions_aggregate_fieldsKeySpecifier)[];
export type goods_item_special_mentions_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_avg_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'sequence_number' | goods_item_special_mentions_avg_fieldsKeySpecifier)[];
export type goods_item_special_mentions_avg_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_max_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'sequence_number' | 'text' | goods_item_special_mentions_max_fieldsKeySpecifier)[];
export type goods_item_special_mentions_max_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_min_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'sequence_number' | 'text' | goods_item_special_mentions_min_fieldsKeySpecifier)[];
export type goods_item_special_mentions_min_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_stddev_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'sequence_number' | goods_item_special_mentions_stddev_fieldsKeySpecifier)[];
export type goods_item_special_mentions_stddev_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_stddev_pop_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'sequence_number' | goods_item_special_mentions_stddev_pop_fieldsKeySpecifier)[];
export type goods_item_special_mentions_stddev_pop_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_stddev_samp_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'sequence_number' | goods_item_special_mentions_stddev_samp_fieldsKeySpecifier)[];
export type goods_item_special_mentions_stddev_samp_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_sum_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'sequence_number' | goods_item_special_mentions_sum_fieldsKeySpecifier)[];
export type goods_item_special_mentions_sum_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_var_pop_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'sequence_number' | goods_item_special_mentions_var_pop_fieldsKeySpecifier)[];
export type goods_item_special_mentions_var_pop_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_var_samp_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'sequence_number' | goods_item_special_mentions_var_samp_fieldsKeySpecifier)[];
export type goods_item_special_mentions_var_samp_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_special_mentions_variance_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'sequence_number' | goods_item_special_mentions_variance_fieldsKeySpecifier)[];
export type goods_item_special_mentions_variance_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagingsKeySpecifier = ('customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'packaging_quantity' | 'packaging_reference_number' | 'packaging_type' | packagingsKeySpecifier)[];
export type packagingsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_reference_number?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_aggregateKeySpecifier = ('aggregate' | 'nodes' | packagings_aggregateKeySpecifier)[];
export type packagings_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | packagings_aggregate_fieldsKeySpecifier)[];
export type packagings_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_avg_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'packaging_quantity' | packagings_avg_fieldsKeySpecifier)[];
export type packagings_avg_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_max_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'packaging_quantity' | 'packaging_reference_number' | 'packaging_type' | packagings_max_fieldsKeySpecifier)[];
export type packagings_max_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_reference_number?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_min_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'packaging_quantity' | 'packaging_reference_number' | 'packaging_type' | packagings_min_fieldsKeySpecifier)[];
export type packagings_min_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_reference_number?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_stddev_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'packaging_quantity' | packagings_stddev_fieldsKeySpecifier)[];
export type packagings_stddev_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_stddev_pop_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'packaging_quantity' | packagings_stddev_pop_fieldsKeySpecifier)[];
export type packagings_stddev_pop_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_stddev_samp_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'packaging_quantity' | packagings_stddev_samp_fieldsKeySpecifier)[];
export type packagings_stddev_samp_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_sum_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'packaging_quantity' | packagings_sum_fieldsKeySpecifier)[];
export type packagings_sum_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_var_pop_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'packaging_quantity' | packagings_var_pop_fieldsKeySpecifier)[];
export type packagings_var_pop_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_var_samp_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'packaging_quantity' | packagings_var_samp_fieldsKeySpecifier)[];
export type packagings_var_samp_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_variance_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'packaging_quantity' | packagings_variance_fieldsKeySpecifier)[];
export type packagings_variance_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permitsKeySpecifier = ('additional_information' | 'customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'issue_date' | 'permit_authority' | 'permit_item_details' | 'permit_number' | 'permit_type' | permitsKeySpecifier)[];
export type permitsFieldPolicy = {
	additional_information?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issue_date?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_item_details?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_number?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_aggregateKeySpecifier = ('aggregate' | 'nodes' | permits_aggregateKeySpecifier)[];
export type permits_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | permits_aggregate_fieldsKeySpecifier)[];
export type permits_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_avg_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'permit_authority' | 'permit_type' | permits_avg_fieldsKeySpecifier)[];
export type permits_avg_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_max_fieldsKeySpecifier = ('additional_information' | 'customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'issue_date' | 'permit_authority' | 'permit_number' | 'permit_type' | permits_max_fieldsKeySpecifier)[];
export type permits_max_fieldsFieldPolicy = {
	additional_information?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issue_date?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_number?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_min_fieldsKeySpecifier = ('additional_information' | 'customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'issue_date' | 'permit_authority' | 'permit_number' | 'permit_type' | permits_min_fieldsKeySpecifier)[];
export type permits_min_fieldsFieldPolicy = {
	additional_information?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	issue_date?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_number?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_stddev_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'permit_authority' | 'permit_type' | permits_stddev_fieldsKeySpecifier)[];
export type permits_stddev_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_stddev_pop_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'permit_authority' | 'permit_type' | permits_stddev_pop_fieldsKeySpecifier)[];
export type permits_stddev_pop_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_stddev_samp_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'permit_authority' | 'permit_type' | permits_stddev_samp_fieldsKeySpecifier)[];
export type permits_stddev_samp_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_sum_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'permit_authority' | 'permit_type' | permits_sum_fieldsKeySpecifier)[];
export type permits_sum_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_var_pop_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'permit_authority' | 'permit_type' | permits_var_pop_fieldsKeySpecifier)[];
export type permits_var_pop_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_var_samp_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'permit_authority' | 'permit_type' | permits_var_samp_fieldsKeySpecifier)[];
export type permits_var_samp_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type permits_variance_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | 'permit_authority' | 'permit_type' | permits_variance_fieldsKeySpecifier)[];
export type permits_variance_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_authority?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documentsKeySpecifier = ('additional_information' | 'customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'produced_document_issue_date' | 'produced_document_reference_number' | 'produced_document_type' | produced_documentsKeySpecifier)[];
export type produced_documentsFieldPolicy = {
	additional_information?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_issue_date?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_reference_number?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_aggregateKeySpecifier = ('aggregate' | 'nodes' | produced_documents_aggregateKeySpecifier)[];
export type produced_documents_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | produced_documents_aggregate_fieldsKeySpecifier)[];
export type produced_documents_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_avg_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | produced_documents_avg_fieldsKeySpecifier)[];
export type produced_documents_avg_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_max_fieldsKeySpecifier = ('additional_information' | 'customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'produced_document_issue_date' | 'produced_document_reference_number' | 'produced_document_type' | produced_documents_max_fieldsKeySpecifier)[];
export type produced_documents_max_fieldsFieldPolicy = {
	additional_information?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_issue_date?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_reference_number?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_min_fieldsKeySpecifier = ('additional_information' | 'customs_item_number' | 'dr_no' | 'file_id' | 'id' | 'produced_document_issue_date' | 'produced_document_reference_number' | 'produced_document_type' | produced_documents_min_fieldsKeySpecifier)[];
export type produced_documents_min_fieldsFieldPolicy = {
	additional_information?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_issue_date?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_reference_number?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_stddev_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | produced_documents_stddev_fieldsKeySpecifier)[];
export type produced_documents_stddev_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_stddev_pop_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | produced_documents_stddev_pop_fieldsKeySpecifier)[];
export type produced_documents_stddev_pop_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_stddev_samp_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | produced_documents_stddev_samp_fieldsKeySpecifier)[];
export type produced_documents_stddev_samp_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_sum_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | produced_documents_sum_fieldsKeySpecifier)[];
export type produced_documents_sum_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_var_pop_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | produced_documents_var_pop_fieldsKeySpecifier)[];
export type produced_documents_var_pop_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_var_samp_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | produced_documents_var_samp_fieldsKeySpecifier)[];
export type produced_documents_var_samp_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_variance_fieldsKeySpecifier = ('customs_item_number' | 'dr_no' | 'id' | produced_documents_variance_fieldsKeySpecifier)[];
export type produced_documents_variance_fieldsFieldPolicy = {
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_aggregateKeySpecifier = ('aggregate' | 'nodes' | goods_item_aggregateKeySpecifier)[];
export type goods_item_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | goods_item_aggregate_fieldsKeySpecifier)[];
export type goods_item_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_avg_fieldsKeySpecifier = ('billing_type' | 'clearance_type' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_avg_fieldsKeySpecifier)[];
export type goods_item_avg_fieldsFieldPolicy = {
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_max_fieldsKeySpecifier = ('additional_unit' | 'billing_type' | 'clearance_type' | 'commodity_code' | 'creation_date' | 'creation_user' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'description' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'file_id' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'origin_country' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'repair_reason' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'un_dangerous_goods_code' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_max_fieldsKeySpecifier)[];
export type goods_item_max_fieldsFieldPolicy = {
	additional_unit?: FieldPolicy<any> | FieldReadFunction<any>,
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	commodity_code?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_country?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	repair_reason?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	un_dangerous_goods_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_min_fieldsKeySpecifier = ('additional_unit' | 'billing_type' | 'clearance_type' | 'commodity_code' | 'creation_date' | 'creation_user' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'description' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'file_id' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'origin_country' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'repair_reason' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'un_dangerous_goods_code' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_min_fieldsKeySpecifier)[];
export type goods_item_min_fieldsFieldPolicy = {
	additional_unit?: FieldPolicy<any> | FieldReadFunction<any>,
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	commodity_code?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_country?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	repair_reason?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	un_dangerous_goods_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_stddev_fieldsKeySpecifier = ('billing_type' | 'clearance_type' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_stddev_fieldsKeySpecifier)[];
export type goods_item_stddev_fieldsFieldPolicy = {
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_stddev_pop_fieldsKeySpecifier = ('billing_type' | 'clearance_type' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_stddev_pop_fieldsKeySpecifier)[];
export type goods_item_stddev_pop_fieldsFieldPolicy = {
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_stddev_samp_fieldsKeySpecifier = ('billing_type' | 'clearance_type' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_stddev_samp_fieldsKeySpecifier)[];
export type goods_item_stddev_samp_fieldsFieldPolicy = {
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_sum_fieldsKeySpecifier = ('billing_type' | 'clearance_type' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_sum_fieldsKeySpecifier)[];
export type goods_item_sum_fieldsFieldPolicy = {
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_var_pop_fieldsKeySpecifier = ('billing_type' | 'clearance_type' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_var_pop_fieldsKeySpecifier)[];
export type goods_item_var_pop_fieldsFieldPolicy = {
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_var_samp_fieldsKeySpecifier = ('billing_type' | 'clearance_type' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_var_samp_fieldsKeySpecifier)[];
export type goods_item_var_samp_fieldsFieldPolicy = {
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_variance_fieldsKeySpecifier = ('billing_type' | 'clearance_type' | 'customs_declaration_version' | 'customs_favour_code' | 'customs_item_number' | 'customs_net_weight' | 'direction' | 'dr_no' | 'duty_and_other_taxes_total' | 'duty_rate' | 'duty_total' | 'gross_mass' | 'net_mass' | 'non_customs_law_obligation' | 'permit_obligation_code' | 'process_type' | 'refinement_type' | 'refund_type' | 'selection_result' | 'statistical_code' | 'statistical_value' | 'storage_type' | 'tare_supplement' | 'vat_code' | 'vat_rate' | 'vat_total' | 'vat_value' | 'voc_quantity' | goods_item_variance_fieldsKeySpecifier)[];
export type goods_item_variance_fieldsFieldPolicy = {
	billing_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_favour_code?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_item_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_net_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	direction?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_and_other_taxes_total?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	gross_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation_code?: FieldPolicy<any> | FieldReadFunction<any>,
	process_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refinement_type?: FieldPolicy<any> | FieldReadFunction<any>,
	refund_type?: FieldPolicy<any> | FieldReadFunction<any>,
	selection_result?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	tare_supplement?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_code?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_value?: FieldPolicy<any> | FieldReadFunction<any>,
	voc_quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type previous_documentsKeySpecifier = ('additional_information' | 'dr_no' | 'file_id' | 'id' | 'previous_document_reference' | 'previous_document_type' | previous_documentsKeySpecifier)[];
export type previous_documentsFieldPolicy = {
	additional_information?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_document_reference?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_document_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussionKeySpecifier = ('closed' | 'creation_date' | 'creation_user' | 'declaration_messages' | 'declaration_messages_aggregate' | 'declaration_request' | 'discussion_id' | 'discussion_theme' | 'dr_no' | 'file_id' | 'meta' | 'user_pp' | declaration_discussionKeySpecifier)[];
export type declaration_discussionFieldPolicy = {
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_messages?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_messages_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_theme?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_messageKeySpecifier = ('creation_user' | 'declaration_discussion' | 'discussion_id' | 'message' | 'meta' | 'msg_date' | 'read_date' | 'type' | 'user' | declaration_messageKeySpecifier)[];
export type declaration_messageFieldPolicy = {
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussion?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	msg_date?: FieldPolicy<any> | FieldReadFunction<any>,
	read_date?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_aggregateKeySpecifier = ('aggregate' | 'nodes' | declaration_message_aggregateKeySpecifier)[];
export type declaration_message_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | declaration_message_aggregate_fieldsKeySpecifier)[];
export type declaration_message_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_avg_fieldsKeySpecifier = ('discussion_id' | declaration_message_avg_fieldsKeySpecifier)[];
export type declaration_message_avg_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_max_fieldsKeySpecifier = ('creation_user' | 'discussion_id' | 'message' | 'msg_date' | 'read_date' | 'type' | declaration_message_max_fieldsKeySpecifier)[];
export type declaration_message_max_fieldsFieldPolicy = {
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	msg_date?: FieldPolicy<any> | FieldReadFunction<any>,
	read_date?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_min_fieldsKeySpecifier = ('creation_user' | 'discussion_id' | 'message' | 'msg_date' | 'read_date' | 'type' | declaration_message_min_fieldsKeySpecifier)[];
export type declaration_message_min_fieldsFieldPolicy = {
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	msg_date?: FieldPolicy<any> | FieldReadFunction<any>,
	read_date?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_stddev_fieldsKeySpecifier = ('discussion_id' | declaration_message_stddev_fieldsKeySpecifier)[];
export type declaration_message_stddev_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_stddev_pop_fieldsKeySpecifier = ('discussion_id' | declaration_message_stddev_pop_fieldsKeySpecifier)[];
export type declaration_message_stddev_pop_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_stddev_samp_fieldsKeySpecifier = ('discussion_id' | declaration_message_stddev_samp_fieldsKeySpecifier)[];
export type declaration_message_stddev_samp_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_sum_fieldsKeySpecifier = ('discussion_id' | declaration_message_sum_fieldsKeySpecifier)[];
export type declaration_message_sum_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_var_pop_fieldsKeySpecifier = ('discussion_id' | declaration_message_var_pop_fieldsKeySpecifier)[];
export type declaration_message_var_pop_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_var_samp_fieldsKeySpecifier = ('discussion_id' | declaration_message_var_samp_fieldsKeySpecifier)[];
export type declaration_message_var_samp_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_variance_fieldsKeySpecifier = ('discussion_id' | declaration_message_variance_fieldsKeySpecifier)[];
export type declaration_message_variance_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_aggregateKeySpecifier = ('aggregate' | 'nodes' | declaration_discussion_aggregateKeySpecifier)[];
export type declaration_discussion_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | declaration_discussion_aggregate_fieldsKeySpecifier)[];
export type declaration_discussion_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_avg_fieldsKeySpecifier = ('discussion_id' | 'dr_no' | declaration_discussion_avg_fieldsKeySpecifier)[];
export type declaration_discussion_avg_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_max_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'discussion_id' | 'discussion_theme' | 'dr_no' | 'file_id' | declaration_discussion_max_fieldsKeySpecifier)[];
export type declaration_discussion_max_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_theme?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_min_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'discussion_id' | 'discussion_theme' | 'dr_no' | 'file_id' | declaration_discussion_min_fieldsKeySpecifier)[];
export type declaration_discussion_min_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_theme?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_stddev_fieldsKeySpecifier = ('discussion_id' | 'dr_no' | declaration_discussion_stddev_fieldsKeySpecifier)[];
export type declaration_discussion_stddev_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_stddev_pop_fieldsKeySpecifier = ('discussion_id' | 'dr_no' | declaration_discussion_stddev_pop_fieldsKeySpecifier)[];
export type declaration_discussion_stddev_pop_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_stddev_samp_fieldsKeySpecifier = ('discussion_id' | 'dr_no' | declaration_discussion_stddev_samp_fieldsKeySpecifier)[];
export type declaration_discussion_stddev_samp_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_sum_fieldsKeySpecifier = ('discussion_id' | 'dr_no' | declaration_discussion_sum_fieldsKeySpecifier)[];
export type declaration_discussion_sum_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_var_pop_fieldsKeySpecifier = ('discussion_id' | 'dr_no' | declaration_discussion_var_pop_fieldsKeySpecifier)[];
export type declaration_discussion_var_pop_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_var_samp_fieldsKeySpecifier = ('discussion_id' | 'dr_no' | declaration_discussion_var_samp_fieldsKeySpecifier)[];
export type declaration_discussion_var_samp_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_variance_fieldsKeySpecifier = ('discussion_id' | 'dr_no' | declaration_discussion_variance_fieldsKeySpecifier)[];
export type declaration_discussion_variance_fieldsFieldPolicy = {
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_documentKeySpecifier = ('doc_id' | 'document' | 'dr_no' | 'file_id' | declaration_documentKeySpecifier)[];
export type declaration_documentFieldPolicy = {
	doc_id?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_request_labelsKeySpecifier = ('dr_no' | 'file_id' | 'label_id' | declaration_request_labelsKeySpecifier)[];
export type declaration_request_labelsFieldPolicy = {
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_statusKeySpecifier = ('name' | declaration_statusKeySpecifier)[];
export type declaration_statusFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_typeKeySpecifier = ('declaration_requests' | 'document_schema' | 'name' | declaration_typeKeySpecifier)[];
export type declaration_typeFieldPolicy = {
	declaration_requests?: FieldPolicy<any> | FieldReadFunction<any>,
	document_schema?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_aggregateKeySpecifier = ('aggregate' | 'nodes' | declaration_task_aggregateKeySpecifier)[];
export type declaration_task_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | declaration_task_aggregate_fieldsKeySpecifier)[];
export type declaration_task_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_avg_fieldsKeySpecifier = ('id' | 'task_status_id' | 'task_type_id' | declaration_task_avg_fieldsKeySpecifier)[];
export type declaration_task_avg_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_max_fieldsKeySpecifier = ('assigned_to' | 'creation_date' | 'due_date' | 'id' | 'object_id' | 'task_status_id' | 'task_type_id' | 'title' | declaration_task_max_fieldsKeySpecifier)[];
export type declaration_task_max_fieldsFieldPolicy = {
	assigned_to?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	due_date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	object_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_min_fieldsKeySpecifier = ('assigned_to' | 'creation_date' | 'due_date' | 'id' | 'object_id' | 'task_status_id' | 'task_type_id' | 'title' | declaration_task_min_fieldsKeySpecifier)[];
export type declaration_task_min_fieldsFieldPolicy = {
	assigned_to?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	due_date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	object_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_stddev_fieldsKeySpecifier = ('id' | 'task_status_id' | 'task_type_id' | declaration_task_stddev_fieldsKeySpecifier)[];
export type declaration_task_stddev_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_stddev_pop_fieldsKeySpecifier = ('id' | 'task_status_id' | 'task_type_id' | declaration_task_stddev_pop_fieldsKeySpecifier)[];
export type declaration_task_stddev_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_stddev_samp_fieldsKeySpecifier = ('id' | 'task_status_id' | 'task_type_id' | declaration_task_stddev_samp_fieldsKeySpecifier)[];
export type declaration_task_stddev_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_sum_fieldsKeySpecifier = ('id' | 'task_status_id' | 'task_type_id' | declaration_task_sum_fieldsKeySpecifier)[];
export type declaration_task_sum_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_var_pop_fieldsKeySpecifier = ('id' | 'task_status_id' | 'task_type_id' | declaration_task_var_pop_fieldsKeySpecifier)[];
export type declaration_task_var_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_var_samp_fieldsKeySpecifier = ('id' | 'task_status_id' | 'task_type_id' | declaration_task_var_samp_fieldsKeySpecifier)[];
export type declaration_task_var_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_variance_fieldsKeySpecifier = ('id' | 'task_status_id' | 'task_type_id' | declaration_task_variance_fieldsKeySpecifier)[];
export type declaration_task_variance_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type task_typeKeySpecifier = ('display_name' | 'id' | 'meta' | task_typeKeySpecifier)[];
export type task_typeFieldPolicy = {
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>
};
export type doc_annotationKeySpecifier = ('anno_type_id' | 'annotation_type' | 'doc_id' | 'document' | 'value' | doc_annotationKeySpecifier)[];
export type doc_annotationFieldPolicy = {
	anno_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_type?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_id?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_extensionKeySpecifier = ('creation_date' | 'creation_user' | 'display_name' | 'last_modified_date' | 'last_modified_user' | 'name' | 'thumbnails_supported' | 'user' | document_extensionKeySpecifier)[];
export type document_extensionFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnails_supported?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_pageKeySpecifier = ('document' | 'document_id' | 'page' | 'page_id' | 'page_number' | document_pageKeySpecifier)[];
export type document_pageFieldPolicy = {
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	document_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	page_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pageKeySpecifier = ('ai_ignore_retraining' | 'created_by_user' | 'creation_date' | 'creation_user' | 'documents' | 'documents_aggregate' | 'id' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'ocr_text' | 'page_extracts' | 'page_status' | 'rotate' | 'thumbnail_big_url' | 'thumbnail_small_url' | pageKeySpecifier)[];
export type pageFieldPolicy = {
	ai_ignore_retraining?: FieldPolicy<any> | FieldReadFunction<any>,
	created_by_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	ocr_text?: FieldPolicy<any> | FieldReadFunction<any>,
	page_extracts?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_big_url?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_small_url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_aggregateKeySpecifier = ('aggregate' | 'nodes' | document_page_aggregateKeySpecifier)[];
export type document_page_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | document_page_aggregate_fieldsKeySpecifier)[];
export type document_page_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_avg_fieldsKeySpecifier = ('page_number' | document_page_avg_fieldsKeySpecifier)[];
export type document_page_avg_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_max_fieldsKeySpecifier = ('document_id' | 'page_id' | 'page_number' | document_page_max_fieldsKeySpecifier)[];
export type document_page_max_fieldsFieldPolicy = {
	document_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_min_fieldsKeySpecifier = ('document_id' | 'page_id' | 'page_number' | document_page_min_fieldsKeySpecifier)[];
export type document_page_min_fieldsFieldPolicy = {
	document_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_stddev_fieldsKeySpecifier = ('page_number' | document_page_stddev_fieldsKeySpecifier)[];
export type document_page_stddev_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_stddev_pop_fieldsKeySpecifier = ('page_number' | document_page_stddev_pop_fieldsKeySpecifier)[];
export type document_page_stddev_pop_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_stddev_samp_fieldsKeySpecifier = ('page_number' | document_page_stddev_samp_fieldsKeySpecifier)[];
export type document_page_stddev_samp_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_sum_fieldsKeySpecifier = ('page_number' | document_page_sum_fieldsKeySpecifier)[];
export type document_page_sum_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_var_pop_fieldsKeySpecifier = ('page_number' | document_page_var_pop_fieldsKeySpecifier)[];
export type document_page_var_pop_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_var_samp_fieldsKeySpecifier = ('page_number' | document_page_var_samp_fieldsKeySpecifier)[];
export type document_page_var_samp_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_page_variance_fieldsKeySpecifier = ('page_number' | document_page_variance_fieldsKeySpecifier)[];
export type document_page_variance_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type page_extractKeySpecifier = ('extract_type' | 'extract_type_id' | 'page' | 'page_id' | 'tables' | 'value' | page_extractKeySpecifier)[];
export type page_extractFieldPolicy = {
	extract_type?: FieldPolicy<any> | FieldReadFunction<any>,
	extract_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	page_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tables?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type extract_typeKeySpecifier = ('extract_type_id' | 'meta' | 'name' | 'translations' | extract_typeKeySpecifier)[];
export type extract_typeFieldPolicy = {
	extract_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_statusKeySpecifier = ('creation_date' | 'creation_user' | 'display_name' | 'last_modified_date' | 'last_modified_user' | 'name' | 'user' | document_statusKeySpecifier)[];
export type document_statusFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type user_org_idKeySpecifier = ('creation_date' | 'creation_user' | 'last_modified_date' | 'last_modified_user' | 'org_id' | 'orgId' | 'user_pp' | user_org_idKeySpecifier)[];
export type user_org_idFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_triggerKeySpecifier = ('config' | 'creation_date' | 'creation_user' | 'creationUser' | 'display_name' | 'id' | 'label' | 'label_id' | 'last_modified_date' | 'last_modified_user' | 'lastModifiedUser' | 'meta' | 'tenant_id' | 'type' | import_list_triggerKeySpecifier)[];
export type import_list_triggerFieldPolicy = {
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_aggregateKeySpecifier = ('aggregate' | 'nodes' | import_list_trigger_aggregateKeySpecifier)[];
export type import_list_trigger_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | import_list_trigger_aggregate_fieldsKeySpecifier)[];
export type import_list_trigger_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_avg_fieldsKeySpecifier = ('id' | 'label_id' | import_list_trigger_avg_fieldsKeySpecifier)[];
export type import_list_trigger_avg_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_max_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'display_name' | 'id' | 'label_id' | 'last_modified_date' | 'last_modified_user' | 'tenant_id' | 'type' | import_list_trigger_max_fieldsKeySpecifier)[];
export type import_list_trigger_max_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_min_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'display_name' | 'id' | 'label_id' | 'last_modified_date' | 'last_modified_user' | 'tenant_id' | 'type' | import_list_trigger_min_fieldsKeySpecifier)[];
export type import_list_trigger_min_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_stddev_fieldsKeySpecifier = ('id' | 'label_id' | import_list_trigger_stddev_fieldsKeySpecifier)[];
export type import_list_trigger_stddev_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_stddev_pop_fieldsKeySpecifier = ('id' | 'label_id' | import_list_trigger_stddev_pop_fieldsKeySpecifier)[];
export type import_list_trigger_stddev_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_stddev_samp_fieldsKeySpecifier = ('id' | 'label_id' | import_list_trigger_stddev_samp_fieldsKeySpecifier)[];
export type import_list_trigger_stddev_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_sum_fieldsKeySpecifier = ('id' | 'label_id' | import_list_trigger_sum_fieldsKeySpecifier)[];
export type import_list_trigger_sum_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_var_pop_fieldsKeySpecifier = ('id' | 'label_id' | import_list_trigger_var_pop_fieldsKeySpecifier)[];
export type import_list_trigger_var_pop_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_var_samp_fieldsKeySpecifier = ('id' | 'label_id' | import_list_trigger_var_samp_fieldsKeySpecifier)[];
export type import_list_trigger_var_samp_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_variance_fieldsKeySpecifier = ('id' | 'label_id' | import_list_trigger_variance_fieldsKeySpecifier)[];
export type import_list_trigger_variance_fieldsFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	label_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type extraction_configKeySpecifier = ('address_id' | 'aliases' | 'document_templates' | 'foun_config' | extraction_configKeySpecifier)[];
export type extraction_configFieldPolicy = {
	address_id?: FieldPolicy<any> | FieldReadFunction<any>,
	aliases?: FieldPolicy<any> | FieldReadFunction<any>,
	document_templates?: FieldPolicy<any> | FieldReadFunction<any>,
	foun_config?: FieldPolicy<any> | FieldReadFunction<any>
};
export type address_groupsKeySpecifier = ('business_case' | 'group_id' | 'group_name' | 'payer_address' | 'payer_name' | 'payerAddress' | address_groupsKeySpecifier)[];
export type address_groupsFieldPolicy = {
	business_case?: FieldPolicy<any> | FieldReadFunction<any>,
	group_id?: FieldPolicy<any> | FieldReadFunction<any>,
	group_name?: FieldPolicy<any> | FieldReadFunction<any>,
	payer_address?: FieldPolicy<any> | FieldReadFunction<any>,
	payer_name?: FieldPolicy<any> | FieldReadFunction<any>,
	payerAddress?: FieldPolicy<any> | FieldReadFunction<any>
};
export type address_mappingKeySpecifier = ('address_id' | 'address_override_id' | 'is_cross_address' | 'tenant_id' | address_mappingKeySpecifier)[];
export type address_mappingFieldPolicy = {
	address_id?: FieldPolicy<any> | FieldReadFunction<any>,
	address_override_id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_cross_address?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type address_overrideKeySpecifier = ('address_type' | 'city' | 'company_name' | 'contact_email' | 'contact_phone' | 'contact_website' | 'country' | 'creation_date' | 'creation_user' | 'id' | 'is_deleted' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'payer_id' | 'reference' | 'street' | 'street_number' | 'vat_number' | 'zipcode' | address_overrideKeySpecifier)[];
export type address_overrideFieldPolicy = {
	address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	company_name?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_email?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_phone?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_website?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	payer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	street_number?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_number?: FieldPolicy<any> | FieldReadFunction<any>,
	zipcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type addressesKeySpecifier = ('address_type' | 'address_types' | 'addressType' | 'ao_id' | 'city' | 'company_name' | 'contact_email' | 'contact_phone' | 'contact_website' | 'country' | 'creation_date' | 'creation_user' | 'customs_account_number' | 'id' | 'is_deleted' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'qty' | 'reference' | 'source' | 'street' | 'street_number' | 'tenant' | 'vat_account_number' | 'vat_number' | 'zipcode' | addressesKeySpecifier)[];
export type addressesFieldPolicy = {
	address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	address_types?: FieldPolicy<any> | FieldReadFunction<any>,
	addressType?: FieldPolicy<any> | FieldReadFunction<any>,
	ao_id?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	company_name?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_email?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_phone?: FieldPolicy<any> | FieldReadFunction<any>,
	contact_website?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	source?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>,
	street_number?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_number?: FieldPolicy<any> | FieldReadFunction<any>,
	zipcode?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ai_stats_dt_typeKeySpecifier = ('creation_date' | 'docs_qty' | 'document_type' | 'documentType' | 'pages_qty' | 'success_ratio' | 'types_match' | 'unknowns' | 'unknowns_pct' | ai_stats_dt_typeKeySpecifier)[];
export type ai_stats_dt_typeFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	docs_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	success_ratio?: FieldPolicy<any> | FieldReadFunction<any>,
	types_match?: FieldPolicy<any> | FieldReadFunction<any>,
	unknowns?: FieldPolicy<any> | FieldReadFunction<any>,
	unknowns_pct?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ai_stats_typeKeySpecifier = ('document_type' | 'documentType' | 'success_ratio' | 'total' | 'types_match' | 'unknowns' | 'unknowns_pct' | ai_stats_typeKeySpecifier)[];
export type ai_stats_typeFieldPolicy = {
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	success_ratio?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>,
	types_match?: FieldPolicy<any> | FieldReadFunction<any>,
	unknowns?: FieldPolicy<any> | FieldReadFunction<any>,
	unknowns_pct?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_aggregateKeySpecifier = ('aggregate' | 'nodes' | bill_aggregateKeySpecifier)[];
export type bill_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | bill_aggregate_fieldsKeySpecifier)[];
export type bill_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_avg_fieldsKeySpecifier = ('bill_id' | 'payment_terms' | bill_avg_fieldsKeySpecifier)[];
export type bill_avg_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_max_fieldsKeySpecifier = ('bill_id' | 'from_ts' | 'payment_terms' | 'tenant_id' | 'to_ts' | bill_max_fieldsKeySpecifier)[];
export type bill_max_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	from_ts?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	to_ts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_min_fieldsKeySpecifier = ('bill_id' | 'from_ts' | 'payment_terms' | 'tenant_id' | 'to_ts' | bill_min_fieldsKeySpecifier)[];
export type bill_min_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	from_ts?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	to_ts?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_stddev_fieldsKeySpecifier = ('bill_id' | 'payment_terms' | bill_stddev_fieldsKeySpecifier)[];
export type bill_stddev_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_stddev_pop_fieldsKeySpecifier = ('bill_id' | 'payment_terms' | bill_stddev_pop_fieldsKeySpecifier)[];
export type bill_stddev_pop_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_stddev_samp_fieldsKeySpecifier = ('bill_id' | 'payment_terms' | bill_stddev_samp_fieldsKeySpecifier)[];
export type bill_stddev_samp_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_sum_fieldsKeySpecifier = ('bill_id' | 'payment_terms' | bill_sum_fieldsKeySpecifier)[];
export type bill_sum_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_var_pop_fieldsKeySpecifier = ('bill_id' | 'payment_terms' | bill_var_pop_fieldsKeySpecifier)[];
export type bill_var_pop_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_var_samp_fieldsKeySpecifier = ('bill_id' | 'payment_terms' | bill_var_samp_fieldsKeySpecifier)[];
export type bill_var_samp_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_variance_fieldsKeySpecifier = ('bill_id' | 'payment_terms' | bill_variance_fieldsKeySpecifier)[];
export type bill_variance_fieldsFieldPolicy = {
	bill_id?: FieldPolicy<any> | FieldReadFunction<any>,
	payment_terms?: FieldPolicy<any> | FieldReadFunction<any>
};
export type count_typeKeySpecifier = ('count' | count_typeKeySpecifier)[];
export type count_typeFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type customs_officeKeySpecifier = ('address' | 'city' | 'name' | 'office_number' | 'prefix' | 'valid_from' | 'valid_to' | customs_officeKeySpecifier)[];
export type customs_officeFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	office_number?: FieldPolicy<any> | FieldReadFunction<any>,
	prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_from?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_to?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussionsKeySpecifier = ('closed' | 'creation_date' | 'creation_user' | 'discussion_id' | 'discussion_theme' | 'file_id' | 'last_read_date' | 'liber_user' | 'messages' | 'messages_aggregate' | 'meta' | 'reference' | declaration_discussionsKeySpecifier)[];
export type declaration_discussionsFieldPolicy = {
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_theme?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_read_date?: FieldPolicy<any> | FieldReadFunction<any>,
	liber_user?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	messages_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_request_address_aiKeySpecifier = ('address' | 'address_id' | 'address_type' | 'creation_date' | 'creation_user' | 'dr_no' | 'file_id' | 'id' | declaration_request_address_aiKeySpecifier)[];
export type declaration_request_address_aiFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	address_id?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_requestsKeySpecifier = ('acceptance_date' | 'account_number' | 'addresses' | 'arrival_time' | 'arrival_type' | 'autoclassified_docs_qty' | 'ch_exp_decl' | 'clearance_type' | 'creation_date' | 'creation_user' | 'customs_declaration_number' | 'customs_declaration_version' | 'customsOffice' | 'declaration_discussions' | 'declaration_discussions_aggregate' | 'declaration_labels' | 'declaration_status' | 'declaration_type' | 'dest_tolldept_code' | 'dest_tolldept_name' | 'dr_no' | 'eta' | 'file' | 'file_id' | 'imp_cust_clr' | 'is_express' | 'last_modified_date' | 'meta' | 'nonclassified_docs_exists' | 'payer' | 'payer_id' | 'permissions_js' | 'qty' | 'reference' | 'row_number' | 'toll_dep' | 'tr_no' | 'trader_reference' | 'transitdoc_type' | 'user_pp' | 'wa_number' | declaration_requestsKeySpecifier)[];
export type declaration_requestsFieldPolicy = {
	acceptance_date?: FieldPolicy<any> | FieldReadFunction<any>,
	account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_time?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type?: FieldPolicy<any> | FieldReadFunction<any>,
	autoclassified_docs_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	ch_exp_decl?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customsOffice?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussions?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type?: FieldPolicy<any> | FieldReadFunction<any>,
	dest_tolldept_code?: FieldPolicy<any> | FieldReadFunction<any>,
	dest_tolldept_name?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	imp_cust_clr?: FieldPolicy<any> | FieldReadFunction<any>,
	is_express?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	nonclassified_docs_exists?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>,
	payer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions_js?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	row_number?: FieldPolicy<any> | FieldReadFunction<any>,
	toll_dep?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_reference?: FieldPolicy<any> | FieldReadFunction<any>,
	transitdoc_type?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_searchKeySpecifier = ('acceptance_date' | 'addresses' | 'arrival_time' | 'arrival_type' | 'arrivalType' | 'autoclassified_docs_qty' | 'classified_docs_qty' | 'clearance_type' | 'company_id' | 'company_name' | 'creation_date' | 'creation_user' | 'declaration_status' | 'declaration_type' | 'declarationDiscussions' | 'declarationDiscussions_aggregate' | 'docs_qty' | 'dr_no' | 'eta' | 'file' | 'file_id' | 'identification' | 'is_express' | 'last_modified_date' | 'nonclassified_docs_exists' | 'org_id' | 'qty' | 'reference' | 'user' | 'user_display_name' | 'wa_number' | declaration_searchKeySpecifier)[];
export type declaration_searchFieldPolicy = {
	acceptance_date?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_time?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type?: FieldPolicy<any> | FieldReadFunction<any>,
	arrivalType?: FieldPolicy<any> | FieldReadFunction<any>,
	autoclassified_docs_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	classified_docs_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	company_id?: FieldPolicy<any> | FieldReadFunction<any>,
	company_name?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationDiscussions?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationDiscussions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	docs_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	is_express?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	nonclassified_docs_exists?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	user_display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_tasksKeySpecifier = ('assigned_to' | 'assigned_user' | 'creation_date' | 'document' | 'due_date' | 'file' | 'id' | 'meta' | 'object_id' | 'qty' | 'rn' | 'task_status_id' | 'task_type' | 'task_type_id' | 'title' | declaration_tasksKeySpecifier)[];
export type declaration_tasksFieldPolicy = {
	assigned_to?: FieldPolicy<any> | FieldReadFunction<any>,
	assigned_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	due_date?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	object_id?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	rn?: FieldPolicy<any> | FieldReadFunction<any>,
	task_status_id?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_tasks_objKeySpecifier = ('tasks' | 'total_finished' | 'total_opened' | declaration_tasks_objKeySpecifier)[];
export type declaration_tasks_objFieldPolicy = {
	tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	total_finished?: FieldPolicy<any> | FieldReadFunction<any>,
	total_opened?: FieldPolicy<any> | FieldReadFunction<any>
};
export type discussion_changesKeySpecifier = ('adit_user' | 'aditUser' | 'declaration_status' | 'discussion_closed' | 'discussion_id' | 'discussion_theme' | 'file_id' | 'file_name' | 'last_msg_date' | 'last_user' | 'liber_user' | 'liberUser' | 'messages' | 'messages_aggregate' | 'reference' | discussion_changesKeySpecifier)[];
export type discussion_changesFieldPolicy = {
	adit_user?: FieldPolicy<any> | FieldReadFunction<any>,
	aditUser?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_closed?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_id?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_theme?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	file_name?: FieldPolicy<any> | FieldReadFunction<any>,
	last_msg_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_user?: FieldPolicy<any> | FieldReadFunction<any>,
	liber_user?: FieldPolicy<any> | FieldReadFunction<any>,
	liberUser?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	messages_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type doc_search_typeKeySpecifier = ('checksum' | 'creation_date' | 'creation_user' | 'document_blobs' | 'document_extension' | 'document_flags' | 'document_name' | 'document_status' | 'document_type' | 'file' | 'id' | 'is_deleted' | 'is_generated' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'number_of_pages' | 'org_id' | 'org_id_description' | 'pages_m2m' | 'pages_m2m_aggregate' | 'sequence' | 'total_rows' | 'user_code' | 'user_display_name' | doc_search_typeKeySpecifier)[];
export type doc_search_typeFieldPolicy = {
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	document_blobs?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	is_generated?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id_description?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	user_code?: FieldPolicy<any> | FieldReadFunction<any>,
	user_display_name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type doc_stats_typeKeySpecifier = ('docs_qty' | 'document_type' | 'total_pages' | 'users_qty' | doc_stats_typeKeySpecifier)[];
export type doc_stats_typeFieldPolicy = {
	docs_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	total_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	users_qty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type docs_for_validationKeySpecifier = ('checksum' | 'creation_date' | 'creation_user' | 'doc_order' | 'document_blobs' | 'document_extension' | 'document_flags' | 'document_name' | 'document_status' | 'document_type' | 'file' | 'id' | 'is_customs_relevant' | 'is_deleted' | 'is_generated' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'number_of_pages' | 'org_id' | 'sequence' | 'user' | docs_for_validationKeySpecifier)[];
export type docs_for_validationFieldPolicy = {
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_order?: FieldPolicy<any> | FieldReadFunction<any>,
	document_blobs?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_customs_relevant?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	is_generated?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_flagKeySpecifier = ('color' | 'display' | 'id' | 'name' | 'translation' | document_flagKeySpecifier)[];
export type document_flagFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	display?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_type_aggregateKeySpecifier = ('aggregate' | 'nodes' | document_type_aggregateKeySpecifier)[];
export type document_type_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_type_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | document_type_aggregate_fieldsKeySpecifier)[];
export type document_type_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_type_max_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'display_name' | 'last_modified_date' | 'last_modified_user' | 'name' | document_type_max_fieldsKeySpecifier)[];
export type document_type_max_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_type_min_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'display_name' | 'last_modified_date' | 'last_modified_user' | 'name' | document_type_min_fieldsKeySpecifier)[];
export type document_type_min_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type dr_statsKeySpecifier = ('metric_id' | 'metric_label' | 'tenant_id' | 'tenant_name' | 'value' | dr_statsKeySpecifier)[];
export type dr_statsFieldPolicy = {
	metric_id?: FieldPolicy<any> | FieldReadFunction<any>,
	metric_label?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_name?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type edec_countriesKeySpecifier = ('created' | 'id' | 'is_active' | 'iso_code' | 'name_de' | 'name_en' | 'name_fr' | 'name_it' | 'valid_from' | 'valid_to' | 'version' | edec_countriesKeySpecifier)[];
export type edec_countriesFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	iso_code?: FieldPolicy<any> | FieldReadFunction<any>,
	name_de?: FieldPolicy<any> | FieldReadFunction<any>,
	name_en?: FieldPolicy<any> | FieldReadFunction<any>,
	name_fr?: FieldPolicy<any> | FieldReadFunction<any>,
	name_it?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_from?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_to?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type edec_customs_officesKeySpecifier = ('address' | 'city' | 'created' | 'id' | 'is_active' | 'name' | 'number' | 'prefix' | 'updated_at' | 'valid_from' | 'valid_to' | 'version' | edec_customs_officesKeySpecifier)[];
export type edec_customs_officesFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	number?: FieldPolicy<any> | FieldReadFunction<any>,
	prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	updated_at?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_from?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_to?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type edec_domainsKeySpecifier = ('created_at' | 'domain_name' | 'id' | 'is_active' | 'meaning_de' | 'meaning_en' | 'meaning_fr' | 'meaning_it' | 'valid_for_export' | 'valid_for_import' | 'valid_from' | 'valid_to' | 'value' | 'version' | edec_domainsKeySpecifier)[];
export type edec_domainsFieldPolicy = {
	created_at?: FieldPolicy<any> | FieldReadFunction<any>,
	domain_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	meaning_de?: FieldPolicy<any> | FieldReadFunction<any>,
	meaning_en?: FieldPolicy<any> | FieldReadFunction<any>,
	meaning_fr?: FieldPolicy<any> | FieldReadFunction<any>,
	meaning_it?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_for_export?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_for_import?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_from?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_to?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type edec_tariff_commodity_codeKeySpecifier = ('created' | 'id' | 'is_active' | 'valid_for_export' | 'valid_for_import' | 'valid_from' | 'valid_to' | 'value' | 'version' | edec_tariff_commodity_codeKeySpecifier)[];
export type edec_tariff_commodity_codeFieldPolicy = {
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_for_export?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_for_import?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_from?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_to?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type edec_tariff_statistical_codeKeySpecifier = ('commodity_code_id' | 'created' | 'id' | 'is_active' | 'lower_scale_weight' | 'scale_weight_code' | 'storage_type' | 'upper_scale_weight' | 'valid_for_export' | 'valid_for_import' | 'valid_from' | 'valid_to' | 'value' | 'version' | edec_tariff_statistical_codeKeySpecifier)[];
export type edec_tariff_statistical_codeFieldPolicy = {
	commodity_code_id?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_active?: FieldPolicy<any> | FieldReadFunction<any>,
	lower_scale_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	scale_weight_code?: FieldPolicy<any> | FieldReadFunction<any>,
	storage_type?: FieldPolicy<any> | FieldReadFunction<any>,
	upper_scale_weight?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_for_export?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_for_import?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_from?: FieldPolicy<any> | FieldReadFunction<any>,
	valid_to?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_typeKeySpecifier = ('attachments' | 'company' | 'creation_date' | 'creation_user' | 'documents' | 'documents_aggregate' | 'file_status' | 'file_url' | 'id' | 'meta' | 'name' | 'sender' | 'total_rows' | email_search_typeKeySpecifier)[];
export type email_search_typeFieldPolicy = {
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	file_url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sender?: FieldPolicy<any> | FieldReadFunction<any>,
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_aggregateKeySpecifier = ('aggregate' | 'nodes' | email_search_type_aggregateKeySpecifier)[];
export type email_search_type_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | email_search_type_aggregate_fieldsKeySpecifier)[];
export type email_search_type_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_avg_fieldsKeySpecifier = ('total_rows' | email_search_type_avg_fieldsKeySpecifier)[];
export type email_search_type_avg_fieldsFieldPolicy = {
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_max_fieldsKeySpecifier = ('attachments' | 'company' | 'creation_date' | 'creation_user' | 'file_status' | 'file_url' | 'id' | 'name' | 'sender' | 'total_rows' | email_search_type_max_fieldsKeySpecifier)[];
export type email_search_type_max_fieldsFieldPolicy = {
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	file_url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sender?: FieldPolicy<any> | FieldReadFunction<any>,
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_min_fieldsKeySpecifier = ('attachments' | 'company' | 'creation_date' | 'creation_user' | 'file_status' | 'file_url' | 'id' | 'name' | 'sender' | 'total_rows' | email_search_type_min_fieldsKeySpecifier)[];
export type email_search_type_min_fieldsFieldPolicy = {
	attachments?: FieldPolicy<any> | FieldReadFunction<any>,
	company?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	file_url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sender?: FieldPolicy<any> | FieldReadFunction<any>,
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_stddev_fieldsKeySpecifier = ('total_rows' | email_search_type_stddev_fieldsKeySpecifier)[];
export type email_search_type_stddev_fieldsFieldPolicy = {
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_stddev_pop_fieldsKeySpecifier = ('total_rows' | email_search_type_stddev_pop_fieldsKeySpecifier)[];
export type email_search_type_stddev_pop_fieldsFieldPolicy = {
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_stddev_samp_fieldsKeySpecifier = ('total_rows' | email_search_type_stddev_samp_fieldsKeySpecifier)[];
export type email_search_type_stddev_samp_fieldsFieldPolicy = {
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_sum_fieldsKeySpecifier = ('total_rows' | email_search_type_sum_fieldsKeySpecifier)[];
export type email_search_type_sum_fieldsFieldPolicy = {
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_var_pop_fieldsKeySpecifier = ('total_rows' | email_search_type_var_pop_fieldsKeySpecifier)[];
export type email_search_type_var_pop_fieldsFieldPolicy = {
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_var_samp_fieldsKeySpecifier = ('total_rows' | email_search_type_var_samp_fieldsKeySpecifier)[];
export type email_search_type_var_samp_fieldsFieldPolicy = {
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type email_search_type_variance_fieldsKeySpecifier = ('total_rows' | email_search_type_variance_fieldsKeySpecifier)[];
export type email_search_type_variance_fieldsFieldPolicy = {
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_aggregateKeySpecifier = ('aggregate' | 'nodes' | file_aggregateKeySpecifier)[];
export type file_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | file_aggregate_fieldsKeySpecifier)[];
export type file_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_avg_fieldsKeySpecifier = ('file_flags' | 'org_id' | file_avg_fieldsKeySpecifier)[];
export type file_avg_fieldsFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_max_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'file_flags' | 'file_status' | 'file_type' | 'file_url' | 'id' | 'identification' | 'last_modified_date' | 'last_modified_user' | 'name' | 'org_id' | 'session_id' | file_max_fieldsKeySpecifier)[];
export type file_max_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file_url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	session_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_min_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'file_flags' | 'file_status' | 'file_type' | 'file_url' | 'id' | 'identification' | 'last_modified_date' | 'last_modified_user' | 'name' | 'org_id' | 'session_id' | file_min_fieldsKeySpecifier)[];
export type file_min_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file_url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	session_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_stddev_fieldsKeySpecifier = ('file_flags' | 'org_id' | file_stddev_fieldsKeySpecifier)[];
export type file_stddev_fieldsFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_stddev_pop_fieldsKeySpecifier = ('file_flags' | 'org_id' | file_stddev_pop_fieldsKeySpecifier)[];
export type file_stddev_pop_fieldsFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_stddev_samp_fieldsKeySpecifier = ('file_flags' | 'org_id' | file_stddev_samp_fieldsKeySpecifier)[];
export type file_stddev_samp_fieldsFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_sum_fieldsKeySpecifier = ('file_flags' | 'org_id' | file_sum_fieldsKeySpecifier)[];
export type file_sum_fieldsFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_var_pop_fieldsKeySpecifier = ('file_flags' | 'org_id' | file_var_pop_fieldsKeySpecifier)[];
export type file_var_pop_fieldsFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_var_samp_fieldsKeySpecifier = ('file_flags' | 'org_id' | file_var_samp_fieldsKeySpecifier)[];
export type file_var_samp_fieldsFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_variance_fieldsKeySpecifier = ('file_flags' | 'org_id' | file_variance_fieldsKeySpecifier)[];
export type file_variance_fieldsFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_stats_typeKeySpecifier = ('file_flags' | 'file_flags_id' | 'qty' | 'users_qty' | file_stats_typeKeySpecifier)[];
export type file_stats_typeFieldPolicy = {
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	file_flags_id?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	users_qty?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_typeKeySpecifier = ('description' | 'doc_types' | 'file_type' | file_typeKeySpecifier)[];
export type file_typeFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_types?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressOrOverrideResultKeySpecifier = ('address' | 'original_id' | AddressOrOverrideResultKeySpecifier)[];
export type AddressOrOverrideResultFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	original_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetAddressOverridesResponseKeySpecifier = ('qty' | 'sourceAddress' | 'targetAddress' | GetAddressOverridesResponseKeySpecifier)[];
export type GetAddressOverridesResponseFieldPolicy = {
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	sourceAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	targetAddress?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetBordereausKeySpecifier = ('count' | 'data' | GetBordereausKeySpecifier)[];
export type GetBordereausFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BordereauKeySpecifier = ('accountNumber' | 'amount' | 'bordereauItems' | 'bordereauPdfDoc' | 'bordereauXmlDoc' | 'consignee' | 'documentDate' | 'documentNumber' | 'documentTime' | 'documentTitle' | 'duties' | 'numberOfDocuments' | 'status' | 'vat' | BordereauKeySpecifier)[];
export type BordereauFieldPolicy = {
	accountNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	bordereauItems?: FieldPolicy<any> | FieldReadFunction<any>,
	bordereauPdfDoc?: FieldPolicy<any> | FieldReadFunction<any>,
	bordereauXmlDoc?: FieldPolicy<any> | FieldReadFunction<any>,
	consignee?: FieldPolicy<any> | FieldReadFunction<any>,
	documentDate?: FieldPolicy<any> | FieldReadFunction<any>,
	documentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	documentTime?: FieldPolicy<any> | FieldReadFunction<any>,
	documentTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	duties?: FieldPolicy<any> | FieldReadFunction<any>,
	numberOfDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	vat?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BordereauItemKeySpecifier = ('amount' | 'customOffice' | 'customsDeclarationVersion' | 'customsReference' | 'documentTypeAbbreviation' | 'documentTypeName' | 'documentTypeNameTranslations' | 'drNo' | 'file' | 'id' | 'status' | 'traderReference' | BordereauItemKeySpecifier)[];
export type BordereauItemFieldPolicy = {
	amount?: FieldPolicy<any> | FieldReadFunction<any>,
	customOffice?: FieldPolicy<any> | FieldReadFunction<any>,
	customsDeclarationVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	customsReference?: FieldPolicy<any> | FieldReadFunction<any>,
	documentTypeAbbreviation?: FieldPolicy<any> | FieldReadFunction<any>,
	documentTypeName?: FieldPolicy<any> | FieldReadFunction<any>,
	documentTypeNameTranslations?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	traderReference?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CustomsOfficeACSKeySpecifier = ('address' | 'city' | 'name' | 'officeNumber' | 'prefix' | 'validFrom' | 'validTo' | CustomsOfficeACSKeySpecifier)[];
export type CustomsOfficeACSFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	officeNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	prefix?: FieldPolicy<any> | FieldReadFunction<any>,
	validFrom?: FieldPolicy<any> | FieldReadFunction<any>,
	validTo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TranslationsACSKeySpecifier = ('de' | 'en' | TranslationsACSKeySpecifier)[];
export type TranslationsACSFieldPolicy = {
	de?: FieldPolicy<any> | FieldReadFunction<any>,
	en?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FileACSKeySpecifier = ('creationDate' | 'creationUser' | 'declarations' | 'documents' | 'fileFlags' | 'fileStatus' | 'fileType' | 'fileUrl' | 'id' | 'identification' | 'isDeleted' | 'lastModifiedDate' | 'lastModifiedUser' | 'meta' | 'name' | 'orgId' | 'sessionId' | FileACSKeySpecifier)[];
export type FileACSFieldPolicy = {
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	declarations?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	fileFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	fileStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	fileType?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationACSKeySpecifier = ('addresses' | 'addressReferences' | 'autoclassifiedDocsQty' | 'customsOffice' | 'declaration' | 'declarationDiscussion' | 'declarationLabels' | 'declarationRequest' | 'declarationStatus' | 'drNo' | 'file' | 'fileId' | 'myDuties' | 'nonclassifiedDocsExists' | 'payer' | 'payerAddress' | 'searchReferences' | 'userPp' | DeclarationACSKeySpecifier)[];
export type DeclarationACSFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	addressReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	autoclassifiedDocsQty?: FieldPolicy<any> | FieldReadFunction<any>,
	customsOffice?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationDiscussion?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	myDuties?: FieldPolicy<any> | FieldReadFunction<any>,
	nonclassifiedDocsExists?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>,
	payerAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	searchReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	userPp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationDiscussionEntityKeySpecifier = ('closed' | 'creationDate' | 'discussionId' | 'discussionTheme' | 'drNo' | 'fileId' | 'meta' | 'unreadMessagesCount' | DeclarationDiscussionEntityKeySpecifier)[];
export type DeclarationDiscussionEntityFieldPolicy = {
	closed?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	discussionId?: FieldPolicy<any> | FieldReadFunction<any>,
	discussionTheme?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	unreadMessagesCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommodityCodeDescriptionKeySpecifier = ('commodityCode' | 'descriptionDe' | 'hierarchyVisual' | 'id' | CommodityCodeDescriptionKeySpecifier)[];
export type CommodityCodeDescriptionFieldPolicy = {
	commodityCode?: FieldPolicy<any> | FieldReadFunction<any>,
	descriptionDe?: FieldPolicy<any> | FieldReadFunction<any>,
	hierarchyVisual?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationLabelQueryOutputKeySpecifier = ('color' | 'description' | 'id' | 'is_deleted' | 'tenant_id' | 'title' | DeclarationLabelQueryOutputKeySpecifier)[];
export type DeclarationLabelQueryOutputFieldPolicy = {
	color?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationAddressKeySpecifier = ('address' | 'addressId' | 'addressType' | 'creationDate' | 'creationUser' | 'drNo' | 'fileId' | 'meta' | 'refs' | DeclarationAddressKeySpecifier)[];
export type DeclarationAddressFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	addressId?: FieldPolicy<any> | FieldReadFunction<any>,
	addressType?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	refs?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationFlatKeySpecifier = ('addressReferences' | 'autoclassifiedDocsQty' | 'consigneeName' | 'consigneeRef' | 'consignorName' | 'consignorRef' | 'creationDate' | 'creationUser' | 'customsOfficeNumber' | 'declarationStatus' | 'discussionId' | 'drNo' | 'evvReceived' | 'fileId' | 'identification' | 'importerRef' | 'messageCount' | 'nonclassifiedDocsExists' | 'orgId' | 'payerName' | 'payerRef' | 'totalColis' | 'totalGrossWeight' | DeclarationFlatKeySpecifier)[];
export type DeclarationFlatFieldPolicy = {
	addressReferences?: FieldPolicy<any> | FieldReadFunction<any>,
	autoclassifiedDocsQty?: FieldPolicy<any> | FieldReadFunction<any>,
	consigneeName?: FieldPolicy<any> | FieldReadFunction<any>,
	consigneeRef?: FieldPolicy<any> | FieldReadFunction<any>,
	consignorName?: FieldPolicy<any> | FieldReadFunction<any>,
	consignorRef?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	customsOfficeNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	discussionId?: FieldPolicy<any> | FieldReadFunction<any>,
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	evvReceived?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	importerRef?: FieldPolicy<any> | FieldReadFunction<any>,
	messageCount?: FieldPolicy<any> | FieldReadFunction<any>,
	nonclassifiedDocsExists?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	payerName?: FieldPolicy<any> | FieldReadFunction<any>,
	payerRef?: FieldPolicy<any> | FieldReadFunction<any>,
	totalColis?: FieldPolicy<any> | FieldReadFunction<any>,
	totalGrossWeight?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetFileDocumentsQueryKeySpecifier = ('blobs' | 'creationUser' | 'documentExtension' | 'documentFlags' | 'documentName' | 'documentStatus' | 'documentType' | 'documentTypeTranslations' | 'id' | 'lastModifiedDate' | 'meta' | 'pages' | 'sequence' | GetFileDocumentsQueryKeySpecifier)[];
export type GetFileDocumentsQueryFieldPolicy = {
	blobs?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	documentExtension?: FieldPolicy<any> | FieldReadFunction<any>,
	documentFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	documentName?: FieldPolicy<any> | FieldReadFunction<any>,
	documentStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	documentTypeTranslations?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	pages?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DocumentBlobKeySpecifier = ('extension' | 'initial' | 'url' | DocumentBlobKeySpecifier)[];
export type DocumentBlobFieldPolicy = {
	extension?: FieldPolicy<any> | FieldReadFunction<any>,
	initial?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetFilesKeySpecifier = ('creationDate' | 'creationUser' | 'declarations' | 'documents' | 'fileFlags' | 'fileUrl' | 'id' | 'identification' | 'isDeleted' | 'lastModifiedDate' | 'meta' | 'name' | 'orgId' | GetFilesKeySpecifier)[];
export type GetFilesFieldPolicy = {
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	declarations?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	fileFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetFilesDocumentACSKeySpecifier = ('checksum' | 'creation_date' | 'creation_user' | 'document_blobs' | 'document_extension' | 'document_flags' | 'document_name' | 'document_status' | 'document_type' | 'document_version' | 'documentPages' | 'file' | 'id' | 'is_customs_relevant' | 'is_deleted' | 'is_generated' | 'is_template' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'number_of_pages' | 'org_id' | 'sequence' | GetFilesDocumentACSKeySpecifier)[];
export type GetFilesDocumentACSFieldPolicy = {
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	document_blobs?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_version?: FieldPolicy<any> | FieldReadFunction<any>,
	documentPages?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_customs_relevant?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	is_generated?: FieldPolicy<any> | FieldReadFunction<any>,
	is_template?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetFilesDocumentTypeACSKeySpecifier = ('creationDate' | 'creationUser' | 'displayName' | 'documentTypeTenantSettings' | 'lastModifiedDate' | 'lastModifiedUser' | 'name' | 'translations' | GetFilesDocumentTypeACSKeySpecifier)[];
export type GetFilesDocumentTypeACSFieldPolicy = {
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	documentTypeTenantSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	translations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetFilesDocumentTypeTenantSettingsKeySpecifier = ('code' | 'creationDate' | 'creationUser' | 'defaultFlags' | 'displayName' | 'documentSchema' | 'documentType' | 'lastModifiedDate' | 'lastModifiedUser' | 'meta' | 'tenant' | GetFilesDocumentTypeTenantSettingsKeySpecifier)[];
export type GetFilesDocumentTypeTenantSettingsFieldPolicy = {
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	defaultFlags?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	documentSchema?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetFilesDocumentPageKeySpecifier = ('documentId' | 'page' | 'pageId' | 'pageNumber' | GetFilesDocumentPageKeySpecifier)[];
export type GetFilesDocumentPageFieldPolicy = {
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	pageId?: FieldPolicy<any> | FieldReadFunction<any>,
	pageNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type GetFilesPageACSKeySpecifier = ('creationDate' | 'creationUser' | 'id' | 'lastModifiedDate' | 'lastModifiedUser' | 'meta' | 'ocrText' | 'pageStatus' | 'rotate' | 'thumbnailBigUrl' | 'thumbnailSmallUrl' | GetFilesPageACSKeySpecifier)[];
export type GetFilesPageACSFieldPolicy = {
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	ocrText?: FieldPolicy<any> | FieldReadFunction<any>,
	pageStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailBigUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnailSmallUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SASTokenResponseKeySpecifier = ('container' | 'expiryDate' | 'sasToken' | SASTokenResponseKeySpecifier)[];
export type SASTokenResponseFieldPolicy = {
	container?: FieldPolicy<any> | FieldReadFunction<any>,
	expiryDate?: FieldPolicy<any> | FieldReadFunction<any>,
	sasToken?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReportEntityKeySpecifier = ('creationDate' | 'creationUser' | 'id' | 'isDeleted' | 'lastModifiedDate' | 'md5' | 'reportType' | 'status' | 'tenantId' | 'url' | ReportEntityKeySpecifier)[];
export type ReportEntityFieldPolicy = {
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	isDeleted?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	md5?: FieldPolicy<any> | FieldReadFunction<any>,
	reportType?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	tenantId?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CaslRuleKeySpecifier = ('action' | 'subject' | CaslRuleKeySpecifier)[];
export type CaslRuleFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_items_for_drsKeySpecifier = ('acceptance_date' | 'account_number' | 'additional_unit' | 'arrival_time' | 'arrival_type' | 'autoclassified_docs_qty' | 'ch_exp_decl' | 'clearance_type' | 'commercial_good' | 'commodity_code' | 'creation_date' | 'creation_user' | 'customs_clearance_type' | 'customs_declaration_number' | 'customs_declaration_version' | 'customs_itemnumber' | 'declaration_request' | 'declaration_status' | 'declaration_type' | 'description' | 'dest_tolldept_code' | 'dest_tolldept_name' | 'doc_id' | 'document_type' | 'dr_no' | 'duty_total' | 'eta' | 'file_id' | 'goods_item' | 'grossmass' | 'hs_code' | 'imp_cust_clr' | 'is_express' | 'last_modified_date' | 'meta' | 'net_mass' | 'non_customs_law_obligation' | 'nonclassified_docs_exists' | 'origin' | 'origin_country' | 'packaging' | 'payer_id' | 'permissions_js' | 'permit_obligation' | 'preference' | 'produced_document' | 'qty' | 'reference' | 'row_number' | 'statistic' | 'statistical_code' | 'statistical_value' | 'toll_dep' | 'tr_no' | 'trader_reference' | 'transitdoc_type' | 'valuation_details' | 'value' | 'vat_total' | 'vatvalue' | 'wa_number' | goods_items_for_drsKeySpecifier)[];
export type goods_items_for_drsFieldPolicy = {
	acceptance_date?: FieldPolicy<any> | FieldReadFunction<any>,
	account_number?: FieldPolicy<any> | FieldReadFunction<any>,
	additional_unit?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_time?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type?: FieldPolicy<any> | FieldReadFunction<any>,
	autoclassified_docs_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	ch_exp_decl?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	commercial_good?: FieldPolicy<any> | FieldReadFunction<any>,
	commodity_code?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_number?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_declaration_version?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_itemnumber?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	dest_tolldept_code?: FieldPolicy<any> | FieldReadFunction<any>,
	dest_tolldept_name?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_id?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	duty_total?: FieldPolicy<any> | FieldReadFunction<any>,
	eta?: FieldPolicy<any> | FieldReadFunction<any>,
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item?: FieldPolicy<any> | FieldReadFunction<any>,
	grossmass?: FieldPolicy<any> | FieldReadFunction<any>,
	hs_code?: FieldPolicy<any> | FieldReadFunction<any>,
	imp_cust_clr?: FieldPolicy<any> | FieldReadFunction<any>,
	is_express?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	net_mass?: FieldPolicy<any> | FieldReadFunction<any>,
	non_customs_law_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	nonclassified_docs_exists?: FieldPolicy<any> | FieldReadFunction<any>,
	origin?: FieldPolicy<any> | FieldReadFunction<any>,
	origin_country?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging?: FieldPolicy<any> | FieldReadFunction<any>,
	payer_id?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions_js?: FieldPolicy<any> | FieldReadFunction<any>,
	permit_obligation?: FieldPolicy<any> | FieldReadFunction<any>,
	preference?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_document?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	reference?: FieldPolicy<any> | FieldReadFunction<any>,
	row_number?: FieldPolicy<any> | FieldReadFunction<any>,
	statistic?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	statistical_value?: FieldPolicy<any> | FieldReadFunction<any>,
	toll_dep?: FieldPolicy<any> | FieldReadFunction<any>,
	tr_no?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_reference?: FieldPolicy<any> | FieldReadFunction<any>,
	transitdoc_type?: FieldPolicy<any> | FieldReadFunction<any>,
	valuation_details?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	vat_total?: FieldPolicy<any> | FieldReadFunction<any>,
	vatvalue?: FieldPolicy<any> | FieldReadFunction<any>,
	wa_number?: FieldPolicy<any> | FieldReadFunction<any>
};
export type intf_dr_payment_infoKeySpecifier = ('addresses' | 'addresses_qi' | 'payer' | intf_dr_payment_infoKeySpecifier)[];
export type intf_dr_payment_infoFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses_qi?: FieldPolicy<any> | FieldReadFunction<any>,
	payer?: FieldPolicy<any> | FieldReadFunction<any>
};
export type json_typeKeySpecifier = ('json_value' | json_typeKeySpecifier)[];
export type json_typeFieldPolicy = {
	json_value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type kc_usersKeySpecifier = ('adit_permissions' | 'adit_permissions_desk' | 'adit_permissions_hex' | 'adit_roles' | 'attrs' | 'code' | 'created' | 'default_role' | 'email' | 'enabled' | 'federation_link' | 'first_name' | 'id' | 'last_name' | 'liber_roles' | 'location' | 'not_before' | 'org_ids' | 'phone_number' | 'qty' | 'realm_id' | 'required_actions' | 'service_account_client_link' | 'tenant' | 'tenant_id' | 'user_client_roles' | 'user_id' | 'username' | kc_usersKeySpecifier)[];
export type kc_usersFieldPolicy = {
	adit_permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	adit_permissions_desk?: FieldPolicy<any> | FieldReadFunction<any>,
	adit_permissions_hex?: FieldPolicy<any> | FieldReadFunction<any>,
	adit_roles?: FieldPolicy<any> | FieldReadFunction<any>,
	attrs?: FieldPolicy<any> | FieldReadFunction<any>,
	code?: FieldPolicy<any> | FieldReadFunction<any>,
	created?: FieldPolicy<any> | FieldReadFunction<any>,
	default_role?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	enabled?: FieldPolicy<any> | FieldReadFunction<any>,
	federation_link?: FieldPolicy<any> | FieldReadFunction<any>,
	first_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_name?: FieldPolicy<any> | FieldReadFunction<any>,
	liber_roles?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	not_before?: FieldPolicy<any> | FieldReadFunction<any>,
	org_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	phone_number?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	realm_id?: FieldPolicy<any> | FieldReadFunction<any>,
	required_actions?: FieldPolicy<any> | FieldReadFunction<any>,
	service_account_client_link?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	user_client_roles?: FieldPolicy<any> | FieldReadFunction<any>,
	user_id?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type max_date_typeKeySpecifier = ('max_change_date' | max_date_typeKeySpecifier)[];
export type max_date_typeFieldPolicy = {
	max_change_date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type model_retrainKeySpecifier = ('end_time' | 'error_message' | 'id' | 'request_time' | 'start_time' | 'status' | model_retrainKeySpecifier)[];
export type model_retrainFieldPolicy = {
	end_time?: FieldPolicy<any> | FieldReadFunction<any>,
	error_message?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	request_time?: FieldPolicy<any> | FieldReadFunction<any>,
	start_time?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type org_idsKeySpecifier = ('addresses_desc' | 'display_name' | 'docs_affected' | 'files_affected' | 'org_id' | 'org_id_description' | 'org_ids_desc' | 'org_params' | 'orgParams' | 'qty' | 'users_affected' | org_idsKeySpecifier)[];
export type org_idsFieldPolicy = {
	addresses_desc?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	docs_affected?: FieldPolicy<any> | FieldReadFunction<any>,
	files_affected?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id_description?: FieldPolicy<any> | FieldReadFunction<any>,
	org_ids_desc?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params?: FieldPolicy<any> | FieldReadFunction<any>,
	orgParams?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	users_affected?: FieldPolicy<any> | FieldReadFunction<any>
};
export type org_paramsKeySpecifier = ('addresses' | 'file_ids' | 'org_id' | 'org_ids' | 'orgId' | 'orgIds' | 'search' | org_paramsKeySpecifier)[];
export type org_paramsFieldPolicy = {
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	file_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	orgIds?: FieldPolicy<any> | FieldReadFunction<any>,
	search?: FieldPolicy<any> | FieldReadFunction<any>
};
export type org_params_org_idKeySpecifier = ('org_id' | 'param_org_id' | 'paramOrgId' | org_params_org_idKeySpecifier)[];
export type org_params_org_idFieldPolicy = {
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	param_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	paramOrgId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type page_statusKeySpecifier = ('creation_date' | 'creation_user' | 'display_name' | 'last_modified_date' | 'last_modified_user' | 'name' | 'user' | page_statusKeySpecifier)[];
export type page_statusFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_aggregateKeySpecifier = ('aggregate' | 'nodes' | pages_m2m_cache_aggregateKeySpecifier)[];
export type pages_m2m_cache_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | pages_m2m_cache_aggregate_fieldsKeySpecifier)[];
export type pages_m2m_cache_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_avg_fieldsKeySpecifier = ('page_number' | 'rotate' | pages_m2m_cache_avg_fieldsKeySpecifier)[];
export type pages_m2m_cache_avg_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_max_fieldsKeySpecifier = ('document_id' | 'page' | 'page_number' | 'page_status' | 'rotate' | 'thumbnail_big_url' | 'thumbnail_small_url' | pages_m2m_cache_max_fieldsKeySpecifier)[];
export type pages_m2m_cache_max_fieldsFieldPolicy = {
	document_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_big_url?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_small_url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_min_fieldsKeySpecifier = ('document_id' | 'page' | 'page_number' | 'page_status' | 'rotate' | 'thumbnail_big_url' | 'thumbnail_small_url' | pages_m2m_cache_min_fieldsKeySpecifier)[];
export type pages_m2m_cache_min_fieldsFieldPolicy = {
	document_id?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_big_url?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail_small_url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_stddev_fieldsKeySpecifier = ('page_number' | 'rotate' | pages_m2m_cache_stddev_fieldsKeySpecifier)[];
export type pages_m2m_cache_stddev_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_stddev_pop_fieldsKeySpecifier = ('page_number' | 'rotate' | pages_m2m_cache_stddev_pop_fieldsKeySpecifier)[];
export type pages_m2m_cache_stddev_pop_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_stddev_samp_fieldsKeySpecifier = ('page_number' | 'rotate' | pages_m2m_cache_stddev_samp_fieldsKeySpecifier)[];
export type pages_m2m_cache_stddev_samp_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_sum_fieldsKeySpecifier = ('page_number' | 'rotate' | pages_m2m_cache_sum_fieldsKeySpecifier)[];
export type pages_m2m_cache_sum_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_var_pop_fieldsKeySpecifier = ('page_number' | 'rotate' | pages_m2m_cache_var_pop_fieldsKeySpecifier)[];
export type pages_m2m_cache_var_pop_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_var_samp_fieldsKeySpecifier = ('page_number' | 'rotate' | pages_m2m_cache_var_samp_fieldsKeySpecifier)[];
export type pages_m2m_cache_var_samp_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pages_m2m_cache_variance_fieldsKeySpecifier = ('page_number' | 'rotate' | pages_m2m_cache_variance_fieldsKeySpecifier)[];
export type pages_m2m_cache_variance_fieldsFieldPolicy = {
	page_number?: FieldPolicy<any> | FieldReadFunction<any>,
	rotate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type pp_types_file_searchKeySpecifier = ('creation_date' | 'creation_user' | 'customs_relevant' | 'customs_relevant_qty' | 'documents' | 'documents_aggregate' | 'extraction_completed_qty' | 'extraction_required' | 'extraction_required_qty' | 'file_flags' | 'file_status' | 'file_url' | 'id' | 'identification' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'name' | 'org' | 'org_id' | 'org_id_description' | 'session_id' | 'total_rows' | pp_types_file_searchKeySpecifier)[];
export type pp_types_file_searchFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_relevant?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_relevant_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_completed_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_required?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_required_qty?: FieldPolicy<any> | FieldReadFunction<any>,
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	file_url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	org?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id_description?: FieldPolicy<any> | FieldReadFunction<any>,
	session_id?: FieldPolicy<any> | FieldReadFunction<any>,
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CommodityCodeStatisticsKeySpecifier = ('declarationCount' | 'goodsItemCount' | 'totalGrossMass' | 'totalNetMass' | CommodityCodeStatisticsKeySpecifier)[];
export type CommodityCodeStatisticsFieldPolicy = {
	declarationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	goodsItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	totalGrossMass?: FieldPolicy<any> | FieldReadFunction<any>,
	totalNetMass?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StatisticsDTOKeySpecifier = ('avgCommodityCodesPerDeclaration' | 'commodityCodesChapters' | 'customsAgencies' | 'customsDeclarations' | StatisticsDTOKeySpecifier)[];
export type StatisticsDTOFieldPolicy = {
	avgCommodityCodesPerDeclaration?: FieldPolicy<any> | FieldReadFunction<any>,
	commodityCodesChapters?: FieldPolicy<any> | FieldReadFunction<any>,
	customsAgencies?: FieldPolicy<any> | FieldReadFunction<any>,
	customsDeclarations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StatisticTariffNumberItemKeySpecifier = ('chapter' | 'declarationCount' | 'goodsItemCount' | 'heading' | 'subheading' | 'tariffNumber' | 'totalGrossMass' | 'totalNetMass' | StatisticTariffNumberItemKeySpecifier)[];
export type StatisticTariffNumberItemFieldPolicy = {
	chapter?: FieldPolicy<any> | FieldReadFunction<any>,
	declarationCount?: FieldPolicy<any> | FieldReadFunction<any>,
	goodsItemCount?: FieldPolicy<any> | FieldReadFunction<any>,
	heading?: FieldPolicy<any> | FieldReadFunction<any>,
	subheading?: FieldPolicy<any> | FieldReadFunction<any>,
	tariffNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	totalGrossMass?: FieldPolicy<any> | FieldReadFunction<any>,
	totalNetMass?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StatisticItemKeySpecifier = ('count' | 'label' | 'percentage' | 'traderIdentificationNumber' | StatisticItemKeySpecifier)[];
export type StatisticItemFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	label?: FieldPolicy<any> | FieldReadFunction<any>,
	percentage?: FieldPolicy<any> | FieldReadFunction<any>,
	traderIdentificationNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DateIntervalKeySpecifier = ('dateInterval' | 'tickInterval' | DateIntervalKeySpecifier)[];
export type DateIntervalFieldPolicy = {
	dateInterval?: FieldPolicy<any> | FieldReadFunction<any>,
	tickInterval?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DateIntervalItemKeySpecifier = ('count' | 'date' | 'lastYearCount' | DateIntervalItemKeySpecifier)[];
export type DateIntervalItemFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	lastYearCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type tenantsKeySpecifier = ('address' | 'address_groups' | 'address_id' | 'address_type' | 'company_name' | 'creation_date' | 'creation_user' | 'creationUser' | 'id' | 'last_modified_date' | 'last_modified_user' | 'lastModifiedUser' | 'permissions' | 'permissions_desk' | 'qty' | 'tenant_id' | 'tenant_name' | 'tenant_type' | 'trader_identification_number' | 'users' | tenantsKeySpecifier)[];
export type tenantsFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	address_groups?: FieldPolicy<any> | FieldReadFunction<any>,
	address_id?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	company_name?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions?: FieldPolicy<any> | FieldReadFunction<any>,
	permissions_desk?: FieldPolicy<any> | FieldReadFunction<any>,
	qty?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_name?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_type?: FieldPolicy<any> | FieldReadFunction<any>,
	trader_identification_number?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type user_search_typeKeySpecifier = ('creation_date' | 'display_name' | 'id' | 'location' | 'role' | 'total_rows' | user_search_typeKeySpecifier)[];
export type user_search_typeFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	total_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type view_document_historyKeySpecifier = ('action_title' | 'action_user' | 'action_value' | 'document' | 'id' | 'op_date' | view_document_historyKeySpecifier)[];
export type view_document_historyFieldPolicy = {
	action_title?: FieldPolicy<any> | FieldReadFunction<any>,
	action_user?: FieldPolicy<any> | FieldReadFunction<any>,
	action_value?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	op_date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type view_file_historyKeySpecifier = ('action_title' | 'action_user' | 'action_value' | 'file' | 'id' | 'op_date' | view_file_historyKeySpecifier)[];
export type view_file_historyFieldPolicy = {
	action_title?: FieldPolicy<any> | FieldReadFunction<any>,
	action_user?: FieldPolicy<any> | FieldReadFunction<any>,
	action_value?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	op_date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type reportKeySpecifier = ('creation_date' | 'creation_user' | 'id' | 'last_modified_date' | 'md5' | 'status' | 'url' | reportKeySpecifier)[];
export type reportFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	md5?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type report_aggregateKeySpecifier = ('aggregate' | 'nodes' | report_aggregateKeySpecifier)[];
export type report_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type report_aggregate_fieldsKeySpecifier = ('count' | 'max' | 'min' | report_aggregate_fieldsKeySpecifier)[];
export type report_aggregate_fieldsFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>
};
export type report_max_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'id' | 'last_modified_date' | 'md5' | 'status' | 'url' | report_max_fieldsKeySpecifier)[];
export type report_max_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	md5?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type report_min_fieldsKeySpecifier = ('creation_date' | 'creation_user' | 'id' | 'last_modified_date' | 'md5' | 'status' | 'url' | report_min_fieldsKeySpecifier)[];
export type report_min_fieldsFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	md5?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariffKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'end_date' | 'id' | 'meta' | 'position_cost' | 'positions_included' | 'start_date' | 'tenant_id' | service_tariffKeySpecifier)[];
export type service_tariffFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	end_date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>,
	start_date?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_aggregateKeySpecifier = ('aggregate' | 'nodes' | service_tariff_aggregateKeySpecifier)[];
export type service_tariff_aggregateFieldPolicy = {
	aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_aggregate_fieldsKeySpecifier = ('avg' | 'count' | 'max' | 'min' | 'stddev' | 'stddev_pop' | 'stddev_samp' | 'sum' | 'var_pop' | 'var_samp' | 'variance' | service_tariff_aggregate_fieldsKeySpecifier)[];
export type service_tariff_aggregate_fieldsFieldPolicy = {
	avg?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	max?: FieldPolicy<any> | FieldReadFunction<any>,
	min?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	stddev_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	sum?: FieldPolicy<any> | FieldReadFunction<any>,
	var_pop?: FieldPolicy<any> | FieldReadFunction<any>,
	var_samp?: FieldPolicy<any> | FieldReadFunction<any>,
	variance?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_avg_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'position_cost' | 'positions_included' | service_tariff_avg_fieldsKeySpecifier)[];
export type service_tariff_avg_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_max_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'end_date' | 'id' | 'position_cost' | 'positions_included' | 'start_date' | 'tenant_id' | service_tariff_max_fieldsKeySpecifier)[];
export type service_tariff_max_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	end_date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>,
	start_date?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_min_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'end_date' | 'id' | 'position_cost' | 'positions_included' | 'start_date' | 'tenant_id' | service_tariff_min_fieldsKeySpecifier)[];
export type service_tariff_min_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	end_date?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>,
	start_date?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_stddev_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'position_cost' | 'positions_included' | service_tariff_stddev_fieldsKeySpecifier)[];
export type service_tariff_stddev_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_stddev_pop_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'position_cost' | 'positions_included' | service_tariff_stddev_pop_fieldsKeySpecifier)[];
export type service_tariff_stddev_pop_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_stddev_samp_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'position_cost' | 'positions_included' | service_tariff_stddev_samp_fieldsKeySpecifier)[];
export type service_tariff_stddev_samp_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_sum_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'position_cost' | 'positions_included' | service_tariff_sum_fieldsKeySpecifier)[];
export type service_tariff_sum_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_var_pop_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'position_cost' | 'positions_included' | service_tariff_var_pop_fieldsKeySpecifier)[];
export type service_tariff_var_pop_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_var_samp_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'position_cost' | 'positions_included' | service_tariff_var_samp_fieldsKeySpecifier)[];
export type service_tariff_var_samp_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_variance_fieldsKeySpecifier = ('direct_upload_cost' | 'email_upload_cost' | 'position_cost' | 'positions_included' | service_tariff_variance_fieldsKeySpecifier)[];
export type service_tariff_variance_fieldsFieldPolicy = {
	direct_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	email_upload_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	position_cost?: FieldPolicy<any> | FieldReadFunction<any>,
	positions_included?: FieldPolicy<any> | FieldReadFunction<any>
};
export type settingKeySpecifier = ('constrained' | 'creation_date' | 'creation_user' | 'data_type' | 'default_value' | 'description' | 'id' | 'identifier' | 'last_modified_date' | 'last_modified_user' | 'max_value' | 'min_value' | 'setting_group' | 'setting_group_id' | 'user' | settingKeySpecifier)[];
export type settingFieldPolicy = {
	constrained?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	data_type?: FieldPolicy<any> | FieldReadFunction<any>,
	default_value?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identifier?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	max_value?: FieldPolicy<any> | FieldReadFunction<any>,
	min_value?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_group?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_group_id?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type setting_groupKeySpecifier = ('creation_date' | 'creation_user' | 'description' | 'id' | 'last_modified_date' | 'last_modified_user' | 'settings' | 'user' | setting_groupKeySpecifier)[];
export type setting_groupFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type setting_valueKeySpecifier = ('creation_date' | 'creation_user' | 'display_name' | 'id' | 'is_template' | 'last_modified_date' | 'last_modified_user' | 'reference_id' | 'reference_type_id' | 'setting_id' | 'user' | 'value' | setting_valueKeySpecifier)[];
export type setting_valueFieldPolicy = {
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	display_name?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_template?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	reference_id?: FieldPolicy<any> | FieldReadFunction<any>,
	reference_type_id?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_id?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type tariff_number_descriptionKeySpecifier = ('description_de' | 'hierarchy_path' | 'hierarchy_visual' | 'id' | 'parent_id' | 'tariff_number' | 'tsv' | tariff_number_descriptionKeySpecifier)[];
export type tariff_number_descriptionFieldPolicy = {
	description_de?: FieldPolicy<any> | FieldReadFunction<any>,
	hierarchy_path?: FieldPolicy<any> | FieldReadFunction<any>,
	hierarchy_visual?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	parent_id?: FieldPolicy<any> | FieldReadFunction<any>,
	tariff_number?: FieldPolicy<any> | FieldReadFunction<any>,
	tsv?: FieldPolicy<any> | FieldReadFunction<any>
};
export type transitdoc_type_descrKeySpecifier = ('description' | 'transitdoc_type' | transitdoc_type_descrKeySpecifier)[];
export type transitdoc_type_descrFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	transitdoc_type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type view_historyKeySpecifier = ('action_title' | 'action_user' | 'action_value' | 'entity' | 'id' | 'op_date' | view_historyKeySpecifier)[];
export type view_historyFieldPolicy = {
	action_title?: FieldPolicy<any> | FieldReadFunction<any>,
	action_user?: FieldPolicy<any> | FieldReadFunction<any>,
	action_value?: FieldPolicy<any> | FieldReadFunction<any>,
	entity?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	op_date?: FieldPolicy<any> | FieldReadFunction<any>
};
export type vw_documentsKeySpecifier = ('checksum' | 'creation_date' | 'creation_user' | 'document_blobs' | 'document_extension' | 'document_flags' | 'document_name' | 'document_status' | 'document_type' | 'documentType' | 'file' | 'id' | 'is_customs_relevant' | 'is_deleted' | 'is_generated' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'number_of_pages' | 'org_id' | 'pages_m2m' | 'pages_m2m_aggregate' | 'sequence' | vw_documentsKeySpecifier)[];
export type vw_documentsFieldPolicy = {
	checksum?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	document_blobs?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	document_name?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	documentType?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_customs_relevant?: FieldPolicy<any> | FieldReadFunction<any>,
	is_deleted?: FieldPolicy<any> | FieldReadFunction<any>,
	is_generated?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	number_of_pages?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	sequence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type vw_finished_filesKeySpecifier = ('created_by_user' | 'creation_date' | 'creation_user' | 'declarations' | 'documents' | 'documents_aggregate' | 'file_flags' | 'file_status' | 'file_url' | 'id' | 'identification' | 'last_modified_by_user' | 'last_modified_date' | 'last_modified_user' | 'meta' | 'name' | 'org_id' | 'orgId' | 'session_id' | vw_finished_filesKeySpecifier)[];
export type vw_finished_filesFieldPolicy = {
	created_by_user?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_date?: FieldPolicy<any> | FieldReadFunction<any>,
	creation_user?: FieldPolicy<any> | FieldReadFunction<any>,
	declarations?: FieldPolicy<any> | FieldReadFunction<any>,
	documents?: FieldPolicy<any> | FieldReadFunction<any>,
	documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_flags?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	file_url?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_by_user?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_date?: FieldPolicy<any> | FieldReadFunction<any>,
	last_modified_user?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	session_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type mutation_rootKeySpecifier = ('acs_insert_address_one' | 'acs_update_address_visibility' | 'activate2FA' | 'addNotificationTrigger' | 'assignDeclarationLabels' | 'assignNotificationLabels' | 'classifyWeDeclareDocument' | 'copyDeclarationAndGoodsItems' | 'createAditUser' | 'createDeclarationMessage' | 'createDeclarationReq' | 'createDeclarationRequest' | 'createDocument' | 'createDocumentType' | 'createEmptyDocument' | 'createTenantACS' | 'createWDUser' | 'delete_address' | 'delete_address_by_pk' | 'delete_containers' | 'delete_containers_by_pk' | 'delete_declaration' | 'delete_declaration_by_pk' | 'delete_declaration_discussion' | 'delete_declaration_discussion_by_pk' | 'delete_declaration_message' | 'delete_declaration_message_by_pk' | 'delete_declaration_request' | 'delete_declaration_request_address' | 'delete_declaration_request_address_by_pk' | 'delete_declaration_request_by_pk' | 'delete_declaration_special_mentions' | 'delete_declaration_special_mentions_by_pk' | 'delete_doc_annotation' | 'delete_doc_annotation_by_pk' | 'delete_document' | 'delete_document_by_pk' | 'delete_document_labels' | 'delete_document_labels_by_pk' | 'delete_document_type' | 'delete_document_type_by_pk' | 'delete_document_type_tenant_settings' | 'delete_document_type_tenant_settings_by_pk' | 'delete_file' | 'delete_file_by_pk' | 'delete_goods_item' | 'delete_goods_item_by_pk' | 'delete_import_list_trigger' | 'delete_import_list_trigger_by_pk' | 'delete_packagings' | 'delete_packagings_by_pk' | 'delete_page' | 'delete_page_by_pk' | 'delete_page_extract' | 'delete_page_extract_by_pk' | 'delete_previous_documents' | 'delete_previous_documents_by_pk' | 'delete_produced_documents' | 'delete_produced_documents_by_pk' | 'delete_service_tariff' | 'delete_setting_value' | 'delete_setting_value_by_pk' | 'delete_user_pp' | 'delete_user_pp_by_pk' | 'deleteNotificationTrigger' | 'deleteTenantReport' | 'editAddressACS' | 'editDocumentType' | 'editTenantACS' | 'enqueueDocument' | 'exportDeclaration' | 'finishDocumentValidation' | 'generate2FA' | 'generateExcelCombinedReport' | 'generateExcelDeclarationReport' | 'insert_address' | 'insert_address_one' | 'insert_address_override' | 'insert_address_override_one' | 'insert_bill_detail' | 'insert_bill_detail_one' | 'insert_containers' | 'insert_containers_one' | 'insert_declaration' | 'insert_declaration_discussion' | 'insert_declaration_discussion_one' | 'insert_declaration_message' | 'insert_declaration_message_one' | 'insert_declaration_one' | 'insert_declaration_request' | 'insert_declaration_request_address' | 'insert_declaration_request_address_one' | 'insert_declaration_request_one' | 'insert_declaration_special_mentions' | 'insert_declaration_special_mentions_one' | 'insert_doc_annotation' | 'insert_doc_annotation_one' | 'insert_document' | 'insert_document_label_org_id' | 'insert_document_label_org_id_one' | 'insert_document_labels' | 'insert_document_labels_one' | 'insert_document_one' | 'insert_document_type' | 'insert_document_type_one' | 'insert_document_type_tenant_settings' | 'insert_document_type_tenant_settings_one' | 'insert_file' | 'insert_file_one' | 'insert_goods_item' | 'insert_goods_item_one' | 'insert_import_list_trigger' | 'insert_import_list_trigger_one' | 'insert_model_retrain' | 'insert_model_retrain_one' | 'insert_packagings' | 'insert_packagings_one' | 'insert_page' | 'insert_page_extract' | 'insert_page_extract_one' | 'insert_page_one' | 'insert_previous_documents' | 'insert_previous_documents_one' | 'insert_produced_documents' | 'insert_produced_documents_one' | 'insert_service_tariff' | 'insert_service_tariff_one' | 'insert_setting_value' | 'insert_setting_value_one' | 'insert_tenant' | 'insert_tenant_one' | 'insert_user_org_id' | 'insert_user_org_id_one' | 'insert_user_pp' | 'insert_user_pp_one' | 'linkAddressesACS' | 'markDocumentAsTemplate' | 'mergeDeclarations' | 'patchTenantConfig' | 'patchUserConfig' | 'refreshOrgIds' | 'refreshOrgIdsV2' | 'removeUser' | 'scheduleAldiSrvProcessing' | 'scheduleDeclarationExport' | 'scheduleDocAnnotationExport' | 'scheduleDocuments' | 'scheduleFileExport' | 'scheduleFiles' | 'scheduleTableCalculation' | 'sendAditResetPasswordLink' | 'sendDeclarationArrivalNotification' | 'sendWDResetPasswordLink' | 'transmitFile' | 'triggerArticlesExtraction' | 'unlinkAddressACS' | 'update_address' | 'update_address_by_pk' | 'update_address_many' | 'update_address_override' | 'update_address_override_by_pk' | 'update_address_override_many' | 'update_bill_detail' | 'update_bill_detail_by_pk' | 'update_bill_detail_many' | 'update_containers' | 'update_containers_by_pk' | 'update_containers_many' | 'update_declaration' | 'update_declaration_by_pk' | 'update_declaration_discussions' | 'update_declaration_discussions_many' | 'update_declaration_many' | 'update_declaration_message' | 'update_declaration_message_by_pk' | 'update_declaration_message_many' | 'update_declaration_request' | 'update_declaration_request_address' | 'update_declaration_request_address_by_pk' | 'update_declaration_request_address_many' | 'update_declaration_request_by_pk' | 'update_declaration_request_many' | 'update_declaration_special_mentions' | 'update_declaration_special_mentions_by_pk' | 'update_declaration_special_mentions_many' | 'update_declaration_task' | 'update_declaration_task_by_pk' | 'update_declaration_task_many' | 'update_doc_annotation' | 'update_doc_annotation_by_pk' | 'update_doc_annotation_many' | 'update_document' | 'update_document_by_pk' | 'update_document_labels' | 'update_document_labels_by_pk' | 'update_document_labels_many' | 'update_document_many' | 'update_document_type' | 'update_document_type_by_pk' | 'update_document_type_many' | 'update_document_type_tenant_settings' | 'update_document_type_tenant_settings_by_pk' | 'update_document_type_tenant_settings_many' | 'update_extraction_config' | 'update_extraction_config_by_pk' | 'update_extraction_config_many' | 'update_file' | 'update_file_by_pk' | 'update_file_many' | 'update_goods_item' | 'update_goods_item_by_pk' | 'update_goods_item_many' | 'update_import_list_trigger' | 'update_import_list_trigger_by_pk' | 'update_import_list_trigger_many' | 'update_model_retrain' | 'update_model_retrain_by_pk' | 'update_model_retrain_many' | 'update_packagings' | 'update_packagings_by_pk' | 'update_packagings_many' | 'update_page' | 'update_page_by_pk' | 'update_page_extract' | 'update_page_extract_by_pk' | 'update_page_extract_many' | 'update_page_many' | 'update_previous_documents' | 'update_previous_documents_by_pk' | 'update_previous_documents_many' | 'update_produced_documents' | 'update_produced_documents_by_pk' | 'update_produced_documents_many' | 'update_service_tariff' | 'update_service_tariff_many' | 'update_setting_value' | 'update_setting_value_by_pk' | 'update_setting_value_many' | 'update_tenant' | 'update_tenant_by_pk' | 'update_tenant_many' | 'update_user_pp' | 'update_user_pp_by_pk' | 'update_user_pp_many' | 'updateAditUser' | 'updateFileNumber' | 'updateNotificationTrigger' | 'updatePassword' | 'updateWDUser' | 'upsertAddressByReference' | 'validateFileNumber' | 'validateJourneyNumber' | mutation_rootKeySpecifier)[];
export type mutation_rootFieldPolicy = {
	acs_insert_address_one?: FieldPolicy<any> | FieldReadFunction<any>,
	acs_update_address_visibility?: FieldPolicy<any> | FieldReadFunction<any>,
	activate2FA?: FieldPolicy<any> | FieldReadFunction<any>,
	addNotificationTrigger?: FieldPolicy<any> | FieldReadFunction<any>,
	assignDeclarationLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	assignNotificationLabels?: FieldPolicy<any> | FieldReadFunction<any>,
	classifyWeDeclareDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	copyDeclarationAndGoodsItems?: FieldPolicy<any> | FieldReadFunction<any>,
	createAditUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createDeclarationMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	createDeclarationReq?: FieldPolicy<any> | FieldReadFunction<any>,
	createDeclarationRequest?: FieldPolicy<any> | FieldReadFunction<any>,
	createDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	createDocumentType?: FieldPolicy<any> | FieldReadFunction<any>,
	createEmptyDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	createTenantACS?: FieldPolicy<any> | FieldReadFunction<any>,
	createWDUser?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_address?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_address_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_containers?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_containers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_discussion?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_discussion_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_message?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_request_address?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_request_address_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_request_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_declaration_special_mentions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_doc_annotation?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_doc_annotation_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_document?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_document_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_document_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_document_labels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_document_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_document_type_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_document_type_tenant_settings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_file?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_file_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_goods_item?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_goods_item_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_import_list_trigger?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_import_list_trigger_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_packagings?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_packagings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_page?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_page_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_page_extract?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_page_extract_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_previous_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_previous_documents_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_produced_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_produced_documents_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_service_tariff?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_setting_value?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_setting_value_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_user_pp?: FieldPolicy<any> | FieldReadFunction<any>,
	delete_user_pp_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteNotificationTrigger?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteTenantReport?: FieldPolicy<any> | FieldReadFunction<any>,
	editAddressACS?: FieldPolicy<any> | FieldReadFunction<any>,
	editDocumentType?: FieldPolicy<any> | FieldReadFunction<any>,
	editTenantACS?: FieldPolicy<any> | FieldReadFunction<any>,
	enqueueDocument?: FieldPolicy<any> | FieldReadFunction<any>,
	exportDeclaration?: FieldPolicy<any> | FieldReadFunction<any>,
	finishDocumentValidation?: FieldPolicy<any> | FieldReadFunction<any>,
	generate2FA?: FieldPolicy<any> | FieldReadFunction<any>,
	generateExcelCombinedReport?: FieldPolicy<any> | FieldReadFunction<any>,
	generateExcelDeclarationReport?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_address?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_address_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_address_override?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_address_override_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bill_detail?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_bill_detail_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_containers?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_containers_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_discussion?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_discussion_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_message?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_message_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_request_address?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_request_address_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_request_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_declaration_special_mentions_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_doc_annotation?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_doc_annotation_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_label_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_label_org_id_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_labels_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_type_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_type_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_document_type_tenant_settings_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_file?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_file_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_goods_item?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_goods_item_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_import_list_trigger?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_import_list_trigger_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_model_retrain?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_model_retrain_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_packagings?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_packagings_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_page?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_page_extract?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_page_extract_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_page_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_previous_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_previous_documents_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_produced_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_produced_documents_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_service_tariff?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_service_tariff_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_setting_value?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_setting_value_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_tenant_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_user_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_user_org_id_one?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_user_pp?: FieldPolicy<any> | FieldReadFunction<any>,
	insert_user_pp_one?: FieldPolicy<any> | FieldReadFunction<any>,
	linkAddressesACS?: FieldPolicy<any> | FieldReadFunction<any>,
	markDocumentAsTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	mergeDeclarations?: FieldPolicy<any> | FieldReadFunction<any>,
	patchTenantConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	patchUserConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshOrgIds?: FieldPolicy<any> | FieldReadFunction<any>,
	refreshOrgIdsV2?: FieldPolicy<any> | FieldReadFunction<any>,
	removeUser?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleAldiSrvProcessing?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleDeclarationExport?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleDocAnnotationExport?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleDocuments?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleFileExport?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleFiles?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduleTableCalculation?: FieldPolicy<any> | FieldReadFunction<any>,
	sendAditResetPasswordLink?: FieldPolicy<any> | FieldReadFunction<any>,
	sendDeclarationArrivalNotification?: FieldPolicy<any> | FieldReadFunction<any>,
	sendWDResetPasswordLink?: FieldPolicy<any> | FieldReadFunction<any>,
	transmitFile?: FieldPolicy<any> | FieldReadFunction<any>,
	triggerArticlesExtraction?: FieldPolicy<any> | FieldReadFunction<any>,
	unlinkAddressACS?: FieldPolicy<any> | FieldReadFunction<any>,
	update_address?: FieldPolicy<any> | FieldReadFunction<any>,
	update_address_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_address_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_address_override?: FieldPolicy<any> | FieldReadFunction<any>,
	update_address_override_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_address_override_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bill_detail?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bill_detail_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_bill_detail_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_containers?: FieldPolicy<any> | FieldReadFunction<any>,
	update_containers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_containers_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_discussions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_discussions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_message?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_message_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_request_address?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_request_address_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_request_address_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_request_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_request_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_special_mentions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_special_mentions_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_task?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_task_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_declaration_task_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_doc_annotation?: FieldPolicy<any> | FieldReadFunction<any>,
	update_doc_annotation_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_doc_annotation_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_labels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_labels_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_type_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_type_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_type_tenant_settings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_document_type_tenant_settings_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_extraction_config?: FieldPolicy<any> | FieldReadFunction<any>,
	update_extraction_config_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_extraction_config_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_file_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_goods_item?: FieldPolicy<any> | FieldReadFunction<any>,
	update_goods_item_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_goods_item_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_import_list_trigger?: FieldPolicy<any> | FieldReadFunction<any>,
	update_import_list_trigger_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_import_list_trigger_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_model_retrain?: FieldPolicy<any> | FieldReadFunction<any>,
	update_model_retrain_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_model_retrain_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_packagings?: FieldPolicy<any> | FieldReadFunction<any>,
	update_packagings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_packagings_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_page?: FieldPolicy<any> | FieldReadFunction<any>,
	update_page_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_page_extract?: FieldPolicy<any> | FieldReadFunction<any>,
	update_page_extract_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_page_extract_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_page_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_previous_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	update_previous_documents_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_previous_documents_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_produced_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	update_produced_documents_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_produced_documents_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_service_tariff?: FieldPolicy<any> | FieldReadFunction<any>,
	update_service_tariff_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_setting_value?: FieldPolicy<any> | FieldReadFunction<any>,
	update_setting_value_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_setting_value_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	update_tenant_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_tenant_many?: FieldPolicy<any> | FieldReadFunction<any>,
	update_user_pp?: FieldPolicy<any> | FieldReadFunction<any>,
	update_user_pp_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	update_user_pp_many?: FieldPolicy<any> | FieldReadFunction<any>,
	updateAditUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFileNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	updateNotificationTrigger?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePassword?: FieldPolicy<any> | FieldReadFunction<any>,
	updateWDUser?: FieldPolicy<any> | FieldReadFunction<any>,
	upsertAddressByReference?: FieldPolicy<any> | FieldReadFunction<any>,
	validateFileNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	validateJourneyNumber?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressVisibilityKeySpecifier = ('addressId' | 'visibleAddress' | AddressVisibilityKeySpecifier)[];
export type AddressVisibilityFieldPolicy = {
	addressId?: FieldPolicy<any> | FieldReadFunction<any>,
	visibleAddress?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserResponseKeySpecifier = ('data' | 'error' | 'success' | UserResponseKeySpecifier)[];
export type UserResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationTriggerKeySpecifier = ('config' | 'creationDate' | 'creationUser' | 'displayName' | 'id' | 'lastModifiedDate' | 'lastModifiedUser' | 'meta' | 'type' | NotificationTriggerKeySpecifier)[];
export type NotificationTriggerFieldPolicy = {
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	creationDate?: FieldPolicy<any> | FieldReadFunction<any>,
	creationUser?: FieldPolicy<any> | FieldReadFunction<any>,
	displayName?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedDate?: FieldPolicy<any> | FieldReadFunction<any>,
	lastModifiedUser?: FieldPolicy<any> | FieldReadFunction<any>,
	meta?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeclarationLabelMutationOutputKeySpecifier = ('drNo' | 'fileId' | 'labelId' | DeclarationLabelMutationOutputKeySpecifier)[];
export type DeclarationLabelMutationOutputFieldPolicy = {
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	labelId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type NotificationLabelMutationOutputKeySpecifier = ('drNo' | 'fileId' | 'labelId' | NotificationLabelMutationOutputKeySpecifier)[];
export type NotificationLabelMutationOutputFieldPolicy = {
	drNo?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	labelId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDeclarationMessageResponseKeySpecifier = ('affected_rows' | CreateDeclarationMessageResponseKeySpecifier)[];
export type CreateDeclarationMessageResponseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDeclarationReqResponseKeySpecifier = ('documentIds' | 'error' | 'fileId' | 'success' | CreateDeclarationReqResponseKeySpecifier)[];
export type CreateDeclarationReqResponseFieldPolicy = {
	documentIds?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDeclarationRequestResponseKeySpecifier = ('documentIds' | 'error' | 'fileId' | 'success' | CreateDeclarationRequestResponseKeySpecifier)[];
export type CreateDeclarationRequestResponseFieldPolicy = {
	documentIds?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	fileId?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateDocumentResponseKeySpecifier = ('documentId' | 'error' | 'success' | CreateDocumentResponseKeySpecifier)[];
export type CreateDocumentResponseFieldPolicy = {
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateEmptyDocumentResponseKeySpecifier = ('documentId' | 'error' | 'pageIds' | CreateEmptyDocumentResponseKeySpecifier)[];
export type CreateEmptyDocumentResponseFieldPolicy = {
	documentId?: FieldPolicy<any> | FieldReadFunction<any>,
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	pageIds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type address_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | address_mutation_responseKeySpecifier)[];
export type address_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type containers_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | containers_mutation_responseKeySpecifier)[];
export type containers_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | declaration_mutation_responseKeySpecifier)[];
export type declaration_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussion_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | declaration_discussion_mutation_responseKeySpecifier)[];
export type declaration_discussion_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_message_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | declaration_message_mutation_responseKeySpecifier)[];
export type declaration_message_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_request_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | declaration_request_mutation_responseKeySpecifier)[];
export type declaration_request_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_request_address_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | declaration_request_address_mutation_responseKeySpecifier)[];
export type declaration_request_address_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_special_mentions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | declaration_special_mentions_mutation_responseKeySpecifier)[];
export type declaration_special_mentions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type doc_annotation_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | doc_annotation_mutation_responseKeySpecifier)[];
export type doc_annotation_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | document_mutation_responseKeySpecifier)[];
export type document_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_labels_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | document_labels_mutation_responseKeySpecifier)[];
export type document_labels_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_type_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | document_type_mutation_responseKeySpecifier)[];
export type document_type_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_type_tenant_settings_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | document_type_tenant_settings_mutation_responseKeySpecifier)[];
export type document_type_tenant_settings_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type file_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | file_mutation_responseKeySpecifier)[];
export type file_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type goods_item_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | goods_item_mutation_responseKeySpecifier)[];
export type goods_item_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type import_list_trigger_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | import_list_trigger_mutation_responseKeySpecifier)[];
export type import_list_trigger_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type packagings_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | packagings_mutation_responseKeySpecifier)[];
export type packagings_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type page_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | page_mutation_responseKeySpecifier)[];
export type page_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type page_extract_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | page_extract_mutation_responseKeySpecifier)[];
export type page_extract_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type previous_documents_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | previous_documents_mutation_responseKeySpecifier)[];
export type previous_documents_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type produced_documents_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | produced_documents_mutation_responseKeySpecifier)[];
export type produced_documents_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type service_tariff_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | service_tariff_mutation_responseKeySpecifier)[];
export type service_tariff_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type setting_value_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | setting_value_mutation_responseKeySpecifier)[];
export type setting_value_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type user_pp_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | user_pp_mutation_responseKeySpecifier)[];
export type user_pp_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type address_override_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | address_override_mutation_responseKeySpecifier)[];
export type address_override_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type bill_detail_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | bill_detail_mutation_responseKeySpecifier)[];
export type bill_detail_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type document_label_org_id_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | document_label_org_id_mutation_responseKeySpecifier)[];
export type document_label_org_id_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type model_retrain_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | model_retrain_mutation_responseKeySpecifier)[];
export type model_retrain_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type tenant_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | tenant_mutation_responseKeySpecifier)[];
export type tenant_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type user_org_id_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | user_org_id_mutation_responseKeySpecifier)[];
export type user_org_id_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressMappingEntityKeySpecifier = ('address_id' | 'address_override_id' | 'is_cross_address' | 'tenant_id' | AddressMappingEntityKeySpecifier)[];
export type AddressMappingEntityFieldPolicy = {
	address_id?: FieldPolicy<any> | FieldReadFunction<any>,
	address_override_id?: FieldPolicy<any> | FieldReadFunction<any>,
	is_cross_address?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_id?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TransmitFileResponseKeySpecifier = ('error' | 'fileIds' | 'success' | TransmitFileResponseKeySpecifier)[];
export type TransmitFileResponseFieldPolicy = {
	error?: FieldPolicy<any> | FieldReadFunction<any>,
	fileIds?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_discussions_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | declaration_discussions_mutation_responseKeySpecifier)[];
export type declaration_discussions_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type declaration_task_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | declaration_task_mutation_responseKeySpecifier)[];
export type declaration_task_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type extraction_config_mutation_responseKeySpecifier = ('affected_rows' | 'returning' | extraction_config_mutation_responseKeySpecifier)[];
export type extraction_config_mutation_responseFieldPolicy = {
	affected_rows?: FieldPolicy<any> | FieldReadFunction<any>,
	returning?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReassignFileNumberResponseKeySpecifier = ('file_id' | 'file_status' | 'identification' | ReassignFileNumberResponseKeySpecifier)[];
export type ReassignFileNumberResponseFieldPolicy = {
	file_id?: FieldPolicy<any> | FieldReadFunction<any>,
	file_status?: FieldPolicy<any> | FieldReadFunction<any>,
	identification?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidateFileNumberResponseKeySpecifier = ('data' | 'error_code' | 'error_description' | ValidateFileNumberResponseKeySpecifier)[];
export type ValidateFileNumberResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	error_code?: FieldPolicy<any> | FieldReadFunction<any>,
	error_description?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShipmentDataKeySpecifier = ('consignee' | 'consignor' | 'importer' | 'lines' | 'orderedBy' | 'orgId' | 'shipmentNumber' | 'shipper' | 'traffic' | ShipmentDataKeySpecifier)[];
export type ShipmentDataFieldPolicy = {
	consignee?: FieldPolicy<any> | FieldReadFunction<any>,
	consignor?: FieldPolicy<any> | FieldReadFunction<any>,
	importer?: FieldPolicy<any> | FieldReadFunction<any>,
	lines?: FieldPolicy<any> | FieldReadFunction<any>,
	orderedBy?: FieldPolicy<any> | FieldReadFunction<any>,
	orgId?: FieldPolicy<any> | FieldReadFunction<any>,
	shipmentNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	shipper?: FieldPolicy<any> | FieldReadFunction<any>,
	traffic?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShipmentInfoAddressKeySpecifier = ('adrID' | 'city' | 'consigneeAdrID' | 'country' | 'name' | 'postalCode' | 'state' | 'street' | ShipmentInfoAddressKeySpecifier)[];
export type ShipmentInfoAddressFieldPolicy = {
	adrID?: FieldPolicy<any> | FieldReadFunction<any>,
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	consigneeAdrID?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	street?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LineKeySpecifier = ('grossWeight' | 'packaging' | 'quantity' | LineKeySpecifier)[];
export type LineFieldPolicy = {
	grossWeight?: FieldPolicy<any> | FieldReadFunction<any>,
	packaging?: FieldPolicy<any> | FieldReadFunction<any>,
	quantity?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidateJourneyNumberResponseKeySpecifier = ('data' | 'error_code' | 'error_description' | ValidateJourneyNumberResponseKeySpecifier)[];
export type ValidateJourneyNumberResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	error_code?: FieldPolicy<any> | FieldReadFunction<any>,
	error_description?: FieldPolicy<any> | FieldReadFunction<any>
};
export type subscription_rootKeySpecifier = ('address' | 'address_by_pk' | 'address_groups' | 'address_groups_stream' | 'address_mapping' | 'address_mapping_by_pk' | 'address_mapping_stream' | 'address_override' | 'address_override_by_pk' | 'address_override_stream' | 'address_stream' | 'address_type' | 'address_type_by_pk' | 'address_type_stream' | 'addresses' | 'addresses_stream' | 'ai_stats_dt_type' | 'ai_stats_dt_type_stream' | 'ai_stats_type' | 'ai_stats_type_stream' | 'annotation_provider' | 'annotation_provider_by_pk' | 'annotation_provider_stream' | 'annotation_type' | 'annotation_type_by_pk' | 'annotation_type_stream' | 'api_key' | 'api_key_by_pk' | 'api_key_stream' | 'arrival_type' | 'arrival_type_by_pk' | 'arrival_type_stream' | 'article' | 'article_by_pk' | 'article_stream' | 'bill' | 'bill_aggregate' | 'bill_by_pk' | 'bill_detail' | 'bill_detail_by_pk' | 'bill_detail_stream' | 'bill_stream' | 'clearance_type' | 'clearance_type_by_pk' | 'clearance_type_stream' | 'containers' | 'containers_by_pk' | 'containers_stream' | 'count_type' | 'count_type_stream' | 'customs_office' | 'customs_office_by_pk' | 'customs_office_stream' | 'customs_offices' | 'customs_offices_by_pk' | 'customs_offices_stream' | 'declaration' | 'declaration_by_pk' | 'declaration_discussion' | 'declaration_discussion_aggregate' | 'declaration_discussion_by_pk' | 'declaration_discussion_stream' | 'declaration_discussions' | 'declaration_discussions_stream' | 'declaration_document' | 'declaration_document_by_pk' | 'declaration_document_stream' | 'declaration_labels' | 'declaration_labels_by_pk' | 'declaration_labels_stream' | 'declaration_message' | 'declaration_message_aggregate' | 'declaration_message_by_pk' | 'declaration_message_stream' | 'declaration_request' | 'declaration_request_address' | 'declaration_request_address_ai' | 'declaration_request_address_ai_by_pk' | 'declaration_request_address_ai_stream' | 'declaration_request_address_by_pk' | 'declaration_request_address_stream' | 'declaration_request_by_pk' | 'declaration_request_labels' | 'declaration_request_labels_by_pk' | 'declaration_request_labels_stream' | 'declaration_request_stream' | 'declaration_requests' | 'declaration_requests_stream' | 'declaration_search' | 'declaration_search_stream' | 'declaration_special_mentions' | 'declaration_special_mentions_by_pk' | 'declaration_special_mentions_stream' | 'declaration_status' | 'declaration_status_by_pk' | 'declaration_status_stream' | 'declaration_stream' | 'declaration_task' | 'declaration_task_aggregate' | 'declaration_task_by_pk' | 'declaration_task_stream' | 'declaration_tasks' | 'declaration_tasks_obj' | 'declaration_tasks_obj_stream' | 'declaration_tasks_stream' | 'declaration_type' | 'declaration_type_by_pk' | 'declaration_type_stream' | 'discussion_changes' | 'discussion_changes_stream' | 'doc_annotation' | 'doc_annotation_by_pk' | 'doc_annotation_stream' | 'doc_search_type' | 'doc_search_type_stream' | 'doc_stats_type' | 'doc_stats_type_stream' | 'docs_for_validation' | 'docs_for_validation_stream' | 'document' | 'document_aggregate' | 'document_by_pk' | 'document_extension' | 'document_extension_by_pk' | 'document_extension_stream' | 'document_flag' | 'document_flag_by_pk' | 'document_flag_stream' | 'document_label_org_id' | 'document_label_org_id_by_pk' | 'document_label_org_id_stream' | 'document_labels' | 'document_labels_by_pk' | 'document_labels_stream' | 'document_page' | 'document_page_aggregate' | 'document_page_by_pk' | 'document_page_stream' | 'document_status' | 'document_status_by_pk' | 'document_status_stream' | 'document_stream' | 'document_type' | 'document_type_aggregate' | 'document_type_all_tenant_settings' | 'document_type_all_tenant_settings_stream' | 'document_type_by_pk' | 'document_type_stream' | 'document_type_tenant_settings' | 'document_type_tenant_settings_by_pk' | 'document_type_tenant_settings_stream' | 'dr_stats' | 'dr_stats_stream' | 'edec_countries' | 'edec_countries_by_pk' | 'edec_countries_stream' | 'edec_customs_offices' | 'edec_customs_offices_by_pk' | 'edec_customs_offices_stream' | 'edec_domains' | 'edec_domains_by_pk' | 'edec_domains_stream' | 'edec_tariff_commodity_code' | 'edec_tariff_commodity_code_by_pk' | 'edec_tariff_commodity_code_stream' | 'edec_tariff_statistical_code' | 'edec_tariff_statistical_code_by_pk' | 'edec_tariff_statistical_code_stream' | 'email_search_type' | 'email_search_type_aggregate' | 'email_search_type_stream' | 'extract_type' | 'extract_type_by_pk' | 'extract_type_stream' | 'extraction_config' | 'extraction_config_by_pk' | 'extraction_config_stream' | 'file' | 'file_aggregate' | 'file_by_pk' | 'file_stats_type' | 'file_stats_type_stream' | 'file_stream' | 'file_type' | 'file_type_by_pk' | 'file_type_stream' | 'goods_item' | 'goods_item_aggregate' | 'goods_item_by_pk' | 'goods_item_special_mentions' | 'goods_item_special_mentions_aggregate' | 'goods_item_special_mentions_by_pk' | 'goods_item_special_mentions_stream' | 'goods_item_stream' | 'goods_items_for_drs' | 'goods_items_for_drs_stream' | 'import_list_trigger' | 'import_list_trigger_aggregate' | 'import_list_trigger_by_pk' | 'import_list_trigger_stream' | 'intf_dr_payment_info' | 'intf_dr_payment_info_stream' | 'json_type' | 'json_type_stream' | 'kc_users' | 'kc_users_stream' | 'max_date_type' | 'max_date_type_stream' | 'model_retrain' | 'model_retrain_by_pk' | 'model_retrain_stream' | 'org_id' | 'org_id_by_pk' | 'org_id_stream' | 'org_ids' | 'org_ids_stream' | 'org_params' | 'org_params_by_pk' | 'org_params_org_id' | 'org_params_org_id_stream' | 'org_params_stream' | 'packagings' | 'packagings_aggregate' | 'packagings_by_pk' | 'packagings_stream' | 'page' | 'page_by_pk' | 'page_extract' | 'page_extract_by_pk' | 'page_extract_stream' | 'page_status' | 'page_status_by_pk' | 'page_status_stream' | 'page_stream' | 'pages_m2m_cache' | 'pages_m2m_cache_aggregate' | 'pages_m2m_cache_stream' | 'permits' | 'permits_aggregate' | 'permits_by_pk' | 'permits_stream' | 'pp_address_groups' | 'pp_addresses' | 'pp_ai_stats' | 'pp_ai_stats_dt' | 'pp_check_json_param' | 'pp_declaration_request' | 'pp_declaration_tasks' | 'pp_declaration_tasks_agg' | 'pp_declaration_tasks_obj' | 'pp_declarations' | 'pp_delete_declaration_requests' | 'pp_doc_max_date_hs' | 'pp_doc_max_date_v2' | 'pp_doc_search' | 'pp_doc_search_hs' | 'pp_doc_stats' | 'pp_docs_for_validation' | 'pp_document' | 'pp_document_aggregate' | 'pp_document_flag' | 'pp_document_labels' | 'pp_dr_max_date' | 'pp_dr_stats' | 'pp_email_search' | 'pp_email_search_aggregate' | 'pp_email_search_hs' | 'pp_email_search_hs_aggregate' | 'pp_file_max_date_hs' | 'pp_file_max_date_v2' | 'pp_file_search' | 'pp_file_search_hs' | 'pp_file_stats' | 'pp_hasura_session' | 'pp_kc_users' | 'pp_last_doc_in_dr' | 'pp_last_doc_in_dr_aggregate' | 'pp_menu_indicators' | 'pp_org_id_delete' | 'pp_org_id_insert' | 'pp_org_id_update' | 'pp_org_ids' | 'pp_page_extract_grids_text' | 'pp_page_extract_text_fragment' | 'pp_page_extract_text_fragment_v2' | 'pp_tenants' | 'pp_types_file_search' | 'pp_types_file_search_stream' | 'pp_user_org_id' | 'pp_user_search' | 'pp_view_document_history' | 'pp_view_file_history' | 'previous_documents' | 'previous_documents_by_pk' | 'previous_documents_stream' | 'produced_documents' | 'produced_documents_aggregate' | 'produced_documents_by_pk' | 'produced_documents_stream' | 'report' | 'report_aggregate' | 'report_by_pk' | 'report_stream' | 'service' | 'service_by_pk' | 'service_rate' | 'service_rate_stream' | 'service_stream' | 'service_tariff' | 'service_tariff_aggregate' | 'service_tariff_stream' | 'setting' | 'setting_by_pk' | 'setting_group' | 'setting_group_by_pk' | 'setting_group_stream' | 'setting_stream' | 'setting_value' | 'setting_value_by_pk' | 'setting_value_stream' | 'tariff_number_description' | 'tariff_number_description_by_pk' | 'tariff_number_description_stream' | 'task_type' | 'task_type_by_pk' | 'task_type_stream' | 'tenant' | 'tenant_by_pk' | 'tenant_stream' | 'tenants' | 'tenants_stream' | 'transitdoc_type_descr' | 'transitdoc_type_descr_stream' | 'user_org_id' | 'user_org_id_by_pk' | 'user_org_id_stream' | 'user_pp' | 'user_pp_by_pk' | 'user_pp_stream' | 'user_search_type' | 'user_search_type_stream' | 'view_document_history' | 'view_document_history_stream' | 'view_file_history' | 'view_file_history_stream' | 'view_history' | 'view_history_stream' | 'vw_documents' | 'vw_documents_stream' | 'vw_finished_files' | 'vw_finished_files_stream' | subscription_rootKeySpecifier)[];
export type subscription_rootFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	address_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	address_groups?: FieldPolicy<any> | FieldReadFunction<any>,
	address_groups_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	address_mapping?: FieldPolicy<any> | FieldReadFunction<any>,
	address_mapping_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	address_mapping_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	address_override?: FieldPolicy<any> | FieldReadFunction<any>,
	address_override_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	address_override_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	address_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	address_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ai_stats_dt_type?: FieldPolicy<any> | FieldReadFunction<any>,
	ai_stats_dt_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	ai_stats_type?: FieldPolicy<any> | FieldReadFunction<any>,
	ai_stats_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_provider?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_provider_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_provider_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_type?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	annotation_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	api_key?: FieldPolicy<any> | FieldReadFunction<any>,
	api_key_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	api_key_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	arrival_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	article?: FieldPolicy<any> | FieldReadFunction<any>,
	article_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	article_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bill?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_detail?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_detail_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_detail_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	bill_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	clearance_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	containers?: FieldPolicy<any> | FieldReadFunction<any>,
	containers_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	containers_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	count_type?: FieldPolicy<any> | FieldReadFunction<any>,
	count_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_office?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_office_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_office_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_offices?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_offices_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	customs_offices_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussion?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussion_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussion_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussion_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussions?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_discussions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_document?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_document_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_document_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_labels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_labels_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_message?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_message_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_message_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_message_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address_ai?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address_ai_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address_ai_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_address_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_labels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_labels_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_request_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_requests?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_requests_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_search?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_search_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_special_mentions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_special_mentions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_status_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_task?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_task_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_task_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_task_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_tasks_obj?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_tasks_obj_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_tasks_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	declaration_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_changes?: FieldPolicy<any> | FieldReadFunction<any>,
	discussion_changes_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_annotation?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_annotation_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_annotation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_search_type?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_search_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_stats_type?: FieldPolicy<any> | FieldReadFunction<any>,
	doc_stats_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	docs_for_validation?: FieldPolicy<any> | FieldReadFunction<any>,
	docs_for_validation_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document?: FieldPolicy<any> | FieldReadFunction<any>,
	document_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	document_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_extension_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flag?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flag_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_flag_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_label_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	document_label_org_id_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_label_org_id_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	document_labels_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_labels_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_page?: FieldPolicy<any> | FieldReadFunction<any>,
	document_page_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	document_page_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_page_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_status_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_all_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_all_tenant_settings_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_tenant_settings?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_tenant_settings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	document_type_tenant_settings_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	dr_stats_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_countries?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_countries_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_countries_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_customs_offices?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_customs_offices_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_customs_offices_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_domains?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_domains_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_domains_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_commodity_code?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_commodity_code_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_commodity_code_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_statistical_code?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_statistical_code_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	edec_tariff_statistical_code_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	email_search_type?: FieldPolicy<any> | FieldReadFunction<any>,
	email_search_type_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	email_search_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	extract_type?: FieldPolicy<any> | FieldReadFunction<any>,
	extract_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	extract_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_config?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_config_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	extraction_config_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	file?: FieldPolicy<any> | FieldReadFunction<any>,
	file_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	file_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	file_stats_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file_stats_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	file_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	file_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_special_mentions_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_item_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_items_for_drs?: FieldPolicy<any> | FieldReadFunction<any>,
	goods_items_for_drs_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_trigger?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_trigger_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_trigger_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	import_list_trigger_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	intf_dr_payment_info?: FieldPolicy<any> | FieldReadFunction<any>,
	intf_dr_payment_info_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	json_type?: FieldPolicy<any> | FieldReadFunction<any>,
	json_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	kc_users?: FieldPolicy<any> | FieldReadFunction<any>,
	kc_users_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	max_date_type?: FieldPolicy<any> | FieldReadFunction<any>,
	max_date_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	model_retrain?: FieldPolicy<any> | FieldReadFunction<any>,
	model_retrain_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	model_retrain_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	org_id_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	org_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	org_ids_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params_org_id_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	org_params_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	packagings_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	page?: FieldPolicy<any> | FieldReadFunction<any>,
	page_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	page_extract?: FieldPolicy<any> | FieldReadFunction<any>,
	page_extract_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	page_extract_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	page_status_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	page_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m_cache?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m_cache_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pages_m2m_cache_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	permits?: FieldPolicy<any> | FieldReadFunction<any>,
	permits_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	permits_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	permits_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_address_groups?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_ai_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_ai_stats_dt?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_check_json_param?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_request?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_tasks?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_tasks_agg?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declaration_tasks_obj?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_declarations?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_delete_declaration_requests?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_max_date_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_max_date_v2?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_search_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_doc_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_docs_for_validation?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_document?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_document_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_document_flag?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_document_labels?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_dr_max_date?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_dr_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_email_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_email_search_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_email_search_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_email_search_hs_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_max_date_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_max_date_v2?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_search_hs?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_file_stats?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_hasura_session?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_kc_users?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_last_doc_in_dr?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_last_doc_in_dr_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_menu_indicators?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_org_id_delete?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_org_id_insert?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_org_id_update?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_org_ids?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_page_extract_grids_text?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_page_extract_text_fragment?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_page_extract_text_fragment_v2?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_tenants?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_types_file_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_types_file_search_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_user_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_user_search?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_view_document_history?: FieldPolicy<any> | FieldReadFunction<any>,
	pp_view_file_history?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_documents_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	previous_documents_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	produced_documents_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	report?: FieldPolicy<any> | FieldReadFunction<any>,
	report_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	report_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	report_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	service?: FieldPolicy<any> | FieldReadFunction<any>,
	service_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	service_rate?: FieldPolicy<any> | FieldReadFunction<any>,
	service_rate_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	service_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	service_tariff?: FieldPolicy<any> | FieldReadFunction<any>,
	service_tariff_aggregate?: FieldPolicy<any> | FieldReadFunction<any>,
	service_tariff_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	setting?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_group?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_group_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_group_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_value?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_value_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	setting_value_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	tariff_number_description?: FieldPolicy<any> | FieldReadFunction<any>,
	tariff_number_description_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	tariff_number_description_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	task_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	tenant_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	tenants?: FieldPolicy<any> | FieldReadFunction<any>,
	tenants_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	transitdoc_type_descr?: FieldPolicy<any> | FieldReadFunction<any>,
	transitdoc_type_descr_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	user_org_id?: FieldPolicy<any> | FieldReadFunction<any>,
	user_org_id_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	user_org_id_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp_by_pk?: FieldPolicy<any> | FieldReadFunction<any>,
	user_pp_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	user_search_type?: FieldPolicy<any> | FieldReadFunction<any>,
	user_search_type_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	view_document_history?: FieldPolicy<any> | FieldReadFunction<any>,
	view_document_history_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	view_file_history?: FieldPolicy<any> | FieldReadFunction<any>,
	view_file_history_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	view_history?: FieldPolicy<any> | FieldReadFunction<any>,
	view_history_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	vw_documents?: FieldPolicy<any> | FieldReadFunction<any>,
	vw_documents_stream?: FieldPolicy<any> | FieldReadFunction<any>,
	vw_finished_files?: FieldPolicy<any> | FieldReadFunction<any>,
	vw_finished_files_stream?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	query_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | query_rootKeySpecifier | (() => undefined | query_rootKeySpecifier),
		fields?: query_rootFieldPolicy,
	},
	DeclarationGoodsItems?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationGoodsItemsKeySpecifier | (() => undefined | DeclarationGoodsItemsKeySpecifier),
		fields?: DeclarationGoodsItemsFieldPolicy,
	},
	AddressACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressACSKeySpecifier | (() => undefined | AddressACSKeySpecifier),
		fields?: AddressACSFieldPolicy,
	},
	AddressTypeACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressTypeACSKeySpecifier | (() => undefined | AddressTypeACSKeySpecifier),
		fields?: AddressTypeACSFieldPolicy,
	},
	EdecCustomsOffices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EdecCustomsOfficesKeySpecifier | (() => undefined | EdecCustomsOfficesKeySpecifier),
		fields?: EdecCustomsOfficesFieldPolicy,
	},
	DeclarationEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationEntityKeySpecifier | (() => undefined | DeclarationEntityKeySpecifier),
		fields?: DeclarationEntityFieldPolicy,
	},
	GoodsItemACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GoodsItemACSKeySpecifier | (() => undefined | GoodsItemACSKeySpecifier),
		fields?: GoodsItemACSFieldPolicy,
	},
	PackagingEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PackagingEntityKeySpecifier | (() => undefined | PackagingEntityKeySpecifier),
		fields?: PackagingEntityFieldPolicy,
	},
	PreviousDocumentEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PreviousDocumentEntityKeySpecifier | (() => undefined | PreviousDocumentEntityKeySpecifier),
		fields?: PreviousDocumentEntityFieldPolicy,
	},
	DeclarationSpecialMentionEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationSpecialMentionEntityKeySpecifier | (() => undefined | DeclarationSpecialMentionEntityKeySpecifier),
		fields?: DeclarationSpecialMentionEntityFieldPolicy,
	},
	DeclarationLabel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationLabelKeySpecifier | (() => undefined | DeclarationLabelKeySpecifier),
		fields?: DeclarationLabelFieldPolicy,
	},
	DeclarationRequestACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationRequestACSKeySpecifier | (() => undefined | DeclarationRequestACSKeySpecifier),
		fields?: DeclarationRequestACSFieldPolicy,
	},
	UserPP?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserPPKeySpecifier | (() => undefined | UserPPKeySpecifier),
		fields?: UserPPFieldPolicy,
	},
	ModuleEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ModuleEntityKeySpecifier | (() => undefined | ModuleEntityKeySpecifier),
		fields?: ModuleEntityFieldPolicy,
	},
	OrgIdEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrgIdEntityKeySpecifier | (() => undefined | OrgIdEntityKeySpecifier),
		fields?: OrgIdEntityFieldPolicy,
	},
	Role?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleKeySpecifier | (() => undefined | RoleKeySpecifier),
		fields?: RoleFieldPolicy,
	},
	GrantedPermission?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GrantedPermissionKeySpecifier | (() => undefined | GrantedPermissionKeySpecifier),
		fields?: GrantedPermissionFieldPolicy,
	},
	PermissionEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermissionEntityKeySpecifier | (() => undefined | PermissionEntityKeySpecifier),
		fields?: PermissionEntityFieldPolicy,
	},
	TenantEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TenantEntityKeySpecifier | (() => undefined | TenantEntityKeySpecifier),
		fields?: TenantEntityFieldPolicy,
	},
	DocumentTypeTenantSettingsACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentTypeTenantSettingsACSKeySpecifier | (() => undefined | DocumentTypeTenantSettingsACSKeySpecifier),
		fields?: DocumentTypeTenantSettingsACSFieldPolicy,
	},
	UserModuleEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserModuleEntityKeySpecifier | (() => undefined | UserModuleEntityKeySpecifier),
		fields?: UserModuleEntityFieldPolicy,
	},
	Documents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentsKeySpecifier | (() => undefined | DocumentsKeySpecifier),
		fields?: DocumentsFieldPolicy,
	},
	CustomsResponseData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomsResponseDataKeySpecifier | (() => undefined | CustomsResponseDataKeySpecifier),
		fields?: CustomsResponseDataFieldPolicy,
	},
	EvvAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EvvAddressKeySpecifier | (() => undefined | EvvAddressKeySpecifier),
		fields?: EvvAddressFieldPolicy,
	},
	DocumentType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentTypeKeySpecifier | (() => undefined | DocumentTypeKeySpecifier),
		fields?: DocumentTypeFieldPolicy,
	},
	DocumentTypeTenantSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentTypeTenantSettingsKeySpecifier | (() => undefined | DocumentTypeTenantSettingsKeySpecifier),
		fields?: DocumentTypeTenantSettingsFieldPolicy,
	},
	DocumentPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentPageKeySpecifier | (() => undefined | DocumentPageKeySpecifier),
		fields?: DocumentPageFieldPolicy,
	},
	PageACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PageACSKeySpecifier | (() => undefined | PageACSKeySpecifier),
		fields?: PageACSFieldPolicy,
	},
	GoodsItemSpecialMentionEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GoodsItemSpecialMentionEntityKeySpecifier | (() => undefined | GoodsItemSpecialMentionEntityKeySpecifier),
		fields?: GoodsItemSpecialMentionEntityFieldPolicy,
	},
	PermitEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PermitEntityKeySpecifier | (() => undefined | PermitEntityKeySpecifier),
		fields?: PermitEntityFieldPolicy,
	},
	ProducedDocumentEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProducedDocumentEntityKeySpecifier | (() => undefined | ProducedDocumentEntityKeySpecifier),
		fields?: ProducedDocumentEntityFieldPolicy,
	},
	Count?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CountKeySpecifier | (() => undefined | CountKeySpecifier),
		fields?: CountFieldPolicy,
	},
	address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | addressKeySpecifier | (() => undefined | addressKeySpecifier),
		fields?: addressFieldPolicy,
	},
	address_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | address_typeKeySpecifier | (() => undefined | address_typeKeySpecifier),
		fields?: address_typeFieldPolicy,
	},
	user_pp?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | user_ppKeySpecifier | (() => undefined | user_ppKeySpecifier),
		fields?: user_ppFieldPolicy,
	},
	tenant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | tenantKeySpecifier | (() => undefined | tenantKeySpecifier),
		fields?: tenantFieldPolicy,
	},
	api_key?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | api_keyKeySpecifier | (() => undefined | api_keyKeySpecifier),
		fields?: api_keyFieldPolicy,
	},
	declaration_labels?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_labelsKeySpecifier | (() => undefined | declaration_labelsKeySpecifier),
		fields?: declaration_labelsFieldPolicy,
	},
	document_labels?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_labelsKeySpecifier | (() => undefined | document_labelsKeySpecifier),
		fields?: document_labelsFieldPolicy,
	},
	document_label_org_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_label_org_idKeySpecifier | (() => undefined | document_label_org_idKeySpecifier),
		fields?: document_label_org_idFieldPolicy,
	},
	org_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | org_idKeySpecifier | (() => undefined | org_idKeySpecifier),
		fields?: org_idFieldPolicy,
	},
	document?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | documentKeySpecifier | (() => undefined | documentKeySpecifier),
		fields?: documentFieldPolicy,
	},
	annotation_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | annotation_typeKeySpecifier | (() => undefined | annotation_typeKeySpecifier),
		fields?: annotation_typeFieldPolicy,
	},
	annotation_provider?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | annotation_providerKeySpecifier | (() => undefined | annotation_providerKeySpecifier),
		fields?: annotation_providerFieldPolicy,
	},
	document_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_typeKeySpecifier | (() => undefined | document_typeKeySpecifier),
		fields?: document_typeFieldPolicy,
	},
	document_type_all_tenant_settings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_type_all_tenant_settingsKeySpecifier | (() => undefined | document_type_all_tenant_settingsKeySpecifier),
		fields?: document_type_all_tenant_settingsFieldPolicy,
	},
	document_type_tenant_settings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_type_tenant_settingsKeySpecifier | (() => undefined | document_type_tenant_settingsKeySpecifier),
		fields?: document_type_tenant_settingsFieldPolicy,
	},
	document_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_aggregateKeySpecifier | (() => undefined | document_aggregateKeySpecifier),
		fields?: document_aggregateFieldPolicy,
	},
	document_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_aggregate_fieldsKeySpecifier | (() => undefined | document_aggregate_fieldsKeySpecifier),
		fields?: document_aggregate_fieldsFieldPolicy,
	},
	document_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_avg_fieldsKeySpecifier | (() => undefined | document_avg_fieldsKeySpecifier),
		fields?: document_avg_fieldsFieldPolicy,
	},
	document_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_max_fieldsKeySpecifier | (() => undefined | document_max_fieldsKeySpecifier),
		fields?: document_max_fieldsFieldPolicy,
	},
	document_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_min_fieldsKeySpecifier | (() => undefined | document_min_fieldsKeySpecifier),
		fields?: document_min_fieldsFieldPolicy,
	},
	document_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_stddev_fieldsKeySpecifier | (() => undefined | document_stddev_fieldsKeySpecifier),
		fields?: document_stddev_fieldsFieldPolicy,
	},
	document_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_stddev_pop_fieldsKeySpecifier | (() => undefined | document_stddev_pop_fieldsKeySpecifier),
		fields?: document_stddev_pop_fieldsFieldPolicy,
	},
	document_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_stddev_samp_fieldsKeySpecifier | (() => undefined | document_stddev_samp_fieldsKeySpecifier),
		fields?: document_stddev_samp_fieldsFieldPolicy,
	},
	document_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_sum_fieldsKeySpecifier | (() => undefined | document_sum_fieldsKeySpecifier),
		fields?: document_sum_fieldsFieldPolicy,
	},
	document_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_var_pop_fieldsKeySpecifier | (() => undefined | document_var_pop_fieldsKeySpecifier),
		fields?: document_var_pop_fieldsFieldPolicy,
	},
	document_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_var_samp_fieldsKeySpecifier | (() => undefined | document_var_samp_fieldsKeySpecifier),
		fields?: document_var_samp_fieldsFieldPolicy,
	},
	document_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_variance_fieldsKeySpecifier | (() => undefined | document_variance_fieldsKeySpecifier),
		fields?: document_variance_fieldsFieldPolicy,
	},
	article?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | articleKeySpecifier | (() => undefined | articleKeySpecifier),
		fields?: articleFieldPolicy,
	},
	pages_m2m_cache?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cacheKeySpecifier | (() => undefined | pages_m2m_cacheKeySpecifier),
		fields?: pages_m2m_cacheFieldPolicy,
	},
	declaration_task?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_taskKeySpecifier | (() => undefined | declaration_taskKeySpecifier),
		fields?: declaration_taskFieldPolicy,
	},
	file?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | fileKeySpecifier | (() => undefined | fileKeySpecifier),
		fields?: fileFieldPolicy,
	},
	declaration_request?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_requestKeySpecifier | (() => undefined | declaration_requestKeySpecifier),
		fields?: declaration_requestFieldPolicy,
	},
	declaration_request_address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_request_addressKeySpecifier | (() => undefined | declaration_request_addressKeySpecifier),
		fields?: declaration_request_addressFieldPolicy,
	},
	arrival_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | arrival_typeKeySpecifier | (() => undefined | arrival_typeKeySpecifier),
		fields?: arrival_typeFieldPolicy,
	},
	bill_detail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_detailKeySpecifier | (() => undefined | bill_detailKeySpecifier),
		fields?: bill_detailFieldPolicy,
	},
	bill?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | billKeySpecifier | (() => undefined | billKeySpecifier),
		fields?: billFieldPolicy,
	},
	service?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | serviceKeySpecifier | (() => undefined | serviceKeySpecifier),
		fields?: serviceFieldPolicy,
	},
	service_rate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_rateKeySpecifier | (() => undefined | service_rateKeySpecifier),
		fields?: service_rateFieldPolicy,
	},
	clearance_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | clearance_typeKeySpecifier | (() => undefined | clearance_typeKeySpecifier),
		fields?: clearance_typeFieldPolicy,
	},
	customs_offices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customs_officesKeySpecifier | (() => undefined | customs_officesKeySpecifier),
		fields?: customs_officesFieldPolicy,
	},
	declaration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declarationKeySpecifier | (() => undefined | declarationKeySpecifier),
		fields?: declarationFieldPolicy,
	},
	containers?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | containersKeySpecifier | (() => undefined | containersKeySpecifier),
		fields?: containersFieldPolicy,
	},
	declaration_special_mentions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_special_mentionsKeySpecifier | (() => undefined | declaration_special_mentionsKeySpecifier),
		fields?: declaration_special_mentionsFieldPolicy,
	},
	goods_item?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_itemKeySpecifier | (() => undefined | goods_itemKeySpecifier),
		fields?: goods_itemFieldPolicy,
	},
	goods_item_special_mentions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentionsKeySpecifier | (() => undefined | goods_item_special_mentionsKeySpecifier),
		fields?: goods_item_special_mentionsFieldPolicy,
	},
	goods_item_special_mentions_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_aggregateKeySpecifier | (() => undefined | goods_item_special_mentions_aggregateKeySpecifier),
		fields?: goods_item_special_mentions_aggregateFieldPolicy,
	},
	goods_item_special_mentions_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_aggregate_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_aggregate_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_aggregate_fieldsFieldPolicy,
	},
	goods_item_special_mentions_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_avg_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_avg_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_avg_fieldsFieldPolicy,
	},
	goods_item_special_mentions_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_max_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_max_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_max_fieldsFieldPolicy,
	},
	goods_item_special_mentions_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_min_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_min_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_min_fieldsFieldPolicy,
	},
	goods_item_special_mentions_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_stddev_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_stddev_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_stddev_fieldsFieldPolicy,
	},
	goods_item_special_mentions_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_stddev_pop_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_stddev_pop_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_stddev_pop_fieldsFieldPolicy,
	},
	goods_item_special_mentions_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_stddev_samp_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_stddev_samp_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_stddev_samp_fieldsFieldPolicy,
	},
	goods_item_special_mentions_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_sum_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_sum_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_sum_fieldsFieldPolicy,
	},
	goods_item_special_mentions_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_var_pop_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_var_pop_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_var_pop_fieldsFieldPolicy,
	},
	goods_item_special_mentions_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_var_samp_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_var_samp_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_var_samp_fieldsFieldPolicy,
	},
	goods_item_special_mentions_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_special_mentions_variance_fieldsKeySpecifier | (() => undefined | goods_item_special_mentions_variance_fieldsKeySpecifier),
		fields?: goods_item_special_mentions_variance_fieldsFieldPolicy,
	},
	packagings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagingsKeySpecifier | (() => undefined | packagingsKeySpecifier),
		fields?: packagingsFieldPolicy,
	},
	packagings_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_aggregateKeySpecifier | (() => undefined | packagings_aggregateKeySpecifier),
		fields?: packagings_aggregateFieldPolicy,
	},
	packagings_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_aggregate_fieldsKeySpecifier | (() => undefined | packagings_aggregate_fieldsKeySpecifier),
		fields?: packagings_aggregate_fieldsFieldPolicy,
	},
	packagings_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_avg_fieldsKeySpecifier | (() => undefined | packagings_avg_fieldsKeySpecifier),
		fields?: packagings_avg_fieldsFieldPolicy,
	},
	packagings_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_max_fieldsKeySpecifier | (() => undefined | packagings_max_fieldsKeySpecifier),
		fields?: packagings_max_fieldsFieldPolicy,
	},
	packagings_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_min_fieldsKeySpecifier | (() => undefined | packagings_min_fieldsKeySpecifier),
		fields?: packagings_min_fieldsFieldPolicy,
	},
	packagings_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_stddev_fieldsKeySpecifier | (() => undefined | packagings_stddev_fieldsKeySpecifier),
		fields?: packagings_stddev_fieldsFieldPolicy,
	},
	packagings_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_stddev_pop_fieldsKeySpecifier | (() => undefined | packagings_stddev_pop_fieldsKeySpecifier),
		fields?: packagings_stddev_pop_fieldsFieldPolicy,
	},
	packagings_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_stddev_samp_fieldsKeySpecifier | (() => undefined | packagings_stddev_samp_fieldsKeySpecifier),
		fields?: packagings_stddev_samp_fieldsFieldPolicy,
	},
	packagings_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_sum_fieldsKeySpecifier | (() => undefined | packagings_sum_fieldsKeySpecifier),
		fields?: packagings_sum_fieldsFieldPolicy,
	},
	packagings_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_var_pop_fieldsKeySpecifier | (() => undefined | packagings_var_pop_fieldsKeySpecifier),
		fields?: packagings_var_pop_fieldsFieldPolicy,
	},
	packagings_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_var_samp_fieldsKeySpecifier | (() => undefined | packagings_var_samp_fieldsKeySpecifier),
		fields?: packagings_var_samp_fieldsFieldPolicy,
	},
	packagings_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_variance_fieldsKeySpecifier | (() => undefined | packagings_variance_fieldsKeySpecifier),
		fields?: packagings_variance_fieldsFieldPolicy,
	},
	permits?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permitsKeySpecifier | (() => undefined | permitsKeySpecifier),
		fields?: permitsFieldPolicy,
	},
	permits_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_aggregateKeySpecifier | (() => undefined | permits_aggregateKeySpecifier),
		fields?: permits_aggregateFieldPolicy,
	},
	permits_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_aggregate_fieldsKeySpecifier | (() => undefined | permits_aggregate_fieldsKeySpecifier),
		fields?: permits_aggregate_fieldsFieldPolicy,
	},
	permits_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_avg_fieldsKeySpecifier | (() => undefined | permits_avg_fieldsKeySpecifier),
		fields?: permits_avg_fieldsFieldPolicy,
	},
	permits_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_max_fieldsKeySpecifier | (() => undefined | permits_max_fieldsKeySpecifier),
		fields?: permits_max_fieldsFieldPolicy,
	},
	permits_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_min_fieldsKeySpecifier | (() => undefined | permits_min_fieldsKeySpecifier),
		fields?: permits_min_fieldsFieldPolicy,
	},
	permits_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_stddev_fieldsKeySpecifier | (() => undefined | permits_stddev_fieldsKeySpecifier),
		fields?: permits_stddev_fieldsFieldPolicy,
	},
	permits_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_stddev_pop_fieldsKeySpecifier | (() => undefined | permits_stddev_pop_fieldsKeySpecifier),
		fields?: permits_stddev_pop_fieldsFieldPolicy,
	},
	permits_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_stddev_samp_fieldsKeySpecifier | (() => undefined | permits_stddev_samp_fieldsKeySpecifier),
		fields?: permits_stddev_samp_fieldsFieldPolicy,
	},
	permits_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_sum_fieldsKeySpecifier | (() => undefined | permits_sum_fieldsKeySpecifier),
		fields?: permits_sum_fieldsFieldPolicy,
	},
	permits_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_var_pop_fieldsKeySpecifier | (() => undefined | permits_var_pop_fieldsKeySpecifier),
		fields?: permits_var_pop_fieldsFieldPolicy,
	},
	permits_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_var_samp_fieldsKeySpecifier | (() => undefined | permits_var_samp_fieldsKeySpecifier),
		fields?: permits_var_samp_fieldsFieldPolicy,
	},
	permits_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | permits_variance_fieldsKeySpecifier | (() => undefined | permits_variance_fieldsKeySpecifier),
		fields?: permits_variance_fieldsFieldPolicy,
	},
	produced_documents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documentsKeySpecifier | (() => undefined | produced_documentsKeySpecifier),
		fields?: produced_documentsFieldPolicy,
	},
	produced_documents_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_aggregateKeySpecifier | (() => undefined | produced_documents_aggregateKeySpecifier),
		fields?: produced_documents_aggregateFieldPolicy,
	},
	produced_documents_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_aggregate_fieldsKeySpecifier | (() => undefined | produced_documents_aggregate_fieldsKeySpecifier),
		fields?: produced_documents_aggregate_fieldsFieldPolicy,
	},
	produced_documents_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_avg_fieldsKeySpecifier | (() => undefined | produced_documents_avg_fieldsKeySpecifier),
		fields?: produced_documents_avg_fieldsFieldPolicy,
	},
	produced_documents_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_max_fieldsKeySpecifier | (() => undefined | produced_documents_max_fieldsKeySpecifier),
		fields?: produced_documents_max_fieldsFieldPolicy,
	},
	produced_documents_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_min_fieldsKeySpecifier | (() => undefined | produced_documents_min_fieldsKeySpecifier),
		fields?: produced_documents_min_fieldsFieldPolicy,
	},
	produced_documents_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_stddev_fieldsKeySpecifier | (() => undefined | produced_documents_stddev_fieldsKeySpecifier),
		fields?: produced_documents_stddev_fieldsFieldPolicy,
	},
	produced_documents_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_stddev_pop_fieldsKeySpecifier | (() => undefined | produced_documents_stddev_pop_fieldsKeySpecifier),
		fields?: produced_documents_stddev_pop_fieldsFieldPolicy,
	},
	produced_documents_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_stddev_samp_fieldsKeySpecifier | (() => undefined | produced_documents_stddev_samp_fieldsKeySpecifier),
		fields?: produced_documents_stddev_samp_fieldsFieldPolicy,
	},
	produced_documents_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_sum_fieldsKeySpecifier | (() => undefined | produced_documents_sum_fieldsKeySpecifier),
		fields?: produced_documents_sum_fieldsFieldPolicy,
	},
	produced_documents_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_var_pop_fieldsKeySpecifier | (() => undefined | produced_documents_var_pop_fieldsKeySpecifier),
		fields?: produced_documents_var_pop_fieldsFieldPolicy,
	},
	produced_documents_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_var_samp_fieldsKeySpecifier | (() => undefined | produced_documents_var_samp_fieldsKeySpecifier),
		fields?: produced_documents_var_samp_fieldsFieldPolicy,
	},
	produced_documents_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_variance_fieldsKeySpecifier | (() => undefined | produced_documents_variance_fieldsKeySpecifier),
		fields?: produced_documents_variance_fieldsFieldPolicy,
	},
	goods_item_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_aggregateKeySpecifier | (() => undefined | goods_item_aggregateKeySpecifier),
		fields?: goods_item_aggregateFieldPolicy,
	},
	goods_item_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_aggregate_fieldsKeySpecifier | (() => undefined | goods_item_aggregate_fieldsKeySpecifier),
		fields?: goods_item_aggregate_fieldsFieldPolicy,
	},
	goods_item_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_avg_fieldsKeySpecifier | (() => undefined | goods_item_avg_fieldsKeySpecifier),
		fields?: goods_item_avg_fieldsFieldPolicy,
	},
	goods_item_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_max_fieldsKeySpecifier | (() => undefined | goods_item_max_fieldsKeySpecifier),
		fields?: goods_item_max_fieldsFieldPolicy,
	},
	goods_item_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_min_fieldsKeySpecifier | (() => undefined | goods_item_min_fieldsKeySpecifier),
		fields?: goods_item_min_fieldsFieldPolicy,
	},
	goods_item_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_stddev_fieldsKeySpecifier | (() => undefined | goods_item_stddev_fieldsKeySpecifier),
		fields?: goods_item_stddev_fieldsFieldPolicy,
	},
	goods_item_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_stddev_pop_fieldsKeySpecifier | (() => undefined | goods_item_stddev_pop_fieldsKeySpecifier),
		fields?: goods_item_stddev_pop_fieldsFieldPolicy,
	},
	goods_item_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_stddev_samp_fieldsKeySpecifier | (() => undefined | goods_item_stddev_samp_fieldsKeySpecifier),
		fields?: goods_item_stddev_samp_fieldsFieldPolicy,
	},
	goods_item_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_sum_fieldsKeySpecifier | (() => undefined | goods_item_sum_fieldsKeySpecifier),
		fields?: goods_item_sum_fieldsFieldPolicy,
	},
	goods_item_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_var_pop_fieldsKeySpecifier | (() => undefined | goods_item_var_pop_fieldsKeySpecifier),
		fields?: goods_item_var_pop_fieldsFieldPolicy,
	},
	goods_item_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_var_samp_fieldsKeySpecifier | (() => undefined | goods_item_var_samp_fieldsKeySpecifier),
		fields?: goods_item_var_samp_fieldsFieldPolicy,
	},
	goods_item_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_variance_fieldsKeySpecifier | (() => undefined | goods_item_variance_fieldsKeySpecifier),
		fields?: goods_item_variance_fieldsFieldPolicy,
	},
	previous_documents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | previous_documentsKeySpecifier | (() => undefined | previous_documentsKeySpecifier),
		fields?: previous_documentsFieldPolicy,
	},
	declaration_discussion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussionKeySpecifier | (() => undefined | declaration_discussionKeySpecifier),
		fields?: declaration_discussionFieldPolicy,
	},
	declaration_message?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_messageKeySpecifier | (() => undefined | declaration_messageKeySpecifier),
		fields?: declaration_messageFieldPolicy,
	},
	declaration_message_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_aggregateKeySpecifier | (() => undefined | declaration_message_aggregateKeySpecifier),
		fields?: declaration_message_aggregateFieldPolicy,
	},
	declaration_message_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_aggregate_fieldsKeySpecifier | (() => undefined | declaration_message_aggregate_fieldsKeySpecifier),
		fields?: declaration_message_aggregate_fieldsFieldPolicy,
	},
	declaration_message_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_avg_fieldsKeySpecifier | (() => undefined | declaration_message_avg_fieldsKeySpecifier),
		fields?: declaration_message_avg_fieldsFieldPolicy,
	},
	declaration_message_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_max_fieldsKeySpecifier | (() => undefined | declaration_message_max_fieldsKeySpecifier),
		fields?: declaration_message_max_fieldsFieldPolicy,
	},
	declaration_message_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_min_fieldsKeySpecifier | (() => undefined | declaration_message_min_fieldsKeySpecifier),
		fields?: declaration_message_min_fieldsFieldPolicy,
	},
	declaration_message_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_stddev_fieldsKeySpecifier | (() => undefined | declaration_message_stddev_fieldsKeySpecifier),
		fields?: declaration_message_stddev_fieldsFieldPolicy,
	},
	declaration_message_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_stddev_pop_fieldsKeySpecifier | (() => undefined | declaration_message_stddev_pop_fieldsKeySpecifier),
		fields?: declaration_message_stddev_pop_fieldsFieldPolicy,
	},
	declaration_message_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_stddev_samp_fieldsKeySpecifier | (() => undefined | declaration_message_stddev_samp_fieldsKeySpecifier),
		fields?: declaration_message_stddev_samp_fieldsFieldPolicy,
	},
	declaration_message_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_sum_fieldsKeySpecifier | (() => undefined | declaration_message_sum_fieldsKeySpecifier),
		fields?: declaration_message_sum_fieldsFieldPolicy,
	},
	declaration_message_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_var_pop_fieldsKeySpecifier | (() => undefined | declaration_message_var_pop_fieldsKeySpecifier),
		fields?: declaration_message_var_pop_fieldsFieldPolicy,
	},
	declaration_message_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_var_samp_fieldsKeySpecifier | (() => undefined | declaration_message_var_samp_fieldsKeySpecifier),
		fields?: declaration_message_var_samp_fieldsFieldPolicy,
	},
	declaration_message_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_variance_fieldsKeySpecifier | (() => undefined | declaration_message_variance_fieldsKeySpecifier),
		fields?: declaration_message_variance_fieldsFieldPolicy,
	},
	declaration_discussion_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_aggregateKeySpecifier | (() => undefined | declaration_discussion_aggregateKeySpecifier),
		fields?: declaration_discussion_aggregateFieldPolicy,
	},
	declaration_discussion_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_aggregate_fieldsKeySpecifier | (() => undefined | declaration_discussion_aggregate_fieldsKeySpecifier),
		fields?: declaration_discussion_aggregate_fieldsFieldPolicy,
	},
	declaration_discussion_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_avg_fieldsKeySpecifier | (() => undefined | declaration_discussion_avg_fieldsKeySpecifier),
		fields?: declaration_discussion_avg_fieldsFieldPolicy,
	},
	declaration_discussion_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_max_fieldsKeySpecifier | (() => undefined | declaration_discussion_max_fieldsKeySpecifier),
		fields?: declaration_discussion_max_fieldsFieldPolicy,
	},
	declaration_discussion_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_min_fieldsKeySpecifier | (() => undefined | declaration_discussion_min_fieldsKeySpecifier),
		fields?: declaration_discussion_min_fieldsFieldPolicy,
	},
	declaration_discussion_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_stddev_fieldsKeySpecifier | (() => undefined | declaration_discussion_stddev_fieldsKeySpecifier),
		fields?: declaration_discussion_stddev_fieldsFieldPolicy,
	},
	declaration_discussion_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_stddev_pop_fieldsKeySpecifier | (() => undefined | declaration_discussion_stddev_pop_fieldsKeySpecifier),
		fields?: declaration_discussion_stddev_pop_fieldsFieldPolicy,
	},
	declaration_discussion_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_stddev_samp_fieldsKeySpecifier | (() => undefined | declaration_discussion_stddev_samp_fieldsKeySpecifier),
		fields?: declaration_discussion_stddev_samp_fieldsFieldPolicy,
	},
	declaration_discussion_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_sum_fieldsKeySpecifier | (() => undefined | declaration_discussion_sum_fieldsKeySpecifier),
		fields?: declaration_discussion_sum_fieldsFieldPolicy,
	},
	declaration_discussion_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_var_pop_fieldsKeySpecifier | (() => undefined | declaration_discussion_var_pop_fieldsKeySpecifier),
		fields?: declaration_discussion_var_pop_fieldsFieldPolicy,
	},
	declaration_discussion_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_var_samp_fieldsKeySpecifier | (() => undefined | declaration_discussion_var_samp_fieldsKeySpecifier),
		fields?: declaration_discussion_var_samp_fieldsFieldPolicy,
	},
	declaration_discussion_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_variance_fieldsKeySpecifier | (() => undefined | declaration_discussion_variance_fieldsKeySpecifier),
		fields?: declaration_discussion_variance_fieldsFieldPolicy,
	},
	declaration_document?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_documentKeySpecifier | (() => undefined | declaration_documentKeySpecifier),
		fields?: declaration_documentFieldPolicy,
	},
	declaration_request_labels?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_request_labelsKeySpecifier | (() => undefined | declaration_request_labelsKeySpecifier),
		fields?: declaration_request_labelsFieldPolicy,
	},
	declaration_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_statusKeySpecifier | (() => undefined | declaration_statusKeySpecifier),
		fields?: declaration_statusFieldPolicy,
	},
	declaration_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_typeKeySpecifier | (() => undefined | declaration_typeKeySpecifier),
		fields?: declaration_typeFieldPolicy,
	},
	declaration_task_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_aggregateKeySpecifier | (() => undefined | declaration_task_aggregateKeySpecifier),
		fields?: declaration_task_aggregateFieldPolicy,
	},
	declaration_task_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_aggregate_fieldsKeySpecifier | (() => undefined | declaration_task_aggregate_fieldsKeySpecifier),
		fields?: declaration_task_aggregate_fieldsFieldPolicy,
	},
	declaration_task_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_avg_fieldsKeySpecifier | (() => undefined | declaration_task_avg_fieldsKeySpecifier),
		fields?: declaration_task_avg_fieldsFieldPolicy,
	},
	declaration_task_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_max_fieldsKeySpecifier | (() => undefined | declaration_task_max_fieldsKeySpecifier),
		fields?: declaration_task_max_fieldsFieldPolicy,
	},
	declaration_task_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_min_fieldsKeySpecifier | (() => undefined | declaration_task_min_fieldsKeySpecifier),
		fields?: declaration_task_min_fieldsFieldPolicy,
	},
	declaration_task_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_stddev_fieldsKeySpecifier | (() => undefined | declaration_task_stddev_fieldsKeySpecifier),
		fields?: declaration_task_stddev_fieldsFieldPolicy,
	},
	declaration_task_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_stddev_pop_fieldsKeySpecifier | (() => undefined | declaration_task_stddev_pop_fieldsKeySpecifier),
		fields?: declaration_task_stddev_pop_fieldsFieldPolicy,
	},
	declaration_task_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_stddev_samp_fieldsKeySpecifier | (() => undefined | declaration_task_stddev_samp_fieldsKeySpecifier),
		fields?: declaration_task_stddev_samp_fieldsFieldPolicy,
	},
	declaration_task_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_sum_fieldsKeySpecifier | (() => undefined | declaration_task_sum_fieldsKeySpecifier),
		fields?: declaration_task_sum_fieldsFieldPolicy,
	},
	declaration_task_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_var_pop_fieldsKeySpecifier | (() => undefined | declaration_task_var_pop_fieldsKeySpecifier),
		fields?: declaration_task_var_pop_fieldsFieldPolicy,
	},
	declaration_task_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_var_samp_fieldsKeySpecifier | (() => undefined | declaration_task_var_samp_fieldsKeySpecifier),
		fields?: declaration_task_var_samp_fieldsFieldPolicy,
	},
	declaration_task_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_variance_fieldsKeySpecifier | (() => undefined | declaration_task_variance_fieldsKeySpecifier),
		fields?: declaration_task_variance_fieldsFieldPolicy,
	},
	task_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | task_typeKeySpecifier | (() => undefined | task_typeKeySpecifier),
		fields?: task_typeFieldPolicy,
	},
	doc_annotation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | doc_annotationKeySpecifier | (() => undefined | doc_annotationKeySpecifier),
		fields?: doc_annotationFieldPolicy,
	},
	document_extension?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_extensionKeySpecifier | (() => undefined | document_extensionKeySpecifier),
		fields?: document_extensionFieldPolicy,
	},
	document_page?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_pageKeySpecifier | (() => undefined | document_pageKeySpecifier),
		fields?: document_pageFieldPolicy,
	},
	page?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pageKeySpecifier | (() => undefined | pageKeySpecifier),
		fields?: pageFieldPolicy,
	},
	document_page_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_aggregateKeySpecifier | (() => undefined | document_page_aggregateKeySpecifier),
		fields?: document_page_aggregateFieldPolicy,
	},
	document_page_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_aggregate_fieldsKeySpecifier | (() => undefined | document_page_aggregate_fieldsKeySpecifier),
		fields?: document_page_aggregate_fieldsFieldPolicy,
	},
	document_page_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_avg_fieldsKeySpecifier | (() => undefined | document_page_avg_fieldsKeySpecifier),
		fields?: document_page_avg_fieldsFieldPolicy,
	},
	document_page_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_max_fieldsKeySpecifier | (() => undefined | document_page_max_fieldsKeySpecifier),
		fields?: document_page_max_fieldsFieldPolicy,
	},
	document_page_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_min_fieldsKeySpecifier | (() => undefined | document_page_min_fieldsKeySpecifier),
		fields?: document_page_min_fieldsFieldPolicy,
	},
	document_page_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_stddev_fieldsKeySpecifier | (() => undefined | document_page_stddev_fieldsKeySpecifier),
		fields?: document_page_stddev_fieldsFieldPolicy,
	},
	document_page_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_stddev_pop_fieldsKeySpecifier | (() => undefined | document_page_stddev_pop_fieldsKeySpecifier),
		fields?: document_page_stddev_pop_fieldsFieldPolicy,
	},
	document_page_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_stddev_samp_fieldsKeySpecifier | (() => undefined | document_page_stddev_samp_fieldsKeySpecifier),
		fields?: document_page_stddev_samp_fieldsFieldPolicy,
	},
	document_page_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_sum_fieldsKeySpecifier | (() => undefined | document_page_sum_fieldsKeySpecifier),
		fields?: document_page_sum_fieldsFieldPolicy,
	},
	document_page_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_var_pop_fieldsKeySpecifier | (() => undefined | document_page_var_pop_fieldsKeySpecifier),
		fields?: document_page_var_pop_fieldsFieldPolicy,
	},
	document_page_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_var_samp_fieldsKeySpecifier | (() => undefined | document_page_var_samp_fieldsKeySpecifier),
		fields?: document_page_var_samp_fieldsFieldPolicy,
	},
	document_page_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_page_variance_fieldsKeySpecifier | (() => undefined | document_page_variance_fieldsKeySpecifier),
		fields?: document_page_variance_fieldsFieldPolicy,
	},
	page_extract?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | page_extractKeySpecifier | (() => undefined | page_extractKeySpecifier),
		fields?: page_extractFieldPolicy,
	},
	extract_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | extract_typeKeySpecifier | (() => undefined | extract_typeKeySpecifier),
		fields?: extract_typeFieldPolicy,
	},
	document_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_statusKeySpecifier | (() => undefined | document_statusKeySpecifier),
		fields?: document_statusFieldPolicy,
	},
	user_org_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | user_org_idKeySpecifier | (() => undefined | user_org_idKeySpecifier),
		fields?: user_org_idFieldPolicy,
	},
	import_list_trigger?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_triggerKeySpecifier | (() => undefined | import_list_triggerKeySpecifier),
		fields?: import_list_triggerFieldPolicy,
	},
	import_list_trigger_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_aggregateKeySpecifier | (() => undefined | import_list_trigger_aggregateKeySpecifier),
		fields?: import_list_trigger_aggregateFieldPolicy,
	},
	import_list_trigger_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_aggregate_fieldsKeySpecifier | (() => undefined | import_list_trigger_aggregate_fieldsKeySpecifier),
		fields?: import_list_trigger_aggregate_fieldsFieldPolicy,
	},
	import_list_trigger_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_avg_fieldsKeySpecifier | (() => undefined | import_list_trigger_avg_fieldsKeySpecifier),
		fields?: import_list_trigger_avg_fieldsFieldPolicy,
	},
	import_list_trigger_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_max_fieldsKeySpecifier | (() => undefined | import_list_trigger_max_fieldsKeySpecifier),
		fields?: import_list_trigger_max_fieldsFieldPolicy,
	},
	import_list_trigger_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_min_fieldsKeySpecifier | (() => undefined | import_list_trigger_min_fieldsKeySpecifier),
		fields?: import_list_trigger_min_fieldsFieldPolicy,
	},
	import_list_trigger_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_stddev_fieldsKeySpecifier | (() => undefined | import_list_trigger_stddev_fieldsKeySpecifier),
		fields?: import_list_trigger_stddev_fieldsFieldPolicy,
	},
	import_list_trigger_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_stddev_pop_fieldsKeySpecifier | (() => undefined | import_list_trigger_stddev_pop_fieldsKeySpecifier),
		fields?: import_list_trigger_stddev_pop_fieldsFieldPolicy,
	},
	import_list_trigger_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_stddev_samp_fieldsKeySpecifier | (() => undefined | import_list_trigger_stddev_samp_fieldsKeySpecifier),
		fields?: import_list_trigger_stddev_samp_fieldsFieldPolicy,
	},
	import_list_trigger_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_sum_fieldsKeySpecifier | (() => undefined | import_list_trigger_sum_fieldsKeySpecifier),
		fields?: import_list_trigger_sum_fieldsFieldPolicy,
	},
	import_list_trigger_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_var_pop_fieldsKeySpecifier | (() => undefined | import_list_trigger_var_pop_fieldsKeySpecifier),
		fields?: import_list_trigger_var_pop_fieldsFieldPolicy,
	},
	import_list_trigger_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_var_samp_fieldsKeySpecifier | (() => undefined | import_list_trigger_var_samp_fieldsKeySpecifier),
		fields?: import_list_trigger_var_samp_fieldsFieldPolicy,
	},
	import_list_trigger_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_variance_fieldsKeySpecifier | (() => undefined | import_list_trigger_variance_fieldsKeySpecifier),
		fields?: import_list_trigger_variance_fieldsFieldPolicy,
	},
	extraction_config?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | extraction_configKeySpecifier | (() => undefined | extraction_configKeySpecifier),
		fields?: extraction_configFieldPolicy,
	},
	address_groups?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | address_groupsKeySpecifier | (() => undefined | address_groupsKeySpecifier),
		fields?: address_groupsFieldPolicy,
	},
	address_mapping?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | address_mappingKeySpecifier | (() => undefined | address_mappingKeySpecifier),
		fields?: address_mappingFieldPolicy,
	},
	address_override?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | address_overrideKeySpecifier | (() => undefined | address_overrideKeySpecifier),
		fields?: address_overrideFieldPolicy,
	},
	addresses?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | addressesKeySpecifier | (() => undefined | addressesKeySpecifier),
		fields?: addressesFieldPolicy,
	},
	ai_stats_dt_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ai_stats_dt_typeKeySpecifier | (() => undefined | ai_stats_dt_typeKeySpecifier),
		fields?: ai_stats_dt_typeFieldPolicy,
	},
	ai_stats_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ai_stats_typeKeySpecifier | (() => undefined | ai_stats_typeKeySpecifier),
		fields?: ai_stats_typeFieldPolicy,
	},
	bill_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_aggregateKeySpecifier | (() => undefined | bill_aggregateKeySpecifier),
		fields?: bill_aggregateFieldPolicy,
	},
	bill_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_aggregate_fieldsKeySpecifier | (() => undefined | bill_aggregate_fieldsKeySpecifier),
		fields?: bill_aggregate_fieldsFieldPolicy,
	},
	bill_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_avg_fieldsKeySpecifier | (() => undefined | bill_avg_fieldsKeySpecifier),
		fields?: bill_avg_fieldsFieldPolicy,
	},
	bill_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_max_fieldsKeySpecifier | (() => undefined | bill_max_fieldsKeySpecifier),
		fields?: bill_max_fieldsFieldPolicy,
	},
	bill_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_min_fieldsKeySpecifier | (() => undefined | bill_min_fieldsKeySpecifier),
		fields?: bill_min_fieldsFieldPolicy,
	},
	bill_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_stddev_fieldsKeySpecifier | (() => undefined | bill_stddev_fieldsKeySpecifier),
		fields?: bill_stddev_fieldsFieldPolicy,
	},
	bill_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_stddev_pop_fieldsKeySpecifier | (() => undefined | bill_stddev_pop_fieldsKeySpecifier),
		fields?: bill_stddev_pop_fieldsFieldPolicy,
	},
	bill_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_stddev_samp_fieldsKeySpecifier | (() => undefined | bill_stddev_samp_fieldsKeySpecifier),
		fields?: bill_stddev_samp_fieldsFieldPolicy,
	},
	bill_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_sum_fieldsKeySpecifier | (() => undefined | bill_sum_fieldsKeySpecifier),
		fields?: bill_sum_fieldsFieldPolicy,
	},
	bill_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_var_pop_fieldsKeySpecifier | (() => undefined | bill_var_pop_fieldsKeySpecifier),
		fields?: bill_var_pop_fieldsFieldPolicy,
	},
	bill_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_var_samp_fieldsKeySpecifier | (() => undefined | bill_var_samp_fieldsKeySpecifier),
		fields?: bill_var_samp_fieldsFieldPolicy,
	},
	bill_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_variance_fieldsKeySpecifier | (() => undefined | bill_variance_fieldsKeySpecifier),
		fields?: bill_variance_fieldsFieldPolicy,
	},
	count_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | count_typeKeySpecifier | (() => undefined | count_typeKeySpecifier),
		fields?: count_typeFieldPolicy,
	},
	customs_office?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | customs_officeKeySpecifier | (() => undefined | customs_officeKeySpecifier),
		fields?: customs_officeFieldPolicy,
	},
	declaration_discussions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussionsKeySpecifier | (() => undefined | declaration_discussionsKeySpecifier),
		fields?: declaration_discussionsFieldPolicy,
	},
	declaration_request_address_ai?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_request_address_aiKeySpecifier | (() => undefined | declaration_request_address_aiKeySpecifier),
		fields?: declaration_request_address_aiFieldPolicy,
	},
	declaration_requests?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_requestsKeySpecifier | (() => undefined | declaration_requestsKeySpecifier),
		fields?: declaration_requestsFieldPolicy,
	},
	declaration_search?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_searchKeySpecifier | (() => undefined | declaration_searchKeySpecifier),
		fields?: declaration_searchFieldPolicy,
	},
	declaration_tasks?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_tasksKeySpecifier | (() => undefined | declaration_tasksKeySpecifier),
		fields?: declaration_tasksFieldPolicy,
	},
	declaration_tasks_obj?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_tasks_objKeySpecifier | (() => undefined | declaration_tasks_objKeySpecifier),
		fields?: declaration_tasks_objFieldPolicy,
	},
	discussion_changes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | discussion_changesKeySpecifier | (() => undefined | discussion_changesKeySpecifier),
		fields?: discussion_changesFieldPolicy,
	},
	doc_search_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | doc_search_typeKeySpecifier | (() => undefined | doc_search_typeKeySpecifier),
		fields?: doc_search_typeFieldPolicy,
	},
	doc_stats_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | doc_stats_typeKeySpecifier | (() => undefined | doc_stats_typeKeySpecifier),
		fields?: doc_stats_typeFieldPolicy,
	},
	docs_for_validation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | docs_for_validationKeySpecifier | (() => undefined | docs_for_validationKeySpecifier),
		fields?: docs_for_validationFieldPolicy,
	},
	document_flag?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_flagKeySpecifier | (() => undefined | document_flagKeySpecifier),
		fields?: document_flagFieldPolicy,
	},
	document_type_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_type_aggregateKeySpecifier | (() => undefined | document_type_aggregateKeySpecifier),
		fields?: document_type_aggregateFieldPolicy,
	},
	document_type_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_type_aggregate_fieldsKeySpecifier | (() => undefined | document_type_aggregate_fieldsKeySpecifier),
		fields?: document_type_aggregate_fieldsFieldPolicy,
	},
	document_type_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_type_max_fieldsKeySpecifier | (() => undefined | document_type_max_fieldsKeySpecifier),
		fields?: document_type_max_fieldsFieldPolicy,
	},
	document_type_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_type_min_fieldsKeySpecifier | (() => undefined | document_type_min_fieldsKeySpecifier),
		fields?: document_type_min_fieldsFieldPolicy,
	},
	dr_stats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | dr_statsKeySpecifier | (() => undefined | dr_statsKeySpecifier),
		fields?: dr_statsFieldPolicy,
	},
	edec_countries?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | edec_countriesKeySpecifier | (() => undefined | edec_countriesKeySpecifier),
		fields?: edec_countriesFieldPolicy,
	},
	edec_customs_offices?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | edec_customs_officesKeySpecifier | (() => undefined | edec_customs_officesKeySpecifier),
		fields?: edec_customs_officesFieldPolicy,
	},
	edec_domains?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | edec_domainsKeySpecifier | (() => undefined | edec_domainsKeySpecifier),
		fields?: edec_domainsFieldPolicy,
	},
	edec_tariff_commodity_code?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | edec_tariff_commodity_codeKeySpecifier | (() => undefined | edec_tariff_commodity_codeKeySpecifier),
		fields?: edec_tariff_commodity_codeFieldPolicy,
	},
	edec_tariff_statistical_code?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | edec_tariff_statistical_codeKeySpecifier | (() => undefined | edec_tariff_statistical_codeKeySpecifier),
		fields?: edec_tariff_statistical_codeFieldPolicy,
	},
	email_search_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_typeKeySpecifier | (() => undefined | email_search_typeKeySpecifier),
		fields?: email_search_typeFieldPolicy,
	},
	email_search_type_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_aggregateKeySpecifier | (() => undefined | email_search_type_aggregateKeySpecifier),
		fields?: email_search_type_aggregateFieldPolicy,
	},
	email_search_type_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_aggregate_fieldsKeySpecifier | (() => undefined | email_search_type_aggregate_fieldsKeySpecifier),
		fields?: email_search_type_aggregate_fieldsFieldPolicy,
	},
	email_search_type_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_avg_fieldsKeySpecifier | (() => undefined | email_search_type_avg_fieldsKeySpecifier),
		fields?: email_search_type_avg_fieldsFieldPolicy,
	},
	email_search_type_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_max_fieldsKeySpecifier | (() => undefined | email_search_type_max_fieldsKeySpecifier),
		fields?: email_search_type_max_fieldsFieldPolicy,
	},
	email_search_type_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_min_fieldsKeySpecifier | (() => undefined | email_search_type_min_fieldsKeySpecifier),
		fields?: email_search_type_min_fieldsFieldPolicy,
	},
	email_search_type_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_stddev_fieldsKeySpecifier | (() => undefined | email_search_type_stddev_fieldsKeySpecifier),
		fields?: email_search_type_stddev_fieldsFieldPolicy,
	},
	email_search_type_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_stddev_pop_fieldsKeySpecifier | (() => undefined | email_search_type_stddev_pop_fieldsKeySpecifier),
		fields?: email_search_type_stddev_pop_fieldsFieldPolicy,
	},
	email_search_type_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_stddev_samp_fieldsKeySpecifier | (() => undefined | email_search_type_stddev_samp_fieldsKeySpecifier),
		fields?: email_search_type_stddev_samp_fieldsFieldPolicy,
	},
	email_search_type_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_sum_fieldsKeySpecifier | (() => undefined | email_search_type_sum_fieldsKeySpecifier),
		fields?: email_search_type_sum_fieldsFieldPolicy,
	},
	email_search_type_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_var_pop_fieldsKeySpecifier | (() => undefined | email_search_type_var_pop_fieldsKeySpecifier),
		fields?: email_search_type_var_pop_fieldsFieldPolicy,
	},
	email_search_type_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_var_samp_fieldsKeySpecifier | (() => undefined | email_search_type_var_samp_fieldsKeySpecifier),
		fields?: email_search_type_var_samp_fieldsFieldPolicy,
	},
	email_search_type_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | email_search_type_variance_fieldsKeySpecifier | (() => undefined | email_search_type_variance_fieldsKeySpecifier),
		fields?: email_search_type_variance_fieldsFieldPolicy,
	},
	file_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_aggregateKeySpecifier | (() => undefined | file_aggregateKeySpecifier),
		fields?: file_aggregateFieldPolicy,
	},
	file_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_aggregate_fieldsKeySpecifier | (() => undefined | file_aggregate_fieldsKeySpecifier),
		fields?: file_aggregate_fieldsFieldPolicy,
	},
	file_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_avg_fieldsKeySpecifier | (() => undefined | file_avg_fieldsKeySpecifier),
		fields?: file_avg_fieldsFieldPolicy,
	},
	file_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_max_fieldsKeySpecifier | (() => undefined | file_max_fieldsKeySpecifier),
		fields?: file_max_fieldsFieldPolicy,
	},
	file_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_min_fieldsKeySpecifier | (() => undefined | file_min_fieldsKeySpecifier),
		fields?: file_min_fieldsFieldPolicy,
	},
	file_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_stddev_fieldsKeySpecifier | (() => undefined | file_stddev_fieldsKeySpecifier),
		fields?: file_stddev_fieldsFieldPolicy,
	},
	file_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_stddev_pop_fieldsKeySpecifier | (() => undefined | file_stddev_pop_fieldsKeySpecifier),
		fields?: file_stddev_pop_fieldsFieldPolicy,
	},
	file_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_stddev_samp_fieldsKeySpecifier | (() => undefined | file_stddev_samp_fieldsKeySpecifier),
		fields?: file_stddev_samp_fieldsFieldPolicy,
	},
	file_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_sum_fieldsKeySpecifier | (() => undefined | file_sum_fieldsKeySpecifier),
		fields?: file_sum_fieldsFieldPolicy,
	},
	file_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_var_pop_fieldsKeySpecifier | (() => undefined | file_var_pop_fieldsKeySpecifier),
		fields?: file_var_pop_fieldsFieldPolicy,
	},
	file_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_var_samp_fieldsKeySpecifier | (() => undefined | file_var_samp_fieldsKeySpecifier),
		fields?: file_var_samp_fieldsFieldPolicy,
	},
	file_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_variance_fieldsKeySpecifier | (() => undefined | file_variance_fieldsKeySpecifier),
		fields?: file_variance_fieldsFieldPolicy,
	},
	file_stats_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_stats_typeKeySpecifier | (() => undefined | file_stats_typeKeySpecifier),
		fields?: file_stats_typeFieldPolicy,
	},
	file_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_typeKeySpecifier | (() => undefined | file_typeKeySpecifier),
		fields?: file_typeFieldPolicy,
	},
	AddressOrOverrideResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressOrOverrideResultKeySpecifier | (() => undefined | AddressOrOverrideResultKeySpecifier),
		fields?: AddressOrOverrideResultFieldPolicy,
	},
	GetAddressOverridesResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetAddressOverridesResponseKeySpecifier | (() => undefined | GetAddressOverridesResponseKeySpecifier),
		fields?: GetAddressOverridesResponseFieldPolicy,
	},
	GetBordereaus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetBordereausKeySpecifier | (() => undefined | GetBordereausKeySpecifier),
		fields?: GetBordereausFieldPolicy,
	},
	Bordereau?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BordereauKeySpecifier | (() => undefined | BordereauKeySpecifier),
		fields?: BordereauFieldPolicy,
	},
	BordereauItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BordereauItemKeySpecifier | (() => undefined | BordereauItemKeySpecifier),
		fields?: BordereauItemFieldPolicy,
	},
	CustomsOfficeACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CustomsOfficeACSKeySpecifier | (() => undefined | CustomsOfficeACSKeySpecifier),
		fields?: CustomsOfficeACSFieldPolicy,
	},
	TranslationsACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TranslationsACSKeySpecifier | (() => undefined | TranslationsACSKeySpecifier),
		fields?: TranslationsACSFieldPolicy,
	},
	FileACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FileACSKeySpecifier | (() => undefined | FileACSKeySpecifier),
		fields?: FileACSFieldPolicy,
	},
	DeclarationACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationACSKeySpecifier | (() => undefined | DeclarationACSKeySpecifier),
		fields?: DeclarationACSFieldPolicy,
	},
	DeclarationDiscussionEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationDiscussionEntityKeySpecifier | (() => undefined | DeclarationDiscussionEntityKeySpecifier),
		fields?: DeclarationDiscussionEntityFieldPolicy,
	},
	CommodityCodeDescription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommodityCodeDescriptionKeySpecifier | (() => undefined | CommodityCodeDescriptionKeySpecifier),
		fields?: CommodityCodeDescriptionFieldPolicy,
	},
	DeclarationLabelQueryOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationLabelQueryOutputKeySpecifier | (() => undefined | DeclarationLabelQueryOutputKeySpecifier),
		fields?: DeclarationLabelQueryOutputFieldPolicy,
	},
	DeclarationAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationAddressKeySpecifier | (() => undefined | DeclarationAddressKeySpecifier),
		fields?: DeclarationAddressFieldPolicy,
	},
	DeclarationFlat?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationFlatKeySpecifier | (() => undefined | DeclarationFlatKeySpecifier),
		fields?: DeclarationFlatFieldPolicy,
	},
	GetFileDocumentsQuery?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetFileDocumentsQueryKeySpecifier | (() => undefined | GetFileDocumentsQueryKeySpecifier),
		fields?: GetFileDocumentsQueryFieldPolicy,
	},
	DocumentBlob?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DocumentBlobKeySpecifier | (() => undefined | DocumentBlobKeySpecifier),
		fields?: DocumentBlobFieldPolicy,
	},
	GetFiles?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetFilesKeySpecifier | (() => undefined | GetFilesKeySpecifier),
		fields?: GetFilesFieldPolicy,
	},
	GetFilesDocumentACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetFilesDocumentACSKeySpecifier | (() => undefined | GetFilesDocumentACSKeySpecifier),
		fields?: GetFilesDocumentACSFieldPolicy,
	},
	GetFilesDocumentTypeACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetFilesDocumentTypeACSKeySpecifier | (() => undefined | GetFilesDocumentTypeACSKeySpecifier),
		fields?: GetFilesDocumentTypeACSFieldPolicy,
	},
	GetFilesDocumentTypeTenantSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetFilesDocumentTypeTenantSettingsKeySpecifier | (() => undefined | GetFilesDocumentTypeTenantSettingsKeySpecifier),
		fields?: GetFilesDocumentTypeTenantSettingsFieldPolicy,
	},
	GetFilesDocumentPage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetFilesDocumentPageKeySpecifier | (() => undefined | GetFilesDocumentPageKeySpecifier),
		fields?: GetFilesDocumentPageFieldPolicy,
	},
	GetFilesPageACS?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | GetFilesPageACSKeySpecifier | (() => undefined | GetFilesPageACSKeySpecifier),
		fields?: GetFilesPageACSFieldPolicy,
	},
	SASTokenResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SASTokenResponseKeySpecifier | (() => undefined | SASTokenResponseKeySpecifier),
		fields?: SASTokenResponseFieldPolicy,
	},
	ReportEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReportEntityKeySpecifier | (() => undefined | ReportEntityKeySpecifier),
		fields?: ReportEntityFieldPolicy,
	},
	CaslRule?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CaslRuleKeySpecifier | (() => undefined | CaslRuleKeySpecifier),
		fields?: CaslRuleFieldPolicy,
	},
	goods_items_for_drs?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_items_for_drsKeySpecifier | (() => undefined | goods_items_for_drsKeySpecifier),
		fields?: goods_items_for_drsFieldPolicy,
	},
	intf_dr_payment_info?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | intf_dr_payment_infoKeySpecifier | (() => undefined | intf_dr_payment_infoKeySpecifier),
		fields?: intf_dr_payment_infoFieldPolicy,
	},
	json_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | json_typeKeySpecifier | (() => undefined | json_typeKeySpecifier),
		fields?: json_typeFieldPolicy,
	},
	kc_users?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | kc_usersKeySpecifier | (() => undefined | kc_usersKeySpecifier),
		fields?: kc_usersFieldPolicy,
	},
	max_date_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | max_date_typeKeySpecifier | (() => undefined | max_date_typeKeySpecifier),
		fields?: max_date_typeFieldPolicy,
	},
	model_retrain?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | model_retrainKeySpecifier | (() => undefined | model_retrainKeySpecifier),
		fields?: model_retrainFieldPolicy,
	},
	org_ids?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | org_idsKeySpecifier | (() => undefined | org_idsKeySpecifier),
		fields?: org_idsFieldPolicy,
	},
	org_params?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | org_paramsKeySpecifier | (() => undefined | org_paramsKeySpecifier),
		fields?: org_paramsFieldPolicy,
	},
	org_params_org_id?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | org_params_org_idKeySpecifier | (() => undefined | org_params_org_idKeySpecifier),
		fields?: org_params_org_idFieldPolicy,
	},
	page_status?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | page_statusKeySpecifier | (() => undefined | page_statusKeySpecifier),
		fields?: page_statusFieldPolicy,
	},
	pages_m2m_cache_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_aggregateKeySpecifier | (() => undefined | pages_m2m_cache_aggregateKeySpecifier),
		fields?: pages_m2m_cache_aggregateFieldPolicy,
	},
	pages_m2m_cache_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_aggregate_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_aggregate_fieldsKeySpecifier),
		fields?: pages_m2m_cache_aggregate_fieldsFieldPolicy,
	},
	pages_m2m_cache_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_avg_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_avg_fieldsKeySpecifier),
		fields?: pages_m2m_cache_avg_fieldsFieldPolicy,
	},
	pages_m2m_cache_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_max_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_max_fieldsKeySpecifier),
		fields?: pages_m2m_cache_max_fieldsFieldPolicy,
	},
	pages_m2m_cache_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_min_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_min_fieldsKeySpecifier),
		fields?: pages_m2m_cache_min_fieldsFieldPolicy,
	},
	pages_m2m_cache_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_stddev_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_stddev_fieldsKeySpecifier),
		fields?: pages_m2m_cache_stddev_fieldsFieldPolicy,
	},
	pages_m2m_cache_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_stddev_pop_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_stddev_pop_fieldsKeySpecifier),
		fields?: pages_m2m_cache_stddev_pop_fieldsFieldPolicy,
	},
	pages_m2m_cache_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_stddev_samp_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_stddev_samp_fieldsKeySpecifier),
		fields?: pages_m2m_cache_stddev_samp_fieldsFieldPolicy,
	},
	pages_m2m_cache_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_sum_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_sum_fieldsKeySpecifier),
		fields?: pages_m2m_cache_sum_fieldsFieldPolicy,
	},
	pages_m2m_cache_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_var_pop_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_var_pop_fieldsKeySpecifier),
		fields?: pages_m2m_cache_var_pop_fieldsFieldPolicy,
	},
	pages_m2m_cache_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_var_samp_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_var_samp_fieldsKeySpecifier),
		fields?: pages_m2m_cache_var_samp_fieldsFieldPolicy,
	},
	pages_m2m_cache_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pages_m2m_cache_variance_fieldsKeySpecifier | (() => undefined | pages_m2m_cache_variance_fieldsKeySpecifier),
		fields?: pages_m2m_cache_variance_fieldsFieldPolicy,
	},
	pp_types_file_search?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | pp_types_file_searchKeySpecifier | (() => undefined | pp_types_file_searchKeySpecifier),
		fields?: pp_types_file_searchFieldPolicy,
	},
	CommodityCodeStatistics?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CommodityCodeStatisticsKeySpecifier | (() => undefined | CommodityCodeStatisticsKeySpecifier),
		fields?: CommodityCodeStatisticsFieldPolicy,
	},
	StatisticsDTO?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StatisticsDTOKeySpecifier | (() => undefined | StatisticsDTOKeySpecifier),
		fields?: StatisticsDTOFieldPolicy,
	},
	StatisticTariffNumberItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StatisticTariffNumberItemKeySpecifier | (() => undefined | StatisticTariffNumberItemKeySpecifier),
		fields?: StatisticTariffNumberItemFieldPolicy,
	},
	StatisticItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StatisticItemKeySpecifier | (() => undefined | StatisticItemKeySpecifier),
		fields?: StatisticItemFieldPolicy,
	},
	DateInterval?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DateIntervalKeySpecifier | (() => undefined | DateIntervalKeySpecifier),
		fields?: DateIntervalFieldPolicy,
	},
	DateIntervalItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DateIntervalItemKeySpecifier | (() => undefined | DateIntervalItemKeySpecifier),
		fields?: DateIntervalItemFieldPolicy,
	},
	tenants?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | tenantsKeySpecifier | (() => undefined | tenantsKeySpecifier),
		fields?: tenantsFieldPolicy,
	},
	user_search_type?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | user_search_typeKeySpecifier | (() => undefined | user_search_typeKeySpecifier),
		fields?: user_search_typeFieldPolicy,
	},
	view_document_history?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | view_document_historyKeySpecifier | (() => undefined | view_document_historyKeySpecifier),
		fields?: view_document_historyFieldPolicy,
	},
	view_file_history?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | view_file_historyKeySpecifier | (() => undefined | view_file_historyKeySpecifier),
		fields?: view_file_historyFieldPolicy,
	},
	report?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | reportKeySpecifier | (() => undefined | reportKeySpecifier),
		fields?: reportFieldPolicy,
	},
	report_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | report_aggregateKeySpecifier | (() => undefined | report_aggregateKeySpecifier),
		fields?: report_aggregateFieldPolicy,
	},
	report_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | report_aggregate_fieldsKeySpecifier | (() => undefined | report_aggregate_fieldsKeySpecifier),
		fields?: report_aggregate_fieldsFieldPolicy,
	},
	report_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | report_max_fieldsKeySpecifier | (() => undefined | report_max_fieldsKeySpecifier),
		fields?: report_max_fieldsFieldPolicy,
	},
	report_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | report_min_fieldsKeySpecifier | (() => undefined | report_min_fieldsKeySpecifier),
		fields?: report_min_fieldsFieldPolicy,
	},
	service_tariff?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariffKeySpecifier | (() => undefined | service_tariffKeySpecifier),
		fields?: service_tariffFieldPolicy,
	},
	service_tariff_aggregate?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_aggregateKeySpecifier | (() => undefined | service_tariff_aggregateKeySpecifier),
		fields?: service_tariff_aggregateFieldPolicy,
	},
	service_tariff_aggregate_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_aggregate_fieldsKeySpecifier | (() => undefined | service_tariff_aggregate_fieldsKeySpecifier),
		fields?: service_tariff_aggregate_fieldsFieldPolicy,
	},
	service_tariff_avg_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_avg_fieldsKeySpecifier | (() => undefined | service_tariff_avg_fieldsKeySpecifier),
		fields?: service_tariff_avg_fieldsFieldPolicy,
	},
	service_tariff_max_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_max_fieldsKeySpecifier | (() => undefined | service_tariff_max_fieldsKeySpecifier),
		fields?: service_tariff_max_fieldsFieldPolicy,
	},
	service_tariff_min_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_min_fieldsKeySpecifier | (() => undefined | service_tariff_min_fieldsKeySpecifier),
		fields?: service_tariff_min_fieldsFieldPolicy,
	},
	service_tariff_stddev_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_stddev_fieldsKeySpecifier | (() => undefined | service_tariff_stddev_fieldsKeySpecifier),
		fields?: service_tariff_stddev_fieldsFieldPolicy,
	},
	service_tariff_stddev_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_stddev_pop_fieldsKeySpecifier | (() => undefined | service_tariff_stddev_pop_fieldsKeySpecifier),
		fields?: service_tariff_stddev_pop_fieldsFieldPolicy,
	},
	service_tariff_stddev_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_stddev_samp_fieldsKeySpecifier | (() => undefined | service_tariff_stddev_samp_fieldsKeySpecifier),
		fields?: service_tariff_stddev_samp_fieldsFieldPolicy,
	},
	service_tariff_sum_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_sum_fieldsKeySpecifier | (() => undefined | service_tariff_sum_fieldsKeySpecifier),
		fields?: service_tariff_sum_fieldsFieldPolicy,
	},
	service_tariff_var_pop_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_var_pop_fieldsKeySpecifier | (() => undefined | service_tariff_var_pop_fieldsKeySpecifier),
		fields?: service_tariff_var_pop_fieldsFieldPolicy,
	},
	service_tariff_var_samp_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_var_samp_fieldsKeySpecifier | (() => undefined | service_tariff_var_samp_fieldsKeySpecifier),
		fields?: service_tariff_var_samp_fieldsFieldPolicy,
	},
	service_tariff_variance_fields?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_variance_fieldsKeySpecifier | (() => undefined | service_tariff_variance_fieldsKeySpecifier),
		fields?: service_tariff_variance_fieldsFieldPolicy,
	},
	setting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | settingKeySpecifier | (() => undefined | settingKeySpecifier),
		fields?: settingFieldPolicy,
	},
	setting_group?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | setting_groupKeySpecifier | (() => undefined | setting_groupKeySpecifier),
		fields?: setting_groupFieldPolicy,
	},
	setting_value?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | setting_valueKeySpecifier | (() => undefined | setting_valueKeySpecifier),
		fields?: setting_valueFieldPolicy,
	},
	tariff_number_description?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | tariff_number_descriptionKeySpecifier | (() => undefined | tariff_number_descriptionKeySpecifier),
		fields?: tariff_number_descriptionFieldPolicy,
	},
	transitdoc_type_descr?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | transitdoc_type_descrKeySpecifier | (() => undefined | transitdoc_type_descrKeySpecifier),
		fields?: transitdoc_type_descrFieldPolicy,
	},
	view_history?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | view_historyKeySpecifier | (() => undefined | view_historyKeySpecifier),
		fields?: view_historyFieldPolicy,
	},
	vw_documents?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | vw_documentsKeySpecifier | (() => undefined | vw_documentsKeySpecifier),
		fields?: vw_documentsFieldPolicy,
	},
	vw_finished_files?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | vw_finished_filesKeySpecifier | (() => undefined | vw_finished_filesKeySpecifier),
		fields?: vw_finished_filesFieldPolicy,
	},
	mutation_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | mutation_rootKeySpecifier | (() => undefined | mutation_rootKeySpecifier),
		fields?: mutation_rootFieldPolicy,
	},
	AddressVisibility?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressVisibilityKeySpecifier | (() => undefined | AddressVisibilityKeySpecifier),
		fields?: AddressVisibilityFieldPolicy,
	},
	UserResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserResponseKeySpecifier | (() => undefined | UserResponseKeySpecifier),
		fields?: UserResponseFieldPolicy,
	},
	NotificationTrigger?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationTriggerKeySpecifier | (() => undefined | NotificationTriggerKeySpecifier),
		fields?: NotificationTriggerFieldPolicy,
	},
	DeclarationLabelMutationOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeclarationLabelMutationOutputKeySpecifier | (() => undefined | DeclarationLabelMutationOutputKeySpecifier),
		fields?: DeclarationLabelMutationOutputFieldPolicy,
	},
	NotificationLabelMutationOutput?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | NotificationLabelMutationOutputKeySpecifier | (() => undefined | NotificationLabelMutationOutputKeySpecifier),
		fields?: NotificationLabelMutationOutputFieldPolicy,
	},
	CreateDeclarationMessageResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDeclarationMessageResponseKeySpecifier | (() => undefined | CreateDeclarationMessageResponseKeySpecifier),
		fields?: CreateDeclarationMessageResponseFieldPolicy,
	},
	CreateDeclarationReqResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDeclarationReqResponseKeySpecifier | (() => undefined | CreateDeclarationReqResponseKeySpecifier),
		fields?: CreateDeclarationReqResponseFieldPolicy,
	},
	CreateDeclarationRequestResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDeclarationRequestResponseKeySpecifier | (() => undefined | CreateDeclarationRequestResponseKeySpecifier),
		fields?: CreateDeclarationRequestResponseFieldPolicy,
	},
	CreateDocumentResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateDocumentResponseKeySpecifier | (() => undefined | CreateDocumentResponseKeySpecifier),
		fields?: CreateDocumentResponseFieldPolicy,
	},
	CreateEmptyDocumentResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateEmptyDocumentResponseKeySpecifier | (() => undefined | CreateEmptyDocumentResponseKeySpecifier),
		fields?: CreateEmptyDocumentResponseFieldPolicy,
	},
	address_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | address_mutation_responseKeySpecifier | (() => undefined | address_mutation_responseKeySpecifier),
		fields?: address_mutation_responseFieldPolicy,
	},
	containers_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | containers_mutation_responseKeySpecifier | (() => undefined | containers_mutation_responseKeySpecifier),
		fields?: containers_mutation_responseFieldPolicy,
	},
	declaration_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_mutation_responseKeySpecifier | (() => undefined | declaration_mutation_responseKeySpecifier),
		fields?: declaration_mutation_responseFieldPolicy,
	},
	declaration_discussion_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussion_mutation_responseKeySpecifier | (() => undefined | declaration_discussion_mutation_responseKeySpecifier),
		fields?: declaration_discussion_mutation_responseFieldPolicy,
	},
	declaration_message_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_message_mutation_responseKeySpecifier | (() => undefined | declaration_message_mutation_responseKeySpecifier),
		fields?: declaration_message_mutation_responseFieldPolicy,
	},
	declaration_request_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_request_mutation_responseKeySpecifier | (() => undefined | declaration_request_mutation_responseKeySpecifier),
		fields?: declaration_request_mutation_responseFieldPolicy,
	},
	declaration_request_address_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_request_address_mutation_responseKeySpecifier | (() => undefined | declaration_request_address_mutation_responseKeySpecifier),
		fields?: declaration_request_address_mutation_responseFieldPolicy,
	},
	declaration_special_mentions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_special_mentions_mutation_responseKeySpecifier | (() => undefined | declaration_special_mentions_mutation_responseKeySpecifier),
		fields?: declaration_special_mentions_mutation_responseFieldPolicy,
	},
	doc_annotation_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | doc_annotation_mutation_responseKeySpecifier | (() => undefined | doc_annotation_mutation_responseKeySpecifier),
		fields?: doc_annotation_mutation_responseFieldPolicy,
	},
	document_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_mutation_responseKeySpecifier | (() => undefined | document_mutation_responseKeySpecifier),
		fields?: document_mutation_responseFieldPolicy,
	},
	document_labels_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_labels_mutation_responseKeySpecifier | (() => undefined | document_labels_mutation_responseKeySpecifier),
		fields?: document_labels_mutation_responseFieldPolicy,
	},
	document_type_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_type_mutation_responseKeySpecifier | (() => undefined | document_type_mutation_responseKeySpecifier),
		fields?: document_type_mutation_responseFieldPolicy,
	},
	document_type_tenant_settings_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_type_tenant_settings_mutation_responseKeySpecifier | (() => undefined | document_type_tenant_settings_mutation_responseKeySpecifier),
		fields?: document_type_tenant_settings_mutation_responseFieldPolicy,
	},
	file_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | file_mutation_responseKeySpecifier | (() => undefined | file_mutation_responseKeySpecifier),
		fields?: file_mutation_responseFieldPolicy,
	},
	goods_item_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | goods_item_mutation_responseKeySpecifier | (() => undefined | goods_item_mutation_responseKeySpecifier),
		fields?: goods_item_mutation_responseFieldPolicy,
	},
	import_list_trigger_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | import_list_trigger_mutation_responseKeySpecifier | (() => undefined | import_list_trigger_mutation_responseKeySpecifier),
		fields?: import_list_trigger_mutation_responseFieldPolicy,
	},
	packagings_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | packagings_mutation_responseKeySpecifier | (() => undefined | packagings_mutation_responseKeySpecifier),
		fields?: packagings_mutation_responseFieldPolicy,
	},
	page_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | page_mutation_responseKeySpecifier | (() => undefined | page_mutation_responseKeySpecifier),
		fields?: page_mutation_responseFieldPolicy,
	},
	page_extract_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | page_extract_mutation_responseKeySpecifier | (() => undefined | page_extract_mutation_responseKeySpecifier),
		fields?: page_extract_mutation_responseFieldPolicy,
	},
	previous_documents_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | previous_documents_mutation_responseKeySpecifier | (() => undefined | previous_documents_mutation_responseKeySpecifier),
		fields?: previous_documents_mutation_responseFieldPolicy,
	},
	produced_documents_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | produced_documents_mutation_responseKeySpecifier | (() => undefined | produced_documents_mutation_responseKeySpecifier),
		fields?: produced_documents_mutation_responseFieldPolicy,
	},
	service_tariff_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | service_tariff_mutation_responseKeySpecifier | (() => undefined | service_tariff_mutation_responseKeySpecifier),
		fields?: service_tariff_mutation_responseFieldPolicy,
	},
	setting_value_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | setting_value_mutation_responseKeySpecifier | (() => undefined | setting_value_mutation_responseKeySpecifier),
		fields?: setting_value_mutation_responseFieldPolicy,
	},
	user_pp_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | user_pp_mutation_responseKeySpecifier | (() => undefined | user_pp_mutation_responseKeySpecifier),
		fields?: user_pp_mutation_responseFieldPolicy,
	},
	address_override_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | address_override_mutation_responseKeySpecifier | (() => undefined | address_override_mutation_responseKeySpecifier),
		fields?: address_override_mutation_responseFieldPolicy,
	},
	bill_detail_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | bill_detail_mutation_responseKeySpecifier | (() => undefined | bill_detail_mutation_responseKeySpecifier),
		fields?: bill_detail_mutation_responseFieldPolicy,
	},
	document_label_org_id_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | document_label_org_id_mutation_responseKeySpecifier | (() => undefined | document_label_org_id_mutation_responseKeySpecifier),
		fields?: document_label_org_id_mutation_responseFieldPolicy,
	},
	model_retrain_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | model_retrain_mutation_responseKeySpecifier | (() => undefined | model_retrain_mutation_responseKeySpecifier),
		fields?: model_retrain_mutation_responseFieldPolicy,
	},
	tenant_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | tenant_mutation_responseKeySpecifier | (() => undefined | tenant_mutation_responseKeySpecifier),
		fields?: tenant_mutation_responseFieldPolicy,
	},
	user_org_id_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | user_org_id_mutation_responseKeySpecifier | (() => undefined | user_org_id_mutation_responseKeySpecifier),
		fields?: user_org_id_mutation_responseFieldPolicy,
	},
	AddressMappingEntity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressMappingEntityKeySpecifier | (() => undefined | AddressMappingEntityKeySpecifier),
		fields?: AddressMappingEntityFieldPolicy,
	},
	TransmitFileResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TransmitFileResponseKeySpecifier | (() => undefined | TransmitFileResponseKeySpecifier),
		fields?: TransmitFileResponseFieldPolicy,
	},
	declaration_discussions_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_discussions_mutation_responseKeySpecifier | (() => undefined | declaration_discussions_mutation_responseKeySpecifier),
		fields?: declaration_discussions_mutation_responseFieldPolicy,
	},
	declaration_task_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | declaration_task_mutation_responseKeySpecifier | (() => undefined | declaration_task_mutation_responseKeySpecifier),
		fields?: declaration_task_mutation_responseFieldPolicy,
	},
	extraction_config_mutation_response?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | extraction_config_mutation_responseKeySpecifier | (() => undefined | extraction_config_mutation_responseKeySpecifier),
		fields?: extraction_config_mutation_responseFieldPolicy,
	},
	ReassignFileNumberResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReassignFileNumberResponseKeySpecifier | (() => undefined | ReassignFileNumberResponseKeySpecifier),
		fields?: ReassignFileNumberResponseFieldPolicy,
	},
	ValidateFileNumberResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidateFileNumberResponseKeySpecifier | (() => undefined | ValidateFileNumberResponseKeySpecifier),
		fields?: ValidateFileNumberResponseFieldPolicy,
	},
	ShipmentData?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShipmentDataKeySpecifier | (() => undefined | ShipmentDataKeySpecifier),
		fields?: ShipmentDataFieldPolicy,
	},
	ShipmentInfoAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShipmentInfoAddressKeySpecifier | (() => undefined | ShipmentInfoAddressKeySpecifier),
		fields?: ShipmentInfoAddressFieldPolicy,
	},
	Line?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LineKeySpecifier | (() => undefined | LineKeySpecifier),
		fields?: LineFieldPolicy,
	},
	ValidateJourneyNumberResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidateJourneyNumberResponseKeySpecifier | (() => undefined | ValidateJourneyNumberResponseKeySpecifier),
		fields?: ValidateJourneyNumberResponseFieldPolicy,
	},
	subscription_root?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | subscription_rootKeySpecifier | (() => undefined | subscription_rootKeySpecifier),
		fields?: subscription_rootFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;